// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23343a40%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M2 5l6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23ffffff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10l3 3l6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%272%27 fill=%27%23ffffff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23ffffff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%280, 0, 0, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23c4d5f9%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23ffffff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%2334c997%27 d=%27M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 12 12%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23ec4a58%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23ec4a58%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%280, 0, 0, 0.55%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.55%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%237a99db%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%238a909d%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23000%27%3e%3cpath d=%27M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23ffffff%27%3e%3cpath d=%27M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23ffffff%27%3e%3cpath d=%27M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bs-blue: #0d6efd;
  --bs-indigo: #6610f2;
  --bs-purple: #8268e2;
  --bs-pink: #ee5588;
  --bs-red: #dc3545;
  --bs-orange: #fd7e14;
  --bs-yellow: #ffc107;
  --bs-green: #198754;
  --bs-teal: #20c997;
  --bs-cyan: #0dcaf0;
  --bs-white: #ffffff;
  --bs-gray: #6c757d;
  --txt-red: red;
  --bs-gray-dark: #545454;
  --bs-gray-100: #fdfdfd;
  --bs-gray-200: #e9ecef;
  --bs-gray-300: #dee2e6;
  --bs-gray-400: #ced4da;
  --bs-gray-500: #adb5bd;
  --bs-gray-600: #6c757d;
  --bs-gray-700: #495057;
  --bs-gray-800: #343a40;
  --bs-gray-900: #212529;
  --bs-purple: #8268e2;
  --bs-purple-rgb: 130, 104, 226;
  --bs-white-rgb: 255, 255, 255;
  --bs-body-color-rgb: 138, 144, 157;
  --bs-body-bg-rgb: 253, 253, 253;
  --bs-font-sans-serif: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));
  --bs-body-font-family: 'Poppins', sans-serif;
  --bs-body-font-size: 0.875rem;
  --bs-body-font-weight: 400;
  --bs-body-line-height: 1.5;
  --bs-body-color: #005460;
  --bs-body-bg: #fdfdfd;
  --bs-admin-color: #423a8e;
  --admin-color: #005460;
  --secondary-color: #3d3d3d;
  --border-radius: 8px;
  --bs-body-bg-color: #FFFFFF;
  --text-color: #005460;
  --button-hover-color: #007080;
  --gray-text-color: #101C2D;
  --card-title-color: #101C2D;
  --border-color: #dde4ee;
  --gray-bg-color: #F9FAFB;
  --bs-black-rgb: #101C2D;
  --bs-placeholder-color: #66768E;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

@media (prefers-reduced-motion: no-preference) {
  :root {
    scroll-behavior: smooth;
  }
}

body {
  margin: 0;
  font-family: var(--bs-body-font-family);
  font-size: var(--bs-body-font-size);
  font-weight: var(--bs-body-font-weight);
  line-height: var(--bs-body-line-height);
  color: var(--bs-black-rgb);
  text-align: var(--bs-body-text-align);
  background-color: var(--bs-body-bg-color);
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

hr {
  /* margin: 1rem 0; */
  color: inherit;
  background-color: currentColor;
  border: 0;
  opacity: 0.25;
}

hr:not([size]) {
  height: 1px;
}

h6,
.h6,
h5,
.h5,
h4,
.h4,
h3,
.h3,
h2,
.h2,
h1,
.h1 {
  margin-top: 0;
  margin-bottom: 0;
  font-weight: 500;
  line-height: 1.2;
}

h1,
.h1 {
  font-size: calc(1.37525rem + 1.503vw);
}

@media (min-width: 1200px) {

  h1,
  .h1 {
    font-size: 2.5025rem;
  }
}

h2,
.h2 {
  font-size: calc(1.3249375rem + 0.89925vw);
}

@media (min-width: 1200px) {

  h2,
  .h2 {
    font-size: 1.999375rem;
  }
}

h3,
.h3 {
  font-size: calc(1.274625rem + 0.2955vw);
}

@media (min-width: 1200px) {

  h3,
  .h3 {
    font-size: 1.49625rem;
  }
}

h4,
.h4 {
  font-size: calc(1.250125rem + 0.0015vw);
}

@media (min-width: 1200px) {

  h4,
  .h4 {
    font-size: 1.25125rem;
  }
}

h5,
.h5 {
  font-size: 1.124375rem;
}

h6,
.h6 {
  font-size: 0.93625rem;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title],
abbr[data-bs-original-title] {
  -webkit-text-decoration: underline dotted;
  text-decoration: underline dotted;
  cursor: help;
  text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul {
  padding-left: 2rem;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: 700;
}

dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1rem;
}

b,
strong {
  font-weight: bolder;
}

small,
.small {
  font-size: 0.875em;
}

mark,
.mark {
  padding: 0.2em;
  background-color: #fcf8e3;
}

sub,
sup {
  position: relative;
  font-size: 0.75em;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: var(--admin-color);
  text-decoration: underline;
}

a:hover {
  /* color: #6d88c2; */
}

a:not([href]):not([className]),
a:not([href]):not([className]):hover {
  color: inherit;
  text-decoration: none;
}

pre,
code,
kbd,
samp {
  font-family: var(--bs-font-monospace);
  font-size: 1em;
  direction: ltr
    /* rtl:ignore */
  ;
  unicode-bidi: bidi-override;
}

pre {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  font-size: 0.875em;
}

pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}

code {
  font-size: 0.875em;
  color: #ee5588;
  word-wrap: break-word;
}

a>code {
  color: inherit;
}

kbd {
  padding: 0.2rem 0.4rem;
  font-size: 0.875em;
  color: #ffffff;
  background-color: #212529;
  border-radius: 0.2rem;
}

kbd kbd {
  padding: 0;
  font-size: 1em;
  font-weight: 700;
}

figure {
  margin: 0 0 1rem;
}

img,
svg {
  vertical-align: middle;
}

table {
  caption-side: bottom;
  border-collapse: collapse;
}

caption {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: #6c757d;
  text-align: left;
}

th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}

thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  vertical-align: middle;
  padding: 15px 0 !important;
}

table.table tr td {
  font-size: 14px;
  padding: 10px 10px !important;
}

thead th {
  /* font-weight: 600 !important; */
  color: var(--gray-text-color) !important;
  /* background: var(--gray-bg-color) !important; */
  padding: 15px 10px !important;
}

label {
  display: inline-block;
}

button {
  border-radius: 0;
  font-size: 13px !important;
  /* padding: 15px 18px; */
}

button:focus:not(:focus-visible) {
  outline: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
select {
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}

select:disabled {
  opacity: 1;
  cursor: not-allowed !important;
}

[list]::-webkit-calendar-picker-indicator {
  display: none;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}

button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}

::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

textarea {
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  float: left;
  width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  font-size: calc(1.275rem + 0.3vw);
  line-height: inherit;
}

@media (min-width: 1200px) {
  legend {
    font-size: 1.5rem;
  }
}

legend+* {
  clear: left;
}

::-webkit-datetime-edit-fields-wrapper,
::-webkit-datetime-edit-text,
::-webkit-datetime-edit-minute,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-year-field {
  padding: 0;
}

::-webkit-inner-spin-button {
  height: auto;
}

[type=search] {
  outline-offset: -2px;
  -webkit-appearance: textfield;
}

/* rtl:raw:
[type="tel"],
[type="url"],
[type="email"],
[type="number"] {
  direction: ltr;
}
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-color-swatch-wrapper {
  padding: 0;
}

::file-selector-button {
  font: inherit;
}

::-webkit-file-upload-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

iframe {
  border: 0;
}

summary {
  display: list-item;
  cursor: pointer;
}

progress {
  vertical-align: baseline;
}

[hidden] {
  display: none !important;
}

.lead {
  font-size: 1.09375rem;
  font-weight: 300;
}

.display-1 {
  font-size: calc(1.625rem + 4.5vw);
  font-weight: 300;
  line-height: 1.2;
}

@media (min-width: 1200px) {
  .display-1 {
    font-size: 5rem;
  }
}

.display-2 {
  font-size: calc(1.575rem + 3.9vw);
  font-weight: 300;
  line-height: 1.2;
}

@media (min-width: 1200px) {
  .display-2 {
    font-size: 4.5rem;
  }
}

.display-3 {
  font-size: calc(1.525rem + 3.3vw);
  font-weight: 300;
  line-height: 1.2;
}

@media (min-width: 1200px) {
  .display-3 {
    font-size: 4rem;
  }
}

.display-4 {
  font-size: calc(1.475rem + 2.7vw);
  font-weight: 300;
  line-height: 1.2;
}

@media (min-width: 1200px) {
  .display-4 {
    font-size: 3.5rem;
  }
}

.display-5 {
  font-size: calc(1.425rem + 2.1vw);
  font-weight: 300;
  line-height: 1.2;
}

@media (min-width: 1200px) {
  .display-5 {
    font-size: 3rem;
  }
}

.display-6 {
  font-size: calc(1.375rem + 1.5vw);
  font-weight: 300;
  line-height: 1.2;
}

@media (min-width: 1200px) {
  .display-6 {
    font-size: 2.5rem;
  }
}

.list-unstyled {
  padding-left: 0;
  list-style: none;
}

.list-inline {
  padding-left: 0;
  list-style: none;
}

.list-inline-item {
  display: inline-block;
}

.list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}

.initialism {
  font-size: 0.875em;
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 1rem;
  font-size: 1.09375rem;
}

.blockquote> :last-child {
  margin-bottom: 0;
}

.blockquote-footer {
  margin-top: -1rem;
  margin-bottom: 1rem;
  font-size: 0.875em;
  color: #6c757d;
}

.blockquote-footer::before {
  content: "— ";
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: #fdfdfd;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
  max-width: 100%;
  height: auto;
}

.figure {
  display: inline-block;
}

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1;
}

.figure-caption {
  font-size: 0.875em;
  color: #6c757d;
}

.container,
.container-fluid,
.container-xxl,
.container-xl,
.container-lg,
.container-md,
.container-sm {
  width: 100%;
  padding-right: var(--bs-gutter-x, 0.75rem);
  padding-left: var(--bs-gutter-x, 0.75rem);
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {

  .container-sm,
  .container {
    max-width: 540px;
  }
}

@media (min-width: 768px) {

  .container-md,
  .container-sm,
  .container {
    max-width: 720px;
  }
}

@media (min-width: 992px) {

  .container-lg,
  .container-md,
  .container-sm,
  .container {
    max-width: 960px;
  }
}

@media (min-width: 1200px) {

  .container-xl,
  .container-lg,
  .container-md,
  .container-sm,
  .container {
    max-width: 1140px;
  }
}

@media (min-width: 1500px) {

  .container-xxl,
  .container-xl,
  .container-lg,
  .container-md,
  .container-sm,
  .container {
    max-width: 1320px;
  }
}

.row {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: calc(-1 * var(--bs-gutter-y));
  margin-right: calc(-.5 * var(--bs-gutter-x));
  margin-left: calc(-.5 * var(--bs-gutter-x));
}

.row>* {
  flex-shrink: 0;
  /* width: 100%; */
  max-width: 100%;
  padding-right: calc(var(--bs-gutter-x) * .5);
  padding-left: calc(var(--bs-gutter-x) * .5);
  margin-top: var(--bs-gutter-y);
}

.col {
  flex: 1 0;
}

.row-cols-auto>* {
  flex: 0 0 auto;
  width: auto;
}

.row-cols-1>* {
  flex: 0 0 auto;
  width: 100%;
}

.row-cols-2>* {
  flex: 0 0 auto;
  width: 50%;
}

.row-cols-3>* {
  flex: 0 0 auto;
  width: 33.3333333333%;
}

.row-cols-4>* {
  flex: 0 0 auto;
  width: 25%;
}

.row-cols-5>* {
  flex: 0 0 auto;
  width: 20%;
}

.row-cols-6>* {
  flex: 0 0 auto;
  width: 16.6666666667%;
}

.col-auto {
  flex: 0 0 auto;
  width: auto;
}

.col-1 {
  flex: 0 0 auto;
  width: 8.33333333%;
}

.col-2 {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-3 {
  flex: 0 0 auto;
  width: 25%;
}

.col-4 {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.col-5 {
  flex: 0 0 auto;
  width: 41.66666667%;
}

.col-6 {
  flex: 0 0 auto;
  width: 50%;
}

.col-7 {
  flex: 0 0 auto;
  width: 58.33333333%;
}

.col-8 {
  flex: 0 0 auto;
  width: 66.66666667%;
}

.col-9 {
  flex: 0 0 auto;
  width: 75%;
}

.col-10 {
  flex: 0 0 auto;
  width: 83.33333333%;
}

.col-11 {
  flex: 0 0 auto;
  width: 91.66666667%;
}

.col-12 {
  flex: 0 0 auto;
  width: 100%;
}

.offset-1 {
  margin-left: 8.33333333%;
}

.offset-2 {
  margin-left: 16.66666667%;
}

.offset-3 {
  margin-left: 25%;
}

.offset-4 {
  margin-left: 33.33333333%;
}

.offset-5 {
  margin-left: 41.66666667%;
}

.offset-6 {
  margin-left: 50%;
}

.offset-7 {
  margin-left: 58.33333333%;
}

.offset-8 {
  margin-left: 66.66666667%;
}

.offset-9 {
  margin-left: 75%;
}

.offset-10 {
  margin-left: 83.33333333%;
}

.offset-11 {
  margin-left: 91.66666667%;
}

.g-6,
.gx-6 {
  --bs-gutter-x: 3.5rem;
}

.g-6,
.gy-6 {
  --bs-gutter-y: 3.5rem;
}

.g-7,
.gx-7 {
  --bs-gutter-x: 4rem;
}

.g-7,
.gy-7 {
  --bs-gutter-y: 4rem;
}

.g-8,
.gx-8 {
  --bs-gutter-x: 4.5rem;
}

.g-8,
.gy-8 {
  --bs-gutter-y: 4.5rem;
}

.g-9,
.gx-9 {
  --bs-gutter-x: 5rem;
}

.g-9,
.gy-9 {
  --bs-gutter-y: 5rem;
}

@media (min-width: 576px) {
  .col-sm {
    flex: 1 0;
  }

  .row-cols-sm-auto>* {
    flex: 0 0 auto;
    width: auto;
  }

  .row-cols-sm-1>* {
    flex: 0 0 auto;
    width: 100%;
  }

  .row-cols-sm-2>* {
    flex: 0 0 auto;
    width: 50%;
  }

  .row-cols-sm-3>* {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }

  .row-cols-sm-4>* {
    flex: 0 0 auto;
    width: 25%;
  }

  .row-cols-sm-5>* {
    flex: 0 0 auto;
    width: 20%;
  }

  .row-cols-sm-6>* {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }

  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
  }

  .col-sm-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }

  .col-sm-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }

  .col-sm-3 {
    flex: 0 0 auto;
    width: 25%;
  }

  .col-sm-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }

  .col-sm-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }

  .col-sm-6 {
    flex: 0 0 auto;
    width: 50%;
  }

  .col-sm-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }

  .col-sm-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }

  .col-sm-9 {
    flex: 0 0 auto;
    width: 75%;
  }

  .col-sm-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }

  .col-sm-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }

  .col-sm-12 {
    flex: 0 0 auto;
    width: 100%;
  }

  .offset-sm-0 {
    margin-left: 0;
  }

  .offset-sm-1 {
    margin-left: 8.33333333%;
  }

  .offset-sm-2 {
    margin-left: 16.66666667%;
  }

  .offset-sm-3 {
    margin-left: 25%;
  }

  .offset-sm-4 {
    margin-left: 33.33333333%;
  }

  .offset-sm-5 {
    margin-left: 41.66666667%;
  }

  .offset-sm-6 {
    margin-left: 50%;
  }

  .offset-sm-7 {
    margin-left: 58.33333333%;
  }

  .offset-sm-8 {
    margin-left: 66.66666667%;
  }

  .offset-sm-9 {
    margin-left: 75%;
  }

  .offset-sm-10 {
    margin-left: 83.33333333%;
  }

  .offset-sm-11 {
    margin-left: 91.66666667%;
  }

  .g-sm-6,
  .gx-sm-6 {
    --bs-gutter-x: 3.5rem;
  }

  .g-sm-6,
  .gy-sm-6 {
    --bs-gutter-y: 3.5rem;
  }

  .g-sm-7,
  .gx-sm-7 {
    --bs-gutter-x: 4rem;
  }

  .g-sm-7,
  .gy-sm-7 {
    --bs-gutter-y: 4rem;
  }

  .g-sm-8,
  .gx-sm-8 {
    --bs-gutter-x: 4.5rem;
  }

  .g-sm-8,
  .gy-sm-8 {
    --bs-gutter-y: 4.5rem;
  }

  .g-sm-9,
  .gx-sm-9 {
    --bs-gutter-x: 5rem;
  }

  .g-sm-9,
  .gy-sm-9 {
    --bs-gutter-y: 5rem;
  }
}

@media (min-width: 768px) {
  .col-md {
    flex: 1 0;
  }

  .row-cols-md-auto>* {
    flex: 0 0 auto;
    width: auto;
  }

  .row-cols-md-1>* {
    flex: 0 0 auto;
    width: 100%;
  }

  .row-cols-md-2>* {
    flex: 0 0 auto;
    width: 50%;
  }

  .row-cols-md-3>* {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }

  .row-cols-md-4>* {
    flex: 0 0 auto;
    width: 25%;
  }

  .row-cols-md-5>* {
    flex: 0 0 auto;
    width: 20%;
  }

  .row-cols-md-6>* {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }

  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
  }

  .col-md-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }

  .col-md-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }

  .col-md-3 {
    flex: 0 0 auto;
    width: 25%;
  }

  .col-md-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }

  .col-md-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }

  .col-md-6 {
    flex: 0 0 auto;
    width: 50%;
  }

  .col-md-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }

  .col-md-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }

  .col-md-9 {
    flex: 0 0 auto;
    width: 75%;
  }

  .col-md-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }

  .col-md-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }

  .col-md-12 {
    flex: 0 0 auto;
    width: 100%;
  }

  .offset-md-0 {
    margin-left: 0;
  }

  .offset-md-1 {
    margin-left: 8.33333333%;
  }

  .offset-md-2 {
    margin-left: 16.66666667%;
  }

  .offset-md-3 {
    margin-left: 25%;
  }

  .offset-md-4 {
    margin-left: 33.33333333%;
  }

  .offset-md-5 {
    margin-left: 41.66666667%;
  }

  .offset-md-6 {
    margin-left: 50%;
  }

  .offset-md-7 {
    margin-left: 58.33333333%;
  }

  .offset-md-8 {
    margin-left: 66.66666667%;
  }

  .offset-md-9 {
    margin-left: 75%;
  }

  .offset-md-10 {
    margin-left: 83.33333333%;
  }

  .offset-md-11 {
    margin-left: 91.66666667%;
  }

  .g-md-6,
  .gx-md-6 {
    --bs-gutter-x: 3.5rem;
  }

  .g-md-6,
  .gy-md-6 {
    --bs-gutter-y: 3.5rem;
  }

  .g-md-7,
  .gx-md-7 {
    --bs-gutter-x: 4rem;
  }

  .g-md-7,
  .gy-md-7 {
    --bs-gutter-y: 4rem;
  }

  .g-md-8,
  .gx-md-8 {
    --bs-gutter-x: 4.5rem;
  }

  .g-md-8,
  .gy-md-8 {
    --bs-gutter-y: 4.5rem;
  }

  .g-md-9,
  .gx-md-9 {
    --bs-gutter-x: 5rem;
  }

  .g-md-9,
  .gy-md-9 {
    --bs-gutter-y: 5rem;
  }
}

@media (min-width: 992px) {
  .col-lg {
    flex: 1 0;
  }

  .row-cols-lg-auto>* {
    flex: 0 0 auto;
    width: auto;
  }

  .row-cols-lg-1>* {
    flex: 0 0 auto;
    width: 100%;
  }

  .row-cols-lg-2>* {
    flex: 0 0 auto;
    width: 50%;
  }

  .row-cols-lg-3>* {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }

  .row-cols-lg-4>* {
    flex: 0 0 auto;
    width: 25%;
  }

  .row-cols-lg-5>* {
    flex: 0 0 auto;
    width: 20%;
  }

  .row-cols-lg-6>* {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }

  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
  }

  .col-lg-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }

  .col-lg-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }

  .col-lg-3 {
    flex: 0 0 auto;
    width: 25%;
  }

  .col-lg-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }

  .col-lg-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }

  .col-lg-6 {
    flex: 0 0 auto;
    width: 50%;
  }

  .col-lg-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }

  .col-lg-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }

  .col-lg-9 {
    flex: 0 0 auto;
    width: 75%;
  }

  .col-lg-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }

  .col-lg-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }

  .col-lg-12 {
    flex: 0 0 auto;
    width: 100%;
  }

  .offset-lg-0 {
    margin-left: 0;
  }

  .offset-lg-1 {
    margin-left: 8.33333333%;
  }

  .offset-lg-2 {
    margin-left: 16.66666667%;
  }

  .offset-lg-3 {
    margin-left: 25%;
  }

  .offset-lg-4 {
    margin-left: 33.33333333%;
  }

  .offset-lg-5 {
    margin-left: 41.66666667%;
  }

  .offset-lg-6 {
    margin-left: 50%;
  }

  .offset-lg-7 {
    margin-left: 58.33333333%;
  }

  .offset-lg-8 {
    margin-left: 66.66666667%;
  }

  .offset-lg-9 {
    margin-left: 75%;
  }

  .offset-lg-10 {
    margin-left: 83.33333333%;
  }

  .offset-lg-11 {
    margin-left: 91.66666667%;
  }

  .g-lg-6,
  .gx-lg-6 {
    --bs-gutter-x: 3.5rem;
  }

  .g-lg-6,
  .gy-lg-6 {
    --bs-gutter-y: 3.5rem;
  }

  .g-lg-7,
  .gx-lg-7 {
    --bs-gutter-x: 4rem;
  }

  .g-lg-7,
  .gy-lg-7 {
    --bs-gutter-y: 4rem;
  }

  .g-lg-8,
  .gx-lg-8 {
    --bs-gutter-x: 4.5rem;
  }

  .g-lg-8,
  .gy-lg-8 {
    --bs-gutter-y: 4.5rem;
  }

  .g-lg-9,
  .gx-lg-9 {
    --bs-gutter-x: 5rem;
  }

  .g-lg-9,
  .gy-lg-9 {
    --bs-gutter-y: 5rem;
  }
}

@media (min-width: 1200px) {
  .col-xl {
    flex: 1 0;
  }

  .row-cols-xl-auto>* {
    flex: 0 0 auto;
    width: auto;
  }

  .row-cols-xl-1>* {
    flex: 0 0 auto;
    width: 100%;
  }

  .row-cols-xl-2>* {
    flex: 0 0 auto;
    width: 50%;
  }

  .row-cols-xl-3>* {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }

  .row-cols-xl-4>* {
    flex: 0 0 auto;
    width: 25%;
  }

  .row-cols-xl-5>* {
    flex: 0 0 auto;
    width: 20%;
  }

  .row-cols-xl-6>* {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }

  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
  }

  .col-xl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }

  .col-xl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }

  .col-xl-3 {
    flex: 0 0 auto;
    width: 25%;
  }

  .col-xl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }

  .col-xl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }

  .col-xl-6 {
    flex: 0 0 auto;
    width: 50%;
  }

  .col-xl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }

  .col-xl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }

  .col-xl-9 {
    flex: 0 0 auto;
    width: 75%;
  }

  .col-xl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }

  .col-xl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }

  .col-xl-12 {
    flex: 0 0 auto;
    width: 100%;
  }

  .offset-xl-0 {
    margin-left: 0;
  }

  .offset-xl-1 {
    margin-left: 8.33333333%;
  }

  .offset-xl-2 {
    margin-left: 16.66666667%;
  }

  .offset-xl-3 {
    margin-left: 25%;
  }

  .offset-xl-4 {
    margin-left: 33.33333333%;
  }

  .offset-xl-5 {
    margin-left: 41.66666667%;
  }

  .offset-xl-6 {
    margin-left: 50%;
  }

  .offset-xl-7 {
    margin-left: 58.33333333%;
  }

  .offset-xl-8 {
    margin-left: 66.66666667%;
  }

  .offset-xl-9 {
    margin-left: 75%;
  }

  .offset-xl-10 {
    margin-left: 83.33333333%;
  }

  .offset-xl-11 {
    margin-left: 91.66666667%;
  }

  .g-xl-6,
  .gx-xl-6 {
    --bs-gutter-x: 3.5rem;
  }

  .g-xl-6,
  .gy-xl-6 {
    --bs-gutter-y: 3.5rem;
  }

  .g-xl-7,
  .gx-xl-7 {
    --bs-gutter-x: 4rem;
  }

  .g-xl-7,
  .gy-xl-7 {
    --bs-gutter-y: 4rem;
  }

  .g-xl-8,
  .gx-xl-8 {
    --bs-gutter-x: 4.5rem;
  }

  .g-xl-8,
  .gy-xl-8 {
    --bs-gutter-y: 4.5rem;
  }

  .g-xl-9,
  .gx-xl-9 {
    --bs-gutter-x: 5rem;
  }

  .g-xl-9,
  .gy-xl-9 {
    --bs-gutter-y: 5rem;
  }
}

@media (min-width: 1500px) {
  .col-xxl {
    flex: 1 0;
  }

  .row-cols-xxl-auto>* {
    flex: 0 0 auto;
    width: auto;
  }

  .row-cols-xxl-1>* {
    flex: 0 0 auto;
    width: 100%;
  }

  .row-cols-xxl-2>* {
    flex: 0 0 auto;
    width: 50%;
  }

  .row-cols-xxl-3>* {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }

  .row-cols-xxl-4>* {
    flex: 0 0 auto;
    width: 25%;
  }

  .row-cols-xxl-5>* {
    flex: 0 0 auto;
    width: 20%;
  }

  .row-cols-xxl-6>* {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }

  .col-xxl-auto {
    flex: 0 0 auto;
    width: auto;
  }

  .col-xxl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }

  .col-xxl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }

  .col-xxl-3 {
    flex: 0 0 auto;
    width: 25%;
  }

  .col-xxl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }

  .col-xxl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }

  .col-xxl-6 {
    flex: 0 0 auto;
    width: 50%;
  }

  .col-xxl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }

  .col-xxl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }

  .col-xxl-9 {
    flex: 0 0 auto;
    width: 75%;
  }

  .col-xxl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }

  .col-xxl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }

  .col-xxl-12 {
    flex: 0 0 auto;
    width: 100%;
  }

  .offset-xxl-0 {
    margin-left: 0;
  }

  .offset-xxl-1 {
    margin-left: 8.33333333%;
  }

  .offset-xxl-2 {
    margin-left: 16.66666667%;
  }

  .offset-xxl-3 {
    margin-left: 25%;
  }

  .offset-xxl-4 {
    margin-left: 33.33333333%;
  }

  .offset-xxl-5 {
    margin-left: 41.66666667%;
  }

  .offset-xxl-6 {
    margin-left: 50%;
  }

  .offset-xxl-7 {
    margin-left: 58.33333333%;
  }

  .offset-xxl-8 {
    margin-left: 66.66666667%;
  }

  .offset-xxl-9 {
    margin-left: 75%;
  }

  .offset-xxl-10 {
    margin-left: 83.33333333%;
  }

  .offset-xxl-11 {
    margin-left: 91.66666667%;
  }

  .g-xxl-6,
  .gx-xxl-6 {
    --bs-gutter-x: 3.5rem;
  }

  .g-xxl-6,
  .gy-xxl-6 {
    --bs-gutter-y: 3.5rem;
  }

  .g-xxl-7,
  .gx-xxl-7 {
    --bs-gutter-x: 4rem;
  }

  .g-xxl-7,
  .gy-xxl-7 {
    --bs-gutter-y: 4rem;
  }

  .g-xxl-8,
  .gx-xxl-8 {
    --bs-gutter-x: 4.5rem;
  }

  .g-xxl-8,
  .gy-xxl-8 {
    --bs-gutter-y: 4.5rem;
  }

  .g-xxl-9,
  .gx-xxl-9 {
    --bs-gutter-x: 5rem;
  }

  .g-xxl-9,
  .gy-xxl-9 {
    --bs-gutter-y: 5rem;
  }
}

.table {
  --bs-table-bg: transparent;
  --bs-table-accent-bg: transparent;
  --bs-table-striped-color: var(--bs-body-color);
  --bs-table-striped-bg: rgba(0, 0, 0, 0.05);
  --bs-table-active-color: var(--bs-body-color);
  --bs-table-active-bg: rgba(0, 0, 0, 0.1);
  --bs-table-hover-color: var(--bs-body-color);
  --bs-table-hover-bg: rgba(0, 0, 0, 0.075);
  width: 100%;
  /* margin-bottom: 1rem; */
  color: var(--bs-black-rgb);
  vertical-align: top;
  border-color: var(--border-color);
}

.tableOutline {
  border-radius: 10px;
  border: 1px solid var(--border-color);
}

.cardWrapper table tr:last-child td {
  border: 0;
}

.paginationWrapper .row {
  border-radius: 10px;
  border: 1px solid var(--border-color);
  padding: 10px 10px;
}

.table> :not(caption)>*>* {
  padding: 0.5rem 0.5rem;
  background-color: var(--bs-table-bg);
  border-bottom-width: 1px;
  box-shadow: inset 0 0 0 9999px var(--bs-table-accent-bg);
}

.table>tbody {
  vertical-align: inherit;
}

.table>thead {
  vertical-align: bottom;
}

.table> :not(:first-child) {
  border-top: 1px solid currentColor;
}

.caption-top {
  caption-side: top;
}

.table-sm> :not(caption)>*>* {
  padding: 0.25rem 0.25rem;
}

.table-bordered> :not(caption)>* {
  border-width: 1px 0;
}

.table-bordered> :not(caption)>*>* {
  border-width: 0 1px;
}

.table-borderless> :not(caption)>*>* {
  border-bottom-width: 0;
}

.table-borderless> :not(:first-child) {
  border-top-width: 0;
}

.table-striped>tbody>tr:nth-of-type(odd)>* {
  --bs-table-accent-bg: var(--bs-table-striped-bg);
  color: var(--bs-table-striped-color);
}

.table-active {
  --bs-table-accent-bg: var(--bs-table-active-bg);
  color: var(--bs-table-active-color);
}

.table-hover>tbody>tr:hover>* {
  --bs-table-accent-bg: var(--bs-table-hover-bg);
  color: var(--bs-table-hover-color);
}

.table-primary {
  --bs-table-bg: #e7eefd;
  --bs-table-striped-bg: #dbe2f0;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #d0d6e4;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #d6dcea;
  --bs-table-hover-color: #000;
  color: #000;
  border-color: #d0d6e4;
}

.table-secondary {
  --bs-table-bg: #e8e9eb;
  --bs-table-striped-bg: #dcdddf;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #d1d2d4;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #d7d8d9;
  --bs-table-hover-color: #000;
  color: #000;
  border-color: #d1d2d4;
}

.table-success {
  --bs-table-bg: #d6f4ea;
  --bs-table-striped-bg: #cbe8de;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #c1dcd3;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #c6e2d8;
  --bs-table-hover-color: #000;
  color: #000;
  border-color: #c1dcd3;
}

.table-info {
  --bs-table-bg: #d3f3f8;
  --bs-table-striped-bg: #c8e7ec;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #bedbdf;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #c3e1e5;
  --bs-table-hover-color: #000;
  color: #000;
  border-color: #bedbdf;
}

.table-warning {
  --bs-table-bg: #f8eecd;
  --bs-table-striped-bg: #ece2c3;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #dfd6b9;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #e5dcbe;
  --bs-table-hover-color: #000;
  color: #000;
  border-color: #dfd6b9;
}

.table-danger {
  --bs-table-bg: #fbdbde;
  --bs-table-striped-bg: #eed0d3;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #e2c5c8;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #e8cbcd;
  --bs-table-hover-color: #000;
  color: #000;
  border-color: #e2c5c8;
}

.table-light {
  --bs-table-bg: #fdfdfd;
  --bs-table-striped-bg: #f0f0f0;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #e4e4e4;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #eaeaea;
  --bs-table-hover-color: #000;
  color: #000;
  border-color: #e4e4e4;
}

.table-dark {
  --bs-table-bg: var(--text-color);
  --bs-table-striped-bg: #5e6875;
  --bs-table-striped-color: #ffffff;
  --bs-table-active-bg: #67707d;
  --bs-table-active-color: #ffffff;
  --bs-table-hover-bg: #636c79;
  --bs-table-hover-color: #ffffff;
  color: #ffffff;
  border-color: #67707d;
}

.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

@media (max-width: 575.98px) {
  .table-responsive-sm {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}

@media (max-width: 767.98px) {
  .table-responsive-md {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}

@media (max-width: 991.98px) {
  .table-responsive-lg {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}

@media (max-width: 1199.98px) {
  .table-responsive-xl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}

@media (max-width: 1499.98px) {
  .table-responsive-xxl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}

.form-label {
  font-size: 15px;
  font-weight: 500;
  margin-bottom: 8px;
  color: var(--gray-text-color);
}

.col-form-label {
  padding-top: calc(0.59rem + 1px);
  padding-bottom: calc(0.59rem + 1px);
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
}

.col-form-label-lg {
  padding-top: calc(0.75rem + 1px);
  padding-bottom: calc(0.75rem + 1px);
  font-size: 1.09375rem;
}

.col-form-label-sm {
  padding-top: calc(0.25rem + 1px);
  padding-bottom: calc(0.25rem + 1px);
  font-size: 0.765625rem;
}

.form-text {
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #6c757d;
}

.form-control {
  display: block;
  width: 100%;
  padding: 0.59rem 1rem;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-black-rgb);
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid var(--border-color);
  appearance: none;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

select.form-control {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 1rem center;
  background-size: 16px 12px;
  cursor: pointer;
}

@media (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}

.form-control[type=file] {
  overflow: hidden;
}

.form-control[type=file]:not(:disabled):not([readonly]) {
  cursor: pointer;
}

.form-control:focus {
  color: var(--bs-black-rgb);
  background-color: #fdfdfd;
  border-color: #c4d5f9;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(136, 170, 243, 0.25);
}

.form-control::-webkit-date-and-time-value {
  height: 1.5em;
}

.form-control::placeholder {
  color: var(--bs-placeholder-color);
  opacity: 1;
}

.form-control:disabled,
.form-control[readonly] {
  background-color: #e9ecef;
  opacity: 1;
}

.form-control::file-selector-button {
  padding: 0.59rem 1rem;
  margin: -0.59rem -1rem;
  margin-inline-end: 1rem;
  color: var(--bs-body-color);
  background-color: #e9ecef;
  pointer-events: none;
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  border-inline-end-width: 1px;
  border-radius: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {

  .form-control::file-selector-button {
    transition: none;
  }
}

.form-control:hover:not(:disabled):not([readonly])::file-selector-button {
  background-color: #dde0e3;
}

.form-control::-webkit-file-upload-button {
  padding: 0.59rem 1rem;
  margin: -0.59rem -1rem;
  margin-inline-end: 1rem;
  color: var(--bs-body-color);
  background-color: #e9ecef;
  pointer-events: none;
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  border-inline-end-width: 1px;
  border-radius: 0;
  -webkit-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .form-control::-webkit-file-upload-button {
    -webkit-transition: none;
    transition: none;
  }
}

.form-control:hover:not(:disabled):not([readonly])::-webkit-file-upload-button {
  background-color: #dde0e3;
}

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.59rem 0;
  margin-bottom: 0;
  line-height: 1.5;
  color: var(--bs-body-color);
  background-color: transparent;
  border: solid transparent;
  border-width: 1px 0;
}

.form-control-plaintext.form-control-sm,
.form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}

.form-control-sm {
  min-height: calc(1.5em + 0.5rem + 2px);
  padding: 0.25rem 0.5rem;
  font-size: 0.765625rem;
  border-radius: 0.2rem;
}

.form-control-sm::file-selector-button {
  padding: 0.25rem 0.5rem;
  margin: -0.25rem -0.5rem;
  margin-inline-end: 0.5rem;
}

.form-control-sm::-webkit-file-upload-button {
  padding: 0.25rem 0.5rem;
  margin: -0.25rem -0.5rem;
  margin-inline-end: 0.5rem;
}

.form-control-lg {
  min-height: calc(1.5em + 1.5rem + 2px);
  padding: 0.75rem 1rem;
  font-size: 1.09375rem;
  border-radius: 0.3rem;
}

.form-control-lg::file-selector-button {
  padding: 0.75rem 1rem;
  margin: -0.75rem -1rem;
  margin-inline-end: 1rem;
}

.form-control-lg::-webkit-file-upload-button {
  padding: 0.75rem 1rem;
  margin: -0.75rem -1rem;
  margin-inline-end: 1rem;
}

textarea.form-control {
  min-height: calc(1.5em + 1.18rem + 2px);
}

textarea.form-control-sm {
  min-height: calc(1.5em + 0.5rem + 2px);
}

textarea.form-control-lg {
  min-height: calc(1.5em + 1.5rem + 2px);
}

.form-control-color {
  width: 3rem;
  height: auto;
  padding: 0.59rem;
}

.form-control-color:not(:disabled):not([readonly]) {
  cursor: pointer;
}

.form-control-color::-moz-color-swatch {
  height: 1.5em;
  border-radius: 0.25rem;
}

.form-control-color::-webkit-color-swatch {
  height: 1.5em;
  border-radius: 0.25rem;
}

.form-select {
  display: block;
  width: 100%;
  padding: 0.59rem 3rem 0.59rem 1rem;
  -moz-padding-start: calc(1rem - 3px);
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-body-color);
  background-color: #fdfdfd;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 1rem center;
  background-size: 16px 12px;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  appearance: none;
}

@media (prefers-reduced-motion: reduce) {
  .form-select {
    transition: none;
  }
}

.form-select:focus {
  border-color: #c4d5f9;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(136, 170, 243, 0.25);
}

.form-select[multiple],
.form-select[size]:not([size="1"]) {
  padding-right: 1rem;
  background-image: none;
}

.form-select:disabled {
  background-color: #e9ecef;
}

.form-select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 var(--bs-body-color);
}

.form-select-sm {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  font-size: 0.765625rem;
  border-radius: 0.2rem;
}

.form-select-lg {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  padding-left: 1rem;
  font-size: 1.09375rem;
  border-radius: 0.3rem;
}

.form-check {
  display: block;
  min-height: 1.3125rem;
  padding-left: 1.5em;
  margin-bottom: 0.125rem;
}

.form-check .form-check-input {
  float: left;
  margin-left: -1.5em;
}

.form-check-input {
  width: 1em;
  height: 1em;
  margin-top: 0.25em;
  vertical-align: top;
  background-color: #fdfdfd;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: 1px solid rgba(0, 0, 0, 0.25);
  appearance: none;
  print-color-adjust: exact;
}

.form-check-input[type=checkbox] {
  border-radius: 0.25em;
}

.form-check-input[type=radio] {
  border-radius: 50%;
}

.form-check-input:active {
  filter: brightness(90%);
}

.form-check-input:focus {
  border-color: #c4d5f9;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(136, 170, 243, 0.25);
}

.form-check-input:checked {
  background-color: var(--admin-color);
  border-color: var(--admin-color);
}

.form-check-input:checked[type=checkbox] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.form-check-input:checked[type=radio] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.form-check-input[type=checkbox]:indeterminate {
  background-color: var(--admin-color);
  border-color: var(--admin-color);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.form-check-input:disabled {
  pointer-events: none;
  filter: none;
  opacity: 0.5;
}

.form-check-input[disabled]~.form-check-label,
.form-check-input:disabled~.form-check-label {
  opacity: 0.5;
}

.form-switch {
  padding-left: 2.5em;
}

.form-switch .form-check-input {
  width: 2em;
  margin-left: -2.5em;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-position: left center;
  border-radius: 2em;
  transition: background-position 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .form-switch .form-check-input {
    transition: none;
  }
}

.form-switch .form-check-input:focus {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}

.form-switch .form-check-input:checked {
  background-position: right center;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}

.form-check-inline {
  display: inline-block;
  margin-right: 1rem;
}

.btn-check {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}

.btn-check[disabled]+.btn,
.btn-check:disabled+.btn {
  pointer-events: none;
  filter: none;
  opacity: 0.65;
}

.form-range {
  width: 100%;
  height: 1.5rem;
  padding: 0;
  background-color: transparent;
  appearance: none;
}

.form-range:focus {
  outline: 0;
}

.form-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #fdfdfd, 0 0 0 0.25rem rgba(136, 170, 243, 0.25);
}

.form-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #fdfdfd, 0 0 0 0.25rem rgba(136, 170, 243, 0.25);
}

.form-range::-moz-focus-outer {
  border: 0;
}

.form-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  background-color: var(--admin-color);
  border: 0;
  border-radius: 1rem;
  -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  appearance: none;
}

@media (prefers-reduced-motion: reduce) {
  .form-range::-webkit-slider-thumb {
    -webkit-transition: none;
    transition: none;
  }
}

.form-range::-webkit-slider-thumb:active {
  background-color: #dbe6fb;
}

.form-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #dee2e6;
  border-color: transparent;
  border-radius: 1rem;
}

.form-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  background-color: var(--admin-color);
  border: 0;
  border-radius: 1rem;
  -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  appearance: none;
}

@media (prefers-reduced-motion: reduce) {
  .form-range::-moz-range-thumb {
    -moz-transition: none;
    transition: none;
  }
}

.form-range::-moz-range-thumb:active {
  background-color: #dbe6fb;
}

.form-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #dee2e6;
  border-color: transparent;
  border-radius: 1rem;
}

.form-range:disabled {
  pointer-events: none;
}

.form-range:disabled::-webkit-slider-thumb {
  background-color: #adb5bd;
}

.form-range:disabled::-moz-range-thumb {
  background-color: #adb5bd;
}

.form-floating {
  position: relative;
}

.form-floating>.form-control,
.form-floating>.form-select {
  height: calc(3.5rem + 2px);
  line-height: 1.25;
}

.form-floating>label {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  padding: 1rem 1rem;
  pointer-events: none;
  border: 1px solid transparent;
  transform-origin: 0 0;
  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .form-floating>label {
    transition: none;
  }
}

.form-floating>.form-control {
  padding: 1rem 1rem;
}

.form-floating>.form-control::placeholder {
  color: transparent;
}

.form-floating>.form-control:focus,
.form-floating>.form-control:not(:placeholder-shown) {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}

.form-floating>.form-control:-webkit-autofill {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}

.form-floating>.form-select {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}

.form-floating>.form-control:focus~label,
.form-floating>.form-control:not(:placeholder-shown)~label,
.form-floating>.form-select~label {
  opacity: 0.65;
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}

.form-floating>.form-control:-webkit-autofill~label {
  opacity: 0.65;
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}

.input-group>.form-control,
.input-group>.form-select {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
}

.input-group>.form-control:focus,
.input-group>.form-select:focus {
  z-index: 3;
}

.input-group .btn {
  position: relative;
  z-index: 2;
}

.input-group .btn:focus {
  z-index: 3;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.59rem 1rem;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-body-color);
  text-align: center;
  white-space: nowrap;
  background-color: #e9ecef;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}

.input-group-lg>.form-control,
.input-group-lg>.form-select,
.input-group-lg>.input-group-text,
.input-group-lg>.btn {
  padding: 0.75rem 1rem;
  font-size: 1.09375rem;
  border-radius: 0.3rem;
}

.input-group-sm>.form-control,
.input-group-sm>.form-select,
.input-group-sm>.input-group-text,
.input-group-sm>.btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.765625rem;
  border-radius: 0.2rem;
}

.input-group-lg>.form-select,
.input-group-sm>.form-select {
  padding-right: 4rem;
}

.input-group:not(.has-validation)> :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu),
.input-group:not(.has-validation)>.dropdown-toggle:nth-last-child(n+3) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-group.has-validation> :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu),
.input-group.has-validation>.dropdown-toggle:nth-last-child(n+4) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-group> :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  margin-left: -1px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #34c997;
}

.valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.765625rem;
  color: #000;
  background-color: rgba(52, 201, 151, 0.9);
  border-radius: 0.25rem;
}

.was-validated :valid~.valid-feedback,
.was-validated :valid~.valid-tooltip,
.is-valid~.valid-feedback,
.is-valid~.valid-tooltip {
  display: block;
}

.was-validated .form-control:valid,
.form-control.is-valid {
  border-color: #34c997;
  padding-right: calc(1.5em + 1.18rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.295rem) center;
  background-size: calc(0.75em + 0.59rem) calc(0.75em + 0.59rem);
}

.was-validated .form-control:valid:focus,
.form-control.is-valid:focus {
  border-color: #34c997;
  box-shadow: 0 0 0 0.25rem rgba(52, 201, 151, 0.25);
}

.was-validated textarea.form-control:valid,
textarea.form-control.is-valid {
  padding-right: calc(1.5em + 1.18rem);
  background-position: top calc(0.375em + 0.295rem) right calc(0.375em + 0.295rem);
}

.was-validated .form-select:valid,
.form-select.is-valid {
  border-color: #34c997;
}

.was-validated .form-select:valid:not([multiple]):not([size]),
.was-validated .form-select:valid:not([multiple])[size="1"],
.form-select.is-valid:not([multiple]):not([size]),
.form-select.is-valid:not([multiple])[size="1"] {
  padding-right: 5.5rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}), url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  background-position: right 1rem center, center right 3rem;
  background-size: 16px 12px, calc(0.75em + 0.59rem) calc(0.75em + 0.59rem);
}

.was-validated .form-select:valid:focus,
.form-select.is-valid:focus {
  border-color: #34c997;
  box-shadow: 0 0 0 0.25rem rgba(52, 201, 151, 0.25);
}

.was-validated .form-check-input:valid,
.form-check-input.is-valid {
  border-color: #34c997;
}

.was-validated .form-check-input:valid:checked,
.form-check-input.is-valid:checked {
  background-color: #34c997;
}

.was-validated .form-check-input:valid:focus,
.form-check-input.is-valid:focus {
  box-shadow: 0 0 0 0.25rem rgba(52, 201, 151, 0.25);
}

.was-validated .form-check-input:valid~.form-check-label,
.form-check-input.is-valid~.form-check-label {
  color: #34c997;
}

.form-check-inline .form-check-input~.valid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group .form-control:valid,
.input-group .form-control.is-valid,
.was-validated .input-group .form-select:valid,
.input-group .form-select.is-valid {
  z-index: 1;
}

.was-validated .input-group .form-control:valid:focus,
.input-group .form-control.is-valid:focus,
.was-validated .input-group .form-select:valid:focus,
.input-group .form-select.is-valid:focus {
  z-index: 3;
}

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #ec4a58;
}

.invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.765625rem;
  color: #000;
  background-color: rgba(236, 74, 88, 0.9);
  border-radius: 0.25rem;
}

.was-validated :invalid~.invalid-feedback,
.was-validated :invalid~.invalid-tooltip,
.is-invalid~.invalid-feedback,
.is-invalid~.invalid-tooltip {
  display: block;
}

.was-validated .form-control:invalid,
.form-control.is-invalid {
  border-color: #ec4a58;
  padding-right: calc(1.5em + 1.18rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.295rem) center;
  background-size: calc(0.75em + 0.59rem) calc(0.75em + 0.59rem);
}

.was-validated .form-control:invalid:focus,
.form-control.is-invalid:focus {
  border-color: #ec4a58;
  box-shadow: 0 0 0 0.25rem rgba(236, 74, 88, 0.25);
}

.was-validated textarea.form-control:invalid,
textarea.form-control.is-invalid {
  padding-right: calc(1.5em + 1.18rem);
  background-position: top calc(0.375em + 0.295rem) right calc(0.375em + 0.295rem);
}

.was-validated .form-select:invalid,
.form-select.is-invalid {
  border-color: #ec4a58;
}

.was-validated .form-select:invalid:not([multiple]):not([size]),
.was-validated .form-select:invalid:not([multiple])[size="1"],
.form-select.is-invalid:not([multiple]):not([size]),
.form-select.is-invalid:not([multiple])[size="1"] {
  padding-right: 5.5rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}), url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  background-position: right 1rem center, center right 3rem;
  background-size: 16px 12px, calc(0.75em + 0.59rem) calc(0.75em + 0.59rem);
}

.was-validated .form-select:invalid:focus,
.form-select.is-invalid:focus {
  border-color: #ec4a58;
  box-shadow: 0 0 0 0.25rem rgba(236, 74, 88, 0.25);
}

.was-validated .form-check-input:invalid,
.form-check-input.is-invalid {
  border-color: #ec4a58;
}

.was-validated .form-check-input:invalid:checked,
.form-check-input.is-invalid:checked {
  background-color: #ec4a58;
}

.was-validated .form-check-input:invalid:focus,
.form-check-input.is-invalid:focus {
  box-shadow: 0 0 0 0.25rem rgba(236, 74, 88, 0.25);
}

.was-validated .form-check-input:invalid~.form-check-label,
.form-check-input.is-invalid~.form-check-label {
  color: #ec4a58;
}

.form-check-inline .form-check-input~.invalid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group .form-control:invalid,
.input-group .form-control.is-invalid,
.was-validated .input-group .form-select:invalid,
.input-group .form-select.is-invalid {
  z-index: 2;
}

.was-validated .input-group .form-control:invalid:focus,
.input-group .form-control.is-invalid:focus,
.was-validated .input-group .form-select:invalid:focus,
.input-group .form-select.is-invalid:focus {
  z-index: 3;
}

.btn {
  display: inline-block;
  font-weight: 500;
  line-height: 1.5;
  color: var(--bs-body-color);
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  padding: 0.59rem 1rem;
  font-size: 0.875rem;
  border-radius: var(--border-radius) !important;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.breadcrumb-wrapper .btn {
  border-radius: var(--border-radius) !important;
}

@media (prefers-reduced-motion: reduce) {
  .btn {
    transition: none;
  }
}

.btn:hover {
  color: var(--bs-body-color);
}

.btn-check:focus+.btn,
.btn:focus {
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(136, 170, 243, 0.25);
}

.btn:disabled,
.btn.disabled,
fieldset:disabled .btn {
  pointer-events: none;
  opacity: 0.65;
  cursor: not-allowed;
}

.btn-purple {
  color: #000;
  background-color: #8268e2;
  border-color: #8268e2;
}

.btn-purple:hover {
  color: #000;
  background-color: #957fe6;
  border-color: #8f77e5;
}

.btn-check:focus+.btn-purple,
.btn-purple:focus {
  color: #000;
  background-color: #957fe6;
  border-color: #8f77e5;
  box-shadow: 0 0 0 0.25rem rgba(111, 88, 192, 0.5);
}

.btn-check:checked+.btn-purple,
.btn-check:active+.btn-purple,
.btn-purple:active,
.btn-purple.active,
.show>.btn-purple.dropdown-toggle {
  color: #000;
  background-color: #9b86e8;
  border-color: #8f77e5;
}

.btn-check:checked+.btn-purple:focus,
.btn-check:active+.btn-purple:focus,
.btn-purple:active:focus,
.btn-purple.active:focus,
.show>.btn-purple.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.25rem rgba(111, 88, 192, 0.5);
}

.btn-purple:disabled,
.btn-purple.disabled {
  color: #000;
  background-color: #8268e2;
  border-color: #8268e2;
}

.btn-outline-purple {
  color: #8268e2;
  border-color: #8268e2;
}

.btn-outline-purple:hover {
  color: #000;
  background-color: #8268e2;
  border-color: #8268e2;
}

.btn-check:focus+.btn-outline-purple,
.btn-outline-purple:focus {
  box-shadow: 0 0 0 0.25rem rgba(130, 104, 226, 0.5);
}

.btn-check:checked+.btn-outline-purple,
.btn-check:active+.btn-outline-purple,
.btn-outline-purple:active,
.btn-outline-purple.active,
.btn-outline-purple.dropdown-toggle.show {
  color: #000;
  background-color: #8268e2;
  border-color: #8268e2;
}

.btn-check:checked+.btn-outline-purple:focus,
.btn-check:active+.btn-outline-purple:focus,
.btn-outline-purple:active:focus,
.btn-outline-purple.active:focus,
.btn-outline-purple.dropdown-toggle.show:focus {
  box-shadow: 0 0 0 0.25rem rgba(130, 104, 226, 0.5);
}

.btn-outline-purple:disabled,
.btn-outline-purple.disabled {
  color: #8268e2;
  background-color: transparent;
}

.btn-link {
  font-weight: 400;
  color: var(--admin-color);
  text-decoration: underline;
}

.btn-link:hover {
  color: #6d88c2;
}

.btn-link:disabled,
.btn-link.disabled {
  color: #6c757d;
}

.btn-lg,
.btn-group-lg>.btn {
  padding: 0.75rem 1rem;
  font-size: 1.09375rem;
  border-radius: 0.3rem;
}

.btn-sm,
.btn-group-sm>.btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.765625rem;
  border-radius: 0.2rem;
}

.fade {
  transition: opacity 0.15s linear;
}

@media (prefers-reduced-motion: reduce) {
  .fade {
    transition: none;
  }
}

.fade:not(.show) {
  opacity: 0;
}

/* .collapse:not(.show) {
  display: none;
} */

.collapsing {
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}

@media (prefers-reduced-motion: reduce) {
  .collapsing {
    transition: none;
  }
}

.collapsing.collapse-horizontal {
  width: 0;
  height: auto;
  transition: width 0.35s ease;
}

@media (prefers-reduced-motion: reduce) {
  .collapsing.collapse-horizontal {
    transition: none;
  }
}

.dropup,
.dropend,
.dropdown,
.dropstart {
  position: relative;
}

.dropdown-toggle {
  white-space: nowrap;
}

.dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  /* content: ""; */
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}

.dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropdown-menu {
  position: absolute;
  z-index: 1000;
  display: none;
  min-width: 10rem;
  padding: 0.5rem 0;
  margin: 0;
  font-size: 0.875rem;
  color: var(--bs-black-rgb);
  text-align: left;
  list-style: none;
  background-color: #ffffff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
}

.dropdown-menu[data-bs-popper] {
  top: 100%;
  left: 0;
  margin-top: 0.125rem;
}

.dropdown-menu-start {
  --bs-position: start;
}

.dropdown-menu-start[data-bs-popper] {
  right: auto;
  left: 0;
}

.dropdown-menu-end {
  --bs-position: end;
}

.dropdown-menu-end[data-bs-popper] {
  right: 0;
  left: auto;
}

@media (min-width: 576px) {
  .dropdown-menu-sm-start {
    --bs-position: start;
  }

  .dropdown-menu-sm-start[data-bs-popper] {
    right: auto;
    left: 0;
  }

  .dropdown-menu-sm-end {
    --bs-position: end;
  }

  .dropdown-menu-sm-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}

@media (min-width: 768px) {
  .dropdown-menu-md-start {
    --bs-position: start;
  }

  .dropdown-menu-md-start[data-bs-popper] {
    right: auto;
    left: 0;
  }

  .dropdown-menu-md-end {
    --bs-position: end;
  }

  .dropdown-menu-md-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}

@media (min-width: 992px) {
  .dropdown-menu-lg-start {
    --bs-position: start;
  }

  .dropdown-menu-lg-start[data-bs-popper] {
    right: auto;
    left: 0;
  }

  .dropdown-menu-lg-end {
    --bs-position: end;
  }

  .dropdown-menu-lg-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}

@media (min-width: 1200px) {
  .dropdown-menu-xl-start {
    --bs-position: start;
  }

  .dropdown-menu-xl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }

  .dropdown-menu-xl-end {
    --bs-position: end;
  }

  .dropdown-menu-xl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}

@media (min-width: 1500px) {
  .dropdown-menu-xxl-start {
    --bs-position: start;
  }

  .dropdown-menu-xxl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }

  .dropdown-menu-xxl-end {
    --bs-position: end;
  }

  .dropdown-menu-xxl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}

.dropup .dropdown-menu[data-bs-popper] {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: 0.125rem;
}

.dropup .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent;
}

.dropup .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropend .dropdown-menu[data-bs-popper] {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: 0.125rem;
}

.dropend .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0;
  border-bottom: 0.3em solid transparent;
  border-left: 0.3em solid;
}

.dropend .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropend .dropdown-toggle::after {
  vertical-align: 0;
}

.dropstart .dropdown-menu[data-bs-popper] {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: 0.125rem;
}

.dropstart .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
}

.dropstart .dropdown-toggle::after {
  display: none;
}

.dropstart .dropdown-toggle::before {
  display: inline-block;
  margin-right: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent;
}

.dropstart .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropstart .dropdown-toggle::before {
  vertical-align: 0;
}

.dropdown-divider {
  height: 0;
  margin: 0.5rem 0;
  overflow: hidden;
  border-top: 1px solid rgba(0, 0, 0, 0.15);
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: 0.25rem 1rem;
  clear: both;
  font-weight: 400;
  color: #212529;
  text-align: inherit;
  text-decoration: none;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
}

.dropdown-item:hover,
.dropdown-item:focus {
  color: #1e2125;
  /* background-color: #e9ecef; */
}

.dropdown-item.active,
.dropdown-item:active {
  color: #ffffff;
  text-decoration: none;
  background-color: var(--admin-color);
}

.dropdown-item.disabled,
.dropdown-item:disabled {
  color: #adb5bd;
  pointer-events: none;
  background-color: transparent;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-header {
  display: flex;
  padding: 0.5rem 1rem;
  margin-bottom: 0;
  font-size: 0.765625rem;
  color: #6c757d;
  white-space: nowrap;
}

.dropdown-item-text {
  display: block;
  padding: 0.25rem 1rem;
  color: #212529;
}

.dropdown-menu-dark {
  color: #dee2e6;
  background-color: #343a40;
  border-color: rgba(0, 0, 0, 0.15);
}

.dropdown-menu-dark .dropdown-item {
  color: #dee2e6;
}

.dropdown-menu-dark .dropdown-item:hover,
.dropdown-menu-dark .dropdown-item:focus {
  color: #ffffff;
  /* background-color: rgba(255, 255, 255, 0.15); */
}

.dropdown-menu-dark .dropdown-item.active,
.dropdown-menu-dark .dropdown-item:active {
  color: #ffffff;
  background-color: var(--admin-color);
}

.dropdown-menu-dark .dropdown-item.disabled,
.dropdown-menu-dark .dropdown-item:disabled {
  color: #adb5bd;
}

.dropdown-menu-dark .dropdown-divider {
  border-color: rgba(0, 0, 0, 0.15);
}

.dropdown-menu-dark .dropdown-item-text {
  color: #dee2e6;
}

.dropdown-menu-dark .dropdown-header {
  color: #adb5bd;
}

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}

.btn-group>.btn,
.btn-group-vertical>.btn {
  position: relative;
  flex: 1 1 auto;
}

.btn-group>.btn-check:checked+.btn,
.btn-group>.btn-check:focus+.btn,
.btn-group>.btn:hover,
.btn-group>.btn:focus,
.btn-group>.btn:active,
.btn-group>.btn.active,
.btn-group-vertical>.btn-check:checked+.btn,
.btn-group-vertical>.btn-check:focus+.btn,
.btn-group-vertical>.btn:hover,
.btn-group-vertical>.btn:focus,
.btn-group-vertical>.btn:active,
.btn-group-vertical>.btn.active {
  z-index: 1;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}

.btn-toolbar .input-group {
  width: auto;
}

.btn-group>.btn:not(:first-child),
.btn-group>.btn-group:not(:first-child) {
  margin-left: -1px;
}

.btn-group>.btn:not(:last-child):not(.dropdown-toggle),
.btn-group>.btn-group:not(:last-child)>.btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.btn-group>.btn:nth-child(n+3),
.btn-group> :not(.btn-check)+.btn,
.btn-group>.btn-group:not(:first-child)>.btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem;
}

.dropdown-toggle-split::after,
.dropup .dropdown-toggle-split::after,
.dropend .dropdown-toggle-split::after {
  margin-left: 0;
}

.dropstart .dropdown-toggle-split::before {
  margin-right: 0;
}

.btn-sm+.dropdown-toggle-split,
.btn-group-sm>.btn+.dropdown-toggle-split {
  padding-right: 0.375rem;
  padding-left: 0.375rem;
}

.btn-lg+.dropdown-toggle-split,
.btn-group-lg>.btn+.dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}

.btn-group-vertical>.btn,
.btn-group-vertical>.btn-group {
  width: 100%;
}

.btn-group-vertical>.btn:not(:first-child),
.btn-group-vertical>.btn-group:not(:first-child) {
  margin-top: -1px;
}

.btn-group-vertical>.btn:not(:last-child):not(.dropdown-toggle),
.btn-group-vertical>.btn-group:not(:last-child)>.btn {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}

.btn-group-vertical>.btn~.btn,
.btn-group-vertical>.btn-group:not(:first-child)>.btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav {
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-link {
  display: block;
  padding: 0.5rem 1rem;
  color: var(--admin-color);
  text-decoration: none;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .nav-link {
    transition: none;
  }
}

.nav-link:hover,
.nav-link:focus {
  color: #6d88c2;
}

.nav-link.disabled {
  color: #6c757d;
  pointer-events: none;
  cursor: default;
}

.nav-tabs {
  /* border-bottom: 1px solid #dee2e6; */
}

.nav-tabs .nav-link {
  margin-bottom: -1px;
  background: none;
  border: 1px solid transparent;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}

.nav-tabs .nav-link:hover,
.nav-tabs .nav-link:focus {
  /* border-color: #e9ecef #e9ecef #dee2e6; */
  isolation: isolate;
}

.nav-tabs .nav-link.disabled {
  color: #6c757d;
  background-color: transparent;
  border-color: transparent;
}

.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: #495057;
  background-color: #fdfdfd;
  border-color: #dee2e6 #dee2e6 #fdfdfd;
}

.nav-tabs .dropdown-menu {
  margin-top: -1px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav-pills .nav-link {
  background: none;
  border: 0;
  border-radius: 0.25rem;
}

.nav-pills .nav-link.active,
.nav-pills .show>.nav-link {
  color: #ffffff;
  background-color: var(--admin-color);
}

.nav-fill>.nav-link,
.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified>.nav-link,
.nav-justified .nav-item {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center;
}

.nav-fill .nav-item .nav-link,
.nav-justified .nav-item .nav-link {
  width: 100%;
}

.tab-content>.tab-pane {
  display: none;
}

.tab-content>.active {
  display: block;
}

.navbar {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  z-index: 100 !important;
}

.navbar>.container,
.navbar>.container-fluid,
.navbar>.container-sm,
.navbar>.container-md,
.navbar>.container-lg,
.navbar>.container-xl,
.navbar>.container-xxl {
  display: flex;
  flex-wrap: inherit;
  align-items: center;
  justify-content: space-between;
}

.navbar-brand {
  padding-top: 0.3359375rem;
  padding-bottom: 0.3359375rem;
  margin-right: 1rem;
  font-size: 1.09375rem;
  text-decoration: none;
  white-space: nowrap;
}

.navbar-nav {
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.navbar-nav .nav-link {
  padding-right: 0;
  padding-left: 0;
}

.navbar-nav .dropdown-menu {
  position: static;
}

.navbar-text {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.navbar-collapse {
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center;
}

.navbar-toggler {
  padding: 0.25rem 0.75rem;
  font-size: 1.09375rem;
  line-height: 1;
  background-color: transparent;
  border: 1px solid transparent;
  border-radius: 0.25rem;
  transition: box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .navbar-toggler {
    transition: none;
  }
}

.navbar-toggler:hover {
  text-decoration: none;
}

.navbar-toggler:focus {
  text-decoration: none;
  outline: 0;
  box-shadow: 0 0 0 0.25rem;
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
}

.navbar-nav-scroll {
  max-height: var(--bs-scroll-height, 75vh);
  overflow-y: auto;
}

@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }

  .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }

  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }

  .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }

  .navbar-expand-sm .navbar-nav-scroll {
    overflow: visible;
  }

  .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }

  .navbar-expand-sm .navbar-toggler {
    display: none;
  }

  .navbar-expand-sm .offcanvas-header {
    display: none;
  }

  .navbar-expand-sm .offcanvas {
    position: inherit;
    bottom: 0;
    z-index: 1000;
    flex-grow: 1;
    visibility: visible !important;
    background-color: transparent;
    border-right: 0;
    border-left: 0;
    transition: none;
    transform: none;
  }

  .navbar-expand-sm .offcanvas-top,
  .navbar-expand-sm .offcanvas-bottom {
    height: auto;
    border-top: 0;
    border-bottom: 0;
  }

  .navbar-expand-sm .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}

@media (min-width: 768px) {
  .navbar-expand-md {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }

  .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }

  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }

  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }

  .navbar-expand-md .navbar-nav-scroll {
    overflow: visible;
  }

  .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }

  .navbar-expand-md .navbar-toggler {
    display: none;
  }

  .navbar-expand-md .offcanvas-header {
    display: none;
  }

  .navbar-expand-md .offcanvas {
    position: inherit;
    bottom: 0;
    z-index: 1000;
    flex-grow: 1;
    visibility: visible !important;
    background-color: transparent;
    border-right: 0;
    border-left: 0;
    transition: none;
    transform: none;
  }

  .navbar-expand-md .offcanvas-top,
  .navbar-expand-md .offcanvas-bottom {
    height: auto;
    border-top: 0;
    border-bottom: 0;
  }

  .navbar-expand-md .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}

@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }

  .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }

  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }

  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }

  .navbar-expand-lg .navbar-nav-scroll {
    overflow: visible;
  }

  .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }

  .navbar-expand-lg .navbar-toggler {
    display: none;
  }

  .navbar-expand-lg .offcanvas-header {
    display: none;
  }

  .navbar-expand-lg .offcanvas {
    position: inherit;
    bottom: 0;
    z-index: 1000;
    flex-grow: 1;
    visibility: visible !important;
    background-color: transparent;
    border-right: 0;
    border-left: 0;
    transition: none;
    transform: none;
  }

  .navbar-expand-lg .offcanvas-top,
  .navbar-expand-lg .offcanvas-bottom {
    height: auto;
    border-top: 0;
    border-bottom: 0;
  }

  .navbar-expand-lg .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}

@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }

  .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }

  .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }

  .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }

  .navbar-expand-xl .navbar-nav-scroll {
    overflow: visible;
  }

  .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }

  .navbar-expand-xl .navbar-toggler {
    display: none;
  }

  .navbar-expand-xl .offcanvas-header {
    display: none;
  }

  .navbar-expand-xl .offcanvas {
    position: inherit;
    bottom: 0;
    z-index: 1000;
    flex-grow: 1;
    visibility: visible !important;
    background-color: transparent;
    border-right: 0;
    border-left: 0;
    transition: none;
    transform: none;
  }

  .navbar-expand-xl .offcanvas-top,
  .navbar-expand-xl .offcanvas-bottom {
    height: auto;
    border-top: 0;
    border-bottom: 0;
  }

  .navbar-expand-xl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}

@media (min-width: 1500px) {
  .navbar-expand-xxl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }

  .navbar-expand-xxl .navbar-nav {
    flex-direction: row;
  }

  .navbar-expand-xxl .navbar-nav .dropdown-menu {
    position: absolute;
  }

  .navbar-expand-xxl .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }

  .navbar-expand-xxl .navbar-nav-scroll {
    overflow: visible;
  }

  .navbar-expand-xxl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }

  .navbar-expand-xxl .navbar-toggler {
    display: none;
  }

  .navbar-expand-xxl .offcanvas-header {
    display: none;
  }

  .navbar-expand-xxl .offcanvas {
    position: inherit;
    bottom: 0;
    z-index: 1000;
    flex-grow: 1;
    visibility: visible !important;
    background-color: transparent;
    border-right: 0;
    border-left: 0;
    transition: none;
    transform: none;
  }

  .navbar-expand-xxl .offcanvas-top,
  .navbar-expand-xxl .offcanvas-bottom {
    height: auto;
    border-top: 0;
    border-bottom: 0;
  }

  .navbar-expand-xxl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}

.navbar-expand {
  flex-wrap: nowrap;
  justify-content: flex-start;
}

.navbar-expand .navbar-nav {
  flex-direction: row;
}

.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}

.navbar-expand .navbar-nav .nav-link {
  padding-right: 0.5rem;
  padding-left: 0.5rem;
}

.navbar-expand .navbar-nav-scroll {
  overflow: visible;
}

.navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}

.navbar-expand .navbar-toggler {
  display: none;
}

.navbar-expand .offcanvas-header {
  display: none;
}

.navbar-expand .offcanvas {
  position: inherit;
  bottom: 0;
  z-index: 1000;
  flex-grow: 1;
  visibility: visible !important;
  background-color: transparent;
  border-right: 0;
  border-left: 0;
  transition: none;
  transform: none;
}

.navbar-expand .offcanvas-top,
.navbar-expand .offcanvas-bottom {
  height: auto;
  border-top: 0;
  border-bottom: 0;
}

.navbar-expand .offcanvas-body {
  display: flex;
  flex-grow: 0;
  padding: 0;
  overflow-y: visible;
}

.navbar-light .navbar-brand {
  color: rgba(0, 0, 0, 0.9);
}

.navbar-light .navbar-brand:hover,
.navbar-light .navbar-brand:focus {
  color: rgba(0, 0, 0, 0.9);
}

.navbar-light .navbar-nav .nav-link {
  color: rgba(0, 0, 0, 0.55);
}

.navbar-light .navbar-nav .nav-link:hover,
.navbar-light .navbar-nav .nav-link:focus {
  color: rgba(0, 0, 0, 0.7);
}

.navbar-light .navbar-nav .nav-link.disabled {
  color: rgba(0, 0, 0, 0.3);
}

.navbar-light .navbar-nav .show>.nav-link,
.navbar-light .navbar-nav .nav-link.active {
  color: rgba(0, 0, 0, 0.9);
}

.navbar-light .navbar-toggler {
  color: rgba(0, 0, 0, 0.55);
  border-color: rgba(0, 0, 0, 0.1);
}

.navbar-light .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
}

.navbar-light .navbar-text {
  color: rgba(0, 0, 0, 0.55);
}

.navbar-light .navbar-text a,
.navbar-light .navbar-text a:hover,
.navbar-light .navbar-text a:focus {
  color: rgba(0, 0, 0, 0.9);
}

.navbar-dark .navbar-brand {
  color: #ffffff;
}

.navbar-dark .navbar-brand:hover,
.navbar-dark .navbar-brand:focus {
  color: #ffffff;
}

.navbar-dark .navbar-nav .nav-link {
  color: rgba(255, 255, 255, 0.55);
}

.navbar-dark .navbar-nav .nav-link:hover,
.navbar-dark .navbar-nav .nav-link:focus {
  color: rgba(255, 255, 255, 0.75);
}

.navbar-dark .navbar-nav .nav-link.disabled {
  color: rgba(255, 255, 255, 0.25);
}

.navbar-dark .navbar-nav .show>.nav-link,
.navbar-dark .navbar-nav .nav-link.active {
  color: #ffffff;
}

.navbar-dark .navbar-toggler {
  color: rgba(255, 255, 255, 0.55);
  border-color: rgba(255, 255, 255, 0.1);
}

.navbar-dark .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
}

.navbar-dark .navbar-text {
  color: rgba(255, 255, 255, 0.55);
}

.navbar-dark .navbar-text a,
.navbar-dark .navbar-text a:hover,
.navbar-dark .navbar-text a:focus {
  color: #ffffff;
}

.card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #ffffff;
  background-clip: border-box;
  /* border: 1px solid #f3f3f3;
  border-radius: 0.25rem; */
}

.card>hr {
  margin-right: 0;
  margin-left: 0;
}

.card>.list-group {
  border-top: inherit;
  border-bottom: inherit;
}

.card>.list-group:first-child {
  border-top-width: 0;
  border-top-left-radius: calc(0.25rem - 1px);
  border-top-right-radius: calc(0.25rem - 1px);
}

.card>.list-group:last-child {
  border-bottom-width: 0;
  border-bottom-right-radius: calc(0.25rem - 1px);
  border-bottom-left-radius: calc(0.25rem - 1px);
}

.card>.card-header+.list-group,
.card>.list-group+.card-footer {
  border-top: 0;
}

/* page loading set height start*/

.pageOnloadHight {
  height: 100vh;
  /* display: none; */
}

/* page loading set height end */
.card-body {
  flex: 1 1 auto;
  padding: 1rem 1rem;
}

.card-title {
  margin-bottom: 0.5rem;
}

.card-subtitle {
  margin-top: -0.25rem;
  margin-bottom: 0;
}

.card-text:last-child {
  margin-bottom: 0;
}

.card-link+.card-link {
  margin-left: 1rem;
}

.card-header {
  padding: 0.5rem 1rem;
  margin-bottom: 0;
  /* background-color: rgba(0, 0, 0, 0.03); */
  border-bottom: 1px solid var(--border-color);
}

.card-header:first-child {
  border-radius: calc(0.25rem - 1px) calc(0.25rem - 1px) 0 0;
}

.card-footer {
  padding: 0.5rem 1rem;
  background-color: rgba(0, 0, 0, 0.03);
  border-top: 1px solid var(--border-color);
}

.card-footer:last-child {
  border-radius: 0 0 calc(0.25rem - 1px) calc(0.25rem - 1px);
}

.card-header-tabs {
  margin-right: -0.5rem;
  margin-bottom: -0.5rem;
  margin-left: -0.5rem;
  border-bottom: 0;
}

.card-header-tabs .nav-link.active {
  background-color: #ffffff;
  border-bottom-color: #ffffff;
}

.card-header-pills {
  margin-right: -0.5rem;
  margin-left: -0.5rem;
}

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 1rem;
  border-radius: calc(0.25rem - 1px);
}

.card-img,
.card-img-top,
.card-img-bottom {
  width: 100%;
}

.card-img,
.card-img-top {
  border-top-left-radius: calc(0.25rem - 1px);
  border-top-right-radius: calc(0.25rem - 1px);
}

.card-img,
.card-img-bottom {
  border-bottom-right-radius: calc(0.25rem - 1px);
  border-bottom-left-radius: calc(0.25rem - 1px);
}

.card-group>.card {
  margin-bottom: 0.75rem;
}

@media (min-width: 576px) {
  .card-group {
    display: flex;
    flex-flow: row wrap;
  }

  .card-group>.card {
    flex: 1 0;
    margin-bottom: 0;
  }

  .card-group>.card+.card {
    margin-left: 0;
    border-left: 0;
  }

  .card-group>.card:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  .card-group>.card:not(:last-child) .card-img-top,
  .card-group>.card:not(:last-child) .card-header {
    border-top-right-radius: 0;
  }

  .card-group>.card:not(:last-child) .card-img-bottom,
  .card-group>.card:not(:last-child) .card-footer {
    border-bottom-right-radius: 0;
  }

  .card-group>.card:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  .card-group>.card:not(:first-child) .card-img-top,
  .card-group>.card:not(:first-child) .card-header {
    border-top-left-radius: 0;
  }

  .card-group>.card:not(:first-child) .card-img-bottom,
  .card-group>.card:not(:first-child) .card-footer {
    border-bottom-left-radius: 0;
  }
}

.accordion-button {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding: 1rem 1.25rem;
  font-size: 0.875rem;
  color: var(--bs-body-color);
  text-align: left;
  background-color: #fdfdfd;
  border: 0;
  border-radius: 0;
  overflow-anchor: none;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;
}

@media (prefers-reduced-motion: reduce) {
  .accordion-button {
    transition: none;
  }
}

.accordion-button:not(.collapsed) {
  color: #7a99db;
  background-color: #f3f7fe;
  box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.125);
}

.accordion-button:not(.collapsed)::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  transform: rotate(-180deg);
}

.accordion-button::after {
  flex-shrink: 0;
  width: 1.25rem;
  height: 1.25rem;
  margin-left: auto;
  content: "";
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  background-repeat: no-repeat;
  background-size: 1.25rem;
  transition: transform 0.2s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .accordion-button::after {
    transition: none;
  }
}

.accordion-button:hover {
  z-index: 2;
}

.accordion-button:focus {
  z-index: 3;
  border-color: #c4d5f9;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(136, 170, 243, 0.25);
}

.accordion-header {
  margin-bottom: 0;
}

.accordion-item {
  background-color: #fdfdfd;
  border: 1px solid rgba(0, 0, 0, 0.125);
}

.accordion-item:first-of-type {
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}

.accordion-item:first-of-type .accordion-button {
  border-top-left-radius: calc(0.25rem - 1px);
  border-top-right-radius: calc(0.25rem - 1px);
}

.accordion-item:not(:first-of-type) {
  border-top: 0;
}

.accordion-item:last-of-type {
  border-bottom-right-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}

.accordion-item:last-of-type .accordion-button.collapsed {
  border-bottom-right-radius: calc(0.25rem - 1px);
  border-bottom-left-radius: calc(0.25rem - 1px);
}

.accordion-item:last-of-type .accordion-collapse {
  border-bottom-right-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}

.accordion-body {
  padding: 1rem 1.25rem;
}

.accordion-flush .accordion-collapse {
  border-width: 0;
}

.accordion-flush .accordion-item {
  border-right: 0;
  border-left: 0;
  border-radius: 0;
}

.accordion-flush .accordion-item:first-child {
  border-top: 0;
}

.accordion-flush .accordion-item:last-child {
  border-bottom: 0;
}

.accordion-flush .accordion-item .accordion-button {
  border-radius: 0;
}

.breadcrumb {
  display: flex;
  flex-wrap: wrap;
  padding: 1rem 1.25rem;
  margin-bottom: 1rem;
  list-style: none;
  background-color: transparent;
}

.breadcrumb-item+.breadcrumb-item {
  padding-left: 0.5rem;
}

.breadcrumb-item+.breadcrumb-item::before {
  float: left;
  padding-right: 0.5rem;
  color: #6c757d;
  content: var(--bs-breadcrumb-divider, "/")
    /* rtl: var(--bs-breadcrumb-divider, "/") */
  ;
}

.breadcrumb-item.active {
  color: #6c757d;
}

.pagination {
  display: flex;
  padding-left: 0;
  list-style: none;
}

.page-link {
  position: relative;
  display: block;
  color: var(--admin-color);
  text-decoration: none;
  background-color: #ffffff;
  border: 1px solid #dee2e6;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .page-link {
    transition: none;
  }
}

.page-link:hover {
  z-index: 2;
  color: #6d88c2;
  background-color: #e9ecef;
  border-color: #dee2e6;
}

.page-link:focus {
  z-index: 3;
  color: #6d88c2;
  background-color: #e9ecef;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(136, 170, 243, 0.25);
}

.page-item:not(:first-child) .page-link {
  margin-left: -1px;
}

.page-item.active .page-link {
  z-index: 3;
  color: #ffffff;
  background-color: var(--admin-color);
  border-color: var(--admin-color);
}

.page-item.disabled .page-link {
  color: #6c757d;
  pointer-events: none;
  background-color: #ffffff;
  border-color: #dee2e6;
}

.page-link {
  padding: 1rem 1.25rem;
}

.page-item:first-child .page-link {
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}

.page-item:last-child .page-link {
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}

.pagination-lg .page-link {
  padding: 0.75rem 1.5rem;
  font-size: 1.09375rem;
}

.pagination-lg .page-item:first-child .page-link {
  border-top-left-radius: 0.3rem;
  border-bottom-left-radius: 0.3rem;
}

.pagination-lg .page-item:last-child .page-link {
  border-top-right-radius: 0.3rem;
  border-bottom-right-radius: 0.3rem;
}

.pagination-sm .page-link {
  padding: 0.25rem 0.5rem;
  font-size: 0.765625rem;
}

.pagination-sm .page-item:first-child .page-link {
  border-top-left-radius: 0.2rem;
  border-bottom-left-radius: 0.2rem;
}

.pagination-sm .page-item:last-child .page-link {
  border-top-right-radius: 0.2rem;
  border-bottom-right-radius: 0.2rem;
}

.badge {
  display: inline-block;
  padding: 0.5em 1em;
  font-size: 0.75em;
  font-weight: 500;
  line-height: 1;
  color: #ffffff;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.125rem;
}

.badge:empty {
  display: none;
}

.btn .badge {
  position: relative;
  top: -1px;
}

.alert {
  position: relative;
  padding: 1.25rem 1.25rem;
  margin-bottom: 1rem;
  border: 1px solid transparent;
  border-radius: 0.25rem;
}

.alert-heading {
  color: inherit;
}

.alert-link {
  font-weight: 700;
}

.alert-dismissible {
  padding-right: 3.75rem;
}

.alert-dismissible .btn-close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  padding: 1.5625rem 1.25rem;
}

.alert-purple {
  color: #4e3e88;
  background-color: #e6e1f9;
  border-color: #dad2f6;
}

.alert-purple .alert-link {
  color: #3e326d;
}

@keyframes progress-bar-stripes {
  0% {
    background-position-x: 1rem;
  }
}

.progress {
  display: flex;
  height: 1rem;
  overflow: hidden;
  font-size: 0.65625rem;
  background-color: #e9ecef;
  border-radius: 0.25rem;
}

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: #ffffff;
  text-align: center;
  white-space: nowrap;
  background-color: var(--admin-color);
  transition: width 0.6s ease;
}

@media (prefers-reduced-motion: reduce) {
  .progress-bar {
    transition: none;
  }
}

.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: 1rem 1rem;
}

.progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes;
}

@media (prefers-reduced-motion: reduce) {
  .progress-bar-animated {
    animation: none;
  }
}

.list-group {
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: 0.25rem;
}

.list-group-numbered {
  list-style-type: none;
  counter-reset: section;
}

.list-group-numbered>li::before {
  content: counters(section, ".") ". ";
  counter-increment: section;
}

.list-group-item-action {
  width: 100%;
  color: #495057;
  text-align: inherit;
}

.list-group-item-action:hover,
.list-group-item-action:focus {
  z-index: 1;
  color: #495057;
  text-decoration: none;
  background-color: #fdfdfd;
}

.list-group-item-action:active {
  color: var(--bs-body-color);
  background-color: #e9ecef;
}

.list-group-item {
  position: relative;
  display: block;
  padding: 0.5rem 1rem;
  color: #212529;
  text-decoration: none;
  background-color: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.125);
}

.list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}

.list-group-item:last-child {
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}

.list-group-item.disabled,
.list-group-item:disabled {
  color: #6c757d;
  pointer-events: none;
  background-color: #ffffff;
}

.list-group-item.active {
  z-index: 2;
  color: #ffffff;
  background-color: var(--admin-color);
  border-color: var(--admin-color);
}

.list-group-item+.list-group-item {
  border-top-width: 0;
}

.list-group-item+.list-group-item.active {
  margin-top: -1px;
  border-top-width: 1px;
}

.list-group-horizontal {
  flex-direction: row;
}

.list-group-horizontal>.list-group-item:first-child {
  border-bottom-left-radius: 0.25rem;
  border-top-right-radius: 0;
}

.list-group-horizontal>.list-group-item:last-child {
  border-top-right-radius: 0.25rem;
  border-bottom-left-radius: 0;
}

.list-group-horizontal>.list-group-item.active {
  margin-top: 0;
}

.list-group-horizontal>.list-group-item+.list-group-item {
  border-top-width: 1px;
  border-left-width: 0;
}

.list-group-horizontal>.list-group-item+.list-group-item.active {
  margin-left: -1px;
  border-left-width: 1px;
}

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row;
  }

  .list-group-horizontal-sm>.list-group-item:first-child {
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0;
  }

  .list-group-horizontal-sm>.list-group-item:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-left-radius: 0;
  }

  .list-group-horizontal-sm>.list-group-item.active {
    margin-top: 0;
  }

  .list-group-horizontal-sm>.list-group-item+.list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }

  .list-group-horizontal-sm>.list-group-item+.list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}

@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row;
  }

  .list-group-horizontal-md>.list-group-item:first-child {
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0;
  }

  .list-group-horizontal-md>.list-group-item:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-left-radius: 0;
  }

  .list-group-horizontal-md>.list-group-item.active {
    margin-top: 0;
  }

  .list-group-horizontal-md>.list-group-item+.list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }

  .list-group-horizontal-md>.list-group-item+.list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}

@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row;
  }

  .list-group-horizontal-lg>.list-group-item:first-child {
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0;
  }

  .list-group-horizontal-lg>.list-group-item:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-left-radius: 0;
  }

  .list-group-horizontal-lg>.list-group-item.active {
    margin-top: 0;
  }

  .list-group-horizontal-lg>.list-group-item+.list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }

  .list-group-horizontal-lg>.list-group-item+.list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}

@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row;
  }

  .list-group-horizontal-xl>.list-group-item:first-child {
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0;
  }

  .list-group-horizontal-xl>.list-group-item:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-left-radius: 0;
  }

  .list-group-horizontal-xl>.list-group-item.active {
    margin-top: 0;
  }

  .list-group-horizontal-xl>.list-group-item+.list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }

  .list-group-horizontal-xl>.list-group-item+.list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}

@media (min-width: 1500px) {
  .list-group-horizontal-xxl {
    flex-direction: row;
  }

  .list-group-horizontal-xxl>.list-group-item:first-child {
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0;
  }

  .list-group-horizontal-xxl>.list-group-item:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-left-radius: 0;
  }

  .list-group-horizontal-xxl>.list-group-item.active {
    margin-top: 0;
  }

  .list-group-horizontal-xxl>.list-group-item+.list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }

  .list-group-horizontal-xxl>.list-group-item+.list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}

.list-group-flush {
  border-radius: 0;
}

.list-group-flush>.list-group-item {
  border-width: 0 0 1px;
}

.list-group-flush>.list-group-item:last-child {
  border-bottom-width: 0;
}

.list-group-item-purple {
  color: #4e3e88;
  background-color: #e6e1f9;
}

.list-group-item-purple.list-group-item-action:hover,
.list-group-item-purple.list-group-item-action:focus {
  color: #4e3e88;
  background-color: #cfcbe0;
}

.list-group-item-purple.list-group-item-action.active {
  color: #ffffff;
  background-color: #4e3e88;
  border-color: #4e3e88;
}

.btn-close {
  box-sizing: content-box;
  width: 1em;
  height: 1em;
  padding: 0.25em 0.25em;
  color: #000;
  background: transparent url(${___CSS_LOADER_URL_REPLACEMENT_13___}) center/1em auto no-repeat;
  border: 0;
  border-radius: 0.25rem;
  opacity: 0.5;
}

.btn-close:hover {
  color: #000;
  text-decoration: none;
  opacity: 0.75;
}

.btn-close:focus {
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(136, 170, 243, 0.25);
  opacity: 1;
}

.btn-close:disabled,
.btn-close.disabled {
  pointer-events: none;
  -webkit-user-select: none;
  user-select: none;
  opacity: 0.25;
}

.btn-close-white {
  filter: invert(1) grayscale(100%) brightness(200%);
}

.toast {
  width: 350px;
  max-width: 100%;
  font-size: 0.875rem;
  pointer-events: auto;
  background-color: rgba(255, 255, 255, 0.85);
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
}

.toast.showing {
  opacity: 0;
}

.toast:not(.show) {
  display: none;
}

.toast-container {
  width: max-content;
  max-width: 100%;
  pointer-events: none;
}

.toast-container> :not(:last-child) {
  margin-bottom: 0.75rem;
}

.toast-header {
  display: flex;
  align-items: center;
  padding: 0.5rem 0.75rem;
  color: #6c757d;
  background-color: rgba(255, 255, 255, 0.85);
  background-clip: padding-box;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  border-top-left-radius: calc(0.25rem - 1px);
  border-top-right-radius: calc(0.25rem - 1px);
}

.toast-header .btn-close {
  margin-right: -0.375rem;
  margin-left: 0.75rem;
}

.toast-body {
  padding: 0.75rem;
  word-wrap: break-word;
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1055;
  display: none;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: 0.5rem;
  pointer-events: none;
}

.modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
  transform: translate(0, -50px);
}

@media (prefers-reduced-motion: reduce) {
  .modal.fade .modal-dialog {
    transition: none;
  }
}

.modal.show .modal-dialog {
  transform: none;
}

.modal.modal-static .modal-dialog {
  transform: scale(1.02);
}

.modal-dialog-scrollable {
  height: calc(100% - 1rem);
}

.modal-dialog-scrollable .modal-content {
  max-height: 100%;
  overflow: hidden;
}

.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - 1rem);
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  pointer-events: auto;
  background-color: #ffffff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0.3rem;
  outline: 0;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1050;
  width: 100vw;
  height: 100vh;
  background-color: #000;
}

.modal-backdrop.fade {
  opacity: 0;
}

.modal-backdrop.show {
  opacity: 0.5;
}

.modal-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1rem;
  border-bottom: 1px solid var(--border-color);
  border-top-left-radius: calc(0.3rem - 1px);
  border-top-right-radius: calc(0.3rem - 1px);
}

.modal-header .btn-close {
  padding: 0.5rem 0.5rem;
  margin: -0.5rem -0.5rem -0.5rem auto;
}

.modal-title {
  margin-bottom: 0;
  line-height: 1.5;
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: 1rem;
}

.modal-footer {
  display: flex;
  flex-wrap: wrap;
  flex-shrink: 0;
  align-items: center;
  justify-content: flex-end;
  padding: 0.75rem;
  border-top: 1px solid var(--border-color);
  border-bottom-right-radius: calc(0.3rem - 1px);
  border-bottom-left-radius: calc(0.3rem - 1px);
}

.modal-footer>* {
  margin: 0.25rem;
}

@media (min-width: 576px) {
  .modal-dialog {
    max-width: 500px;
    margin: 1.75rem auto;
  }

  .modal-dialog-scrollable {
    height: calc(100% - 3.5rem);
  }

  .modal-dialog-centered {
    min-height: calc(100% - 3.5rem);
  }

  .modal-sm {
    max-width: 400px;
  }
}

@media (min-width: 992px) {

  .modal-lg,
  .modal-xl {
    max-width: 800px;
  }
}

@media (min-width: 1200px) {
  .modal-xl {
    max-width: 1140px;
  }
}

.modal-fullscreen {
  width: 100vw;
  max-width: none;
  height: 100%;
  margin: 0;
}

.modal-fullscreen .modal-content {
  height: 100%;
  border: 0;
  border-radius: 0;
}

.modal-fullscreen .modal-header {
  border-radius: 0;
}

.modal-fullscreen .modal-body {
  overflow-y: auto;
}

.modal-fullscreen .modal-footer {
  border-radius: 0;
}

@media (max-width: 575.98px) {
  .modal-fullscreen-sm-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }

  .modal-fullscreen-sm-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }

  .modal-fullscreen-sm-down .modal-header {
    border-radius: 0;
  }

  .modal-fullscreen-sm-down .modal-body {
    overflow-y: auto;
  }

  .modal-fullscreen-sm-down .modal-footer {
    border-radius: 0;
  }
}

@media (max-width: 767.98px) {
  .modal-fullscreen-md-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }

  .modal-fullscreen-md-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }

  .modal-fullscreen-md-down .modal-header {
    border-radius: 0;
  }

  .modal-fullscreen-md-down .modal-body {
    overflow-y: auto;
  }

  .modal-fullscreen-md-down .modal-footer {
    border-radius: 0;
  }
}

@media (max-width: 991.98px) {
  .modal-fullscreen-lg-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }

  .modal-fullscreen-lg-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }

  .modal-fullscreen-lg-down .modal-header {
    border-radius: 0;
  }

  .modal-fullscreen-lg-down .modal-body {
    overflow-y: auto;
  }

  .modal-fullscreen-lg-down .modal-footer {
    border-radius: 0;
  }
}

@media (max-width: 1199.98px) {
  .modal-fullscreen-xl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }

  .modal-fullscreen-xl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }

  .modal-fullscreen-xl-down .modal-header {
    border-radius: 0;
  }

  .modal-fullscreen-xl-down .modal-body {
    overflow-y: auto;
  }

  .modal-fullscreen-xl-down .modal-footer {
    border-radius: 0;
  }
}

@media (max-width: 1499.98px) {
  .modal-fullscreen-xxl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }

  .modal-fullscreen-xxl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }

  .modal-fullscreen-xxl-down .modal-header {
    border-radius: 0;
  }

  .modal-fullscreen-xxl-down .modal-body {
    overflow-y: auto;
  }

  .modal-fullscreen-xxl-down .modal-footer {
    border-radius: 0;
  }
}

.tooltip {
  position: absolute;
  z-index: 1080;
  display: block;
  margin: 0;
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  word-spacing: normal;
  white-space: normal;
  line-break: auto;
  font-size: 0.765625rem;
  word-wrap: break-word;
  opacity: 0;
}

.tooltip.show {
  opacity: 0.9;
}

.tooltip .tooltip-arrow {
  position: absolute;
  display: block;
  width: 0.8rem;
  height: 0.4rem;
}

.tooltip .tooltip-arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-tooltip-top,
.bs-tooltip-auto[data-popper-placement^=top] {
  padding: 0.4rem 0;
}

.bs-tooltip-top .tooltip-arrow,
.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow {
  bottom: 0;
}

.bs-tooltip-top .tooltip-arrow::before,
.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {
  top: -1px;
  border-width: 0.4rem 0.4rem 0;
  border-top-color: #000;
}

.bs-tooltip-end,
.bs-tooltip-auto[data-popper-placement^=right] {
  padding: 0 0.4rem;
}

.bs-tooltip-end .tooltip-arrow,
.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow {
  left: 0;
  width: 0.4rem;
  height: 0.8rem;
}

.bs-tooltip-end .tooltip-arrow::before,
.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {
  right: -1px;
  border-width: 0.4rem 0.4rem 0.4rem 0;
  border-right-color: #000;
}

.bs-tooltip-bottom,
.bs-tooltip-auto[data-popper-placement^=bottom] {
  padding: 0.4rem 0;
}

.bs-tooltip-bottom .tooltip-arrow,
.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow {
  top: 0;
}

.bs-tooltip-bottom .tooltip-arrow::before,
.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {
  bottom: -1px;
  border-width: 0 0.4rem 0.4rem;
  border-bottom-color: #000;
}

.bs-tooltip-start,
.bs-tooltip-auto[data-popper-placement^=left] {
  padding: 0 0.4rem;
}

.bs-tooltip-start .tooltip-arrow,
.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow {
  right: 0;
  width: 0.4rem;
  height: 0.8rem;
}

.bs-tooltip-start .tooltip-arrow::before,
.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {
  left: -1px;
  border-width: 0.4rem 0 0.4rem 0.4rem;
  border-left-color: #000;
}

.tooltip-inner {
  max-width: 200px;
  padding: 0.25rem 0.5rem;
  color: #ffffff;
  text-align: center;
  background-color: #000;
  border-radius: 0.25rem;
}

.popover {
  position: absolute;
  top: 0;
  left: 0
    /* rtl:ignore */
  ;
  z-index: 1070;
  display: block;
  max-width: 276px;
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  word-spacing: normal;
  white-space: normal;
  line-break: auto;
  font-size: 0.765625rem;
  word-wrap: break-word;
  background-color: #ffffff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0.3rem;
}

.popover .popover-arrow {
  position: absolute;
  display: block;
  width: 1rem;
  height: 0.5rem;
}

.popover .popover-arrow::before,
.popover .popover-arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-popover-top>.popover-arrow,
.bs-popover-auto[data-popper-placement^=top]>.popover-arrow {
  bottom: calc(-0.5rem - 1px);
}

.bs-popover-top>.popover-arrow::before,
.bs-popover-auto[data-popper-placement^=top]>.popover-arrow::before {
  bottom: 0;
  border-width: 0.5rem 0.5rem 0;
  border-top-color: rgba(0, 0, 0, 0.25);
}

.bs-popover-top>.popover-arrow::after,
.bs-popover-auto[data-popper-placement^=top]>.popover-arrow::after {
  bottom: 1px;
  border-width: 0.5rem 0.5rem 0;
  border-top-color: #ffffff;
}

.bs-popover-end>.popover-arrow,
.bs-popover-auto[data-popper-placement^=right]>.popover-arrow {
  left: calc(-0.5rem - 1px);
  width: 0.5rem;
  height: 1rem;
}

.bs-popover-end>.popover-arrow::before,
.bs-popover-auto[data-popper-placement^=right]>.popover-arrow::before {
  left: 0;
  border-width: 0.5rem 0.5rem 0.5rem 0;
  border-right-color: rgba(0, 0, 0, 0.25);
}

.bs-popover-end>.popover-arrow::after,
.bs-popover-auto[data-popper-placement^=right]>.popover-arrow::after {
  left: 1px;
  border-width: 0.5rem 0.5rem 0.5rem 0;
  border-right-color: #ffffff;
}

.bs-popover-bottom>.popover-arrow,
.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow {
  top: calc(-0.5rem - 1px);
}

.bs-popover-bottom>.popover-arrow::before,
.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow::before {
  top: 0;
  border-width: 0 0.5rem 0.5rem 0.5rem;
  border-bottom-color: rgba(0, 0, 0, 0.25);
}

.bs-popover-bottom>.popover-arrow::after,
.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow::after {
  top: 1px;
  border-width: 0 0.5rem 0.5rem 0.5rem;
  border-bottom-color: #ffffff;
}

.bs-popover-bottom .popover-header::before,
.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: 1rem;
  margin-left: -0.5rem;
  content: "";
  border-bottom: 1px solid #f0f0f0;
}

.bs-popover-start>.popover-arrow,
.bs-popover-auto[data-popper-placement^=left]>.popover-arrow {
  right: calc(-0.5rem - 1px);
  width: 0.5rem;
  height: 1rem;
}

.bs-popover-start>.popover-arrow::before,
.bs-popover-auto[data-popper-placement^=left]>.popover-arrow::before {
  right: 0;
  border-width: 0.5rem 0 0.5rem 0.5rem;
  border-left-color: rgba(0, 0, 0, 0.25);
}

.bs-popover-start>.popover-arrow::after,
.bs-popover-auto[data-popper-placement^=left]>.popover-arrow::after {
  right: 1px;
  border-width: 0.5rem 0 0.5rem 0.5rem;
  border-left-color: #ffffff;
}

.popover-header {
  padding: 0.5rem 1rem;
  margin-bottom: 0;
  font-size: 0.875rem;
  background-color: #f0f0f0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  border-top-left-radius: calc(0.3rem - 1px);
  border-top-right-radius: calc(0.3rem - 1px);
}

.popover-header:empty {
  display: none;
}

.popover-body {
  padding: 1rem 1rem;
  color: var(--bs-body-color);
}

.carousel {
  position: relative;
}

.carousel.pointer-event {
  touch-action: pan-y;
}

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.carousel-inner::after {
  display: block;
  clear: both;
  content: "";
}

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  backface-visibility: hidden;
  transition: transform 0.6s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .carousel-item {
    transition: none;
  }
}

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block;
}

/* rtl:begin:ignore */
.carousel-item-next:not(.carousel-item-start),
.active.carousel-item-end {
  transform: translateX(100%);
}

.carousel-item-prev:not(.carousel-item-end),
.active.carousel-item-start {
  transform: translateX(-100%);
}

/* rtl:end:ignore */
.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none;
}

.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-start,
.carousel-fade .carousel-item-prev.carousel-item-end {
  z-index: 1;
  opacity: 1;
}

.carousel-fade .active.carousel-item-start,
.carousel-fade .active.carousel-item-end {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s;
}

@media (prefers-reduced-motion: reduce) {

  .carousel-fade .active.carousel-item-start,
  .carousel-fade .active.carousel-item-end {
    transition: none;
  }
}

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  padding: 0;
  color: #ffffff;
  text-align: center;
  background: none;
  border: 0;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}

@media (prefers-reduced-motion: reduce) {

  .carousel-control-prev,
  .carousel-control-next {
    transition: none;
  }
}

.carousel-control-prev:hover,
.carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
  color: #ffffff;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}

.carousel-control-prev {
  left: 0;
}

.carousel-control-next {
  right: 0;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 100% 100%;
}

/* rtl:options: {
  "autoRename": true,
  "stringMap":[ {
    "name"    : "prev-next",
    "search"  : "prev",
    "replace" : "next"
  } ]
} */
.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
}

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
}

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  display: flex;
  justify-content: center;
  padding: 0;
  margin-right: 15%;
  margin-bottom: 1rem;
  margin-left: 15%;
  list-style: none;
}

.carousel-indicators [data-bs-target] {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  padding: 0;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #ffffff;
  background-clip: padding-box;
  border: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  transition: opacity 0.6s ease;
}

@media (prefers-reduced-motion: reduce) {
  .carousel-indicators [data-bs-target] {
    transition: none;
  }
}

.carousel-indicators .active {
  opacity: 1;
}

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 1.25rem;
  left: 15%;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: #ffffff;
  text-align: center;
}

.carousel-dark .carousel-control-prev-icon,
.carousel-dark .carousel-control-next-icon {
  filter: invert(1) grayscale(100);
}

.carousel-dark .carousel-indicators [data-bs-target] {
  background-color: #000;
}

.carousel-dark .carousel-caption {
  color: #000;
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg)
      /* rtl:ignore */
    ;
  }
}

.spinner-border {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: -0.125em;
  border: 0.25em solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: 0.75s linear infinite spinner-border;
}

.spinner-border-sm {
  width: 1rem;
  height: 1rem;
  border-width: 0.2em;
}

@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }

  50% {
    opacity: 1;
    transform: none;
  }
}

.spinner-grow {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: -0.125em;
  background-color: currentColor;
  border-radius: 50%;
  opacity: 0;
  animation: 0.75s linear infinite spinner-grow;
}

.spinner-grow-sm {
  width: 1rem;
  height: 1rem;
}

@media (prefers-reduced-motion: reduce) {

  .spinner-border,
  .spinner-grow {
    animation-duration: 1.5s;
  }
}

.offcanvas {
  position: fixed;
  bottom: 0;
  z-index: 1045;
  display: flex;
  flex-direction: column;
  max-width: 100%;
  visibility: hidden;
  background-color: #ffffff;
  background-clip: padding-box;
  outline: 0;
  transition: transform 0.3s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .offcanvas {
    transition: none;
  }
}

.offcanvas-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #000;
}

.offcanvas-backdrop.fade {
  opacity: 0;
}

.offcanvas-backdrop.show {
  opacity: 0.5;
}

.offcanvas-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1rem;
}

.offcanvas-header .btn-close {
  padding: 0.5rem 0.5rem;
  margin-top: -0.5rem;
  margin-right: -0.5rem;
  margin-bottom: -0.5rem;
}

.offcanvas-title {
  margin-bottom: 0;
  line-height: 1.5;
}

.offcanvas-body {
  flex-grow: 1;
  padding: 1rem 1rem;
  overflow-y: auto;
}

.offcanvas-start {
  top: 0;
  left: 0;
  width: 400px;
  border-right: 1px solid rgba(0, 0, 0, 0.2);
  transform: translateX(-100%);
}

.offcanvas-end {
  top: 0;
  right: 0;
  width: 400px;
  border-left: 1px solid rgba(0, 0, 0, 0.2);
  transform: translateX(100%);
}

.offcanvas-top {
  top: 0;
  right: 0;
  left: 0;
  height: 30vh;
  max-height: 100%;
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  transform: translateY(-100%);
}

.offcanvas-bottom {
  right: 0;
  left: 0;
  height: 30vh;
  max-height: 100%;
  border-top: 1px solid rgba(0, 0, 0, 0.2);
  transform: translateY(100%);
}

.offcanvas.show {
  transform: none;
}

.placeholder {
  display: inline-block;
  min-height: 1em;
  vertical-align: middle;
  cursor: wait;
  background-color: currentColor;
  opacity: 0.5;
}

.placeholder.btn::before {
  display: inline-block;
  content: "";
}

.placeholder-xs {
  min-height: 0.6em;
}

.placeholder-sm {
  min-height: 0.8em;
}

.placeholder-lg {
  min-height: 1.2em;
}

.placeholder-glow .placeholder {
  animation: placeholder-glow 2s ease-in-out infinite;
}

@keyframes placeholder-glow {
  50% {
    opacity: 0.2;
  }
}

.placeholder-wave {
  mask-image: linear-gradient(130deg, #000 55%, rgba(0, 0, 0, 0.8) 75%, #000 95%);
  mask-size: 200% 100%;
  animation: placeholder-wave 2s linear infinite;
}

@keyframes placeholder-wave {
  100% {
    mask-position: -200% 0%;
  }
}

.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.link-purple {
  color: #8268e2;
}

.link-purple:hover,
.link-purple:focus {
  color: #9b86e8;
}

.ratio {
  position: relative;
  width: 100%;
}

.ratio::before {
  display: block;
  padding-top: var(--bs-aspect-ratio);
  content: "";
}

.ratio>* {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.ratio-1x1 {
  --bs-aspect-ratio: 100%;
}

.ratio-4x3 {
  --bs-aspect-ratio: calc(3 / 4 * 100%);
}

.ratio-16x9 {
  --bs-aspect-ratio: calc(9 / 16 * 100%);
}

.ratio-21x9 {
  --bs-aspect-ratio: calc(9 / 21 * 100%);
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

.sticky-top {
  position: sticky;
  top: 0;
  z-index: 1020;
}

@media (min-width: 576px) {
  .sticky-sm-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
}

@media (min-width: 768px) {
  .sticky-md-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
}

@media (min-width: 992px) {
  .sticky-lg-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
}

@media (min-width: 1200px) {
  .sticky-xl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
}

@media (min-width: 1500px) {
  .sticky-xxl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
}

.hstack {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
}

.vstack {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-self: stretch;
}

.visually-hidden,
.visually-hidden-focusable:not(:focus):not(:focus-within) {
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}

.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  content: "";
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vr {
  display: inline-block;
  align-self: stretch;
  width: 1px;
  min-height: 1em;
  background-color: currentColor;
  opacity: 0.25;
}

.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

.float-start {
  float: left !important;
}

.float-end {
  float: right !important;
}

.float-none {
  float: none !important;
}

.opacity-0 {
  opacity: 0 !important;
}

.opacity-25 {
  opacity: 0.25 !important;
}

.opacity-50 {
  opacity: 0.5 !important;
}

.opacity-75 {
  opacity: 0.75 !important;
}

.opacity-100 {
  opacity: 1 !important;
}

.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.overflow-visible {
  overflow: visible !important;
}

.overflow-scroll {
  overflow: scroll !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-grid {
  display: grid !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

.d-none {
  display: none !important;
}

.shadow {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}

.shadow-sm {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
}

.shadow-lg {
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175) !important;
}

.shadow-none {
  box-shadow: none !important;
}

.position-static {
  position: static !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: sticky !important;
}

.top-0 {
  top: 0 !important;
}

.top-50 {
  top: 50% !important;
}

.top-100 {
  top: 100% !important;
}

.bottom-0 {
  bottom: 0 !important;
}

.bottom-50 {
  bottom: 50% !important;
}

.bottom-100 {
  bottom: 100% !important;
}

.start-0 {
  left: 0 !important;
}

.start-50 {
  left: 50% !important;
}

.start-100 {
  left: 100% !important;
}

.end-0 {
  right: 0 !important;
}

.end-50 {
  right: 50% !important;
}

.end-100 {
  right: 100% !important;
}

.translate-middle {
  transform: translate(-50%, -50%) !important;
}

.translate-middle-x {
  transform: translateX(-50%) !important;
}

.translate-middle-y {
  transform: translateY(-50%) !important;
}

.border {
  border: 1px solid var(--border-color) !important;
}

.border-0 {
  border: 0 !important;
}

.border-top {
  border-top: 1px solid var(--border-color) !important;
}

.border-top-0 {
  border-top: 0 !important;
}

.border-end {
  border-right: 1px solid var(--border-color) !important;
}

.border-end-0 {
  border-right: 0 !important;
}

.border-bottom {
  border-bottom: 1px solid var(--border-color) !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

.border-start {
  border-left: 1px solid var(--border-color) !important;
}

.border-start-0 {
  border-left: 0 !important;
}

.border-purple {
  border-color: #8268e2 !important;
}

.border-white {
  border-color: #ffffff !important;
}

.border-1 {
  border-width: 1px !important;
}

.border-2 {
  border-width: 2px !important;
}

.border-3 {
  border-width: 3px !important;
}

.border-4 {
  border-width: 4px !important;
}

.border-5 {
  border-width: 5px !important;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.mw-100 {
  max-width: 100% !important;
}

.vw-100 {
  width: 100vw !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.mh-100 {
  max-height: 100% !important;
}

.vh-100 {
  height: 100vh !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.gap-6 {
  gap: 3.5rem !important;
}

.gap-7 {
  gap: 4rem !important;
}

.gap-8 {
  gap: 4.5rem !important;
}

.gap-9 {
  gap: 5rem !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.justify-content-evenly {
  justify-content: space-evenly !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

.order-first {
  order: -1 !important;
}

.order-0 {
  order: 0 !important;
}

.order-1 {
  order: 1 !important;
}

.order-2 {
  order: 2 !important;
}

.order-3 {
  order: 3 !important;
}

.order-4 {
  order: 4 !important;
}

.order-5 {
  order: 5 !important;
}

.order-last {
  order: 6 !important;
}

.m-6 {
  margin: 3.5rem !important;
}

.m-7 {
  margin: 4rem !important;
}

.m-8 {
  margin: 4.5rem !important;
}

.m-9 {
  margin: 5rem !important;
}

.m-auto {
  margin: auto !important;
}

.mx-6 {
  margin-right: 3.5rem !important;
  margin-left: 3.5rem !important;
}

.mx-7 {
  margin-right: 4rem !important;
  margin-left: 4rem !important;
}

.mx-8 {
  margin-right: 4.5rem !important;
  margin-left: 4.5rem !important;
}

.mx-9 {
  margin-right: 5rem !important;
  margin-left: 5rem !important;
}

.mx-auto {
  margin-right: auto !important;
  margin-left: auto !important;
}

.my-6 {
  margin-top: 3.5rem !important;
  margin-bottom: 3.5rem !important;
}

.my-7 {
  margin-top: 4rem !important;
  margin-bottom: 4rem !important;
}

.my-8 {
  margin-top: 4.5rem !important;
  margin-bottom: 4.5rem !important;
}

.my-9 {
  margin-top: 5rem !important;
  margin-bottom: 5rem !important;
}

.my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important;
}

.mt-6 {
  margin-top: 3.5rem !important;
}

.mt-7 {
  margin-top: 4rem !important;
}

.mt-8 {
  margin-top: 4.5rem !important;
}

.mt-9 {
  margin-top: 5rem !important;
}

.mt-auto {
  margin-top: auto !important;
}

.me-6 {
  margin-right: 3.5rem !important;
}

.me-7 {
  margin-right: 4rem !important;
}

.me-8 {
  margin-right: 4.5rem !important;
}

.me-9 {
  margin-right: 5rem !important;
}

.me-auto {
  margin-right: auto !important;
}

.mb-6 {
  margin-bottom: 3.5rem !important;
}

.mb-7 {
  margin-bottom: 4rem !important;
}

.mb-8 {
  margin-bottom: 4.5rem !important;
}

.mb-9 {
  margin-bottom: 5rem !important;
}

.mb-auto {
  margin-bottom: auto !important;
}

.ms-6 {
  margin-left: 3.5rem !important;
}

.ms-7 {
  margin-left: 4rem !important;
}

.ms-8 {
  margin-left: 4.5rem !important;
}

.ms-9 {
  margin-left: 5rem !important;
}

.ms-auto {
  margin-left: auto !important;
}

.p-6 {
  padding: 3.5rem !important;
}

.p-7 {
  padding: 4rem !important;
}

.p-8 {
  padding: 4.5rem !important;
}

.p-9 {
  padding: 5rem !important;
}

.px-6 {
  padding-right: 3.5rem !important;
  padding-left: 3.5rem !important;
}

.px-7 {
  padding-right: 4rem !important;
  padding-left: 4rem !important;
}

.px-8 {
  padding-right: 4.5rem !important;
  padding-left: 4.5rem !important;
}

.px-9 {
  padding-right: 5rem !important;
  padding-left: 5rem !important;
}

.py-6 {
  padding-top: 3.5rem !important;
  padding-bottom: 3.5rem !important;
}

.py-7 {
  padding-top: 4rem !important;
  padding-bottom: 4rem !important;
}

.py-8 {
  padding-top: 4.5rem !important;
  padding-bottom: 4.5rem !important;
}

.py-9 {
  padding-top: 5rem !important;
  padding-bottom: 5rem !important;
}

.pt-6 {
  padding-top: 3.5rem !important;
}

.pt-7 {
  padding-top: 4rem !important;
}

.pt-8 {
  padding-top: 4.5rem !important;
}

.pt-9 {
  padding-top: 5rem !important;
}

.pe-6 {
  padding-right: 3.5rem !important;
}

.pe-7 {
  padding-right: 4rem !important;
}

.pe-8 {
  padding-right: 4.5rem !important;
}

.pe-9 {
  padding-right: 5rem !important;
}

.pb-6 {
  padding-bottom: 3.5rem !important;
}

.pb-7 {
  padding-bottom: 4rem !important;
}

.pb-8 {
  padding-bottom: 4.5rem !important;
}

.pb-9 {
  padding-bottom: 5rem !important;
}

.ps-6 {
  padding-left: 3.5rem !important;
}

.ps-7 {
  padding-left: 4rem !important;
}

.ps-8 {
  padding-left: 4.5rem !important;
}

.ps-9 {
  padding-left: 5rem !important;
}

.font-monospace {
  font-family: var(--bs-font-monospace) !important;
}

.fs-1 {
  font-size: calc(1.37525rem + 1.503vw) !important;
}

.fs-2 {
  font-size: calc(1.3249375rem + 0.89925vw) !important;
}

.fs-3 {
  font-size: calc(1.274625rem + 0.2955vw) !important;
}

.fs-4 {
  font-size: calc(1.250125rem + 0.0015vw) !important;
}

.fs-5 {
  font-size: 1.124375rem !important;
}

.fs-6 {
  font-size: 0.93625rem !important;
}

.fst-italic {
  font-style: italic !important;
}

.fst-normal {
  font-style: normal !important;
}

.fw-light {
  font-weight: 300 !important;
}

.fw-lighter {
  font-weight: lighter !important;
}

.fw-normal {
  font-weight: 400 !important;
}

.fw-bold {
  font-weight: 700 !important;
}

.fw-bolder {
  font-weight: bolder !important;
}

.lh-1 {
  line-height: 1 !important;
}

.lh-sm {
  line-height: 1.25 !important;
}

.lh-base {
  line-height: 1.5 !important;
}

.lh-lg {
  line-height: 2 !important;
}

.text-start {
  text-align: left !important;
}

.text-end {
  text-align: right !important;
}

.text-center {
  text-align: center !important;
}

.text-decoration-none {
  text-decoration: none !important;
}

.text-decoration-underline {
  text-decoration: underline !important;
}

.text-decoration-line-through {
  text-decoration: line-through !important;
}

.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.text-wrap {
  white-space: normal !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

/* rtl:begin:remove */
.text-break {
  word-wrap: break-word !important;
  word-break: break-word !important;
}

/* rtl:end:remove */
.text-purple {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-purple-rgb), var(--bs-text-opacity)) !important;
}

.text-black {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;
}

.text-white {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;
}

.text-body {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important;
}

.text-muted {
  --bs-text-opacity: 1;
  color: #6c757d !important;
}

.text-black-50 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, 0.5) !important;
}

.text-white-50 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-reset {
  --bs-text-opacity: 1;
  color: inherit !important;
}

.text-opacity-25 {
  --bs-text-opacity: 0.25;
}

.text-opacity-50 {
  --bs-text-opacity: 0.5;
}

.text-opacity-75 {
  --bs-text-opacity: 0.75;
}

.text-opacity-100 {
  --bs-text-opacity: 1;
}

.bg-purple {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-purple-rgb), var(--bs-bg-opacity)) !important;
}

.bg-black {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important;
}

.bg-white {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-transparent {
  --bs-bg-opacity: 1;
  background-color: transparent !important;
}

.bg-opacity-10 {
  --bs-bg-opacity: 0.1;
}

.bg-opacity-25 {
  --bs-bg-opacity: 0.25;
}

.bg-opacity-50 {
  --bs-bg-opacity: 0.5;
}

.bg-opacity-75 {
  --bs-bg-opacity: 0.75;
}

.bg-opacity-100 {
  --bs-bg-opacity: 1;
}

.bg-gradient {
  background-image: var(--bs-gradient) !important;
}

.user-select-all {
  -webkit-user-select: all !important;
  user-select: all !important;
}

.user-select-auto {
  -webkit-user-select: auto !important;
  user-select: auto !important;
}

.user-select-none {
  -webkit-user-select: none !important;
  user-select: none !important;
}

.pe-none {
  pointer-events: none !important;
}

.pe-auto {
  pointer-events: auto !important;
}

.rounded {
  border-radius: 0.25rem !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.rounded-1 {
  border-radius: 0.2rem !important;
}

.rounded-2 {
  border-radius: 0.25rem !important;
}

.rounded-3 {
  border-radius: 0.3rem !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-pill {
  border-radius: 50rem !important;
}

.rounded-top {
  border-top-left-radius: 0.25rem !important;
  border-top-right-radius: 0.25rem !important;
}

.rounded-end {
  border-top-right-radius: 0.25rem !important;
  border-bottom-right-radius: 0.25rem !important;
}

.rounded-bottom {
  border-bottom-right-radius: 0.25rem !important;
  border-bottom-left-radius: 0.25rem !important;
}

.rounded-start {
  border-bottom-left-radius: 0.25rem !important;
  border-top-left-radius: 0.25rem !important;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

@media (min-width: 576px) {
  .float-sm-start {
    float: left !important;
  }

  .float-sm-end {
    float: right !important;
  }

  .float-sm-none {
    float: none !important;
  }

  .d-sm-inline {
    display: inline !important;
  }

  .d-sm-inline-block {
    display: inline-block !important;
  }

  .d-sm-block {
    display: block !important;
  }

  .d-sm-grid {
    display: grid !important;
  }

  .d-sm-table {
    display: table !important;
  }

  .d-sm-table-row {
    display: table-row !important;
  }

  .d-sm-table-cell {
    display: table-cell !important;
  }

  .d-sm-flex {
    display: flex !important;
  }

  .d-sm-inline-flex {
    display: inline-flex !important;
  }

  .d-sm-none {
    display: none !important;
  }

  .flex-sm-fill {
    flex: 1 1 auto !important;
  }

  .flex-sm-row {
    flex-direction: row !important;
  }

  .flex-sm-column {
    flex-direction: column !important;
  }

  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }

  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }

  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }

  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }

  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }

  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }

  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }

  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }

  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }

  .gap-sm-6 {
    gap: 3.5rem !important;
  }

  .gap-sm-7 {
    gap: 4rem !important;
  }

  .gap-sm-8 {
    gap: 4.5rem !important;
  }

  .gap-sm-9 {
    gap: 5rem !important;
  }

  .justify-content-sm-start {
    justify-content: flex-start !important;
  }

  .justify-content-sm-end {
    justify-content: flex-end !important;
  }

  .justify-content-sm-center {
    justify-content: center !important;
  }

  .justify-content-sm-between {
    justify-content: space-between !important;
  }

  .justify-content-sm-around {
    justify-content: space-around !important;
  }

  .justify-content-sm-evenly {
    justify-content: space-evenly !important;
  }

  .align-items-sm-start {
    align-items: flex-start !important;
  }

  .align-items-sm-end {
    align-items: flex-end !important;
  }

  .align-items-sm-center {
    align-items: center !important;
  }

  .align-items-sm-baseline {
    align-items: baseline !important;
  }

  .align-items-sm-stretch {
    align-items: stretch !important;
  }

  .align-content-sm-start {
    align-content: flex-start !important;
  }

  .align-content-sm-end {
    align-content: flex-end !important;
  }

  .align-content-sm-center {
    align-content: center !important;
  }

  .align-content-sm-between {
    align-content: space-between !important;
  }

  .align-content-sm-around {
    align-content: space-around !important;
  }

  .align-content-sm-stretch {
    align-content: stretch !important;
  }

  .align-self-sm-auto {
    align-self: auto !important;
  }

  .align-self-sm-start {
    align-self: flex-start !important;
  }

  .align-self-sm-end {
    align-self: flex-end !important;
  }

  .align-self-sm-center {
    align-self: center !important;
  }

  .align-self-sm-baseline {
    align-self: baseline !important;
  }

  .align-self-sm-stretch {
    align-self: stretch !important;
  }

  .order-sm-first {
    order: -1 !important;
  }

  .order-sm-0 {
    order: 0 !important;
  }

  .order-sm-1 {
    order: 1 !important;
  }

  .order-sm-2 {
    order: 2 !important;
  }

  .order-sm-3 {
    order: 3 !important;
  }

  .order-sm-4 {
    order: 4 !important;
  }

  .order-sm-5 {
    order: 5 !important;
  }

  .order-sm-last {
    order: 6 !important;
  }

  .m-sm-6 {
    margin: 3.5rem !important;
  }

  .m-sm-7 {
    margin: 4rem !important;
  }

  .m-sm-8 {
    margin: 4.5rem !important;
  }

  .m-sm-9 {
    margin: 5rem !important;
  }

  .m-sm-auto {
    margin: auto !important;
  }

  .mx-sm-6 {
    margin-right: 3.5rem !important;
    margin-left: 3.5rem !important;
  }

  .mx-sm-7 {
    margin-right: 4rem !important;
    margin-left: 4rem !important;
  }

  .mx-sm-8 {
    margin-right: 4.5rem !important;
    margin-left: 4.5rem !important;
  }

  .mx-sm-9 {
    margin-right: 5rem !important;
    margin-left: 5rem !important;
  }

  .mx-sm-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }

  .my-sm-6 {
    margin-top: 3.5rem !important;
    margin-bottom: 3.5rem !important;
  }

  .my-sm-7 {
    margin-top: 4rem !important;
    margin-bottom: 4rem !important;
  }

  .my-sm-8 {
    margin-top: 4.5rem !important;
    margin-bottom: 4.5rem !important;
  }

  .my-sm-9 {
    margin-top: 5rem !important;
    margin-bottom: 5rem !important;
  }

  .my-sm-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }

  .mt-sm-6 {
    margin-top: 3.5rem !important;
  }

  .mt-sm-7 {
    margin-top: 4rem !important;
  }

  .mt-sm-8 {
    margin-top: 4.5rem !important;
  }

  .mt-sm-9 {
    margin-top: 5rem !important;
  }

  .mt-sm-auto {
    margin-top: auto !important;
  }

  .me-sm-6 {
    margin-right: 3.5rem !important;
  }

  .me-sm-7 {
    margin-right: 4rem !important;
  }

  .me-sm-8 {
    margin-right: 4.5rem !important;
  }

  .me-sm-9 {
    margin-right: 5rem !important;
  }

  .me-sm-auto {
    margin-right: auto !important;
  }

  .mb-sm-6 {
    margin-bottom: 3.5rem !important;
  }

  .mb-sm-7 {
    margin-bottom: 4rem !important;
  }

  .mb-sm-8 {
    margin-bottom: 4.5rem !important;
  }

  .mb-sm-9 {
    margin-bottom: 5rem !important;
  }

  .mb-sm-auto {
    margin-bottom: auto !important;
  }

  .ms-sm-6 {
    margin-left: 3.5rem !important;
  }

  .ms-sm-7 {
    margin-left: 4rem !important;
  }

  .ms-sm-8 {
    margin-left: 4.5rem !important;
  }

  .ms-sm-9 {
    margin-left: 5rem !important;
  }

  .ms-sm-auto {
    margin-left: auto !important;
  }

  .p-sm-6 {
    padding: 3.5rem !important;
  }

  .p-sm-7 {
    padding: 4rem !important;
  }

  .p-sm-8 {
    padding: 4.5rem !important;
  }

  .p-sm-9 {
    padding: 5rem !important;
  }

  .px-sm-6 {
    padding-right: 3.5rem !important;
    padding-left: 3.5rem !important;
  }

  .px-sm-7 {
    padding-right: 4rem !important;
    padding-left: 4rem !important;
  }

  .px-sm-8 {
    padding-right: 4.5rem !important;
    padding-left: 4.5rem !important;
  }

  .px-sm-9 {
    padding-right: 5rem !important;
    padding-left: 5rem !important;
  }

  .py-sm-6 {
    padding-top: 3.5rem !important;
    padding-bottom: 3.5rem !important;
  }

  .py-sm-7 {
    padding-top: 4rem !important;
    padding-bottom: 4rem !important;
  }

  .py-sm-8 {
    padding-top: 4.5rem !important;
    padding-bottom: 4.5rem !important;
  }

  .py-sm-9 {
    padding-top: 5rem !important;
    padding-bottom: 5rem !important;
  }

  .pt-sm-6 {
    padding-top: 3.5rem !important;
  }

  .pt-sm-7 {
    padding-top: 4rem !important;
  }

  .pt-sm-8 {
    padding-top: 4.5rem !important;
  }

  .pt-sm-9 {
    padding-top: 5rem !important;
  }

  .pe-sm-6 {
    padding-right: 3.5rem !important;
  }

  .pe-sm-7 {
    padding-right: 4rem !important;
  }

  .pe-sm-8 {
    padding-right: 4.5rem !important;
  }

  .pe-sm-9 {
    padding-right: 5rem !important;
  }

  .pb-sm-6 {
    padding-bottom: 3.5rem !important;
  }

  .pb-sm-7 {
    padding-bottom: 4rem !important;
  }

  .pb-sm-8 {
    padding-bottom: 4.5rem !important;
  }

  .pb-sm-9 {
    padding-bottom: 5rem !important;
  }

  .ps-sm-6 {
    padding-left: 3.5rem !important;
  }

  .ps-sm-7 {
    padding-left: 4rem !important;
  }

  .ps-sm-8 {
    padding-left: 4.5rem !important;
  }

  .ps-sm-9 {
    padding-left: 5rem !important;
  }

  .text-sm-start {
    text-align: left !important;
  }

  .text-sm-end {
    text-align: right !important;
  }

  .text-sm-center {
    text-align: center !important;
  }
}

@media (min-width: 768px) {
  .float-md-start {
    float: left !important;
  }

  .float-md-end {
    float: right !important;
  }

  .float-md-none {
    float: none !important;
  }

  .d-md-inline {
    display: inline !important;
  }

  .d-md-inline-block {
    display: inline-block !important;
  }

  .d-md-block {
    display: block !important;
  }

  .d-md-grid {
    display: grid !important;
  }

  .d-md-table {
    display: table !important;
  }

  .d-md-table-row {
    display: table-row !important;
  }

  .d-md-table-cell {
    display: table-cell !important;
  }

  .d-md-flex {
    display: flex !important;
  }

  .d-md-inline-flex {
    display: inline-flex !important;
  }

  .d-md-none {
    display: none !important;
  }

  .flex-md-fill {
    flex: 1 1 auto !important;
  }

  .flex-md-row {
    flex-direction: row !important;
  }

  .flex-md-column {
    flex-direction: column !important;
  }

  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }

  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }

  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }

  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }

  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }

  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }

  .flex-md-wrap {
    flex-wrap: wrap !important;
  }

  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }

  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }

  .gap-md-6 {
    gap: 3.5rem !important;
  }

  .gap-md-7 {
    gap: 4rem !important;
  }

  .gap-md-8 {
    gap: 4.5rem !important;
  }

  .gap-md-9 {
    gap: 5rem !important;
  }

  .justify-content-md-start {
    justify-content: flex-start !important;
  }

  .justify-content-md-end {
    justify-content: flex-end !important;
  }

  .justify-content-md-center {
    justify-content: center !important;
  }

  .justify-content-md-between {
    justify-content: space-between !important;
  }

  .justify-content-md-around {
    justify-content: space-around !important;
  }

  .justify-content-md-evenly {
    justify-content: space-evenly !important;
  }

  .align-items-md-start {
    align-items: flex-start !important;
  }

  .align-items-md-end {
    align-items: flex-end !important;
  }

  .align-items-md-center {
    align-items: center !important;
  }

  .align-items-md-baseline {
    align-items: baseline !important;
  }

  .align-items-md-stretch {
    align-items: stretch !important;
  }

  .align-content-md-start {
    align-content: flex-start !important;
  }

  .align-content-md-end {
    align-content: flex-end !important;
  }

  .align-content-md-center {
    align-content: center !important;
  }

  .align-content-md-between {
    align-content: space-between !important;
  }

  .align-content-md-around {
    align-content: space-around !important;
  }

  .align-content-md-stretch {
    align-content: stretch !important;
  }

  .align-self-md-auto {
    align-self: auto !important;
  }

  .align-self-md-start {
    align-self: flex-start !important;
  }

  .align-self-md-end {
    align-self: flex-end !important;
  }

  .align-self-md-center {
    align-self: center !important;
  }

  .align-self-md-baseline {
    align-self: baseline !important;
  }

  .align-self-md-stretch {
    align-self: stretch !important;
  }

  .order-md-first {
    order: -1 !important;
  }

  .order-md-0 {
    order: 0 !important;
  }

  .order-md-1 {
    order: 1 !important;
  }

  .order-md-2 {
    order: 2 !important;
  }

  .order-md-3 {
    order: 3 !important;
  }

  .order-md-4 {
    order: 4 !important;
  }

  .order-md-5 {
    order: 5 !important;
  }

  .order-md-last {
    order: 6 !important;
  }

  .m-md-6 {
    margin: 3.5rem !important;
  }

  .m-md-7 {
    margin: 4rem !important;
  }

  .m-md-8 {
    margin: 4.5rem !important;
  }

  .m-md-9 {
    margin: 5rem !important;
  }

  .m-md-auto {
    margin: auto !important;
  }

  .mx-md-6 {
    margin-right: 3.5rem !important;
    margin-left: 3.5rem !important;
  }

  .mx-md-7 {
    margin-right: 4rem !important;
    margin-left: 4rem !important;
  }

  .mx-md-8 {
    margin-right: 4.5rem !important;
    margin-left: 4.5rem !important;
  }

  .mx-md-9 {
    margin-right: 5rem !important;
    margin-left: 5rem !important;
  }

  .mx-md-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }

  .my-md-6 {
    margin-top: 3.5rem !important;
    margin-bottom: 3.5rem !important;
  }

  .my-md-7 {
    margin-top: 4rem !important;
    margin-bottom: 4rem !important;
  }

  .my-md-8 {
    margin-top: 4.5rem !important;
    margin-bottom: 4.5rem !important;
  }

  .my-md-9 {
    margin-top: 5rem !important;
    margin-bottom: 5rem !important;
  }

  .my-md-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }

  .mt-md-6 {
    margin-top: 3.5rem !important;
  }

  .mt-md-7 {
    margin-top: 4rem !important;
  }

  .mt-md-8 {
    margin-top: 4.5rem !important;
  }

  .mt-md-9 {
    margin-top: 5rem !important;
  }

  .mt-md-auto {
    margin-top: auto !important;
  }

  .me-md-6 {
    margin-right: 3.5rem !important;
  }

  .me-md-7 {
    margin-right: 4rem !important;
  }

  .me-md-8 {
    margin-right: 4.5rem !important;
  }

  .me-md-9 {
    margin-right: 5rem !important;
  }

  .me-md-auto {
    margin-right: auto !important;
  }

  .mb-md-6 {
    margin-bottom: 3.5rem !important;
  }

  .mb-md-7 {
    margin-bottom: 4rem !important;
  }

  .mb-md-8 {
    margin-bottom: 4.5rem !important;
  }

  .mb-md-9 {
    margin-bottom: 5rem !important;
  }

  .mb-md-auto {
    margin-bottom: auto !important;
  }

  .ms-md-6 {
    margin-left: 3.5rem !important;
  }

  .ms-md-7 {
    margin-left: 4rem !important;
  }

  .ms-md-8 {
    margin-left: 4.5rem !important;
  }

  .ms-md-9 {
    margin-left: 5rem !important;
  }

  .ms-md-auto {
    margin-left: auto !important;
  }

  .p-md-6 {
    padding: 3.5rem !important;
  }

  .p-md-7 {
    padding: 4rem !important;
  }

  .p-md-8 {
    padding: 4.5rem !important;
  }

  .p-md-9 {
    padding: 5rem !important;
  }

  .px-md-6 {
    padding-right: 3.5rem !important;
    padding-left: 3.5rem !important;
  }

  .px-md-7 {
    padding-right: 4rem !important;
    padding-left: 4rem !important;
  }

  .px-md-8 {
    padding-right: 4.5rem !important;
    padding-left: 4.5rem !important;
  }

  .px-md-9 {
    padding-right: 5rem !important;
    padding-left: 5rem !important;
  }

  .py-md-6 {
    padding-top: 3.5rem !important;
    padding-bottom: 3.5rem !important;
  }

  .py-md-7 {
    padding-top: 4rem !important;
    padding-bottom: 4rem !important;
  }

  .py-md-8 {
    padding-top: 4.5rem !important;
    padding-bottom: 4.5rem !important;
  }

  .py-md-9 {
    padding-top: 5rem !important;
    padding-bottom: 5rem !important;
  }

  .pt-md-6 {
    padding-top: 3.5rem !important;
  }

  .pt-md-7 {
    padding-top: 4rem !important;
  }

  .pt-md-8 {
    padding-top: 4.5rem !important;
  }

  .pt-md-9 {
    padding-top: 5rem !important;
  }

  .pe-md-6 {
    padding-right: 3.5rem !important;
  }

  .pe-md-7 {
    padding-right: 4rem !important;
  }

  .pe-md-8 {
    padding-right: 4.5rem !important;
  }

  .pe-md-9 {
    padding-right: 5rem !important;
  }

  .pb-md-6 {
    padding-bottom: 3.5rem !important;
  }

  .pb-md-7 {
    padding-bottom: 4rem !important;
  }

  .pb-md-8 {
    padding-bottom: 4.5rem !important;
  }

  .pb-md-9 {
    padding-bottom: 5rem !important;
  }

  .ps-md-6 {
    padding-left: 3.5rem !important;
  }

  .ps-md-7 {
    padding-left: 4rem !important;
  }

  .ps-md-8 {
    padding-left: 4.5rem !important;
  }

  .ps-md-9 {
    padding-left: 5rem !important;
  }

  .text-md-start {
    text-align: left !important;
  }

  .text-md-end {
    text-align: right !important;
  }

  .text-md-center {
    text-align: center !important;
  }
}

@media (min-width: 992px) {
  .float-lg-start {
    float: left !important;
  }

  .float-lg-end {
    float: right !important;
  }

  .float-lg-none {
    float: none !important;
  }

  .d-lg-inline {
    display: inline !important;
  }

  .d-lg-inline-block {
    display: inline-block !important;
  }

  .d-lg-block {
    display: block !important;
  }

  .d-lg-grid {
    display: grid !important;
  }

  .d-lg-table {
    display: table !important;
  }

  .d-lg-table-row {
    display: table-row !important;
  }

  .d-lg-table-cell {
    display: table-cell !important;
  }

  .d-lg-flex {
    display: flex !important;
  }

  .d-lg-inline-flex {
    display: inline-flex !important;
  }

  .d-lg-none {
    display: none !important;
  }

  .flex-lg-fill {
    flex: 1 1 auto !important;
  }

  .flex-lg-row {
    flex-direction: row !important;
  }

  .flex-lg-column {
    flex-direction: column !important;
  }

  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }

  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }

  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }

  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }

  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }

  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }

  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }

  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }

  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }

  .gap-lg-6 {
    gap: 3.5rem !important;
  }

  .gap-lg-7 {
    gap: 4rem !important;
  }

  .gap-lg-8 {
    gap: 4.5rem !important;
  }

  .gap-lg-9 {
    gap: 5rem !important;
  }

  .justify-content-lg-start {
    justify-content: flex-start !important;
  }

  .justify-content-lg-end {
    justify-content: flex-end !important;
  }

  .justify-content-lg-center {
    justify-content: center !important;
  }

  .justify-content-lg-between {
    justify-content: space-between !important;
  }

  .justify-content-lg-around {
    justify-content: space-around !important;
  }

  .justify-content-lg-evenly {
    justify-content: space-evenly !important;
  }

  .align-items-lg-start {
    align-items: flex-start !important;
  }

  .align-items-lg-end {
    align-items: flex-end !important;
  }

  .align-items-lg-center {
    align-items: center !important;
  }

  .align-items-lg-baseline {
    align-items: baseline !important;
  }

  .align-items-lg-stretch {
    align-items: stretch !important;
  }

  .align-content-lg-start {
    align-content: flex-start !important;
  }

  .align-content-lg-end {
    align-content: flex-end !important;
  }

  .align-content-lg-center {
    align-content: center !important;
  }

  .align-content-lg-between {
    align-content: space-between !important;
  }

  .align-content-lg-around {
    align-content: space-around !important;
  }

  .align-content-lg-stretch {
    align-content: stretch !important;
  }

  .align-self-lg-auto {
    align-self: auto !important;
  }

  .align-self-lg-start {
    align-self: flex-start !important;
  }

  .align-self-lg-end {
    align-self: flex-end !important;
  }

  .align-self-lg-center {
    align-self: center !important;
  }

  .align-self-lg-baseline {
    align-self: baseline !important;
  }

  .align-self-lg-stretch {
    align-self: stretch !important;
  }

  .order-lg-first {
    order: -1 !important;
  }

  .order-lg-0 {
    order: 0 !important;
  }

  .order-lg-1 {
    order: 1 !important;
  }

  .order-lg-2 {
    order: 2 !important;
  }

  .order-lg-3 {
    order: 3 !important;
  }

  .order-lg-4 {
    order: 4 !important;
  }

  .order-lg-5 {
    order: 5 !important;
  }

  .order-lg-last {
    order: 6 !important;
  }

  .m-lg-6 {
    margin: 3.5rem !important;
  }

  .m-lg-7 {
    margin: 4rem !important;
  }

  .m-lg-8 {
    margin: 4.5rem !important;
  }

  .m-lg-9 {
    margin: 5rem !important;
  }

  .m-lg-auto {
    margin: auto !important;
  }

  .mx-lg-6 {
    margin-right: 3.5rem !important;
    margin-left: 3.5rem !important;
  }

  .mx-lg-7 {
    margin-right: 4rem !important;
    margin-left: 4rem !important;
  }

  .mx-lg-8 {
    margin-right: 4.5rem !important;
    margin-left: 4.5rem !important;
  }

  .mx-lg-9 {
    margin-right: 5rem !important;
    margin-left: 5rem !important;
  }

  .mx-lg-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }

  .my-lg-6 {
    margin-top: 3.5rem !important;
    margin-bottom: 3.5rem !important;
  }

  .my-lg-7 {
    margin-top: 4rem !important;
    margin-bottom: 4rem !important;
  }

  .my-lg-8 {
    margin-top: 4.5rem !important;
    margin-bottom: 4.5rem !important;
  }

  .my-lg-9 {
    margin-top: 5rem !important;
    margin-bottom: 5rem !important;
  }

  .my-lg-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }

  .mt-lg-6 {
    margin-top: 3.5rem !important;
  }

  .mt-lg-7 {
    margin-top: 4rem !important;
  }

  .mt-lg-8 {
    margin-top: 4.5rem !important;
  }

  .mt-lg-9 {
    margin-top: 5rem !important;
  }

  .mt-lg-auto {
    margin-top: auto !important;
  }

  .me-lg-6 {
    margin-right: 3.5rem !important;
  }

  .me-lg-7 {
    margin-right: 4rem !important;
  }

  .me-lg-8 {
    margin-right: 4.5rem !important;
  }

  .me-lg-9 {
    margin-right: 5rem !important;
  }

  .me-lg-auto {
    margin-right: auto !important;
  }

  .mb-lg-6 {
    margin-bottom: 3.5rem !important;
  }

  .mb-lg-7 {
    margin-bottom: 4rem !important;
  }

  .mb-lg-8 {
    margin-bottom: 4.5rem !important;
  }

  .mb-lg-9 {
    margin-bottom: 5rem !important;
  }

  .mb-lg-auto {
    margin-bottom: auto !important;
  }

  .ms-lg-6 {
    margin-left: 3.5rem !important;
  }

  .ms-lg-7 {
    margin-left: 4rem !important;
  }

  .ms-lg-8 {
    margin-left: 4.5rem !important;
  }

  .ms-lg-9 {
    margin-left: 5rem !important;
  }

  .ms-lg-auto {
    margin-left: auto !important;
  }

  .p-lg-6 {
    padding: 3.5rem !important;
  }

  .p-lg-7 {
    padding: 4rem !important;
  }

  .p-lg-8 {
    padding: 4.5rem !important;
  }

  .p-lg-9 {
    padding: 5rem !important;
  }

  .px-lg-6 {
    padding-right: 3.5rem !important;
    padding-left: 3.5rem !important;
  }

  .px-lg-7 {
    padding-right: 4rem !important;
    padding-left: 4rem !important;
  }

  .px-lg-8 {
    padding-right: 4.5rem !important;
    padding-left: 4.5rem !important;
  }

  .px-lg-9 {
    padding-right: 5rem !important;
    padding-left: 5rem !important;
  }

  .py-lg-6 {
    padding-top: 3.5rem !important;
    padding-bottom: 3.5rem !important;
  }

  .py-lg-7 {
    padding-top: 4rem !important;
    padding-bottom: 4rem !important;
  }

  .py-lg-8 {
    padding-top: 4.5rem !important;
    padding-bottom: 4.5rem !important;
  }

  .py-lg-9 {
    padding-top: 5rem !important;
    padding-bottom: 5rem !important;
  }

  .pt-lg-6 {
    padding-top: 3.5rem !important;
  }

  .pt-lg-7 {
    padding-top: 4rem !important;
  }

  .pt-lg-8 {
    padding-top: 4.5rem !important;
  }

  .pt-lg-9 {
    padding-top: 5rem !important;
  }

  .pe-lg-6 {
    padding-right: 3.5rem !important;
  }

  .pe-lg-7 {
    padding-right: 4rem !important;
  }

  .pe-lg-8 {
    padding-right: 4.5rem !important;
  }

  .pe-lg-9 {
    padding-right: 5rem !important;
  }

  .pb-lg-6 {
    padding-bottom: 3.5rem !important;
  }

  .pb-lg-7 {
    padding-bottom: 4rem !important;
  }

  .pb-lg-8 {
    padding-bottom: 4.5rem !important;
  }

  .pb-lg-9 {
    padding-bottom: 5rem !important;
  }

  .ps-lg-6 {
    padding-left: 3.5rem !important;
  }

  .ps-lg-7 {
    padding-left: 4rem !important;
  }

  .ps-lg-8 {
    padding-left: 4.5rem !important;
  }

  .ps-lg-9 {
    padding-left: 5rem !important;
  }

  .text-lg-start {
    text-align: left !important;
  }

  .text-lg-end {
    text-align: right !important;
  }

  .text-lg-center {
    text-align: center !important;
  }
}

@media (min-width: 1200px) {
  .float-xl-start {
    float: left !important;
  }

  .float-xl-end {
    float: right !important;
  }

  .float-xl-none {
    float: none !important;
  }

  .d-xl-inline {
    display: inline !important;
  }

  .d-xl-inline-block {
    display: inline-block !important;
  }

  .d-xl-block {
    display: block !important;
  }

  .d-xl-grid {
    display: grid !important;
  }

  .d-xl-table {
    display: table !important;
  }

  .d-xl-table-row {
    display: table-row !important;
  }

  .d-xl-table-cell {
    display: table-cell !important;
  }

  .d-xl-flex {
    display: flex !important;
  }

  .d-xl-inline-flex {
    display: inline-flex !important;
  }

  .d-xl-none {
    display: none !important;
  }

  .flex-xl-fill {
    flex: 1 1 auto !important;
  }

  .flex-xl-row {
    flex-direction: row !important;
  }

  .flex-xl-column {
    flex-direction: column !important;
  }

  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }

  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }

  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }

  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }

  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }

  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }

  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }

  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }

  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }

  .gap-xl-6 {
    gap: 3.5rem !important;
  }

  .gap-xl-7 {
    gap: 4rem !important;
  }

  .gap-xl-8 {
    gap: 4.5rem !important;
  }

  .gap-xl-9 {
    gap: 5rem !important;
  }

  .justify-content-xl-start {
    justify-content: flex-start !important;
  }

  .justify-content-xl-end {
    justify-content: flex-end !important;
  }

  .justify-content-xl-center {
    justify-content: center !important;
  }

  .justify-content-xl-between {
    justify-content: space-between !important;
  }

  .justify-content-xl-around {
    justify-content: space-around !important;
  }

  .justify-content-xl-evenly {
    justify-content: space-evenly !important;
  }

  .align-items-xl-start {
    align-items: flex-start !important;
  }

  .align-items-xl-end {
    align-items: flex-end !important;
  }

  .align-items-xl-center {
    align-items: center !important;
  }

  .align-items-xl-baseline {
    align-items: baseline !important;
  }

  .align-items-xl-stretch {
    align-items: stretch !important;
  }

  .align-content-xl-start {
    align-content: flex-start !important;
  }

  .align-content-xl-end {
    align-content: flex-end !important;
  }

  .align-content-xl-center {
    align-content: center !important;
  }

  .align-content-xl-between {
    align-content: space-between !important;
  }

  .align-content-xl-around {
    align-content: space-around !important;
  }

  .align-content-xl-stretch {
    align-content: stretch !important;
  }

  .align-self-xl-auto {
    align-self: auto !important;
  }

  .align-self-xl-start {
    align-self: flex-start !important;
  }

  .align-self-xl-end {
    align-self: flex-end !important;
  }

  .align-self-xl-center {
    align-self: center !important;
  }

  .align-self-xl-baseline {
    align-self: baseline !important;
  }

  .align-self-xl-stretch {
    align-self: stretch !important;
  }

  .order-xl-first {
    order: -1 !important;
  }

  .order-xl-0 {
    order: 0 !important;
  }

  .order-xl-1 {
    order: 1 !important;
  }

  .order-xl-2 {
    order: 2 !important;
  }

  .order-xl-3 {
    order: 3 !important;
  }

  .order-xl-4 {
    order: 4 !important;
  }

  .order-xl-5 {
    order: 5 !important;
  }

  .order-xl-last {
    order: 6 !important;
  }

  .m-xl-6 {
    margin: 3.5rem !important;
  }

  .m-xl-7 {
    margin: 4rem !important;
  }

  .m-xl-8 {
    margin: 4.5rem !important;
  }

  .m-xl-9 {
    margin: 5rem !important;
  }

  .m-xl-auto {
    margin: auto !important;
  }

  .mx-xl-6 {
    margin-right: 3.5rem !important;
    margin-left: 3.5rem !important;
  }

  .mx-xl-7 {
    margin-right: 4rem !important;
    margin-left: 4rem !important;
  }

  .mx-xl-8 {
    margin-right: 4.5rem !important;
    margin-left: 4.5rem !important;
  }

  .mx-xl-9 {
    margin-right: 5rem !important;
    margin-left: 5rem !important;
  }

  .mx-xl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }

  .my-xl-6 {
    margin-top: 3.5rem !important;
    margin-bottom: 3.5rem !important;
  }

  .my-xl-7 {
    margin-top: 4rem !important;
    margin-bottom: 4rem !important;
  }

  .my-xl-8 {
    margin-top: 4.5rem !important;
    margin-bottom: 4.5rem !important;
  }

  .my-xl-9 {
    margin-top: 5rem !important;
    margin-bottom: 5rem !important;
  }

  .my-xl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }

  .mt-xl-6 {
    margin-top: 3.5rem !important;
  }

  .mt-xl-7 {
    margin-top: 4rem !important;
  }

  .mt-xl-8 {
    margin-top: 4.5rem !important;
  }

  .mt-xl-9 {
    margin-top: 5rem !important;
  }

  .mt-xl-auto {
    margin-top: auto !important;
  }

  .me-xl-6 {
    margin-right: 3.5rem !important;
  }

  .me-xl-7 {
    margin-right: 4rem !important;
  }

  .me-xl-8 {
    margin-right: 4.5rem !important;
  }

  .me-xl-9 {
    margin-right: 5rem !important;
  }

  .me-xl-auto {
    margin-right: auto !important;
  }

  .mb-xl-6 {
    margin-bottom: 3.5rem !important;
  }

  .mb-xl-7 {
    margin-bottom: 4rem !important;
  }

  .mb-xl-8 {
    margin-bottom: 4.5rem !important;
  }

  .mb-xl-9 {
    margin-bottom: 5rem !important;
  }

  .mb-xl-auto {
    margin-bottom: auto !important;
  }

  .ms-xl-6 {
    margin-left: 3.5rem !important;
  }

  .ms-xl-7 {
    margin-left: 4rem !important;
  }

  .ms-xl-8 {
    margin-left: 4.5rem !important;
  }

  .ms-xl-9 {
    margin-left: 5rem !important;
  }

  .ms-xl-auto {
    margin-left: auto !important;
  }

  .p-xl-6 {
    padding: 3.5rem !important;
  }

  .p-xl-7 {
    padding: 4rem !important;
  }

  .p-xl-8 {
    padding: 4.5rem !important;
  }

  .p-xl-9 {
    padding: 5rem !important;
  }

  .px-xl-6 {
    padding-right: 3.5rem !important;
    padding-left: 3.5rem !important;
  }

  .px-xl-7 {
    padding-right: 4rem !important;
    padding-left: 4rem !important;
  }

  .px-xl-8 {
    padding-right: 4.5rem !important;
    padding-left: 4.5rem !important;
  }

  .px-xl-9 {
    padding-right: 5rem !important;
    padding-left: 5rem !important;
  }

  .py-xl-6 {
    padding-top: 3.5rem !important;
    padding-bottom: 3.5rem !important;
  }

  .py-xl-7 {
    padding-top: 4rem !important;
    padding-bottom: 4rem !important;
  }

  .py-xl-8 {
    padding-top: 4.5rem !important;
    padding-bottom: 4.5rem !important;
  }

  .py-xl-9 {
    padding-top: 5rem !important;
    padding-bottom: 5rem !important;
  }

  .pt-xl-6 {
    padding-top: 3.5rem !important;
  }

  .pt-xl-7 {
    padding-top: 4rem !important;
  }

  .pt-xl-8 {
    padding-top: 4.5rem !important;
  }

  .pt-xl-9 {
    padding-top: 5rem !important;
  }

  .pe-xl-6 {
    padding-right: 3.5rem !important;
  }

  .pe-xl-7 {
    padding-right: 4rem !important;
  }

  .pe-xl-8 {
    padding-right: 4.5rem !important;
  }

  .pe-xl-9 {
    padding-right: 5rem !important;
  }

  .pb-xl-6 {
    padding-bottom: 3.5rem !important;
  }

  .pb-xl-7 {
    padding-bottom: 4rem !important;
  }

  .pb-xl-8 {
    padding-bottom: 4.5rem !important;
  }

  .pb-xl-9 {
    padding-bottom: 5rem !important;
  }

  .ps-xl-6 {
    padding-left: 3.5rem !important;
  }

  .ps-xl-7 {
    padding-left: 4rem !important;
  }

  .ps-xl-8 {
    padding-left: 4.5rem !important;
  }

  .ps-xl-9 {
    padding-left: 5rem !important;
  }

  .text-xl-start {
    text-align: left !important;
  }

  .text-xl-end {
    text-align: right !important;
  }

  .text-xl-center {
    text-align: center !important;
  }
}

@media (min-width: 1500px) {
  .float-xxl-start {
    float: left !important;
  }

  .float-xxl-end {
    float: right !important;
  }

  .float-xxl-none {
    float: none !important;
  }

  .d-xxl-inline {
    display: inline !important;
  }

  .d-xxl-inline-block {
    display: inline-block !important;
  }

  .d-xxl-block {
    display: block !important;
  }

  .d-xxl-grid {
    display: grid !important;
  }

  .d-xxl-table {
    display: table !important;
  }

  .d-xxl-table-row {
    display: table-row !important;
  }

  .d-xxl-table-cell {
    display: table-cell !important;
  }

  .d-xxl-flex {
    display: flex !important;
  }

  .d-xxl-inline-flex {
    display: inline-flex !important;
  }

  .d-xxl-none {
    display: none !important;
  }

  .flex-xxl-fill {
    flex: 1 1 auto !important;
  }

  .flex-xxl-row {
    flex-direction: row !important;
  }

  .flex-xxl-column {
    flex-direction: column !important;
  }

  .flex-xxl-row-reverse {
    flex-direction: row-reverse !important;
  }

  .flex-xxl-column-reverse {
    flex-direction: column-reverse !important;
  }

  .flex-xxl-grow-0 {
    flex-grow: 0 !important;
  }

  .flex-xxl-grow-1 {
    flex-grow: 1 !important;
  }

  .flex-xxl-shrink-0 {
    flex-shrink: 0 !important;
  }

  .flex-xxl-shrink-1 {
    flex-shrink: 1 !important;
  }

  .flex-xxl-wrap {
    flex-wrap: wrap !important;
  }

  .flex-xxl-nowrap {
    flex-wrap: nowrap !important;
  }

  .flex-xxl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }

  .gap-xxl-6 {
    gap: 3.5rem !important;
  }

  .gap-xxl-7 {
    gap: 4rem !important;
  }

  .gap-xxl-8 {
    gap: 4.5rem !important;
  }

  .gap-xxl-9 {
    gap: 5rem !important;
  }

  .justify-content-xxl-start {
    justify-content: flex-start !important;
  }

  .justify-content-xxl-end {
    justify-content: flex-end !important;
  }

  .justify-content-xxl-center {
    justify-content: center !important;
  }

  .justify-content-xxl-between {
    justify-content: space-between !important;
  }

  .justify-content-xxl-around {
    justify-content: space-around !important;
  }

  .justify-content-xxl-evenly {
    justify-content: space-evenly !important;
  }

  .align-items-xxl-start {
    align-items: flex-start !important;
  }

  .align-items-xxl-end {
    align-items: flex-end !important;
  }

  .align-items-xxl-center {
    align-items: center !important;
  }

  .align-items-xxl-baseline {
    align-items: baseline !important;
  }

  .align-items-xxl-stretch {
    align-items: stretch !important;
  }

  .align-content-xxl-start {
    align-content: flex-start !important;
  }

  .align-content-xxl-end {
    align-content: flex-end !important;
  }

  .align-content-xxl-center {
    align-content: center !important;
  }

  .align-content-xxl-between {
    align-content: space-between !important;
  }

  .align-content-xxl-around {
    align-content: space-around !important;
  }

  .align-content-xxl-stretch {
    align-content: stretch !important;
  }

  .align-self-xxl-auto {
    align-self: auto !important;
  }

  .align-self-xxl-start {
    align-self: flex-start !important;
  }

  .align-self-xxl-end {
    align-self: flex-end !important;
  }

  .align-self-xxl-center {
    align-self: center !important;
  }

  .align-self-xxl-baseline {
    align-self: baseline !important;
  }

  .align-self-xxl-stretch {
    align-self: stretch !important;
  }

  .order-xxl-first {
    order: -1 !important;
  }

  .order-xxl-0 {
    order: 0 !important;
  }

  .order-xxl-1 {
    order: 1 !important;
  }

  .order-xxl-2 {
    order: 2 !important;
  }

  .order-xxl-3 {
    order: 3 !important;
  }

  .order-xxl-4 {
    order: 4 !important;
  }

  .order-xxl-5 {
    order: 5 !important;
  }

  .order-xxl-last {
    order: 6 !important;
  }

  .m-xxl-6 {
    margin: 3.5rem !important;
  }

  .m-xxl-7 {
    margin: 4rem !important;
  }

  .m-xxl-8 {
    margin: 4.5rem !important;
  }

  .m-xxl-9 {
    margin: 5rem !important;
  }

  .m-xxl-auto {
    margin: auto !important;
  }

  .mx-xxl-6 {
    margin-right: 3.5rem !important;
    margin-left: 3.5rem !important;
  }

  .mx-xxl-7 {
    margin-right: 4rem !important;
    margin-left: 4rem !important;
  }

  .mx-xxl-8 {
    margin-right: 4.5rem !important;
    margin-left: 4.5rem !important;
  }

  .mx-xxl-9 {
    margin-right: 5rem !important;
    margin-left: 5rem !important;
  }

  .mx-xxl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }

  .my-xxl-6 {
    margin-top: 3.5rem !important;
    margin-bottom: 3.5rem !important;
  }

  .my-xxl-7 {
    margin-top: 4rem !important;
    margin-bottom: 4rem !important;
  }

  .my-xxl-8 {
    margin-top: 4.5rem !important;
    margin-bottom: 4.5rem !important;
  }

  .my-xxl-9 {
    margin-top: 5rem !important;
    margin-bottom: 5rem !important;
  }

  .my-xxl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }

  .mt-xxl-6 {
    margin-top: 3.5rem !important;
  }

  .mt-xxl-7 {
    margin-top: 4rem !important;
  }

  .mt-xxl-8 {
    margin-top: 4.5rem !important;
  }

  .mt-xxl-9 {
    margin-top: 5rem !important;
  }

  .mt-xxl-auto {
    margin-top: auto !important;
  }

  .me-xxl-6 {
    margin-right: 3.5rem !important;
  }

  .me-xxl-7 {
    margin-right: 4rem !important;
  }

  .me-xxl-8 {
    margin-right: 4.5rem !important;
  }

  .me-xxl-9 {
    margin-right: 5rem !important;
  }

  .me-xxl-auto {
    margin-right: auto !important;
  }

  .mb-xxl-6 {
    margin-bottom: 3.5rem !important;
  }

  .mb-xxl-7 {
    margin-bottom: 4rem !important;
  }

  .mb-xxl-8 {
    margin-bottom: 4.5rem !important;
  }

  .mb-xxl-9 {
    margin-bottom: 5rem !important;
  }

  .mb-xxl-auto {
    margin-bottom: auto !important;
  }

  .ms-xxl-6 {
    margin-left: 3.5rem !important;
  }

  .ms-xxl-7 {
    margin-left: 4rem !important;
  }

  .ms-xxl-8 {
    margin-left: 4.5rem !important;
  }

  .ms-xxl-9 {
    margin-left: 5rem !important;
  }

  .ms-xxl-auto {
    margin-left: auto !important;
  }

  .p-xxl-6 {
    padding: 3.5rem !important;
  }

  .p-xxl-7 {
    padding: 4rem !important;
  }

  .p-xxl-8 {
    padding: 4.5rem !important;
  }

  .p-xxl-9 {
    padding: 5rem !important;
  }

  .px-xxl-6 {
    padding-right: 3.5rem !important;
    padding-left: 3.5rem !important;
  }

  .px-xxl-7 {
    padding-right: 4rem !important;
    padding-left: 4rem !important;
  }

  .px-xxl-8 {
    padding-right: 4.5rem !important;
    padding-left: 4.5rem !important;
  }

  .px-xxl-9 {
    padding-right: 5rem !important;
    padding-left: 5rem !important;
  }

  .py-xxl-6 {
    padding-top: 3.5rem !important;
    padding-bottom: 3.5rem !important;
  }

  .py-xxl-7 {
    padding-top: 4rem !important;
    padding-bottom: 4rem !important;
  }

  .py-xxl-8 {
    padding-top: 4.5rem !important;
    padding-bottom: 4.5rem !important;
  }

  .py-xxl-9 {
    padding-top: 5rem !important;
    padding-bottom: 5rem !important;
  }

  .pt-xxl-6 {
    padding-top: 3.5rem !important;
  }

  .pt-xxl-7 {
    padding-top: 4rem !important;
  }

  .pt-xxl-8 {
    padding-top: 4.5rem !important;
  }

  .pt-xxl-9 {
    padding-top: 5rem !important;
  }

  .pe-xxl-6 {
    padding-right: 3.5rem !important;
  }

  .pe-xxl-7 {
    padding-right: 4rem !important;
  }

  .pe-xxl-8 {
    padding-right: 4.5rem !important;
  }

  .pe-xxl-9 {
    padding-right: 5rem !important;
  }

  .pb-xxl-6 {
    padding-bottom: 3.5rem !important;
  }

  .pb-xxl-7 {
    padding-bottom: 4rem !important;
  }

  .pb-xxl-8 {
    padding-bottom: 4.5rem !important;
  }

  .pb-xxl-9 {
    padding-bottom: 5rem !important;
  }

  .ps-xxl-6 {
    padding-left: 3.5rem !important;
  }

  .ps-xxl-7 {
    padding-left: 4rem !important;
  }

  .ps-xxl-8 {
    padding-left: 4.5rem !important;
  }

  .ps-xxl-9 {
    padding-left: 5rem !important;
  }

  .text-xxl-start {
    text-align: left !important;
  }

  .text-xxl-end {
    text-align: right !important;
  }

  .text-xxl-center {
    text-align: center !important;
  }
}

@media (min-width: 1200px) {
  .fs-1 {
    font-size: 2.5025rem !important;
  }

  .fs-2 {
    font-size: 1.999375rem !important;
  }

  .fs-3 {
    font-size: 1.49625rem !important;
  }

  .fs-4 {
    font-size: 1.25125rem !important;
  }
}

@media print {
  .d-print-inline {
    display: inline !important;
  }

  .d-print-inline-block {
    display: inline-block !important;
  }

  .d-print-block {
    display: block !important;
  }

  .d-print-grid {
    display: grid !important;
  }

  .d-print-table {
    display: table !important;
  }

  .d-print-table-row {
    display: table-row !important;
  }

  .d-print-table-cell {
    display: table-cell !important;
  }

  .d-print-flex {
    display: flex !important;
  }

  .d-print-inline-flex {
    display: inline-flex !important;
  }

  .d-print-none {
    display: none !important;
  }
}

.ec-cat-form h4,
.ec-cat-form .h4 {
  border-bottom: 1px solid var(--border-color);
  padding-bottom: 20px;
  margin-bottom: 15px;
}

@media (max-width: 1199.98px) {

  .ec-cat-form h4,
  .ec-cat-form .h4 {
    font-size: 18px;
  }
}

.ec-cat-form form label {
  width: 100%;
  font-weight: 500;
  color: var(--bs-body-color);
}

.ec-cat-form form label span {
  font-size: 13px;
  color: #999;
  font-weight: 300;
  text-transform: none;
}

.ec-cat-form form input {
  width: 100%;
  padding: 0 15px;
  border-radius: 0;
  border: 1px solid #eeeeee !important;
  background-color: transparent;
  color: #777;
  line-height: 3;
  border-radius: 15px;
}

.ec-cat-form form textarea {
  width: 100%;
  padding: 0 15px;
  border-radius: 0;
  border: 1px solid #eeeeee !important;
  background-color: transparent;
  color: #777;
  padding: 15px;
  border-radius: 15px;
}

.ec-cat-form form select {
  width: 100%;
  height: 45px;
  margin: 0;
  padding: 0 15px;
  border-radius: 0;
  border: 1px solid #eeeeee !important;
  background-color: transparent;
  color: #777;
  box-shadow: none;
  outline: none;
  border-radius: 15px;
}

.ec-cat-form form input[type=text] {
  height: 45px;
  box-shadow: none;
  outline: none;
  border-radius: 15px;
}

.ec-cat-form form small,
.ec-cat-form form .small {
  margin-top: 10px;
  display: block;
}

.ec-cat-form form input[type=color] {
  width: 25px !important;
  height: 25px !important;
  padding: 0;
  border-radius: 15px;
  border-radius: 0 !important;
  display: inline-flex;
  margin: 4px;
  min-height: 25px;
}

.ec-cat-form form input[type=color] i {
  border-radius: 0;
}

.ec-cat-form form .form-checkbox-box {
  height: 30px;
  margin-top: 5px;
  display: inline-block;
}

.ec-cat-form form .form-check {
  height: 20px;
  margin: 0 5px 0 0;
  padding: 0;
  display: inline-flex;
  align-items: center;
}

.ec-cat-form form .form-check input {
  width: 35px !important;
  height: 100% !important;
  margin: 0;
}

.ec-cat-form form .form-check label {
  margin: 5px 5px 2px 7px;
  line-height: 11px;
  color: #999;
}

.ec-cat-form .bootstrap-tagsinput {
  width: 100%;
  margin-bottom: 15px;
  background-color: transparent;
  border: 1px solid #eeeeee;
  display: inline-block;
  padding: 5px 10px;
  color: #555;
  vertical-align: middle;
  border-radius: 15px;
  line-height: 22px;
  cursor: text;
}

.ec-cat-form .bootstrap-tagsinput input {
  height: 40px;
  border: none !important;
  box-shadow: none;
  outline: none;
  background-color: transparent;
  padding: 0 5px;
  margin: 0;
  width: auto;
  max-width: inherit;
}

.ec-cat-form .bootstrap-tagsinput input:focus {
  border: none;
  box-shadow: none;
}

.ec-cat-form .bootstrap-tagsinput input::placeholder {
  color: #999;
  opacity: 1;
}

.ec-cat-form .bootstrap-tagsinput .tag {
  margin-right: 2px;
  color: #777;
}

.ec-cat-form .bootstrap-tagsinput .tag [data-role=remove] {
  margin-left: 8px;
  cursor: pointer;
  color: #f96e6e;
}

.ec-cat-form .bootstrap-tagsinput .tag [data-role=remove]:after {
  content: "×";
  padding: 0px 2px;
}

.ec-cat-form .bootstrap-tagsinput .tag [data-role=remove]:hover {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.2), 0 1px 2px rgba(0, 0, 0, 0.05);
}

.ec-cat-form .bootstrap-tagsinput .tag [data-role=remove]:hover:active {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
}

.ec-cat-form .bootstrap-tagsinput.form-control input::-moz-placeholder {
  color: #777;
  opacity: 1;
}

.ec-cat-form .bootstrap-tagsinput.form-control input:-ms-input-placeholder {
  color: #777;
}

.ec-cat-form .bootstrap-tagsinput.form-control input::-webkit-input-placeholder {
  color: #777;
}

.ec-cat-list .cat-thumb {
  width: 45px;
  height: 45px;
  border-radius: 15px;
}

.ec-cat-list table tbody tr td {
  max-width: 300px;
}

.ec-cat-list table tbody tr td .ec-sub-cat-count {
  margin: 2px 0 2px 5px;
  background-color: var(--admin-color);
  padding: 2px 7px;
  color: #fff;
  border-radius: 10px;
  display: inline-block;
  flex-direction: row;
}

.ec-cat-list table tbody tr td .ec-sub-cat-tag {
  margin: 3px 0 3px 5px;
  background-color: #f9f9f9;
  padding: 2px 7px;
  border-radius: 10px;
  text-transform: capitalize;
  display: inline-block;
  flex-direction: row;
  font-size: 12px;
  letter-spacing: 0.02rem;
}

/*===== ERROR =====*/
.error-wrapper {
  padding-top: 30px;
  padding-bottom: 30px;
  border-radius: 15px;
}

.error-wrapper .error-title {
  font-size: 140px;
  line-height: 120px;
  font-weight: 600;
}

@media (max-width: 991.98px) {
  .error-wrapper .error-title {
    font-size: 100px;
    line-height: 80px;
  }
}

@media (max-width: 767.98px) {
  .error-wrapper .error-title {
    font-size: 70px;
    line-height: 50px;
  }
}

@media (max-width: 575.98px) {
  .error-wrapper .error-title {
    font-size: 50px;
    line-height: 35px;
  }
}

.error-wrapper .error-title .error-subtitle {
  font-size: 15px;
}

.error-wrapper .error-title .img-responsive {
  max-width: 100%;
}

/*===== PROFILE =====*/
@media (min-width: 992px) {
  .profile-content-right {
    border-top: 0px;
    border-left: 1px solid var(--border-color);
  }
}

.profile-content-right .nav-style-border.nav-tabs .nav-link {
  padding: 0 0 0.94rem;
}

.profile-timeline-media .media-body>span {
  font-size: 0.81rem;
}

.profile-timeline-media .media-body>p {
  line-height: 1.6;
  padding-top: 2rem;
}

.text-dark {
  color: var(--bs-black-rgb);
}

.text-secondary {
  color: var(--bs-body-color) !important;
}

.ec-store-list .store-thumb {
  width: 45px;
  height: 45px;
  border-radius: 15px;
}

@media (max-width: 575.98px) {
  .ec-store-wrapper .ec-card-space {
    padding: 15px !important;
  }
}

.ec-store-card .card-default {
  overflow: inherit;
}

.ec-store-card .card-default .ec-store-detail h6,
.ec-store-card .card-default .ec-store-detail .h6 {
  margin: 10px 0 10px 0;
  padding: 5px 2px;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.2;
  color: var(--bs-body-color);
  text-transform: capitalize !important;
  border-radius: 10px;
  background: #f1f1f1;
}

.ec-store-card .card-default .ec-store-detail h5,
.ec-store-card .card-default .ec-store-detail .h5 {
  margin-top: 0;
  margin-bottom: 0;
  font-weight: 600;
  line-height: 1.2;
  color: var(--bs-body-color);
  font-size: 15px;
}

.ec-store-card .card-default .view-detail {
  position: absolute;
  top: 6px;
  right: 15px;
  font-size: 20px;
  color: #bbb;
}

.ec-store-card .card-default .view-detail:hover {
  color: var(--admin-color);
}

.ec-store-card .card-default .store-info .img-fluid {
  width: 150px;
}

.user-list .store-thumb {
  width: 45px;
  height: 45px;
}

.ec-user-card .img-fluid {
  width: 70px;
  border-radius: 15px;
}

.ec-user-card .media-body h5,
.ec-user-card .media-body .h5 {
  font-size: 16px;
}

.ec-ec-content-wrapper .view-detail {
  position: absolute;
  top: 6px;
  right: 15px;
  font-size: 20px;
  color: #bbb;
}

.ec-ec-content-wrapper .modal-contact-detail .dropdown i {
  margin: 0 15px;
}

/*===== ORDERS =====*/
.ec-odr-dtl .ec-odr {
  display: flex;
  justify-content: space-between;
}

.ec-odr-dtl h2,
.ec-odr-dtl .h2 {
  margin-top: 0px;
  line-height: 0.8em;
  display: inline-flex;
  width: 100%;
}

.ec-odr-dtl .small {
  font-weight: 300;
  text-align: right;
}

.ec-odr-dtl hr {
  /* margin-top: 10px; */
  border-color: #ddd;
}

.ec-odr-dtl .table tr.line {
  border-bottom: 1px solid #ccc;
}

.ec-odr-dtl .table td {
  border: none;
}

.ec-odr-dtl .identity {
  margin-top: 10px;
  font-size: 1.1em;
  font-weight: 300;
}

.ec-odr-dtl .identity strong {
  font-weight: 600;
}

.ec-odr-dtl .info-grid {
  font-style: normal;
  line-height: inherit;
  border: 1px solid #e1e2e6;
  height: 100%;
  border-radius: 15px;
  overflow: hidden;
}

@media (max-width: 1199.98px) {
  .ec-odr-dtl .info-grid {
    height: auto;
    margin-bottom: 24px;
  }
}

.ec-odr-dtl .info-title {
  width: 100%;
  text-align: center;
  display: inline-block;
  background: #f7f7f7;
  padding: 10px;
  color: var(--text-color);
}

.ec-odr-dtl .info-title strong {
  font-weight: 500;
}

.ec-odr-dtl .info-content {
  padding: 20px;
}

.ec-odr-dtl .tbl-title {
  margin-top: 30px;
  border: 1px solid #f7f7f7;
  text-align: center;
  padding: 10px;
  margin-bottom: 20px;
  background: #f7f7f7;
  color: #2b2b2b;
  font-size: 15px;
}

@media (max-width: 1199.98px) {
  .ec-odr-dtl .tbl-title {
    margin-top: 0;
  }
}

.ec-odr-dtl .product-img {
  width: 50px;
  border-radius: 15px;
}

.product-img.tbl-img {
  width: 50px;
  border-radius: 15px;
}

.o-tbl thead tr td strong {
  font-weight: 500;
  color: var(--text-color);
}

.o-tbl tbody tr:nth-of-type(odd)>* {
  background-color: #f9f9f9;
  --bs-table-accent-bg: #f9f9f9;
}

.o-tbl tbody tr td strong {
  font-weight: 500;
  color: var(--text-color);
}

/*===== TRACK ORDERS =====*/
.steps .step {
  display: block;
  width: 100%;
  text-align: center;
}

@media (max-width: 575.98px) {
  .steps .step {
    margin-bottom: 24px;
  }
}

.steps .step .step-icon-wrap {
  display: block;
  position: relative;
  width: 100%;
  height: 80px;
  text-align: center;
}

.steps .step .step-icon-wrap::before {
  display: block;
  position: absolute;
  top: 50%;
  width: 50%;
  height: 3px;
  margin-top: -1px;
  background-color: #e1e7ec;
  content: "";
  z-index: 1;
  left: 0;
}

.steps .step .step-icon-wrap::after {
  display: block;
  position: absolute;
  top: 50%;
  width: 50%;
  height: 3px;
  margin-top: -1px;
  background-color: #e1e7ec;
  content: "";
  z-index: 1;
  right: 0;
}

@media (max-width: 991.98px) {
  .steps .step .step-icon-wrap {
    height: 50px;
  }
}

.steps .step .step-icon {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
  border: 1px solid #e1e7ec;
  border-radius: 30px;
  background-color: #f5f5f5;
  color: #374250;
  font-size: 38px;
  line-height: 81px;
  z-index: 5;
}

@media (max-width: 991.98px) {
  .steps .step .step-icon {
    width: 50px;
    height: 50px;
    font-size: 26px;
    line-height: 50px;
    border-radius: 18px;
  }
}

.steps .step .step-title {
  margin-top: 16px;
  margin-bottom: 0;
  color: #606975;
  font-size: 14px;
  font-weight: 500;
}

.steps .step:first-child .step-icon-wrap::before {
  display: none;
}

.steps .step:last-child .step-icon-wrap::after {
  display: none;
}

.steps .step.completed .step-icon-wrap::before {
  background-color: var(--admin-color);
}

.steps .step.completed .step-icon-wrap::after {
  background-color: var(--admin-color);
}

.steps .step.completed .step-icon {
  border-color: var(--admin-color);
  background-color: var(--admin-color);
  color: #fff;
}

.trk-order span {
  color: #777777;
}

.bg-faded,
.bg-secondary {
  background-color: #f5f5f5 !important;
}

@media (max-width: 576px) {
  .flex-sm-nowrap .step .step-icon-wrap::before {
    display: none;
  }

  .flex-sm-nowrap .step .step-icon-wrap::after {
    display: none;
  }
}

@media (max-width: 768px) {
  .flex-md-nowrap .step .step-icon-wrap::before {
    display: none;
  }

  .flex-md-nowrap .step .step-icon-wrap::after {
    display: none;
  }
}

@media (max-width: 991px) {
  .flex-lg-nowrap .step .step-icon-wrap::before {
    display: none;
  }

  .flex-lg-nowrap .step .step-icon-wrap::after {
    display: none;
  }
}

@media (max-width: 1200px) {
  .flex-xl-nowrap .step .step-icon-wrap::before {
    display: none;
  }

  .flex-xl-nowrap .step .step-icon-wrap::after {
    display: none;
  }
}

/*===== ADD PRODUCTS =====*/
.ec-store-uploads .ec-store-img-upload {
  margin-bottom: -10px;
  position: sticky;
  top: 30px;
}

.ec-store-uploads .ec-store-img-upload .ec-store-main-img .avatar-upload {
  margin-bottom: 10px;
  position: relative;
}

@media (max-width: 991.98px) {
  .ec-store-uploads .ec-store-img-upload .ec-store-main-img .avatar-upload {
    max-width: 400px;
    margin: 0 auto 15px auto;
  }
}

.ec-store-uploads .ec-store-img-upload .ec-store-main-img .avatar-upload .avatar-edit {
  position: absolute;
  right: 25px;
  z-index: 1;
  top: 25px;
}

.ec-store-uploads .ec-store-img-upload .ec-store-main-img .avatar-upload .avatar-edit input {
  opacity: 0;
  width: 40px;
  height: 40px;
  padding: 0;
  border-radius: 50%;
  position: absolute;
  z-index: 1;
}

.ec-store-uploads .ec-store-img-upload .ec-store-main-img .avatar-upload .avatar-edit input+label {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  padding: 10px;
  margin-bottom: 0;
  border-radius: 10px;
  background: #ffffff;
  border: 1px solid transparent;
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.15);
  border: 1px solid #eeeeee;
  cursor: pointer;
  font-weight: normal;
  transition: all 0.2s ease-in-out;
}

.ec-store-uploads .ec-store-img-upload .ec-store-main-img .avatar-upload .avatar-edit input+label .svg_img {
  width: 25px;
  opacity: 0.6;
}

.ec-store-uploads .ec-store-img-upload .ec-store-main-img .avatar-upload .avatar-edit input+label:hover {
  box-shadow: none;
}

.ec-store-uploads .ec-store-img-upload .ec-store-main-img .avatar-upload .avatar-preview {
  width: 100%;
  height: 100%;
  padding: 15px;
  position: relative;
  border: 1px solid #eeeeee;
  border-radius: 15px;
}

.ec-store-uploads .ec-store-img-upload .ec-store-main-img .avatar-upload .avatar-preview>div {
  width: 100%;
  height: 100%;
  display: flex;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

.ec-store-uploads .ec-store-img-upload .ec-store-main-img .avatar-upload .avatar-preview .imagePreview img {
  margin: auto;
  vertical-align: middle;
  max-width: 100%;
  border-radius: 10px;
}

.ec-store-uploads .ec-store-img-upload .ec-store-main-img .thumb-upload-set {
  display: inline-flex;
  width: 100%;
  flex-wrap: wrap;
  justify-content: center;
}

@media (max-width: 991.98px) {
  .ec-store-uploads .ec-store-img-upload .ec-store-main-img .thumb-upload-set {
    padding-bottom: 24px;
  }
}

.ec-store-uploads .ec-store-img-upload .ec-store-main-img .thumb-upload-set .thumb-upload {
  margin: 2px 7px 10px 7px;
  position: relative;
  z-index: 1;
  overflow: hidden;
  display: inline-block;
}

.ec-store-uploads .ec-store-img-upload .ec-store-main-img .thumb-upload-set .thumb-upload .thumb-edit {
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 1;
  cursor: pointer;
}

.ec-store-uploads .ec-store-img-upload .ec-store-main-img .thumb-upload-set .thumb-upload input {
  opacity: 0;
  width: 30px;
  height: 30px;
  padding: 0;
  border-radius: 50%;
  position: absolute;
  z-index: 1;
  cursor: pointer;
}

.ec-store-uploads .ec-store-img-upload .ec-store-main-img .thumb-upload-set .thumb-upload input+label {
  width: 30px;
  height: 30px;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0;
  border-radius: 10px;
  background: #ffffff;
  border: 1px solid transparent;
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.15);
  border: 1px solid #eeeeee;
  cursor: pointer;
  font-weight: normal;
  transition: all 0.2s ease-in-out;
  cursor: pointer;
}

.ec-store-uploads .ec-store-img-upload .ec-store-main-img .thumb-upload-set .thumb-upload input+label .svg_img {
  width: 18px;
  opacity: 0.6;
  cursor: pointer;
}

.ec-store-uploads .ec-store-img-upload .ec-store-main-img .thumb-upload-set .thumb-upload input+label:hover {
  box-shadow: none;
}

.ec-store-uploads .ec-store-img-upload .ec-store-main-img .thumb-upload-set .thumb-upload .thumb-preview {
  padding: 2px;
  position: relative;
  border: 1px solid #eeeeee;
  border-radius: 10px;
}

.ec-store-uploads .ec-store-img-upload .ec-store-main-img .thumb-upload-set .thumb-upload .thumb-preview>div {
  width: 80px;
  height: 80px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

@media (max-width: 1199.98px) {
  .ec-store-uploads .ec-store-img-upload .ec-store-main-img .thumb-upload-set .thumb-upload .thumb-preview>div {
    width: 70px;
    height: 70px;
  }
}

.ec-store-uploads .ec-store-img-upload .ec-store-main-img .thumb-upload-set .thumb-upload .thumb-preview img {
  width: 100%;
  height: 100%;
  vertical-align: middle;
  max-width: 100%;
  border-radius: 7px;
}

.ec-store-uploads .ec-store-upload-detail .mb-25 {
  margin-bottom: 25px;
}

.ec-store-uploads .ec-store-upload-detail form label {
  width: 100%;
  text-transform: uppercase;
  font-weight: 500;
}

.ec-store-uploads .ec-store-upload-detail form label span {
  font-size: 13px;
  color: #999;
  font-weight: 300;
  text-transform: none;
}

.ec-store-uploads .ec-store-upload-detail form input {
  width: 100%;
  margin-bottom: 30px;
  padding: 0 15px;
  border-radius: 0;
  border: 1px solid #eeeeee !important;
  background-color: transparent;
  color: #777;
  line-height: 3;
  border-radius: 15px;
}

.ec-store-uploads .ec-store-upload-detail form textarea {
  width: 100%;
  margin-bottom: 30px;
  padding: 0 15px;
  border-radius: 0;
  border: 1px solid #eeeeee !important;
  background-color: transparent;
  color: #777;
  padding: 15px;
  border-radius: 15px;
}

.ec-store-uploads .ec-store-upload-detail form select {
  width: 100%;
  height: 45px;
  margin-bottom: 30px;
  padding: 0 15px;
  border-radius: 0;
  border: 1px solid #eeeeee !important;
  background-color: transparent;
  color: #777;
  box-shadow: none;
  outline: none;
  border-radius: 15px;
}

.ec-store-uploads .ec-store-upload-detail form input[type=text] {
  height: 45px;
  box-shadow: none;
  outline: none;
  border-radius: 15px;
}

.ec-store-uploads .ec-store-upload-detail form input[type=color] {
  width: 25px !important;
  height: 25px !important;
  padding: 0;
  border-radius: 15px;
  border-radius: 0 !important;
  display: inline-flex;
  margin: 4px;
  min-height: 25px;
}

.ec-store-uploads .ec-store-upload-detail form input[type=color] i {
  border-radius: 0;
}

.ec-store-uploads .ec-store-upload-detail form .form-checkbox-box {
  height: 30px;
  margin-top: 5px;
  display: inline-block;
}

.ec-store-uploads .ec-store-upload-detail form .form-check {
  height: 20px;
  margin: 0 5px 0 0;
  padding: 0;
  display: inline-flex;
  align-items: center;
}

.ec-store-uploads .ec-store-upload-detail form .form-check input {
  width: 35px !important;
  height: 100% !important;
  margin: 0;
}

.ec-store-uploads .ec-store-upload-detail form .form-check label {
  margin: 5px 5px 2px 7px;
  line-height: 11px;
  color: #999;
}

.ec-store-uploads .ec-store-upload-detail .bootstrap-tagsinput {
  width: 100%;
  margin-bottom: 30px;
  background-color: transparent;
  border: 1px solid #eeeeee;
  display: inline-block;
  padding: 5px 10px;
  color: #555;
  vertical-align: middle;
  border-radius: 15px;
  line-height: 22px;
  cursor: text;
}

.ec-store-uploads .ec-store-upload-detail .bootstrap-tagsinput input {
  height: 40px;
  border: none !important;
  box-shadow: none;
  outline: none;
  background-color: transparent;
  padding: 0 5px;
  margin: 0;
  width: auto;
  max-width: inherit;
}

.ec-store-uploads .ec-store-upload-detail .bootstrap-tagsinput input:focus {
  border: none;
  box-shadow: none;
}

.ec-store-uploads .ec-store-upload-detail .bootstrap-tagsinput input::placeholder {
  color: #999;
  opacity: 1;
}

.ec-store-uploads .ec-store-upload-detail .bootstrap-tagsinput .tag {
  margin-right: 2px;
  color: #777;
}

.ec-store-uploads .ec-store-upload-detail .bootstrap-tagsinput .tag [data-role=remove] {
  margin-left: 8px;
  cursor: pointer;
  color: #f96e6e;
}

.ec-store-uploads .ec-store-upload-detail .bootstrap-tagsinput .tag [data-role=remove]:after {
  content: "×";
  padding: 0px 2px;
}

.ec-store-uploads .ec-store-upload-detail .bootstrap-tagsinput .tag [data-role=remove]:hover {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.2), 0 1px 2px rgba(0, 0, 0, 0.05);
}

.ec-store-uploads .ec-store-upload-detail .bootstrap-tagsinput .tag [data-role=remove]:hover:active {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
}

.ec-store-uploads .ec-store-upload-detail .bootstrap-tagsinput.form-control input::-moz-placeholder {
  color: #777;
  opacity: 1;
}

.ec-store-uploads .ec-store-upload-detail .bootstrap-tagsinput.form-control input:-ms-input-placeholder {
  color: #777;
}

.ec-store-uploads .ec-store-upload-detail .bootstrap-tagsinput.form-control input::-webkit-input-placeholder {
  color: #777;
}

/*===== LIST PRODUCTS =====*/
.card-default .card-header .card-bar {
  width: 100%;
  display: flex;
}

.card-default .card-header .card-bar .p-space {
  padding: 0 6px;
}

@media (max-width: 991.98px) {
  .card-default .card-header .card-bar .p-space {
    width: 50%;
  }
}

.card-default .card-header .card-bar .sort {
  display: flex;
  justify-content: flex-end;
}

@media (max-width: 991.98px) {
  .card-default .card-header .card-bar .sort {
    padding-top: 12px;
  }
}

@media (max-width: 991.98px) {
  .card-default .card-header .card-bar {
    flex-direction: column;
  }
}

.card-wrapper {
  transition: all 0.3s ease-in-out;
  background: white;
  margin-bottom: 24px;
  position: relative;
  overflow: hidden;
  border: 1px solid #f0f0f0;
  border-radius: 15px;
  box-shadow: 0;
}

.card-wrapper:hover {
  box-shadow: 0px 0 20px -1px rgba(0, 0, 0, 0.1);
}

.card-wrapper:hover .card-top .card-image {
  border-radius: 10px;
  transform: scale(1.03);
}

.card-wrapper .card-container {
  padding: 12px;
}

.card-wrapper .card-container .card-top {
  overflow: hidden;
  border-radius: 10px;
}

.card-wrapper .card-container .card-top .card-image {
  transition: all 0.3s ease-in-out;
  width: 100%;
  border-radius: 10px;
}

.card-wrapper .card-container .card-bottom {
  padding: 12px 0 0 0;
  width: 100%;
  background: #ffffff;
}

.card-wrapper .card-container .card-bottom h3,
.card-wrapper .card-container .card-bottom .h3 {
  margin: 0 0 5px 0;
  padding: 0;
  font-size: 14px;
  font-weight: 400;
}

.card-wrapper .card-container .card-bottom h3:hover,
.card-wrapper .card-container .card-bottom .h3:hover {
  cursor: pointer;
}

.card-wrapper .card-container .card-bottom p {
  margin: 0;
  padding: 0;
  font-weight: 600;
}

.card-wrapper .card-container .card-action {
  transition: all 0.3s ease-in-out;
  position: absolute;
  list-style: none;
  line-height: 2em;
  overflow: hidden;
  top: 22px;
  right: -50px;
  background: #fff;
  display: flex;
  flex-direction: column;
  right: 22px;
  opacity: 0;
  border-radius: 10px;
  border: 1px solid var(--border-color);
}

.card-wrapper .card-container .card-action .card-edit {
  align-content: center;
  width: 35px;
  height: 35px;
  display: grid;
  text-align: center;
}

.card-wrapper .card-container .card-action .card-edit i {
  font-size: 20px;
  padding: 0;
  color: #bbb;
  padding: 15px ​10p;
}

.card-wrapper .card-container .card-action .card-edit:hover {
  cursor: pointer;
}

.card-wrapper .card-container .card-action .card-edit:hover i {
  color: var(--admin-color);
  transition: all 0.7s ease-in-out;
}

.card-wrapper .card-container .card-action .card-preview {
  align-content: center;
  display: grid;
  width: 35px;
  height: 35px;
  text-align: center;
  border-top: 1px solid var(--border-color);
  border-bottom: 1px solid var(--border-color);
}

.card-wrapper .card-container .card-action .card-preview i {
  font-size: 20px;
  padding: 0;
  color: #bbb;
}

.card-wrapper .card-container .card-action .card-preview:hover {
  cursor: pointer;
}

.card-wrapper .card-container .card-action .card-preview:hover i {
  color: var(--admin-color);
  transition: all 0.7s ease-in-out;
}

.card-wrapper .card-container .card-action .card-remove {
  align-content: center;
  display: grid;
  width: 35px;
  height: 35px;
  text-align: center;
}

.card-wrapper .card-container .card-action .card-remove i {
  font-size: 20px;
  padding: 0;
  color: #bbb;
}

.card-wrapper .card-container .card-action .card-remove:hover {
  cursor: pointer;
}

.card-wrapper .card-container .card-action .card-remove:hover i {
  color: var(--admin-color);
  transition: all 0.7s ease-in-out;
}

.card-wrapper:hover .card-action {
  transition: all 0.3s ease-in-out;
  right: 22px;
  opacity: 1;
}

/*===== PRODUCT DETAILS =====*/
/*-----  Single Product  -----*/
.single-pro-img {
  position: relative;
  width: 100%;
}

@media (max-width: 991.98px) {
  .single-pro-img {
    max-width: 500px;
    margin: auto;
  }
}

.single-pro-img .single-product-scroll {
  position: sticky;
  top: 30px;
}

.single-pro-img .ec-360-lbl {
  position: absolute;
  top: 15px;
  right: 15px;
  z-index: 1;
  border-radius: 50%;
  cursor: pointer;
  height: 40px;
  width: 40px;
  text-align: center;
  align-content: center;
  display: grid;
  opacity: 0.7;
}

.single-pro-img .ec-360-lbl:hover {
  opacity: 1;
}

.single-pro-img .ec-video-icon {
  position: absolute;
  display: grid;
  top: 15px;
  right: 15px;
  height: 40px;
  width: 40px;
  text-align: center;
  align-content: center;
  cursor: pointer;
  z-index: 1;
  opacity: 0.7;
}

.single-pro-img .ec-video-icon:hover {
  opacity: 1;
}

.single-product-cover {
  overflow: hidden;
  cursor: zoom-in;
  border-radius: 15px;
}

.single-product-cover .slick-slide img {
  width: 100%;
  border-radius: 15px;
}

.single-nav-thumb {
  width: 100%;
}

.single-nav-thumb .slick-arrow {
  position: absolute;
  top: 37%;
  left: auto;
  right: auto;
  margin: 0 auto;
  font-size: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  padding: 0;
  z-index: 1;
}

.single-nav-thumb .slick-arrow.slick-prev {
  right: auto;
  left: -11px;
}

.single-nav-thumb .slick-arrow.slick-prev:before {
  content: "";
  font-family: "Material Design Icons";
  color: #777;
}

.single-nav-thumb .slick-arrow.slick-next {
  right: -14px;
  left: auto;
}

.single-nav-thumb .slick-arrow.slick-next:before {
  content: "";
  font-family: "Material Design Icons";
  color: #777;
}

.single-nav-thumb .slick-arrow {
  opacity: 0.5;
}

.single-nav-thumb .slick-arrow:hover {
  opacity: 1;
}

.single-nav-thumb .slick-arrow:before {
  content: "";
  color: #777777;
  position: relative;
  font-size: 30px;
  font-family: "EcIcons";
  width: 100%;
  line-height: 30px;
  height: 30px;
}

.single-nav-thumb .slick-list {
  margin: 0 -8px;
}

.single-nav-thumb .single-slide {
  padding: 11px 11px 0 11px;
  display: block !important;
}

.single-nav-thumb .slick-slide img {
  width: 100%;
  border: 1px solid transparent;
  transition: all 0.3s ease 0s;
  cursor: pointer;
  border-radius: 10px;
  border-color: var(--border-color);
}

.single-nav-thumb .slick-slide:hover img {
  border-color: var(--admin-color);
}

.single-nav-thumb .slick-slide.slick-current.slick-active img {
  border-color: #ddd;
}

.single-nav-thumb .slick-arrow {
  top: 40%;
}

.product-detail .product-desc {
  padding-bottom: 15px;
}

.product-detail .product-rate {
  padding: 5px 0;
}

.product-detail .product-rate i {
  font-size: 22px;
  padding: 0 2px 0 0;
}

.product-detail .product-rate .is-rated {
  color: #ffd481;
}

.product-detail h5,
.product-detail .h5 {
  color: var(--text-color);
}

.product-detail .product-price {
  padding-bottom: 15px;
  font-weight: 700;
  font-size: 16px;
}

.product-detail .product-sku {
  padding-bottom: 15px;
}

.product-detail .ec-ofr {
  margin: 10px 0 20px 0;
}

.product-detail .ec-ofr ul li {
  margin: 10px 0;
}

.product-detail .ec-ofr ul li b {
  font-weight: 500;
}

.product-detail .product-size,
.product-detail .product-color {
  display: flex;
  padding-bottom: 15px;
}

.product-detail .product-size li,
.product-detail .product-color li {
  display: flex;
  padding: 2px;
  border-radius: 30px;
  opacity: 0.7;
  background-color: transparent;
  transition: all 0.3s ease-in-out;
  width: 25px;
  height: 25px;
  cursor: pointer;
  justify-content: center;
  font-size: 12px;
  line-height: 22px;
  padding: 0;
  border: 1px solid #eeeeee;
  float: left;
  margin-right: 10px;
  border-radius: 0;
}

.product-detail .product-size li {
  width: auto;
  height: auto;
  line-height: 18px;
  padding: 0px 7px;
  border-radius: 10px;
}

.product-detail .product-color .color {
  border-radius: 30px;
}

.product-detail .product-color .color span {
  width: 100%;
  height: 100%;
  display: block;
  border-radius: 30px;
}

.product-detail .product-stock {
  display: inline-flex;
}

.product-detail .product-stock .stock {
  border: 1px solid var(--border-color);
  margin: 0 20px 5px 0;
  padding: 10px;
  text-align: center;
  border-radius: 15px;
}

.product-detail .product-stock .stock .title {
  font-weight: 500;
  font-size: 14px;
}

.product-detail .seller-card {
  overflow: inherit;
}

@media (max-width: 991.98px) {
  .product-detail .product-overview {
    padding-top: 24px;
  }
}

.product-detail .product-overview .list-unstyled li {
  display: block !important;
  text-align: center;
}

.product-detail .nav-tabs {
  border: none;
  justify-content: center;
}

.product-detail .nav-tabs .nav-link {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.product-detail .nav-tabs .nav-link i {
  font-size: 16px;
}

.product-detail .tab-content {
  overflow: hidden;
  background-color: #fff;
  text-align: left;
  padding: 35px 30px 21px 30px;
  border: 1px solid #eeeeee;
  border-radius: 0;
  color: #202020;
  font-size: 18px;
  letter-spacing: 0;
  line-height: 1.6;
  border-radius: 15px;
}

.product-detail .tab-content p {
  color: #777777;
}

.product-detail .tab-content .tab-pane {
  padding: 0 !important;
}

.product-detail .tab-content .tab-pane .features {
  padding-top: 10px;
}

.product-detail .tab-content .tab-pane ul {
  padding-left: 16px;
  font-size: 15px;
}

.product-detail .tab-content .tab-pane ul li {
  list-style-type: disclosure-closed;
  color: #777777;
}

.product-detail .tab-content .tab-pane .ec-t-review-item {
  display: flex;
  margin: 0 0 25px;
  padding-bottom: 25px;
  border-bottom: 1px solid #eeeeee;
  align-items: center;
}

.product-detail .tab-content .tab-pane .ec-t-review-item .ec-t-review-top {
  display: flex;
  flex-direction: column;
  margin: 0;
}

.product-detail .tab-content .tab-pane .ec-t-review-item .ec-t-review-top .ec-t-review-name {
  font-weight: 500;
}

.product-detail .tab-content .tab-pane .ec-t-review-item .ec-t-review-avtar {
  width: 100px;
  margin: 0 15px 0 0;
  flex: 0 0 90px;
}

.product-detail .tab-content .tab-pane .ec-t-review-item .ec-t-review-avtar img {
  width: 100%;
  border-radius: 15px;
}

@media (max-width: 1199.98px) {
  .product-detail .u-card {
    margin-top: 24px;
  }

  .product-detail .u-card img {
    width: 100px;
  }
}

.ec-t-rate {
  padding: 0;
  line-height: 25px;
}

.ec-t-rate i {
  font-size: 18px;
  padding: 0;
}

.ec-t-rate .is-rated {
  color: #ffd481;
}

.product-brand .card-default {
  margin-bottom: 24px;
  overflow: inherit;
}

@media (max-width: 767.98px) {
  .product-brand .card-default {
    max-width: 300px;
    margin: 0 auto 24px auto;
  }
}

.product-brand .rounded-circle {
  border-radius: 15px !important;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.05);
  width: 100px;
  border: 1px solid var(--border-color);
}

.product-brand .brand-delete {
  transition: all 0.3s ease-in-out;
  position: absolute;
  right: 10px;
  top: 5px;
  font-size: 17px;
  cursor: pointer;
  color: #bbb;
}

.product-brand .brand-delete:hover {
  color: #f7b7b7;
}

/** Invoice CSS **/
.invoice-wrapper .text-dark {
  font-weight: 500;
}

.invoice-wrapper address span {
  font-weight: 500;
}

.invoice-wrapper .inv-tbl tbody tr:nth-of-type(odd)>* {
  background-color: #f9f9f9;
  --bs-table-accent-bg: #f9f9f9;
}

.invoice-wrapper .inv-tbl tbody tr td {
  vertical-align: middle;
}

.invoice-wrapper .inv-tbl tbody tr td img {
  width: 40px;
  border-radius: 15px;
}

.invoice-wrapper .inc-total ul li span {
  float: right;
}

.invoice-wrapper .inc-total .btn {
  max-width: 180px;
  margin-left: auto;
}

@media (max-width: 1199.98px) {
  .invoice-wrapper .disp-none {
    display: none;
  }
}

.m-0 {
  margin: 0 !important;
}

.mt-0,
.my-0 {
  margin-top: 0 !important;
}

.mr-0,
.mx-0 {
  margin-right: 0 !important;
}

.mb-0,
.my-0 {
  margin-bottom: 0 !important;
}

.ml-0,
.mx-0 {
  margin-left: 0 !important;
}

.m-1 {
  margin: 5px !important;
}

.mt-1,
.my-1 {
  margin-top: 5px !important;
}

.mr-1,
.mx-1 {
  margin-right: 5px !important;
}

.mb-1,
.my-1 {
  margin-bottom: 5px !important;
}

.ml-1,
.mx-1 {
  margin-left: 5px !important;
}

.m-2 {
  margin: 5px !important;
}

.mt-2,
.my-2 {
  margin-top: 5px !important;
}

.mr-2,
.mx-2 {
  margin-right: 5px !important;
}

.mb-2,
.my-2 {
  margin-bottom: 5px !important;
}

.ml-2,
.mx-2 {
  margin-left: 5px !important;
}

.m-3 {
  margin: 15px !important;
}

.mt-3,
.my-3 {
  margin-top: 15px !important;
}

.mr-3,
.mx-3 {
  margin-right: 15px !important;
}

.mb-3,
.my-3 {
  margin-bottom: 15px !important;
}

.ml-3,
.mx-3 {
  margin-left: 15px !important;
}

.m-4 {
  margin: 30px !important;
}

.mt-4,
.my-4 {
  margin-top: 30px !important;
}

.mt-24px {
  margin-top: 24px;
}

.mb-24px {
  margin-bottom: 24px;
}

.mt-m-24px {
  margin-top: -24px;
}

.mb-m-24px {
  margin-bottom: -24px;
}

.mr-4,
.mx-4 {
  margin-right: 30px !important;
}

.mb-4,
.my-4 {
  margin-bottom: 30px !important;
}

.ml-4,
.mx-4 {
  margin-left: 30px !important;
}

.m-5 {
  margin: 30px !important;
}

.mt-5,
.my-5 {
  margin-top: 30px !important;
}

.mr-5,
.mx-5 {
  margin-right: 30px !important;
}

.mb-5,
.my-5 {
  margin-bottom: 30px !important;
}

.ml-5,
.mx-5 {
  margin-left: 30px !important;
}

.m-6 {
  margin: 50px !important;
}

.mt-6,
.my-6 {
  margin-top: 50px !important;
}

.mr-6,
.mx-6 {
  margin-right: 50px !important;
}

.mb-6,
.my-6 {
  margin-bottom: 50px !important;
}

.ml-6,
.mx-6 {
  margin-left: 50px !important;
}

.m-7 {
  margin: 60px !important;
}

.mt-7,
.my-7 {
  margin-top: 60px !important;
}

.mr-7,
.mx-7 {
  margin-right: 60px !important;
}

.mb-7,
.my-7 {
  margin-bottom: 60px !important;
}

.ml-7,
.mx-7 {
  margin-left: 60px !important;
}

.m-8 {
  margin: 70px !important;
}

.mt-8,
.my-8 {
  margin-top: 70px !important;
}

.mr-8,
.mx-8 {
  margin-right: 70px !important;
}

.mb-8,
.my-8 {
  margin-bottom: 70px !important;
}

.ml-8,
.mx-8 {
  margin-left: 70px !important;
}

.m-9 {
  margin: 80px !important;
}

.mt-9,
.my-9 {
  margin-top: 80px !important;
}

.mr-9,
.mx-9 {
  margin-right: 80px !important;
}

.mb-9,
.my-9 {
  margin-bottom: 80px !important;
}

.ml-9,
.mx-9 {
  margin-left: 80px !important;
}

.p-0 {
  padding: 0 !important;
}

.pt-0,
.py-0 {
  padding-top: 0 !important;
}

.pr-0,
.px-0 {
  padding-right: 0 !important;
}

.pb-0,
.py-0 {
  padding-bottom: 0 !important;
}

.pl-0,
.px-0 {
  padding-left: 0 !important;
}

.p-1 {
  padding: 5px !important;
}

.pt-1,
.py-1 {
  padding-top: 5px !important;
}

.pr-1,
.px-1 {
  padding-right: 5px !important;
}

.pb-1,
.py-1 {
  padding-bottom: 5px !important;
}

.pl-1,
.px-1 {
  padding-left: 5px !important;
}

.p-2 {
  padding: 5px !important;
}

.pt-2,
.py-2 {
  padding-top: 5px !important;
}

.pr-2,
.px-2 {
  padding-right: 5px !important;
}

.pb-2,
.py-2 {
  padding-bottom: 5px !important;
}

.pl-2,
.px-2 {
  padding-left: 5px !important;
}

.p-3 {
  padding: 15px !important;
}

.pt-15px {
  padding-top: 15px !important;
}

.pb-15px {
  padding-bottom: 15px !important;
}

.pt-3,
.py-3 {
  padding-top: 15px !important;
}

.pr-3,
.px-3 {
  padding-right: 15px !important;
}

.pb-3,
.py-3 {
  padding-bottom: 15px !important;
}

.pl-3,
.px-3 {
  padding-left: 15px !important;
}

.p-4 {
  padding: 30px !important;
}

.p-24px {
  padding: 24px !important;
}

.pt-24px {
  padding-top: 24px !important;
}

.pb-24px {
  padding-bottom: 24px !important;
}

.pt-4,
.py-4 {
  padding-top: 30px !important;
}

.pr-4,
.px-4 {
  padding-right: 30px !important;
}

.pb-4,
.py-4 {
  padding-bottom: 30px !important;
}

.pl-4,
.px-4 {
  padding-left: 30px !important;
}

.p-5 {
  padding: 30px !important;
}

.pt-5,
.py-5 {
  padding-top: 30px !important;
}

.pr-5,
.px-5 {
  padding-right: 30px !important;
}

.pb-5,
.py-5 {
  padding-bottom: 30px !important;
}

.pl-5,
.px-5 {
  padding-left: 30px !important;
}

.p-6 {
  padding: 50px !important;
}

.pt-6,
.py-6 {
  padding-top: 50px !important;
}

.pr-6,
.px-6 {
  padding-right: 50px !important;
}

.pb-6,
.py-6 {
  padding-bottom: 50px !important;
}

.pl-6,
.px-6 {
  padding-left: 50px !important;
}

.p-7 {
  padding: 60px !important;
}

.pt-7,
.py-7 {
  padding-top: 60px !important;
}

.pr-7,
.px-7 {
  padding-right: 60px !important;
}

.pb-7,
.py-7 {
  padding-bottom: 60px !important;
}

.pl-7,
.px-7 {
  padding-left: 60px !important;
}

.p-8 {
  padding: 70px !important;
}

.pt-8,
.py-8 {
  padding-top: 70px !important;
}

.pr-8,
.px-8 {
  padding-right: 70px !important;
}

.pb-8,
.py-8 {
  padding-bottom: 70px !important;
}

.pl-8,
.px-8 {
  padding-left: 70px !important;
}

.p-9 {
  padding: 80px !important;
}

.pt-9,
.py-9 {
  padding-top: 80px !important;
}

.pr-9,
.px-9 {
  padding-right: 80px !important;
}

.pb-9,
.py-9 {
  padding-bottom: 80px !important;
}

.pl-9,
.px-9 {
  padding-left: 80px !important;
}

.m-n1 {
  margin: -5px !important;
}

.mt-n1,
.my-n1 {
  margin-top: -5px !important;
}

.mr-n1,
.mx-n1 {
  margin-right: -5px !important;
}

.mb-n1,
.my-n1 {
  margin-bottom: -5px !important;
}

.ml-n1,
.mx-n1 {
  margin-left: -5px !important;
}

.m-n2 {
  margin: -5px !important;
}

.mt-n2,
.my-n2 {
  margin-top: -5px !important;
}

.mr-n2,
.mx-n2 {
  margin-right: -5px !important;
}

.mb-n2,
.my-n2 {
  margin-bottom: -5px !important;
}

.ml-n2,
.mx-n2 {
  margin-left: -5px !important;
}

.m-n3 {
  margin: -15px !important;
}

.mt-n3,
.my-n3 {
  margin-top: -15px !important;
}

.mr-n3,
.mx-n3 {
  margin-right: -15px !important;
}

.mb-n3,
.my-n3 {
  margin-bottom: -15px !important;
}

.ml-n3,
.mx-n3 {
  margin-left: -15px !important;
}

.m-n4 {
  margin: -30px !important;
}

.mt-n4,
.my-n4 {
  margin-top: -30px !important;
}

.mr-n4,
.mx-n4 {
  margin-right: -30px !important;
}

.mb-n4,
.my-n4 {
  margin-bottom: -30px !important;
}

.ml-n4,
.mx-n4 {
  margin-left: -30px !important;
}

.m-n5 {
  margin: -50px !important;
}

.mt-n5,
.my-n5 {
  margin-top: -50px !important;
}

.mr-n5,
.mx-n5 {
  margin-right: -50px !important;
}

.mb-n5,
.my-n5 {
  margin-bottom: -50px !important;
}

.ml-n5,
.mx-n5 {
  margin-left: -50px !important;
}

.m-n6 {
  margin: -50px !important;
}

.mt-n6,
.my-n6 {
  margin-top: -50px !important;
}

.mr-n6,
.mx-n6 {
  margin-right: -50px !important;
}

.mb-n6,
.my-n6 {
  margin-bottom: -50px !important;
}

.ml-n6,
.mx-n6 {
  margin-left: -50px !important;
}

.m-n7 {
  margin: -60px !important;
}

.mt-n7,
.my-n7 {
  margin-top: -60px !important;
}

.mr-n7,
.mx-n7 {
  margin-right: -60px !important;
}

.mb-n7,
.my-n7 {
  margin-bottom: -60px !important;
}

.ml-n7,
.mx-n7 {
  margin-left: -60px !important;
}

.m-n8 {
  margin: -70px !important;
}

.mt-n8,
.my-n8 {
  margin-top: -70px !important;
}

.mr-n8,
.mx-n8 {
  margin-right: -70px !important;
}

.mb-n8,
.my-n8 {
  margin-bottom: -70px !important;
}

.ml-n8,
.mx-n8 {
  margin-left: -70px !important;
}

.m-n9 {
  margin: -80px !important;
}

.mt-n9,
.my-n9 {
  margin-top: -80px !important;
}

.mr-n9,
.mx-n9 {
  margin-right: -80px !important;
}

.mb-n9,
.my-n9 {
  margin-bottom: -80px !important;
}

.ml-n9,
.mx-n9 {
  margin-left: -80px !important;
}

.m-auto {
  margin: auto !important;
}

.mt-auto,
.my-auto {
  margin-top: auto !important;
}

.mr-auto,
.mx-auto {
  margin-right: auto !important;
}

.mb-auto,
.my-auto {
  margin-bottom: auto !important;
}

.ml-auto,
.mx-auto {
  margin-left: auto !important;
}

@media (min-width: 576px) {
  .m-sm-0 {
    margin: 0 !important;
  }

  .mt-sm-0,
  .my-sm-0 {
    margin-top: 0 !important;
  }

  .mr-sm-0,
  .mx-sm-0 {
    margin-right: 0 !important;
  }

  .mb-sm-0,
  .my-sm-0 {
    margin-bottom: 0 !important;
  }

  .ml-sm-0,
  .mx-sm-0 {
    margin-left: 0 !important;
  }

  .m-sm-1 {
    margin: 5px !important;
  }

  .mt-sm-1,
  .my-sm-1 {
    margin-top: 5px !important;
  }

  .mr-sm-1,
  .mx-sm-1 {
    margin-right: 5px !important;
  }

  .mb-sm-1,
  .my-sm-1 {
    margin-bottom: 5px !important;
  }

  .ml-sm-1,
  .mx-sm-1 {
    margin-left: 5px !important;
  }

  .m-sm-2 {
    margin: 5px !important;
  }

  .mt-sm-2,
  .my-sm-2 {
    margin-top: 5px !important;
  }

  .mr-sm-2,
  .mx-sm-2 {
    margin-right: 5px !important;
  }

  .mb-sm-2,
  .my-sm-2 {
    margin-bottom: 5px !important;
  }

  .ml-sm-2,
  .mx-sm-2 {
    margin-left: 5px !important;
  }

  .m-sm-3 {
    margin: 15px !important;
  }

  .mt-sm-3,
  .my-sm-3 {
    margin-top: 15px !important;
  }

  .mr-sm-3,
  .mx-sm-3 {
    margin-right: 15px !important;
  }

  .mb-sm-3,
  .my-sm-3 {
    margin-bottom: 15px !important;
  }

  .ml-sm-3,
  .mx-sm-3 {
    margin-left: 15px !important;
  }

  .m-sm-4 {
    margin: 30px !important;
  }

  .mt-sm-4,
  .my-sm-4 {
    margin-top: 30px !important;
  }

  .mr-sm-4,
  .mx-sm-4 {
    margin-right: 30px !important;
  }

  .mb-sm-4,
  .my-sm-4 {
    margin-bottom: 30px !important;
  }

  .ml-sm-4,
  .mx-sm-4 {
    margin-left: 30px !important;
  }

  .m-sm-5 {
    margin: 30px !important;
  }

  .mt-sm-5,
  .my-sm-5 {
    margin-top: 30px !important;
  }

  .mr-sm-5,
  .mx-sm-5 {
    margin-right: 30px !important;
  }

  .mb-sm-5,
  .my-sm-5 {
    margin-bottom: 30px !important;
  }

  .ml-sm-5,
  .mx-sm-5 {
    margin-left: 30px !important;
  }

  .m-sm-6 {
    margin: 50px !important;
  }

  .mt-sm-6,
  .my-sm-6 {
    margin-top: 50px !important;
  }

  .mr-sm-6,
  .mx-sm-6 {
    margin-right: 50px !important;
  }

  .mb-sm-6,
  .my-sm-6 {
    margin-bottom: 50px !important;
  }

  .ml-sm-6,
  .mx-sm-6 {
    margin-left: 50px !important;
  }

  .m-sm-7 {
    margin: 60px !important;
  }

  .mt-sm-7,
  .my-sm-7 {
    margin-top: 60px !important;
  }

  .mr-sm-7,
  .mx-sm-7 {
    margin-right: 60px !important;
  }

  .mb-sm-7,
  .my-sm-7 {
    margin-bottom: 60px !important;
  }

  .ml-sm-7,
  .mx-sm-7 {
    margin-left: 60px !important;
  }

  .m-sm-8 {
    margin: 70px !important;
  }

  .mt-sm-8,
  .my-sm-8 {
    margin-top: 70px !important;
  }

  .mr-sm-8,
  .mx-sm-8 {
    margin-right: 70px !important;
  }

  .mb-sm-8,
  .my-sm-8 {
    margin-bottom: 70px !important;
  }

  .ml-sm-8,
  .mx-sm-8 {
    margin-left: 70px !important;
  }

  .m-sm-9 {
    margin: 80px !important;
  }

  .mt-sm-9,
  .my-sm-9 {
    margin-top: 80px !important;
  }

  .mr-sm-9,
  .mx-sm-9 {
    margin-right: 80px !important;
  }

  .mb-sm-9,
  .my-sm-9 {
    margin-bottom: 80px !important;
  }

  .ml-sm-9,
  .mx-sm-9 {
    margin-left: 80px !important;
  }

  .p-sm-0 {
    padding: 0 !important;
  }

  .pt-sm-0,
  .py-sm-0 {
    padding-top: 0 !important;
  }

  .pr-sm-0,
  .px-sm-0 {
    padding-right: 0 !important;
  }

  .pb-sm-0,
  .py-sm-0 {
    padding-bottom: 0 !important;
  }

  .pl-sm-0,
  .px-sm-0 {
    padding-left: 0 !important;
  }

  .p-sm-1 {
    padding: 5px !important;
  }

  .pt-sm-1,
  .py-sm-1 {
    padding-top: 5px !important;
  }

  .pr-sm-1,
  .px-sm-1 {
    padding-right: 5px !important;
  }

  .pb-sm-1,
  .py-sm-1 {
    padding-bottom: 5px !important;
  }

  .pl-sm-1,
  .px-sm-1 {
    padding-left: 5px !important;
  }

  .p-sm-2 {
    padding: 5px !important;
  }

  .pt-sm-2,
  .py-sm-2 {
    padding-top: 5px !important;
  }

  .pr-sm-2,
  .px-sm-2 {
    padding-right: 5px !important;
  }

  .pb-sm-2,
  .py-sm-2 {
    padding-bottom: 5px !important;
  }

  .pl-sm-2,
  .px-sm-2 {
    padding-left: 5px !important;
  }

  .p-sm-3 {
    padding: 15px !important;
  }

  .pt-sm-3,
  .py-sm-3 {
    padding-top: 15px !important;
  }

  .pr-sm-3,
  .px-sm-3 {
    padding-right: 15px !important;
  }

  .pb-sm-3,
  .py-sm-3 {
    padding-bottom: 15px !important;
  }

  .pl-sm-3,
  .px-sm-3 {
    padding-left: 15px !important;
  }

  .p-sm-4 {
    padding: 30px !important;
  }

  .pt-sm-4,
  .py-sm-4 {
    padding-top: 30px !important;
  }

  .pr-sm-4,
  .px-sm-4 {
    padding-right: 30px !important;
  }

  .pb-sm-4,
  .py-sm-4 {
    padding-bottom: 30px !important;
  }

  .pl-sm-4,
  .px-sm-4 {
    padding-left: 30px !important;
  }

  .p-sm-5 {
    padding: 30px !important;
  }

  .pt-sm-5,
  .py-sm-5 {
    padding-top: 30px !important;
  }

  .pr-sm-5,
  .px-sm-5 {
    padding-right: 30px !important;
  }

  .pb-sm-5,
  .py-sm-5 {
    padding-bottom: 30px !important;
  }

  .pl-sm-5,
  .px-sm-5 {
    padding-left: 30px !important;
  }

  .p-sm-6 {
    padding: 50px !important;
  }

  .pt-sm-6,
  .py-sm-6 {
    padding-top: 50px !important;
  }

  .pr-sm-6,
  .px-sm-6 {
    padding-right: 50px !important;
  }

  .pb-sm-6,
  .py-sm-6 {
    padding-bottom: 50px !important;
  }

  .pl-sm-6,
  .px-sm-6 {
    padding-left: 50px !important;
  }

  .p-sm-7 {
    padding: 60px !important;
  }

  .pt-sm-7,
  .py-sm-7 {
    padding-top: 60px !important;
  }

  .pr-sm-7,
  .px-sm-7 {
    padding-right: 60px !important;
  }

  .pb-sm-7,
  .py-sm-7 {
    padding-bottom: 60px !important;
  }

  .pl-sm-7,
  .px-sm-7 {
    padding-left: 60px !important;
  }

  .p-sm-8 {
    padding: 70px !important;
  }

  .pt-sm-8,
  .py-sm-8 {
    padding-top: 70px !important;
  }

  .pr-sm-8,
  .px-sm-8 {
    padding-right: 70px !important;
  }

  .pb-sm-8,
  .py-sm-8 {
    padding-bottom: 70px !important;
  }

  .pl-sm-8,
  .px-sm-8 {
    padding-left: 70px !important;
  }

  .p-sm-9 {
    padding: 80px !important;
  }

  .pt-sm-9,
  .py-sm-9 {
    padding-top: 80px !important;
  }

  .pr-sm-9,
  .px-sm-9 {
    padding-right: 80px !important;
  }

  .pb-sm-9,
  .py-sm-9 {
    padding-bottom: 80px !important;
  }

  .pl-sm-9,
  .px-sm-9 {
    padding-left: 80px !important;
  }

  .m-sm-n1 {
    margin: -5px !important;
  }

  .mt-sm-n1,
  .my-sm-n1 {
    margin-top: -5px !important;
  }

  .mr-sm-n1,
  .mx-sm-n1 {
    margin-right: -5px !important;
  }

  .mb-sm-n1,
  .my-sm-n1 {
    margin-bottom: -5px !important;
  }

  .ml-sm-n1,
  .mx-sm-n1 {
    margin-left: -5px !important;
  }

  .m-sm-n2 {
    margin: -5px !important;
  }

  .mt-sm-n2,
  .my-sm-n2 {
    margin-top: -5px !important;
  }

  .mr-sm-n2,
  .mx-sm-n2 {
    margin-right: -5px !important;
  }

  .mb-sm-n2,
  .my-sm-n2 {
    margin-bottom: -5px !important;
  }

  .ml-sm-n2,
  .mx-sm-n2 {
    margin-left: -5px !important;
  }

  .m-sm-n3 {
    margin: -15px !important;
  }

  .mt-sm-n3,
  .my-sm-n3 {
    margin-top: -15px !important;
  }

  .mr-sm-n3,
  .mx-sm-n3 {
    margin-right: -15px !important;
  }

  .mb-sm-n3,
  .my-sm-n3 {
    margin-bottom: -15px !important;
  }

  .ml-sm-n3,
  .mx-sm-n3 {
    margin-left: -15px !important;
  }

  .m-sm-n4 {
    margin: -30px !important;
  }

  .mt-sm-n4,
  .my-sm-n4 {
    margin-top: -30px !important;
  }

  .mr-sm-n4,
  .mx-sm-n4 {
    margin-right: -30px !important;
  }

  .mb-sm-n4,
  .my-sm-n4 {
    margin-bottom: -30px !important;
  }

  .ml-sm-n4,
  .mx-sm-n4 {
    margin-left: -30px !important;
  }

  .m-sm-n5 {
    margin: -50px !important;
  }

  .mt-sm-n5,
  .my-sm-n5 {
    margin-top: -50px !important;
  }

  .mr-sm-n5,
  .mx-sm-n5 {
    margin-right: -50px !important;
  }

  .mb-sm-n5,
  .my-sm-n5 {
    margin-bottom: -50px !important;
  }

  .ml-sm-n5,
  .mx-sm-n5 {
    margin-left: -50px !important;
  }

  .m-sm-n6 {
    margin: -50px !important;
  }

  .mt-sm-n6,
  .my-sm-n6 {
    margin-top: -50px !important;
  }

  .mr-sm-n6,
  .mx-sm-n6 {
    margin-right: -50px !important;
  }

  .mb-sm-n6,
  .my-sm-n6 {
    margin-bottom: -50px !important;
  }

  .ml-sm-n6,
  .mx-sm-n6 {
    margin-left: -50px !important;
  }

  .m-sm-n7 {
    margin: -60px !important;
  }

  .mt-sm-n7,
  .my-sm-n7 {
    margin-top: -60px !important;
  }

  .mr-sm-n7,
  .mx-sm-n7 {
    margin-right: -60px !important;
  }

  .mb-sm-n7,
  .my-sm-n7 {
    margin-bottom: -60px !important;
  }

  .ml-sm-n7,
  .mx-sm-n7 {
    margin-left: -60px !important;
  }

  .m-sm-n8 {
    margin: -70px !important;
  }

  .mt-sm-n8,
  .my-sm-n8 {
    margin-top: -70px !important;
  }

  .mr-sm-n8,
  .mx-sm-n8 {
    margin-right: -70px !important;
  }

  .mb-sm-n8,
  .my-sm-n8 {
    margin-bottom: -70px !important;
  }

  .ml-sm-n8,
  .mx-sm-n8 {
    margin-left: -70px !important;
  }

  .m-sm-n9 {
    margin: -80px !important;
  }

  .mt-sm-n9,
  .my-sm-n9 {
    margin-top: -80px !important;
  }

  .mr-sm-n9,
  .mx-sm-n9 {
    margin-right: -80px !important;
  }

  .mb-sm-n9,
  .my-sm-n9 {
    margin-bottom: -80px !important;
  }

  .ml-sm-n9,
  .mx-sm-n9 {
    margin-left: -80px !important;
  }

  .m-sm-auto {
    margin: auto !important;
  }

  .mt-sm-auto,
  .my-sm-auto {
    margin-top: auto !important;
  }

  .mr-sm-auto,
  .mx-sm-auto {
    margin-right: auto !important;
  }

  .mb-sm-auto,
  .my-sm-auto {
    margin-bottom: auto !important;
  }

  .ml-sm-auto,
  .mx-sm-auto {
    margin-left: auto !important;
  }
}

@media (min-width: 768px) {
  .m-md-0 {
    margin: 0 !important;
  }

  .mt-md-0,
  .my-md-0 {
    margin-top: 0 !important;
  }

  .mr-md-0,
  .mx-md-0 {
    margin-right: 0 !important;
  }

  .mb-md-0,
  .my-md-0 {
    margin-bottom: 0 !important;
  }

  .ml-md-0,
  .mx-md-0 {
    margin-left: 0 !important;
  }

  .m-md-1 {
    margin: 5px !important;
  }

  .mt-md-1,
  .my-md-1 {
    margin-top: 5px !important;
  }

  .mr-md-1,
  .mx-md-1 {
    margin-right: 5px !important;
  }

  .mb-md-1,
  .my-md-1 {
    margin-bottom: 5px !important;
  }

  .ml-md-1,
  .mx-md-1 {
    margin-left: 5px !important;
  }

  .m-md-2 {
    margin: 5px !important;
  }

  .mt-md-2,
  .my-md-2 {
    margin-top: 5px !important;
  }

  .mr-md-2,
  .mx-md-2 {
    margin-right: 5px !important;
  }

  .mb-md-2,
  .my-md-2 {
    margin-bottom: 5px !important;
  }

  .ml-md-2,
  .mx-md-2 {
    margin-left: 5px !important;
  }

  .m-md-3 {
    margin: 15px !important;
  }

  .mt-md-3,
  .my-md-3 {
    margin-top: 15px !important;
  }

  .mr-md-3,
  .mx-md-3 {
    margin-right: 15px !important;
  }

  .mb-md-3,
  .my-md-3 {
    margin-bottom: 15px !important;
  }

  .ml-md-3,
  .mx-md-3 {
    margin-left: 15px !important;
  }

  .m-md-4 {
    margin: 30px !important;
  }

  .mt-md-4,
  .my-md-4 {
    margin-top: 30px !important;
  }

  .mr-md-4,
  .mx-md-4 {
    margin-right: 30px !important;
  }

  .mb-md-4,
  .my-md-4 {
    margin-bottom: 30px !important;
  }

  .ml-md-4,
  .mx-md-4 {
    margin-left: 30px !important;
  }

  .m-md-5 {
    margin: 30px !important;
  }

  .mt-md-5,
  .my-md-5 {
    margin-top: 30px !important;
  }

  .mr-md-5,
  .mx-md-5 {
    margin-right: 30px !important;
  }

  .mb-md-5,
  .my-md-5 {
    margin-bottom: 30px !important;
  }

  .ml-md-5,
  .mx-md-5 {
    margin-left: 30px !important;
  }

  .m-md-6 {
    margin: 50px !important;
  }

  .mt-md-6,
  .my-md-6 {
    margin-top: 50px !important;
  }

  .mr-md-6,
  .mx-md-6 {
    margin-right: 50px !important;
  }

  .mb-md-6,
  .my-md-6 {
    margin-bottom: 50px !important;
  }

  .ml-md-6,
  .mx-md-6 {
    margin-left: 50px !important;
  }

  .m-md-7 {
    margin: 60px !important;
  }

  .mt-md-7,
  .my-md-7 {
    margin-top: 60px !important;
  }

  .mr-md-7,
  .mx-md-7 {
    margin-right: 60px !important;
  }

  .mb-md-7,
  .my-md-7 {
    margin-bottom: 60px !important;
  }

  .ml-md-7,
  .mx-md-7 {
    margin-left: 60px !important;
  }

  .m-md-8 {
    margin: 70px !important;
  }

  .mt-md-8,
  .my-md-8 {
    margin-top: 70px !important;
  }

  .mr-md-8,
  .mx-md-8 {
    margin-right: 70px !important;
  }

  .mb-md-8,
  .my-md-8 {
    margin-bottom: 70px !important;
  }

  .ml-md-8,
  .mx-md-8 {
    margin-left: 70px !important;
  }

  .m-md-9 {
    margin: 80px !important;
  }

  .mt-md-9,
  .my-md-9 {
    margin-top: 80px !important;
  }

  .mr-md-9,
  .mx-md-9 {
    margin-right: 80px !important;
  }

  .mb-md-9,
  .my-md-9 {
    margin-bottom: 80px !important;
  }

  .ml-md-9,
  .mx-md-9 {
    margin-left: 80px !important;
  }

  .p-md-0 {
    padding: 0 !important;
  }

  .pt-md-0,
  .py-md-0 {
    padding-top: 0 !important;
  }

  .pr-md-0,
  .px-md-0 {
    padding-right: 0 !important;
  }

  .pb-md-0,
  .py-md-0 {
    padding-bottom: 0 !important;
  }

  .pl-md-0,
  .px-md-0 {
    padding-left: 0 !important;
  }

  .p-md-1 {
    padding: 5px !important;
  }

  .pt-md-1,
  .py-md-1 {
    padding-top: 5px !important;
  }

  .pr-md-1,
  .px-md-1 {
    padding-right: 5px !important;
  }

  .pb-md-1,
  .py-md-1 {
    padding-bottom: 5px !important;
  }

  .pl-md-1,
  .px-md-1 {
    padding-left: 5px !important;
  }

  .p-md-2 {
    padding: 5px !important;
  }

  .pt-md-2,
  .py-md-2 {
    padding-top: 5px !important;
  }

  .pr-md-2,
  .px-md-2 {
    padding-right: 5px !important;
  }

  .pb-md-2,
  .py-md-2 {
    padding-bottom: 5px !important;
  }

  .pl-md-2,
  .px-md-2 {
    padding-left: 5px !important;
  }

  .p-md-3 {
    padding: 15px !important;
  }

  .pt-md-3,
  .py-md-3 {
    padding-top: 15px !important;
  }

  .pr-md-3,
  .px-md-3 {
    padding-right: 15px !important;
  }

  .pb-md-3,
  .py-md-3 {
    padding-bottom: 15px !important;
  }

  .pl-md-3,
  .px-md-3 {
    padding-left: 15px !important;
  }

  .p-md-4 {
    padding: 30px !important;
  }

  .pt-md-4,
  .py-md-4 {
    padding-top: 30px !important;
  }

  .pr-md-4,
  .px-md-4 {
    padding-right: 30px !important;
  }

  .pb-md-4,
  .py-md-4 {
    padding-bottom: 30px !important;
  }

  .pl-md-4,
  .px-md-4 {
    padding-left: 30px !important;
  }

  .p-md-5 {
    padding: 30px !important;
  }

  .pt-md-5,
  .py-md-5 {
    padding-top: 30px !important;
  }

  .pr-md-5,
  .px-md-5 {
    padding-right: 30px !important;
  }

  .pb-md-5,
  .py-md-5 {
    padding-bottom: 30px !important;
  }

  .pl-md-5,
  .px-md-5 {
    padding-left: 30px !important;
  }

  .p-md-6 {
    padding: 50px !important;
  }

  .pt-md-6,
  .py-md-6 {
    padding-top: 50px !important;
  }

  .pr-md-6,
  .px-md-6 {
    padding-right: 50px !important;
  }

  .pb-md-6,
  .py-md-6 {
    padding-bottom: 50px !important;
  }

  .pl-md-6,
  .px-md-6 {
    padding-left: 50px !important;
  }

  .p-md-7 {
    padding: 60px !important;
  }

  .pt-md-7,
  .py-md-7 {
    padding-top: 60px !important;
  }

  .pr-md-7,
  .px-md-7 {
    padding-right: 60px !important;
  }

  .pb-md-7,
  .py-md-7 {
    padding-bottom: 60px !important;
  }

  .pl-md-7,
  .px-md-7 {
    padding-left: 60px !important;
  }

  .p-md-8 {
    padding: 70px !important;
  }

  .pt-md-8,
  .py-md-8 {
    padding-top: 70px !important;
  }

  .pr-md-8,
  .px-md-8 {
    padding-right: 70px !important;
  }

  .pb-md-8,
  .py-md-8 {
    padding-bottom: 70px !important;
  }

  .pl-md-8,
  .px-md-8 {
    padding-left: 70px !important;
  }

  .p-md-9 {
    padding: 80px !important;
  }

  .pt-md-9,
  .py-md-9 {
    padding-top: 80px !important;
  }

  .pr-md-9,
  .px-md-9 {
    padding-right: 80px !important;
  }

  .pb-md-9,
  .py-md-9 {
    padding-bottom: 80px !important;
  }

  .pl-md-9,
  .px-md-9 {
    padding-left: 80px !important;
  }

  .m-md-n1 {
    margin: -5px !important;
  }

  .mt-md-n1,
  .my-md-n1 {
    margin-top: -5px !important;
  }

  .mr-md-n1,
  .mx-md-n1 {
    margin-right: -5px !important;
  }

  .mb-md-n1,
  .my-md-n1 {
    margin-bottom: -5px !important;
  }

  .ml-md-n1,
  .mx-md-n1 {
    margin-left: -5px !important;
  }

  .m-md-n2 {
    margin: -5px !important;
  }

  .mt-md-n2,
  .my-md-n2 {
    margin-top: -5px !important;
  }

  .mr-md-n2,
  .mx-md-n2 {
    margin-right: -5px !important;
  }

  .mb-md-n2,
  .my-md-n2 {
    margin-bottom: -5px !important;
  }

  .ml-md-n2,
  .mx-md-n2 {
    margin-left: -5px !important;
  }

  .m-md-n3 {
    margin: -15px !important;
  }

  .mt-md-n3,
  .my-md-n3 {
    margin-top: -15px !important;
  }

  .mr-md-n3,
  .mx-md-n3 {
    margin-right: -15px !important;
  }

  .mb-md-n3,
  .my-md-n3 {
    margin-bottom: -15px !important;
  }

  .ml-md-n3,
  .mx-md-n3 {
    margin-left: -15px !important;
  }

  .m-md-n4 {
    margin: -30px !important;
  }

  .mt-md-n4,
  .my-md-n4 {
    margin-top: -30px !important;
  }

  .mr-md-n4,
  .mx-md-n4 {
    margin-right: -30px !important;
  }

  .mb-md-n4,
  .my-md-n4 {
    margin-bottom: -30px !important;
  }

  .ml-md-n4,
  .mx-md-n4 {
    margin-left: -30px !important;
  }

  .m-md-n5 {
    margin: -50px !important;
  }

  .mt-md-n5,
  .my-md-n5 {
    margin-top: -50px !important;
  }

  .mr-md-n5,
  .mx-md-n5 {
    margin-right: -50px !important;
  }

  .mb-md-n5,
  .my-md-n5 {
    margin-bottom: -50px !important;
  }

  .ml-md-n5,
  .mx-md-n5 {
    margin-left: -50px !important;
  }

  .m-md-n6 {
    margin: -50px !important;
  }

  .mt-md-n6,
  .my-md-n6 {
    margin-top: -50px !important;
  }

  .mr-md-n6,
  .mx-md-n6 {
    margin-right: -50px !important;
  }

  .mb-md-n6,
  .my-md-n6 {
    margin-bottom: -50px !important;
  }

  .ml-md-n6,
  .mx-md-n6 {
    margin-left: -50px !important;
  }

  .m-md-n7 {
    margin: -60px !important;
  }

  .mt-md-n7,
  .my-md-n7 {
    margin-top: -60px !important;
  }

  .mr-md-n7,
  .mx-md-n7 {
    margin-right: -60px !important;
  }

  .mb-md-n7,
  .my-md-n7 {
    margin-bottom: -60px !important;
  }

  .ml-md-n7,
  .mx-md-n7 {
    margin-left: -60px !important;
  }

  .m-md-n8 {
    margin: -70px !important;
  }

  .mt-md-n8,
  .my-md-n8 {
    margin-top: -70px !important;
  }

  .mr-md-n8,
  .mx-md-n8 {
    margin-right: -70px !important;
  }

  .mb-md-n8,
  .my-md-n8 {
    margin-bottom: -70px !important;
  }

  .ml-md-n8,
  .mx-md-n8 {
    margin-left: -70px !important;
  }

  .m-md-n9 {
    margin: -80px !important;
  }

  .mt-md-n9,
  .my-md-n9 {
    margin-top: -80px !important;
  }

  .mr-md-n9,
  .mx-md-n9 {
    margin-right: -80px !important;
  }

  .mb-md-n9,
  .my-md-n9 {
    margin-bottom: -80px !important;
  }

  .ml-md-n9,
  .mx-md-n9 {
    margin-left: -80px !important;
  }

  .m-md-auto {
    margin: auto !important;
  }

  .mt-md-auto,
  .my-md-auto {
    margin-top: auto !important;
  }

  .mr-md-auto,
  .mx-md-auto {
    margin-right: auto !important;
  }

  .mb-md-auto,
  .my-md-auto {
    margin-bottom: auto !important;
  }

  .ml-md-auto,
  .mx-md-auto {
    margin-left: auto !important;
  }
}

@media (min-width: 992px) {
  .m-lg-0 {
    margin: 0 !important;
  }

  .mt-lg-0,
  .my-lg-0 {
    margin-top: 0 !important;
  }

  .mr-lg-0,
  .mx-lg-0 {
    margin-right: 0 !important;
  }

  .mb-lg-0,
  .my-lg-0 {
    margin-bottom: 0 !important;
  }

  .ml-lg-0,
  .mx-lg-0 {
    margin-left: 0 !important;
  }

  .m-lg-1 {
    margin: 5px !important;
  }

  .mt-lg-1,
  .my-lg-1 {
    margin-top: 5px !important;
  }

  .mr-lg-1,
  .mx-lg-1 {
    margin-right: 5px !important;
  }

  .mb-lg-1,
  .my-lg-1 {
    margin-bottom: 5px !important;
  }

  .ml-lg-1,
  .mx-lg-1 {
    margin-left: 5px !important;
  }

  .m-lg-2 {
    margin: 5px !important;
  }

  .mt-lg-2,
  .my-lg-2 {
    margin-top: 5px !important;
  }

  .mr-lg-2,
  .mx-lg-2 {
    margin-right: 5px !important;
  }

  .mb-lg-2,
  .my-lg-2 {
    margin-bottom: 5px !important;
  }

  .ml-lg-2,
  .mx-lg-2 {
    margin-left: 5px !important;
  }

  .m-lg-3 {
    margin: 15px !important;
  }

  .mt-lg-3,
  .my-lg-3 {
    margin-top: 15px !important;
  }

  .mr-lg-3,
  .mx-lg-3 {
    margin-right: 15px !important;
  }

  .mb-lg-3,
  .my-lg-3 {
    margin-bottom: 15px !important;
  }

  .ml-lg-3,
  .mx-lg-3 {
    margin-left: 15px !important;
  }

  .m-lg-4 {
    margin: 30px !important;
  }

  .mt-lg-4,
  .my-lg-4 {
    margin-top: 30px !important;
  }

  .mr-lg-4,
  .mx-lg-4 {
    margin-right: 30px !important;
  }

  .mb-lg-4,
  .my-lg-4 {
    margin-bottom: 30px !important;
  }

  .ml-lg-4,
  .mx-lg-4 {
    margin-left: 30px !important;
  }

  .m-lg-5 {
    margin: 30px !important;
  }

  .mt-lg-5,
  .my-lg-5 {
    margin-top: 30px !important;
  }

  .mr-lg-5,
  .mx-lg-5 {
    margin-right: 30px !important;
  }

  .mb-lg-5,
  .my-lg-5 {
    margin-bottom: 30px !important;
  }

  .ml-lg-5,
  .mx-lg-5 {
    margin-left: 30px !important;
  }

  .m-lg-6 {
    margin: 50px !important;
  }

  .mt-lg-6,
  .my-lg-6 {
    margin-top: 50px !important;
  }

  .mr-lg-6,
  .mx-lg-6 {
    margin-right: 50px !important;
  }

  .mb-lg-6,
  .my-lg-6 {
    margin-bottom: 50px !important;
  }

  .ml-lg-6,
  .mx-lg-6 {
    margin-left: 50px !important;
  }

  .m-lg-7 {
    margin: 60px !important;
  }

  .mt-lg-7,
  .my-lg-7 {
    margin-top: 60px !important;
  }

  .mr-lg-7,
  .mx-lg-7 {
    margin-right: 60px !important;
  }

  .mb-lg-7,
  .my-lg-7 {
    margin-bottom: 60px !important;
  }

  .ml-lg-7,
  .mx-lg-7 {
    margin-left: 60px !important;
  }

  .m-lg-8 {
    margin: 70px !important;
  }

  .mt-lg-8,
  .my-lg-8 {
    margin-top: 70px !important;
  }

  .mr-lg-8,
  .mx-lg-8 {
    margin-right: 70px !important;
  }

  .mb-lg-8,
  .my-lg-8 {
    margin-bottom: 70px !important;
  }

  .ml-lg-8,
  .mx-lg-8 {
    margin-left: 70px !important;
  }

  .m-lg-9 {
    margin: 80px !important;
  }

  .mt-lg-9,
  .my-lg-9 {
    margin-top: 80px !important;
  }

  .mr-lg-9,
  .mx-lg-9 {
    margin-right: 80px !important;
  }

  .mb-lg-9,
  .my-lg-9 {
    margin-bottom: 80px !important;
  }

  .ml-lg-9,
  .mx-lg-9 {
    margin-left: 80px !important;
  }

  .p-lg-0 {
    padding: 0 !important;
  }

  .pt-lg-0,
  .py-lg-0 {
    padding-top: 0 !important;
  }

  .pr-lg-0,
  .px-lg-0 {
    padding-right: 0 !important;
  }

  .pb-lg-0,
  .py-lg-0 {
    padding-bottom: 0 !important;
  }

  .pl-lg-0,
  .px-lg-0 {
    padding-left: 0 !important;
  }

  .p-lg-1 {
    padding: 5px !important;
  }

  .pt-lg-1,
  .py-lg-1 {
    padding-top: 5px !important;
  }

  .pr-lg-1,
  .px-lg-1 {
    padding-right: 5px !important;
  }

  .pb-lg-1,
  .py-lg-1 {
    padding-bottom: 5px !important;
  }

  .pl-lg-1,
  .px-lg-1 {
    padding-left: 5px !important;
  }

  .p-lg-2 {
    padding: 5px !important;
  }

  .pt-lg-2,
  .py-lg-2 {
    padding-top: 5px !important;
  }

  .pr-lg-2,
  .px-lg-2 {
    padding-right: 5px !important;
  }

  .pb-lg-2,
  .py-lg-2 {
    padding-bottom: 5px !important;
  }

  .pl-lg-2,
  .px-lg-2 {
    padding-left: 5px !important;
  }

  .p-lg-3 {
    padding: 15px !important;
  }

  .pt-lg-3,
  .py-lg-3 {
    padding-top: 15px !important;
  }

  .pr-lg-3,
  .px-lg-3 {
    padding-right: 15px !important;
  }

  .pb-lg-3,
  .py-lg-3 {
    padding-bottom: 15px !important;
  }

  .pl-lg-3,
  .px-lg-3 {
    padding-left: 15px !important;
  }

  .p-lg-4 {
    padding: 30px !important;
  }

  .pt-lg-4,
  .py-lg-4 {
    padding-top: 30px !important;
  }

  .pr-lg-4,
  .px-lg-4 {
    padding-right: 30px !important;
  }

  .pb-lg-4,
  .py-lg-4 {
    padding-bottom: 30px !important;
  }

  .pl-lg-4,
  .px-lg-4 {
    padding-left: 30px !important;
  }

  .p-lg-5 {
    padding: 30px !important;
  }

  .pt-lg-5,
  .py-lg-5 {
    padding-top: 30px !important;
  }

  .pr-lg-5,
  .px-lg-5 {
    padding-right: 30px !important;
  }

  .pb-lg-5,
  .py-lg-5 {
    padding-bottom: 30px !important;
  }

  .pl-lg-5,
  .px-lg-5 {
    padding-left: 30px !important;
  }

  .p-lg-6 {
    padding: 50px !important;
  }

  .pt-lg-6,
  .py-lg-6 {
    padding-top: 50px !important;
  }

  .pr-lg-6,
  .px-lg-6 {
    padding-right: 50px !important;
  }

  .pb-lg-6,
  .py-lg-6 {
    padding-bottom: 50px !important;
  }

  .pl-lg-6,
  .px-lg-6 {
    padding-left: 50px !important;
  }

  .p-lg-7 {
    padding: 60px !important;
  }

  .pt-lg-7,
  .py-lg-7 {
    padding-top: 60px !important;
  }

  .pr-lg-7,
  .px-lg-7 {
    padding-right: 60px !important;
  }

  .pb-lg-7,
  .py-lg-7 {
    padding-bottom: 60px !important;
  }

  .pl-lg-7,
  .px-lg-7 {
    padding-left: 60px !important;
  }

  .p-lg-8 {
    padding: 70px !important;
  }

  .pt-lg-8,
  .py-lg-8 {
    padding-top: 70px !important;
  }

  .pr-lg-8,
  .px-lg-8 {
    padding-right: 70px !important;
  }

  .pb-lg-8,
  .py-lg-8 {
    padding-bottom: 70px !important;
  }

  .pl-lg-8,
  .px-lg-8 {
    padding-left: 70px !important;
  }

  .p-lg-9 {
    padding: 80px !important;
  }

  .pt-lg-9,
  .py-lg-9 {
    padding-top: 80px !important;
  }

  .pr-lg-9,
  .px-lg-9 {
    padding-right: 80px !important;
  }

  .pb-lg-9,
  .py-lg-9 {
    padding-bottom: 80px !important;
  }

  .pl-lg-9,
  .px-lg-9 {
    padding-left: 80px !important;
  }

  .m-lg-n1 {
    margin: -5px !important;
  }

  .mt-lg-n1,
  .my-lg-n1 {
    margin-top: -5px !important;
  }

  .mr-lg-n1,
  .mx-lg-n1 {
    margin-right: -5px !important;
  }

  .mb-lg-n1,
  .my-lg-n1 {
    margin-bottom: -5px !important;
  }

  .ml-lg-n1,
  .mx-lg-n1 {
    margin-left: -5px !important;
  }

  .m-lg-n2 {
    margin: -5px !important;
  }

  .mt-lg-n2,
  .my-lg-n2 {
    margin-top: -5px !important;
  }

  .mr-lg-n2,
  .mx-lg-n2 {
    margin-right: -5px !important;
  }

  .mb-lg-n2,
  .my-lg-n2 {
    margin-bottom: -5px !important;
  }

  .ml-lg-n2,
  .mx-lg-n2 {
    margin-left: -5px !important;
  }

  .m-lg-n3 {
    margin: -15px !important;
  }

  .mt-lg-n3,
  .my-lg-n3 {
    margin-top: -15px !important;
  }

  .mr-lg-n3,
  .mx-lg-n3 {
    margin-right: -15px !important;
  }

  .mb-lg-n3,
  .my-lg-n3 {
    margin-bottom: -15px !important;
  }

  .ml-lg-n3,
  .mx-lg-n3 {
    margin-left: -15px !important;
  }

  .m-lg-n4 {
    margin: -30px !important;
  }

  .mt-lg-n4,
  .my-lg-n4 {
    margin-top: -30px !important;
  }

  .mr-lg-n4,
  .mx-lg-n4 {
    margin-right: -30px !important;
  }

  .mb-lg-n4,
  .my-lg-n4 {
    margin-bottom: -30px !important;
  }

  .ml-lg-n4,
  .mx-lg-n4 {
    margin-left: -30px !important;
  }

  .m-lg-n5 {
    margin: -50px !important;
  }

  .mt-lg-n5,
  .my-lg-n5 {
    margin-top: -50px !important;
  }

  .mr-lg-n5,
  .mx-lg-n5 {
    margin-right: -50px !important;
  }

  .mb-lg-n5,
  .my-lg-n5 {
    margin-bottom: -50px !important;
  }

  .ml-lg-n5,
  .mx-lg-n5 {
    margin-left: -50px !important;
  }

  .m-lg-n6 {
    margin: -50px !important;
  }

  .mt-lg-n6,
  .my-lg-n6 {
    margin-top: -50px !important;
  }

  .mr-lg-n6,
  .mx-lg-n6 {
    margin-right: -50px !important;
  }

  .mb-lg-n6,
  .my-lg-n6 {
    margin-bottom: -50px !important;
  }

  .ml-lg-n6,
  .mx-lg-n6 {
    margin-left: -50px !important;
  }

  .m-lg-n7 {
    margin: -60px !important;
  }

  .mt-lg-n7,
  .my-lg-n7 {
    margin-top: -60px !important;
  }

  .mr-lg-n7,
  .mx-lg-n7 {
    margin-right: -60px !important;
  }

  .mb-lg-n7,
  .my-lg-n7 {
    margin-bottom: -60px !important;
  }

  .ml-lg-n7,
  .mx-lg-n7 {
    margin-left: -60px !important;
  }

  .m-lg-n8 {
    margin: -70px !important;
  }

  .mt-lg-n8,
  .my-lg-n8 {
    margin-top: -70px !important;
  }

  .mr-lg-n8,
  .mx-lg-n8 {
    margin-right: -70px !important;
  }

  .mb-lg-n8,
  .my-lg-n8 {
    margin-bottom: -70px !important;
  }

  .ml-lg-n8,
  .mx-lg-n8 {
    margin-left: -70px !important;
  }

  .m-lg-n9 {
    margin: -80px !important;
  }

  .mt-lg-n9,
  .my-lg-n9 {
    margin-top: -80px !important;
  }

  .mr-lg-n9,
  .mx-lg-n9 {
    margin-right: -80px !important;
  }

  .mb-lg-n9,
  .my-lg-n9 {
    margin-bottom: -80px !important;
  }

  .ml-lg-n9,
  .mx-lg-n9 {
    margin-left: -80px !important;
  }

  .m-lg-auto {
    margin: auto !important;
  }

  .mt-lg-auto,
  .my-lg-auto {
    margin-top: auto !important;
  }

  .mr-lg-auto,
  .mx-lg-auto {
    margin-right: auto !important;
  }

  .mb-lg-auto,
  .my-lg-auto {
    margin-bottom: auto !important;
  }

  .ml-lg-auto,
  .mx-lg-auto {
    margin-left: auto !important;
  }
}

@media (min-width: 1200px) {
  .m-xl-0 {
    margin: 0 !important;
  }

  .mt-xl-0,
  .my-xl-0 {
    margin-top: 0 !important;
  }

  .mr-xl-0,
  .mx-xl-0 {
    margin-right: 0 !important;
  }

  .mb-xl-0,
  .my-xl-0 {
    margin-bottom: 0 !important;
  }

  .ml-xl-0,
  .mx-xl-0 {
    margin-left: 0 !important;
  }

  .m-xl-1 {
    margin: 5px !important;
  }

  .mt-xl-1,
  .my-xl-1 {
    margin-top: 5px !important;
  }

  .mr-xl-1,
  .mx-xl-1 {
    margin-right: 5px !important;
  }

  .mb-xl-1,
  .my-xl-1 {
    margin-bottom: 5px !important;
  }

  .ml-xl-1,
  .mx-xl-1 {
    margin-left: 5px !important;
  }

  .m-xl-2 {
    margin: 5px !important;
  }

  .mt-xl-2,
  .my-xl-2 {
    margin-top: 5px !important;
  }

  .mr-xl-2,
  .mx-xl-2 {
    margin-right: 5px !important;
  }

  .mb-xl-2,
  .my-xl-2 {
    margin-bottom: 5px !important;
  }

  .ml-xl-2,
  .mx-xl-2 {
    margin-left: 5px !important;
  }

  .m-xl-3 {
    margin: 15px !important;
  }

  .mt-xl-3,
  .my-xl-3 {
    margin-top: 15px !important;
  }

  .mr-xl-3,
  .mx-xl-3 {
    margin-right: 15px !important;
  }

  .mb-xl-3,
  .my-xl-3 {
    margin-bottom: 15px !important;
  }

  .ml-xl-3,
  .mx-xl-3 {
    margin-left: 15px !important;
  }

  .m-xl-4 {
    margin: 30px !important;
  }

  .mt-xl-4,
  .my-xl-4 {
    margin-top: 30px !important;
  }

  .mr-xl-4,
  .mx-xl-4 {
    margin-right: 30px !important;
  }

  .mb-xl-4,
  .my-xl-4 {
    margin-bottom: 30px !important;
  }

  .ml-xl-4,
  .mx-xl-4 {
    margin-left: 30px !important;
  }

  .m-xl-5 {
    margin: 30px !important;
  }

  .mt-xl-5,
  .my-xl-5 {
    margin-top: 30px !important;
  }

  .mr-xl-5,
  .mx-xl-5 {
    margin-right: 30px !important;
  }

  .mb-xl-5,
  .my-xl-5 {
    margin-bottom: 30px !important;
  }

  .ml-xl-5,
  .mx-xl-5 {
    margin-left: 30px !important;
  }

  .m-xl-6 {
    margin: 50px !important;
  }

  .mt-xl-6,
  .my-xl-6 {
    margin-top: 50px !important;
  }

  .mr-xl-6,
  .mx-xl-6 {
    margin-right: 50px !important;
  }

  .mb-xl-6,
  .my-xl-6 {
    margin-bottom: 50px !important;
  }

  .ml-xl-6,
  .mx-xl-6 {
    margin-left: 50px !important;
  }

  .m-xl-7 {
    margin: 60px !important;
  }

  .mt-xl-7,
  .my-xl-7 {
    margin-top: 60px !important;
  }

  .mr-xl-7,
  .mx-xl-7 {
    margin-right: 60px !important;
  }

  .mb-xl-7,
  .my-xl-7 {
    margin-bottom: 60px !important;
  }

  .ml-xl-7,
  .mx-xl-7 {
    margin-left: 60px !important;
  }

  .m-xl-8 {
    margin: 70px !important;
  }

  .mt-xl-8,
  .my-xl-8 {
    margin-top: 70px !important;
  }

  .mr-xl-8,
  .mx-xl-8 {
    margin-right: 70px !important;
  }

  .mb-xl-8,
  .my-xl-8 {
    margin-bottom: 70px !important;
  }

  .ml-xl-8,
  .mx-xl-8 {
    margin-left: 70px !important;
  }

  .m-xl-9 {
    margin: 80px !important;
  }

  .mt-xl-9,
  .my-xl-9 {
    margin-top: 80px !important;
  }

  .mr-xl-9,
  .mx-xl-9 {
    margin-right: 80px !important;
  }

  .mb-xl-9,
  .my-xl-9 {
    margin-bottom: 80px !important;
  }

  .ml-xl-9,
  .mx-xl-9 {
    margin-left: 80px !important;
  }

  .p-xl-0 {
    padding: 0 !important;
  }

  .pt-xl-0,
  .py-xl-0 {
    padding-top: 0 !important;
  }

  .pr-xl-0,
  .px-xl-0 {
    padding-right: 0 !important;
  }

  .pb-xl-0,
  .py-xl-0 {
    padding-bottom: 0 !important;
  }

  .pl-xl-0,
  .px-xl-0 {
    padding-left: 0 !important;
  }

  .p-xl-1 {
    padding: 5px !important;
  }

  .pt-xl-1,
  .py-xl-1 {
    padding-top: 5px !important;
  }

  .pr-xl-1,
  .px-xl-1 {
    padding-right: 5px !important;
  }

  .pb-xl-1,
  .py-xl-1 {
    padding-bottom: 5px !important;
  }

  .pl-xl-1,
  .px-xl-1 {
    padding-left: 5px !important;
  }

  .p-xl-2 {
    padding: 5px !important;
  }

  .pt-xl-2,
  .py-xl-2 {
    padding-top: 5px !important;
  }

  .pr-xl-2,
  .px-xl-2 {
    padding-right: 5px !important;
  }

  .pb-xl-2,
  .py-xl-2 {
    padding-bottom: 5px !important;
  }

  .pl-xl-2,
  .px-xl-2 {
    padding-left: 5px !important;
  }

  .p-xl-3 {
    padding: 15px !important;
  }

  .pt-xl-3,
  .py-xl-3 {
    padding-top: 15px !important;
  }

  .pr-xl-3,
  .px-xl-3 {
    padding-right: 15px !important;
  }

  .pb-xl-3,
  .py-xl-3 {
    padding-bottom: 15px !important;
  }

  .pl-xl-3,
  .px-xl-3 {
    padding-left: 15px !important;
  }

  .p-xl-4 {
    padding: 30px !important;
  }

  .pt-xl-4,
  .py-xl-4 {
    padding-top: 30px !important;
  }

  .pr-xl-4,
  .px-xl-4 {
    padding-right: 30px !important;
  }

  .pb-xl-4,
  .py-xl-4 {
    padding-bottom: 30px !important;
  }

  .pl-xl-4,
  .px-xl-4 {
    padding-left: 30px !important;
  }

  .p-xl-5 {
    padding: 30px !important;
  }

  .pt-xl-5,
  .py-xl-5 {
    padding-top: 30px !important;
  }

  .pr-xl-5,
  .px-xl-5 {
    padding-right: 30px !important;
  }

  .pb-xl-5,
  .py-xl-5 {
    padding-bottom: 30px !important;
  }

  .pl-xl-5,
  .px-xl-5 {
    padding-left: 30px !important;
  }

  .p-xl-6 {
    padding: 50px !important;
  }

  .pt-xl-6,
  .py-xl-6 {
    padding-top: 50px !important;
  }

  .pr-xl-6,
  .px-xl-6 {
    padding-right: 50px !important;
  }

  .pb-xl-6,
  .py-xl-6 {
    padding-bottom: 50px !important;
  }

  .pl-xl-6,
  .px-xl-6 {
    padding-left: 50px !important;
  }

  .p-xl-7 {
    padding: 60px !important;
  }

  .pt-xl-7,
  .py-xl-7 {
    padding-top: 60px !important;
  }

  .pr-xl-7,
  .px-xl-7 {
    padding-right: 60px !important;
  }

  .pb-xl-7,
  .py-xl-7 {
    padding-bottom: 60px !important;
  }

  .pl-xl-7,
  .px-xl-7 {
    padding-left: 60px !important;
  }

  .p-xl-8 {
    padding: 70px !important;
  }

  .pt-xl-8,
  .py-xl-8 {
    padding-top: 70px !important;
  }

  .pr-xl-8,
  .px-xl-8 {
    padding-right: 70px !important;
  }

  .pb-xl-8,
  .py-xl-8 {
    padding-bottom: 70px !important;
  }

  .pl-xl-8,
  .px-xl-8 {
    padding-left: 70px !important;
  }

  .p-xl-9 {
    padding: 80px !important;
  }

  .pt-xl-9,
  .py-xl-9 {
    padding-top: 80px !important;
  }

  .pr-xl-9,
  .px-xl-9 {
    padding-right: 80px !important;
  }

  .pb-xl-9,
  .py-xl-9 {
    padding-bottom: 80px !important;
  }

  .pl-xl-9,
  .px-xl-9 {
    padding-left: 80px !important;
  }

  .m-xl-n1 {
    margin: -5px !important;
  }

  .mt-xl-n1,
  .my-xl-n1 {
    margin-top: -5px !important;
  }

  .mr-xl-n1,
  .mx-xl-n1 {
    margin-right: -5px !important;
  }

  .mb-xl-n1,
  .my-xl-n1 {
    margin-bottom: -5px !important;
  }

  .ml-xl-n1,
  .mx-xl-n1 {
    margin-left: -5px !important;
  }

  .m-xl-n2 {
    margin: -5px !important;
  }

  .mt-xl-n2,
  .my-xl-n2 {
    margin-top: -5px !important;
  }

  .mr-xl-n2,
  .mx-xl-n2 {
    margin-right: -5px !important;
  }

  .mb-xl-n2,
  .my-xl-n2 {
    margin-bottom: -5px !important;
  }

  .ml-xl-n2,
  .mx-xl-n2 {
    margin-left: -5px !important;
  }

  .m-xl-n3 {
    margin: -15px !important;
  }

  .mt-xl-n3,
  .my-xl-n3 {
    margin-top: -15px !important;
  }

  .mr-xl-n3,
  .mx-xl-n3 {
    margin-right: -15px !important;
  }

  .mb-xl-n3,
  .my-xl-n3 {
    margin-bottom: -15px !important;
  }

  .ml-xl-n3,
  .mx-xl-n3 {
    margin-left: -15px !important;
  }

  .m-xl-n4 {
    margin: -30px !important;
  }

  .mt-xl-n4,
  .my-xl-n4 {
    margin-top: -30px !important;
  }

  .mr-xl-n4,
  .mx-xl-n4 {
    margin-right: -30px !important;
  }

  .mb-xl-n4,
  .my-xl-n4 {
    margin-bottom: -30px !important;
  }

  .ml-xl-n4,
  .mx-xl-n4 {
    margin-left: -30px !important;
  }

  .m-xl-n5 {
    margin: -50px !important;
  }

  .mt-xl-n5,
  .my-xl-n5 {
    margin-top: -50px !important;
  }

  .mr-xl-n5,
  .mx-xl-n5 {
    margin-right: -50px !important;
  }

  .mb-xl-n5,
  .my-xl-n5 {
    margin-bottom: -50px !important;
  }

  .ml-xl-n5,
  .mx-xl-n5 {
    margin-left: -50px !important;
  }

  .m-xl-n6 {
    margin: -50px !important;
  }

  .mt-xl-n6,
  .my-xl-n6 {
    margin-top: -50px !important;
  }

  .mr-xl-n6,
  .mx-xl-n6 {
    margin-right: -50px !important;
  }

  .mb-xl-n6,
  .my-xl-n6 {
    margin-bottom: -50px !important;
  }

  .ml-xl-n6,
  .mx-xl-n6 {
    margin-left: -50px !important;
  }

  .m-xl-n7 {
    margin: -60px !important;
  }

  .mt-xl-n7,
  .my-xl-n7 {
    margin-top: -60px !important;
  }

  .mr-xl-n7,
  .mx-xl-n7 {
    margin-right: -60px !important;
  }

  .mb-xl-n7,
  .my-xl-n7 {
    margin-bottom: -60px !important;
  }

  .ml-xl-n7,
  .mx-xl-n7 {
    margin-left: -60px !important;
  }

  .m-xl-n8 {
    margin: -70px !important;
  }

  .mt-xl-n8,
  .my-xl-n8 {
    margin-top: -70px !important;
  }

  .mr-xl-n8,
  .mx-xl-n8 {
    margin-right: -70px !important;
  }

  .mb-xl-n8,
  .my-xl-n8 {
    margin-bottom: -70px !important;
  }

  .ml-xl-n8,
  .mx-xl-n8 {
    margin-left: -70px !important;
  }

  .m-xl-n9 {
    margin: -80px !important;
  }

  .mt-xl-n9,
  .my-xl-n9 {
    margin-top: -80px !important;
  }

  .mr-xl-n9,
  .mx-xl-n9 {
    margin-right: -80px !important;
  }

  .mb-xl-n9,
  .my-xl-n9 {
    margin-bottom: -80px !important;
  }

  .ml-xl-n9,
  .mx-xl-n9 {
    margin-left: -80px !important;
  }

  .m-xl-auto {
    margin: auto !important;
  }

  .mt-xl-auto,
  .my-xl-auto {
    margin-top: auto !important;
  }

  .mr-xl-auto,
  .mx-xl-auto {
    margin-right: auto !important;
  }

  .mb-xl-auto,
  .my-xl-auto {
    margin-bottom: auto !important;
  }

  .ml-xl-auto,
  .mx-xl-auto {
    margin-left: auto !important;
  }
}

@media (min-width: 1500px) {
  .m-xxl-0 {
    margin: 0 !important;
  }

  .mt-xxl-0,
  .my-xxl-0 {
    margin-top: 0 !important;
  }

  .mr-xxl-0,
  .mx-xxl-0 {
    margin-right: 0 !important;
  }

  .mb-xxl-0,
  .my-xxl-0 {
    margin-bottom: 0 !important;
  }

  .ml-xxl-0,
  .mx-xxl-0 {
    margin-left: 0 !important;
  }

  .m-xxl-1 {
    margin: 5px !important;
  }

  .mt-xxl-1,
  .my-xxl-1 {
    margin-top: 5px !important;
  }

  .mr-xxl-1,
  .mx-xxl-1 {
    margin-right: 5px !important;
  }

  .mb-xxl-1,
  .my-xxl-1 {
    margin-bottom: 5px !important;
  }

  .ml-xxl-1,
  .mx-xxl-1 {
    margin-left: 5px !important;
  }

  .m-xxl-2 {
    margin: 5px !important;
  }

  .mt-xxl-2,
  .my-xxl-2 {
    margin-top: 5px !important;
  }

  .mr-xxl-2,
  .mx-xxl-2 {
    margin-right: 5px !important;
  }

  .mb-xxl-2,
  .my-xxl-2 {
    margin-bottom: 5px !important;
  }

  .ml-xxl-2,
  .mx-xxl-2 {
    margin-left: 5px !important;
  }

  .m-xxl-3 {
    margin: 15px !important;
  }

  .mt-xxl-3,
  .my-xxl-3 {
    margin-top: 15px !important;
  }

  .mr-xxl-3,
  .mx-xxl-3 {
    margin-right: 15px !important;
  }

  .mb-xxl-3,
  .my-xxl-3 {
    margin-bottom: 15px !important;
  }

  .ml-xxl-3,
  .mx-xxl-3 {
    margin-left: 15px !important;
  }

  .m-xxl-4 {
    margin: 30px !important;
  }

  .mt-xxl-4,
  .my-xxl-4 {
    margin-top: 30px !important;
  }

  .mr-xxl-4,
  .mx-xxl-4 {
    margin-right: 30px !important;
  }

  .mb-xxl-4,
  .my-xxl-4 {
    margin-bottom: 30px !important;
  }

  .ml-xxl-4,
  .mx-xxl-4 {
    margin-left: 30px !important;
  }

  .m-xxl-5 {
    margin: 30px !important;
  }

  .mt-xxl-5,
  .my-xxl-5 {
    margin-top: 30px !important;
  }

  .mr-xxl-5,
  .mx-xxl-5 {
    margin-right: 30px !important;
  }

  .mb-xxl-5,
  .my-xxl-5 {
    margin-bottom: 30px !important;
  }

  .ml-xxl-5,
  .mx-xxl-5 {
    margin-left: 30px !important;
  }

  .m-xxl-6 {
    margin: 50px !important;
  }

  .mt-xxl-6,
  .my-xxl-6 {
    margin-top: 50px !important;
  }

  .mr-xxl-6,
  .mx-xxl-6 {
    margin-right: 50px !important;
  }

  .mb-xxl-6,
  .my-xxl-6 {
    margin-bottom: 50px !important;
  }

  .ml-xxl-6,
  .mx-xxl-6 {
    margin-left: 50px !important;
  }

  .m-xxl-7 {
    margin: 60px !important;
  }

  .mt-xxl-7,
  .my-xxl-7 {
    margin-top: 60px !important;
  }

  .mr-xxl-7,
  .mx-xxl-7 {
    margin-right: 60px !important;
  }

  .mb-xxl-7,
  .my-xxl-7 {
    margin-bottom: 60px !important;
  }

  .ml-xxl-7,
  .mx-xxl-7 {
    margin-left: 60px !important;
  }

  .m-xxl-8 {
    margin: 70px !important;
  }

  .mt-xxl-8,
  .my-xxl-8 {
    margin-top: 70px !important;
  }

  .mr-xxl-8,
  .mx-xxl-8 {
    margin-right: 70px !important;
  }

  .mb-xxl-8,
  .my-xxl-8 {
    margin-bottom: 70px !important;
  }

  .ml-xxl-8,
  .mx-xxl-8 {
    margin-left: 70px !important;
  }

  .m-xxl-9 {
    margin: 80px !important;
  }

  .mt-xxl-9,
  .my-xxl-9 {
    margin-top: 80px !important;
  }

  .mr-xxl-9,
  .mx-xxl-9 {
    margin-right: 80px !important;
  }

  .mb-xxl-9,
  .my-xxl-9 {
    margin-bottom: 80px !important;
  }

  .ml-xxl-9,
  .mx-xxl-9 {
    margin-left: 80px !important;
  }

  .p-xxl-0 {
    padding: 0 !important;
  }

  .pt-xxl-0,
  .py-xxl-0 {
    padding-top: 0 !important;
  }

  .pr-xxl-0,
  .px-xxl-0 {
    padding-right: 0 !important;
  }

  .pb-xxl-0,
  .py-xxl-0 {
    padding-bottom: 0 !important;
  }

  .pl-xxl-0,
  .px-xxl-0 {
    padding-left: 0 !important;
  }

  .p-xxl-1 {
    padding: 5px !important;
  }

  .pt-xxl-1,
  .py-xxl-1 {
    padding-top: 5px !important;
  }

  .pr-xxl-1,
  .px-xxl-1 {
    padding-right: 5px !important;
  }

  .pb-xxl-1,
  .py-xxl-1 {
    padding-bottom: 5px !important;
  }

  .pl-xxl-1,
  .px-xxl-1 {
    padding-left: 5px !important;
  }

  .p-xxl-2 {
    padding: 5px !important;
  }

  .pt-xxl-2,
  .py-xxl-2 {
    padding-top: 5px !important;
  }

  .pr-xxl-2,
  .px-xxl-2 {
    padding-right: 5px !important;
  }

  .pb-xxl-2,
  .py-xxl-2 {
    padding-bottom: 5px !important;
  }

  .pl-xxl-2,
  .px-xxl-2 {
    padding-left: 5px !important;
  }

  .p-xxl-3 {
    padding: 15px !important;
  }

  .pt-xxl-3,
  .py-xxl-3 {
    padding-top: 15px !important;
  }

  .pr-xxl-3,
  .px-xxl-3 {
    padding-right: 15px !important;
  }

  .pb-xxl-3,
  .py-xxl-3 {
    padding-bottom: 15px !important;
  }

  .pl-xxl-3,
  .px-xxl-3 {
    padding-left: 15px !important;
  }

  .p-xxl-4 {
    padding: 30px !important;
  }

  .pt-xxl-4,
  .py-xxl-4 {
    padding-top: 30px !important;
  }

  .pr-xxl-4,
  .px-xxl-4 {
    padding-right: 30px !important;
  }

  .pb-xxl-4,
  .py-xxl-4 {
    padding-bottom: 30px !important;
  }

  .pl-xxl-4,
  .px-xxl-4 {
    padding-left: 30px !important;
  }

  .p-xxl-5 {
    padding: 30px !important;
  }

  .pt-xxl-5,
  .py-xxl-5 {
    padding-top: 30px !important;
  }

  .pr-xxl-5,
  .px-xxl-5 {
    padding-right: 30px !important;
  }

  .pb-xxl-5,
  .py-xxl-5 {
    padding-bottom: 30px !important;
  }

  .pl-xxl-5,
  .px-xxl-5 {
    padding-left: 30px !important;
  }

  .p-xxl-6 {
    padding: 50px !important;
  }

  .pt-xxl-6,
  .py-xxl-6 {
    padding-top: 50px !important;
  }

  .pr-xxl-6,
  .px-xxl-6 {
    padding-right: 50px !important;
  }

  .pb-xxl-6,
  .py-xxl-6 {
    padding-bottom: 50px !important;
  }

  .pl-xxl-6,
  .px-xxl-6 {
    padding-left: 50px !important;
  }

  .p-xxl-7 {
    padding: 60px !important;
  }

  .pt-xxl-7,
  .py-xxl-7 {
    padding-top: 60px !important;
  }

  .pr-xxl-7,
  .px-xxl-7 {
    padding-right: 60px !important;
  }

  .pb-xxl-7,
  .py-xxl-7 {
    padding-bottom: 60px !important;
  }

  .pl-xxl-7,
  .px-xxl-7 {
    padding-left: 60px !important;
  }

  .p-xxl-8 {
    padding: 70px !important;
  }

  .pt-xxl-8,
  .py-xxl-8 {
    padding-top: 70px !important;
  }

  .pr-xxl-8,
  .px-xxl-8 {
    padding-right: 70px !important;
  }

  .pb-xxl-8,
  .py-xxl-8 {
    padding-bottom: 70px !important;
  }

  .pl-xxl-8,
  .px-xxl-8 {
    padding-left: 70px !important;
  }

  .p-xxl-9 {
    padding: 80px !important;
  }

  .pt-xxl-9,
  .py-xxl-9 {
    padding-top: 80px !important;
  }

  .pr-xxl-9,
  .px-xxl-9 {
    padding-right: 80px !important;
  }

  .pb-xxl-9,
  .py-xxl-9 {
    padding-bottom: 80px !important;
  }

  .pl-xxl-9,
  .px-xxl-9 {
    padding-left: 80px !important;
  }

  .m-xxl-n1 {
    margin: -5px !important;
  }

  .mt-xxl-n1,
  .my-xxl-n1 {
    margin-top: -5px !important;
  }

  .mr-xxl-n1,
  .mx-xxl-n1 {
    margin-right: -5px !important;
  }

  .mb-xxl-n1,
  .my-xxl-n1 {
    margin-bottom: -5px !important;
  }

  .ml-xxl-n1,
  .mx-xxl-n1 {
    margin-left: -5px !important;
  }

  .m-xxl-n2 {
    margin: -5px !important;
  }

  .mt-xxl-n2,
  .my-xxl-n2 {
    margin-top: -5px !important;
  }

  .mr-xxl-n2,
  .mx-xxl-n2 {
    margin-right: -5px !important;
  }

  .mb-xxl-n2,
  .my-xxl-n2 {
    margin-bottom: -5px !important;
  }

  .ml-xxl-n2,
  .mx-xxl-n2 {
    margin-left: -5px !important;
  }

  .m-xxl-n3 {
    margin: -15px !important;
  }

  .mt-xxl-n3,
  .my-xxl-n3 {
    margin-top: -15px !important;
  }

  .mr-xxl-n3,
  .mx-xxl-n3 {
    margin-right: -15px !important;
  }

  .mb-xxl-n3,
  .my-xxl-n3 {
    margin-bottom: -15px !important;
  }

  .ml-xxl-n3,
  .mx-xxl-n3 {
    margin-left: -15px !important;
  }

  .m-xxl-n4 {
    margin: -30px !important;
  }

  .mt-xxl-n4,
  .my-xxl-n4 {
    margin-top: -30px !important;
  }

  .mr-xxl-n4,
  .mx-xxl-n4 {
    margin-right: -30px !important;
  }

  .mb-xxl-n4,
  .my-xxl-n4 {
    margin-bottom: -30px !important;
  }

  .ml-xxl-n4,
  .mx-xxl-n4 {
    margin-left: -30px !important;
  }

  .m-xxl-n5 {
    margin: -50px !important;
  }

  .mt-xxl-n5,
  .my-xxl-n5 {
    margin-top: -50px !important;
  }

  .mr-xxl-n5,
  .mx-xxl-n5 {
    margin-right: -50px !important;
  }

  .mb-xxl-n5,
  .my-xxl-n5 {
    margin-bottom: -50px !important;
  }

  .ml-xxl-n5,
  .mx-xxl-n5 {
    margin-left: -50px !important;
  }

  .m-xxl-n6 {
    margin: -50px !important;
  }

  .mt-xxl-n6,
  .my-xxl-n6 {
    margin-top: -50px !important;
  }

  .mr-xxl-n6,
  .mx-xxl-n6 {
    margin-right: -50px !important;
  }

  .mb-xxl-n6,
  .my-xxl-n6 {
    margin-bottom: -50px !important;
  }

  .ml-xxl-n6,
  .mx-xxl-n6 {
    margin-left: -50px !important;
  }

  .m-xxl-n7 {
    margin: -60px !important;
  }

  .mt-xxl-n7,
  .my-xxl-n7 {
    margin-top: -60px !important;
  }

  .mr-xxl-n7,
  .mx-xxl-n7 {
    margin-right: -60px !important;
  }

  .mb-xxl-n7,
  .my-xxl-n7 {
    margin-bottom: -60px !important;
  }

  .ml-xxl-n7,
  .mx-xxl-n7 {
    margin-left: -60px !important;
  }

  .m-xxl-n8 {
    margin: -70px !important;
  }

  .mt-xxl-n8,
  .my-xxl-n8 {
    margin-top: -70px !important;
  }

  .mr-xxl-n8,
  .mx-xxl-n8 {
    margin-right: -70px !important;
  }

  .mb-xxl-n8,
  .my-xxl-n8 {
    margin-bottom: -70px !important;
  }

  .ml-xxl-n8,
  .mx-xxl-n8 {
    margin-left: -70px !important;
  }

  .m-xxl-n9 {
    margin: -80px !important;
  }

  .mt-xxl-n9,
  .my-xxl-n9 {
    margin-top: -80px !important;
  }

  .mr-xxl-n9,
  .mx-xxl-n9 {
    margin-right: -80px !important;
  }

  .mb-xxl-n9,
  .my-xxl-n9 {
    margin-bottom: -80px !important;
  }

  .ml-xxl-n9,
  .mx-xxl-n9 {
    margin-left: -80px !important;
  }

  .m-xxl-auto {
    margin: auto !important;
  }

  .mt-xxl-auto,
  .my-xxl-auto {
    margin-top: auto !important;
  }

  .mr-xxl-auto,
  .mx-xxl-auto {
    margin-right: auto !important;
  }

  .mb-xxl-auto,
  .my-xxl-auto {
    margin-bottom: auto !important;
  }

  .ml-xxl-auto,
  .mx-xxl-auto {
    margin-left: auto !important;
  }
}

/* Padding Top */
.pt-25 {
  padding-top: 25px;
}

.pt-30 {
  padding-top: 30px;
}

.pt-35 {
  padding-top: 35px;
}

.pt-40 {
  padding-top: 40px;
}

.pt-45 {
  padding-top: 48px;
}

.pt-55 {
  padding-top: 55px;
}

.pt-50 {
  padding-top: 50px;
}

.pt-60 {
  padding-top: 60px;
}

.pt-65 {
  padding-top: 65px;
}

.pt-70 {
  padding-top: 70px;
}

.pt-75 {
  padding-top: 75px;
}

.pt-80 {
  padding-top: 80px;
}

.pt-90 {
  padding-top: 90px;
}

.pt-100 {
  padding-top: 100px;
}

@media (min-width: 992px) {
  .pt-100 {
    padding-top: 100px;
  }
}

/* Padding Bottom */
.pb-25 {
  padding-bottom: 25px;
}

.pb-30 {
  padding-bottom: 30px;
}

.pb-35 {
  padding-bottom: 35px;
}

.pb-40 {
  padding-bottom: 40px;
}

.pb-45 {
  padding-bottom: 45px;
}

.pb-50 {
  padding-bottom: 50px;
}

.pb-55 {
  padding-bottom: 55px;
}

.pb-60 {
  padding-bottom: 60px;
}

.pb-65 {
  padding-bottom: 65px;
}

.pb-70 {
  padding-bottom: 70px;
}

.pb-75 {
  padding-bottom: 75px;
}

.pb-80 {
  padding-bottom: 80px;
}

.pb-90 {
  padding-bottom: 90px;
}

.pb-100 {
  padding-bottom: 100px;
}

.pv-35 {
  padding-top: 35px;
  padding-bottom: 35px;
}

.pv-40 {
  padding-top: 40px;
  padding-bottom: 40px;
}

.pv-45 {
  padding-top: 45px;
  padding-bottom: 40px;
}

.pv-50 {
  padding-top: 50px;
  padding-bottom: 50px;
}

.pv-55 {
  padding-top: 55px;
  padding-bottom: 55px;
}

.pv-60 {
  padding-top: 60px;
  padding-bottom: 60px;
}

.pv-65 {
  padding-top: 65px;
  padding-bottom: 65px;
}

.pv-70 {
  padding-top: 70px;
  padding-bottom: 70px;
}

.pv-75 {
  padding-top: 75px;
  padding-bottom: 75px;
}

.pv-80 {
  padding-top: 80px;
  padding-bottom: 80px;
}

.pv-90 {
  padding-top: 90px;
  padding-bottom: 90px;
}

.pv-100 {
  padding-top: 100px;
  padding-bottom: 100px;
}

/*  margin top */
.mt-5px {
  margin-top: 5px;
}

.mt-10px {
  margin-top: 10px;
}

.mt-30 {
  margin-top: 30px;
}

.mt-35 {
  margin-top: 35px;
}

.mt-40 {
  margin-top: 40px;
}

.mt-50 {
  margin-top: 50px;
}

.mt-60 {
  margin-top: 60px;
}

.mt-70 {
  margin-top: 70px;
}

.mt-75 {
  margin-top: 75px;
}

.mt-80 {
  margin-top: 80px;
}

.mt-85 {
  margin-top: 85px;
}

.mt-90 {
  margin-top: 90px;
}

.mt-95 {
  margin-top: 95px;
}

.mt-100 {
  margin-top: 100px;
}

/* Margin Bottom */
.mb-5px {
  margin-bottom: 5px;
}

.mb-10px {
  margin-bottom: 10px;
}

.mb-30 {
  margin-bottom: 30px;
}

.mb-35 {
  margin-bottom: 35px;
}

.mb-40 {
  margin-bottom: 40px;
}

.mb-50 {
  margin-bottom: 50px;
}

.mb-60 {
  margin-bottom: 60px;
}

.mb-70 {
  margin-bottom: 70px;
}

.mb-75 {
  margin-bottom: 75px;
}

.mb-80 {
  margin-bottom: 80px;
}

.mb-85 {
  margin-bottom: 85px;
}

.mb-90 {
  margin-bottom: 90px;
}

.mb-95 {
  margin-bottom: 95px;
}

.mb-100 {
  margin-bottom: 100px;
}

/* Width */
.w-45 {
  width: 45px;
  height: auto;
}

/* Icon box width */
.iconbox-18 {
  width: 18px;
  height: 18px;
}

.iconbox-45 {
  width: 45px;
  height: 45px;
}

/* Weight */
.font-weight-medium {
  font-weight: 500;
}

.font-size-20 {
  font-size: 20px;
}

/* Vertical Position */
.absolute-middle {
  top: 50%;
  transform: translateY(-50%);
}

.absolute-bottom {
  top: auto;
  bottom: 0;
}

/* Over Flow Hidden */
.overflow-hidden {
  overflow: hidden;
}

/*===== REBOOT =====*/
* {
  outline: 0;
  margin: 0;
  padding: 0;
}

html,
* {
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

ul {
  margin: 0;
  padding: 0;
}

ul li {
  list-style-type: none;
}

hr {
  /* margin: 10px 0; */
  background: var(--border-color);
  opacity: 1;
}

p {
  font-weight: 400;
  margin-bottom: 0;
  font-size: 14px;
  /* line-height: 1.2; */
}

::selection {
  background-color: var(--admin-color);
  color: #ffffff;
}

button,
a {
  text-decoration: none;
  transition: all 0.3s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {

  button,
  a {
    transition: none;
  }
}

button:hover,
button:focus,
button:active,
a:hover,
a:focus,
a:active {
  box-shadow: none;
  outline: none;
  text-decoration: none;
}

button {
  background: transparent;
  border: none;
  cursor: pointer;
}

/*===== BADGE =====*/
.badge {
  text-transform: uppercase;
  color: #ffffff;
  padding-top: 0.75em;
}

.badge-sm {
  padding-top: 0.5em;
  padding-left: 0.6em;
  padding-right: 0.6em;
  font-size: 65%;
}

.badge {
  display: inline-block;
  padding: 0.5em 1em;
  font-size: 75%;
  font-weight: 500;
  line-height: 9px;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 10px;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .badge {
    transition: none;
  }
}

a.badge:hover,
a.badge:focus {
  text-decoration: none;
}

.badge:empty {
  display: none;
}

.btn .badge {
  position: relative;
  top: -1px;
}

.badge-pill {
  padding-right: 0.6em;
  padding-left: 0.6em;
  border-radius: 10rem;
}

.badge-primary {
  color: #ffffff;
  background-color: #4c84ff;
}

a.badge-primary:hover,
a.badge-primary:focus {
  color: #ffffff;
  background-color: #1961ff;
}

a.badge-primary:focus,
a.badge-primary.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(76, 132, 255, 0.5);
}

.badge-secondary {
  color: #ffffff;
  background-color: var(--bs-body-color);
}

a.badge-secondary:hover,
a.badge-secondary:focus {
  color: #ffffff;
  background-color: #6f7685;
}

a.badge-secondary:focus,
a.badge-secondary.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(138, 144, 157, 0.5);
}

.badge-success {
  color: #ffffff;
  background-color: #29cc97;
}

a.badge-success:hover,
a.badge-success:focus {
  color: #ffffff;
  background-color: #20a278;
}

a.badge-success:focus,
a.badge-success.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(41, 204, 151, 0.5);
}

.badge-info {
  color: #ffffff;
  background-color: #13cae1;
}

a.badge-info:hover,
a.badge-info:focus {
  color: #ffffff;
  background-color: #0fa0b2;
}

a.badge-info:focus,
a.badge-info.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(19, 202, 225, 0.5);
}

.badge-warning {
  color: #212529;
  background-color: #fec400;
}

a.badge-warning:hover,
a.badge-warning:focus {
  color: #212529;
  background-color: #cb9d00;
}

a.badge-warning:focus,
a.badge-warning.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(254, 196, 0, 0.5);
}

.badge-danger {
  color: #ffffff;
  background-color: #fe5461;
}

a.badge-danger:hover,
a.badge-danger:focus {
  color: #ffffff;
  background-color: #fe2132;
}

a.badge-danger:focus,
a.badge-danger.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(254, 84, 97, 0.5);
}

.badge-light {
  color: #212529;
  background-color: #f5f6fa;
}

a.badge-light:hover,
a.badge-light:focus {
  color: #212529;
  background-color: #d3d7e9;
}

a.badge-light:focus,
a.badge-light.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(245, 246, 250, 0.5);
}

.badge-dark {
  color: #ffffff;
  background-color: #1b223c;
}

a.badge-dark:hover,
a.badge-dark:focus {
  color: #ffffff;
  background-color: #0b0e19;
}

a.badge-dark:focus,
a.badge-dark.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(27, 34, 60, 0.5);
}

.badge-purple {
  color: #ffffff;
  background-color: #896def;
}

a.badge-purple:hover,
a.badge-purple:focus {
  color: #ffffff;
  background-color: #643fea;
}

a.badge-purple:focus,
a.badge-purple.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(137, 109, 239, 0.5);
}

/*===== BREDCRUMB =====*/
.breadcrumb-wrapper-2 {
  display: flex;
  justify-content: space-between;
}

.breadcrumb-wrapper-2 .breadcrumbs {
  margin-top: 0 !important;
}

.breadcrumb-wrapper {
  margin-bottom: 20px;
  margin-top: 20px;
}

.breadcrumb-wrapper h1,
.breadcrumb-wrapper .h1 {
  color: var(--text-color);
  font-size: 25px;
  font-weight: 500;
}

@media (max-width: 1499.98px) {

  .breadcrumb-wrapper h1,
  .breadcrumb-wrapper .h1 {
    font-size: 23px;
  }
}

@media (max-width: 1199.98px) {

  .breadcrumb-wrapper h1,
  .breadcrumb-wrapper .h1 {
    font-size: 20px;
  }
}

.breadcrumb-wrapper .btn {
  border-radius: 15px;
}

.breadcrumb-wrapper .btn:hover {
  /* background-color: #6d88c2; */
}

.breadcrumb-wrapper .breadcrumbs {
  margin-top: 5px;
}

.breadcrumb-wrapper .breadcrumbs span i {
  margin: 0 5px;
  font-size: 18px;
}

.breadcrumb-wrapper.breadcrumb-contacts {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
}

.breadcrumb-wrapper.breadcrumb-contacts .btn {
  /* margin: 10px 0; */
}

.breadcrumb .breadcrumb-item {
  font-size: 15px;
  text-transform: capitalize;
}

.breadcrumb .breadcrumb-item a {
  color: var(--bs-body-color);
  text-transform: capitalize;
}

.breadcrumb.breadcrumb-inverse {
  border-color: #4c84ff;
  background-color: rgba(228, 237, 255, 0.6);
}

.breadcrumb.breadcrumb-inverse .breadcrumb-item {
  color: var(--admin-color);
}

.breadcrumb.breadcrumb-inverse .breadcrumb-item:before {
  color: inherit;
}

.breadcrumb.breadcrumb-primary {
  border-color: var(--admin-color);
  background-color: var(--admin-color);
}

.breadcrumb.breadcrumb-primary .breadcrumb-item,
.breadcrumb.breadcrumb-primary .breadcrumb-item a {
  color: #ffffff;
}

.breadcrumb.breadcrumb-primary .breadcrumb-item:before {
  color: #ffffff;
}

.breadcrumb.breadcrumb-pink {
  border-color: #ee5588;
  background-color: #ee5588;
}

.breadcrumb.breadcrumb-pink .breadcrumb-item,
.breadcrumb.breadcrumb-pink .breadcrumb-item a {
  color: #ffffff;
}

.breadcrumb.breadcrumb-pink .breadcrumb-item:before {
  color: #ffffff;
}

.breadcrumb.breadcrumb-success {
  border-color: #34c997;
  background-color: #34c997;
}

.breadcrumb.breadcrumb-success .breadcrumb-item,
.breadcrumb.breadcrumb-success .breadcrumb-item a {
  color: #ffffff;
}

.breadcrumb.breadcrumb-success .breadcrumb-item:before {
  color: #ffffff;
}

.breadcrumb.breadcrumb-danger {
  border-color: #ec4a58;
  background-color: #ec4a58;
}

.breadcrumb.breadcrumb-danger .breadcrumb-item,
.breadcrumb.breadcrumb-danger .breadcrumb-item a {
  color: #ffffff;
}

.breadcrumb.breadcrumb-danger .breadcrumb-item:before {
  color: #ffffff;
}

.breadcrumb.breadcrumb-warning {
  border-color: #ddaa04;
  background-color: #ddaa04;
}

.breadcrumb.breadcrumb-warning .breadcrumb-item,
.breadcrumb.breadcrumb-warning .breadcrumb-item a {
  color: #ffffff;
}

.breadcrumb.breadcrumb-warning .breadcrumb-item:before {
  color: #ffffff;
}

.breadcrumb.breadcrumb-info {
  border-color: #24c4da;
  background-color: #24c4da;
}

.breadcrumb.breadcrumb-info .breadcrumb-item,
.breadcrumb.breadcrumb-info .breadcrumb-item a {
  color: #ffffff;
}

.breadcrumb.breadcrumb-info .breadcrumb-item:before {
  color: #ffffff;
}

.breadcrumb-item+.breadcrumb-item::before {
  content: "";
  top: 10px;
  font-size: 7px;
  color: var(--bs-body-color);
  position: relative;
  transform: rotate(45deg);
  font-family: "Material Design Icons";
}

/*===== BUTTONS =====*/
.btn {
  border-radius: 15px;
}

.btn.btn-square {
  border-radius: 0px;
}

.btn.btn-pill {
  border-radius: 100px;
}

.btn.btn-outline-primary {
  color: var(--admin-color);
  border-color: var(--admin-color);
}

.btn.btn-outline-secondary {
  color: var(--bs-body-color);
  border-color: var(--bs-body-color);
}

.btn.btn-outline-success {
  color: #34c997;
  border-color: #34c997;
}

.btn.btn-outline-info {
  color: #24c4da;
  border-color: #24c4da;
}

.btn.btn-outline-warning {
  color: #ddaa04;
  border-color: #ddaa04;
}

.btn.btn-outline-danger {
  color: #ec4a58;
  border-color: #ec4a58;
}

.btn.btn-primary {
  color: #ffffff;
  background-color: var(--admin-color);
  border-color: var(--admin-color);
}

.btn.btn-primary:hover,
.btn.btn-outline-primary:hover {
  color: #ffffff;
  background-color: var(--button-hover-color);
  border-color: var(--button-hover-color);
}

.btn.btn-secondary {
  color: #ffffff;
  background-color: var(--bs-body-color);
  border-color: var(--bs-body-color);
}

.btn.btn-secondary:hover,
.btn.btn-outline-secondary:hover {
  color: #ffffff;
  background-color: var(--bs-body-color);
  border-color: var(--bs-body-color);
}

.btn.btn-success {
  color: #ffffff;
  background-color: #34c997;
  border-color: #34c997;
}

.btn.btn-success:hover,
.btn.btn-outline-success:hover {
  color: #ffffff;
  background-color: #34c997;
  border-color: #34c997;
}

.btn.btn-info {
  color: #ffffff;
  background-color: #24c4da;
  border-color: #24c4da;
}

.btn.btn-info:hover,
.btn.btn-outline-info:hover {
  color: #ffffff;
  background-color: #24c4da;
  border-color: #24c4da;
}

.btn.btn-warning {
  color: #ffffff;
  background-color: #ddaa04;
  border-color: #ddaa04;
}

.btn.btn-warning:hover,
.btn.btn-outline-warning:hover {
  color: #ffffff;
  background-color: #ddaa04;
  border-color: #ddaa04;
}

.btn.btn-danger {
  color: #ffffff;
  background-color: #ec4a58;
  border-color: #ec4a58;
}

.btn.btn-danger:hover,
.btn.btn-outline-danger:hover {
  color: #ffffff;
  background-color: #ec4a58;
  border-color: #ec4a58;
}

.btn-block {
  display: block;
  width: 100%;
}

/* Button Social */
.btn-facebook,
.btn-twitter,
.btn-google-plus,
.btn-linkedin,
.btn-pinterest,
.btn-tumblr,
.btn-vimeo,
.btn-skype,
.btn-dropbox {
  position: relative;
  overflow: hidden;
  color: #ffffff;
  text-align: center;
  padding: 0.312rem 0.625rem;
  font-size: 15px;
  border: 1px solid transparent;
  line-height: 1.5;
  width: 40px;
  height: 40px;
}

.btn-facebook.text,
.btn-twitter.text,
.btn-google-plus.text,
.btn-linkedin.text,
.btn-pinterest.text,
.btn-tumblr.text,
.btn-vimeo.text,
.btn-skype.text,
.btn-dropbox.text {
  width: auto;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}

.btn-facebook.text i,
.btn-twitter.text i,
.btn-google-plus.text i,
.btn-linkedin.text i,
.btn-pinterest.text i,
.btn-tumblr.text i,
.btn-vimeo.text i,
.btn-skype.text i,
.btn-dropbox.text i {
  margin-right: 0.5rem;
}

.btn-facebook.btn-lg,
.btn-group-lg>.btn-facebook.btn,
.btn-twitter.btn-lg,
.btn-group-lg>.btn-twitter.btn,
.btn-google-plus.btn-lg,
.btn-group-lg>.btn-google-plus.btn,
.btn-linkedin.btn-lg,
.btn-group-lg>.btn-linkedin.btn,
.btn-pinterest.btn-lg,
.btn-group-lg>.btn-pinterest.btn,
.btn-tumblr.btn-lg,
.btn-group-lg>.btn-tumblr.btn,
.btn-vimeo.btn-lg,
.btn-group-lg>.btn-vimeo.btn,
.btn-skype.btn-lg,
.btn-group-lg>.btn-skype.btn,
.btn-dropbox.btn-lg,
.btn-group-lg>.btn-dropbox.btn {
  height: 50px;
  padding-left: 1.88rem;
  padding-right: 1.88rem;
}

.btn-facebook {
  background: #3b5998;
}

.btn-facebook.btn-outline {
  color: #3b5998;
  border-color: rgba(59, 89, 152, 0.6);
  background: transparent;
}

.btn-facebook:hover {
  color: #ffffff;
  background: #344e86;
}

.btn-facebook:hover.btn-outline {
  color: #ffffff;
  border-color: #3b5998;
}

.btn-facebook:hover::before {
  background: #2d4373;
}

.btn-twitter {
  background: #00aced;
}

.btn-twitter.btn-outline {
  color: #00aced;
  border-color: rgba(0, 172, 237, 0.6);
  background: transparent;
}

.btn-twitter:hover {
  color: #ffffff;
  background: #0099d4;
}

.btn-twitter:hover.btn-outline {
  color: #ffffff;
  border-color: #00aced;
}

.btn-skype {
  background: #00aff0;
}

.btn-skype.btn-outline {
  color: #00aff0;
  border-color: rgba(0, 175, 240, 0.6);
  background: transparent;
}

.btn-skype:hover {
  color: #ffffff;
  background: #00aff0;
}

.btn-skype:hover.btn-outline {
  color: #ffffff;
  border-color: #00aff0;
}

.btn-skype:hover::before {
  background: #0087ba;
}

.btn-linkedin {
  background: #4875b4;
}

.btn-linkedin.btn-outline {
  color: #4875b4;
  border-color: rgba(72, 117, 180, 0.6);
  background: transparent;
}

.btn-linkedin:hover {
  color: #ffffff;
  background: #4169a2;
}

.btn-linkedin:hover.btn-outline {
  color: #ffffff;
  border-color: #4875b4;
}

.btn-linkedin:hover::before {
  background: #395d90;
}

.btn-pinterest {
  background: #cb2027;
}

.btn-pinterest.btn-outline {
  color: #cb2027;
  border-color: rgba(203, 32, 39, 0.6);
  background: transparent;
}

.btn-pinterest:hover {
  color: #ffffff;
  background: #b51d23;
}

.btn-pinterest:hover.btn-outline {
  color: #ffffff;
  border-color: #cb2027;
}

.btn-pinterest:hover::before {
  background: #9f191f;
}

.btn-tumblr {
  background: #32506d;
}

.btn-tumblr.btn-outline {
  color: #32506d;
  border-color: rgba(50, 80, 109, 0.6);
  background: transparent;
}

.btn-tumblr:hover {
  color: #ffffff;
  background: #2a435c;
}

.btn-tumblr:hover.btn-outline {
  color: #ffffff;
  border-color: #32506d;
}

.btn-tumblr:hover::before {
  background: #22364a;
}

.btn-google-plus {
  background: #d34836;
}

.btn-google-plus.btn-outline {
  color: #d34836;
  border-color: rgba(211, 72, 54, 0.6);
  background: transparent;
}

.btn-google-plus:hover {
  color: #ffffff;
  background: #c43d2b;
}

.btn-google-plus:hover.btn-outline {
  color: #ffffff;
  border-color: #d34836;
}

.btn-google-plus:hover::before {
  background: #b03626;
}

.btn-dropbox {
  background: #007ee5;
}

.btn-dropbox.btn-outline {
  color: #007ee5;
  border-color: rgba(0, 126, 229, 0.6);
  background: transparent;
}

.btn-dropbox:hover {
  color: #ffffff;
  background: #0070cc;
}

.btn-dropbox:hover.btn-outline {
  color: #ffffff;
  border-color: #007ee5;
}

.btn-dropbox:hover::before {
  background: #0062b2;
}

.btn-vimeo {
  background: #aad450;
}

.btn-vimeo.btn-outline {
  color: #aad450;
  border-color: rgba(170, 212, 80, 0.6);
  background: transparent;
}

.btn-vimeo:hover {
  color: #ffffff;
  background: #a0cf3c;
}

.btn-vimeo:hover.btn-outline {
  color: #ffffff;
  border-color: #aad450;
}

.btn-vimeo:hover::before {
  background: #93c130;
}

.social-button .btn {
  margin: 2px;
  border-color: var(--border-color);
  line-height: 28px;
  color: var(--bs-body-color);
}

.social-button .btn:hover {
  border-color: var(--admin-color);
  color: #ffffff;
  background: var(--admin-color);
}

/*===== 4.12 DROPDOWN =====*/
.btn:focus,
.btn:active,
.btn.active,
.dropdown-toggle:focus,
.dropdown-toggle:active,
.dropdown-toggle.active {
  box-shadow: none !important;
}

.dropdown-toggle::after {
  border-right: 5px solid transparent;
  border-bottom: 0px;
  border-top: 6px solid;
  border-left: 5px solid transparent;
  vertical-align: middle;
}

/* Button Split */
.dropdown-toggle-split {
  padding: 0 0.75rem;
}

/*===== BUTTON LOADING =====*/
.btn.btn-ladda {
  display: inline-block;
  margin-bottom: 0;
  font-weight: 500;
  text-align: center;
  vertical-align: middle;
  touch-action: manipulation;
  cursor: pointer;
  white-space: nowrap;
  padding: auto 20px;
  font-size: auto;
  border-radius: 0px;
}

/*===== CARD =====*/
.card {
  /* width: 48%; */
  border-radius: var(--border-radius);
  /* -webkit-box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.03);
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.03); */
  border: 1px solid var(--border-color);
}

.cardWrapper.card-default .card-body {
  padding: 0;
}

.showLogin .card {
  border-radius: 0;
  box-shadow: none;
}

.card .card-header h2,
.card .card-header .h2 {
  color: var(--text-color);
  margin-bottom: 0.312rem;
  font-size: 20px;
  line-height: 1;
}

.card .card-img-overlay {
  z-index: 1;
}

.card-default .card-header {
  padding: 20px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  background-color: #ffffff;
  border-radius: 15px 15px 0 0;
}

@media (min-width: 1500px) {
  .card-default .card-header {
    /* padding-left: 30px; */
    /* padding-right: 30px; */
  }
}

.card-default .card-header .dropdown-menu {
  right: 0 !important;
  left: auto !important;
}

.card-default .card-header h2,
.card-default .card-header .h2 {
  color: var(--card-title-color);
  margin-bottom: 0;
  font-size: 18px;
  line-height: 1;
  font-weight: 500;
}

.card-default .card-header .tools {
  line-height: 15px;
}

.card-default .card-header .date-range-report {
  line-height: 17px;
}

@media (max-width: 575.98px) {
  .card-default .card-header .date-range-report {
    width: 100%;
    margin-top: 5px;
  }
}

/* .card-default .card-header-border-bottom {
  border-bottom: 1px solid var(--border-color);
} */

.card-default .card-header-border-bottom h2,
.card-default .card-header-border-bottom .h2 {
  margin-bottom: 0;
}

.card-default .card-body {
  padding: 15px 20px;
  overflow: auto;
}

.card-default .card-body p {
  line-height: 1.5;
  color: var(--bs-black-rgb);
}

.card-default .card-body .billingAddressWrapper p.mandatory_field {
  color: var(--card-title-color);
  font-weight: 500;
  font-size: 15px;
}

.card-default .card-footer {
  border-top: 1px solid var(--border-color);
  padding-left: 20px;
  padding-right: 20px;
  border-radius: 0 0 15px 15px;
}

.card-default .card-footer a {
  text-decoration: none;
}

.card-default .card-footer ul li {
  font-size: 13px;
}

.card-default.contact a {
  color: var(--bs-body-color);
}

.card-default.contact .contact-details .small {
  font-size: 0.875rem;
}

/*Card mini*/
.card-mini {
  border: 1px solid var(--border-color);
  border-radius: 15px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.03);
}

.card-mini .card-body {
  padding: 1.63rem;
}

.card-mini .card-body h2,
.card-mini .card-body .h2 {
  color: var(--text-color);
  font-size: 23px;
}

.card-mini .chartjs-wrapper {
  height: 100px;
}

.card-mini .card-footer {
  border-top: 1px solid var(--border-color);
}

/* Card Icon Info*/
.card-icon-info>i {
  color: var(--admin-color);
  font-size: 1.56rem;
  display: inline-block;
}

.card-icon-info>span {
  font-size: 0.88rem;
  display: inline-block;
}

/* Card table border none */
.card-table-border-none .card-header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  background-color: #ffffff;
}

.card-table-border-none .card-header h2,
.card-table-border-none .card-header .h2 {
  color: var(--text-color);
  margin-bottom: 0;
  font-size: 20px;
  line-height: 1;
}

.card-table-border-none .card-header-border-bottom {
  background-color: #ffffff;
  padding-top: 28px;
  padding-bottom: 20px;
  border-bottom: 1px solid var(--border-color);
}

.card-table-border-none .card-header-border-bottom h2,
.card-table-border-none .card-header-border-bottom .h2 {
  margin-bottom: 0;
}

.card-table-border-none .card-body {
  padding: 20px;
}

@media (min-width: 1500px) {
  .card-table-border-none .card-body {
    padding: 3.125rem 3.125rem;
  }
}

.card-table-border-none .card-footer {
  border-top: 1px solid var(--border-color);
  padding-left: 20px;
  padding-right: 20px;
}

@media (min-width: 1500px) {
  .card-table-border-none .card-footer {
    padding-left: 3.125rem;
    padding-right: 3.125rem;
  }
}

.card-table-border-none tbody td,
.card-table-border-none thead th {
  border: none;
}

.card-table-border-none tbody td {
  font-size: 14px;
  padding-top: 30px;
}

.Sold-card-table tbody td,
.Sold-card-table thead th {
  border-bottom: 1px solid var(--border-color);
}

.Sold-card-table tbody td {
  padding: 15px 0;
  font-size: 15px;
}

.card-deck {
  display: flex;
  flex-flow: row wrap;
  margin-right: -15px;
  margin-left: -15px;
}

.card-deck .card {
  flex: 1 0;
  margin-right: 15px;
  margin-bottom: 0;
  margin-left: 15px;
}

/*===== ACCORDION CARD =====*/
.accordion .card {
  border: 0px;
  margin-bottom: 0.94rem;
}

.accordion .card-header {
  padding: 0;
  background-color: transparent;
  border: none;
}

.accordion .card-header .btn,
.accordion .card-header a {
  display: block;
  height: auto;
  position: relative;
  line-height: 1.5;
  padding: 1.56rem;
  width: 100%;
  text-align: left;
  text-decoration: none !important;
  color: var(--text-color);
  border-radius: calc(.25rem - 1px) calc(.25rem - 1px) 0 0;
  white-space: unset;
  transition: all 0.3s 0.2s ease-in;
}

.noteContent{
  font-size: 10px;
  font-weight: 300;
}

@media (prefers-reduced-motion: reduce) {

  .accordion .card-header .btn,
  .accordion .card-header a {
    transition: none;
  }
}

.accordion .card-header .btn:after,
.accordion .card-header a:after {
  position: absolute;
  color: var(--bs-body-color);
  font-size: 15px;
  right: 25px;
  top: 50%;
  transform: translateY(-50%);
}

.accordion .card-header .btn:hover,
.accordion .card-header .btn:focus,
.accordion .card-header a:hover,
.accordion .card-header a:focus {
  text-decoration: none !important;
}

.accordion .card-header .btn[aria-expanded=false]:after,
.accordion .card-header a[aria-expanded=false]:after {
  content: "";
  font-family: "Material Design Icons";
}

.accordion .card-header .btn[aria-expanded=true],
.accordion .card-header a[aria-expanded=true] {
  box-shadow: 0px 0px 19px rgba(229, 230, 235, 0.6) !important;
  color: var(--admin-color);
  border-bottom: 1px solid var(--border-color);
}

.accordion .card-header .btn[aria-expanded=true]:after,
.accordion .card-header a[aria-expanded=true]:after {
  content: "";
  font-family: "Material Design Icons";
  color: var(--admin-color);
}

.accordion .card-body {
  box-shadow: 0px 7px 19px rgba(229, 230, 235, 0.6);
}

.accordion-shadow .card {
  box-shadow: 0px 7px 19px rgba(229, 230, 235, 0.6);
}

.accordion-shadow .card-header .btn[aria-expanded=false]:after,
.accordion-shadow .card-header a[aria-expanded=false]:after {
  opacity: 1;
}

.accordion-shadow .card-header .btn[aria-expanded=true],
.accordion-shadow .card-header a[aria-expanded=true] {
  box-shadow: none !important;
}

.accordion-shadow .card-header .btn[aria-expanded=true]:after,
.accordion-shadow .card-header a[aria-expanded=true]:after {
  content: "";
  font-family: "Material Design Icons";
  color: var(--admin-color);
}

.accordion-shadow .card-body {
  box-shadow: none !important;
}

.accordion-bordered .card {
  border: 1px solid var(--border-color) !important;
  border-radius: 0;
}

.accordion-bordered .card-header .btn[aria-expanded=false]:after,
.accordion-bordered .card-header a[aria-expanded=false]:after {
  opacity: 1;
}

.accordion-bordered .card-header .btn[aria-expanded=true],
.accordion-bordered .card-header a[aria-expanded=true] {
  box-shadow: none !important;
}

.accordion-bordered .card-body {
  box-shadow: none !important;
}

.accordion-header-border-bottom .card-header {
  border-bottom: 1px solid var(--border-color);
}

.accordion-header-border-bottom .card-header .btn,
.accordion-header-border-bottom .card-header a {
  padding: 1.56rem 0;
  border-bottom: none;
}

.accordion-header-border-bottom .card-header .btn:after,
.accordion-header-border-bottom .card-header a:after {
  right: 0;
}

.accordion-header-border-bottom .card-header .btn[aria-expanded=false]:after,
.accordion-header-border-bottom .card-header a[aria-expanded=false]:after {
  opacity: 1;
}

.accordion-header-border-bottom .card-header .btn[aria-expanded=true],
.accordion-header-border-bottom .card-header a[aria-expanded=true] {
  border-bottom: none;
  box-shadow: none !important;
}

.accordion-header-border-bottom .card-header .btn[aria-expanded=true]:after,
.accordion-header-border-bottom .card-header a[aria-expanded=true]:after {
  content: "";
  font-family: "Material Design Icons";
  color: var(--admin-color);
}

.accordion-header-border-bottom .card-body {
  padding-left: 0;
  padding-right: 0;
  box-shadow: none !important;
}

.accordion .card-header {
  padding: 0 !important;
  background-color: transparent;
  border: none;
}

.full-calendar {
  position: relative;
}

.full-calendar .fc-header-toolbar {
  margin: 30px;
  line-height: 0;
}

@media (min-width: 1500px) {
  .full-calendar .fc-header-toolbar {
    margin: 30px 50px;
  }
}

.full-calendar .fc-toolbar {
  flex-direction: column;
  align-items: flex-start;
}

@media (min-width: 768px) {
  .full-calendar .fc-toolbar {
    flex-flow: wrap;
    align-items: center;
  }
}

.full-calendar .fc-left {
  margin-bottom: 25px;
}

@media (min-width: 768px) {
  .full-calendar .fc-left {
    margin-bottom: 0;
  }
}

.full-calendar .fc-left h2,
.full-calendar .fc-left .h2 {
  color: var(--text-color);
  font-size: 1.25125rem;
  text-transform: capitalize;
  margin-left: 0;
}

.full-calendar .fc-view-container {
  background-color: #ffffff;
  border-radius: 0.25rem;
  border: 1px solid #ddd;
  margin: 30px;
}

@media (min-width: 1500px) {
  .full-calendar .fc-view-container {
    margin: 30px 50px 50px;
  }
}

.full-calendar thead tr {
  background-color: transparent;
  box-shadow: none;
}

.full-calendar .fc-day-header {
  padding: 10px 0;
}

.full-calendar .fc-day-header span {
  color: #000;
  font-size: 1rem;
}

.full-calendar .fc-time,
.full-calendar .fc-title {
  color: #ffffff;
}

.full-calendar .fc-day-number {
  color: #000;
}

.full-calendar .fc-time {
  font-weight: normal;
}

.full-calendar thead tr th:first-child {
  border-top-left-radius: 10px;
}

.full-calendar .fc-event {
  border: 1px solid transparent;
}

.full-calendar .fc-event,
.full-calendar .fc-event-dot {
  background-color: var(--admin-color);
  cursor: pointer;
}

.full-calendar .fc-button-primary {
  background-color: #ffffff;
  border-color: #ddd;
}

.full-calendar .fc-button-primary:focus {
  box-shadow: none !important;
}

.full-calendar .fc-button-primary:hover {
  background-color: transparent;
  border-color: #ddd;
}

.error-message{
  text-align: center;
  color: var(--bs-red);
}

.full-calendar .fc-icon {
  margin-top: -3px;
}

.full-calendar .fc-icon-chevron-left,
.full-calendar .fc-icon-chevron-right {
  color: var(--bs-body-color);
}

.full-calendar .fc-today-button {
  color: #ffffff;
  background-color: var(--admin-color);
  border-color: var(--admin-color);
  text-transform: uppercase;
}

.full-calendar .fc-today-button:focus {
  box-shadow: none !important;
}

.full-calendar .fc-today-button:hover {
  color: var(--admin-color);
  background-color: #ffffff;
  border-color: var(--admin-color);
}

.full-calendar .fc-button:disabled {
  opacity: 1;
}

.full-calendar .fc-button-primary:not(:disabled).fc-button-active,
.full-calendar .fc-button-primary:not(:disabled):active {
  background-color: transparent;
  border-color: #ddd;
}

.full-calendar .fc td,
.full-calendar .fc th {
  border: 1px solid transparent;
}

.full-calendar .fc td {
  border-right: 1px solid #ddd;
}

.full-calendar .fc td:last-child {
  border-right-color: transparent;
}

.full-calendar .fc-row .fc-bg {
  border-top: 1px solid #ddd !important;
}

.full-calendar tbody tr {
  border-bottom: 1px solid #ddd !important;
}

.full-calendar .fc th {
  border: 1px solid #ddd;
}

.full-calendar .fc-past-event {
  background-color: #bfbfc3;
}

.full-calendar .fc-current-event .fc-time,
.full-calendar .fc-current-event .fc-title {
  font-size: 13px;
}

.full-calendar .fc-today .fc-day-number {
  background-color: var(--admin-color);
  color: #ffffff;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
}

.fc-datepicker-header {
  cursor: pointer;
}

.fc-unthemed td.fc-today {
  background-color: rgba(136, 170, 243, 0.3);
}

.ui-icon {
  top: -4px;
  left: -7px;
}

/*===== ALERT =====*/
label {
  /* text-transform: capitalize; */
}

p,
li,
span {
  letter-spacing: 0.02rem;
}

.alert {
  font-size: 15px;
  font-weight: 500;
  color: var(--text-color);
}

.alert.alert-highlighted {
  color: #ffffff;
}

.alert.alert-primary {
  background-color: #ffdada;
  border-color: #c5d6fc;
}

.alert.alert-secondary {
  background-color: #cacaca;
  border-color: #cacaca;
}

.alert.alert-success {
  background-color: #bffde9;
  border-color: #bffde9;
}

.alert.alert-danger {
  background-color: #ffc3c8;
  border-color: #ffc3c8;
}

.alert.alert-warning {
  background-color: #faeec6;
  border-color: #faeec6;
}

.alert.alert-info {
  background-color: #b8f5fc;
  border-color: #b8f5fc;
}

.alert.alert-light {
  background-color: #f5f6fa;
  border-color: #f5f6fa;
  color: var(--text-color);
}

.alert.alert-dark {
  background-color: #3d3d3d;
  border-color: #3d3d3d;
}

.alert.alert-outlined {
  background-color: transparent;
  color: #3d3d3d;
}

/* Notification List */
.notifications-list li a {
  display: block;
  color: var(--bs-body-color);
  font-size: 0.88rem;
  padding: 0.625rem 1.25rem;
}

.notifications-list li:hover {
  /* background-color: #fdfdfd; */
}

/*===== ALERT =====*/
.bg-primary {
  background-color: var(--admin-color) !important;
}

.bg-success {
  background-color: #34c997 !important;
}

.bg-warning {
  background-color: #ddaa04 !important;
}

.bg-info {
  background-color: #24c4da !important;
}

.bg-danger {
  background-color: #ec4a58 !important;
}

label {
  /* text-transform: capitalize; */
  display: inline-block;
  margin-bottom: 0.5rem;
}

.text-right {
  text-align: right !important;
}

@media (max-width: 1199.98px) {
  .ec-cust-card {
    margin-bottom: 24px;
  }
}

.ec-cust-card tbody td {
  padding-top: 22px;
}

.ec-cust-card tbody td small,
.ec-cust-card tbody td .small {
  color: #999;
}

.ec-card-top-prod .ec-pos {
  position: relative;
}

.ec-card-top-prod .ec-price {
  margin-top: 10px;
}

.ec-card-top-prod .ec-price span {
  margin-right: 10px;
  font-weight: 500;
}

.ec-card-top-prod .ec-price del {
  color: #999;
  font-size: 13px;
}

.ec-card-top-prod .sale {
  position: absolute;
  top: 0;
  right: 15px;
  color: #999 !important;
  font-size: 13px;
}

.media-image img {
  width: 100%;
  border-radius: 15px;
}

.table .tbl-thumb {
  width: 50px;
  border-radius: 15px;
}

.rounded-circle {
  border-radius: 15px !important;
}

.border-right {
  border-right: 1px solid #e5e9f2;
}

.p-b-15 {
  padding-bottom: 24px;
}

.p-20 {
  padding: 20px;
}

.dash-card .card-body span {
  position: absolute;
  right: 20px;
  bottom: 25px;
  font-size: 30px;
  border-radius: 15px;
  width: 50px;
  height: 50px;
  text-align: center;
  background: var(--admin-color);
  color: #ffffff;
}

.profile-img {
  width: 50px !important;
}

/* ===== CARET =====*/
.caret {
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 0.125rem;
  vertical-align: middle;
  border-top: 4px dashed;
  border-top: 4px solid;
  border-right: 4px solid transparent;
  border-left: 4px solid transparent;

}

/* ===== Form Control =====*/
.form-control {
  border-radius: 5px;
}

/*===== CAROUSEL =====*/
.carousel-indicators {
  bottom: 0;
}

@media (min-width: 768px) {
  .carousel-indicators {
    bottom: -5px;
  }
}

.carousel-indicators.indicator-success li {
  background-color: rgba(52, 201, 151, 0.2);
}

.carousel-indicators.indicator-success li.active {
  background-color: #34c997;
}

.carousel-indicators li {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #ffffff;
  background-clip: padding-box;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  transition: opacity 0.6s ease;
}

.carousel-caption {
  bottom: 40px;
}

/* Carousel Testimonial */
.carousel-testimonial .carousel-control-next,
.carousel-testimonial .carousel-control-prev {
  color: red;
}

.carousel-testimonial .carousel-control-prev,
.carousel-testimonial .carousel-control-next {
  width: auto;
  z-index: 55;
  color: var(--bs-body-color);
}

.carousel-testimonial .carousel-control-prev .carousel-control-prev-icon {
  color: var(--bs-body-color);
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

/*===== CHART =====*/
@media (max-width: 575.98px) {
  #user-acquisition .mb-6 {
    margin-bottom: 80px !important;
  }
}

.world-data-chart {
  padding-left: 20px;
  padding-right: 20px;
}

@media (min-width: 1200px) {
  .world-data-chart.border-bottom {
    border-bottom: 0 !important;
    border-right: 1px solid var(--border-color);
  }
}

#regions_purchase>div>div {
  margin: 0 auto 30px auto;
}

@media (min-width: 1200px) {
  #linechart {
    min-height: 280px;
  }
}

@media (min-width: 1200px) {
  #doChart {
    min-height: 210px;
  }
}

#polar,
#radar {
  min-height: 200px;
}

@media (min-width: 768px) {

  #polar,
  #radar {
    min-height: 230px;
  }
}

@media (min-width: 1200px) {

  #polar,
  #radar {
    min-height: 270px;
    min-width: 100%;
  }
}

[polar-data-height] {
  height: 455px;
}

[radar-data-height] {
  height: 408px;
}

@media (min-width: 1200px) {
  #currentUser {
    min-height: 283px;
    height: 283px !important;
  }
}

@media (min-width: 1200px) {
  #activity {
    min-height: 280px;
  }
}

#deviceChart {
  min-height: 200px;
}

@media (min-width: 768px) {
  #deviceChart {
    min-height: 230px;
  }
}

/* Coutom Lenged*/
.customLegend li {
  display: inline-block;
  margin-right: 20px;
  margin-top: 20px;
}

.customLegend li span {
  display: inline-block;
  width: 12px;
  height: 12px;
  margin-right: 0.312rem;
  border-radius: 1.56rem;
}

.chat {
  border-radius: 0.25rem;
}

.chat .chat-left-side .chat-search {
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}

.chat .chat-left-side #chat-left-content {
  height: 373px !important;
}

@media (min-width: 992px) {
  .chat .chat-left-side #chat-left-content {
    height: calc(100vh - 320px) !important;
  }
}

@media (min-width: 1200px) {
  .chat .chat-left-side #chat-left-content {
    height: calc(100vh - 350px) !important;
  }
}

@media (min-width: 768px) {
  .chat .chat-left-side .last-msg {
    width: 300px;
  }
}

@media (min-width: 992px) {
  .chat .chat-left-side .last-msg {
    width: 125px;
  }
}

@media (min-width: 1500px) {
  .chat .chat-left-side .last-msg {
    width: 220px;
  }
}

.chat .chat-right-side {
  border-left: 1px solid var(--border-color);
}

.chat .chat-right-side .chat-right-content {
  padding: 1.5rem;
}

.chat .chat-right-side #chat-right-content {
  height: 373px !important;
}

@media (min-width: 992px) {
  .chat .chat-right-side #chat-right-content {
    height: calc(100vh - 395px) !important;
  }
}

@media (min-width: 1200px) {
  .chat .chat-right-side #chat-right-content {
    height: calc(100vh - 405px) !important;
  }
}

pre {
  border-left: 4px solid var(--admin-color);
  padding: 1.25rem 0.94rem;
  background: rgba(0, 0, 0, 0.05);
  border-radius: 0.19rem;
}

pre code {
  background: transparent;
  font-size: 1rem;
  color: var(--text-color);
}

.pre-code,
code {
  font-family: Menlo, Monaco, "Courier New", Courier, monospace;
  font-size: 1rem;
  background: rgba(0, 0, 0, 0.05);
  padding: 0.19rem 0.625rem;
  margin: 0 0.125rem;
  color: var(--text-color);
}

.pre-code {
  padding: 1.25rem 0.94rem !important;
}

/* Dropdown Menu */
.dropdown-menu {
  border: 1px solid var(--border-color);
  right: 0;
}

.sign-inup .container {
  position: relative;
  z-index: 2;
}

.sign-inup .form-height {
  height: 100vh;
}

@media (max-width: 575.98px) {
  .sign-inup .form-height {
    height: 100%;
  }
}

@media (max-height: 600px) {
  .sign-inup .form-height {
    height: 100%;
  }
}

.sign-inup .form-height-login {
  height: 100vh;
}

@media (max-width: 575.98px) {
  .sign-inup .form-height-login {
    height: 100%;
  }
}

@media (max-height: 480px) {
  .sign-inup .form-height-login {
    height: 100%;
  }
}

/*===== REGISTRATION =====*/
.sign-inup .card {
  overflow: hidden;
}

@media (max-width: 991.98px) {
  .sign-inup .card {
    max-width: 430px;
  }
}

@media (max-width: 767.98px) {
  .sign-inup .card .p-5 {
    padding: 20px 15px 15px 15px !important;
  }
}

.sign-inup .card .ec-brand {
  border: none;
}

.sign-inup .card form .control {
  color: #777777;
}

.sign-inup .card form button {
  width: 130px;
  margin: auto;
}

.sign-inup .text-dark {
  text-align: center;
  margin-bottom: 25px !important;
}

.sign-inup .ec-brand span {
  width: 100%;
  padding: 0;
  display: block;
  text-align: center;
  border: none;
}

.sign-inup .ec-brand span img {
  margin-bottom: 0;
}

.sign-inup .sign-upp {
  text-align: center;
}

.sign-inup .ec-brand span img {
  width: 100px;
  max-width: 100px;
}

.sign-upp {
  text-align: center;
}

/* Separator */
.separator {
  border-top: 1px solid var(--border-color);
}

/*===== DATERANGEPICKER =====*/
.daterangepicker {
  box-shadow: 0px 5px 18px 0px rgba(229, 233, 242, 0.5);
}

.daterangepicker .ranges ul {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
  width: auto;
}

.daterangepicker .ranges li {
  padding: 0.5rem 1.25rem;
  font-size: 0.875rem;
}

.daterangepicker .ranges li.active {
  background-color: transparent;
  color: var(--admin-color);
}

.daterangepicker:before,
.daterangepicker:after {
  display: none;
}

.daterangepicker .drp-buttons .btn {
  padding: 0 1.25rem;
}

.daterangepicker td.in-range {
  background-color: rgba(136, 170, 243, 0.1);
}

.daterangepicker td.available:hover {
  background-color: var(--admin-color);
  color: #ffffff;
}

.daterangepicker .ranges li:hover {
  background-color: transparent;
  color: var(--admin-color);
}

/* Ragnge Date Picker */
.date-range-report span {
  cursor: pointer;
}

.date-range-report span:after {
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 1em;
  content: "";
  border-right: 5px solid transparent;
  border-bottom: 0px;
  border-top: 6px solid;
  border-left: 5px solid transparent;
  vertical-align: middle;
}

.date-range::placeholder {
  color: #495057;
}

/*===== FORMS =====*/
.form-control:focus {
  box-shadow: none;
}

.form-group,
.input-group {
  /* padding: 0px; */
  /* margin-bottom: 1.25rem; */
}

.form-group label,
.input-group label {
  /* color: #56606e; */
  font-size: 14px;
  margin-bottom: 12px;
  font-weight: 500;
}

.form-group label {
  color: var(--gray-text-color);
}

.form-group .form-control,
.input-group .form-control {
  font-size: 14px;
  /* height: 35px; */
  padding: 0.5rem 0.5rem;
  border-color: var(--border-color);
  margin-bottom: 18px;
}

.form-group .form-control.input-lg,
.input-group .form-control.input-lg {
  font-size: 1.06rem;
  padding: 0.9375rem 1.06rem;
}

.form-group .form-control.input-sm,
.input-group .form-control.input-sm {
  font-size: 0.8125rem;
  padding: 0.38rem 1.06rem;
}

.form-group .input-group-prepend,
.input-group .input-group-prepend {
  margin-right: -1px;
}

.form-group .input-group-prepend,
.form-group .input-group-append,
.input-group .input-group-prepend,
.input-group .input-group-append {
  display: flex;
}

.form-pill .form-group .form-control {
  border-radius: 100px;
}

.horizontal-form .form-check {
  padding-left: 0;
}

.horizontal-form .form-check label {
  font-weight: 400;
  font-size: 0.875rem;
}

.form-row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -5px;
  margin-left: -5px;
}

.form-row>[className*=col-] {
  padding-right: 5px;
  padding-left: 5px;
}

/* Form components - checkbox and radios */
.control {
  display: block;
  position: relative;
  padding-left: 1.56rem;
  color: var(--text-color);
  margin-bottom: 0.9375rem;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 500;
}

.control input {
  position: absolute;
  z-index: -1;
  opacity: 0;
}

.control-indicator {
  position: absolute;
  top: 2px;
  left: 0;
  height: 15px;
  width: 15px;
  background: #e1e2e5;
  border: 1px solid #ccc;
  border-radius: 0.125rem;
}

.control-radio .control-indicator {
  border-radius: 50%;
}

.control input:disabled~.control-indicator {
  background: #e1e2e5;
  opacity: 0.6;
  pointer-events: none;
  border: 1px solid #ccc;
}

.control-indicator:after {
  content: "";
  position: absolute;
  display: none;
}

.control input:checked~.control-indicator:after {
  display: block;
}

.control-checkbox .control-indicator:after {
  left: 4px;
  top: 1px;
  width: 5px;
  height: 8px;
  background: transparent !important;
  border: solid var(--text-color);
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.control-checkbox input:disabled~.control-indicator:after {
  border-color: #7b7b7b;
}

.control-radio .control-indicator:after {
  left: 4px;
  top: 4px;
  height: 5px;
  width: 5px;
  border-radius: 50%;
  background: var(--text-color);
}

.control-radio input:disabled~.control-indicator:after {
  background: #7b7b7b;
}

/* Contextual Style */
.checkbox-primary .control-indicator,
.radio-primary .control-indicator {
  background: var(--admin-color);
  border-color: var(--admin-color);
}

.checkbox-primary .control-indicator::after,
.radio-primary .control-indicator::after {
  color: #ffffff;
  border-color: #ffffff;
  background: #ffffff;
}

.checkbox-warning .control-indicator,
.radio-warning .control-indicator {
  background: #ddaa04;
  border-color: #ddaa04;
}

.checkbox-warning .control-indicator::after,
.radio-warning .control-indicator::after {
  color: #ffffff;
  border-color: #ffffff;
  background: #ffffff;
}

.checkbox-danger .control-indicator,
.radio-danger .control-indicator {
  background: #ec4a58;
  border-color: #ec4a58;
}

.checkbox-danger .control-indicator::after,
.radio-danger .control-indicator::after {
  color: #ffffff;
  border-color: #ffffff;
  background: #ffffff;
}

.checkbox-success .control-indicator,
.radio-success .control-indicator {
  background: #34c997;
  border-color: #34c997;
}

.checkbox-success .control-indicator::after,
.radio-success .control-indicator::after {
  color: #ffffff;
  border-color: #ffffff;
  background: #ffffff;
}

.checkbox-info .control-indicator,
.radio-info .control-indicator {
  background: #24c4da;
  border-color: #24c4da;
}

.checkbox-info .control-indicator::after,
.radio-info .control-indicator::after {
  color: #ffffff;
  border-color: #ffffff;
  background: #ffffff;
}

/* All Outline Contextual Style */
.control.outlined .control-indicator {
  background: transparent !important;
}

.control.outlined input:disabled~.control-indicator {
  background: transparent !important;
}

.control.outlined.checkbox-primary .control-indicator,
.control.outlined.radio-primary .control-indicator {
  background: transparent;
  border-color: var(--admin-color);
}

.control.outlined.checkbox-primary .control-indicator::after,
.control.outlined.radio-primary .control-indicator::after {
  background: var(--admin-color);
  border-color: var(--admin-color);
  color: #ffffff;
}

.control.outlined.checkbox-warning .control-indicator,
.control.outlined.radio-warning .control-indicator {
  background: transparent;
  border-color: #ddaa04;
}

.control.outlined.checkbox-warning .control-indicator::after,
.control.outlined.radio-warning .control-indicator::after {
  background: #ddaa04;
  border-color: #ddaa04;
  color: #ffffff;
}

.control.outlined.checkbox-danger .control-indicator,
.control.outlined.radio-danger .control-indicator {
  background: transparent;
  border-color: #ec4a58;
}

.control.outlined.checkbox-danger .control-indicator::after,
.control.outlined.radio-danger .control-indicator::after {
  background: #ec4a58;
  border-color: #ec4a58;
  color: #ffffff;
}

.control.outlined.checkbox-success .control-indicator,
.control.outlined.radio-success .control-indicator {
  background: transparent;
  border-color: #34c997;
}

.control.outlined.checkbox-success .control-indicator::after,
.control.outlined.radio-success .control-indicator::after {
  background: #34c997;
  border-color: #34c997;
  color: #ffffff;
}

.control.outlined.checkbox-info .control-indicator,
.control.outlined.radio-info .control-indicator {
  background: transparent;
  border-color: #24c4da;
}

.control.outlined.checkbox-info .control-indicator::after,
.control.outlined.radio-info .control-indicator::after {
  background: #24c4da;
  border-color: #24c4da;
  color: #ffffff;
}

.custom-select {
  width: auto;
  margin-left: 0.625rem;
}

/* Form components- input groups */
.input-group>.input-group-prepend>.input-group-text,
.input-group>.input-group-append>.input-group-text {
  background-color: #fdfdfd;
  border-color: var(--border-color);
}

.input-group>.input-group-prepend>.input-group-text.bg-primary,
.input-group>.input-group-append>.input-group-text.bg-primary {
  border-color: var(--admin-color);
  color: #ffffff;
}

.input-group>.input-group-prepend>.input-group-text.bg-warning,
.input-group>.input-group-append>.input-group-text.bg-warning {
  border-color: #ddaa04;
  color: #ffffff;
}

.input-group>.input-group-prepend>.input-group-text.bg-danger,
.input-group>.input-group-append>.input-group-text.bg-danger {
  border-color: #ec4a58;
  color: #ffffff;
}

.input-group>.input-group-prepend>.input-group-text.bg-success,
.input-group>.input-group-append>.input-group-text.bg-success {
  border-color: #34c997;
  color: #ffffff;
}

.input-group>.input-group-prepend>.input-group-text .control,
.input-group>.input-group-append>.input-group-text .control {
  margin-bottom: 1.25rem;
}

.input-group>.input-group-prepend .form-check,
.input-group>.input-group-append .form-check {
  padding-left: 0;
}

.input-group>.input-group-prepend .form-check .form-check-label,
.input-group>.input-group-append .form-check .form-check-label {
  margin-bottom: 0;
}

.input-group>.input-group-prepend .form-check .radio-custom-label:before,
.input-group>.input-group-prepend .form-check .checkbox-custom-label:before,
.input-group>.input-group-append .form-check .radio-custom-label:before,
.input-group>.input-group-append .form-check .checkbox-custom-label:before {
  margin-right: 0;
  background: #ffffff;
}

.input-group>.input-group-prepend .form-check .radio-custom:checked+.radio-custom-label:before,
.input-group>.input-group-prepend .form-check .checkbox-custom:checked+.checkbox-custom-label:before,
.input-group>.input-group-append .form-check .radio-custom:checked+.radio-custom-label:before,
.input-group>.input-group-append .form-check .checkbox-custom:checked+.checkbox-custom-label:before {
  border: 1px solid #d4d5db;
  line-height: 1rem;
}

.input-group>.input-group-prepend .form-check .radio-custom:checked+.radio-custom-label:before,
.input-group>.input-group-append .form-check .radio-custom:checked+.radio-custom-label:before {
  font-size: 0.5rem;
}

/* Form components- Validation */
.invalid-feedback,
.valid-feedback {
  font-size: 90%;
}

/* Form components- Advanced */
.select2-container--default .select2-selection--multiple {
  border-color: var(--border-color);
}

.select2-container--default.select2-container--focus .select2-selection--multiple {
  border-color: rgba(136, 170, 243, 0.5);
}

.select2-container--default .select2-selection--multiple .select2-selection__choice {
  border-color: #4c84ff;
  background-color: rgba(76, 132, 255, 0.051);
  color: #4c84ff;
}

.select2-container--default .select2-selection--multiple .select2-selection__choice__remove {
  color: #4c84ff;
  padding-right: 0.31rem;
  margin-right: 0.31rem;
  border-right: 1px solid #4c84ff;
}

.form-group .custom-file {
  position: relative;
  display: inline-block;
  width: 100%;
  height: calc(1.5em + 1.18rem + 2px);
  margin-bottom: 0;
}

.form-group .custom-file .custom-file-input {
  position: relative;
  z-index: 2;
  width: 100%;
  height: calc(1.5em + 1.18rem + 2px);
  margin: 0;
  overflow: hidden;
  opacity: 0;
}

.form-group .custom-file .form-group label,
.form-group .custom-file .input-group label {
  color: #1b223c;
  font-size: 15px;
}

.form-group .custom-file .custom-file-label {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1;
  height: calc(1.5em + 1.18rem + 2px);
  width: 80px;
  padding: 0.59rem 1rem;
  overflow: hidden;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #ffffff;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}

.form-group .custom-file .custom-file-label::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 3;
  display: block;
  height: calc(1.5em + 1.18rem);
  padding: 0.59rem 1rem;
  line-height: 1.5;
  color: #495057;
  content: "Browse";
  background-color: #e9ecef;
  border-left: inherit;
  border-radius: 0 0.25rem 0.25rem 0;
}

/* Media Small */
.media {
  display: flex;
  align-items: flex-start;
}

.media-message {
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

.media-message img {
  width: 40px;
}

.media-message .status {
  position: absolute;
  bottom: 0;
  right: 0px;
  width: 12px;
  height: 12px;
  border: 2px solid transparent;
  border-radius: 50%;
}

.media-message .status.active,
.media-message .status.away {
  border-color: #ffffff;
}

.media-message .status.active {
  background-color: #34c997;
}

.media-message .status.away {
  background-color: #ddaa04;
}

.media-message .title {
  color: var(--text-color);
  font-size: 0.9375rem;
  margin-bottom: 0;
}

.media-message .last-msg {
  width: 180px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  margin-bottom: 0;
  color: var(--bs-body-color);
}

@media (min-width: 768px) {
  .media-message .last-msg {
    width: 550px;
  }
}

@media (min-width: 992px) {
  .media-message .last-msg {
    width: 125px;
  }
}

@media (min-width: 1200px) {
  .media-message .last-msg {
    width: 220px;
  }
}

.media-message .date {
  text-align: right;
  font-size: 12px;
  color: var(--bs-body-color);
}

.media-message:hover {
  background-color: rgba(233, 236, 239, 0.5);
  text-decoration: none;
}

.media-message.media-active {
  background-color: var(--admin-color);
}

.media-message.media-active .title,
.media-message.media-active .last-msg,
.media-message.media-active .date {
  color: #ffffff;
}

.media-message.event-active {
  background-color: rgba(233, 236, 239, 0.5);
}

.media-notification .last-msg {
  width: 200px;
}

.media-chat {
  margin-bottom: 1.5rem;
}

.media-chat .content {
  background-color: rgba(233, 236, 239, 0.5);
  padding: 0.5rem 1.25rem;
  border-radius: 0.25rem;
  margin-bottom: 1.25rem;
}

.media-chat .heading-title a {
  color: var(--text-color);
}

.media-chat .heading-title a:hover {
  color: var(--admin-color);
  text-decoration: none;
}

.media-chat .title {
  color: var(--admin-color);
  font-size: 1rem;
}

.media-chat .message {
  background-color: rgba(233, 236, 239, 0.5);
  padding: 0.5rem 1.25rem;
  border-radius: 0.25rem;
  margin-bottom: 0.25rem;
  color: var(--text-color);
}

.media-chat .date-time {
  font-size: 10px;
  padding-left: 1.25rem;
}

.media-chat.media-left img {
  width: 50px;
}

.media-chat.media-right {
  text-align: right;
  justify-content: flex-end;
}

.media-chat.media-right img {
  width: 40px;
}

.media-chat:hover {
  text-decoration: none;
}

.media-chat.media-chat-header {
  border-bottom: 1px solid var(--border-color);
  border-top: 1px solid var(--border-color);
  padding: 1.125rem 1.5rem;
}

@media (min-width: 992px) {
  .media-chat.media-chat-header {
    border-top: 0;
  }
}

.media-chat.media-chat-header img {
  width: 60px;
}

.media-chat.media-chat-header .dropdown-toggle {
  color: var(--bs-body-color);
  text-transform: uppercase;
}

.media-chat.media-chat-header .dropdown-toggle.icon-burger-mini {
  font-size: 1.5rem;
  position: relative;
}

.media-chat.media-chat-header .dropdown-toggle.icon-burger-mini:after {
  display: none;
}

.media-chat.media-chat-header .dropdown-toggle.icon-burger-mini:before {
  font-family: "Material Design Icons";
  content: "";
}

.media-chat.media-chat-header .dropdown-menu {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  box-shadow: 0px 5px 18px 0px rgba(229, 233, 242, 0.5);
  min-width: auto;
}

.media-chat.media-chat-header .dropdown-menu .dropdown-item {
  padding: 0.3125rem 1.25rem;
}

.media-chat.media-chat-header .dropdown-menu .dropdown-item a {
  font-size: 0.875rem;
  color: var(--bs-body-color);
  text-transform: capitalize;
}

.media-chat.media-chat-header .dropdown-menu .dropdown-item:hover {
  background-color: transparent;
}

.media-chat.media-chat-header .dropdown-menu .dropdown-item:hover a {
  color: var(--admin-color);
}

.media-body {
  flex: 1 1;
}

/*===== FOOTER =====*/
.main-footer {
  background: #ffffff;
  padding: 15px;
  color: #444444;
  border-top: 1px solid var(--border-color);
}

.copyright {
  padding: 15px;
  border-top: 1px solid var(--border-color);
}

.copyright p {
  font-weight: 300;
  text-align: center;
  font-size: 14px;
}

/* Body */
#body {
  position: relative;
  height: 100%;
  overflow-x: hidden;
}

/* Wrapper */
.wrapper {
  display: flex;
  align-items: stretch;
  flex: 1 1 auto;
  width: 100%;
  min-height: 100vh;
}

/* Page Wrapper */
.ec-page-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.ec-content-wrapper {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
}

/* Content */
.content {
  margin-right: auto;
  margin-left: auto;
  padding: 30px;
  padding-top: 0px;
  width: 100%;
  position: relative;
}

@media (max-width: 767.98px) {
  .content {
    padding: 30px 15px;
  }
}

.no-gutters>[className*=col-] {
  padding-right: 0;
  padding-left: 0;
}

/* Meterial Desing Codes */
.mdi-show-code code {
  display: inline-block;
  vertical-align: middle;
  background: rgba(138, 144, 157, 0.1);
  padding: 3px 5px;
  border-radius: 3px;
  border: 1px solid var(--border-color);
}

.mdi-show-code i.mdi {
  vertical-align: middle;
  border-radius: 4px;
  display: inline-block;
}

.mdi-show-code i.mdi.dark-demo {
  background: #333;
}

.mdi-show-code .note {
  color: #999;
  font-size: 14px;
  padding: 0 20px 5px 20px;
}

.icons {
  column-count: 1;
  column-gap: 20px;
}

@media (min-width: 992px) {
  .icons {
    column-count: 2;
  }
}

@media (min-width: 1200px) {
  .icons {
    column-count: 3;
  }
}

.icons div {
  line-height: 3em;
}

.icons div span {
  cursor: pointer;
  font-size: 14px;
  text-overflow: ellipsis;
  display: inline-block;
  max-width: calc(100% - 90px);
  overflow: hidden;
  vertical-align: middle;
  white-space: nowrap;
}

.icons div code:hover,
.icons div span:hover,
.icons div i:hover {
  color: var(--admin-color);
}

.icons div code:hover {
  border-color: var(--admin-color);
}

.icons div code {
  border: 1px solid var(--border-color);
  width: 65px;
  margin-left: 2px;
  margin-right: 4px;
  border-radius: 4px;
  display: inline-block;
  vertical-align: middle;
  text-align: center;
  line-height: 24px;
  cursor: pointer;
}

.icons div i {
  display: inline-block;
  width: 32px;
  height: 24px;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  line-height: 24px;
}

.icons .mdi:before {
  font-size: 24px;
}

div.copied {
  position: fixed;
  top: 100px;
  left: 50%;
  width: 200px;
  text-align: center;
  color: #ffffff;
  background-color: #34c997;
  padding: 10px 15px;
  border-radius: 4px;
  margin-left: -100px;
}

.icons-list .fa-icon {
  font-weight: 900;
  font-size: 20px;
  margin: 5px 10px;
  line-height: 21px;
  padding: 10px 0;
  width: 30px;
  text-align: center;
}

.icons-list .fa-span {
  background: #f1f1f1;
  padding: 5px 10px;
  border-radius: 5px;
  cursor: pointer;
}

/*===== LIST GROUP =====*/
.list-group .list-group-item {
  padding: 1.38rem;
}

.list-styled>li {
  list-style-type: disc;
  margin-left: 0.94rem;
  margin-right: 0.94rem;
}

.list-group-item-secondary {
  color: var(--bs-body-color);
  background-color: #cacaca;
}

.list-group-item-success {
  color: #34c997;
  background-color: #bffde9;
}

.list-group-item-danger {
  color: #ec4a58;
  background-color: #ffc3c8;
}

.list-group-item-warning {
  color: #ddaa04;
  background-color: #faeec6;
}

.list-group-item-info {
  color: #24c4da;
  background-color: #b8f5fc;
}

/* ======== MAP ======== */
.map-container {
  height: 400px;
  width: 100%;
  margin: 0;
  padding: 0;
}

.info-title {
  color: var(--text-color);
  padding: 0.31rem;
}

/* ===== Vector Map Zoom In And Zoom Out Button ===== */
.jvectormap-zoomin,
.jvectormap-zoomout {
  background-color: var(--admin-color);
}

/* ======== VECTOR MAP ======== */
/* Vector Map World 2 */
.vector-map-world-2 {
  padding-bottom: 0 !important;
  height: 350px;
}

@media (min-width: 992px) {

  #modal-add-contact .modal-lg,
  #modal-contact .modal-lg {
    max-width: 755px;
  }
}

@media (min-width: 1200px) {

  #modal-add-contact .modal-lg,
  #modal-contact .modal-lg {
    margin-left: auto;
    margin-right: auto;
  }
}

#modal-add-contact .modal-header .btn-close-icon,
#modal-add-contact .modal-header .btn-edit-icon,
#modal-add-contact .modal-header .btn-dots-icon,
#modal-contact .modal-header .btn-close-icon,
#modal-contact .modal-header .btn-edit-icon,
#modal-contact .modal-header .btn-dots-icon {
  font-size: 1.125rem;
  padding: 0 5px;
  color: var(--bs-body-color);
}

.modal .modal-content {
  border-radius: 30px;
}

#modal-add-member .modal-header .btn-close-icon,
#modal-add-member .modal-header .btn-edit-icon,
#modal-add-member .modal-header .btn-dots-icon {
  font-size: 1.125rem;
  padding: 0 5px;
  color: var(--bs-body-color);
}

@media (min-width: 768px) {
  #modal-add-member .last-msg {
    width: 200px;
  }
}

@media (min-width: 992px) {
  #modal-add-member .last-msg {
    width: 125px;
  }
}

@media (min-width: 1200px) {
  #modal-add-member .last-msg {
    width: 220px;
  }
}

/* ======================================
  --> 2. NAVBAR
========================================= */
.ec-main-header {
  position: fixed;
  top: 0;
  left: 0%;
  right: 0;
  z-index: 15;
  margin-bottom: 0;
  padding: 0;
  transition: box-shadow 0.2s linear;
}

/* Navbar */
.navbar {
  margin-bottom: 0;
  border: none;
  min-height: 70px;
  border-radius: 0;
  padding: 0;
  border-bottom: 1px solid var(--border-color);
  transition: margin-left 0.3s ease-in-out;
  background-color: #ffffff;
  /* Search Form */
  /* Navbar Nav */
  /* Navbar Collapse */
  /* Navbar Right */
}

@media (prefers-reduced-motion: reduce) {
  .navbar {
    transition: none;
  }
}

.navbar .sidebar-offcanvas-toggle,
.navbar .sidebar-toggle {
  background-color: transparent;
  background-image: none;
  color: #bbb;
  font-size: 30px;
  padding: 0 24px;
  border: 0px;
  cursor: pointer;
}

.navbar .sidebar-offcanvas-toggle:before,
.navbar .sidebar-toggle:before {
  content: "神";
  font-family: "Material Design Icons";
}

.navbar .navbar-toggler i {
  color: var(--bs-body-color);
}

.navbar .search-form {
  width: 400px;
  position: relative;
  margin-right: auto;
  padding-left: 0;
  background-color: #f7f7f7;
  border-radius: 15px;
}

@media (min-width: 1500px) {
  .navbar .search-form {
    width: auto;
  }
}

@media (max-width: 1199.98px) {
  .navbar .search-form {
    width: 300px;
  }
}

@media (max-width: 767.98px) {
  .navbar .search-form {
    width: 70%;
    margin: 0 auto 15px auto;
    order: 2;
  }
}

@media (max-width: 575.98px) {
  .navbar .search-form {
    width: 100%;
    margin: 0 24px 15px 24px;
    order: 2;
  }
}

.navbar .search-form .input-group {
  margin-bottom: 0;
}

.navbar .search-form .btn {
  background: transparent;
  border: none;
  color: var(--bs-body-color);
  font-size: 20px;
  padding: 0px 10px;
}

.navbar .search-form .btn:active,
.navbar .search-form .btn:focus {
  outline: none;
  box-shadow: none;
}

.navbar .search-form input.form-control {
  border: none;
  background: transparent;
  padding: 0.5rem 15px;
}

/* @media (min-width: 1500px) {
  .navbar .search-form input.form-control {
    min-width: 500px;
  }
} */
.navbar .search-form #search-results-container {
  width: 100%;
  background: #fff;
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  box-shadow: 1px 2px 5px #e5e9f2;
}

.navbar .search-form #search-results-container li {
  padding: 20px 30px;
}

.navbar .search-form #search-results-container li .link {
  font-size: 15px;
}

.navbar .navbar-nav {
  flex-wrap: nowrap;
  padding-left: 1rem;
  padding-right: 1rem;
}

@media (min-width: 768px) {
  .navbar .navbar-nav {
    align-items: center;
    padding-left: 0;
    padding-right: 0;
  }
}

@media (min-width: 1200px) {
  .navbar .navbar-nav {
    padding-left: 20px;
    padding-right: 20px;
  }
}

.navbar .navbar-nav .nav-item {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

@media (min-width: 992px) {
  .navbar .navbar-nav .nav-item {
    padding-top: 1.28px;
    padding-bottom: 1.28px;
  }
}

.navbar .navbar-nav .nav-item .nav-link {
  color: var(--bs-body-color);
}

.navbar .navbar-collapse {
  order: 1;
  border-top: 1px solid var((--border-color));
}

@media (min-width: 992px) {
  .navbar .navbar-collapse {
    order: 0;
    border-top: none;
  }
}

.navbar .navbar-right .navbar-nav {
  flex-direction: row;
  align-items: center;
}

@media (min-width: 992px) {
  .navbar .navbar-right .navbar-nav {
    padding-left: 0;
    padding-right: 0;
  }
}

@media (min-width: 1200px) {
  .navbar .navbar-right .navbar-nav {
    padding-left: 0;
    padding-right: 0;
  }
}

@media (max-width: 767.98px) {
  .navbar .navbar-right .navbar-nav {
    margin: 15px 0;
  }
}

.navbar .navbar-right .navbar-nav li>.dropdown-menu {
  transition: all 0.3s ease-in-out;
  position: absolute;
  top: 60px;
  left: auto;
  right: 0;
  border-color: var(--border-color);
  border-radius: 15px;
  overflow: hidden;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.1);
}

@media (max-width: 575.98px) {
  .navbar .navbar-right .navbar-nav li>.dropdown-menu {
    right: -130px;
  }
}

@media (min-width: 992px) {
  .navbar .navbar-right .navbar-nav .user-menu {
    text-align: right;
  }
}

.navbar .navbar-right .navbar-nav .user-menu .user-image {
  width: 40px;
  border-radius: 15px;
}

.navbar .navbar-right .navbar-nav .user-menu .dropdown-toggle {
  font-size: 15px;
  padding: 0 15px;
  transition: all 0.3s ease-in-out;
}

.navbar .navbar-right .navbar-nav .user-menu .dropdown-toggle:after {
  border-top: 6px solid;
  border-left-width: 6px;
  border-right-width: 6px;
  vertical-align: middle;
  color: #bbb;
}


.navbar .navbar-right .navbar-nav .notifications-menu>.dropdown-menu {
  width: 275px;
  right: -75px;
}


.navbar .navbar-right .navbar-nav .right-sidebar-2-menu i {
  font-size: 24px;
  color: #bbb;
  line-height: 30px;
}

.navbar .dropdown-menu {
  width: 255px;
  padding: 0 0 0 0;
  margin: 0;
  top: 100%;
  border-color: transparent;
}

.navbar .dropdown-menu li.dropdown-header img {
  width: 50px;
  vertical-align: top;
  border-radius: 15px;
  margin-right: 0.63rem;
}

.navbar .dropdown-menu li.dropdown-header small,
.navbar .dropdown-menu li.dropdown-header .small {
  font-size: 13px;
  display: block;
  color: var(--bs-black-rgb);
}

.navbar .dropdown-menu>li .link {
  display: block;
  color: var(--bs-black-rgb);
  font-size: 14px;
  padding: 10px 15px;
  cursor: pointer;
}

.navbar .dropdown-menu>li .link:hover {
  background-color: #f0f0f0;
}

.navbar .dropdown-menu>li .link>i {
  width: 18px;
  margin-right: 10px;
  display: inline-block;
  text-align: center;
  font-size: 17px;
  line-height: 15px;
}

.navbar .dropdown-menu li.dropdown-footer {
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  border-top-right-radius: 0;
  border-top-left-radius: 0;
  background-color: #ffffff;
  border-top: 1px solid var(--border-color);
  margin-top: 10px;
}

.navbar .dropdown-menu li.dropdown-footer>a {
  padding: 15px 20px;
}

.navbar .dropdown-item.active,
.navbar .dropdown-item:active {
  color: var(--bs-body-color);
  background-color: transparent;
}

@media (max-width: 767px) {

  .ec-main-header .logo,
  .ec-main-header .navbar {
    width: 100%;
  }

  .ec-main-header .navbar {
    margin: 0;
  }
}

/* Header Fix and Header Static For Mobile */
.ec-header-fixed .ec-page-wrapper {
  padding-top: 4.4rem;
}

@media (max-width: 767.98px) {
  .ec-header-fixed .ec-page-wrapper {
    padding-top: 7.4rem;
  }
}

.ec-header-fixed.ec-header-static-mobile .ec-main-header {
  position: relative;
}

@media (min-width: 768px) {
  .ec-header-fixed.ec-header-static-mobile .ec-main-header {
    position: fixed;
  }
}

.ec-header-fixed.ec-header-static-mobile .ec-page-wrapper {
  padding-top: 0;
}

@media (min-width: 768px) {
  .ec-header-fixed.ec-header-static-mobile .ec-page-wrapper {
    padding-top: 4.875rem;
  }
}

/* Header Static and Header Fixed for Mobile */
.ec-header-static.ec-header-fixed-mobile .ec-main-header {
  position: fixed !important;
}

@media (min-width: 768px) {
  .ec-header-static.ec-header-fixed-mobile .ec-main-header {
    position: relative !important;
  }
}

.ec-header-static.ec-header-fixed-mobile .ec-page-wrapper {
  padding-top: 4.875rem;
}

@media (min-width: 992px) {
  .navbar .dropdown-menu {
    border-color: var(--border-color);
  }
}

.navbar .dropdown-menu li.dropdown-header {
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
  background-color: #ffffff;
  border-bottom: 1px solid var(--border-color);
  padding-bottom: 15px;
  padding: 15px;
  color: var(--text-color);
  font-size: 15px;
  margin-bottom: 0.63rem;
}


@media (min-width: 768px) {
  .ec-header-static.ec-header-fixed-mobile .ec-page-wrapper {
    padding-top: 0;
  }
}

/*  Header Dark Version */
.ec-header-dark .navbar {
  background: #1a283e;
}

.ec-header-dark .navbar .search-form .input-group input,
.ec-header-dark .navbar .search-form .input-group .btn {
  background-color: var(--text-color);
  color: #fff !important;
}

.ec-header-dark .navbar .search-form .input-group input::placeholder,
.ec-header-dark .navbar .search-form .input-group .btn::placeholder {
  color: #eee;
}

.ec-header-dark .navbar .sidebar-toggle {
  border-color: rgba(255, 255, 255, 0.2);
  color: #fff;
}

.ec-header-dark .navbar .navbar-right .navbar-nav .user-menu .dropdown-toggle:after {
  color: #fff;
}

.ec-header-dark .navbar .navbar-right .navbar-nav .notifications-menu .dropdown-toggle {
  color: #fff;
}

.ec-header-dark .navbar .navbar-right .navbar-nav .right-sidebar-2-menu i {
  color: #fff;
}

.ec-header-dark .navbar .sidebar-offcanvas-toggle {
  border-color: rgba(255, 255, 255, 0.2);
}

.ec-header-dark .navbar .search-form .btn,
.ec-header-dark .navbar .search-form .input-group input.form-control {
  color: #b7c0cd;
}

.ec-header-dark .navbar .navbar-right .navbar-nav .notifications-menu .dropdown-toggle {
  border-left: 1px solid var(--text-color) !important;
  border-right: 1px solid var(--text-color) !important;
}

.ec-header-dark .navbar .navbar-right .navbar-nav .user-menu .dropdown-toggle>span {
  color: var(--bs-body-color);
}

.ec-header-dark .navbar .navbar-right .navbar-nav .right-sidebar-2-menu {
  border-color: rgba(255, 255, 255, 0.2);
}

/* light Header */
.ec-header-light .navbar {
  background-color: #ffffff;
}

.ec-header-light .navbar .sidebar-toggle {
  border-color: var(--border-color);
}

.ec-header-light .navbar .sidebar-offcanvas-toggle {
  border-color: var(--border-color);
}

.ec-header-light .navbar .search-form .btn,
.ec-header-light .navbar .search-form .input-group input.form-control {
  color: var(--bs-body-color);
}

.ec-header-light .navbar .navbar-right .navbar-nav .notifications-menu .dropdown-toggle {
  border-left: 1px solid var(--border-color) !important;
  border-right: 1px solid var(--border-color) !important;
}

.ec-header-light .navbar .navbar-right .navbar-nav .user-menu .dropdown-toggle>span {
  color: var(--text-color);
}

/* Cusmtom Dropdown */
.custom-dropdown .custom-dropdown-toggler .icon {
  font-size: 28px;
  color: #212529;
}

.custom-dropdown .custom-dropdown-toggler .badge-xs {
  position: absolute;
  top: 4px;
  right: 8px;
  background-color: var(--bs-body-color);
  min-width: 18px;
  min-height: 18px;
  color: #ffffff;
  font-size: 12px;
  font-weight: 700;
  padding: 3px 5px;
}

/* Notification */
.dropdown-notify {
  transition: all 0.3s ease-in-out;
  display: none;
  width: 320px;
  position: absolute;
  top: 50px;
  border-radius: 5px;
  background-color: #ffffff;
  transform: translateX(-50%);
  right: 0;
  left: auto;
  border-radius: 15px;
  overflow: hidden;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.1);
  transform: translateX(0);
  z-index: 15;
}

@media (max-width: 575.98px) {
  .dropdown-notify {
    width: 300px;
    right: -67px;
    left: auto;
  }
}

/*===== PAGINATION =====*/
.pagination {
  justify-content: center;
}

.pagination .page-item.active .page-link {
  z-index: 3;
  color: #fff;
}

.pagination .page-item:first-child .page-link {
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}

.pagination .page-item:last-child .page-link {
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
}

.pagination .page-link {
  padding: 5px 10px;
  line-height: 17px;
  color: var(--bs-body-color);
}

.pagination .page-link:focus {
  box-shadow: none;
}

.pagination-flat .page-item .page-link {
  border: 0px;
}

.pagination-flat-rounded .page-item .page-link {
  border-radius: 100%;
}

.pagination-seperated .page-item .page-link {
  padding: 5px 10px;
  margin: 0 3px;
  border-radius: 0;
}

@media (max-width: 575.98px) {
  .pagination-seperated .page-item .page-link {
    padding: 5px 7px;
  }
}

.pagination-seperated .page-item:last-child .page-link {
  margin-right: 0;
}

.pagination-seperated .page-item:first-child .page-link {
  margin-left: 0;
}

.pagination-seperated-rounded .page-item .page-link {
  border-radius: 10px;
}

.border-rounded .page-item:last-child .page-link {
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
}

.border-rounded .page-item:first-child .page-link {
  margin-left: 0;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}

/*===== CIRCLE PROGRESS =====*/
.circle {
  position: relative;
  text-align: center;
}

.circle .circle-content {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  transform: translate(-50%, -50%);
}

.circle .circle-content h6,
.circle .circle-content .h6,
.circle .circle-content strong {
  font-size: 12px;
}

.circle.circle-lg h6,
.circle.circle-lg .h6 {
  font-size: 45px;
}

.circle.circle-lg h6 span,
.circle.circle-lg .h6 span {
  font-size: 35px;
}

/*===== TOOLTIP =====*/
/*Popver Tooltip*/
.popover {
  background-color: #ffffff;
}

.popover .arrow {
  position: absolute;
  display: block;
  width: 1rem;
  height: 0.5rem;
  margin: 0 0.3rem;
}

.popover .arrow::before,
.popover .arrow::after {
  position: absolute;
  display: block;
  /* content: ""; */
  border-color: transparent;
  border-right-color: transparent;
  border-style: solid;
}

.popover-header {
  background-color: transparent;
  border-bottom: 0px;
  padding-bottom: 0px;
  color: var(--text-color);
  font-size: 1.125rem;
}

.popover-body {
  color: var(--bs-body-color);
}

.bs-popover-right>.arrow,
.bs-popover-auto[x-placement^=right]>.arrow {
  left: calc(-0.5rem - 1px);
  width: 0.5rem;
  height: 1rem;
  margin: 0.3rem 0;
}

.bs-popover-right>.arrow::before,
.bs-popover-auto[x-placement^=right]>.arrow::before {
  left: 0;
  border-width: 0.5rem 0.5rem 0.5rem 0;
  border-right-color: rgba(0, 0, 0, 0.25);
}

.bs-popover-right>.arrow::after,
.bs-popover-auto[x-placement^=right]>.arrow::after {
  left: 1px;
  border-width: 0.5rem 0.5rem 0.5rem 0;
  border-right-color: #ffffff;
}

.bs-popover-top>.arrow,
.bs-popover-auto[data-popper-placement^=top]>.arrow,
.bs-popover-auto[x-placement^=top]>.arrow {
  bottom: calc(-0.5rem - 1px);
}

.bs-popover-top>.arrow::before,
.bs-popover-auto[data-popper-placement^=top]>.arrow::before,
.bs-popover-auto[x-placement^=top]>.arrow::before {
  bottom: 0;
  border-width: 0.5rem 0.5rem 0;
  border-top-color: rgba(0, 0, 0, 0.25);
}

.bs-popover-top>.arrow::after,
.bs-popover-auto[data-popper-placement^=top]>.arrow::after,
.bs-popover-auto[x-placement^=top]>.arrow::after {
  bottom: 1px;
  border-width: 0.5rem 0.5rem 0;
  border-top-color: #ffffff;
}

.bs-popover-left>.arrow,
.bs-popover-auto[x-placement^=left]>.arrow {
  right: calc(-0.5rem - 1px);
  width: 0.5rem;
  height: 1rem;
  margin: 0.3rem 0;
}

.bs-popover-left>.arrow::before,
.bs-popover-auto[x-placement^=left]>.arrow::before {
  right: 0;
  border-width: 0.5rem 0 0.5rem 0.5rem;
  border-left-color: rgba(0, 0, 0, 0.25);
}

.bs-popover-left>.arrow::after,
.bs-popover-auto[x-placement^=left]>.arrow::after {
  right: 1px;
  border-width: 0.5rem 0 0.5rem 0.5rem;
  border-left-color: #ffffff;
}

.bs-popover-bottom>.arrow,
.bs-popover-auto[data-popper-placement^=bottom]>.arrow,
.bs-popover-auto[x-placement^=bottom]>.arrow {
  top: calc(-0.5rem - 1px);
}

.bs-popover-bottom>.arrow::before,
.bs-popover-auto[data-popper-placement^=bottom]>.arrow::before,
.bs-popover-auto[x-placement^=bottom]>.arrow::before {
  top: 0;
  border-width: 0 0.5rem 0.5rem 0.5rem;
  border-bottom-color: rgba(0, 0, 0, 0.25);
}

.bs-popover-bottom>.arrow::after,
.bs-popover-auto[data-popper-placement^=bottom]>.arrow::after,
.bs-popover-auto[x-placement^=bottom]>.arrow::after {
  top: 1px;
  border-width: 0 0.5rem 0.5rem 0.5rem;
  border-bottom-color: #ffffff;
}

/* Tooltip Inner */
.tooltip-inner {
  background-color: #ffffff;
  border: 1px solid #ebebeb;
  padding: 0.56rem 1.125rem;
  color: var(--text-color);
  color: var(--text-color);
  font-size: 15px;
  font-weight: 500;
}

.bs-tooltip-auto[x-placement^=top] .arrow::before,
.bs-tooltip-top .arrow::before,
.bs-tooltip-auto[data-popper-placement^=top] .arrow::before {
  top: 0px;
  border-top-color: var(--border-color);
}

.bs-tooltip-auto[x-placement^=right] .arrow::before,
.bs-tooltip-right .arrow::before {
  right: 0px;
  border-right-color: var(--border-color);
}

.bs-tooltip-auto[x-placement^=bottom] .arrow::before,
.bs-tooltip-bottom .arrow::before,
.bs-tooltip-auto[data-popper-placement^=bottom] .arrow::before {
  bottom: 0px;
  border-bottom-color: var(--border-color);
}

.bs-tooltip-auto[x-placement^=left] .arrow::before,
.bs-tooltip-left .arrow::before {
  left: 0px;
  border-left-color: var(--border-color);
}

.tooltip .arrow::after {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-tooltip-auto[x-placement^=top] .arrow::after,
.bs-tooltip-top .arrow::after,
.bs-tooltip-auto[data-popper-placement^=top] .arrow::after {
  z-index: 0;
  top: -1px;
  border-width: 0.4rem 0.4rem 0;
  border-top-color: #fff;
}

.bs-tooltip-auto[x-placement^=right] .arrow::after,
.bs-tooltip-right .arrow::after {
  z-index: 0;
  right: -1px;
  border-width: 0.4rem 0.4rem 0.4rem 0;
  border-right-color: #fff;
}

.bs-tooltip-auto[x-placement^=bottom] .arrow::after,
.bs-tooltip-bottom .arrow::after,
.bs-tooltip-auto[data-popper-placement^=bottom] .arrow::after {
  border-width: 0 0.4rem 0.4rem;
  z-index: 0;
  bottom: -1px;
  border-bottom-color: #fff;
}

.bs-tooltip-auto[x-placement^=left] .arrow::after,
.bs-tooltip-left .arrow::after {
  border-width: 0.4rem 0.4rem;
  z-index: 0;
  left: -1px;
  border-left-color: #fff;
}

/* Vector Map Tooltip */
.jvectormap-tip {
  background-color: #ffffff;
  color: var(--bs-body-color);
  padding-left: 0.625rem;
  padding-right: 0.625rem;
  border-radius: 0.31rem;
}

/* ======================================
--> 3. SIDEBAR NAVIGATION
========================================= */

/* width */
::-webkit-scrollbar {

  width: 5px;
  height: 100%;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px white;
  border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #ced4da;
  border-radius: 10px;
}

/* Handle on hover
::-webkit-scrollbar-thumb:hover {
  background: #b30000; 
} */

.ec-navigation {
  height: calc(100% - 45px);
  overflow-y: auto;
}

.ec-left-sidebar {
  position: fixed;
  display: flex;
  flex-direction: column;
  transform: translateX(-251px);
  top: 0%;
  bottom: 0;
}

@media (min-width: 768px) {
  .ec-left-sidebar {
    transform: translateX(0);
    width: 250px;
    position: relative;
    z-index: 1;
  }
}

.sidebar {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100%;
  z-index: 1050;
  min-height: 100vh;
  position: relative;
}

.sidebar .sidebar-inner {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  margin-top: 10px;
}

@media (min-width: 768px) {
  .sidebar .sidebar-inner {
    margin-top: 20px;
  }
}

@media (min-width: 1200px) {
  .sidebar .sidebar-inner {
    margin-top: 10px;
  }
}

.sidebar .sidebar-inner>li {
  position: relative;
}

.sidebar .sidebar-inner>li>span {
  padding: 15px 25px;
  line-height: 20px;
  color: var(--secondary-color);
  display: block;
  text-decoration: none;
  font-weight: 400;
  white-space: nowrap;
}

.sidebar .sidebar-inner .collapse.show {
  width: 100%;
  /* display: block; */
}

.sidebar .sidebar-inner>li.active>span {
  position: relative;
  z-index: 10;
  color: #ffffff;
}

.sidebar .sidebar-inner>li.active>a:before {
  opacity: 1;
}

.sidebar .sidebar-inner>li>span:before {
  position: absolute;
  content: "";
  left: 5px;
  top: 0;
  width: 5px;
  height: 100%;
  /* border-radius: 5px; */
  background: var(--admin-color);
  opacity: 0;
}

.sidebar .sidebar-inner .section-title {
  padding: 1.25rem 1.56rem 0;
  font-weight: 700;
  text-transform: uppercase;
  font-size: 0.75rem;
  color: var(--text-color);
  letter-spacing: 1.2px;
}

.sidebar .sidebar-inner .sub-menu .section-title {
  padding: 1.25rem 0.94rem 0.625rem;
}

/* App brand */
.ec-brand {
  position: relative;
  display: block;
  background-color: transparent;
}

.ec-brand span {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 70px;
  line-height: 75px;
  width: 250px;
  border-right: 1px solid var(--border-color);
  transition: width 0.3s ease-in-out;
  padding-left: 1.56rem;

}

@media (prefers-reduced-motion: reduce) {
  .ec-brand span {
    transition: none;
  }
}

@media (min-width: 768px) {
  .ec-brand span {
    overflow: hidden;
  }
}

.ec-brand span img {
  max-width: 30px;
  vertical-align: middle;
}

.ec-brand .ec-brand-name {
  color: var(--text-color);
  font-size: 30px;
  margin-left: 5px;
  max-width: 170px;
  font-size: 30px;
  font-weight: 700;
}

/*  Nav menus Icon Styles */
.sidebar .nav>li>span i {
  float: left;
  margin-right: 0.94rem;
  width: 20px;
  text-align: center;
  line-height: 20px;
  font-size: 1.5rem;
}

/* .sidebar .nav > li.active > a i {
  color: var(--admin-color);
} */

p {
  letter-spacing: 0.02rem;
}

span {
  letter-spacing: 0.02rem;
}

/* Caret styles */
.sidebar li>span .caret {
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  font-size: 1.25rem;
  border: none;
}

.sidebar li>span .caret:before {
  content: "\\e5e1";
  display: block;
  text-align: center;
  transition: all 0.2s linear;
  opacity: 0.5;
  font-size: 13px;
}

.sidebar li>span .caret:before {
  font-family: "Material Symbols Outlined" !important;
  font-weight: 400;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
}

.sidebar li.active>span .caret:before,
.sidebar li.expand>span .caret:before,
.sidebar li.expanding>span .caret:before {
  transform: rotate(0);
}

.sidebar li.active.expand>span .caret:before,
.sidebar li.expand>span .caret:before,
.sidebar li.expanding>span .caret:before {
  transform: rotate(90deg);
}

.sidebar li.active>span .caret:before {
  opacity: 1;
}

.sidebar li.closed>span .caret:before,
.sidebar li.closing>span .caret:before {
  transform: rotate(0);
}

/*  sub-menu dropdowns */
.sidebar .sub-menu {
  list-style-type: none;
  padding: 0.625rem 0 0.625rem 2.81rem;
  margin: 0;
  position: relative;
}

.sidebar .sub-menu>li>span {
  padding: 0.625rem 1.25rem 0.625rem 0.94rem;
  display: block;
  text-decoration: none;
  position: relative;
  font-size: 0.88rem;
}

.sidebar .sub-menu>li .sub-menu {
  padding-left: 2.18rem;
}

.sidebar .sub-menu>li .sub-menu>li>span {
  position: relative;
  font-size: 0.81rem;
  padding-left: 0;
  text-overflow: ellipsis;
}

.sidebar .sub-menu>li .sub-menu>li>span:after {
  position: absolute;
  content: "";
  top: 20px;
  left: -20px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  width: 10px;
}

.sidebar .has-sub.active.expand>.sub-menu {
  display: none;
}

.sidebar .has-sub .has-sub .caret {
  top: 12px;
}

.sidebar .sidenav-item-link {
  display: flex !important;
  flex-grow: 1;
  align-items: center;
}

.sidebar .sidenav-item-link .nav-text {
  margin-right: auto;
  overflow: hidden;
  max-width: 130px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sidebar .sidenav-item-link .badge {
  padding: 0.4em 0.6em;
}

.sidebar .sub-menu>li>span .nav-text {
  white-space: pre-line;
}

.sidebar .sub-menu .has-sub .nav-text {
  white-space: nowrap;
}

.collapse:hover {
  display: block;
}

/* Sidebar for Mobile */
.sidebar-mobile-in .ec-left-sidebar {
  transform: translateX(0px) !important;
  z-index: 1050;
  transition: transform 0.3s ease-in-out;
}

@media (min-width: 768px) {
  .sidebar-mobile-in .ec-left-sidebar {
    transform: translateX(-251px) !important;
  }
}

.sidebar-mobile-out .ec-left-sidebar {
  transform: translateX(-251px) !important;
  z-index: 1050;
  transition: transform 0.3s ease-in-out;
}

@media (min-width: 768px) {
  .sidebar-mobile-out .ec-left-sidebar {
    transform: translateX(0px) !important;
  }
}

/* Sidebar Minified */
.sidebar-minified .ec-left-sidebar {
  width: 250px;
  z-index: 15;
  transform: translateX(0);
  transition: transform 0.3s ease-in-out;
}

@media (min-width: 768px) {
  .sidebar-minified .ec-left-sidebar {
    width: 75px;
    transition: width 0.3s ease-in;
  }
}

@media (min-width: 768px) {
  .sidebar-minified .ec-left-sidebar .ec-brand .ec-brand-name {
    visibility: hidden;
    opacity: 0;
    transition: opacity 0.3s ease-in-out;
  }
}

@media (min-width: 768px) and (prefers-reduced-motion: reduce) {
  .sidebar-minified .ec-left-sidebar .ec-brand .ec-brand-name {
    transition: none;
  }
}

.sidebar-minified .ec-left-sidebar .sidebar .sub-menu {
  padding-top: 0;
  padding-bottom: 0;
}

.sidebar-minified .ec-left-sidebar .nav>li>span>.caret,
.sidebar-minified .ec-left-sidebar .nav>li>span {
  opacity: 1;
}

@media (min-width: 768px) {

  .sidebar-minified .ec-left-sidebar .nav>li>span>.caret,
  .sidebar-minified .ec-left-sidebar .nav>li>span>p {
    opacity: 0;
  }
}

.sidebar-minified .ec-left-sidebar .nav>li>a>.caret {
  right: 15px;
}

.sidebar-minified .ec-left-sidebar .nav li.has-sub .collapse>.sub-menu {
  left: 0;
  top: 0;
  width: 100%;
  margin: 0;
}

.sidebar-minified .ec-left-sidebar .nav li.has-sub.expand .collapse>.sub-menu {
  height: 0;
}

.sidebar-minified .ec-left-sidebar .nav li.has-sub.expand .collapse>.sub-menu li {
  visibility: hidden;
  opacity: 0;
}

@media (max-width: 575.98px) {
  .sidebar-minified .ec-left-sidebar .nav li.has-sub.expand .collapse>.sub-menu {
    transition: opacity 0.3s ease-in-out;
    display: block !important;
    opacity: 1;
    visibility: visible;
  }
}

@media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {
  .sidebar-minified .ec-left-sidebar .nav li.has-sub.expand .collapse>.sub-menu {
    transition: none;
  }
}

.sidebar-minified .ec-left-sidebar .separator {
  border-top-width: 0;
}

@media (min-width: 768px) {
  .sidebar-minified .ec-left-sidebar .sidebar-footer {
    height: 0;
  }
}

@media (min-width: 768px) {
  .sidebar-minified .ec-left-sidebar .sidebar-footer-content {
    visibility: hidden;
    opacity: 0;
  }
}

.sidebar-minified .ec-left-sidebar .sidebar-scrollbar {
  overflow: unset !important;
}

/* Sidebar Minified Hover */
@media (min-width: 768px) {
  .sidebar-minified .ec-left-sidebar:hover {
    width: 250px;
    margin-right: -10.94rem;
  }
}

.sidebar-minified .ec-left-sidebar:hover .nav li.has-sub.expand .collapse>.sub-menu {
  transition: opacity 0.3s ease-in-out;
  height: auto;
}

@media (prefers-reduced-motion: reduce) {
  .sidebar-minified .ec-left-sidebar:hover .nav li.has-sub.expand .collapse>.sub-menu {
    transition: none;
  }
}

.sidebar-minified .ec-left-sidebar:hover .nav li.has-sub.expand .collapse>.sub-menu li {
  opacity: 1;
  visibility: visible;
  transition: opacity 0.3s ease-out 0.25s;
}

@media (prefers-reduced-motion: reduce) {
  .sidebar-minified .ec-left-sidebar:hover .nav li.has-sub.expand .collapse>.sub-menu li {
    transition: none;
  }
}

.sidebar-minified .ec-left-sidebar:hover .nav>li>span>.caret,
.sidebar-minified .ec-left-sidebar:hover .nav>li>span>p {
  opacity: 1;
  transition: opacity 0.3s ease-in;
  transition-delay: 0.15s;
}

@media (prefers-reduced-motion: reduce) {

  .sidebar-minified .ec-left-sidebar:hover .nav>li>span>.caret,
  .sidebar-minified .ec-left-sidebar:hover .nav>li>span>p {
    transition: none;
  }
}

.sidebar-minified .ec-left-sidebar:hover .ec-brand-name {
  opacity: 1;
  visibility: visible;
  transition: opacity 0.3s ease;
  transition-delay: 0.3s;
}

@media (prefers-reduced-motion: reduce) {
  .sidebar-minified .ec-left-sidebar:hover .ec-brand-name {
    transition: none;
  }
}

@media (min-width: 768px) {
  .sidebar-minified .ec-left-sidebar:hover .ec-brand .ec-brand-name {
    opacity: 1;
    visibility: visible;
    transition-delay: 0.3s;
  }
}

.sidebar-minified .ec-left-sidebar:hover .sidebar .sub-menu {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}

.sidebar-minified .ec-left-sidebar:hover .separator {
  border-top-width: 1px;
}

@media (min-width: 768px) {
  .sidebar-minified .ec-left-sidebar:hover .sidebar-footer {
    height: auto;
  }
}

.sidebar-minified .ec-left-sidebar:hover .sidebar-footer-content {
  visibility: visible;
  opacity: 1;
  transition: opacity 0.3s ease-in-out 0.15s;
}

@media (prefers-reduced-motion: reduce) {
  .sidebar-minified .ec-left-sidebar:hover .sidebar-footer-content {
    transition: none;
  }
}

.sidebar-minified .ec-left-sidebar:hover .sidebar-scrollbar {
  overflow: hidden !important;
}

/* Sidebar Minified Not transition */
@media (min-width: 768px) {
  .sidebar-minified:not(.ec-left-sidebar) .ec-left-sidebar {
    transition-duration: 0.3s;
    transition-timing-function: ease-in-out;
    transition-property: margin-left, margin-right, width;
  }
}

/* Sidebar Static With Minified */
.ec-sidebar-static.sidebar-minified .ec-page-wrapper .ec-main-header {
  transition: padding-left 0.3s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .ec-sidebar-static.sidebar-minified .ec-page-wrapper .ec-main-header {
    transition: none;
  }
}

@media (min-width: 768px) {
  .ec-sidebar-static.sidebar-minified.ec-header-fixed .ec-page-wrapper .ec-main-header {
    padding-left: 4.69rem;
  }
}

.ec-sidebar-static.sidebar-minified-out .ec-left-sidebar {
  transition: width 0.3s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .ec-sidebar-static.sidebar-minified-out .ec-left-sidebar {
    transition: none;
  }
}

.ec-sidebar-static.sidebar-minified-out .ec-page-wrapper .ec-main-header {
  transition: padding-left 0.3s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .ec-sidebar-static.sidebar-minified-out .ec-page-wrapper .ec-main-header {
    transition: none;
  }
}

/* Sidebar Fixed With Minified Layout Container */
@media (min-width: 768px) {
  .ec-sidebar-fixed.sidebar-minified .ec-page-wrapper {
    padding-left: 4.69rem;
    transition: padding-left 0.3s ease-in-out;
  }
}

@media (min-width: 768px) and (prefers-reduced-motion: reduce) {
  .ec-sidebar-fixed.sidebar-minified .ec-page-wrapper {
    transition: none;
  }
}

@media (min-width: 768px) {
  .ec-sidebar-fixed.sidebar-minified.ec-header-fixed .ec-page-wrapper .ec-main-header {
    padding-left: 4.69rem;
    transition: padding-left 0.3s ease-in-out;
  }
}

@media (min-width: 768px) and (prefers-reduced-motion: reduce) {
  .ec-sidebar-fixed.sidebar-minified.ec-header-fixed .ec-page-wrapper .ec-main-header {
    transition: none;
  }
}

/* Sidebar Minified Out */
/* .sidebar-minified-out {
  Sidebar Fixed With Sidebar Minified Out
} */

.sidebar-minified-out .ec-left-sidebar {
  z-index: 10000;
  transform: translateX(-251px);
  transition: transform 0.3s ease-in-out !important;
}

@media (min-width: 768px) {
  .sidebar-minified-out .ec-left-sidebar {
    transform: translateX(0px);
    transition: width 0.3s ease-in-out !important;
  }
}

.sidebar-minified-out .sidebar .sub-menu {
  padding-bottom: 0.625rem;
  padding-top: 0.625rem;
}

.sidebar-minified-out .sidebar .nav>li>span {
  transition: opacity 0.3s ease-in-out 0.3s;
  visibility: visible;
  opacity: 1;
}

.sidebar-minified-out .sidebar li>span .caret {
  transition: opacity 0.3s ease-in-out 0.3s;
  visibility: visible;
  opacity: 1;
}

.sidebar-minified-out .nav li.has-sub.expand .collapse>.sub-menu {
  height: auto;
}

.sidebar-minified-out .nav li.has-sub.expand .collapse>.sub-menu li {
  opacity: 1;
  visibility: visible;
  transition: opacity 0.3s ease-out 0.25s;
}

@media (prefers-reduced-motion: reduce) {
  .sidebar-minified-out .nav li.has-sub.expand .collapse>.sub-menu li {
    transition: none;
  }
}

.sidebar-minified-out .sidebar-footer-content {
  visibility: visible;
  opacity: 1;
  transition: opacity 0.3s ease-in-out 0.15s;
}

@media (prefers-reduced-motion: reduce) {
  .sidebar-minified-out .sidebar-footer-content {
    transition: none;
  }
}

.sidebar-minified-out .ec-left-sidebar {
  transition: width 0.3s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .sidebar-minified-out .ec-left-sidebar {
    transition: none;
  }
}

.sidebar-minified-out .ec-page-wrapper {
  transition: padding-left 0.3s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .sidebar-minified-out .ec-page-wrapper {
    transition: none;
  }
}

.sidebar-minified-out .ec-page-wrapper .ec-main-header {
  transition: padding-left 0.3s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .sidebar-minified-out .ec-page-wrapper .ec-main-header {
    transition: none;
  }
}

/* Sidebar Fixed And Offcanvas */
@media (min-width: 768px) {

  .ec-sidebar-fixed-offcanvas .ec-left-sidebar,
  .ec-sidebar-fixed .ec-left-sidebar {
    position: fixed;
    top: 70px;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 16;
  }
}

@media (min-width: 768px) {

  .ec-sidebar-fixed-offcanvas .ec-page-wrapper,
  .ec-sidebar-fixed .ec-page-wrapper {
    padding-left: 15.6rem;
  }
}

@media (min-width: 768px) {

  .ec-sidebar-fixed-offcanvas .ec-main-header,
  .ec-sidebar-fixed .ec-main-header {
    /* padding-left: 15.6rem; */
  }
}

.ec-sidebar-fixed-offcanvas.ec-header-static .ec-main-header,
.ec-sidebar-fixed.ec-header-static .ec-main-header {
  position: relative;
}

@media (min-width: 768px) {

  .ec-sidebar-fixed-offcanvas.ec-header-static .ec-main-header,
  .ec-sidebar-fixed.ec-header-static .ec-main-header {
    padding-left: 0;
  }
}

.ec-sidebar-fixed-offcanvas .ec-sidebar-footer,
.ec-sidebar-fixed .ec-sidebar-footer {
  padding-bottom: 30px;
}

@media (min-width: 768px) {

  .ec-sidebar-fixed-offcanvas .ec-sidebar-footer,
  .ec-sidebar-fixed .ec-sidebar-footer {
    padding-bottom: 30px;
  }
}

.ec-sidebar-fixed-offcanvas .ec-sidebar-footer .sidebar-footer,
.ec-sidebar-fixed .ec-sidebar-footer .sidebar-footer {
  position: absolute;
  bottom: 0;
}

.ec-sidebar-fixed-offcanvas.sidebar-collapse .ec-page-wrapper {
  padding-left: 0;
}

@media (min-width: 768px) {
  .ec-sidebar-fixed-offcanvas.sidebar-collapse .sidebar-footer {
    left: -251px;
  }
}

@media (min-width: 768px) {
  .ec-sidebar-fixed-offcanvas.sidebar-collapse-out .sidebar-footer {
    left: 0px;
    transition: left 0.3s ease-in-out;
  }
}

@media (min-width: 768px) and (prefers-reduced-motion: reduce) {
  .ec-sidebar-fixed-offcanvas.sidebar-collapse-out .sidebar-footer {
    transition: none;
  }
}

/* Sidebar Collapse */
@media (min-width: 768px) {
  .sidebar-collapse .ec-left-sidebar {
    margin-left: -15.6rem;
    transition: margin-left 0.3s ease-in-out;
  }
}

@media (min-width: 768px) and (prefers-reduced-motion: reduce) {
  .sidebar-collapse .ec-left-sidebar {
    transition: none;
  }
}

@media (min-width: 768px) {
  .sidebar-collapse .ec-page-wrapper {
    transition: padding-left 0.3s ease-in-out;
  }
}

@media (min-width: 768px) and (prefers-reduced-motion: reduce) {
  .sidebar-collapse .ec-page-wrapper {
    transition: none;
  }
}

/* Sidebar Out Collapse */
@media (min-width: 768px) {
  .sidebar-collapse-out .ec-left-sidebar {
    margin-left: 0px;
    transition: margin-left 0.3s ease-in-out;
  }
}

@media (min-width: 768px) and (prefers-reduced-motion: reduce) {
  .sidebar-collapse-out .ec-left-sidebar {
    transition: none;
  }
}

@media (min-width: 768px) {
  .sidebar-collapse-out .ec-page-wrapper {
    transition: padding-left 0.3s ease-in-out;
  }
}

@media (min-width: 768px) and (prefers-reduced-motion: reduce) {
  .sidebar-collapse-out .ec-page-wrapper {
    transition: none;
  }
}

.sidebar-collapse.ec-header-fixed .ec-page-wrapper .ec-main-header {
  padding-left: 0;
  transition: padding-left 0.3s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .sidebar-collapse.ec-header-fixed .ec-page-wrapper .ec-main-header {
    transition: none;
  }
}

.sidebar-collapse-out .ec-page-wrapper .ec-main-header {
  transition: padding-left 0.3s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .sidebar-collapse-out .ec-page-wrapper .ec-main-header {
    transition: none;
  }
}

/* Sidebar Static With Footer */
.ec-sidebar-static .sidebar.ec-sidebar-footer .slimScrollDiv,
.ec-sidebar-static-offcanvas .sidebar.ec-sidebar-footer .slimScrollDiv {
  height: 100%;
}

@media (min-width: 768px) {

  .ec-sidebar-static .sidebar.ec-sidebar-footer .slimScrollDiv,
  .ec-sidebar-static-offcanvas .sidebar.ec-sidebar-footer .slimScrollDiv {
    height: auto !important;
  }
}

@media (min-width: 768px) {

  .ec-sidebar-static.ec-header-fixed .ec-main-header,
  .ec-sidebar-static-offcanvas.ec-header-fixed .ec-main-header {
    padding-left: 15.6rem;
  }
}

.sidebar-ec-content-wrapper {
  height: calc(100% - 45px) !important;
}

/* Sidebar Bg Dark */
.ec-sidebar-dark .ec-brand {
  border-color: #37455a;
  border-right: 1px solid #37455a;
}

.ec-sidebar-dark .ec-brand span {
  border-color: #37455a;
}

.ec-sidebar-dark hr {
  background: #37455a;
}

.ec-sidebar-dark .ec-left-sidebar {
  background-color: #1a283e;
}

.ec-sidebar-dark .sidebar .sub-menu {
  background: #293546;
}

.ec-sidebar-dark .sidebar .sub-menu>li>span {
  color: #b7c0cd;
}

.ec-sidebar-dark .sidebar .sub-menu>li>span.active {
  color: #ffffff;
}

.ec-sidebar-dark .sidebar .sub-menu>li>a .nav-text {
  white-space: pre-line;
}

.ec-sidebar-dark .sidebar .sub-menu .has-sub .nav-text {
  white-space: nowrap;
}

.ec-sidebar-dark .sidebar .sub-menu>li.active>span,
.ec-sidebar-dark .sidebar .sub-menu>li.active>span:focus,
.ec-sidebar-dark .sidebar .sub-menu>li.active>span:hover,
.ec-sidebar-dark .sidebar .sub-menu>li>span:focus,
.ec-sidebar-dark .sidebar .sub-menu>li>span:hover {
  color: #ffffff;
}

.ec-sidebar-dark .sidebar .nav>li.active>span {
  color: #ffffff;
}

.ec-sidebar-dark .separator {
  border-color: rgba(243, 243, 243, 0.2);
}

.ec-sidebar-dark .sidebar-footer {
  background-color: #212a39;
}

/* Sidebar Light */
.ec-sidebar-light .ec-left-sidebar {
  background-color: #ffffff;
}

.ec-sidebar-light .sidebar {
  border-right: 1px solid var(--border-color);
}

.ec-sidebar-light .sidebar .sub-menu {
  background-color: var(--gray-bg-color);
}

.ec-sidebar-light .sidebar .sub-menu>li>a {
  color: var(--bs-body-color);
}

.ec-sidebar-light .sidebar .sub-menu>li>span.active {
  color: #4c515b;
}

.ec-sidebar-light .sidebar .sub-menu>li.active>span,
.ec-sidebar-light .sidebar .sub-menu>li.active>span:focus,
.ec-sidebar-light .sidebar .sub-menu>li.active>span:hover,
.ec-sidebar-light .sidebar .sub-menu>li>span:focus,
.ec-sidebar-light .sidebar .sub-menu>li>span:hover {
  color: #4c515b;
}

.ec-sidebar-light .sidebar .nav>li.active>span {
  color: #4c515b;
}

.ec-sidebar-light .sidebar .separator {
  border-color: var(--border-color);
}

.ec-sidebar-light .sidebar-footer {
  background-color: #ffffff;
}

.ec-sidebar-light .sidebar .sub-menu>li .sub-menu>li>span:after {
  border: 1px solid var(--bs-body-color);
}

/* Sidebar Footer Content*/
.sidebar-footer-content {
  padding: 0 1.9rem;
  padding-top: 1.56rem;
  padding-bottom: 0.75rem;
  width: 250px;
}

@media (min-width: 1200px) {
  .sidebar-footer-content {
    padding-top: 2.81rem;
    padding-bottom: 2rem;
  }
}

.sidebar-footer-content>h6,
.sidebar-footer-content>.h6 {
  color: #b7c0cd;
  font-size: 0.81rem;
  margin-top: 0.69rem;
  margin-bottom: 0.69rem;
  white-space: nowrap;
}

.sidebar-footer-content .progress {
  height: 15px;
  margin-bottom: 1.88rem;
  overflow: hidden;
  background-color: #e4eaec;
  border-radius: 0.215rem;
}

.sidebar-footer-content .progress-xs {
  height: 4px;
  border-radius: 0.06rem;
}

.sidebar-footer-content .progress-xs .progress-bar {
  line-height: 4px;
}

.sidebar-footer-content .progress-xs .progress-bar.progress-bar-warning {
  background: #ddaa04;
}

/* App Logo Fill Color */
.logo-fill-blue {
  fill: #84befc;
}

.logo-fill-white {
  fill: #ffffff;
}

/* Right Sidebar Toogler Add */
.right-sidebar-toggoler-in .right-sidebar {
  right: 0;
  transition: right 0.3s ease-in-out;
}

.right-sidebar-toggoler-in .right-sidebar .btn-right-sidebar-toggler {
  right: 60px;
  transition: right 0.3s ease-in-out;
}

.right-sidebar-toggoler-in .right-sidebar .btn-right-sidebar-toggler i {
  transform: rotate(180deg);
  transition: transform 0.3s ease-in-out;
}

.right-sidebar-toggoler-out .right-sidebar {
  transition: right 0.3s ease-in-out;
}

.right-sidebar-toggoler-out .right-sidebar .btn-right-sidebar-toggler {
  transition: right 0.3s ease-in-out;
}

.right-sidebar-toggoler-out .right-sidebar i {
  transform: rotate(0deg);
  transition: transform 0.3s ease-in-out;
}

/* Right Sidebar */
.right-sidebar {
  width: 60px;
  min-height: 100vh;
  position: fixed;
  right: -60px;
  top: 0;
  z-index: 1;
  transition: right 0.3s ease-in-out;
  /* From Group Label */
}

@media (min-width: 1200px) {
  .right-sidebar {
    right: 0;
    transition: right 0.3s ease-in-out;
  }
}

.right-sidebar .btn-right-sidebar-toggler {
  position: fixed;
  top: 135px;
  right: 0;
  background-color: #ffffff;
  border-top-left-radius: 1rem;
  border-bottom-left-radius: 1rem;
  width: 35px;
  height: 30px;
  border: 1px solid var(--border-color);
}

.right-sidebar .btn-right-sidebar-toggler i {
  line-height: 28px;
  margin-left: 5px;
  font-size: 1.25rem;
  display: inline-block;
}

@media (min-width: 1200px) {
  .right-sidebar .btn-right-sidebar-toggler {
    display: none;
  }
}

.right-sidebar .form-group label {
  line-height: 1.3;
}

/* Nav Right Sidebar */
.nav-right-sidebar {
  flex-direction: column;
  position: relative;
}

.nav-right-sidebar .nav-item {
  margin: auto;
  margin-bottom: 0.75rem;
}

.nav-right-sidebar .nav-link {
  font-size: 1.5rem;
}

.nav-right-sidebar .nav-link:focus {
  background-color: rgba(138, 144, 157, 0.1);
}

/* Nav Container */
.right-nav-container {
  position: relative;
  z-index: 100;
  background-color: #ffffff;
  min-height: 100vh;
  border-left: 1px solid var(--border-color);
}

.right-nav-container .nav-right-sidebar {
  padding-top: 120px;
}

/* Right Sidebar Tab Content */
.right-sidebar-tab {
  position: fixed;
  top: 76px;
  right: -375px;
  width: 315px;
  min-height: 100%;
  background-color: #ffffff;
  border-left: 1px solid var(--border-color);
}

.right-sidebar-tab .tab-content {
  position: relative;
  z-index: 10;
}

/* Right Sidebar Content Out */
@media (min-width: 1200px) {
  .right-sidebar-out .ec-content-wrapper {
    margin-right: 60px;
    transition: margin-right 0.3s ease-in-out;
  }
}

.right-sidebar-out .right-sidebar-tab {
  right: -315px;
  transition: right 0.3s ease-in-out;
}

/* Right Sidebar Content IN */
@media (min-width: 1200px) {
  .right-sidebar-in .ec-content-wrapper {
    margin-right: 375px;
    transition: margin-right 0.3s ease-in-out;
  }
}

.right-sidebar-in .right-sidebar-tab {
  right: 60px;
  transition: right 0.3s ease-in-out;
}

/* Nav Icon Small */
.icon-sm {
  width: 45px;
  height: 45px;
  line-height: 45px;
  border-radius: 50%;
  padding: 0;
  text-align: center;
}

/* Card Right Sidebar */
.card-right-sidebar {
  border: none;
}

.card-right-sidebar .card-header {
  background-color: transparent;
  padding: 1rem;
  padding-top: 1.5rem;
  padding-right: 1rem;
  padding-bottom: 1rem;
  padding-right: 1rem;
  color: var(--text-color);
}

.card-right-sidebar .card-header .close {
  width: 30px;
  height: 30px;
  line-height: 1;
  border-radius: 50%;
  margin-top: -5px;
}

.card-right-sidebar .card-header .close:hover {
  background-color: rgba(138, 144, 157, 0.1);
}

.card-right-sidebar .card-header .card-title {
  margin-bottom: 0;
  font-size: 0.94rem;
}

/* Dark Version  */
.right-ec-sidebar-dark .right-nav-container {
  background-color: #1a283e;
  border-left: 1px solid rgba(255, 255, 255, 0.2);
}

/* Right Sidebar 2 */
.right-sidebar-container-2 {
  right: 0;
  top: 0;
  width: 315px !important;
  display: block;
  z-index: 555555;
  position: fixed;
  background: #fff;
  border-radius: 0;
  height: 100%;
  transform: translateX(100%);
  border-left: 1px solid var(--border-color);
  transition: all 0.3s ease;
  /* Theme Button */
  /* Reset Button */
  /* Theme Button Active */
  /* Slelect box */
  /* Theme Subtitle */
}

.right-sidebar-container-2 .btn-close-right-sidebar-2 {
  top: 50%;
  right: 0;
  transform: translate(-50%, -50%);
  position: absolute;
  border-bottom-left-radius: 6px;
  border-top-left-radius: 6px;
  margin-left: -40px;
  min-width: 40px;
  height: 35px;
  line-height: 35px;
  text-align: center;
  cursor: pointer;
  font-size: 1.25rem;
  color: var(--text-color);
}

.right-sidebar-container-2 h2,
.right-sidebar-container-2 .h2 {
  font-size: 1.25rem;
  font-weight: 200;
  color: #ffffff;
}

.right-sidebar-container-2 .right-sidebar-2-header {
  padding: 17px 30px;
  border-radius: 0 0 !important;
  display: block;
  color: var(--text-color);
  position: relative;
  background-color: #fff;
  border-bottom: 1px solid var(--border-color);
}

.right-sidebar-container-2 .right-sidebar-2-header p {
  font-size: 13px;
  color: var(--text-color);
  display: none;
}

.right-sidebar-container-2 .right-sidebar-2-header h2,
.right-sidebar-container-2 .right-sidebar-2-header .h2 {
  color: var(--text-color);
}

.right-sidebar-container-2 .btn-right-sidebar-2 {
  color: var(--bs-body-color);
  font-size: 13px;
  text-transform: uppercase;
  font-weight: 200;
  padding: 4px 10px;
  width: 48%;
  text-align: center;
  margin-right: 10px;
  text-decoration: none;
  line-height: 21px;
}

.right-sidebar-container-2 .btn-right-sidebar-2:last-child {
  margin-right: 0;
}

.right-sidebar-container-2 .btn-reset {
  background-color: var(--admin-color);
  border: 0;
  color: #ffffff;
  width: auto;
  cursor: pointer;
  line-height: 2;
  border-radius: 15px !important;
}

.right-sidebar-container-2 .btn-right-sidebar-2.btn-right-sidebar-2-active {
  background-color: var(--bs-body-color);
  color: #ffffff;
  text-decoration: none;
}

.right-sidebar-container-2 .right-sidebar-2-select {
  width: 100%;
  height: 31px;
  border-radius: 4px;
  padding-left: 10px;
  padding-right: 10px;
}

.right-sidebar-container-2 .right-sidebar-2-subtitle {
  color: #a6aab4;
  font-size: 16px;
  display: block;
  margin-bottom: 10px;
  margin-top: 10px;
}

/* Theme Option Visibile */
.right-sidebar-2-visible {
  transform: translateX(0);
}

/* Style Swticher Body */
.right-sidebar-2-body {
  padding: 15px 30px;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  height: calc(100vh - 60px);
}

.right-sidebar-2-body .no-col-space {
  margin-bottom: 30px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.right-sidebar-2-body hr {
  /* margin: 11px 0; */
  border-color: #454545;
}

/* Simplebar */
.simplebar-scrollbar::before {
  background-color: rgba(153, 153, 153, 0.8);
  width: 5px;
  left: 6px;
  right: 6px;
}

/*===== SPINNERS =====*/
/* Rotating Plane */
.sk-rotating-plane {
  width: 40px;
  height: 40px;
  background-color: #333;
  animation: sk-rotateplane 1.2s infinite ease-in-out;
}

@keyframes sk-rotateplane {
  0% {
    transform: perspective(120px) rotateX(0deg) rotateY(0deg);
    -webkit-transform: perspective(120px) rotateX(0deg) rotateY(0deg);
  }

  50% {
    transform: perspective(120px) rotateX(-180.1deg) rotateY(0deg);
    -webkit-transform: perspective(120px) rotateX(-180.1deg) rotateY(0deg);
  }

  100% {
    transform: perspective(120px) rotateX(-180deg) rotateY(-179.9deg);
    -webkit-transform: perspective(120px) rotateX(-180deg) rotateY(-179.9deg);
  }
}

/* double-bounce */
.sk-double-bounce {
  width: 40px;
  height: 40px;
  position: relative;
}

.double-bounce1,
.double-bounce2 {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-color: #333;
  opacity: 0.6;
  position: absolute;
  top: 0;
  left: 0;
  animation: sk-bounce 2s infinite ease-in-out;
}

.double-bounce2 {
  animation-delay: -1s;
}

@keyframes sk-bounce {

  0%,
  100% {
    transform: scale(0);
    -webkit-transform: scale(0);
  }

  50% {
    transform: scale(1);
    -webkit-transform: scale(1);
  }
}

/* Wave */
.sk-wave {
  width: 50px;
  height: 40px;
  text-align: center;
  font-size: 0.625rem;
}

.sk-wave>div {
  background-color: #333;
  height: 100%;
  width: 6px;
  display: inline-block;
  animation: sk-stretchdelay 1.2s infinite ease-in-out;
}

.sk-wave .rect2 {
  animation-delay: -1.1s;
}

.sk-wave .rect3 {
  animation-delay: -1s;
}

.sk-wave .rect4 {
  animation-delay: -0.9s;
}

.sk-wave .rect5 {
  animation-delay: -0.8s;
}

@keyframes sk-stretchdelay {

  0%,
  40%,
  100% {
    transform: scaleY(0.4);
    -webkit-transform: scaleY(0.4);
  }

  20% {
    transform: scaleY(1);
    -webkit-transform: scaleY(1);
  }
}

/* Wonderting Cube */
.sk-wonder-cube {
  width: 40px;
  height: 40px;
  position: relative;
}

.cube1,
.cube2 {
  background-color: #333;
  width: 15px;
  height: 15px;
  position: absolute;
  top: 0;
  left: 0;
  animation: sk-cubemove 1.8s infinite ease-in-out;
}

.cube2 {
  animation-delay: -0.9s;
}

@keyframes sk-cubemove {
  25% {
    transform: translateX(42px) rotate(-90deg) scale(0.5);
    -webkit-transform: translateX(42px) rotate(-90deg) scale(0.5);
  }

  50% {
    transform: translateX(42px) translateY(42px) rotate(-179deg);
    -webkit-transform: translateX(42px) translateY(42px) rotate(-179deg);
  }

  50.1% {
    transform: translateX(42px) translateY(42px) rotate(-180deg);
    -webkit-transform: translateX(42px) translateY(42px) rotate(-180deg);
  }

  75% {
    transform: translateX(0px) translateY(42px) rotate(-270deg) scale(0.5);
    -webkit-transform: translateX(0px) translateY(42px) rotate(-270deg) scale(0.5);
  }

  100% {
    transform: rotate(-360deg);
    -webkit-transform: rotate(-360deg);
  }
}

/* Pulse */
.sk-pulse {
  width: 60px;
  height: 60px;
  background-color: #333;
  border-radius: 100%;
  animation: sk-scaleout 1s infinite ease-in-out;
}

@keyframes sk-scaleout {
  0% {
    transform: scale(0);
  }

  100% {
    transform: scale(1);
    opacity: 0;
  }
}

/* Chasing dots */
.sk-chasing-dots {
  width: 40px;
  height: 40px;
  position: relative;
  text-align: center;
  animation: sk-rotate 2s infinite linear;
}

.dot1,
.dot2 {
  width: 60%;
  height: 60%;
  display: inline-block;
  position: absolute;
  top: 0;
  background-color: #333;
  border-radius: 100%;
  animation: sk-bounce 2s infinite ease-in-out;
}

.dot2 {
  top: auto;
  bottom: 0;
  animation-delay: -1s;
}

@keyframes sk-rotate {
  100% {
    transform: rotate(360deg);
    -webkit-transform: rotate(360deg);
  }
}

@keyframes sk-bounce {

  0%,
  100% {
    transform: scale(0);
    -webkit-transform: scale(0);
  }

  50% {
    transform: scale(1);
    -webkit-transform: scale(1);
  }
}

/* Three bounce */
.sk-three-bounce {
  width: 70px;
  height: 40px;
  text-align: center;
}

.sk-three-bounce>div {
  width: 18px;
  height: 18px;
  background-color: #333;
  border-radius: 100%;
  display: inline-block;
  animation: sk-bouncedelay 1.4s infinite ease-in-out both;
}

.sk-three-bounce .bounce1 {
  animation-delay: -0.32s;
}

.sk-three-bounce .bounce2 {
  animation-delay: -0.16s;
}

@keyframes sk-bouncedelay {

  0%,
  80%,
  100% {
    transform: scale(0);
  }

  40% {
    transform: scale(1);
  }
}

/* Circle */
.sk-circle {
  width: 40px;
  height: 40px;
  position: relative;
}

.sk-circle .sk-child {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}

.sk-circle .sk-child:before {
  content: "";
  display: block;
  margin: 0 auto;
  width: 15%;
  height: 15%;
  background-color: #333;
  border-radius: 100%;
  animation: sk-circleBounceDelay 1.2s infinite ease-in-out both;
}

.sk-circle .sk-circle2 {
  transform: rotate(30deg);
}

.sk-circle .sk-circle3 {
  transform: rotate(60deg);
}

.sk-circle .sk-circle4 {
  transform: rotate(90deg);
}

.sk-circle .sk-circle5 {
  transform: rotate(120deg);
}

.sk-circle .sk-circle6 {
  transform: rotate(150deg);
}

.sk-circle .sk-circle7 {
  transform: rotate(180deg);
}

.sk-circle .sk-circle8 {
  transform: rotate(210deg);
}

.sk-circle .sk-circle9 {
  transform: rotate(240deg);
}

.sk-circle .sk-circle10 {
  transform: rotate(270deg);
}

.sk-circle .sk-circle11 {
  transform: rotate(300deg);
}

.sk-circle .sk-circle12 {
  transform: rotate(330deg);
}

.sk-circle .sk-circle2:before {
  animation-delay: -1.1s;
}

.sk-circle .sk-circle3:before {
  animation-delay: -1s;
}

.sk-circle .sk-circle4:before {
  animation-delay: -0.9s;
}

.sk-circle .sk-circle5:before {
  animation-delay: -0.8s;
}

.sk-circle .sk-circle6:before {
  animation-delay: -0.7s;
}

.sk-circle .sk-circle7:before {
  animation-delay: -0.6s;
}

.sk-circle .sk-circle8:before {
  animation-delay: -0.5s;
}

.sk-circle .sk-circle9:before {
  animation-delay: -0.4s;
}

.sk-circle .sk-circle10:before {
  animation-delay: -0.3s;
}

.sk-circle .sk-circle11:before {
  animation-delay: -0.2s;
}

.sk-circle .sk-circle12:before {
  animation-delay: -0.1s;
}

@keyframes sk-circleBounceDelay {

  0%,
  80%,
  100% {
    transform: scale(0);
  }

  40% {
    transform: scale(1);
  }
}

/* Cube Grid */
.sk-cube-grid {
  width: 40px;
  height: 40px;
}

.sk-cube-grid .sk-cube {
  width: 33%;
  height: 33%;
  background-color: #333;
  float: left;
  animation: sk-cubeGridScaleDelay 1.3s infinite ease-in-out;
}

.sk-cube-grid .sk-cube1 {
  animation-delay: 0.2s;
}

.sk-cube-grid .sk-cube2 {
  animation-delay: 0.3s;
}

.sk-cube-grid .sk-cube3 {
  animation-delay: 0.4s;
}

.sk-cube-grid .sk-cube4 {
  animation-delay: 0.1s;
}

.sk-cube-grid .sk-cube5 {
  animation-delay: 0.2s;
}

.sk-cube-grid .sk-cube6 {
  animation-delay: 0.3s;
}

.sk-cube-grid .sk-cube7 {
  animation-delay: 0s;
}

.sk-cube-grid .sk-cube8 {
  animation-delay: 0.1s;
}

.sk-cube-grid .sk-cube9 {
  animation-delay: 0.2s;
}

@keyframes sk-cubeGridScaleDelay {

  0%,
  70%,
  100% {
    transform: scale3D(1, 1, 1);
  }

  35% {
    transform: scale3D(0, 0, 1);
  }
}

/* Fading Circle */
.sk-fading-circle {
  width: 40px;
  height: 40px;
  position: relative;
}

.sk-fading-circle .sk-circle {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}

.sk-fading-circle .sk-circle:before {
  content: "";
  display: block;
  margin: 0 auto;
  width: 15%;
  height: 15%;
  background-color: #333;
  border-radius: 100%;
  animation: sk-circleFadeDelay 1.2s infinite ease-in-out both;
}

.sk-fading-circle .sk-circle2 {
  transform: rotate(30deg);
}

.sk-fading-circle .sk-circle3 {
  transform: rotate(60deg);
}

.sk-fading-circle .sk-circle4 {
  transform: rotate(90deg);
}

.sk-fading-circle .sk-circle5 {
  transform: rotate(120deg);
}

.sk-fading-circle .sk-circle6 {
  transform: rotate(150deg);
}

.sk-fading-circle .sk-circle7 {
  transform: rotate(180deg);
}

.sk-fading-circle .sk-circle8 {
  transform: rotate(210deg);
}

.sk-fading-circle .sk-circle9 {
  transform: rotate(240deg);
}

.sk-fading-circle .sk-circle10 {
  transform: rotate(270deg);
}

.sk-fading-circle .sk-circle11 {
  transform: rotate(300deg);
}

.sk-fading-circle .sk-circle12 {
  transform: rotate(330deg);
}

.sk-fading-circle .sk-circle2:before {
  animation-delay: -1.1s;
}

.sk-fading-circle .sk-circle3:before {
  animation-delay: -1s;
}

.sk-fading-circle .sk-circle4:before {
  animation-delay: -0.9s;
}

.sk-fading-circle .sk-circle5:before {
  animation-delay: -0.8s;
}

.sk-fading-circle .sk-circle6:before {
  animation-delay: -0.7s;
}

.sk-fading-circle .sk-circle7:before {
  animation-delay: -0.6s;
}

.sk-fading-circle .sk-circle8:before {
  animation-delay: -0.5s;
}

.sk-fading-circle .sk-circle9:before {
  animation-delay: -0.4s;
}

.sk-fading-circle .sk-circle10:before {
  animation-delay: -0.3s;
}

.sk-fading-circle .sk-circle11:before {
  animation-delay: -0.2s;
}

.sk-fading-circle .sk-circle12:before {
  animation-delay: -0.1s;
}

@keyframes sk-circleFadeDelay {

  0%,
  39%,
  100% {
    opacity: 0;
  }

  40% {
    opacity: 1;
  }
}

/* Folding Cube */
.sk-folding-cube {
  width: 40px;
  height: 40px;
  position: relative;
  transform: rotateZ(45deg);
}

.sk-folding-cube .sk-cube {
  float: left;
  width: 50%;
  height: 50%;
  position: relative;
  transform: scale(1.1);
}

.sk-folding-cube .sk-cube:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #333;
  animation: sk-foldCubeAngle 2.4s infinite linear both;
  transform-origin: 100% 100%;
}

.sk-folding-cube .sk-cube2 {
  transform: scale(1.1) rotateZ(90deg);
}

.sk-folding-cube .sk-cube3 {
  transform: scale(1.1) rotateZ(180deg);
}

.sk-folding-cube .sk-cube4 {
  transform: scale(1.1) rotateZ(270deg);
}

.sk-folding-cube .sk-cube2:before {
  animation-delay: 0.3s;
}

.sk-folding-cube .sk-cube3:before {
  animation-delay: 0.6s;
}

.sk-folding-cube .sk-cube4:before {
  animation-delay: 0.9s;
}

@keyframes sk-foldCubeAngle {

  0%,
  10% {
    transform: perspective(140px) rotateX(-180deg);
    opacity: 0;
  }

  25%,
  75% {
    transform: perspective(140px) rotateX(0deg);
    opacity: 1;
  }

  90%,
  100% {
    transform: perspective(140px) rotateY(180deg);
    opacity: 0;
  }
}

/* Chase */
.sk-chase {
  width: 60px;
  height: 60px;
  position: relative;
  animation: sk-chase 2.5s infinite linear both;
}

.sk-chase-dot {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  animation: sk-chase-dot 2s infinite ease-in-out both;
}

.sk-chase-dot:before {
  content: "";
  display: block;
  width: 25%;
  height: 25%;
  background-color: #333;
  border-radius: 100%;
  animation: sk-chase-dot-before 2s infinite ease-in-out both;
}

.sk-chase-dot:nth-child(1) {
  animation-delay: -1.1s;
}

.sk-chase-dot:nth-child(2) {
  animation-delay: -1s;
}

.sk-chase-dot:nth-child(3) {
  animation-delay: -0.9s;
}

.sk-chase-dot:nth-child(4) {
  animation-delay: -0.8s;
}

.sk-chase-dot:nth-child(5) {
  animation-delay: -0.7s;
}

.sk-chase-dot:nth-child(6) {
  animation-delay: -0.6s;
}

.sk-chase-dot:nth-child(1):before {
  animation-delay: -1.1s;
}

.sk-chase-dot:nth-child(2):before {
  animation-delay: -1s;
}

.sk-chase-dot:nth-child(3):before {
  animation-delay: -0.9s;
}

.sk-chase-dot:nth-child(4):before {
  animation-delay: -0.8s;
}

.sk-chase-dot:nth-child(5):before {
  animation-delay: -0.7s;
}

@keyframes sk-chase {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes sk-chase-dot {

  80%,
  100% {
    transform: rotate(360deg);
  }
}

@keyframes sk-chase-dot-before {
  50% {
    transform: scale(0.4);
  }

  100%,
  0% {
    transform: scale(1);
  }
}

/*===== SWITCHERS =====*/
input[type=checkbox],
input[type=radio] {
  box-sizing: border-box;
  padding: 0;
}

.switch {
  position: relative;
  display: inline-block;
  vertical-align: top;
  width: 64px;
  height: 30px;
  background-color: transparent;
  cursor: pointer;
}

.switch .switch-input {
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  display: none;
  visibility: hidden;
}

.switch .switch-label {
  position: relative;
  display: block;
  height: inherit;
  font-size: 0.625rem;
  font-weight: 600;
  text-transform: uppercase;
  background-color: #fff;
  border: 1px solid #c2cfd6;
  border-radius: 4px;
  transition: opacity background-color 0.3s 0.3s ease-out;
}

.switch .switch-handle {
  position: absolute;
  top: 3px;
  left: 3px;
  width: 24px;
  height: 24px;
  background: #fff;
  border: 1px solid #c2cfd6;
  border-radius: 1px;
  transition: left 0.3s ease-out;
}

.switch .switch-input:checked~.switch-handle {
  left: 37px;
}

/* Switch context properties */
.switch-primary>.switch-input:checked~.switch-label {
  background-color: var(--admin-color) !important;
  border-color: var(--admin-color);
}

.switch-primary>.switch-input:checked~.switch-handle {
  border-color: transparent;
}

.switch-secondary>.switch-input:checked~.switch-label {
  background-color: var(--bs-body-color) !important;
  border-color: var(--bs-body-color);
}

.switch-secondary>.switch-input:checked~.switch-handle {
  border-color: transparent;
}

.switch-success>.switch-input:checked~.switch-label {
  background-color: #34c997 !important;
  border-color: #34c997;
}

.switch-success>.switch-input:checked~.switch-handle {
  border-color: transparent;
}

.switch-info>.switch-input:checked~.switch-label {
  background-color: #24c4da !important;
  border-color: #24c4da;
}

.switch-info>.switch-input:checked~.switch-handle {
  border-color: transparent;
}

.switch-warning>.switch-input:checked~.switch-label {
  background-color: #ddaa04 !important;
  border-color: #ddaa04;
}

.switch-warning>.switch-input:checked~.switch-handle {
  border-color: transparent;
}

.switch-danger>.switch-input:checked~.switch-label {
  background-color: #ec4a58 !important;
  border-color: #ec4a58;
}

.switch-danger>.switch-input:checked~.switch-handle {
  border-color: transparent;
}

/* Switch Pill */
.switch-pill .switch-handle,
.switch-pill .switch-label {
  border-radius: 50px !important;
}

/* Switch Outline */
.switch-outline-primary>.switch-input:checked~.switch-label {
  background-color: #ffffff !important;
  border-color: var(--admin-color);
}

.switch-outline-primary .switch-input:checked~.switch-label:after {
  color: var(--admin-color);
}

.switch-outline-primary>.switch-input:checked~.switch-handle {
  border-color: var(--admin-color);
}

.switch-outline-secondary>.switch-input:checked~.switch-label {
  background-color: #ffffff !important;
  border-color: var(--bs-body-color);
}

.switch-outline-secondary .switch-input:checked~.switch-label:after {
  color: var(--bs-body-color);
}

.switch-outline-secondary>.switch-input:checked~.switch-handle {
  border-color: var(--bs-body-color);
}

.switch-outline-success>.switch-input:checked~.switch-label {
  background-color: #ffffff !important;
  border-color: #34c997;
}

.switch-outline-success .switch-input:checked~.switch-label:after {
  color: #34c997;
}

.switch-outline-success>.switch-input:checked~.switch-handle {
  border-color: #34c997;
}

.switch-outline-info>.switch-input:checked~.switch-label {
  background-color: #ffffff !important;
  border-color: #24c4da;
}

.switch-outline-info .switch-input:checked~.switch-label:after {
  color: #24c4da;
}

.switch-outline-info>.switch-input:checked~.switch-handle {
  border-color: #24c4da;
}

.switch-outline-warning>.switch-input:checked~.switch-label {
  background-color: #ffffff !important;
  border-color: #ddaa04;
}

.switch-outline-warning>.switch-input:checked~.switch-label:after {
  color: #ddaa04;
}

.switch-outline-warning>.switch-input:checked~.switch-handle {
  border-color: #ddaa04;
}

.switch-outline-danger>.switch-input:checked~.switch-label {
  background-color: #ffffff !important;
  border-color: #ec4a58;
}

.switch-outline-danger>.switch-input:checked~.switch-label:after {
  color: #ec4a58;
}

.switch-outline-danger>.switch-input:checked~.switch-handle {
  border-color: #ec4a58;
}

/* Switch Outline Alternative */
.switch-outline-alt-primary>.switch-input:checked~.switch-label {
  background-color: #ffffff !important;
  border-color: var(--admin-color);
}

.switch-outline-alt-primary .switch-input:checked~.switch-label:after {
  color: var(--admin-color);
}

.switch-outline-alt-primary>.switch-input:checked~.switch-handle {
  background-color: var(--admin-color);
  border-color: var(--admin-color);
}

.switch-outline-alt-secondary>.switch-input:checked~.switch-label {
  background-color: #ffffff !important;
  border-color: var(--bs-body-color);
}

.switch-outline-alt-secondary>.switch-input:checked~.switch-label:after {
  color: var(--bs-body-color);
}

.switch-outline-alt-secondary>.switch-input:checked~.switch-handle {
  background-color: var(--bs-body-color);
  border-color: var(--bs-body-color);
}

.switch-outline-alt-success>.switch-input:checked~.switch-label {
  background-color: #ffffff !important;
  border-color: #34c997;
}

.switch-outline-alt-success>.switch-input:checked~.switch-label:after {
  color: #34c997;
}

.switch-outline-alt-success>.switch-input:checked~.switch-handle {
  background-color: #34c997;
  border-color: #34c997;
}

.switch-outline-alt-info>.switch-input:checked~.switch-label {
  background-color: #ffffff !important;
  border-color: #24c4da;
}

.switch-outline-alt-info>.switch-input:checked~.switch-label:after {
  color: #24c4da;
}

.switch-outline-alt-info>.switch-input:checked~.switch-handle {
  background-color: #24c4da;
  border-color: #24c4da;
}

.switch-outline-alt-warning>.switch-input:checked~.switch-label {
  background-color: #ffffff !important;
  border-color: #ddaa04;
}

.switch-outline-alt-warning>.switch-input:checked~.switch-label:after {
  color: #ddaa04;
}

.switch-outline-alt-warning>.switch-input:checked~.switch-handle {
  background-color: #ddaa04;
  border-color: #ddaa04;
}

.switch-outline-alt-danger>.switch-input:checked~.switch-label {
  background-color: #ffffff !important;
  border-color: #ec4a58;
}

.switch-outline-alt-danger>.switch-input:checked~.switch-label:after {
  color: #ec4a58;
}

.switch-outline-alt-danger>.switch-input:checked~.switch-handle {
  background-color: #ec4a58;
  border-color: #ec4a58;
}

/* Switch With Text */
.switch.switch-text,
.switch.switch-icon {
  position: relative;
  display: inline-block;
  vertical-align: top;
  width: 64px;
  height: 30px;
  background-color: transparent;
  cursor: pointer;
}

.switch.switch-text .switch-input,
.switch.switch-icon .switch-input {
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
}

.switch.switch-text .switch-label,
.switch.switch-icon .switch-label {
  position: relative;
  display: block;
  height: inherit;
  font-size: 0.625rem;
  font-weight: 600;
  text-transform: uppercase;
  background-color: #ffffff;
  border: 1px solid #c2cfd6;
  border-radius: 2px;
  transition: opacity background 0.3s ease-out;
}

.switch.switch-text .switch-handle,
.switch.switch-icon .switch-handle {
  position: absolute;
  top: 3px;
  left: 3px;
  width: 24px;
  height: 24px;
  background: #fff;
  border: 1px solid #c2cfd6;
  border-radius: 0.06rem;
  transition: left 0.3s ease-out;
}

.switch.switch-text .switch-label:after,
.switch.switch-text .switch-label:before {
  position: absolute;
  top: 50%;
  width: 50%;
  margin-top: -0.31rem;
  line-height: 1;
  font-size: 12px;
  font-weight: 400;
  font-family: "Roboto", sans-serif;
  text-align: center;
  transition: inherit;
}

.switch.switch-text .switch-label:before {
  right: 1px;
  color: #c2cfd6;
  content: attr(data-off);
}

.switch.switch-text .switch-label:after {
  left: 1px;
  color: #fff;
  content: attr(data-on);
  opacity: 0;
}

.switch.switch-text .switch-input:checked~.switch-label:before {
  opacity: 0;
}

.switch.switch-text .switch-input:checked~.switch-label:after {
  opacity: 1;
}

.switch.switch-text .switch-input:checked~.switch-handle {
  left: 37px;
}

/* Switch With Icon */
.switch.switch-icon .switch-label:after,
.switch.switch-icon .switch-label:before {
  position: absolute;
  top: 50%;
  width: 50%;
  margin-top: -8px;
  line-height: 1;
  font-size: 1rem;
  font-weight: 400;
  font-family: "Material Design Icons";
  text-align: center;
  transition: inherit;
}

.switch.switch-icon .switch-label:before {
  right: 1px;
  color: #c2cfd6;
  content: "";
}

.switch.switch-icon .switch-label:after {
  left: 1px;
  color: #fff;
  content: "";
  opacity: 0;
}

.switch.switch-icon .switch-input:checked~.switch-label:before {
  opacity: 0;
}

.switch.switch-icon .switch-input:checked~.switch-label:after {
  opacity: 1;
}

.switch.switch-icon .switch-input:checked~.switch-handle {
  left: 37px;
}

/*===== TABS =====*/
.notifications-menu .card-default .card-header-border-bottom {
  margin-bottom: 12px !important;
}

.nav-tabs .nav-item .nav-link {
  color: var(--text-color);
  font-size: 16px;
  font-weight: 500;
  padding: 8px 20px;
}

.nav-tabs .nav-item .nav-link.active {
  color: var(--admin-color);
}

.nav-tabs .nav-item .nav-link.disabled {
  color: var(--bs-body-color);
}

.nav-tabs .nav-item .nav-link.disabled:hover {
  cursor: not-allowed;
}

.nav-pills .nav-item .nav-link {
  color: var(--text-color);
  font-weight: 500;
  padding: 12px 20px;
}

.nav-pills .nav-item .nav-link.active {
  color: #ffffff;
  background: var(--admin-color);
}

.nav-pills .nav-item .nav-link.disabled {
  color: var(--bs-body-color);
}

.nav-pills .nav-item .nav-link.disabled:hover {
  cursor: not-allowed;
}

.tab-pane {
  line-height: 1.8;
}

/* Custom Tab Style - Fill */
.nav-style-fill.nav-pills {
  border: 2px solid var(--border-color);
  border-radius: 0.38rem;
  overflow: hidden;
}

.nav-style-fill.nav-pills .nav-link {
  border-radius: 0;
  padding-top: 0.94rem;
  padding-bottom: 0.94rem;
}

.nav-style-fill.nav-pills .nav-link.active,
.nav-style-fill.nav-pills .show>.nav-link {
  color: var(--admin-color);
  background-color: #f5f6fa;
}

.nav-tabs.nav-style-border {
  padding-left: 1.9rem;
  padding-right: 1.9rem;
  padding-bottom: 0.625rem;
}

@media (min-width: 768px) {
  .nav-tabs.nav-style-border {
    padding-bottom: 0;
  }
}

@media (min-width: 1500px) {
  .nav-tabs.nav-style-border {
    padding-left: 3.12rem;
    padding-right: 3.12rem;
  }
}

.nav-tabs.nav-style-border .nav-item {
  margin-right: 0.94rem;
}

@media (min-width: 768px) {
  .nav-tabs.nav-style-border .nav-item {
    margin-right: 2.19rem;
  }
}

@media (min-width: 1200px) {
  .nav-tabs.nav-style-border .nav-item {
    /* margin-right: 3.12rem; */
    margin-bottom: 0;
  }
}

@media (min-width: 1500px) {
  .nav-tabs.nav-style-border .nav-item {
    margin-right: 5rem;
  }
}

.nav-tabs.nav-style-border .nav-item .nav-link {
  padding: 20px 0 20px 0;
  color: var(--bs-gray-dark);
  position: relative;
  cursor: pointer;
}

.nav-tabs.nav-style-border .nav-item .nav-link .type-name {
  display: block;
}

.nav-tabs.nav-style-border .nav-item .nav-link:after {
  content: "";
  position: absolute;
  bottom: 14px;
  left: 0;
  height: 2px;
  background: var(--bs-gray-dark);
  width: 100%;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease-in;
}

@media (prefers-reduced-motion: reduce) {
  .nav-tabs.nav-style-border .nav-item .nav-link:after {
    transition: none;
  }
}

@media (min-width: 576px) {
  .nav-tabs.nav-style-border .nav-item .nav-link:after {
    bottom: -1px;
  }
}

.nav-tabs.nav-style-border .nav-item .nav-link.active:after {
  opacity: 1;
  visibility: visible;
}

.nav-tabs.nav-style-border .nav-item .nav-link:hover,
.nav-tabs.nav-style-border .nav-item .nav-link.active {
  border-color: transparent;
  background-color: transparent;
}

@media (min-width: 768px) {
  .nav-tabs.nav-style-border .nav-item:first-child {
    margin-bottom: 0.94rem;
  }
}

@media (min-width: 992px) {
  .nav-tabs.nav-style-border .nav-item:first-child {
    margin-bottom: 0;
  }
}

.nav-tabs.nav-style-border .nav-item:last-child {
  margin-bottom: 0;
}

/* Vertical Tabs */
.nav-tabs.nav-stacked {
  margin-right: 0;
  border-bottom: 0;
  border-right: none;
}

@media (min-width: 768px) {
  .nav-tabs.nav-stacked {
    border-right: 1px solid var(--border-color);
    padding-right: 0;
  }
}

.nav-tabs.nav-stacked .nav-item {
  margin: 0 !important;
  float: none !important;
  display: block !important;
}

.nav-tabs.nav-stacked .nav-item .nav-link {
  padding: 12px 0.94rem;
  margin-right: 0px;
  border-right: 0px;
  margin-right: -1px;
  border-color: transparent;
}

.nav-tabs.nav-stacked .nav-item .nav-link i {
  padding-right: 0.625rem;
}

.nav-tabs.nav-stacked .nav-item .nav-link.active {
  border: 1px solid var(--border-color);
}

@media (min-width: 768px) {
  .nav-tabs.nav-stacked .nav-item .nav-link.active {
    border-right: 0px;
    border-radius: 0;
    border-top-left-radius: 0.38rem;
    border-bottom-left-radius: 0.38rem;
  }

  .nav-tabs.nav-stacked .nav-item .nav-link.active:before {
    top: 0;
    width: 2px;
    height: 100%;
    bottom: 0px;
  }
}

/*===== TODO LIST ======*/
.todo-single-item {
  margin-bottom: 2.19em;
  position: relative;
}

.todo-single-item .task-content {
  white-space: nowrap;
  line-height: normal;
}

.todo-single-item .task-content span {
  margin-left: 1rem;
}

.todo-single-item>span {
  margin-left: 2rem;
  position: relative;
  display: inline-block;
  color: #000;
}

.todo-single-item>span.badge {
  color: #ffffff;
  transition: all 0.3s ease-in;
  display: inline-table;
}

@media (prefers-reduced-motion: reduce) {
  .todo-single-item>span.badge {
    transition: none;
  }
}

.todo-single-item.alert {
  padding: 0;
  font-weight: inherit;
  font-size: inherit;
}

.todo-single-item i.mdi {
  width: 20px;
  height: 20px;
  border: 1px solid #d4d5db;
  border-radius: 50%;
  margin-right: 0.38rem;
  position: relative;
  overflow: hidden;
  text-align: center;
  line-height: 1.3rem;
  position: absolute;
  left: 0;
  transition: all 0.3s ease-in;
}

@media (prefers-reduced-motion: reduce) {
  .todo-single-item i.mdi {
    transition: none;
  }
}

.todo-single-item i.mdi:hover {
  border-color: rgba(52, 201, 151, 0.5);
  background-color: rgba(52, 201, 151, 0.2);
  cursor: pointer;
}

.todo-input {
  display: none;
}

.todo-input input {
  margin-top: -0.31rem;
  border: none;
  font-size: 15px;
  padding: 0.312rem 0.625rem;
}

.todo-input input:active,
.todo-input input:focus {
  box-shadow: 0px 2px 8px rgba(86, 96, 110, 0.2);
}

.todo-single-item.finished>span {
  color: var(--bs-body-color);
  text-decoration: line-through;
}

.todo-single-item.finished>span.badge {
  text-decoration: none;
  background-color: #cfd0d8;
  color: var(--bs-body-color);
}

.todo-single-item.finished i.mdi {
  background-color: transparent;
  border-color: #d4d5db;
}

.todo-single-item.finished i.mdi:after {
  content: "";
  font-size: 0.75rem;
  color: #34c997;
  font-family: "Material Design Icons";
  font-weight: bold;
}

.todo-single-item.finished .task-content span.badge {
  text-decoration: none;
  background-color: #cfd0d8;
  color: var(--bs-body-color);
}

.remove-task {
  transition: all 0.3s;
  fill: #cfd0d8;
  cursor: pointer;
}

.remove-task:hover {
  fill: rgba(236, 74, 88, 0.7);
}

.todo-form i.mdi {
  border-color: transparent;
  font-size: 20px;
  width: auto;
  height: auto;
  margin-right: 0;
  position: absolute;
  right: 0;
}

@media (min-width: 992px) {
  .todo-form i.mdi {
    font-size: 25px;
  }
}

.todo-form i.mdi:hover {
  border-color: transparent;
  background-color: transparent;
}

/*===== FONTS SIZE =====*/
.font-size-10 {
  font-size: 10px;
}

.font-size-11 {
  font-size: 11px;
}

.font-size-12 {
  font-size: 12px;
}

.font-size-13 {
  font-size: 13px;
}

.font-size-14 {
  font-size: 14px;
}

.font-size-15 {
  font-size: 15px;
}

.font-size-16 {
  font-size: 16px;
}

.font-size-17 {
  font-size: 17px;
}

.font-size-18 {
  font-size: 18px;
}

.font-size-19 {
  font-size: 19px;
}

.font-size-20 {
  font-size: 20px;
}

.salesOverviewCard .card {
  margin: 0 10px;
}

.salesOverviewCard .card:first-child {
  margin-left: 0;
}

/*===== TABLES =====*/
@media (max-width: 767.98px) {
  div.dataTables_wrapper div.dataTables_paginate ul.pagination {
    justify-content: flex-start;
  }
}

div.dataTables_wrapper div.dataTables_length select {
  margin: 0 5px;
  border-color: var(--border-color);
  border-radius: 10px;
}

div.dataTables_wrapper div.dataTables_filter input {
  border-color: var(--border-color);
  border-radius: 10px;
}

.bottom-information {
  /* margin-top: 15px !important; */
  align-items: center;
}

@media (max-width: 575.98px) {
  .dataTables_length {
    width: 100% !important;
    margin-bottom: 15px;
  }
}

@media (max-width: 575.98px) {
  #responsive-data-table_filter {
    width: 100% !important;
  }
}

@media (max-width: 575.98px) {
  .dataTables_info {
    display: none;
  }
}

.table> :not(:first-child) {
  border-top: 1px solid var(--border-color);
}

table.dataTable td {
  vertical-align: middle;
}

table.dataTable td .dropdown-menu {
  top: 30px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
}

table.dataTable td .btn-group button {
  padding: 3px 10px;
}

table.dataTable td .btn-group button:first-child {
  border-radius: 15px 0 0 15px !important;
}

table.dataTable td .btn-group button:nth-last-child(-n+2) {
  border-radius: 0 15px 15px 0 !important;
}

.ec-tbl .ec-tbl-content {
  overflow-y: auto;
}

.ec-tbl .ec-tbl-content table {
  min-width: 800px;
}

div.dataTables_wrapper div.dataTables_info,
div.dataTables_wrapper div.dataTables_paginate {
  width: auto !important;
  padding: 0 !important;
}

th {
  font-weight: 500;
  font-size: 15px;
}

thead th,
tbody tr td:first-child {
  color: var(--bs-black-rgb);

}

.table-secondary td {
  background-color: #ffffff;
  color: var(--bs-black-rgb);
}

.table-primary {
  background-color: rgba(136, 170, 243, 0.6);
  color: var(--text-color);
}

.table-info {
  background-color: rgba(36, 196, 218, 0.6);
  color: var(--text-color);
}

.table-success {
  background-color: rgba(52, 201, 151, 0.6);
  color: var(--text-color);
}

.table-danger {
  background-color: rgba(236, 74, 88, 0.6);
  color: var(--text-color);
}

.table-warning {
  background-color: rgba(221, 170, 4, 0.6);
  color: var(--text-color);
}

.table-dark thead th,
.table-dark tbody tr td:first-child {
  color: #ffffff;
}

/* Table borderless */
.table-borderless th,
.table-borderless td {
  border: 1px solid transparent;
}

.table-borderless thead th {
  border-bottom: 1px solid transparent;
  font-size: 0.81rem;
  color: var(--bs-body-color);
  font-weight: 400;
}

.table-borderless tbody tr a.link {
  color: var(--text-color);
}

.table-borderless tbody tr a.link:hover {
  color: var(--admin-color);
}

/* Card Table */
.card-table {
  margin-top: 20px;
  margin-bottom: 0;
}

.card-table thead th {
  font-size: 14px;
  font-weight: 500;
  padding: 0 1.9rem 1.25rem 0;
  color: var(--bs-body-color);
}

@media (min-width: 768px) {
  .card-table thead th {
    font-size: 14px;
  }
}

.card-table tbody td {
  padding: 15px 15px 15px 0;
  vertical-align: middle;
  margin: 0.625rem 0 0.625rem;
  font-size: 0.81rem;
}

@media (min-width: 768px) {
  .card-table tbody td {
    font-size: 15px;
  }
}

.card-table tbody td a:hover {
  color: var(--admin-color) !important;
}

.card-table tbody tr {
  position: relative;
  transition: box-shadow 0.3s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .card-table tbody tr {
    transition: none;
  }
}

.card-table tbody tr td:first-child {
  color: var(--bs-body-color);
}

.card-table .avater {
  width: 45px;
  height: 45px;
  overflow: hidden;
}

@media (min-width: 1200px) {
  .table-responsive-large {
    display: inline-table;
  }
}

/* Customer Table */
.customer-table .media-image {
  width: 45px;
  height: 45px;
  overflow: hidden;
}

.customer-table .media-image img {
  max-width: 100%;
}

.customer-table .media-body h6,
.customer-table .media-body .h6 {
  font-size: 15px;
  font-weight: 500;
}

/* Notification Block */
.notification-table .table-header {
  margin-bottom: 1.9rem;
}

.notification-table .media {
  max-width: 70%;
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.notification-table .media-icon {
  color: #ffffff;
  font-size: 1rem;
}

.notification-table .media-icon.cat-1 {
  background-color: var(--admin-color);
}

.notification-table .media-icon.cat-2 {
  background-color: #34c997;
}

.notification-table .media-icon.cat-3 {
  background-color: #ddaa04;
}

.notification-table .media-icon.cat-4 {
  background-color: #24c4da;
}

.notification-table .media-body a {
  font-size: 15px;
  color: var(--text-color);
  display: inline-block;
}

.notification-table .media-body a:hover {
  color: var(--admin-color);
}

.notification-table .media-body p {
  font-size: 0.81rem;
}

/* Products Table */
.products-table .table-header {
  padding-bottom: 0.94rem;
}

.products-table table tr td {
  vertical-align: middle;
  padding-top: 1.9rem;
}

.products-table a.dropdown-toggle:after {
  display: none;
}

.products-table .media {
  margin-top: 2.19rem;
}

@media (min-width: 1200px) {
  .products-table .media {
    margin-top: 2.81rem;
  }
}

@media (min-width: 1500px) {
  .products-table .media {
    margin-top: 2.19rem;
  }
}

.products-table .media .media-body {
  padding-right: 1.25rem;
}

.products-table .media .media-body a {
  color: var(--text-color);
}

.products-table .media .media-body a h6,
.products-table .media .media-body a .h6 {
  font-size: 15px;
  margin-bottom: 0.625rem;
  font-weight: 500;
  color: inherit;
}

.products-table .media .media-body a:hover {
  color: var(--admin-color);
}

.products-table .media .media-body>p {
  margin-bottom: 0.31rem;
  line-height: 1.5;
}

/* Data Tables */
.expendable-data-table,
.basic-data-table {
  overflow-x: scroll;
}

@media (min-width: 1500px) {

  .expendable-data-table,
  .basic-data-table {
    overflow-x: hidden;
  }
}

.expendable-data-table .table,
.basic-data-table .table,
.responsive-data-table .table {
  border-top: 0;
  margin: 25px 0 !important;
}

.expendable-data-table .table.table-borderless thead th,
.basic-data-table .table.table-borderless thead th,
.responsive-data-table .table.table-borderless thead th {
  border-bottom: 1px solid transparent;
}

.expendable-data-table .table-bordered thead th,
.expendable-data-table .table-bordered thead td,
.basic-data-table .table-bordered thead th,
.basic-data-table .table-bordered thead td,
.responsive-data-table .table-bordered thead th,
.responsive-data-table .table-bordered thead td {
  border-bottom-width: 1px;
}

.expendable-data-table .table thead th,
.basic-data-table .table thead th,
.responsive-data-table .table thead th {
  border-bottom: 1px solid var(--border-color);
}

.expendable-data-table thead th,
.expendable-data-table tbody tr td:first-child,
.basic-data-table thead th,
.basic-data-table tbody tr td:first-child,
.responsive-data-table thead th,
.responsive-data-table tbody tr td:first-child {
  color: #1b223c;
  font-weight: 500;
  font-size: 14px;
}

.expendable-data-table table.dataTable>tbody>tr.child span.dtr-title,
.basic-data-table table.dataTable>tbody>tr.child span.dtr-title,
.responsive-data-table table.dataTable>tbody>tr.child span.dtr-title {
  font-weight: 500;
}

.expendable-data-table .top-information,
.expendable-data-table .bottom-information,
.basic-data-table .top-information,
.basic-data-table .bottom-information,
.responsive-data-table .top-information,
.responsive-data-table .bottom-information {
  padding: 0 15px;
  align-items: center;
}

.expendable-data-table .dataTables_filter,
.basic-data-table .dataTables_filter,
.responsive-data-table .dataTables_filter {
  display: inline-block !important;
}

.expendable-data-table .dataTables_filter label,
.basic-data-table .dataTables_filter label,
.responsive-data-table .dataTables_filter label {
  margin-bottom: 0;
}

.expendable-data-table .dataTables_filter label .form-control-sm,
.basic-data-table .dataTables_filter label .form-control-sm,
.responsive-data-table .dataTables_filter label .form-control-sm {
  height: 30px;
  border-radius: 10px;
}

.expendable-data-table .dataTables_length,
.basic-data-table .dataTables_length,
.responsive-data-table .dataTables_length {
  display: inline-block !important;
}

.expendable-data-table .dataTables_length label,
.basic-data-table .dataTables_length label,
.responsive-data-table .dataTables_length label {
  margin-bottom: 0;
}

.expendable-data-table .dataTables_length label .custom-select-sm,
.basic-data-table .dataTables_length label .custom-select-sm,
.responsive-data-table .dataTables_length label .custom-select-sm {
  height: 30px;
  margin: 0 10px;
  cursor: pointer;
  border-radius: 10px;
}

.expendable-data-table .dataTables_length .custom-select,
.basic-data-table .dataTables_length .custom-select,
.responsive-data-table .dataTables_length .custom-select {
  background: transparent;
}

.expendable-data-table .dataTables_info,
.basic-data-table .dataTables_info,
.responsive-data-table .dataTables_info {
  padding-top: 7px !important;
}

@media (min-width: 768px) {

  .expendable-data-table .dataTables_info,
  .basic-data-table .dataTables_info,
  .responsive-data-table .dataTables_info {
    margin-bottom: 0;
    opacity: 0;
  }
}

@media (min-width: 992px) {

  .expendable-data-table .dataTables_info,
  .basic-data-table .dataTables_info,
  .responsive-data-table .dataTables_info {
    padding-top: 1.2em !important;
    opacity: 1;
  }
}

@media (min-width: 1200px) {

  .expendable-data-table .dataTables_info,
  .basic-data-table .dataTables_info,
  .responsive-data-table .dataTables_info {
    padding-top: 1em !important;
  }
}

.expendable-data-table .pagination .disabled .page-link,
.basic-data-table .pagination .disabled .page-link,
.responsive-data-table .pagination .disabled .page-link {
  background-color: transparent !important;
}

.expendable-data-table table.dataTable.dtr-inline.collapsed>tbody>tr[role=row]>td:first-child:before,
.expendable-data-table table.dataTable.dtr-inline.collapsed>tbody>tr[role=row]>th:first-child:before,
.basic-data-table table.dataTable.dtr-inline.collapsed>tbody>tr[role=row]>td:first-child:before,
.basic-data-table table.dataTable.dtr-inline.collapsed>tbody>tr[role=row]>th:first-child:before,
.responsive-data-table table.dataTable.dtr-inline.collapsed>tbody>tr[role=row]>td:first-child:before,
.responsive-data-table table.dataTable.dtr-inline.collapsed>tbody>tr[role=row]>th:first-child:before {
  background-color: #34c997;
  top: 14px;
  width: 16px;
  height: 16px;
  line-height: 16px;
  border: 0;
  font-weight: bold;
  box-shadow: none;
}

.expendable-data-table table.dataTable.dtr-inline.collapsed>tbody>tr.parent>td:first-child:before,
.expendable-data-table table.dataTable.dtr-inline.collapsed>tbody>tr.parent>th:first-child:before,
.basic-data-table table.dataTable.dtr-inline.collapsed>tbody>tr.parent>td:first-child:before,
.basic-data-table table.dataTable.dtr-inline.collapsed>tbody>tr.parent>th:first-child:before,
.responsive-data-table table.dataTable.dtr-inline.collapsed>tbody>tr.parent>td:first-child:before,
.responsive-data-table table.dataTable.dtr-inline.collapsed>tbody>tr.parent>th:first-child:before {
  background-color: #ddaa04;
}

.expendable-data-table table.dataTable.hover tbody tr:hover,
.expendable-data-table table.dataTable.display tbody tr:hover,
.basic-data-table table.dataTable.hover tbody tr:hover,
.basic-data-table table.dataTable.display tbody tr:hover,
.responsive-data-table table.dataTable.hover tbody tr:hover,
.responsive-data-table table.dataTable.display tbody tr:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

#basic-data-table_next .page-link,
#basic-data-table_previous .page-link,
#responsive-data-table_previous .page-link,
#responsive-data-table_next .page-link,
#expendable-data-table_previous .page-link,
#expendable-data-table_next .page-link {
  background-color: #e9ecef;
}

/* Responsive Data Tables */
.responsive-data-table table.dataTable.dtr-inline.collapsed>tbody>tr[role=row]>td:first-child,
.responsive-data-table table.dataTable.dtr-inline.collapsed>tbody>tr[role=row]>th:first-child {
  padding-left: 40px;
}

.responsive-data-table table.dataTable.dtr-inline.collapsed>tbody>tr[role=row]>td:first-child:before,
.responsive-data-table table.dataTable.dtr-inline.collapsed>tbody>tr[role=row]>th:first-child:before {
  left: 10px;
}

/* Expendable Data Tables */
.expendable-data-table .dataTable {
  margin: 25px 0 !important;
}

.expendable-data-table table.dataTable.display tbody tr.odd>.sorting_1,
.expendable-data-table table.dataTable.display tbody tr.even>.sorting_1,
.expendable-data-table table.dataTable.order-column.stripe tbody tr.odd>.sorting_1,
.expendable-data-table table.dataTable.order-column.stripe tbody tr.even>.sorting_1,
.expendable-data-table table.dataTable thead .sorting_asc,
.expendable-data-table table.dataTable thead .sorting {
  background-color: transparent;
  font-weight: 500;
  color: var(--text-color);
}

.expendable-data-table table.dataTable.display tbody tr.odd,
.expendable-data-table table.dataTable.display tbody tr:hover {
  background-color: transparent;
}

.expendable-data-table table.dataTable.display tbody td {
  border-top: 1px solid var(--border-color);
}

.expendable-data-table .table-bordered.table.dataTable.display tbody tr[role] td {
  padding: 12px 12px;
}

.expendable-data-table table.dataTable.display tbody tr[role] td {
  border-top: 1px solid var(--border-color);
  padding: 12px 0px;
}

.expendable-data-table .table-borderless.table.dataTable thead th,
.expendable-data-table .table-borderless.table.dataTable tbody td,
.expendable-data-table .table-borderless.table.dataTable.display tbody tr[role] td {
  border-top: 1px solid transparent;
}

.expendable-data-table .table-striped tbody tr[role]:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.05) !important;
}

.expendable-data-table .table-striped tbody tr:nth-of-type(odd) {
  background-color: transparent;
}

.expendable-data-table table.dataTable tbody td {
  border-top: 1px solid var(--border-color);
}

.expendable-data-table table.dataTable thead th {
  border-top: 1px solid var(--border-color);
  border-bottom: 1px solid var(--border-color);
  padding: 12px 18px;
}

.expendable-data-table table.dataTable.no-footer {
  border-bottom: 1px solid transparent;
}

.expendable-data-table .dataTables_wrapper .dataTables_paginate .paginate_button {
  padding: 0;
  margin-left: -2px;
  background: linear-gradient(to bottom, transparent 0%, transparent 100%);
}

.expendable-data-table .dataTables_wrapper .dataTables_paginate .paginate_button:hover {
  border: 1px solid #ffffff;
}

.expendable-data-table .dataTables_wrapper .dataTables_paginate .paginate_button:active {
  box-shadow: none;
}

.expendable-data-table .dataTables_wrapper .dataTables_paginate {
  padding-top: 0;
}

.expendable-data-table .table-bordered.table.dataTable thead .sorting_asc,
.expendable-data-table .table-bordered.table.dataTable thead .sorting {
  padding-left: 12px;
}

.expendable-data-table .table-bordered.table.dataTable.no-footer {
  border-bottom: 1px solid var(--border-color);
}

.expendable-data-table table.dataTable thead .sorting_asc,
.expendable-data-table table.dataTable thead .sorting {
  background: transparent;
  padding-left: 0px;
}

.expendable-data-table table.dataTable thead th:first-child:before,
.expendable-data-table table.dataTable thead th:first-child:after {
  display: none;
}

.expendable-data-table table.dataTable thead .sorting:before,
.expendable-data-table table.dataTable thead .sorting_desc:before,
.expendable-data-table table.dataTable thead .sorting_asc:before {
  right: 2em;
}

.expendable-data-table table.dataTable thead .sorting:after,
.expendable-data-table table.dataTable thead .sorting_desc:after,
.expendable-data-table table.dataTable thead .sorting_asc:after {
  right: 1.5em;
}

.expendable-data-table .dataTables_filter,
.expendable-data-table .dataTables_length,
.expendable-data-table .dataTables_wrapper .dataTables_info {
  color: var(--bs-body-color);
}

.expendable-data-table .dataTables_filter,
.expendable-data-table .dataTables_info,
.expendable-data-table .dataTables_length {
  margin-top: 0;
  padding-top: 0 !important;
}

.expendable-data-table .top-information,
.expendable-data-table .bottom-information {
  padding: 0 16px;
}

.expendable-data-table th.details-control.sorting_disabled {
  width: 1px !important;
}

.expendable-data-table table.dataTable thead>tr>th.sorting_desc {
  padding-left: 0;
  font-weight: 500;
}

.expendable-data-table tr.shown td.details-control,
.expendable-data-table td.details-control {
  position: relative;
  background: transparent;
  cursor: pointer;
}

.expendable-data-table tr.shown td.details-control::before,
.expendable-data-table td.details-control::before {
  position: absolute;
  content: "+";
  font-family: "Courier New", Courier, monospace;
  top: 14px;
  left: 50%;
  transform: translateX(-50%);
  width: 16px;
  height: 16px;
  line-height: 16px;
  color: #ffffff;
  border-radius: 16px;
  text-align: center;
  font-weight: bold;
  background-color: #34c997;
}

.expendable-data-table tr.shown td.details-control::before {
  content: "-";
  background-color: #ddaa04;
}

.expendable-data-table .table-hover tbody tr:hover {
  color: var(--text-color);
}

.expendable-data-table .table-hover.table.dataTable.hover tbody tr[role]:hover,
.expendable-data-table .table-hover.table.dataTable.display tbody tr[role]:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

div.dataTables_wrapper div.dataTables_length,
div.dataTables_wrapper div.dataTables_filter {
  flex: 0 0 auto;
  width: 50%;
}

/*===== WIDGETS =====*/
.profile-content .profile-left-spacing {
  padding: 24px 0 24px 24px;
}

@media (max-width: 991.98px) {
  .profile-content .profile-left-spacing {
    padding: 24px 24px 0 24px;
  }
}

.profile-content .profile-left-spacing .btn {
  border-radius: 15px;
}

.profile-content .nav-tabs.nav-style-border {
  padding-bottom: 0;
}

.profile-content .nav-tabs.nav-style-border .nav-item:first-child {
  margin-bottom: 0;
}

.widget-block {
  position: relative;
  padding: 1.9rem;
  margin-bottom: 1.9rem;
}

.widget-block.bg-primary {
  border-color: var(--admin-color);
}

.widget-block.bg-primary p {
  color: rgba(255, 255, 255, 0.7);
}

.widget-block.bg-primary .progress {
  background: rgba(255, 255, 255, 0.5);
}

.widget-block.bg-warning {
  border-color: #ddaa04;
}

.widget-block.bg-warning p {
  color: rgba(255, 255, 255, 0.7);
}

.widget-block.bg-warning .progress {
  background: rgba(255, 255, 255, 0.5);
}

.widget-block.bg-danger {
  border-color: #ec4a58;
}

.widget-block.bg-danger p {
  color: rgba(255, 255, 255, 0.7);
}

.widget-block.bg-danger .progress {
  background: rgba(255, 255, 255, 0.5);
}

.widget-block.bg-success {
  border-color: #34c997;
}

.widget-block.bg-success p {
  color: rgba(255, 255, 255, 0.7);
}

.widget-block.bg-success .progress {
  background: rgba(255, 255, 255, 0.5);
}

.widget-block i {
  font-size: 1.38rem;
}

.widget-chart {
  height: 70px;
}

.widget-chart #barChart {
  width: 100%;
  height: 100%;
}

.widget-media {
  position: relative;
  padding: 24px;
  margin-bottom: 24px;
  border-radius: 15px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.03);
}

.widget-media .icon {
  width: 60px;
  height: 60px;
  text-align: center;
  line-height: 60px;
}

.widget-media i {
  font-size: 26px;
}

.widget-profile .card-img {
  width: 100px;
  height: 100px;
  overflow: hidden;
}

.widget-profile .card-img img {
  width: 100%;
}

/* Widgets Dropdown */
.widget-dropdown .dropdown-toggle {
  color: var(--bs-body-color);
  text-transform: uppercase;
}

.widget-dropdown .dropdown-toggle.icon-burger-mini {
  font-size: 1.5rem;
  position: relative;
}

.widget-dropdown .dropdown-toggle.icon-burger-mini:after {
  display: none;
}

.widget-dropdown .dropdown-toggle.icon-burger-mini:before {
  font-family: "Material Design Icons";
  content: "";
}

.widget-dropdown .dropdown-menu {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  box-shadow: 0px 5px 18px 0px rgba(229, 233, 242, 0.5);
  min-width: auto;
  right: 0 !important;
  left: auto !important;
}

.widget-dropdown .dropdown-menu .dropdown-item {
  padding: 0.3125rem 1.25rem;
}

.widget-dropdown .dropdown-menu .dropdown-item a {
  font-size: 0.875rem;
  color: var(--bs-body-color);
  text-transform: capitalize;
}

.widget-dropdown .dropdown-menu .dropdown-item:hover {
  background-color: transparent;
}

.widget-dropdown .dropdown-menu .dropdown-item:hover a {
  color: var(--admin-color);
}

/*===== COMPACT SPACING =====*/
.compact-spacing {
  /* Navbar */
  /* Github Icon */
  /* App Brand */
  /* App Brand */
  /* Right Sidebar 2 */
  /* Header Fix */
  /* Content */
  /* Sidebar */
  /* Compact Units */
  /* Compact Notifications */
  /* Media */
  /* Card */
  /* Analytics Data Height */
  /* Polar Data Content */
  /* Profile Data Height */
  /* Activity Data Spacing */
  /* User Profile */
  /* Invoice Wrapper */
  /* Table */
  /* Copyright */
}

.compact-spacing .navbar {
  min-height: 60px;
  transition: all 0.3s;
  /* Navbar Right */
}

.compact-spacing .navbar .sidebar-offcanvas-toggle,
.compact-spacing .navbar .sidebar-toggle {
  height: 60px;
}

.compact-spacing .navbar .navbar-right .navbar-nav .user-menu .dropdown-toggle {
  line-height: 60px;
}

.compact-spacing .navbar .navbar-right .navbar-nav .notifications-menu .dropdown-toggle {
  line-height: 60px;
}

.compact-spacing .navbar .navbar-right .navbar-nav .right-sidebar-2-menu i {
  line-height: 60px;
}

.compact-spacing .github-link {
  top: -8px;
}

.compact-spacing .github-link i {
  top: 0px;
  right: 5px;
}

.compact-spacing .github-link svg {
  width: 69px;
  height: 69px;
}

.compact-spacing .ec-brand span {
  height: 62px;
  line-height: 62px;
  transition: all 0.3s;
}

.compact-spacing #toast-container {
  margin-top: 50px;
}

.compact-spacing .right-sidebar-container-2 .right-sidebar-2-header {
  padding: 11.5px 30px;
  transition: all 0.3s;
}

.compact-spacing.ec-header-fixed .ec-page-wrapper {
  padding-top: 3.875rem;
}

@media (min-width: 1200px) {
  .compact-spacing .content {
    padding: 24px;
    transition: all 0.3s;
  }
}

.compact-spacing .sidebar .sidebar-inner>li>span {
  padding: 12px 25px;
}

.compact-spacing .compact-units {
  height: 365px !important;
}

.compact-spacing .compact-notifications {
  height: 415px !important;
}

.compact-spacing .media-border-bottom {
  padding-left: 2rem !important;
  padding-right: 2rem !important;
}

.compact-spacing .card-table-border-none .card-header,
.compact-spacing .card-default .card-header {
  padding: 15px;
}

.compact-spacing .card-table-border-none .card-body,
.compact-spacing .card-default .card-body {
  padding: 15px;
}

.compact-spacing .card-table-border-none .card-footer,
.compact-spacing .card-default .card-footer {
  padding-left: 15px;
  padding-right: 15px;
}

.compact-spacing .card-table-border-none .card-footer a,
.compact-spacing .card-default .card-footer a {
  padding: 7px 0 !important;
}

.compact-spacing [analytics-data-height] {
  height: 573px;
}

.compact-spacing [polar-data-content] {
  margin-bottom: 20px;
}

.compact-spacing [Profile-data-height] {
  min-height: 520px;
}

.compact-spacing [activity-data-spacing] {
  margin-bottom: 39px;
}

.compact-spacing .profile-right-spacing {
  padding: 1.88rem 0 !important;
}

.compact-spacing .profile-right-spacing .nav-style-border {
  padding-left: 1.88rem !important;
  padding-right: 1.88rem !important;
}

.compact-spacing .profile-right-spacing .tab-content {
  padding-left: 1.88rem !important;
  padding-right: 1.88rem !important;
}

.compact-spacing .profile-right-spacing .tab-content .tab-pane-content {
  margin-top: 1.88rem !important;
}

.compact-spacing .profile-right-spacing .tab-content .tab-pane-content .form-group {
  margin-bottom: 1.5rem !important;
}

.compact-spacing .tab-widget,
.compact-spacing .timeline-media-spacing {
  margin-top: 15px !important;
}

.compact-spacing .invoice-wrapper {
  padding: 15px !important;
}

.compact-spacing .recent-orders .card-body {
  padding-bottom: 0 !important;
}

.compact-spacing .card-table {
  margin-top: 1rem;
}

.compact-spacing .copyright {
  padding-top: 1.35rem;
  padding-bottom: 1.35rem;
}

.compact-spacing .right-sidebar-2-body {
  padding: 0 15px;
}

.compact-spacing .right-sidebar-2-body .no-col-space {
  margin-bottom: 20px;
}

/** Options sidebar css **/
.ec-tools-sidebar-overlay {
  display: none;
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 17;
}

.right-sidebar-2-body .no-col-space {
  border: solid 1px #eee !important;
  border-radius: 15px;
}

.right-sidebar-container-2 .btn-right-sidebar-2 {
  width: 50% !important;
  margin-right: 0 !important;
  border: 0;
  border-radius: 15px;
}

.right-sidebar-container-2 .btn-right-sidebar-2.btn-right-sidebar-2-active {
  background-color: #eee !important;
  color: #777777 !important;
  text-decoration: none !important;
  margin-right: 0 !important;
  border-radius: 15px !important;
}

.right-sidebar-container-2 .right-sidebar-2-select {
  background: #eee;
  color: #777777;
  border: none;
  border-radius: 15px;
}



.card-body.defaultText {
  min-height: 330px;
  display: flex;
  justify-content: space-around;
  flex-direction: column;
}

.filterTab .nav-style-border {
  margin: 0 0 0 0;
  padding: 0;
  /* border-bottom: 1px solid rgb(222, 226, 230); */
}

.filterTab .search-form {
  width: 350px;
  position: relative;
  margin-right: auto;
  padding-left: 0;
  background-color: var(--gray-bg-color);
  border-radius: var(--border-radius);
  height: 35px;
}

.filterTab .col-lg-7 {
  padding-right: 0;
}

.filterTab .col-lg-5 {
  /* border-bottom: 1px solid rgb(222, 226, 230); */
  /* padding-left: 0; */
}

.filterTab .nav-tabs .nav-link {
  margin-bottom: 0px;
}

.filterTab .nav-tabs.nav-style-border .nav-item .nav-link {
  padding: 10px 0 10px 0;
}

#productTypeFilter,
#productTypeFilter:focus,
#productTypeFilter:active,
#storeFilter,
#storeFilter:focus,
#storeFilter:active {
  box-shadow: none !important;
  outline: none;
}


.card-default .card-body p.addressChangeBtn {
  color: var(--admin-color);
  cursor: pointer;
  text-decoration: underline;
}

.createOrderPage .form-group label,
.createOrderPage .input-group label {
  /* color: rgb(138, 144, 157) */
}

.editOrderPage .form-group label,
.editOrderPage .input-group label {
  /* color: rgb(138, 144, 157) */
}

.card.ordersCard {
  box-shadow: none;
  border: none;
  width: 800px;
  height: 550px;
  border: 1px solid #ced4da;
}

.card.ordersCard tbody tr {
  cursor: pointer;
}

.addaddress.small .form-group,
.editAddress.small .form-group {
  margin-bottom: 10px !important;
}

.addaddress.small .saveBtn,
.editAddress.small .saveBtn {
  text-align: right;
  padding: 0 30px 24px 0;
}

.editAddress .hideStatus {
  display: none;
}

.addaddress.small .mdi-arrow-left,
.editAddress.small .mdi-arrow-left {
  font-size: 22px;
  cursor: pointer;
}

.navAndSearchWrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid var(--border-color);
  width: 100%;
  border-radius: 10px;
  padding: 10px 10px;
}


/* custome css */

/* MyProfile css start */

.rest_email_message .resetLink {
  color: var(--admin-color);
  cursor: pointer;
  border-bottom: 1px solid;
}

/* MyProfile css end */

input {
  font-size: 14px;
  height: 35px;
  padding: 0.5rem 1.06rem;
  border-color: var(--border-color);
  margin-bottom: 18px;
}

textarea {
  font-size: 14px;
  padding: 0.5rem 1.06rem;
  border-color: var(--border-color);
  margin-bottom: 18px;
}

.search-form .input-group input {
  font-size: 14px;
  /* height: 48px !important; */
  padding: 0.5rem 1.06rem;
  border-color: var(--border-color);
  margin-bottom: 0px !important;
}

#search-results input {
  height: 100%;
  margin: 0;
}

.SearchGroup input {
  /* height: 47px; */
  margin: 0;
}

.search_icon {
  padding: 7px 14px;
}

.search-form .input-group span {
  margin: auto;
}

#search-results span {
  /* margin: auto; */
}

/* Change the background color of the saved input fields */
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
textarea:-webkit-autofill,
textarea:-webkit-autofill:hover,
textarea:-webkit-autofill:focus,
select:-webkit-autofill,
select:-webkit-autofill:hover,
select:-webkit-autofill:focus {
  color: var(--bs-black-rgb) !important;
  background-color: #fdfdfd !important;
  -webkit-transition: background-color 5000s ease-in-out 0s;
  transition: background-color 5000s ease-in-out 0s;
}

/* Change the text color of the saved input fields */
input:-webkit-autofill::first-line {
  color: var(--bs-black-rgb) !important;
}

.form-control input {
  border-color: var(--border-color)
}

.form-control select {
  border-color: var(--border-color)
}

.SearchGroup {
  height: 35px;
}

.SearchGroup span {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
}

.select_store p {
  height: 50vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.mandatory_field::after {
  content: "*";
  color: red;
  padding-left: 5px;
  font-size: 14px;
}

.optional {
  color: #ff8c8c;
}

.table_loader {
  z-index: 5;
  background-color: white !important;
  width: 95%;
  height: 50vh;
  border-radius: 10px;
  background: no-repeat;
}

.edit_page_loader {
  position: absolute;
  z-index: 5;
  background-color: white !important;
  width: 100%;
  height: 75vh;
  top: 5%;
  border-radius: 10px;
  background: no-repeat;
  margin-right: 30px;
}

.full_page_loader {
  position: absolute;
  z-index: 5;
  background-color: white !important;
  width: 100%;
  height: 100vh;
  top: 0;
  border-radius: 10px;
  background: no-repeat;
}

.page_loader {

  position: absolute;
  z-index: 5;
  background-color: white !important;
  width: 95%;
  height: 71vh;
  top: 30px;
  border-radius: 10px;
  background: no-repeat;
  margin-right: 30px;

}

.dashboard_page_loader {

  position: absolute;
  z-index: 5;
  background-color: white !important;
  width: 95%;
  height: 71vh;
  top: 75px;
  border-radius: 10px;
  background: no-repeat;
  margin-right: 30px;

}

.sales_and_fee_filterTab {
  /* display: flex; */
  /* justify-content: flex-end; */
  margin-bottom: 10px;
}

.sales_and_fee_filterTab .sales_and_fee_search_form {
  /* width: 350px; */
  position: relative;
  padding-left: 0;
  background-color: #f7f7f7;
  border-radius: var(--border-radius);
  height: 35px;
}


select {
  appearance: none;
  margin: 0;
  padding: 0;
  font-size: 100%;
  font-family: inherit;
  border: none;
  background: none;
}

/* Custom styles for the dropdown */
select {
  width: 200px;
  padding: 8px;
  /* border: 1px solid #ccc; */
  border-radius: 4px;
  background-color: #f7f7f7;
  color: var(--bs-black-rgb);
  font-size: 14px;
}

/* Style dropdown options */
select option {
  background-color: #f7f7f7;
  color: var(--bs-black-rgb);
  font-size: 14px;
  padding: 4px;
}

/* Hover effect on options */
select option:hover {
  background-color: #e3e3e3;
}

/* Focus effect on the dropdown */
select:focus {
  outline: none;
  border-color: #6c9ce8;
  box-shadow: 0 0 5px rgba(108, 156, 232, 0.5);
}

/* orders_list_page */

.orders_button_wrapper {
  margin-left: 50%;
}


.filter_dropDown_wrapper {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 20px;
  margin-bottom: 20px;
}

.fulfillment_wrapper {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  margin-top: 20px;
  margin-bottom: 20px;
}

.filter_operation_mode {
  width: 20%;
}

.filter_popup {
  position: fixed !important;
  top: 50% !important;
  left: 59%;
  transform: translate(-50%, -50%) !important;
  z-index: 9999 !important;
  background-color: #fff !important;
  padding: 20px !important;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.3) !important;
  width: 75%;
}

.filter_popup_height {
  /* height: 200px; */
}


.filter_operation_mode .from_and_to_date {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 300px;
}

.filter_operation_mode .from_and_to_date input {
  height: 41px;
  margin-bottom: 0;

}

.from_and_to_date .fillter_to_date {
  margin-left: 10px;
}

.close_fillter {
  position: absolute;
  right: 25px;
  cursor: pointer;
}

.close_fillter:hover {
  color: red;
}

.close_fillter_file_upload {
  position: absolute;
  right: 18px;
  top:15px;
  font-size: 18px;
  cursor: pointer;
}

.close_fillter_file_upload:hover {
  color: red;
}

.filter_by_order_id input {
  margin: 0;
  height: 41px;
}

.applied_filter_remove {
  position: absolute;
  right: 15px;
  top: 10px;
  font-size: 10px;
  cursor: pointer;
}

.applied_filter_remove:hover {
  color: red;
}

.add_fillter_btn {
  margin-left: 175px;
}

.fillter_message_Wrapper {
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.filterMessage {
  /* width: 25%; */
  margin: 20px 20px 20px 0px;
}

.fliter_operation_mode_btn {
  width: 20%;
  display: flex;
  justify-content: space-evenly;
  margin-top: 34px;
}

.filter_btn_with_date {
  margin-left: 130px;
}

.filter_dateWrapper {
  display: flex;
  flex-direction: column;
  width: 50%;
}

.filter_body {
  padding: 25px;
}

input[type="password"] {
  -webkit-text-security: disc;
  text-security: disc;
}

.abbr.no-style {
  text-decoration: none;
  border-bottom: none;
  cursor: default;
}


.no-scroll {
  overflow: hidden;
}

.no_recipient {
  height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.images_preview_block_wrapper {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
}

.images_preview_block_wrapper .images_preview_block {

  width: 43%;
}

.message_center {
  display: flex;
  justify-content: center;
  align-items: center
}

.recipient_header_wrapper {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.otp-input{
  width: 44px;
  margin-right: 10px;
  margin-top: 10px;
}

.input-password{
  position: relative;
  width: 320px !important;
  margin-top: 10px;
}

.otp-buttons{
  width: 320px;
  display: flex;
  justify-content:space-between;
}`, "",{"version":3,"sources":["webpack://./src/css/MarketPlace.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,uBAAuB;EACvB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,oBAAoB;EACpB,8BAA8B;EAC9B,6BAA6B;EAC7B,kCAAkC;EAClC,+BAA+B;EAC/B,qNAAqN;EACrN,yGAAyG;EACzG,yFAAyF;EACzF,4CAA4C;EAC5C,6BAA6B;EAC7B,0BAA0B;EAC1B,0BAA0B;EAC1B,wBAAwB;EACxB,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,0BAA0B;EAC1B,oBAAoB;EACpB,2BAA2B;EAC3B,qBAAqB;EACrB,6BAA6B;EAC7B,0BAA0B;EAC1B,2BAA2B;EAC3B,uBAAuB;EACvB,wBAAwB;EACxB,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;;;EAIE,sBAAsB;AACxB;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,SAAS;EACT,uCAAuC;EACvC,mCAAmC;EACnC,uCAAuC;EACvC,uCAAuC;EACvC,0BAA0B;EAC1B,qCAAqC;EACrC,yCAAyC;EACzC,8BAA8B;EAC9B,6CAA6C;AAC/C;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,8BAA8B;EAC9B,SAAS;EACT,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;;;;;;;;;;;;EAYE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;;EAEE;;IAEE,oBAAoB;EACtB;AACF;;AAEA;;EAEE,yCAAyC;AAC3C;;AAEA;;EAEE;;IAEE,sBAAsB;EACxB;AACF;;AAEA;;EAEE,uCAAuC;AACzC;;AAEA;;EAEE;;IAEE,qBAAqB;EACvB;AACF;;AAEA;;EAEE,uCAAuC;AACzC;;AAEA;;EAEE;;IAEE,qBAAqB;EACvB;AACF;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,yCAAyC;EACzC,iCAAiC;EACjC,YAAY;EAEZ,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;;;EAIE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;EAEE,cAAc;EACd,qBAAqB;AACvB;;AAEA;;;;EAIE,qCAAqC;EACrC,cAAc;EACd;;EAEA;EACA,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;;;;;;EAME,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;EACjC,wCAAwC;EACxC,iDAAiD;EACjD,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;;;;;EAKE,SAAS;EACT,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;;;;EAIE,0BAA0B;AAC5B;;AAEA;;;;EAIE,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,SAAS;EACT,SAAS;AACX;;AAEA;EACE,WAAW;EACX,WAAW;EACX,UAAU;EACV,qBAAqB;EACrB,iCAAiC;EACjC,oBAAoB;AACtB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;;;;;;;EAOE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;;;;;;;CAOC;AACD;EACE,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAMA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;;;;;;EAOE,WAAW;EACX,0CAA0C;EAC1C,yCAAyC;EACzC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;EAEE;;IAEE,gBAAgB;EAClB;AACF;;AAEA;;EAEE;;;IAGE,gBAAgB;EAClB;AACF;;AAEA;;EAEE;;;;IAIE,gBAAgB;EAClB;AACF;;AAEA;;EAEE;;;;;IAKE,iBAAiB;EACnB;AACF;;AAEA;;EAEE;;;;;;IAME,iBAAiB;EACnB;AACF;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAGhB,aAAa;EAEb,eAAe;EACf,yCAAyC;EACzC,4CAA4C;EAC5C,2CAA2C;AAC7C;;AAEA;EAEE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,4CAA4C;EAC5C,2CAA2C;EAC3C,8BAA8B;AAChC;;AAEA;EAGE,SAAY;AACd;;AAEA;EAGE,cAAc;EACd,WAAW;AACb;;AAEA;EAGE,cAAc;EACd,WAAW;AACb;;AAEA;EAGE,cAAc;EACd,UAAU;AACZ;;AAEA;EAGE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EAGE,cAAc;EACd,UAAU;AACZ;;AAEA;EAGE,cAAc;EACd,UAAU;AACZ;;AAEA;EAGE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EAGE,cAAc;EACd,WAAW;AACb;;AAEA;EAGE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EAGE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EAGE,cAAc;EACd,UAAU;AACZ;;AAEA;EAGE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EAGE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EAGE,cAAc;EACd,UAAU;AACZ;;AAEA;EAGE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EAGE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EAGE,cAAc;EACd,UAAU;AACZ;;AAEA;EAGE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EAGE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EAGE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE;IAGE,SAAY;EACd;;EAEA;IAGE,cAAc;IACd,WAAW;EACb;;EAEA;IAGE,cAAc;IACd,WAAW;EACb;;EAEA;IAGE,cAAc;IACd,UAAU;EACZ;;EAEA;IAGE,cAAc;IACd,qBAAqB;EACvB;;EAEA;IAGE,cAAc;IACd,UAAU;EACZ;;EAEA;IAGE,cAAc;IACd,UAAU;EACZ;;EAEA;IAGE,cAAc;IACd,qBAAqB;EACvB;;EAEA;IAGE,cAAc;IACd,WAAW;EACb;;EAEA;IAGE,cAAc;IACd,kBAAkB;EACpB;;EAEA;IAGE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IAGE,cAAc;IACd,UAAU;EACZ;;EAEA;IAGE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IAGE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IAGE,cAAc;IACd,UAAU;EACZ;;EAEA;IAGE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IAGE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IAGE,cAAc;IACd,UAAU;EACZ;;EAEA;IAGE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IAGE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IAGE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;;IAEE,qBAAqB;EACvB;;EAEA;;IAEE,qBAAqB;EACvB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;;IAEE,qBAAqB;EACvB;;EAEA;;IAEE,qBAAqB;EACvB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;;IAEE,mBAAmB;EACrB;AACF;;AAEA;EACE;IAGE,SAAY;EACd;;EAEA;IAGE,cAAc;IACd,WAAW;EACb;;EAEA;IAGE,cAAc;IACd,WAAW;EACb;;EAEA;IAGE,cAAc;IACd,UAAU;EACZ;;EAEA;IAGE,cAAc;IACd,qBAAqB;EACvB;;EAEA;IAGE,cAAc;IACd,UAAU;EACZ;;EAEA;IAGE,cAAc;IACd,UAAU;EACZ;;EAEA;IAGE,cAAc;IACd,qBAAqB;EACvB;;EAEA;IAGE,cAAc;IACd,WAAW;EACb;;EAEA;IAGE,cAAc;IACd,kBAAkB;EACpB;;EAEA;IAGE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IAGE,cAAc;IACd,UAAU;EACZ;;EAEA;IAGE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IAGE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IAGE,cAAc;IACd,UAAU;EACZ;;EAEA;IAGE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IAGE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IAGE,cAAc;IACd,UAAU;EACZ;;EAEA;IAGE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IAGE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IAGE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;;IAEE,qBAAqB;EACvB;;EAEA;;IAEE,qBAAqB;EACvB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;;IAEE,qBAAqB;EACvB;;EAEA;;IAEE,qBAAqB;EACvB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;;IAEE,mBAAmB;EACrB;AACF;;AAEA;EACE;IAGE,SAAY;EACd;;EAEA;IAGE,cAAc;IACd,WAAW;EACb;;EAEA;IAGE,cAAc;IACd,WAAW;EACb;;EAEA;IAGE,cAAc;IACd,UAAU;EACZ;;EAEA;IAGE,cAAc;IACd,qBAAqB;EACvB;;EAEA;IAGE,cAAc;IACd,UAAU;EACZ;;EAEA;IAGE,cAAc;IACd,UAAU;EACZ;;EAEA;IAGE,cAAc;IACd,qBAAqB;EACvB;;EAEA;IAGE,cAAc;IACd,WAAW;EACb;;EAEA;IAGE,cAAc;IACd,kBAAkB;EACpB;;EAEA;IAGE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IAGE,cAAc;IACd,UAAU;EACZ;;EAEA;IAGE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IAGE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IAGE,cAAc;IACd,UAAU;EACZ;;EAEA;IAGE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IAGE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IAGE,cAAc;IACd,UAAU;EACZ;;EAEA;IAGE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IAGE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IAGE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;;IAEE,qBAAqB;EACvB;;EAEA;;IAEE,qBAAqB;EACvB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;;IAEE,qBAAqB;EACvB;;EAEA;;IAEE,qBAAqB;EACvB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;;IAEE,mBAAmB;EACrB;AACF;;AAEA;EACE;IAGE,SAAY;EACd;;EAEA;IAGE,cAAc;IACd,WAAW;EACb;;EAEA;IAGE,cAAc;IACd,WAAW;EACb;;EAEA;IAGE,cAAc;IACd,UAAU;EACZ;;EAEA;IAGE,cAAc;IACd,qBAAqB;EACvB;;EAEA;IAGE,cAAc;IACd,UAAU;EACZ;;EAEA;IAGE,cAAc;IACd,UAAU;EACZ;;EAEA;IAGE,cAAc;IACd,qBAAqB;EACvB;;EAEA;IAGE,cAAc;IACd,WAAW;EACb;;EAEA;IAGE,cAAc;IACd,kBAAkB;EACpB;;EAEA;IAGE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IAGE,cAAc;IACd,UAAU;EACZ;;EAEA;IAGE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IAGE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IAGE,cAAc;IACd,UAAU;EACZ;;EAEA;IAGE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IAGE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IAGE,cAAc;IACd,UAAU;EACZ;;EAEA;IAGE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IAGE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IAGE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;;IAEE,qBAAqB;EACvB;;EAEA;;IAEE,qBAAqB;EACvB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;;IAEE,qBAAqB;EACvB;;EAEA;;IAEE,qBAAqB;EACvB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;;IAEE,mBAAmB;EACrB;AACF;;AAEA;EACE;IAGE,SAAY;EACd;;EAEA;IAGE,cAAc;IACd,WAAW;EACb;;EAEA;IAGE,cAAc;IACd,WAAW;EACb;;EAEA;IAGE,cAAc;IACd,UAAU;EACZ;;EAEA;IAGE,cAAc;IACd,qBAAqB;EACvB;;EAEA;IAGE,cAAc;IACd,UAAU;EACZ;;EAEA;IAGE,cAAc;IACd,UAAU;EACZ;;EAEA;IAGE,cAAc;IACd,qBAAqB;EACvB;;EAEA;IAGE,cAAc;IACd,WAAW;EACb;;EAEA;IAGE,cAAc;IACd,kBAAkB;EACpB;;EAEA;IAGE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IAGE,cAAc;IACd,UAAU;EACZ;;EAEA;IAGE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IAGE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IAGE,cAAc;IACd,UAAU;EACZ;;EAEA;IAGE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IAGE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IAGE,cAAc;IACd,UAAU;EACZ;;EAEA;IAGE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IAGE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IAGE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;;IAEE,qBAAqB;EACvB;;EAEA;;IAEE,qBAAqB;EACvB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;;IAEE,qBAAqB;EACvB;;EAEA;;IAEE,qBAAqB;EACvB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;;IAEE,mBAAmB;EACrB;AACF;;AAEA;EACE,0BAA0B;EAC1B,iCAAiC;EACjC,8CAA8C;EAC9C,0CAA0C;EAC1C,6CAA6C;EAC7C,wCAAwC;EACxC,4CAA4C;EAC5C,yCAAyC;EACzC,WAAW;EACX,yBAAyB;EACzB,0BAA0B;EAC1B,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,oCAAoC;EACpC,wBAAwB;EAExB,wDAAwD;AAC1D;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gDAAgD;EAChD,oCAAoC;AACtC;;AAEA;EACE,+CAA+C;EAC/C,mCAAmC;AACrC;;AAEA;EACE,8CAA8C;EAC9C,kCAAkC;AACpC;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,8BAA8B;EAC9B,6BAA6B;EAC7B,6BAA6B;EAC7B,4BAA4B;EAC5B,4BAA4B;EAC5B,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,8BAA8B;EAC9B,6BAA6B;EAC7B,6BAA6B;EAC7B,4BAA4B;EAC5B,4BAA4B;EAC5B,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,8BAA8B;EAC9B,6BAA6B;EAC7B,6BAA6B;EAC7B,4BAA4B;EAC5B,4BAA4B;EAC5B,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,8BAA8B;EAC9B,6BAA6B;EAC7B,6BAA6B;EAC7B,4BAA4B;EAC5B,4BAA4B;EAC5B,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,8BAA8B;EAC9B,6BAA6B;EAC7B,6BAA6B;EAC7B,4BAA4B;EAC5B,4BAA4B;EAC5B,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,8BAA8B;EAC9B,6BAA6B;EAC7B,6BAA6B;EAC7B,4BAA4B;EAC5B,4BAA4B;EAC5B,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,8BAA8B;EAC9B,6BAA6B;EAC7B,6BAA6B;EAC7B,4BAA4B;EAC5B,4BAA4B;EAC5B,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;EAC9B,iCAAiC;EACjC,6BAA6B;EAC7B,gCAAgC;EAChC,4BAA4B;EAC5B,+BAA+B;EAC/B,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE;IACE,gBAAgB;IAChB,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,iCAAiC;EACnC;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;EAChC,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,mCAAmC;EACnC,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;EAC1B,sBAAsB;EACtB,4BAA4B;EAC5B,qCAAqC;EAGrC,gBAAgB;EAChB,sBAAsB;EAGtB,wEAAwE;AAE1E;;AAEA;EACE,yDAAiP;EACjP,4BAA4B;EAC5B,sCAAsC;EACtC,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE;IAEE,gBAAgB;EAClB;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,qBAAqB;EACrB,UAAU;EAEV,mDAAmD;AACrD;;AAEA;EACE,aAAa;AACf;;AAsBA;EACE,kCAAkC;EAClC,UAAU;AACZ;;AAEA;;EAEE,yBAAyB;EACzB,UAAU;AACZ;;AAqBA;EACE,qBAAqB;EACrB,sBAAsB;EAEtB,uBAAuB;EACvB,2BAA2B;EAC3B,yBAAyB;EACzB,oBAAoB;EACpB,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAGhB,qIAAqI;AAEvI;;AAEA;;EAME;IAEE,gBAAgB;EAClB;AACF;;AAMA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EAEtB,uBAAuB;EACvB,2BAA2B;EAC3B,yBAAyB;EACzB,oBAAoB;EACpB,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAGhB,6IAAqI;EAArI,qIAAqI;AAEvI;;AAEA;EACE;IAEE,wBAAgB;IAAhB,gBAAgB;EAClB;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,2BAA2B;EAC3B,6BAA6B;EAC7B,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,sCAAsC;EACtC,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;AACvB;;AASA;EACE,uBAAuB;EACvB,wBAAwB;EAExB,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EAExB,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;AACvB;;AASA;EACE,qBAAqB;EACrB,sBAAsB;EAEtB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EAEtB,uBAAuB;AACzB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kCAAkC;EAClC,oCAAoC;EACpC,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,2BAA2B;EAC3B,yBAAyB;EACzB,yDAAiP;EACjP,4BAA4B;EAC5B,sCAAsC;EACtC,0BAA0B;EAC1B,yBAAyB;EACzB,sBAAsB;EAGtB,wEAAwE;EAIxE,gBAAgB;AAClB;;AAEA;EACE;IAEE,gBAAgB;EAClB;AACF;;AAEA;EACE,qBAAqB;EACrB,UAAU;EAEV,mDAAmD;AACrD;;AAEA;;EAEE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,oBAAoB;EACpB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;EACxB,qCAAqC;EAGrC,gBAAgB;EAEhB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EAEE,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EAEV,mDAAmD;AACrD;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,yDAAkP;AACpP;;AAEA;EACE,yDAA0J;AAC5J;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,yDAA4O;AAC9O;;AAEA;EACE,oBAAoB;EAEpB,YAAY;EACZ,YAAY;AACd;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,yDAAwK;EACxK,gCAAgC;EAChC,kBAAkB;EAElB,iDAAiD;AACnD;;AAEA;EACE;IAEE,gBAAgB;EAClB;AACF;;AAEA;EACE,yDAA0J;AAC5J;;AAEA;EACE,iCAAiC;EACjC,yDAA0J;AAC5J;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;;EAEE,oBAAoB;EAEpB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;EACX,cAAc;EACd,UAAU;EACV,6BAA6B;EAG7B,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EAEE,sEAAsE;AACxE;;AAEA;EACE,sEAAsE;AACxE;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,oCAAoC;EACpC,SAAS;EACT,mBAAmB;EAGnB,oHAA4G;EAA5G,4GAA4G;EAG5G,gBAAgB;AAClB;;AAEA;EACE;IAEE,wBAAgB;IAAhB,gBAAgB;EAClB;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,SAAS;EACT,mBAAmB;EAEnB,iHAA4G;EAA5G,4GAA4G;EAE5G,gBAAgB;AAClB;;AAEA;EACE;IAEE,qBAAgB;IAAhB,gBAAgB;EAClB;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,6BAA6B;EAE7B,qBAAqB;EAGrB,gEAAgE;AAElE;;AAEA;EACE;IAEE,gBAAgB;EAClB;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAkBA;EACE,kBAAkB;AACpB;;AAYA;;EAEE,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;AAC1B;;AAYA;;;EAGE,aAAa;EAEb,8DAA8D;AAChE;;AAEA;EACE,aAAa;EAEb,8DAA8D;AAChE;;AAEA;EACE,kBAAkB;EAGlB,aAAa;EAEb,eAAe;EAGf,oBAAoB;EACpB,WAAW;AACb;;AAEA;;EAEE,kBAAkB;EAGlB,cAAc;EACd,SAAS;EACT,YAAY;AACd;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EAGE,aAAa;EAGb,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;;;;EAIE,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;;;;EAIE,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;;EAEE,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,yCAAyC;EACzC,sBAAsB;AACxB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;EACrB,oCAAoC;EACpC,yDAA4P;EAC5P,4BAA4B;EAC5B,0DAA0D;EAC1D,8DAA8D;AAChE;;AAEA;;EAEE,qBAAqB;EAErB,kDAAkD;AACpD;;AAEA;;EAEE,oCAAoC;EACpC,gFAAgF;AAClF;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;;;EAIE,qBAAqB;EACrB,kGAA6d;EAC7d,yDAAyD;EACzD,yEAAyE;AAC3E;;AAEA;;EAEE,qBAAqB;EAErB,kDAAkD;AACpD;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAGE,kDAAkD;AACpD;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;;EAIE,UAAU;AACZ;;AAEA;;;;EAIE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,wCAAwC;EACxC,sBAAsB;AACxB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;EACrB,oCAAoC;EACpC,yDAA4U;EAC5U,4BAA4B;EAC5B,0DAA0D;EAC1D,8DAA8D;AAChE;;AAEA;;EAEE,qBAAqB;EAErB,iDAAiD;AACnD;;AAEA;;EAEE,oCAAoC;EACpC,gFAAgF;AAClF;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;;;EAIE,qBAAqB;EACrB,kGAA6iB;EAC7iB,yDAAyD;EACzD,yEAAyE;AAC3E;;AAEA;;EAEE,qBAAqB;EAErB,iDAAiD;AACnD;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAGE,iDAAiD;AACnD;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;;EAIE,UAAU;AACZ;;AAEA;;;;EAIE,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;EACf,yBAAyB;EAGzB,iBAAiB;EACjB,6BAA6B;EAC7B,6BAA6B;EAC7B,qBAAqB;EACrB,mBAAmB;EACnB,8CAA8C;EAG9C,qIAAqI;AAEvI;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE;IAEE,gBAAgB;EAClB;AACF;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,UAAU;EAEV,mDAAmD;AACrD;;AAEA;;;EAGE,oBAAoB;EACpB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EAErB,iDAAiD;AACnD;;AAEA;;;;;EAKE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;;;EAME,iDAAiD;AACnD;;AAEA;;EAEE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAGE,kDAAkD;AACpD;;AAEA;;;;;EAKE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;;;EAME,kDAAkD;AACpD;;AAEA;;EAEE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;;EAEE,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EAEE,gCAAgC;AAClC;;AAEA;EACE;IAEE,gBAAgB;EAClB;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;;GAEG;;AAEH;EACE,SAAS;EACT,gBAAgB;EAEhB,6BAA6B;AAC/B;;AAEA;EACE;IAEE,gBAAgB;EAClB;AACF;;AAEA;EACE,QAAQ;EACR,YAAY;EAEZ,4BAA4B;AAC9B;;AAEA;EACE;IAEE,gBAAgB;EAClB;AACF;;AAEA;;;;EAIE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,uBAAuB;EACvB,iBAAiB;EACjB,uBAAuB;EACvB,qCAAqC;EACrC,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,mBAAmB;EACnB,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,4BAA4B;EAC5B,qCAAqC;EACrC,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,OAAO;EACP,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,OAAO;AACT;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,OAAO;EACT;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,QAAQ;IACR,UAAU;EACZ;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,OAAO;EACT;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,QAAQ;IACR,UAAU;EACZ;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,OAAO;EACT;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,QAAQ;IACR,UAAU;EACZ;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,OAAO;EACT;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,QAAQ;IACR,UAAU;EACZ;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,OAAO;EACT;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,QAAQ;IACR,UAAU;EACZ;AACF;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,uBAAuB;EACvB,WAAW;EACX,aAAa;EACb,qCAAqC;EACrC,0BAA0B;EAC1B,oCAAoC;AACtC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,MAAM;EACN,WAAW;EACX,UAAU;EACV,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,uBAAuB;EACvB,WAAW;EACX,mCAAmC;EACnC,eAAe;EACf,sCAAsC;EACtC,wBAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,MAAM;EACN,WAAW;EACX,UAAU;EACV,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,uBAAuB;EACvB,WAAW;EACX,mCAAmC;EACnC,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,WAAW;EACX,qBAAqB;EACrB,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,6BAA6B;EAC7B,SAAS;AACX;;AAEA;;EAEE,cAAc;EACd,+BAA+B;AACjC;;AAEA;;EAEE,cAAc;EACd,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;;EAEE,cAAc;EACd,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,iDAAiD;AACnD;;AAEA;;EAEE,cAAc;EACd,oCAAoC;AACtC;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;EAGlB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;;EAEE,kBAAkB;EAGlB,cAAc;AAChB;;AAEA;;;;;;;;;;;;EAYE,UAAU;AACZ;;AAEA;EAGE,aAAa;EAEb,eAAe;EAGf,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;;;EAGE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;;EAEE,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EAIE,sBAAsB;EAGtB,uBAAuB;EAGvB,uBAAuB;AACzB;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;;EAEE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EAGE,aAAa;EAEb,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,yBAAyB;EACzB,qBAAqB;EAErB,uGAAuG;AACzG;;AAEA;EACE;IAEE,gBAAgB;EAClB;AACF;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;EAC7B,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;;EAEE,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;EACd,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,sBAAsB;AACxB;;AAEA;;EAEE,cAAc;EACd,oCAAoC;AACtC;;AAEA;;EAIE,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAGE,aAAa;EAGb,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAGlB,aAAa;EAEb,eAAe;EAGf,mBAAmB;EAGnB,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;;;;;;;EASE,aAAa;EAEb,kBAAkB;EAGlB,mBAAmB;EAGnB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EAGE,aAAa;EAIb,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EAEE,gBAAgB;EAGhB,YAAY;EAGZ,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,cAAc;EACd,6BAA6B;EAC7B,6BAA6B;EAC7B,sBAAsB;EAGtB,wCAAwC;AAE1C;;AAEA;EACE;IAEE,gBAAgB;EAClB;AACF;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EAEV,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,4BAA4B;EAC5B,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE;IAEE,iBAAiB;IAGjB,2BAA2B;EAC7B;;EAEA;IAIE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;IACrB,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IAGE,wBAAwB;IAExB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,SAAS;IACT,aAAa;IAGb,YAAY;IACZ,8BAA8B;IAC9B,6BAA6B;IAC7B,eAAe;IACf,cAAc;IAEd,gBAAgB;IAEhB,eAAe;EACjB;;EAEA;;IAEE,YAAY;IACZ,aAAa;IACb,gBAAgB;EAClB;;EAEA;IAGE,aAAa;IAGb,YAAY;IACZ,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE;IAEE,iBAAiB;IAGjB,2BAA2B;EAC7B;;EAEA;IAIE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;IACrB,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IAGE,wBAAwB;IAExB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,SAAS;IACT,aAAa;IAGb,YAAY;IACZ,8BAA8B;IAC9B,6BAA6B;IAC7B,eAAe;IACf,cAAc;IAEd,gBAAgB;IAEhB,eAAe;EACjB;;EAEA;;IAEE,YAAY;IACZ,aAAa;IACb,gBAAgB;EAClB;;EAEA;IAGE,aAAa;IAGb,YAAY;IACZ,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE;IAEE,iBAAiB;IAGjB,2BAA2B;EAC7B;;EAEA;IAIE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;IACrB,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IAGE,wBAAwB;IAExB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,SAAS;IACT,aAAa;IAGb,YAAY;IACZ,8BAA8B;IAC9B,6BAA6B;IAC7B,eAAe;IACf,cAAc;IAEd,gBAAgB;IAEhB,eAAe;EACjB;;EAEA;;IAEE,YAAY;IACZ,aAAa;IACb,gBAAgB;EAClB;;EAEA;IAGE,aAAa;IAGb,YAAY;IACZ,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE;IAEE,iBAAiB;IAGjB,2BAA2B;EAC7B;;EAEA;IAIE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;IACrB,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IAGE,wBAAwB;IAExB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,SAAS;IACT,aAAa;IAGb,YAAY;IACZ,8BAA8B;IAC9B,6BAA6B;IAC7B,eAAe;IACf,cAAc;IAEd,gBAAgB;IAEhB,eAAe;EACjB;;EAEA;;IAEE,YAAY;IACZ,aAAa;IACb,gBAAgB;EAClB;;EAEA;IAGE,aAAa;IAGb,YAAY;IACZ,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE;IAEE,iBAAiB;IAGjB,2BAA2B;EAC7B;;EAEA;IAIE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;IACrB,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IAGE,wBAAwB;IAExB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,SAAS;IACT,aAAa;IAGb,YAAY;IACZ,8BAA8B;IAC9B,6BAA6B;IAC7B,eAAe;IACf,cAAc;IAEd,gBAAgB;IAEhB,eAAe;EACjB;;EAEA;;IAEE,YAAY;IACZ,aAAa;IACb,gBAAgB;EAClB;;EAEA;IAGE,aAAa;IAGb,YAAY;IACZ,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EAEE,iBAAiB;EAGjB,2BAA2B;AAC7B;;AAEA;EAIE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EAGE,wBAAwB;EAExB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,aAAa;EAGb,YAAY;EACZ,8BAA8B;EAC9B,6BAA6B;EAC7B,eAAe;EACf,cAAc;EAEd,gBAAgB;EAEhB,eAAe;AACjB;;AAEA;;EAEE,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;;AAEA;EAGE,aAAa;EAGb,YAAY;EACZ,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,yDAA6P;AAC/P;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,sCAAsC;AACxC;;AAEA;EACE,0DAAmQ;AACrQ;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAGlB,aAAa;EAIb,sBAAsB;EACtB,YAAY;EACZ,qBAAqB;EACrB,yBAAyB;EACzB,2BAA2B;EAC3B;2BACyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,4CAA4C;AAC9C;;AAEA;EACE,sBAAsB;EACtB,+CAA+C;EAC/C,8CAA8C;AAChD;;AAEA;;EAEE,aAAa;AACf;;AAEA,iCAAiC;;AAEjC;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;EAGE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,2CAA2C;EAC3C,4CAA4C;AAC9C;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,oBAAoB;EACpB,qCAAqC;EACrC,yCAAyC;AAC3C;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,aAAa;EACb,kCAAkC;AACpC;;AAEA;;;EAGE,WAAW;AACb;;AAEA;;EAEE,2CAA2C;EAC3C,4CAA4C;AAC9C;;AAEA;;EAEE,+CAA+C;EAC/C,8CAA8C;AAChD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IAGE,aAAa;IAIb,mBAAmB;EACrB;;EAEA;IAGE,SAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,cAAc;EAChB;;EAEA;IACE,0BAA0B;IAC1B,6BAA6B;EAC/B;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,yBAAyB;IACzB,4BAA4B;EAC9B;;EAEA;;IAEE,yBAAyB;EAC3B;;EAEA;;IAEE,4BAA4B;EAC9B;AACF;;AAEA;EACE,kBAAkB;EAGlB,aAAa;EAGb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;EAChB,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,qBAAqB;EAGrB,+JAA+J;AAEjK;;AAEA;EACE;IAEE,gBAAgB;EAClB;AACF;;AAEA;EACE,cAAc;EACd,yBAAyB;EAEzB,+CAA+C;AACjD;;AAEA;EACE,0DAAiS;EAEjS,0BAA0B;AAC5B;;AAEA;EAEE,cAAc;EACd,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,0DAAiS;EACjS,4BAA4B;EAC5B,wBAAwB;EAGxB,sCAAsC;AAExC;;AAEA;EACE;IAEE,gBAAgB;EAClB;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,qBAAqB;EACrB,UAAU;EAEV,mDAAmD;AACrD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,2CAA2C;EAC3C,4CAA4C;AAC9C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,+CAA+C;EAC/C,8CAA8C;AAChD;;AAEA;EACE,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EAGE,aAAa;EAEb,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,cAAc;EACd;;EAEA;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EAGE,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;EAGzB,qIAAqI;AAEvI;;AAEA;EACE;IAEE,gBAAgB;EAClB;AACF;;AAEA;EACE,UAAU;EACV,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,cAAc;EACd,yBAAyB;EACzB,UAAU;EAEV,mDAAmD;AACrD;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,cAAc;EACd,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;EACnB,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAQA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;EAGE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EAGE,aAAa;EAIb,sBAAsB;EAGtB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,oCAAoC;EAEpC,2BAA2B;AAC7B;;AAEA;EACE;IAEE,gBAAgB;EAClB;AACF;;AAEA;EACE,qMAAqM;EACrM,0BAA0B;AAC5B;;AAEA;EAEE,kDAAkD;AACpD;;AAEA;EACE;IAEE,eAAe;EACjB;AACF;;AAEA;EAGE,aAAa;EAIb,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,cAAc;EACd,mBAAmB;AACrB;;AAEA;;EAEE,UAAU;EACV,cAAc;EACd,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,cAAc;EACd,qBAAqB;EACrB,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;;EAEE,cAAc;EACd,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,cAAc;EACd,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EAIE,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE;IAIE,mBAAmB;EACrB;;EAEA;IACE,kCAAkC;IAClC,0BAA0B;EAC5B;;EAEA;IACE,gCAAgC;IAChC,4BAA4B;EAC9B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,qBAAqB;IACrB,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;EACxB;AACF;;AAEA;EACE;IAIE,mBAAmB;EACrB;;EAEA;IACE,kCAAkC;IAClC,0BAA0B;EAC5B;;EAEA;IACE,gCAAgC;IAChC,4BAA4B;EAC9B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,qBAAqB;IACrB,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;EACxB;AACF;;AAEA;EACE;IAIE,mBAAmB;EACrB;;EAEA;IACE,kCAAkC;IAClC,0BAA0B;EAC5B;;EAEA;IACE,gCAAgC;IAChC,4BAA4B;EAC9B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,qBAAqB;IACrB,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;EACxB;AACF;;AAEA;EACE;IAIE,mBAAmB;EACrB;;EAEA;IACE,kCAAkC;IAClC,0BAA0B;EAC5B;;EAEA;IACE,gCAAgC;IAChC,4BAA4B;EAC9B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,qBAAqB;IACrB,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;EACxB;AACF;;AAEA;EACE;IAIE,mBAAmB;EACrB;;EAEA;IACE,kCAAkC;IAClC,0BAA0B;EAC5B;;EAEA;IACE,gCAAgC;IAChC,4BAA4B;EAC9B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,qBAAqB;IACrB,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;EACxB;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EAEE,uBAAuB;EACvB,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,WAAW;EACX,0FAA2W;EAC3W,SAAS;EACT,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,UAAU;EAEV,mDAAmD;EACnD,UAAU;AACZ;;AAEA;;EAEE,oBAAoB;EACpB,yBAAyB;EAGzB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EAEE,kDAAkD;AACpD;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,2CAA2C;EAC3C,4BAA4B;EAC5B,oCAAoC;EAEpC,6CAA6C;EAC7C,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EAGE,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EAGE,aAAa;EAGb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,2CAA2C;EAC3C,4BAA4B;EAC5B,4CAA4C;EAC5C,2CAA2C;EAC3C,4CAA4C;AAC9C;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,aAAa;EACb,aAAa;EACb,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,oBAAoB;AACtB;;AAEA;EAGE,mCAAmC;EAGnC,8BAA8B;AAChC;;AAEA;EACE;IAEE,gBAAgB;EAClB;AACF;;AAEA;EAEE,eAAe;AACjB;;AAEA;EAEE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EAGE,aAAa;EAGb,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAGlB,aAAa;EAIb,sBAAsB;EACtB,WAAW;EACX,oBAAoB;EACpB,yBAAyB;EACzB,4BAA4B;EAC5B,oCAAoC;EACpC,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EAGE,aAAa;EAEb,cAAc;EAGd,mBAAmB;EAGnB,8BAA8B;EAC9B,kBAAkB;EAClB,4CAA4C;EAC5C,0CAA0C;EAC1C,2CAA2C;AAC7C;;AAEA;EACE,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAGlB,cAAc;EACd,aAAa;AACf;;AAEA;EAGE,aAAa;EAEb,eAAe;EAEf,cAAc;EAGd,mBAAmB;EAGnB,yBAAyB;EACzB,gBAAgB;EAChB,yCAAyC;EACzC,8CAA8C;EAC9C,6CAA6C;AAC/C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;;EAEE;;IAEE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,SAAS;EACT,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,SAAS;AACX;;AAEA;;EAEE,SAAS;EACT,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,OAAO;EACP,aAAa;EACb,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,MAAM;AACR;;AAEA;;EAEE,YAAY;EACZ,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,QAAQ;EACR,aAAa;EACb,cAAc;AAChB;;AAEA;;EAEE,UAAU;EACV,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN;;EAEA;EACA,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,yBAAyB;EACzB,4BAA4B;EAC5B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,SAAS;EACT,6BAA6B;EAC7B,qCAAqC;AACvC;;AAEA;;EAEE,WAAW;EACX,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,aAAa;EACb,YAAY;AACd;;AAEA;;EAEE,OAAO;EACP,oCAAoC;EACpC,uCAAuC;AACzC;;AAEA;;EAEE,SAAS;EACT,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;;EAEE,MAAM;EACN,oCAAoC;EACpC,wCAAwC;AAC1C;;AAEA;;EAEE,QAAQ;EACR,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;;EAEE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,cAAc;EACd,WAAW;EACX,oBAAoB;EACpB,WAAW;EACX,gCAAgC;AAClC;;AAEA;;EAEE,0BAA0B;EAC1B,aAAa;EACb,YAAY;AACd;;AAEA;;EAEE,QAAQ;EACR,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;;EAEE,UAAU;EACV,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,2CAA2C;EAC3C,0CAA0C;EAC1C,2CAA2C;AAC7C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EAEE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,WAAW;EACX,mBAAmB;EAEnB,2BAA2B;EAG3B,sCAAsC;AAExC;;AAEA;EACE;IAEE,gBAAgB;EAClB;AACF;;AAEA;;;EAGE,cAAc;AAChB;;AAEA,qBAAqB;AACrB;;EAGE,2BAA2B;AAC7B;;AAEA;;EAGE,4BAA4B;AAC9B;;AAEA,mBAAmB;AACnB;EACE,UAAU;EAEV,4BAA4B;EAE5B,eAAe;AACjB;;AAEA;;;EAGE,UAAU;EACV,UAAU;AACZ;;AAEA;;EAEE,UAAU;EACV,UAAU;EAEV,2BAA2B;AAC7B;;AAEA;;EAEE;;IAGE,gBAAgB;EAClB;AACF;;AAEA;;EAEE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;EAGV,aAAa;EAGb,mBAAmB;EAGnB,uBAAuB;EACvB,UAAU;EACV,UAAU;EACV,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,YAAY;EAEZ,8BAA8B;AAChC;;AAEA;;EAEE;;IAGE,gBAAgB;EAClB;AACF;;AAEA;;;;EAIE,cAAc;EACd,qBAAqB;EACrB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,QAAQ;AACV;;AAEA;;EAEE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;;;;;;;GAOG;AACH;EACE,0DAA4Q;AAC9Q;;AAEA;EACE,0DAA6Q;AAC/Q;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,OAAO;EACP,UAAU;EAGV,aAAa;EAGb,uBAAuB;EACvB,UAAU;EACV,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EAEE,uBAAuB;EAGvB,cAAc;EACd,WAAW;EACX,WAAW;EACX,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,4BAA4B;EAC5B,SAAS;EACT,kCAAkC;EAClC,qCAAqC;EACrC,YAAY;EAEZ,6BAA6B;AAC/B;;AAEA;EACE;IAEE,gBAAgB;EAClB;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,SAAS;EACT,oBAAoB;EACpB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAGE,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAaA;EACE;IAIE;;IAEA;EACF;AACF;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,iCAAiC;EACjC,+BAA+B;EAC/B,kBAAkB;EAElB,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAeA;EACE;IAEE,mBAAmB;EACrB;;EAEA;IACE,UAAU;IAEV,eAAe;EACjB;AACF;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,8BAA8B;EAC9B,kBAAkB;EAClB,UAAU;EAEV,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE;;IAGE,wBAAwB;EAC1B;AACF;;AAEA;EACE,eAAe;EACf,SAAS;EACT,aAAa;EAGb,aAAa;EAIb,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,4BAA4B;EAC5B,UAAU;EAGV,sCAAsC;AAExC;;AAEA;EACE;IAEE,gBAAgB;EAClB;AACF;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EAGE,aAAa;EAGb,mBAAmB;EAGnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EAGE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,MAAM;EACN,OAAO;EACP,YAAY;EACZ,0CAA0C;EAE1C,4BAA4B;AAC9B;;AAEA;EACE,MAAM;EACN,QAAQ;EACR,YAAY;EACZ,yCAAyC;EAEzC,2BAA2B;AAC7B;;AAEA;EACE,MAAM;EACN,QAAQ;EACR,OAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,2CAA2C;EAE3C,4BAA4B;AAC9B;;AAEA;EACE,QAAQ;EACR,OAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,wCAAwC;EAExC,2BAA2B;AAC7B;;AAEA;EAEE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,sBAAsB;EACtB,YAAY;EACZ,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EAEE,mDAAmD;AACrD;;AAQA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EAEE,+EAA+E;EAE/E,oBAAoB;EAEpB,8CAA8C;AAChD;;AASA;EACE;IAEE,uBAAuB;EACzB;AACF;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,OAAO;EACP,aAAa;AACf;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,OAAO;EACP,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,aAAa;AACf;;AAEA;EACE;IACE,gBAAgB;IAChB,MAAM;IACN,aAAa;EACf;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,MAAM;IACN,aAAa;EACf;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,MAAM;IACN,aAAa;EACf;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,MAAM;IACN,aAAa;EACf;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,MAAM;IACN,aAAa;EACf;AACF;;AAEA;EAGE,aAAa;EAIb,mBAAmB;EAGnB,mBAAmB;EAGnB,mBAAmB;AACrB;;AAEA;EAGE,aAAa;EAGb,cAAc;EAId,sBAAsB;EAGtB,mBAAmB;AACrB;;AAEA;;EAEE,6BAA6B;EAC7B,qBAAqB;EACrB,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,2BAA2B;EAC3B,iCAAiC;EACjC,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,UAAU;EACV,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EAGrB,mBAAmB;EACnB,UAAU;EACV,eAAe;EACf,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EAEE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EAGE,wBAAwB;AAC1B;;AAEA;EAGE,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EAEE,wDAAwD;AAC1D;;AAEA;EAEE,8DAA8D;AAChE;;AAEA;EAEE,uDAAuD;AACzD;;AAEA;EAEE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EAEE,2CAA2C;AAC7C;;AAEA;EAEE,sCAAsC;AACxC;;AAEA;EAEE,sCAAsC;AACxC;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EAGE,yBAAyB;AAC3B;;AAEA;EAIE,8BAA8B;AAChC;;AAEA;EAIE,iCAAiC;AACnC;;AAEA;EAIE,sCAAsC;AACxC;;AAEA;EAIE,yCAAyC;AAC3C;;AAEA;EAGE,uBAAuB;AACzB;;AAEA;EAGE,uBAAuB;AACzB;;AAEA;EAEE,yBAAyB;AAC3B;;AAEA;EAEE,yBAAyB;AAC3B;;AAEA;EAEE,0BAA0B;AAC5B;;AAEA;EAEE,4BAA4B;AAC9B;;AAEA;EAEE,kCAAkC;AACpC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EAGE,sCAAsC;AACxC;;AAEA;EAGE,oCAAoC;AACtC;;AAEA;EAGE,kCAAkC;AACpC;;AAEA;EAGE,yCAAyC;AAC3C;;AAEA;EAEE,wCAAwC;AAC1C;;AAEA;EAGE,wCAAwC;AAC1C;;AAEA;EAGE,kCAAkC;AACpC;;AAEA;EAGE,gCAAgC;AAClC;;AAEA;EAGE,8BAA8B;AAChC;;AAEA;EAGE,gCAAgC;AAClC;;AAEA;EAGE,+BAA+B;AACjC;;AAEA;EAEE,oCAAoC;AACtC;;AAEA;EAEE,kCAAkC;AACpC;;AAEA;EAEE,gCAAgC;AAClC;;AAEA;EAEE,uCAAuC;AACzC;;AAEA;EAEE,sCAAsC;AACxC;;AAEA;EAEE,iCAAiC;AACnC;;AAEA;EAGE,2BAA2B;AAC7B;;AAEA;EAEE,iCAAiC;AACnC;;AAEA;EAEE,+BAA+B;AACjC;;AAEA;EAGE,6BAA6B;AAC/B;;AAEA;EAEE,+BAA+B;AACjC;;AAEA;EAGE,8BAA8B;AAChC;;AAEA;EAGE,oBAAoB;AACtB;;AAEA;EAGE,mBAAmB;AACrB;;AAEA;EAGE,mBAAmB;AACrB;;AAEA;EAGE,mBAAmB;AACrB;;AAEA;EAGE,mBAAmB;AACrB;;AAEA;EAGE,mBAAmB;AACrB;;AAEA;EAGE,mBAAmB;AACrB;;AAEA;EAGE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA,qBAAqB;AACrB;EACE,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA,mBAAmB;AACnB;EACE,oBAAoB;EACpB,oEAAoE;AACtE;;AAEA;EACE,oBAAoB;EACpB,mEAAmE;AACrE;;AAEA;EACE,oBAAoB;EACpB,mEAAmE;AACrE;;AAEA;EACE,oBAAoB;EACpB,wEAAwE;AAC1E;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,oCAAoC;AACtC;;AAEA;EACE,oBAAoB;EACpB,0CAA0C;AAC5C;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,6EAA6E;AAC/E;;AAEA;EACE,kBAAkB;EAClB,4EAA4E;AAC9E;;AAEA;EACE,kBAAkB;EAClB,4EAA4E;AAC9E;;AAEA;EACE,kBAAkB;EAClB,8EAA8E;AAChF;;AAEA;EACE,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,mCAAmC;EAEnC,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EAGpC,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;EAGpC,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,0CAA0C;EAC1C,2CAA2C;AAC7C;;AAEA;EACE,2CAA2C;EAC3C,8CAA8C;AAChD;;AAEA;EACE,8CAA8C;EAC9C,6CAA6C;AAC/C;;AAEA;EACE,6CAA6C;EAC7C,0CAA0C;AAC5C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IAEE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IAGE,wBAAwB;EAC1B;;EAEA;IAGE,+BAA+B;EACjC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IAGE,yBAAyB;EAC3B;;EAEA;IAIE,8BAA8B;EAChC;;EAEA;IAIE,iCAAiC;EACnC;;EAEA;IAIE,sCAAsC;EACxC;;EAEA;IAIE,yCAAyC;EAC3C;;EAEA;IAGE,uBAAuB;EACzB;;EAEA;IAGE,uBAAuB;EACzB;;EAEA;IAEE,yBAAyB;EAC3B;;EAEA;IAEE,yBAAyB;EAC3B;;EAEA;IAEE,0BAA0B;EAC5B;;EAEA;IAEE,4BAA4B;EAC9B;;EAEA;IAEE,kCAAkC;EACpC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IAGE,sCAAsC;EACxC;;EAEA;IAGE,oCAAoC;EACtC;;EAEA;IAGE,kCAAkC;EACpC;;EAEA;IAGE,yCAAyC;EAC3C;;EAEA;IAEE,wCAAwC;EAC1C;;EAEA;IAGE,wCAAwC;EAC1C;;EAEA;IAGE,kCAAkC;EACpC;;EAEA;IAGE,gCAAgC;EAClC;;EAEA;IAGE,8BAA8B;EAChC;;EAEA;IAGE,gCAAgC;EAClC;;EAEA;IAGE,+BAA+B;EACjC;;EAEA;IAEE,oCAAoC;EACtC;;EAEA;IAEE,kCAAkC;EACpC;;EAEA;IAEE,gCAAgC;EAClC;;EAEA;IAEE,uCAAuC;EACzC;;EAEA;IAEE,sCAAsC;EACxC;;EAEA;IAEE,iCAAiC;EACnC;;EAEA;IAGE,2BAA2B;EAC7B;;EAEA;IAEE,iCAAiC;EACnC;;EAEA;IAEE,+BAA+B;EACjC;;EAEA;IAGE,6BAA6B;EAC/B;;EAEA;IAEE,+BAA+B;EACjC;;EAEA;IAGE,8BAA8B;EAChC;;EAEA;IAGE,oBAAoB;EACtB;;EAEA;IAGE,mBAAmB;EACrB;;EAEA;IAGE,mBAAmB;EACrB;;EAEA;IAGE,mBAAmB;EACrB;;EAEA;IAGE,mBAAmB;EACrB;;EAEA;IAGE,mBAAmB;EACrB;;EAEA;IAGE,mBAAmB;EACrB;;EAEA;IAGE,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,+BAA+B;IAC/B,8BAA8B;EAChC;;EAEA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;;EAEA;IACE,+BAA+B;IAC/B,8BAA8B;EAChC;;EAEA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;IAC7B,gCAAgC;EAClC;;EAEA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;;EAEA;IACE,6BAA6B;IAC7B,gCAAgC;EAClC;;EAEA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;;EAEA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,gCAAgC;IAChC,+BAA+B;EACjC;;EAEA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;;EAEA;IACE,gCAAgC;IAChC,+BAA+B;EACjC;;EAEA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;;EAEA;IACE,8BAA8B;IAC9B,iCAAiC;EACnC;;EAEA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;;EAEA;IACE,8BAA8B;IAC9B,iCAAiC;EACnC;;EAEA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IAEE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IAGE,wBAAwB;EAC1B;;EAEA;IAGE,+BAA+B;EACjC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IAGE,yBAAyB;EAC3B;;EAEA;IAIE,8BAA8B;EAChC;;EAEA;IAIE,iCAAiC;EACnC;;EAEA;IAIE,sCAAsC;EACxC;;EAEA;IAIE,yCAAyC;EAC3C;;EAEA;IAGE,uBAAuB;EACzB;;EAEA;IAGE,uBAAuB;EACzB;;EAEA;IAEE,yBAAyB;EAC3B;;EAEA;IAEE,yBAAyB;EAC3B;;EAEA;IAEE,0BAA0B;EAC5B;;EAEA;IAEE,4BAA4B;EAC9B;;EAEA;IAEE,kCAAkC;EACpC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IAGE,sCAAsC;EACxC;;EAEA;IAGE,oCAAoC;EACtC;;EAEA;IAGE,kCAAkC;EACpC;;EAEA;IAGE,yCAAyC;EAC3C;;EAEA;IAEE,wCAAwC;EAC1C;;EAEA;IAGE,wCAAwC;EAC1C;;EAEA;IAGE,kCAAkC;EACpC;;EAEA;IAGE,gCAAgC;EAClC;;EAEA;IAGE,8BAA8B;EAChC;;EAEA;IAGE,gCAAgC;EAClC;;EAEA;IAGE,+BAA+B;EACjC;;EAEA;IAEE,oCAAoC;EACtC;;EAEA;IAEE,kCAAkC;EACpC;;EAEA;IAEE,gCAAgC;EAClC;;EAEA;IAEE,uCAAuC;EACzC;;EAEA;IAEE,sCAAsC;EACxC;;EAEA;IAEE,iCAAiC;EACnC;;EAEA;IAGE,2BAA2B;EAC7B;;EAEA;IAEE,iCAAiC;EACnC;;EAEA;IAEE,+BAA+B;EACjC;;EAEA;IAGE,6BAA6B;EAC/B;;EAEA;IAEE,+BAA+B;EACjC;;EAEA;IAGE,8BAA8B;EAChC;;EAEA;IAGE,oBAAoB;EACtB;;EAEA;IAGE,mBAAmB;EACrB;;EAEA;IAGE,mBAAmB;EACrB;;EAEA;IAGE,mBAAmB;EACrB;;EAEA;IAGE,mBAAmB;EACrB;;EAEA;IAGE,mBAAmB;EACrB;;EAEA;IAGE,mBAAmB;EACrB;;EAEA;IAGE,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,+BAA+B;IAC/B,8BAA8B;EAChC;;EAEA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;;EAEA;IACE,+BAA+B;IAC/B,8BAA8B;EAChC;;EAEA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;IAC7B,gCAAgC;EAClC;;EAEA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;;EAEA;IACE,6BAA6B;IAC7B,gCAAgC;EAClC;;EAEA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;;EAEA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,gCAAgC;IAChC,+BAA+B;EACjC;;EAEA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;;EAEA;IACE,gCAAgC;IAChC,+BAA+B;EACjC;;EAEA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;;EAEA;IACE,8BAA8B;IAC9B,iCAAiC;EACnC;;EAEA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;;EAEA;IACE,8BAA8B;IAC9B,iCAAiC;EACnC;;EAEA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IAEE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IAGE,wBAAwB;EAC1B;;EAEA;IAGE,+BAA+B;EACjC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IAGE,yBAAyB;EAC3B;;EAEA;IAIE,8BAA8B;EAChC;;EAEA;IAIE,iCAAiC;EACnC;;EAEA;IAIE,sCAAsC;EACxC;;EAEA;IAIE,yCAAyC;EAC3C;;EAEA;IAGE,uBAAuB;EACzB;;EAEA;IAGE,uBAAuB;EACzB;;EAEA;IAEE,yBAAyB;EAC3B;;EAEA;IAEE,yBAAyB;EAC3B;;EAEA;IAEE,0BAA0B;EAC5B;;EAEA;IAEE,4BAA4B;EAC9B;;EAEA;IAEE,kCAAkC;EACpC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IAGE,sCAAsC;EACxC;;EAEA;IAGE,oCAAoC;EACtC;;EAEA;IAGE,kCAAkC;EACpC;;EAEA;IAGE,yCAAyC;EAC3C;;EAEA;IAEE,wCAAwC;EAC1C;;EAEA;IAGE,wCAAwC;EAC1C;;EAEA;IAGE,kCAAkC;EACpC;;EAEA;IAGE,gCAAgC;EAClC;;EAEA;IAGE,8BAA8B;EAChC;;EAEA;IAGE,gCAAgC;EAClC;;EAEA;IAGE,+BAA+B;EACjC;;EAEA;IAEE,oCAAoC;EACtC;;EAEA;IAEE,kCAAkC;EACpC;;EAEA;IAEE,gCAAgC;EAClC;;EAEA;IAEE,uCAAuC;EACzC;;EAEA;IAEE,sCAAsC;EACxC;;EAEA;IAEE,iCAAiC;EACnC;;EAEA;IAGE,2BAA2B;EAC7B;;EAEA;IAEE,iCAAiC;EACnC;;EAEA;IAEE,+BAA+B;EACjC;;EAEA;IAGE,6BAA6B;EAC/B;;EAEA;IAEE,+BAA+B;EACjC;;EAEA;IAGE,8BAA8B;EAChC;;EAEA;IAGE,oBAAoB;EACtB;;EAEA;IAGE,mBAAmB;EACrB;;EAEA;IAGE,mBAAmB;EACrB;;EAEA;IAGE,mBAAmB;EACrB;;EAEA;IAGE,mBAAmB;EACrB;;EAEA;IAGE,mBAAmB;EACrB;;EAEA;IAGE,mBAAmB;EACrB;;EAEA;IAGE,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,+BAA+B;IAC/B,8BAA8B;EAChC;;EAEA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;;EAEA;IACE,+BAA+B;IAC/B,8BAA8B;EAChC;;EAEA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;IAC7B,gCAAgC;EAClC;;EAEA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;;EAEA;IACE,6BAA6B;IAC7B,gCAAgC;EAClC;;EAEA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;;EAEA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,gCAAgC;IAChC,+BAA+B;EACjC;;EAEA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;;EAEA;IACE,gCAAgC;IAChC,+BAA+B;EACjC;;EAEA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;;EAEA;IACE,8BAA8B;IAC9B,iCAAiC;EACnC;;EAEA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;;EAEA;IACE,8BAA8B;IAC9B,iCAAiC;EACnC;;EAEA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IAEE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IAGE,wBAAwB;EAC1B;;EAEA;IAGE,+BAA+B;EACjC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IAGE,yBAAyB;EAC3B;;EAEA;IAIE,8BAA8B;EAChC;;EAEA;IAIE,iCAAiC;EACnC;;EAEA;IAIE,sCAAsC;EACxC;;EAEA;IAIE,yCAAyC;EAC3C;;EAEA;IAGE,uBAAuB;EACzB;;EAEA;IAGE,uBAAuB;EACzB;;EAEA;IAEE,yBAAyB;EAC3B;;EAEA;IAEE,yBAAyB;EAC3B;;EAEA;IAEE,0BAA0B;EAC5B;;EAEA;IAEE,4BAA4B;EAC9B;;EAEA;IAEE,kCAAkC;EACpC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IAGE,sCAAsC;EACxC;;EAEA;IAGE,oCAAoC;EACtC;;EAEA;IAGE,kCAAkC;EACpC;;EAEA;IAGE,yCAAyC;EAC3C;;EAEA;IAEE,wCAAwC;EAC1C;;EAEA;IAGE,wCAAwC;EAC1C;;EAEA;IAGE,kCAAkC;EACpC;;EAEA;IAGE,gCAAgC;EAClC;;EAEA;IAGE,8BAA8B;EAChC;;EAEA;IAGE,gCAAgC;EAClC;;EAEA;IAGE,+BAA+B;EACjC;;EAEA;IAEE,oCAAoC;EACtC;;EAEA;IAEE,kCAAkC;EACpC;;EAEA;IAEE,gCAAgC;EAClC;;EAEA;IAEE,uCAAuC;EACzC;;EAEA;IAEE,sCAAsC;EACxC;;EAEA;IAEE,iCAAiC;EACnC;;EAEA;IAGE,2BAA2B;EAC7B;;EAEA;IAEE,iCAAiC;EACnC;;EAEA;IAEE,+BAA+B;EACjC;;EAEA;IAGE,6BAA6B;EAC/B;;EAEA;IAEE,+BAA+B;EACjC;;EAEA;IAGE,8BAA8B;EAChC;;EAEA;IAGE,oBAAoB;EACtB;;EAEA;IAGE,mBAAmB;EACrB;;EAEA;IAGE,mBAAmB;EACrB;;EAEA;IAGE,mBAAmB;EACrB;;EAEA;IAGE,mBAAmB;EACrB;;EAEA;IAGE,mBAAmB;EACrB;;EAEA;IAGE,mBAAmB;EACrB;;EAEA;IAGE,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,+BAA+B;IAC/B,8BAA8B;EAChC;;EAEA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;;EAEA;IACE,+BAA+B;IAC/B,8BAA8B;EAChC;;EAEA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;IAC7B,gCAAgC;EAClC;;EAEA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;;EAEA;IACE,6BAA6B;IAC7B,gCAAgC;EAClC;;EAEA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;;EAEA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,gCAAgC;IAChC,+BAA+B;EACjC;;EAEA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;;EAEA;IACE,gCAAgC;IAChC,+BAA+B;EACjC;;EAEA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;;EAEA;IACE,8BAA8B;IAC9B,iCAAiC;EACnC;;EAEA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;;EAEA;IACE,8BAA8B;IAC9B,iCAAiC;EACnC;;EAEA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IAEE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IAGE,wBAAwB;EAC1B;;EAEA;IAGE,+BAA+B;EACjC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IAGE,yBAAyB;EAC3B;;EAEA;IAIE,8BAA8B;EAChC;;EAEA;IAIE,iCAAiC;EACnC;;EAEA;IAIE,sCAAsC;EACxC;;EAEA;IAIE,yCAAyC;EAC3C;;EAEA;IAGE,uBAAuB;EACzB;;EAEA;IAGE,uBAAuB;EACzB;;EAEA;IAEE,yBAAyB;EAC3B;;EAEA;IAEE,yBAAyB;EAC3B;;EAEA;IAEE,0BAA0B;EAC5B;;EAEA;IAEE,4BAA4B;EAC9B;;EAEA;IAEE,kCAAkC;EACpC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IAGE,sCAAsC;EACxC;;EAEA;IAGE,oCAAoC;EACtC;;EAEA;IAGE,kCAAkC;EACpC;;EAEA;IAGE,yCAAyC;EAC3C;;EAEA;IAEE,wCAAwC;EAC1C;;EAEA;IAGE,wCAAwC;EAC1C;;EAEA;IAGE,kCAAkC;EACpC;;EAEA;IAGE,gCAAgC;EAClC;;EAEA;IAGE,8BAA8B;EAChC;;EAEA;IAGE,gCAAgC;EAClC;;EAEA;IAGE,+BAA+B;EACjC;;EAEA;IAEE,oCAAoC;EACtC;;EAEA;IAEE,kCAAkC;EACpC;;EAEA;IAEE,gCAAgC;EAClC;;EAEA;IAEE,uCAAuC;EACzC;;EAEA;IAEE,sCAAsC;EACxC;;EAEA;IAEE,iCAAiC;EACnC;;EAEA;IAGE,2BAA2B;EAC7B;;EAEA;IAEE,iCAAiC;EACnC;;EAEA;IAEE,+BAA+B;EACjC;;EAEA;IAGE,6BAA6B;EAC/B;;EAEA;IAEE,+BAA+B;EACjC;;EAEA;IAGE,8BAA8B;EAChC;;EAEA;IAGE,oBAAoB;EACtB;;EAEA;IAGE,mBAAmB;EACrB;;EAEA;IAGE,mBAAmB;EACrB;;EAEA;IAGE,mBAAmB;EACrB;;EAEA;IAGE,mBAAmB;EACrB;;EAEA;IAGE,mBAAmB;EACrB;;EAEA;IAGE,mBAAmB;EACrB;;EAEA;IAGE,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,+BAA+B;IAC/B,8BAA8B;EAChC;;EAEA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;;EAEA;IACE,+BAA+B;IAC/B,8BAA8B;EAChC;;EAEA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;IAC7B,gCAAgC;EAClC;;EAEA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;;EAEA;IACE,6BAA6B;IAC7B,gCAAgC;EAClC;;EAEA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;;EAEA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,gCAAgC;IAChC,+BAA+B;EACjC;;EAEA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;;EAEA;IACE,gCAAgC;IAChC,+BAA+B;EACjC;;EAEA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;;EAEA;IACE,8BAA8B;IAC9B,iCAAiC;EACnC;;EAEA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;;EAEA;IACE,8BAA8B;IAC9B,iCAAiC;EACnC;;EAEA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,+BAA+B;EACjC;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IAEE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IAGE,wBAAwB;EAC1B;;EAEA;IAGE,+BAA+B;EACjC;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;;EAEE,4CAA4C;EAC5C,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;;EAEE;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,6BAA6B;EAC7B,WAAW;EACX,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,6BAA6B;EAC7B,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,6BAA6B;EAC7B,WAAW;EAEX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EAEZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,UAAU;EACV,mBAAmB;EACnB,2BAA2B;EAG3B,oBAAoB;EACpB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,UAAU;EAGV,oBAAoB;EAGpB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,6BAA6B;EAC7B,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,uBAAuB;EAEvB,gBAAgB;EAChB,aAAa;EACb,6BAA6B;EAC7B,cAAc;EACd,SAAS;EACT,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,YAAY;EAEZ,gBAAgB;AAClB;;AAwBA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EAEE,iFAAiF;AACnF;;AAEA;EAEE,gDAAgD;AAClD;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;EACpC,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,qBAAqB;EAIrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;EAC1B,qBAAqB;EAIrB,mBAAmB;EACnB,eAAe;EACf,uBAAuB;AACzB;;AAEA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE;IACE,gBAAgB;IAChB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;IACf,0CAA0C;EAC5C;AACF;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,qCAAqC;EACrC,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,eAAe;EACf,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EAGE,aAAa;EAGb,8BAA8B;AAChC;;AAEA;;EAEE,eAAe;EACf,kBAAkB;EAGlB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE;IACE,YAAY;IACZ,mBAAmB;EACrB;AACF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA,2BAA2B;AAC3B;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;EACX,UAAU;EACV,OAAO;AACT;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;EACX,UAAU;EACV,QAAQ;AACV;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;AACF;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,2BAA2B;AAC3B;EACE,oBAAoB;EACpB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE;IACE,gBAAgB;IAChB,wBAAwB;EAC1B;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,SAAS;AACX;;AAEA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EAGE,aAAa;EAGb,mBAAmB;EAGnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAE7B,+CAA+C;EAC/C,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EAEnB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EAEE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EAGZ,aAAa;EACb,sBAAsB;EACtB,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EAGE,oBAAoB;EACpB,WAAW;EAEX,eAAe;EAGf,uBAAuB;AACzB;;AAEA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EAGZ,aAAa;EAGb,mBAAmB;EAGnB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAE7B,+CAA+C;EAC/C,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EAEnB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EAEE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,6BAA6B;EAC7B,WAAW;EACX,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,6BAA6B;EAC7B,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,6BAA6B;EAC7B,WAAW;EAEX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EAEZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,UAAU;EACV,mBAAmB;EACnB,2BAA2B;EAG3B,oBAAoB;EACpB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,UAAU;EAGV,oBAAoB;EAGpB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,6BAA6B;EAC7B,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,uBAAuB;EAEvB,gBAAgB;EAChB,aAAa;EACb,6BAA6B;EAC7B,cAAc;EACd,SAAS;EACT,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,YAAY;EAEZ,gBAAgB;AAClB;;AAwBA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EAEE,iFAAiF;AACnF;;AAEA;EAEE,gDAAgD;AAClD;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA,4BAA4B;AAC5B;EACE,WAAW;EAGX,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EAGE,aAAa;EAGb,yBAAyB;AAC3B;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IAIE,sBAAsB;EACxB;AACF;;AAEA;EAEE,gCAAgC;EAChC,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EAEnB,aAAa;AACf;;AAEA;EAEE,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EAEnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EAEE,gCAAgC;EAChC,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;EACjB,UAAU;EACV,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EAEE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,YAAY;EACZ,gBAAgB;EAGhB,aAAa;EAIb,sBAAsB;EACtB,WAAW;EACX,UAAU;EACV,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EAEE,qBAAqB;EACrB,WAAW;EACX,YAAY;EAEZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EAEzB,gCAAgC;AAClC;;AAEA;EAEE,qBAAqB;EAErB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yCAAyC;EACzC,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,UAAU;EACV,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EAEzB,gCAAgC;AAClC;;AAEA;EAEE,qBAAqB;EAErB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EAEzB,gCAAgC;AAClC;;AAEA;EAEE,gCAAgC;EAChC,WAAW;EACX,UAAU;AACZ;;AAEA,8BAA8B;AAC9B,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE;IACE,gBAAgB;IAChB,YAAY;EACd;AACF;;AAEA;EACE,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,WAAW;EACX,kBAAkB;EAElB,qBAAqB;EAErB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAElB,aAAa;EACb,SAAS;EACT,WAAW;EACX,YAAY;EACZ,WAAW;EACX,kBAAkB;EAElB,qBAAqB;EACrB,eAAe;EACf,UAAU;EACV,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAEhB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,cAAc;EACd,YAAY;EAGZ,aAAa;EAGb,uBAAuB;EAGvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,6BAA6B;EAE7B,4BAA4B;EAC5B,eAAe;EACf,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAIE,aAAa;EACb,oBAAoB;AACtB;;AAEA;;EAIE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,6BAA6B;EAE7B,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,eAAe;EAGf,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,UAAU;EACV,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;AACrB;;AAEA;EAGE,oBAAoB;AACtB;;AAEA;EACE,qCAAqC;EACrC,oBAAoB;EACpB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EAGZ,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EAGE,aAAa;EACb,gBAAgB;EAChB,oBAAoB;EACpB,gCAAgC;EAGhC,mBAAmB;AACrB;;AAEA;EAGE,aAAa;EAIb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAGlB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE;IACE,gBAAgB;IAChB,wBAAwB;EAC1B;AACF;;AAEA;EACE,8BAA8B;EAE9B,gDAAgD;EAChD,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EAEE,gCAAgC;EAChC,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;;IAEE,wBAAwB;EAC1B;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;;IAEE,yBAAyB;EAC3B;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;;IAEE,wBAAwB;EAC1B;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;;IAEE,yBAAyB;EAC3B;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;;IAEE,wBAAwB;EAC1B;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;;IAEE,yBAAyB;EAC3B;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;;IAEE,wBAAwB;EAC1B;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;;IAEE,yBAAyB;EAC3B;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;;IAEE,wBAAwB;EAC1B;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;;IAEE,yBAAyB;EAC3B;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;AACF;;AAEA,gBAAgB;AAChB;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA,mBAAmB;AACnB;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,gBAAgB;AAChB;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA,UAAU;AACV;EACE,WAAW;EACX,YAAY;AACd;;AAEA,mBAAmB;AACnB;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,WAAW;AACX;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,QAAQ;EAER,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,SAAS;AACX;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,UAAU;EACV,SAAS;EACT,UAAU;AACZ;;AAEA;;EAEE,kCAAkC;EAClC,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,+BAA+B;EAC/B,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;;AAOA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;EAErB,gCAAgC;AAClC;;AAEA;;EAEE;;IAGE,gBAAgB;EAClB;AACF;;AAEA;;;;;;EAOE,gBAAgB;EAChB,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;EACxB,mBAAmB;EAGnB,qIAAqI;AAEvI;;AAEA;EACE;IAEE,gBAAgB;EAClB;AACF;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,UAAU;EAEV,gDAAgD;AAClD;;AAEA;EACE,cAAc;EACd,sCAAsC;AACxC;;AAEA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,UAAU;EAEV,iDAAiD;AACnD;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,UAAU;EAEV,gDAAgD;AAClD;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,UAAU;EAEV,gDAAgD;AAClD;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,UAAU;EAEV,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,UAAU;EAEV,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,UAAU;EAEV,iDAAiD;AACnD;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,UAAU;EAEV,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,UAAU;EAEV,iDAAiD;AACnD;;AAEA,wBAAwB;AACxB;EAGE,aAAa;EAGb,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE;;IAEE,eAAe;EACjB;AACF;;AAEA;;EAEE;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EAGE,aAAa;EAEb,eAAe;EAGf,mBAAmB;EAGnB,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;AACtC;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,cAAc;EACd,2BAA2B;EAC3B,kBAAkB;EAElB,wBAAwB;EACxB,oCAAoC;AACtC;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;;EAEE,cAAc;EACd,2CAA2C;EAC3C,uCAAuC;AACzC;;AAEA;EACE,cAAc;EACd,sCAAsC;EACtC,kCAAkC;AACpC;;AAEA;;EAEE,cAAc;EACd,sCAAsC;EACtC,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA,kBAAkB;AAClB;;;;;;;;;EASE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;;AAEA;;;;;;;;;EASE,WAAW;EACX,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;;;;;;;;;EASE,oBAAoB;AACtB;;AAEA;;;;;;;;;;;;;;;;;;EAkBE,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qCAAqC;EACrC,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qCAAqC;EACrC,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iCAAiC;EACjC,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,cAAc;EACd,8BAA8B;AAChC;;AAEA,4BAA4B;AAC5B;;;;;;EAOE,2BAA2B;AAC7B;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,qBAAqB;EACrB,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;AACpB;;AAEA,6BAA6B;AAC7B;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EAEtB,0BAA0B;EAC1B,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;EAChB,mCAAmC;EACnC;+CAC6C;EAC7C,qCAAqC;AACvC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAEhB,gBAAgB;AAClB;;AAEA;;EAEE,wBAAwB;EACxB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EAGb,aAAa;EAEb,eAAe;EAGf,mBAAmB;EACnB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE;IACE,wBAAwB;IACxB,yBAAyB;EAC3B;AACF;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,WAAW;IACX,eAAe;EACjB;AACF;;AAEA;;GAEG;;AAEH;;EAEE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yCAAyC;EACzC,kBAAkB;EAClB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,qCAAqC;EACrC,mBAAmB;EAEnB,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,2BAA2B;AAC3B;EAGE,aAAa;EAEb,eAAe;EAGf,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;EAEE,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,yCAAyC;EACzC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;AACF;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EAGE,aAAa;EAIb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EAGE,SAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,6BAA6B;AAC7B;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,6BAA6B;EAC7B,YAAY;AACd;;AAEA;;EAEE,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gCAAgC;EAChC,wBAAwB;EACxB,wDAAwD;EACxD,kBAAkB;EAElB,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE;;IAGE,gBAAgB;EAClB;AACF;;AAEA;;EAEE,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;EACf,WAAW;EACX,QAAQ;EAER,2BAA2B;AAC7B;;AAEA;;;;EAIE,gCAAgC;AAClC;;AAEA;;EAEE,YAAY;EACZ,oCAAoC;AACtC;;AAEA;;EAGE,4DAA4D;EAC5D,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;;EAEE,YAAY;EACZ,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EAEE,iDAAiD;AACnD;;AAEA;EAEE,iDAAiD;AACnD;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAGE,2BAA2B;AAC7B;;AAEA;;EAEE,YAAY;EACZ,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EAEE,2BAA2B;AAC7B;;AAEA;EACE,gDAAgD;EAChD,gBAAgB;AAClB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAGE,2BAA2B;AAC7B;;AAEA;EAEE,2BAA2B;AAC7B;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;;EAEE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,QAAQ;AACV;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,mBAAmB;EAEnB,2BAA2B;AAC7B;;AAEA;;EAEE,YAAY;EACZ,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAEhB,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EAIE,sBAAsB;EAGtB,uBAAuB;AACzB;;AAEA;EACE;IAEE,eAAe;IAGf,mBAAmB;EACrB;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;;EAEE,wBAAwB;EACxB,qBAAqB;EACrB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,6BAA6B;EAE7B,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EAEE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EAEE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA,oBAAoB;AACpB;EACE,gCAAgC;AAClC;;AAEA;;;EAGE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,cAAc;EACd,2BAA2B;EAC3B,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA,oBAAoB;AACpB;EACE,+CAA+C;AACjD;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gCAAgC;EAChC,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,qBAAqB;AACrB;EACE,qBAAqB;EACrB,QAAQ;EACR,SAAS;EACT,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;EACtB,qBAAqB;EACrB,mCAAmC;EACnC,kCAAkC;;AAEpC;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,SAAS;AACX;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EAEE,uBAAuB;EAGvB,cAAc;EACd,WAAW;EACX,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,4BAA4B;EAC5B,kCAAkC;EAClC,qCAAqC;EACrC,YAAY;EAEZ,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA,yBAAyB;AACzB;;EAEE,UAAU;AACZ;;AAEA;;EAEE,WAAW;EACX,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA,oBAAoB;AACpB;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE;IACE,2BAA2B;IAC3B,2CAA2C;EAC7C;AACF;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE;;IAEE,iBAAiB;EACnB;AACF;;AAEA;;EAEE;;IAEE,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,iBAAiB;IACjB,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA,iBAAiB;AACjB;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,sCAAsC;EACxC;AACF;;AAEA;EACE;IACE,sCAAsC;EACxC;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,sCAAsC;EACxC;AACF;;AAEA;EACE;IACE,sCAAsC;EACxC;AACF;;AAEA;EACE,yCAAyC;EACzC,wBAAwB;EACxB,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;;EAEE,6DAA6D;EAC7D,eAAe;EACf,+BAA+B;EAC/B,yBAAyB;EACzB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,mCAAmC;AACrC;;AAEA,kBAAkB;AAClB;EACE,qCAAqC;EACrC,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA,2BAA2B;AAC3B;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,uCAAuC;EACzC;AACF;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,UAAU;EACV,cAAc;EACd,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,cAAc;AACd;EACE,yCAAyC;AAC3C;;AAEA,8BAA8B;AAC9B;EAEE,qDAAqD;AACvD;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA,uBAAuB;AACvB;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,WAAW;EACX,mCAAmC;EACnC,kBAAkB;EAClB,qBAAqB;EACrB,kCAAkC;EAClC,sBAAsB;AACxB;;AAkBA;EACE,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;;EAEE,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;;EAEE,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;;;EAME,aAAa;AACf;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EAGE,aAAa;EAEb,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,0CAA0C;AAC1C;EACE,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,wBAAwB;EACxB,wBAAwB;EACxB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,QAAQ;EACR,UAAU;EACV,WAAW;EACX,kCAAkC;EAClC,+BAA+B;EAC/B,yBAAyB;EAEzB,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,QAAQ;EACR,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;;EAEE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;;EAEE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,iCAAiC;AACjC;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;EAEE,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;;EAEE,8BAA8B;EAC9B,gCAAgC;EAChC,cAAc;AAChB;;AAEA;;EAEE,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;EAEE,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;EAEE,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;EAEE,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA,kCAAkC;AAClC;;EAEE,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;;EAEE,gCAAgC;EAChC,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;;;EAIE,eAAe;EACf,mBAAmB;AACrB;;AAEA;;;;EAIE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA,gCAAgC;AAChC;;EAEE,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE,iCAAiC;AACnC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,qBAAqB;EACrB,2CAA2C;EAC3C,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,mCAAmC;EACnC,SAAS;EACT,gBAAgB;EAChB,UAAU;AACZ;;AAEA;;EAEE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,OAAO;EACP,UAAU;EACV,mCAAmC;EACnC,WAAW;EACX,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,UAAU;EACV,cAAc;EACd,6BAA6B;EAC7B,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA,gBAAgB;AAChB;EAGE,aAAa;EAGb,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,0CAA0C;EAC1C,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,0CAA0C;EAC1C,uBAAuB;EACvB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,0CAA0C;EAC1C,uBAAuB;EACvB,sBAAsB;EACtB,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EAGjB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,4CAA4C;EAC5C,yCAAyC;EACzC,wBAAwB;AAC1B;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EAEtB,qDAAqD;EACrD,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EAGE,SAAO;AACT;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;;AAEA,YAAY;AACZ;EAGE,aAAa;EAGb,oBAAoB;EAGpB,cAAc;EACd,WAAW;EACX,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EAGE,aAAa;EAIb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EAGE,aAAa;EAGb,cAAc;EAId,sBAAsB;AACxB;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA,0BAA0B;AAC1B;EACE,qBAAqB;EACrB,sBAAsB;EACtB,oCAAoC;EACpC,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EAGE,eAAe;EAGf,gBAAgB;AAClB;;AAEA;EACE;IAGE,eAAe;EACjB;AACF;;AAEA;EACE;IAGE,eAAe;EACjB;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,uBAAuB;EACvB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,qCAAqC;EACrC,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,WAAW;EACX,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA,uDAAuD;AACvD;;EAEE,oCAAoC;AACtC;;AAEA,iCAAiC;AACjC,uBAAuB;AACvB;EACE,4BAA4B;EAC5B,aAAa;AACf;;AAEA;;EAEE;;IAEE,gBAAgB;EAClB;AACF;;AAEA;;EAEE;;IAEE,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA;;;;;;EAME,mBAAmB;EACnB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,mBAAmB;EACnB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;;2CAE2C;AAC3C;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,UAAU;EAGV,kCAAkC;AAEpC;;AAEA,WAAW;AACX;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,4CAA4C;EAE5C,wCAAwC;EACxC,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE;IAEE,gBAAgB;EAClB;AACF;;AAEA;;EAEE,6BAA6B;EAC7B,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;;EAEE,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,UAAU;IACV,wBAAwB;IAGxB,QAAQ;EACV;AACF;;AAEA;EACE;IACE,WAAW;IACX,wBAAwB;IAGxB,QAAQ;EACV;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,2BAA2B;EAC3B,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EAEb,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;;;;GAIG;AACH;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EAER,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EAEE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE;IAGE,mBAAmB;IACnB,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE;IACE,mBAAmB;IACnB,sBAAsB;EACxB;AACF;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EAGE,QAAQ;EACR,2CAA2C;AAC7C;;AAEA;EACE;IAGE,QAAQ;IACR,gBAAgB;EAClB;AACF;;AAEA;EAIE,mBAAmB;EAGnB,mBAAmB;AACrB;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EAEE,gCAAgC;EAChC,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,QAAQ;EACR,iCAAiC;EACjC,mBAAmB;EACnB,gBAAgB;EAEhB,wCAAwC;AAC1C;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EAEf,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,sBAAsB;EACtB,WAAW;AACb;;;AAGA;EACE,YAAY;EACZ,YAAY;AACd;;;AAGA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,SAAS;EACT,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,eAAe;EACf,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,0BAA0B;EAC1B,yBAAyB;EACzB,yBAAyB;EACzB,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;;EAEE;;IAEE,WAAW;EACb;;EAEA;IACE,SAAS;EACX;AACF;;AAEA,4CAA4C;AAC5C;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,qBAAqB;EACvB;AACF;;AAEA,8CAA8C;AAC9C;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,iCAAiC;EACnC;AACF;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,4BAA4B;EAC5B,yBAAyB;EACzB,4CAA4C;EAC5C,oBAAoB;EACpB,aAAa;EACb,wBAAwB;EACxB,eAAe;EACf,sBAAsB;AACxB;;;AAGA;EACE;IACE,cAAc;EAChB;AACF;;AAEA,yBAAyB;AACzB;EACE,mBAAmB;AACrB;;AAEA;;EAEE,mCAAmC;EACnC,sBAAsB;AACxB;;AAsBA;;EAEE,WAAW;AACb;;AAEA;EACE,sCAAsC;EACtC,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sCAAsC;AACxC;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,mDAAmD;EACnD,oDAAoD;AACtD;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;AACxC;;AAEA,iBAAiB;AACjB;EACE,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,qDAAqD;EACrD,sDAAsD;AACxD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,qBAAqB;AACrB;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,sCAAsC;EACtC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EAEE,gCAAgC;EAChC,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EAEzB,2BAA2B;EAC3B,QAAQ;EACR,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAEhB,wCAAwC;EAExC,wBAAwB;EACxB,WAAW;AACb;;AAEA;EACE;IACE,YAAY;IACZ,YAAY;IACZ,UAAU;EACZ;AACF;;AAEA,yBAAyB;AACzB;EAGE,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EAEE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EAEX,gCAAgC;AAClC;;AAEA;;;EAGE,eAAe;AACjB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,eAAe;AACjB;;AAEA,sBAAsB;AACtB,iBAAiB;AACjB;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,yBAAyB;EACzB,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;EAEE,OAAO;EACP,oCAAoC;EACpC,uCAAuC;AACzC;;AAEA;;EAEE,SAAS;EACT,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;;;EAGE,2BAA2B;AAC7B;;AAEA;;;EAGE,SAAS;EACT,6BAA6B;EAC7B,qCAAqC;AACvC;;AAEA;;;EAGE,WAAW;EACX,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;;EAEE,0BAA0B;EAC1B,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;EAEE,QAAQ;EACR,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;;EAEE,UAAU;EACV,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;;;EAGE,wBAAwB;AAC1B;;AAEA;;;EAGE,MAAM;EACN,oCAAoC;EACpC,wCAAwC;AAC1C;;AAEA;;;EAGE,QAAQ;EACR,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,wBAAwB;EACxB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;EAGE,QAAQ;EACR,qCAAqC;AACvC;;AAEA;;EAEE,UAAU;EACV,uCAAuC;AACzC;;AAEA;;;EAGE,WAAW;EACX,wCAAwC;AAC1C;;AAEA;;EAEE,SAAS;EACT,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;;EAGE,UAAU;EACV,SAAS;EACT,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;;EAEE,UAAU;EACV,WAAW;EACX,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;;;EAGE,6BAA6B;EAC7B,UAAU;EACV,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;;EAEE,2BAA2B;EAC3B,UAAU;EACV,UAAU;EACV,uBAAuB;AACzB;;AAEA,uBAAuB;AACvB;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,sBAAsB;EACtB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;;2CAE2C;;AAE3C,UAAU;AACV;;EAEE,UAAU;EACV,YAAY;AACd;;AAEA,UAAU;AACV;EACE,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;;GAGG;;AAEH;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EAGf,aAAa;EAIb,sBAAsB;EAEtB,6BAA6B;EAC7B,OAAO;EACP,SAAS;AACX;;AAEA;EACE;IAEE,wBAAwB;IACxB,YAAY;IACZ,kBAAkB;IAClB,UAAU;EACZ;AACF;;AAEA;EAGE,aAAa;EAIb,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EAGE,aAAa;EAIb,sBAAsB;EAGtB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,6BAA6B;EAC7B,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,MAAM;EACN,UAAU;EACV,YAAY;EACZ,wBAAwB;EACxB,8BAA8B;EAC9B,UAAU;AACZ;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,iCAAiC;AACnC;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EAGE,aAAa;EAIb,mBAAmB;EAGnB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,2CAA2C;EAE3C,kCAAkC;EAClC,qBAAqB;;AAEvB;;AAEA;EACE;IAEE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,WAAW;EACX,qBAAqB;EACrB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;;GAEG;;AAEH;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAElB,2BAA2B;EAC3B,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mDAAmD;EACnD,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;;;EAIE,oBAAoB;AACtB;;AAEA;;;EAIE,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAGE,oBAAoB;AACtB;;AAEA,wBAAwB;AACxB;EACE,qBAAqB;EACrB,oCAAoC;EACpC,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,WAAW;EACX,0CAA0C;EAC1C,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;AACX;;AAEA;EAGE,wBAAwB;EAGxB,YAAY;EAGZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EAEE,qCAAqC;EACrC,aAAa;EAGb,sCAAsC;AAExC;;AAEA;EACE;IAEE,wCAAwC;EAC1C;AACF;;AAEA;EAEE,wCAAwC;EACxC,aAAa;EAGb,sCAAsC;AAExC;;AAEA;EACE;IAEE,qCAAqC;EACvC;AACF;;AAEA,qBAAqB;AACrB;EACE,YAAY;EACZ,WAAW;EAEX,wBAAwB;EAGxB,sCAAsC;AAExC;;AAEA;EACE;IACE,WAAW;IAEX,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,UAAU;IAEV,oCAAoC;EACtC;AACF;;AAEA;EACE;IAEE,gBAAgB;EAClB;AACF;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE;;IAEE,UAAU;EACZ;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,OAAO;EACP,MAAM;EACN,WAAW;EACX,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE;IAEE,oCAAoC;IACpC,yBAAyB;IACzB,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE;IAEE,gBAAgB;EAClB;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,UAAU;EACZ;AACF;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,2BAA2B;AAC3B;EACE;IACE,YAAY;IACZ,uBAAuB;EACzB;AACF;;AAEA;EAEE,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE;IAEE,gBAAgB;EAClB;AACF;;AAEA;EACE,UAAU;EACV,mBAAmB;EAEnB,uCAAuC;AACzC;;AAEA;EACE;IAEE,gBAAgB;EAClB;AACF;;AAEA;;EAEE,UAAU;EAEV,gCAAgC;EAEhC,uBAAuB;AACzB;;AAEA;;EAEE;;IAGE,gBAAgB;EAClB;AACF;;AAEA;EACE,UAAU;EACV,mBAAmB;EAEnB,6BAA6B;EAE7B,sBAAsB;AACxB;;AAEA;EACE;IAEE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,UAAU;IACV,mBAAmB;IAEnB,sBAAsB;EACxB;AACF;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE,mBAAmB;EACnB,UAAU;EAEV,0CAA0C;AAC5C;;AAEA;EACE;IAEE,gBAAgB;EAClB;AACF;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,oCAAoC;AACpC;EACE;IAEE,yBAAyB;IAEzB,uCAAuC;IAEvC,qDAAqD;EACvD;AACF;;AAEA,iCAAiC;AACjC;EAEE,yCAAyC;AAC3C;;AAEA;EACE;IAEE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;AACF;;AAEA;EAEE,kCAAkC;AACpC;;AAEA;EACE;IAEE,gBAAgB;EAClB;AACF;;AAEA;EAEE,yCAAyC;AAC3C;;AAEA;EACE;IAEE,gBAAgB;EAClB;AACF;;AAEA,iDAAiD;AACjD;EACE;IACE,qBAAqB;IAErB,yCAAyC;EAC3C;AACF;;AAEA;EACE;IAEE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,qBAAqB;IAErB,yCAAyC;EAC3C;AACF;;AAEA;EACE;IAEE,gBAAgB;EAClB;AACF;;AAEA,yBAAyB;AACzB;;GAEG;;AAEH;EACE,cAAc;EAEd,6BAA6B;EAG7B,iDAAiD;AAEnD;;AAEA;EACE;IAEE,0BAA0B;IAE1B,6CAA6C;EAC/C;AACF;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EAEE,yCAAyC;EACzC,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EAEE,yCAAyC;EACzC,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,mBAAmB;EAEnB,uCAAuC;AACzC;;AAEA;EACE;IAEE,gBAAgB;EAClB;AACF;;AAEA;EACE,mBAAmB;EACnB,UAAU;EAEV,0CAA0C;AAC5C;;AAEA;EACE;IAEE,gBAAgB;EAClB;AACF;;AAEA;EAEE,kCAAkC;AACpC;;AAEA;EACE;IAEE,gBAAgB;EAClB;AACF;;AAEA;EAEE,yCAAyC;AAC3C;;AAEA;EACE;IAEE,gBAAgB;EAClB;AACF;;AAEA;EAEE,yCAAyC;AAC3C;;AAEA;EACE;IAEE,gBAAgB;EAClB;AACF;;AAEA,gCAAgC;AAChC;;EAEE;;IAEE,eAAe;IACf,SAAS;IACT,OAAO;IACP,SAAS;IACT,QAAQ;IACR,WAAW;EACb;AACF;;AAEA;;EAEE;;IAEE,qBAAqB;EACvB;AACF;;AAEA;;EAEE;;IAEE,2BAA2B;EAC7B;AACF;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE;;IAEE,eAAe;EACjB;AACF;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;;EAEE;;IAEE,oBAAoB;EACtB;AACF;;AAEA;;EAEE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,SAAS;IAET,iCAAiC;EACnC;AACF;;AAEA;EACE;IAEE,gBAAgB;EAClB;AACF;;AAEA,qBAAqB;AACrB;EACE;IACE,qBAAqB;IAErB,wCAAwC;EAC1C;AACF;;AAEA;EACE;IAEE,gBAAgB;EAClB;AACF;;AAEA;EACE;IAEE,yCAAyC;EAC3C;AACF;;AAEA;EACE;IAEE,gBAAgB;EAClB;AACF;;AAEA,yBAAyB;AACzB;EACE;IACE,gBAAgB;IAEhB,wCAAwC;EAC1C;AACF;;AAEA;EACE;IAEE,gBAAgB;EAClB;AACF;;AAEA;EACE;IAEE,yCAAyC;EAC3C;AACF;;AAEA;EACE;IAEE,gBAAgB;EAClB;AACF;;AAEA;EACE,eAAe;EAEf,yCAAyC;AAC3C;;AAEA;EACE;IAEE,gBAAgB;EAClB;AACF;;AAEA;EAEE,yCAAyC;AAC3C;;AAEA;EACE;IAEE,gBAAgB;EAClB;AACF;;AAEA,+BAA+B;AAC/B;;EAEE,YAAY;AACd;;AAEA;;EAEE;;IAEE,uBAAuB;EACzB;AACF;;AAEA;;EAEE;;IAEE,qBAAqB;EACvB;AACF;;AAEA;EACE,oCAAoC;AACtC;;AAEA,oBAAoB;AACpB;EACE,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;;;EAKE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;AAC3B;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;;EAKE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;AACxC;;AAEA,0BAA0B;AAC1B;EACE,iBAAiB;EACjB,oBAAoB;EACpB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE;IACE,oBAAoB;IACpB,oBAAoB;EACtB;AACF;;AAEA;;EAEE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA,8BAA8B;AAC9B;EACE,QAAQ;EAER,kCAAkC;AACpC;;AAEA;EACE,WAAW;EAEX,kCAAkC;AACpC;;AAEA;EAEE,yBAAyB;EAGzB,sCAAsC;AAExC;;AAEA;EAEE,kCAAkC;AACpC;;AAEA;EAEE,kCAAkC;AACpC;;AAEA;EAEE,uBAAuB;EAGvB,sCAAsC;AAExC;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,MAAM;EACN,UAAU;EAEV,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE;IACE,QAAQ;IAER,kCAAkC;EACpC;AACF;;AAEA;EACE,eAAe;EACf,UAAU;EACV,QAAQ;EACR,yBAAyB;EACzB,4BAA4B;EAC5B,+BAA+B;EAC/B,WAAW;EACX,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EAIE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;EACjB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;AACpB;;AAEA,8BAA8B;AAC9B;EACE,eAAe;EACf,SAAS;EACT,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA,8BAA8B;AAC9B;EACE;IACE,kBAAkB;IAElB,yCAAyC;EAC3C;AACF;;AAEA;EACE,aAAa;EAEb,kCAAkC;AACpC;;AAEA,6BAA6B;AAC7B;EACE;IACE,mBAAmB;IAEnB,yCAAyC;EAC3C;AACF;;AAEA;EACE,WAAW;EAEX,kCAAkC;AACpC;;AAEA,mBAAmB;AACnB;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA,oBAAoB;AACpB;EACE,QAAQ;EACR,MAAM;EACN,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EAEZ,2BAA2B;EAC3B,0CAA0C;EAE1C,yBAAyB;EACzB,iBAAiB;EACjB,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,QAAQ;EACR,QAAQ;EAER,gCAAgC;EAChC,kBAAkB;EAClB,8BAA8B;EAC9B,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,cAAc;EACd,wBAAwB;EACxB,kBAAkB;EAClB,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,aAAa;AACf;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,SAAS;EACT,cAAc;EACd,WAAW;EACX,eAAe;EACf,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,sCAAsC;EACtC,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EAEE,wBAAwB;AAC1B;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EAGnB,aAAa;EAIb,mBAAmB;EAGnB,8BAA8B;EAG9B,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA,cAAc;AACd;EACE,0CAA0C;EAC1C,UAAU;EACV,SAAS;EACT,UAAU;AACZ;;AAEA,uBAAuB;AACvB,mBAAmB;AACnB;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EAEtB,mDAAmD;AACrD;;AAgBA;EACE;IACE,yDAAyD;IACzD,iEAAiE;EACnE;;EAEA;IACE,8DAA8D;IAC9D,sEAAsE;EACxE;;EAEA;IACE,iEAAiE;IACjE,yEAAyE;EAC3E;AACF;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,OAAO;EAEP,4CAA4C;AAC9C;;AAEA;EAEE,oBAAoB;AACtB;;AAcA;;EAEE;;IAEE,mBAAmB;IACnB,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;IACnB,2BAA2B;EAC7B;AACF;;AAEA,SAAS;AACT;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,UAAU;EACV,qBAAqB;EAErB,oDAAoD;AACtD;;AAEA;EAEE,sBAAsB;AACxB;;AAEA;EAEE,oBAAoB;AACtB;;AAEA;EAEE,sBAAsB;AACxB;;AAEA;EAEE,sBAAsB;AACxB;;AAeA;;EAEE;;;IAGE,sBAAsB;IACtB,8BAA8B;EAChC;;EAEA;IACE,oBAAoB;IACpB,4BAA4B;EAC9B;AACF;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;EAEE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,OAAO;EAEP,gDAAgD;AAClD;;AAEA;EAEE,sBAAsB;AACxB;;AAoBA;EACE;IACE,qDAAqD;IACrD,6DAA6D;EAC/D;;EAEA;IACE,4DAA4D;IAC5D,oEAAoE;EACtE;;EAEA;IACE,4DAA4D;IAC5D,oEAAoE;EACtE;;EAEA;IACE,sEAAsE;IACtE,8EAA8E;EAChF;;EAEA;IACE,0BAA0B;IAC1B,kCAAkC;EACpC;AACF;;AAEA,UAAU;AACV;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EAEnB,8CAA8C;AAChD;;AAaA;EACE;IAEE,mBAAmB;EACrB;;EAEA;IAEE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAElB,uCAAuC;AACzC;;AAEA;;EAEE,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,MAAM;EACN,sBAAsB;EACtB,mBAAmB;EAEnB,4CAA4C;AAC9C;;AAEA;EACE,SAAS;EACT,SAAS;EAET,oBAAoB;AACtB;;AAQA;EACE;IACE,yBAAyB;IACzB,iCAAiC;EACnC;AACF;;AAcA;;EAEE;;IAEE,mBAAmB;IACnB,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;IACnB,2BAA2B;EAC7B;AACF;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EAErB,wDAAwD;AAC1D;;AAEA;EAEE,uBAAuB;AACzB;;AAEA;EAEE,uBAAuB;AACzB;;AAeA;;EAEE;;;IAIE,mBAAmB;EACrB;;EAEA;IAEE,mBAAmB;EACrB;AACF;;AAEA,WAAW;AACX;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,MAAM;AACR;;AAEA;EACE,WAAW;EACX,cAAc;EACd,cAAc;EACd,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EAEnB,8DAA8D;AAChE;;AAEA;EAEE,wBAAwB;AAC1B;;AAEA;EAEE,wBAAwB;AAC1B;;AAEA;EAEE,wBAAwB;AAC1B;;AAEA;EAEE,yBAAyB;AAC3B;;AAEA;EAEE,yBAAyB;AAC3B;;AAEA;EAEE,yBAAyB;AAC3B;;AAEA;EAEE,yBAAyB;AAC3B;;AAEA;EAEE,yBAAyB;AAC3B;;AAEA;EAEE,yBAAyB;AAC3B;;AAEA;EAEE,yBAAyB;AAC3B;;AAEA;EAEE,yBAAyB;AAC3B;;AAEA;EAEE,sBAAsB;AACxB;;AAEA;EAEE,oBAAoB;AACtB;;AAEA;EAEE,sBAAsB;AACxB;;AAEA;EAEE,sBAAsB;AACxB;;AAEA;EAEE,sBAAsB;AACxB;;AAEA;EAEE,sBAAsB;AACxB;;AAEA;EAEE,sBAAsB;AACxB;;AAEA;EAEE,sBAAsB;AACxB;;AAEA;EAEE,sBAAsB;AACxB;;AAEA;EAEE,sBAAsB;AACxB;;AAEA;EAEE,sBAAsB;AACxB;;AAiBA;;EAEE;;;IAIE,mBAAmB;EACrB;;EAEA;IAEE,mBAAmB;EACrB;AACF;;AAEA,cAAc;AACd;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,WAAW;EAEX,0DAA0D;AAC5D;;AAEA;EAEE,qBAAqB;AACvB;;AAEA;EAEE,qBAAqB;AACvB;;AAEA;EAEE,qBAAqB;AACvB;;AAEA;EAEE,qBAAqB;AACvB;;AAEA;EAEE,qBAAqB;AACvB;;AAEA;EAEE,qBAAqB;AACvB;;AAEA;EAEE,mBAAmB;AACrB;;AAEA;EAEE,qBAAqB;AACvB;;AAEA;EAEE,qBAAqB;AACvB;;AAiBA;;EAEE;;;IAIE,2BAA2B;EAC7B;;EAEA;IAEE,2BAA2B;EAC7B;AACF;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,MAAM;AACR;;AAEA;EACE,WAAW;EACX,cAAc;EACd,cAAc;EACd,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EAEnB,4DAA4D;AAC9D;;AAEA;EAEE,wBAAwB;AAC1B;;AAEA;EAEE,wBAAwB;AAC1B;;AAEA;EAEE,wBAAwB;AAC1B;;AAEA;EAEE,yBAAyB;AAC3B;;AAEA;EAEE,yBAAyB;AAC3B;;AAEA;EAEE,yBAAyB;AAC3B;;AAEA;EAEE,yBAAyB;AAC3B;;AAEA;EAEE,yBAAyB;AAC3B;;AAEA;EAEE,yBAAyB;AAC3B;;AAEA;EAEE,yBAAyB;AAC3B;;AAEA;EAEE,yBAAyB;AAC3B;;AAEA;EAEE,sBAAsB;AACxB;;AAEA;EAEE,oBAAoB;AACtB;;AAEA;EAEE,sBAAsB;AACxB;;AAEA;EAEE,sBAAsB;AACxB;;AAEA;EAEE,sBAAsB;AACxB;;AAEA;EAEE,sBAAsB;AACxB;;AAEA;EAEE,sBAAsB;AACxB;;AAEA;EAEE,sBAAsB;AACxB;;AAEA;EAEE,sBAAsB;AACxB;;AAEA;EAEE,sBAAsB;AACxB;;AAEA;EAEE,sBAAsB;AACxB;;AAeA;;EAEE;;;IAGE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAElB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAElB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,sBAAsB;EAEtB,qDAAqD;EAErD,2BAA2B;AAC7B;;AAEA;EAEE,oCAAoC;AACtC;;AAEA;EAEE,qCAAqC;AACvC;;AAEA;EAEE,qCAAqC;AACvC;;AAEA;EAEE,qBAAqB;AACvB;;AAEA;EAEE,qBAAqB;AACvB;;AAEA;EAEE,qBAAqB;AACvB;;AA0BA;;EAEE;;IAGE,8CAA8C;IAC9C,UAAU;EACZ;;EAEA;;IAGE,2CAA2C;IAC3C,UAAU;EACZ;;EAEA;;IAGE,6CAA6C;IAC7C,UAAU;EACZ;AACF;;AAEA,UAAU;AACV;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAElB,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,MAAM;EAEN,oDAAoD;AACtD;;AAEA;EACE,WAAW;EACX,cAAc;EACd,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EAEnB,2DAA2D;AAC7D;;AAEA;EAEE,sBAAsB;AACxB;;AAEA;EAEE,oBAAoB;AACtB;;AAEA;EAEE,sBAAsB;AACxB;;AAEA;EAEE,sBAAsB;AACxB;;AAEA;EAEE,sBAAsB;AACxB;;AAEA;EAEE,sBAAsB;AACxB;;AAEA;EAEE,sBAAsB;AACxB;;AAEA;EAEE,oBAAoB;AACtB;;AAEA;EAEE,sBAAsB;AACxB;;AAEA;EAEE,sBAAsB;AACxB;;AAEA;EAEE,sBAAsB;AACxB;;AASA;EACE;IAEE,yBAAyB;EAC3B;AACF;;AAWA;;EAEE;;IAGE,yBAAyB;EAC3B;AACF;;AAeA;EACE;IAEE,qBAAqB;EACvB;;EAEA;;IAGE,mBAAmB;EACrB;AACF;;AAEA,wBAAwB;AACxB;;EAGE,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;EACV,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAElB,uDAAuD;AACzD;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAElB,8BAA8B;AAChC;;AAEA;EACE,UAAU;AACZ;;AAEA,8BAA8B;AAC9B;EACE,+CAA+C;EAC/C,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iDAAiD;EACjD,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;;EAEE,8BAA8B;AAChC;;AAEA,mBAAmB;AACnB;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,+BAA+B;AAC/B;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;EACtC,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,qBAAqB;AACrB;;EAEE,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;AACZ;;AAEA;;EAEE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAElB,4CAA4C;AAC9C;;AAEA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EAEtB,8BAA8B;AAChC;;AAEA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,kBAAkB;EAElB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA,qBAAqB;AACrB;;EAEE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,kBAAkB;EAElB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,cAAc;EACd,YAAY;AACd;;AAEA;EACE,SAAS;EACT,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA,mBAAmB;AACnB;EACE,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;EACE,qCAAqC;EACrC,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;;EAEE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,qBAAqB;IACrB,sBAAsB;EACxB;AACF;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,2BAA2B;IAC3B,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,WAAW;EACX,+BAA+B;EAC/B,WAAW;EACX,UAAU;EACV,kBAAkB;EAElB,4BAA4B;AAC9B;;AAEA;EACE;IAEE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE;IACE,2CAA2C;IAC3C,gBAAgB;EAClB;AACF;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE;IACE,iBAAiB;IACjB,gBAAgB;IAChB,+BAA+B;IAC/B,kCAAkC;EACpC;;EAEA;IACE,MAAM;IACN,UAAU;IACV,YAAY;IACZ,WAAW;EACb;AACF;;AAEA,yBAAyB;AACzB;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,cAAc;EAEd,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE;IAEE,gBAAgB;EAClB;AACF;;AAEA;EACE,UAAU;EACV,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,OAAO;EAEP,4BAA4B;AAC9B;;AAEA;EACE;IAEE,gBAAgB;EAClB;AACF;;AAEA;EACE,qCAAqC;EACrC,yCAAyC;EACzC,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,eAAe;EACf,0BAA0B;AAC5B;;AAEA;;EAGE,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,oCAAoC;EACpC,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EAEE,oBAAoB;EACpB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA,yBAAyB;AACzB;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE;IAGE,2BAA2B;EAC7B;AACF;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EAGjC,mBAAmB;AACrB;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EAET,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,0BAA0B;;AAE5B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,0CAA0C;EAC1C,wBAAwB;AAC1B;;AAEA;EACE,yCAAyC;EACzC,wBAAwB;AAC1B;;AAEA;EACE,yCAAyC;EACzC,wBAAwB;AAC1B;;AAEA;EACE,wCAAwC;EACxC,wBAAwB;AAC1B;;AAEA;EACE,wCAAwC;EACxC,wBAAwB;AAC1B;;AAEA;;EAEE,cAAc;AAChB;;AAEA,qBAAqB;AACrB;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,eAAe;AACf;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAGlB,uCAAuC;AAEzC;;AAEA;EACE;IAEE,gBAAgB;EAClB;AACF;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE;IACE,qBAAqB;EACvB;AACF;;AAEA,mBAAmB;AACnB;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE;;IAEE,kBAAkB;EACpB;AACF;;AAEA;;;EAGE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;;;EAGE,oCAAoC;AACtC;;AAEA;;;;;;EAME,wBAAwB;AAC1B;;AAEA;;;EAGE,4CAA4C;AAC9C;;AAEA;;;;;;EAME,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;;;;;;EAME,eAAe;EAGf,mBAAmB;AACrB;;AAEA;;;EAGE,gCAAgC;AAClC;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;;;EAGE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;;EAGE,gCAAgC;AAClC;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;;;EAGE,YAAY;EACZ,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;;;EAGE,uBAAuB;AACzB;;AAEA;;;EAGE,2BAA2B;AAC7B;;AAEA;;EAEE;;;IAGE,gBAAgB;IAChB,UAAU;EACZ;AACF;;AAEA;;EAEE;;;IAGE,6BAA6B;IAC7B,UAAU;EACZ;AACF;;AAEA;;EAEE;;;IAGE,2BAA2B;EAC7B;AACF;;AAEA;;;EAGE,wCAAwC;AAC1C;;AAEA;;;;;;EAME,yBAAyB;EACzB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,SAAS;EACT,iBAAiB;EAEjB,gBAAgB;AAClB;;AAEA;;;;;;EAME,yBAAyB;AAC3B;;AAEA;;;;;;EAME,qCAAqC;AACvC;;AAEA;;;;;;EAME,yBAAyB;AAC3B;;AAEA,2BAA2B;AAC3B;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,UAAU;AACZ;;AAEA,2BAA2B;AAC3B;EACE,yBAAyB;AAC3B;;AAEA;;;;;;EAME,6BAA6B;EAC7B,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;EACzC,iBAAiB;AACnB;;AAEA;;;EAGE,iCAAiC;AACnC;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;EACzC,4CAA4C;EAC5C,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,UAAU;EACV,iBAAiB;EAEjB,wEAAwE;AAC1E;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EAEE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;;EAEE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;;EAGE,UAAU;AACZ;;AAEA;;;EAGE,YAAY;AACd;;AAEA;;;EAGE,2BAA2B;AAC7B;;AAEA;;;EAGE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,8CAA8C;EAC9C,SAAS;EACT,SAAS;EAET,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;;EAIE,cAAc;EACd,UAAU;AACZ;;AAEA,sBAAsB;AACtB;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EAEnB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA,qBAAqB;AACrB;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EAEtB,qDAAqD;EACrD,eAAe;EACf,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,8BAA8B;AAC9B;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;EAC1B,UAAU;EACV,SAAS;EACT,0BAA0B;EAC1B,uBAAuB;EACvB,wBAAwB;EACxB,0BAA0B;EAC1B,iBAAiB;EACjB,oBAAoB;EACpB,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAEhB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,iBAAiB;EAEjB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EAEpB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,aAAa;IAEb,oBAAoB;EACtB;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,WAAW;EACX,aAAa;EACb,eAAe;EACf,MAAM;EACN,OAAO;EACP,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,yBAAyB;EACzB,gCAAgC;EAChC,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,mBAAmB;AACrB;;;;AAIA;EACE,iBAAiB;EACjB,aAAa;EACb,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,iDAAiD;AACnD;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,sCAAsC;EACtC,mCAAmC;EACnC,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iDAAiD;EACjD,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;;;;EAOE,2BAA2B;EAC3B,aAAa;AACf;;;AAGA;EACE,yBAAyB;EACzB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qCAAqC;EACrC,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;;AAGA,gBAAgB;;AAEhB,wBAAwB;;AAExB;EACE,yBAAyB;EACzB,eAAe;EACf,wBAAwB;AAC1B;;AAEA,sBAAsB;;AAEtB;EACE,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,uBAAuB;EACvB,iCAAiC;EACjC,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA,0DAA0D;AAC1D;;;;;;;;;EASE,qCAAqC;EACrC,oCAAoC;EACpC,yDAAiD;EAAjD,iDAAiD;AACnD;;AAEA,oDAAoD;AACpD;EACE,qCAAqC;AACvC;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,kCAAkC;EAClC,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kCAAkC;EAClC,WAAW;EACX,YAAY;EACZ,OAAO;EACP,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kCAAkC;EAClC,WAAW;EACX,aAAa;EACb,MAAM;EACN,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;EACV,kCAAkC;EAClC,UAAU;EACV,YAAY;EACZ,SAAS;EACT,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;;AAEpB;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;EACV,kCAAkC;EAClC,UAAU;EACV,YAAY;EACZ,SAAS;EACT,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;;AAEpB;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,mCAAmC;EACnC,YAAY;AACd;;;AAGA;EAGE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,eAAe;EACf,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;AAClB;;AAEA,mCAAmC;AACnC;EACE,YAAY;EACZ,YAAY;EACZ,4BAA4B;EAC5B,kBAAkB;EAClB,yBAAyB;EACzB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,eAAe;EACf,YAAY;AACd;;AAEA,4BAA4B;AAC5B;EACE,yBAAyB;AAC3B;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA,qBAAqB;;AAErB;EACE,gBAAgB;AAClB;;;AAGA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,SAAS;EACT,2CAA2C;EAC3C,wBAAwB;EACxB,iCAAiC;EACjC,wBAAwB;EACxB,kDAAkD;EAClD,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;;AAGA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,gBAAgB;;AAElB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,aAAa;EACb,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;AACjB;;;AAGA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB;AACF;;AAEA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,6BAA6B;AAC/B","sourcesContent":[":root {\n  --bs-blue: #0d6efd;\n  --bs-indigo: #6610f2;\n  --bs-purple: #8268e2;\n  --bs-pink: #ee5588;\n  --bs-red: #dc3545;\n  --bs-orange: #fd7e14;\n  --bs-yellow: #ffc107;\n  --bs-green: #198754;\n  --bs-teal: #20c997;\n  --bs-cyan: #0dcaf0;\n  --bs-white: #ffffff;\n  --bs-gray: #6c757d;\n  --txt-red: red;\n  --bs-gray-dark: #545454;\n  --bs-gray-100: #fdfdfd;\n  --bs-gray-200: #e9ecef;\n  --bs-gray-300: #dee2e6;\n  --bs-gray-400: #ced4da;\n  --bs-gray-500: #adb5bd;\n  --bs-gray-600: #6c757d;\n  --bs-gray-700: #495057;\n  --bs-gray-800: #343a40;\n  --bs-gray-900: #212529;\n  --bs-purple: #8268e2;\n  --bs-purple-rgb: 130, 104, 226;\n  --bs-white-rgb: 255, 255, 255;\n  --bs-body-color-rgb: 138, 144, 157;\n  --bs-body-bg-rgb: 253, 253, 253;\n  --bs-font-sans-serif: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n  --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));\n  --bs-body-font-family: 'Poppins', sans-serif;\n  --bs-body-font-size: 0.875rem;\n  --bs-body-font-weight: 400;\n  --bs-body-line-height: 1.5;\n  --bs-body-color: #005460;\n  --bs-body-bg: #fdfdfd;\n  --bs-admin-color: #423a8e;\n  --admin-color: #005460;\n  --secondary-color: #3d3d3d;\n  --border-radius: 8px;\n  --bs-body-bg-color: #FFFFFF;\n  --text-color: #005460;\n  --button-hover-color: #007080;\n  --gray-text-color: #101C2D;\n  --card-title-color: #101C2D;\n  --border-color: #dde4ee;\n  --gray-bg-color: #F9FAFB;\n  --bs-black-rgb: #101C2D;\n  --bs-placeholder-color: #66768E;\n}\n\n*,\n*::before,\n*::after {\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  :root {\n    scroll-behavior: smooth;\n  }\n}\n\nbody {\n  margin: 0;\n  font-family: var(--bs-body-font-family);\n  font-size: var(--bs-body-font-size);\n  font-weight: var(--bs-body-font-weight);\n  line-height: var(--bs-body-line-height);\n  color: var(--bs-black-rgb);\n  text-align: var(--bs-body-text-align);\n  background-color: var(--bs-body-bg-color);\n  -webkit-text-size-adjust: 100%;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\nhr {\n  /* margin: 1rem 0; */\n  color: inherit;\n  background-color: currentColor;\n  border: 0;\n  opacity: 0.25;\n}\n\nhr:not([size]) {\n  height: 1px;\n}\n\nh6,\n.h6,\nh5,\n.h5,\nh4,\n.h4,\nh3,\n.h3,\nh2,\n.h2,\nh1,\n.h1 {\n  margin-top: 0;\n  margin-bottom: 0;\n  font-weight: 500;\n  line-height: 1.2;\n}\n\nh1,\n.h1 {\n  font-size: calc(1.37525rem + 1.503vw);\n}\n\n@media (min-width: 1200px) {\n\n  h1,\n  .h1 {\n    font-size: 2.5025rem;\n  }\n}\n\nh2,\n.h2 {\n  font-size: calc(1.3249375rem + 0.89925vw);\n}\n\n@media (min-width: 1200px) {\n\n  h2,\n  .h2 {\n    font-size: 1.999375rem;\n  }\n}\n\nh3,\n.h3 {\n  font-size: calc(1.274625rem + 0.2955vw);\n}\n\n@media (min-width: 1200px) {\n\n  h3,\n  .h3 {\n    font-size: 1.49625rem;\n  }\n}\n\nh4,\n.h4 {\n  font-size: calc(1.250125rem + 0.0015vw);\n}\n\n@media (min-width: 1200px) {\n\n  h4,\n  .h4 {\n    font-size: 1.25125rem;\n  }\n}\n\nh5,\n.h5 {\n  font-size: 1.124375rem;\n}\n\nh6,\n.h6 {\n  font-size: 0.93625rem;\n}\n\np {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nabbr[title],\nabbr[data-bs-original-title] {\n  -webkit-text-decoration: underline dotted;\n  text-decoration: underline dotted;\n  cursor: help;\n  -webkit-text-decoration-skip-ink: none;\n  text-decoration-skip-ink: none;\n}\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\nol,\nul {\n  padding-left: 2rem;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: 700;\n}\n\ndd {\n  margin-bottom: 0.5rem;\n  margin-left: 0;\n}\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\nb,\nstrong {\n  font-weight: bolder;\n}\n\nsmall,\n.small {\n  font-size: 0.875em;\n}\n\nmark,\n.mark {\n  padding: 0.2em;\n  background-color: #fcf8e3;\n}\n\nsub,\nsup {\n  position: relative;\n  font-size: 0.75em;\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub {\n  bottom: -0.25em;\n}\n\nsup {\n  top: -0.5em;\n}\n\na {\n  color: var(--admin-color);\n  text-decoration: underline;\n}\n\na:hover {\n  /* color: #6d88c2; */\n}\n\na:not([href]):not([className]),\na:not([href]):not([className]):hover {\n  color: inherit;\n  text-decoration: none;\n}\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: var(--bs-font-monospace);\n  font-size: 1em;\n  direction: ltr\n    /* rtl:ignore */\n  ;\n  unicode-bidi: bidi-override;\n}\n\npre {\n  display: block;\n  margin-top: 0;\n  margin-bottom: 1rem;\n  overflow: auto;\n  font-size: 0.875em;\n}\n\npre code {\n  font-size: inherit;\n  color: inherit;\n  word-break: normal;\n}\n\ncode {\n  font-size: 0.875em;\n  color: #ee5588;\n  word-wrap: break-word;\n}\n\na>code {\n  color: inherit;\n}\n\nkbd {\n  padding: 0.2rem 0.4rem;\n  font-size: 0.875em;\n  color: #ffffff;\n  background-color: #212529;\n  border-radius: 0.2rem;\n}\n\nkbd kbd {\n  padding: 0;\n  font-size: 1em;\n  font-weight: 700;\n}\n\nfigure {\n  margin: 0 0 1rem;\n}\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\ntable {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  color: #6c757d;\n  text-align: left;\n}\n\nth {\n  text-align: inherit;\n  text-align: -webkit-match-parent;\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n  vertical-align: middle;\n  padding: 15px 0 !important;\n}\n\ntable.table tr td {\n  font-size: 14px;\n  padding: 10px 10px !important;\n}\n\nthead th {\n  /* font-weight: 600 !important; */\n  color: var(--gray-text-color) !important;\n  /* background: var(--gray-bg-color) !important; */\n  padding: 15px 10px !important;\n}\n\nlabel {\n  display: inline-block;\n}\n\nbutton {\n  border-radius: 0;\n  font-size: 13px !important;\n  /* padding: 15px 18px; */\n}\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0;\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n}\n\nbutton,\nselect {\n  text-transform: none;\n}\n\n[role=button] {\n  cursor: pointer;\n}\n\nselect {\n  word-wrap: normal;\n}\n\nselect:disabled {\n  opacity: 1;\n  cursor: not-allowed !important;\n}\n\n[list]::-webkit-calendar-picker-indicator {\n  display: none;\n}\n\nbutton,\n[type=button],\n[type=reset],\n[type=submit] {\n  -webkit-appearance: button;\n}\n\nbutton:not(:disabled),\n[type=button]:not(:disabled),\n[type=reset]:not(:disabled),\n[type=submit]:not(:disabled) {\n  cursor: pointer;\n}\n\n::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\ntextarea {\n  resize: vertical;\n}\n\nfieldset {\n  min-width: 0;\n  padding: 0;\n  margin: 0;\n  border: 0;\n}\n\nlegend {\n  float: left;\n  width: 100%;\n  padding: 0;\n  margin-bottom: 0.5rem;\n  font-size: calc(1.275rem + 0.3vw);\n  line-height: inherit;\n}\n\n@media (min-width: 1200px) {\n  legend {\n    font-size: 1.5rem;\n  }\n}\n\nlegend+* {\n  clear: left;\n}\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n\n::-webkit-inner-spin-button {\n  height: auto;\n}\n\n[type=search] {\n  outline-offset: -2px;\n  -webkit-appearance: textfield;\n}\n\n/* rtl:raw:\n[type=\"tel\"],\n[type=\"url\"],\n[type=\"email\"],\n[type=\"number\"] {\n  direction: ltr;\n}\n*/\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n\n::-webkit-file-upload-button {\n  font: inherit;\n}\n\n::file-selector-button {\n  font: inherit;\n}\n\n::-webkit-file-upload-button {\n  font: inherit;\n  -webkit-appearance: button;\n}\n\noutput {\n  display: inline-block;\n}\n\niframe {\n  border: 0;\n}\n\nsummary {\n  display: list-item;\n  cursor: pointer;\n}\n\nprogress {\n  vertical-align: baseline;\n}\n\n[hidden] {\n  display: none !important;\n}\n\n.lead {\n  font-size: 1.09375rem;\n  font-weight: 300;\n}\n\n.display-1 {\n  font-size: calc(1.625rem + 4.5vw);\n  font-weight: 300;\n  line-height: 1.2;\n}\n\n@media (min-width: 1200px) {\n  .display-1 {\n    font-size: 5rem;\n  }\n}\n\n.display-2 {\n  font-size: calc(1.575rem + 3.9vw);\n  font-weight: 300;\n  line-height: 1.2;\n}\n\n@media (min-width: 1200px) {\n  .display-2 {\n    font-size: 4.5rem;\n  }\n}\n\n.display-3 {\n  font-size: calc(1.525rem + 3.3vw);\n  font-weight: 300;\n  line-height: 1.2;\n}\n\n@media (min-width: 1200px) {\n  .display-3 {\n    font-size: 4rem;\n  }\n}\n\n.display-4 {\n  font-size: calc(1.475rem + 2.7vw);\n  font-weight: 300;\n  line-height: 1.2;\n}\n\n@media (min-width: 1200px) {\n  .display-4 {\n    font-size: 3.5rem;\n  }\n}\n\n.display-5 {\n  font-size: calc(1.425rem + 2.1vw);\n  font-weight: 300;\n  line-height: 1.2;\n}\n\n@media (min-width: 1200px) {\n  .display-5 {\n    font-size: 3rem;\n  }\n}\n\n.display-6 {\n  font-size: calc(1.375rem + 1.5vw);\n  font-weight: 300;\n  line-height: 1.2;\n}\n\n@media (min-width: 1200px) {\n  .display-6 {\n    font-size: 2.5rem;\n  }\n}\n\n.list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n\n.list-inline {\n  padding-left: 0;\n  list-style: none;\n}\n\n.list-inline-item {\n  display: inline-block;\n}\n\n.list-inline-item:not(:last-child) {\n  margin-right: 0.5rem;\n}\n\n.initialism {\n  font-size: 0.875em;\n  text-transform: uppercase;\n}\n\n.blockquote {\n  margin-bottom: 1rem;\n  font-size: 1.09375rem;\n}\n\n.blockquote> :last-child {\n  margin-bottom: 0;\n}\n\n.blockquote-footer {\n  margin-top: -1rem;\n  margin-bottom: 1rem;\n  font-size: 0.875em;\n  color: #6c757d;\n}\n\n.blockquote-footer::before {\n  content: \"— \";\n}\n\n.img-fluid {\n  max-width: 100%;\n  height: auto;\n}\n\n.img-thumbnail {\n  padding: 0.25rem;\n  background-color: #fdfdfd;\n  border: 1px solid #dee2e6;\n  border-radius: 0.25rem;\n  max-width: 100%;\n  height: auto;\n}\n\n.figure {\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: 0.5rem;\n  line-height: 1;\n}\n\n.figure-caption {\n  font-size: 0.875em;\n  color: #6c757d;\n}\n\n.container,\n.container-fluid,\n.container-xxl,\n.container-xl,\n.container-lg,\n.container-md,\n.container-sm {\n  width: 100%;\n  padding-right: var(--bs-gutter-x, 0.75rem);\n  padding-left: var(--bs-gutter-x, 0.75rem);\n  margin-right: auto;\n  margin-left: auto;\n}\n\n@media (min-width: 576px) {\n\n  .container-sm,\n  .container {\n    max-width: 540px;\n  }\n}\n\n@media (min-width: 768px) {\n\n  .container-md,\n  .container-sm,\n  .container {\n    max-width: 720px;\n  }\n}\n\n@media (min-width: 992px) {\n\n  .container-lg,\n  .container-md,\n  .container-sm,\n  .container {\n    max-width: 960px;\n  }\n}\n\n@media (min-width: 1200px) {\n\n  .container-xl,\n  .container-lg,\n  .container-md,\n  .container-sm,\n  .container {\n    max-width: 1140px;\n  }\n}\n\n@media (min-width: 1500px) {\n\n  .container-xxl,\n  .container-xl,\n  .container-lg,\n  .container-md,\n  .container-sm,\n  .container {\n    max-width: 1320px;\n  }\n}\n\n.row {\n  --bs-gutter-x: 1.5rem;\n  --bs-gutter-y: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  margin-top: calc(-1 * var(--bs-gutter-y));\n  margin-right: calc(-.5 * var(--bs-gutter-x));\n  margin-left: calc(-.5 * var(--bs-gutter-x));\n}\n\n.row>* {\n  -ms-flex-negative: 0;\n  flex-shrink: 0;\n  /* width: 100%; */\n  max-width: 100%;\n  padding-right: calc(var(--bs-gutter-x) * .5);\n  padding-left: calc(var(--bs-gutter-x) * .5);\n  margin-top: var(--bs-gutter-y);\n}\n\n.col {\n  -webkit-box-flex: 1;\n  -ms-flex: 1 0 0%;\n  flex: 1 0 0%;\n}\n\n.row-cols-auto>* {\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n  width: auto;\n}\n\n.row-cols-1>* {\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n  width: 100%;\n}\n\n.row-cols-2>* {\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n  width: 50%;\n}\n\n.row-cols-3>* {\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n  width: 33.3333333333%;\n}\n\n.row-cols-4>* {\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n  width: 25%;\n}\n\n.row-cols-5>* {\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n  width: 20%;\n}\n\n.row-cols-6>* {\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n  width: 16.6666666667%;\n}\n\n.col-auto {\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n  width: auto;\n}\n\n.col-1 {\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n  width: 8.33333333%;\n}\n\n.col-2 {\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n  width: 16.66666667%;\n}\n\n.col-3 {\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n  width: 25%;\n}\n\n.col-4 {\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n  width: 33.33333333%;\n}\n\n.col-5 {\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n  width: 41.66666667%;\n}\n\n.col-6 {\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n  width: 50%;\n}\n\n.col-7 {\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n  width: 58.33333333%;\n}\n\n.col-8 {\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n  width: 66.66666667%;\n}\n\n.col-9 {\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n  width: 75%;\n}\n\n.col-10 {\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n  width: 83.33333333%;\n}\n\n.col-11 {\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n  width: 91.66666667%;\n}\n\n.col-12 {\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n  width: 100%;\n}\n\n.offset-1 {\n  margin-left: 8.33333333%;\n}\n\n.offset-2 {\n  margin-left: 16.66666667%;\n}\n\n.offset-3 {\n  margin-left: 25%;\n}\n\n.offset-4 {\n  margin-left: 33.33333333%;\n}\n\n.offset-5 {\n  margin-left: 41.66666667%;\n}\n\n.offset-6 {\n  margin-left: 50%;\n}\n\n.offset-7 {\n  margin-left: 58.33333333%;\n}\n\n.offset-8 {\n  margin-left: 66.66666667%;\n}\n\n.offset-9 {\n  margin-left: 75%;\n}\n\n.offset-10 {\n  margin-left: 83.33333333%;\n}\n\n.offset-11 {\n  margin-left: 91.66666667%;\n}\n\n.g-6,\n.gx-6 {\n  --bs-gutter-x: 3.5rem;\n}\n\n.g-6,\n.gy-6 {\n  --bs-gutter-y: 3.5rem;\n}\n\n.g-7,\n.gx-7 {\n  --bs-gutter-x: 4rem;\n}\n\n.g-7,\n.gy-7 {\n  --bs-gutter-y: 4rem;\n}\n\n.g-8,\n.gx-8 {\n  --bs-gutter-x: 4.5rem;\n}\n\n.g-8,\n.gy-8 {\n  --bs-gutter-y: 4.5rem;\n}\n\n.g-9,\n.gx-9 {\n  --bs-gutter-x: 5rem;\n}\n\n.g-9,\n.gy-9 {\n  --bs-gutter-y: 5rem;\n}\n\n@media (min-width: 576px) {\n  .col-sm {\n    -webkit-box-flex: 1;\n    -ms-flex: 1 0 0%;\n    flex: 1 0 0%;\n  }\n\n  .row-cols-sm-auto>* {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: auto;\n  }\n\n  .row-cols-sm-1>* {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 100%;\n  }\n\n  .row-cols-sm-2>* {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 50%;\n  }\n\n  .row-cols-sm-3>* {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 33.3333333333%;\n  }\n\n  .row-cols-sm-4>* {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 25%;\n  }\n\n  .row-cols-sm-5>* {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 20%;\n  }\n\n  .row-cols-sm-6>* {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 16.6666666667%;\n  }\n\n  .col-sm-auto {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: auto;\n  }\n\n  .col-sm-1 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n\n  .col-sm-2 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n\n  .col-sm-3 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 25%;\n  }\n\n  .col-sm-4 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n\n  .col-sm-5 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n\n  .col-sm-6 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 50%;\n  }\n\n  .col-sm-7 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n\n  .col-sm-8 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n\n  .col-sm-9 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 75%;\n  }\n\n  .col-sm-10 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n\n  .col-sm-11 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n\n  .col-sm-12 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 100%;\n  }\n\n  .offset-sm-0 {\n    margin-left: 0;\n  }\n\n  .offset-sm-1 {\n    margin-left: 8.33333333%;\n  }\n\n  .offset-sm-2 {\n    margin-left: 16.66666667%;\n  }\n\n  .offset-sm-3 {\n    margin-left: 25%;\n  }\n\n  .offset-sm-4 {\n    margin-left: 33.33333333%;\n  }\n\n  .offset-sm-5 {\n    margin-left: 41.66666667%;\n  }\n\n  .offset-sm-6 {\n    margin-left: 50%;\n  }\n\n  .offset-sm-7 {\n    margin-left: 58.33333333%;\n  }\n\n  .offset-sm-8 {\n    margin-left: 66.66666667%;\n  }\n\n  .offset-sm-9 {\n    margin-left: 75%;\n  }\n\n  .offset-sm-10 {\n    margin-left: 83.33333333%;\n  }\n\n  .offset-sm-11 {\n    margin-left: 91.66666667%;\n  }\n\n  .g-sm-6,\n  .gx-sm-6 {\n    --bs-gutter-x: 3.5rem;\n  }\n\n  .g-sm-6,\n  .gy-sm-6 {\n    --bs-gutter-y: 3.5rem;\n  }\n\n  .g-sm-7,\n  .gx-sm-7 {\n    --bs-gutter-x: 4rem;\n  }\n\n  .g-sm-7,\n  .gy-sm-7 {\n    --bs-gutter-y: 4rem;\n  }\n\n  .g-sm-8,\n  .gx-sm-8 {\n    --bs-gutter-x: 4.5rem;\n  }\n\n  .g-sm-8,\n  .gy-sm-8 {\n    --bs-gutter-y: 4.5rem;\n  }\n\n  .g-sm-9,\n  .gx-sm-9 {\n    --bs-gutter-x: 5rem;\n  }\n\n  .g-sm-9,\n  .gy-sm-9 {\n    --bs-gutter-y: 5rem;\n  }\n}\n\n@media (min-width: 768px) {\n  .col-md {\n    -webkit-box-flex: 1;\n    -ms-flex: 1 0 0%;\n    flex: 1 0 0%;\n  }\n\n  .row-cols-md-auto>* {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: auto;\n  }\n\n  .row-cols-md-1>* {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 100%;\n  }\n\n  .row-cols-md-2>* {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 50%;\n  }\n\n  .row-cols-md-3>* {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 33.3333333333%;\n  }\n\n  .row-cols-md-4>* {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 25%;\n  }\n\n  .row-cols-md-5>* {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 20%;\n  }\n\n  .row-cols-md-6>* {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 16.6666666667%;\n  }\n\n  .col-md-auto {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: auto;\n  }\n\n  .col-md-1 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n\n  .col-md-2 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n\n  .col-md-3 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 25%;\n  }\n\n  .col-md-4 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n\n  .col-md-5 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n\n  .col-md-6 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 50%;\n  }\n\n  .col-md-7 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n\n  .col-md-8 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n\n  .col-md-9 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 75%;\n  }\n\n  .col-md-10 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n\n  .col-md-11 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n\n  .col-md-12 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 100%;\n  }\n\n  .offset-md-0 {\n    margin-left: 0;\n  }\n\n  .offset-md-1 {\n    margin-left: 8.33333333%;\n  }\n\n  .offset-md-2 {\n    margin-left: 16.66666667%;\n  }\n\n  .offset-md-3 {\n    margin-left: 25%;\n  }\n\n  .offset-md-4 {\n    margin-left: 33.33333333%;\n  }\n\n  .offset-md-5 {\n    margin-left: 41.66666667%;\n  }\n\n  .offset-md-6 {\n    margin-left: 50%;\n  }\n\n  .offset-md-7 {\n    margin-left: 58.33333333%;\n  }\n\n  .offset-md-8 {\n    margin-left: 66.66666667%;\n  }\n\n  .offset-md-9 {\n    margin-left: 75%;\n  }\n\n  .offset-md-10 {\n    margin-left: 83.33333333%;\n  }\n\n  .offset-md-11 {\n    margin-left: 91.66666667%;\n  }\n\n  .g-md-6,\n  .gx-md-6 {\n    --bs-gutter-x: 3.5rem;\n  }\n\n  .g-md-6,\n  .gy-md-6 {\n    --bs-gutter-y: 3.5rem;\n  }\n\n  .g-md-7,\n  .gx-md-7 {\n    --bs-gutter-x: 4rem;\n  }\n\n  .g-md-7,\n  .gy-md-7 {\n    --bs-gutter-y: 4rem;\n  }\n\n  .g-md-8,\n  .gx-md-8 {\n    --bs-gutter-x: 4.5rem;\n  }\n\n  .g-md-8,\n  .gy-md-8 {\n    --bs-gutter-y: 4.5rem;\n  }\n\n  .g-md-9,\n  .gx-md-9 {\n    --bs-gutter-x: 5rem;\n  }\n\n  .g-md-9,\n  .gy-md-9 {\n    --bs-gutter-y: 5rem;\n  }\n}\n\n@media (min-width: 992px) {\n  .col-lg {\n    -webkit-box-flex: 1;\n    -ms-flex: 1 0 0%;\n    flex: 1 0 0%;\n  }\n\n  .row-cols-lg-auto>* {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: auto;\n  }\n\n  .row-cols-lg-1>* {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 100%;\n  }\n\n  .row-cols-lg-2>* {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 50%;\n  }\n\n  .row-cols-lg-3>* {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 33.3333333333%;\n  }\n\n  .row-cols-lg-4>* {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 25%;\n  }\n\n  .row-cols-lg-5>* {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 20%;\n  }\n\n  .row-cols-lg-6>* {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 16.6666666667%;\n  }\n\n  .col-lg-auto {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: auto;\n  }\n\n  .col-lg-1 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n\n  .col-lg-2 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n\n  .col-lg-3 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 25%;\n  }\n\n  .col-lg-4 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n\n  .col-lg-5 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n\n  .col-lg-6 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 50%;\n  }\n\n  .col-lg-7 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n\n  .col-lg-8 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n\n  .col-lg-9 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 75%;\n  }\n\n  .col-lg-10 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n\n  .col-lg-11 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n\n  .col-lg-12 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 100%;\n  }\n\n  .offset-lg-0 {\n    margin-left: 0;\n  }\n\n  .offset-lg-1 {\n    margin-left: 8.33333333%;\n  }\n\n  .offset-lg-2 {\n    margin-left: 16.66666667%;\n  }\n\n  .offset-lg-3 {\n    margin-left: 25%;\n  }\n\n  .offset-lg-4 {\n    margin-left: 33.33333333%;\n  }\n\n  .offset-lg-5 {\n    margin-left: 41.66666667%;\n  }\n\n  .offset-lg-6 {\n    margin-left: 50%;\n  }\n\n  .offset-lg-7 {\n    margin-left: 58.33333333%;\n  }\n\n  .offset-lg-8 {\n    margin-left: 66.66666667%;\n  }\n\n  .offset-lg-9 {\n    margin-left: 75%;\n  }\n\n  .offset-lg-10 {\n    margin-left: 83.33333333%;\n  }\n\n  .offset-lg-11 {\n    margin-left: 91.66666667%;\n  }\n\n  .g-lg-6,\n  .gx-lg-6 {\n    --bs-gutter-x: 3.5rem;\n  }\n\n  .g-lg-6,\n  .gy-lg-6 {\n    --bs-gutter-y: 3.5rem;\n  }\n\n  .g-lg-7,\n  .gx-lg-7 {\n    --bs-gutter-x: 4rem;\n  }\n\n  .g-lg-7,\n  .gy-lg-7 {\n    --bs-gutter-y: 4rem;\n  }\n\n  .g-lg-8,\n  .gx-lg-8 {\n    --bs-gutter-x: 4.5rem;\n  }\n\n  .g-lg-8,\n  .gy-lg-8 {\n    --bs-gutter-y: 4.5rem;\n  }\n\n  .g-lg-9,\n  .gx-lg-9 {\n    --bs-gutter-x: 5rem;\n  }\n\n  .g-lg-9,\n  .gy-lg-9 {\n    --bs-gutter-y: 5rem;\n  }\n}\n\n@media (min-width: 1200px) {\n  .col-xl {\n    -webkit-box-flex: 1;\n    -ms-flex: 1 0 0%;\n    flex: 1 0 0%;\n  }\n\n  .row-cols-xl-auto>* {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: auto;\n  }\n\n  .row-cols-xl-1>* {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 100%;\n  }\n\n  .row-cols-xl-2>* {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 50%;\n  }\n\n  .row-cols-xl-3>* {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 33.3333333333%;\n  }\n\n  .row-cols-xl-4>* {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 25%;\n  }\n\n  .row-cols-xl-5>* {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 20%;\n  }\n\n  .row-cols-xl-6>* {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 16.6666666667%;\n  }\n\n  .col-xl-auto {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: auto;\n  }\n\n  .col-xl-1 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n\n  .col-xl-2 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n\n  .col-xl-3 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 25%;\n  }\n\n  .col-xl-4 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n\n  .col-xl-5 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n\n  .col-xl-6 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 50%;\n  }\n\n  .col-xl-7 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n\n  .col-xl-8 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n\n  .col-xl-9 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 75%;\n  }\n\n  .col-xl-10 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n\n  .col-xl-11 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n\n  .col-xl-12 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 100%;\n  }\n\n  .offset-xl-0 {\n    margin-left: 0;\n  }\n\n  .offset-xl-1 {\n    margin-left: 8.33333333%;\n  }\n\n  .offset-xl-2 {\n    margin-left: 16.66666667%;\n  }\n\n  .offset-xl-3 {\n    margin-left: 25%;\n  }\n\n  .offset-xl-4 {\n    margin-left: 33.33333333%;\n  }\n\n  .offset-xl-5 {\n    margin-left: 41.66666667%;\n  }\n\n  .offset-xl-6 {\n    margin-left: 50%;\n  }\n\n  .offset-xl-7 {\n    margin-left: 58.33333333%;\n  }\n\n  .offset-xl-8 {\n    margin-left: 66.66666667%;\n  }\n\n  .offset-xl-9 {\n    margin-left: 75%;\n  }\n\n  .offset-xl-10 {\n    margin-left: 83.33333333%;\n  }\n\n  .offset-xl-11 {\n    margin-left: 91.66666667%;\n  }\n\n  .g-xl-6,\n  .gx-xl-6 {\n    --bs-gutter-x: 3.5rem;\n  }\n\n  .g-xl-6,\n  .gy-xl-6 {\n    --bs-gutter-y: 3.5rem;\n  }\n\n  .g-xl-7,\n  .gx-xl-7 {\n    --bs-gutter-x: 4rem;\n  }\n\n  .g-xl-7,\n  .gy-xl-7 {\n    --bs-gutter-y: 4rem;\n  }\n\n  .g-xl-8,\n  .gx-xl-8 {\n    --bs-gutter-x: 4.5rem;\n  }\n\n  .g-xl-8,\n  .gy-xl-8 {\n    --bs-gutter-y: 4.5rem;\n  }\n\n  .g-xl-9,\n  .gx-xl-9 {\n    --bs-gutter-x: 5rem;\n  }\n\n  .g-xl-9,\n  .gy-xl-9 {\n    --bs-gutter-y: 5rem;\n  }\n}\n\n@media (min-width: 1500px) {\n  .col-xxl {\n    -webkit-box-flex: 1;\n    -ms-flex: 1 0 0%;\n    flex: 1 0 0%;\n  }\n\n  .row-cols-xxl-auto>* {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: auto;\n  }\n\n  .row-cols-xxl-1>* {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 100%;\n  }\n\n  .row-cols-xxl-2>* {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 50%;\n  }\n\n  .row-cols-xxl-3>* {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 33.3333333333%;\n  }\n\n  .row-cols-xxl-4>* {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 25%;\n  }\n\n  .row-cols-xxl-5>* {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 20%;\n  }\n\n  .row-cols-xxl-6>* {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 16.6666666667%;\n  }\n\n  .col-xxl-auto {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: auto;\n  }\n\n  .col-xxl-1 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n\n  .col-xxl-2 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n\n  .col-xxl-3 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 25%;\n  }\n\n  .col-xxl-4 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n\n  .col-xxl-5 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n\n  .col-xxl-6 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 50%;\n  }\n\n  .col-xxl-7 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n\n  .col-xxl-8 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n\n  .col-xxl-9 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 75%;\n  }\n\n  .col-xxl-10 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n\n  .col-xxl-11 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n\n  .col-xxl-12 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 100%;\n  }\n\n  .offset-xxl-0 {\n    margin-left: 0;\n  }\n\n  .offset-xxl-1 {\n    margin-left: 8.33333333%;\n  }\n\n  .offset-xxl-2 {\n    margin-left: 16.66666667%;\n  }\n\n  .offset-xxl-3 {\n    margin-left: 25%;\n  }\n\n  .offset-xxl-4 {\n    margin-left: 33.33333333%;\n  }\n\n  .offset-xxl-5 {\n    margin-left: 41.66666667%;\n  }\n\n  .offset-xxl-6 {\n    margin-left: 50%;\n  }\n\n  .offset-xxl-7 {\n    margin-left: 58.33333333%;\n  }\n\n  .offset-xxl-8 {\n    margin-left: 66.66666667%;\n  }\n\n  .offset-xxl-9 {\n    margin-left: 75%;\n  }\n\n  .offset-xxl-10 {\n    margin-left: 83.33333333%;\n  }\n\n  .offset-xxl-11 {\n    margin-left: 91.66666667%;\n  }\n\n  .g-xxl-6,\n  .gx-xxl-6 {\n    --bs-gutter-x: 3.5rem;\n  }\n\n  .g-xxl-6,\n  .gy-xxl-6 {\n    --bs-gutter-y: 3.5rem;\n  }\n\n  .g-xxl-7,\n  .gx-xxl-7 {\n    --bs-gutter-x: 4rem;\n  }\n\n  .g-xxl-7,\n  .gy-xxl-7 {\n    --bs-gutter-y: 4rem;\n  }\n\n  .g-xxl-8,\n  .gx-xxl-8 {\n    --bs-gutter-x: 4.5rem;\n  }\n\n  .g-xxl-8,\n  .gy-xxl-8 {\n    --bs-gutter-y: 4.5rem;\n  }\n\n  .g-xxl-9,\n  .gx-xxl-9 {\n    --bs-gutter-x: 5rem;\n  }\n\n  .g-xxl-9,\n  .gy-xxl-9 {\n    --bs-gutter-y: 5rem;\n  }\n}\n\n.table {\n  --bs-table-bg: transparent;\n  --bs-table-accent-bg: transparent;\n  --bs-table-striped-color: var(--bs-body-color);\n  --bs-table-striped-bg: rgba(0, 0, 0, 0.05);\n  --bs-table-active-color: var(--bs-body-color);\n  --bs-table-active-bg: rgba(0, 0, 0, 0.1);\n  --bs-table-hover-color: var(--bs-body-color);\n  --bs-table-hover-bg: rgba(0, 0, 0, 0.075);\n  width: 100%;\n  /* margin-bottom: 1rem; */\n  color: var(--bs-black-rgb);\n  vertical-align: top;\n  border-color: var(--border-color);\n}\n\n.tableOutline {\n  border-radius: 10px;\n  border: 1px solid var(--border-color);\n}\n\n.cardWrapper table tr:last-child td {\n  border: 0;\n}\n\n.paginationWrapper .row {\n  border-radius: 10px;\n  border: 1px solid var(--border-color);\n  padding: 10px 10px;\n}\n\n.table> :not(caption)>*>* {\n  padding: 0.5rem 0.5rem;\n  background-color: var(--bs-table-bg);\n  border-bottom-width: 1px;\n  -webkit-box-shadow: inset 0 0 0 9999px var(--bs-table-accent-bg);\n  box-shadow: inset 0 0 0 9999px var(--bs-table-accent-bg);\n}\n\n.table>tbody {\n  vertical-align: inherit;\n}\n\n.table>thead {\n  vertical-align: bottom;\n}\n\n.table> :not(:first-child) {\n  border-top: 1px solid currentColor;\n}\n\n.caption-top {\n  caption-side: top;\n}\n\n.table-sm> :not(caption)>*>* {\n  padding: 0.25rem 0.25rem;\n}\n\n.table-bordered> :not(caption)>* {\n  border-width: 1px 0;\n}\n\n.table-bordered> :not(caption)>*>* {\n  border-width: 0 1px;\n}\n\n.table-borderless> :not(caption)>*>* {\n  border-bottom-width: 0;\n}\n\n.table-borderless> :not(:first-child) {\n  border-top-width: 0;\n}\n\n.table-striped>tbody>tr:nth-of-type(odd)>* {\n  --bs-table-accent-bg: var(--bs-table-striped-bg);\n  color: var(--bs-table-striped-color);\n}\n\n.table-active {\n  --bs-table-accent-bg: var(--bs-table-active-bg);\n  color: var(--bs-table-active-color);\n}\n\n.table-hover>tbody>tr:hover>* {\n  --bs-table-accent-bg: var(--bs-table-hover-bg);\n  color: var(--bs-table-hover-color);\n}\n\n.table-primary {\n  --bs-table-bg: #e7eefd;\n  --bs-table-striped-bg: #dbe2f0;\n  --bs-table-striped-color: #000;\n  --bs-table-active-bg: #d0d6e4;\n  --bs-table-active-color: #000;\n  --bs-table-hover-bg: #d6dcea;\n  --bs-table-hover-color: #000;\n  color: #000;\n  border-color: #d0d6e4;\n}\n\n.table-secondary {\n  --bs-table-bg: #e8e9eb;\n  --bs-table-striped-bg: #dcdddf;\n  --bs-table-striped-color: #000;\n  --bs-table-active-bg: #d1d2d4;\n  --bs-table-active-color: #000;\n  --bs-table-hover-bg: #d7d8d9;\n  --bs-table-hover-color: #000;\n  color: #000;\n  border-color: #d1d2d4;\n}\n\n.table-success {\n  --bs-table-bg: #d6f4ea;\n  --bs-table-striped-bg: #cbe8de;\n  --bs-table-striped-color: #000;\n  --bs-table-active-bg: #c1dcd3;\n  --bs-table-active-color: #000;\n  --bs-table-hover-bg: #c6e2d8;\n  --bs-table-hover-color: #000;\n  color: #000;\n  border-color: #c1dcd3;\n}\n\n.table-info {\n  --bs-table-bg: #d3f3f8;\n  --bs-table-striped-bg: #c8e7ec;\n  --bs-table-striped-color: #000;\n  --bs-table-active-bg: #bedbdf;\n  --bs-table-active-color: #000;\n  --bs-table-hover-bg: #c3e1e5;\n  --bs-table-hover-color: #000;\n  color: #000;\n  border-color: #bedbdf;\n}\n\n.table-warning {\n  --bs-table-bg: #f8eecd;\n  --bs-table-striped-bg: #ece2c3;\n  --bs-table-striped-color: #000;\n  --bs-table-active-bg: #dfd6b9;\n  --bs-table-active-color: #000;\n  --bs-table-hover-bg: #e5dcbe;\n  --bs-table-hover-color: #000;\n  color: #000;\n  border-color: #dfd6b9;\n}\n\n.table-danger {\n  --bs-table-bg: #fbdbde;\n  --bs-table-striped-bg: #eed0d3;\n  --bs-table-striped-color: #000;\n  --bs-table-active-bg: #e2c5c8;\n  --bs-table-active-color: #000;\n  --bs-table-hover-bg: #e8cbcd;\n  --bs-table-hover-color: #000;\n  color: #000;\n  border-color: #e2c5c8;\n}\n\n.table-light {\n  --bs-table-bg: #fdfdfd;\n  --bs-table-striped-bg: #f0f0f0;\n  --bs-table-striped-color: #000;\n  --bs-table-active-bg: #e4e4e4;\n  --bs-table-active-color: #000;\n  --bs-table-hover-bg: #eaeaea;\n  --bs-table-hover-color: #000;\n  color: #000;\n  border-color: #e4e4e4;\n}\n\n.table-dark {\n  --bs-table-bg: var(--text-color);\n  --bs-table-striped-bg: #5e6875;\n  --bs-table-striped-color: #ffffff;\n  --bs-table-active-bg: #67707d;\n  --bs-table-active-color: #ffffff;\n  --bs-table-hover-bg: #636c79;\n  --bs-table-hover-color: #ffffff;\n  color: #ffffff;\n  border-color: #67707d;\n}\n\n.table-responsive {\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n@media (max-width: 575.98px) {\n  .table-responsive-sm {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .table-responsive-md {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n\n@media (max-width: 991.98px) {\n  .table-responsive-lg {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n\n@media (max-width: 1199.98px) {\n  .table-responsive-xl {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n\n@media (max-width: 1499.98px) {\n  .table-responsive-xxl {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n\n.form-label {\n  font-size: 15px;\n  font-weight: 500;\n  margin-bottom: 8px;\n  color: var(--gray-text-color);\n}\n\n.col-form-label {\n  padding-top: calc(0.59rem + 1px);\n  padding-bottom: calc(0.59rem + 1px);\n  margin-bottom: 0;\n  font-size: inherit;\n  line-height: 1.5;\n}\n\n.col-form-label-lg {\n  padding-top: calc(0.75rem + 1px);\n  padding-bottom: calc(0.75rem + 1px);\n  font-size: 1.09375rem;\n}\n\n.col-form-label-sm {\n  padding-top: calc(0.25rem + 1px);\n  padding-bottom: calc(0.25rem + 1px);\n  font-size: 0.765625rem;\n}\n\n.form-text {\n  margin-top: 0.25rem;\n  font-size: 0.875em;\n  color: #6c757d;\n}\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: 0.59rem 1rem;\n  font-size: 0.875rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: var(--bs-black-rgb);\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid var(--border-color);\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  border-radius: 0.25rem;\n  -webkit-transition: border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;\n  transition: border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;\n}\n\nselect.form-control {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right 1rem center;\n  background-size: 16px 12px;\n  cursor: pointer;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .form-control {\n    -webkit-transition: none;\n    transition: none;\n  }\n}\n\n.form-control[type=file] {\n  overflow: hidden;\n}\n\n.form-control[type=file]:not(:disabled):not([readonly]) {\n  cursor: pointer;\n}\n\n.form-control:focus {\n  color: var(--bs-black-rgb);\n  background-color: #fdfdfd;\n  border-color: #c4d5f9;\n  outline: 0;\n  -webkit-box-shadow: 0 0 0 0.25rem rgba(136, 170, 243, 0.25);\n  box-shadow: 0 0 0 0.25rem rgba(136, 170, 243, 0.25);\n}\n\n.form-control::-webkit-date-and-time-value {\n  height: 1.5em;\n}\n\n.form-control::-webkit-input-placeholder {\n  color: var(--bs-black-rgb);\n  opacity: 1;\n}\n\n.form-control::-moz-placeholder {\n  color: var(--bs-black-rgb);\n  opacity: 1;\n}\n\n.form-control:-ms-input-placeholder {\n  color: var(--bs-black-rgb);\n  opacity: 1;\n}\n\n.form-control::-ms-input-placeholder {\n  color: var(--bs-black-rgb);\n  opacity: 1;\n}\n\n.form-control::placeholder {\n  color: var(--bs-placeholder-color);\n  opacity: 1;\n}\n\n.form-control:disabled,\n.form-control[readonly] {\n  background-color: #e9ecef;\n  opacity: 1;\n}\n\n.form-control::-webkit-file-upload-button {\n  padding: 0.59rem 1rem;\n  margin: -0.59rem -1rem;\n  -webkit-margin-end: 1rem;\n  margin-inline-end: 1rem;\n  color: var(--bs-black-rgb);\n  background-color: #e9ecef;\n  pointer-events: none;\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n  border-inline-end-width: 1px;\n  border-radius: 0;\n  -webkit-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;\n}\n\n.form-control::file-selector-button {\n  padding: 0.59rem 1rem;\n  margin: -0.59rem -1rem;\n  -webkit-margin-end: 1rem;\n  margin-inline-end: 1rem;\n  color: var(--bs-body-color);\n  background-color: #e9ecef;\n  pointer-events: none;\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n  border-inline-end-width: 1px;\n  border-radius: 0;\n  -webkit-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .form-control::-webkit-file-upload-button {\n    -webkit-transition: none;\n    transition: none;\n  }\n\n  .form-control::file-selector-button {\n    -webkit-transition: none;\n    transition: none;\n  }\n}\n\n.form-control:hover:not(:disabled):not([readonly])::-webkit-file-upload-button {\n  background-color: #dde0e3;\n}\n\n.form-control:hover:not(:disabled):not([readonly])::file-selector-button {\n  background-color: #dde0e3;\n}\n\n.form-control::-webkit-file-upload-button {\n  padding: 0.59rem 1rem;\n  margin: -0.59rem -1rem;\n  -webkit-margin-end: 1rem;\n  margin-inline-end: 1rem;\n  color: var(--bs-body-color);\n  background-color: #e9ecef;\n  pointer-events: none;\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n  border-inline-end-width: 1px;\n  border-radius: 0;\n  -webkit-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .form-control::-webkit-file-upload-button {\n    -webkit-transition: none;\n    transition: none;\n  }\n}\n\n.form-control:hover:not(:disabled):not([readonly])::-webkit-file-upload-button {\n  background-color: #dde0e3;\n}\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: 0.59rem 0;\n  margin-bottom: 0;\n  line-height: 1.5;\n  color: var(--bs-body-color);\n  background-color: transparent;\n  border: solid transparent;\n  border-width: 1px 0;\n}\n\n.form-control-plaintext.form-control-sm,\n.form-control-plaintext.form-control-lg {\n  padding-right: 0;\n  padding-left: 0;\n}\n\n.form-control-sm {\n  min-height: calc(1.5em + 0.5rem + 2px);\n  padding: 0.25rem 0.5rem;\n  font-size: 0.765625rem;\n  border-radius: 0.2rem;\n}\n\n.form-control-sm::-webkit-file-upload-button {\n  padding: 0.25rem 0.5rem;\n  margin: -0.25rem -0.5rem;\n  -webkit-margin-end: 0.5rem;\n  margin-inline-end: 0.5rem;\n}\n\n.form-control-sm::file-selector-button {\n  padding: 0.25rem 0.5rem;\n  margin: -0.25rem -0.5rem;\n  -webkit-margin-end: 0.5rem;\n  margin-inline-end: 0.5rem;\n}\n\n.form-control-sm::-webkit-file-upload-button {\n  padding: 0.25rem 0.5rem;\n  margin: -0.25rem -0.5rem;\n  -webkit-margin-end: 0.5rem;\n  margin-inline-end: 0.5rem;\n}\n\n.form-control-lg {\n  min-height: calc(1.5em + 1.5rem + 2px);\n  padding: 0.75rem 1rem;\n  font-size: 1.09375rem;\n  border-radius: 0.3rem;\n}\n\n.form-control-lg::-webkit-file-upload-button {\n  padding: 0.75rem 1rem;\n  margin: -0.75rem -1rem;\n  -webkit-margin-end: 1rem;\n  margin-inline-end: 1rem;\n}\n\n.form-control-lg::file-selector-button {\n  padding: 0.75rem 1rem;\n  margin: -0.75rem -1rem;\n  -webkit-margin-end: 1rem;\n  margin-inline-end: 1rem;\n}\n\n.form-control-lg::-webkit-file-upload-button {\n  padding: 0.75rem 1rem;\n  margin: -0.75rem -1rem;\n  -webkit-margin-end: 1rem;\n  margin-inline-end: 1rem;\n}\n\ntextarea.form-control {\n  min-height: calc(1.5em + 1.18rem + 2px);\n}\n\ntextarea.form-control-sm {\n  min-height: calc(1.5em + 0.5rem + 2px);\n}\n\ntextarea.form-control-lg {\n  min-height: calc(1.5em + 1.5rem + 2px);\n}\n\n.form-control-color {\n  width: 3rem;\n  height: auto;\n  padding: 0.59rem;\n}\n\n.form-control-color:not(:disabled):not([readonly]) {\n  cursor: pointer;\n}\n\n.form-control-color::-moz-color-swatch {\n  height: 1.5em;\n  border-radius: 0.25rem;\n}\n\n.form-control-color::-webkit-color-swatch {\n  height: 1.5em;\n  border-radius: 0.25rem;\n}\n\n.form-select {\n  display: block;\n  width: 100%;\n  padding: 0.59rem 3rem 0.59rem 1rem;\n  -moz-padding-start: calc(1rem - 3px);\n  font-size: 0.875rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: var(--bs-body-color);\n  background-color: #fdfdfd;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right 1rem center;\n  background-size: 16px 12px;\n  border: 1px solid #ced4da;\n  border-radius: 0.25rem;\n  -webkit-transition: border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;\n  transition: border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .form-select {\n    -webkit-transition: none;\n    transition: none;\n  }\n}\n\n.form-select:focus {\n  border-color: #c4d5f9;\n  outline: 0;\n  -webkit-box-shadow: 0 0 0 0.25rem rgba(136, 170, 243, 0.25);\n  box-shadow: 0 0 0 0.25rem rgba(136, 170, 243, 0.25);\n}\n\n.form-select[multiple],\n.form-select[size]:not([size=\"1\"]) {\n  padding-right: 1rem;\n  background-image: none;\n}\n\n.form-select:disabled {\n  background-color: #e9ecef;\n}\n\n.form-select:-moz-focusring {\n  color: transparent;\n  text-shadow: 0 0 0 var(--bs-body-color);\n}\n\n.form-select-sm {\n  padding-top: 0.25rem;\n  padding-bottom: 0.25rem;\n  padding-left: 0.5rem;\n  font-size: 0.765625rem;\n  border-radius: 0.2rem;\n}\n\n.form-select-lg {\n  padding-top: 0.75rem;\n  padding-bottom: 0.75rem;\n  padding-left: 1rem;\n  font-size: 1.09375rem;\n  border-radius: 0.3rem;\n}\n\n.form-check {\n  display: block;\n  min-height: 1.3125rem;\n  padding-left: 1.5em;\n  margin-bottom: 0.125rem;\n}\n\n.form-check .form-check-input {\n  float: left;\n  margin-left: -1.5em;\n}\n\n.form-check-input {\n  width: 1em;\n  height: 1em;\n  margin-top: 0.25em;\n  vertical-align: top;\n  background-color: #fdfdfd;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: 1px solid rgba(0, 0, 0, 0.25);\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  -webkit-print-color-adjust: exact;\n  print-color-adjust: exact;\n}\n\n.form-check-input[type=checkbox] {\n  border-radius: 0.25em;\n}\n\n.form-check-input[type=radio] {\n  border-radius: 50%;\n}\n\n.form-check-input:active {\n  -webkit-filter: brightness(90%);\n  filter: brightness(90%);\n}\n\n.form-check-input:focus {\n  border-color: #c4d5f9;\n  outline: 0;\n  -webkit-box-shadow: 0 0 0 0.25rem rgba(136, 170, 243, 0.25);\n  box-shadow: 0 0 0 0.25rem rgba(136, 170, 243, 0.25);\n}\n\n.form-check-input:checked {\n  background-color: var(--admin-color);\n  border-color: var(--admin-color);\n}\n\n.form-check-input:checked[type=checkbox] {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23ffffff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10l3 3l6-6'/%3e%3c/svg%3e\");\n}\n\n.form-check-input:checked[type=radio] {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='2' fill='%23ffffff'/%3e%3c/svg%3e\");\n}\n\n.form-check-input[type=checkbox]:indeterminate {\n  background-color: var(--admin-color);\n  border-color: var(--admin-color);\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23ffffff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/%3e%3c/svg%3e\");\n}\n\n.form-check-input:disabled {\n  pointer-events: none;\n  -webkit-filter: none;\n  filter: none;\n  opacity: 0.5;\n}\n\n.form-check-input[disabled]~.form-check-label,\n.form-check-input:disabled~.form-check-label {\n  opacity: 0.5;\n}\n\n.form-switch {\n  padding-left: 2.5em;\n}\n\n.form-switch .form-check-input {\n  width: 2em;\n  margin-left: -2.5em;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba%280, 0, 0, 0.25%29'/%3e%3c/svg%3e\");\n  background-position: left center;\n  border-radius: 2em;\n  -webkit-transition: background-position 0.15s ease-in-out;\n  transition: background-position 0.15s ease-in-out;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .form-switch .form-check-input {\n    -webkit-transition: none;\n    transition: none;\n  }\n}\n\n.form-switch .form-check-input:focus {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23c4d5f9'/%3e%3c/svg%3e\");\n}\n\n.form-switch .form-check-input:checked {\n  background-position: right center;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23ffffff'/%3e%3c/svg%3e\");\n}\n\n.form-check-inline {\n  display: inline-block;\n  margin-right: 1rem;\n}\n\n.btn-check {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n}\n\n.btn-check[disabled]+.btn,\n.btn-check:disabled+.btn {\n  pointer-events: none;\n  -webkit-filter: none;\n  filter: none;\n  opacity: 0.65;\n}\n\n.form-range {\n  width: 100%;\n  height: 1.5rem;\n  padding: 0;\n  background-color: transparent;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n}\n\n.form-range:focus {\n  outline: 0;\n}\n\n.form-range:focus::-webkit-slider-thumb {\n  -webkit-box-shadow: 0 0 0 1px #fdfdfd, 0 0 0 0.25rem rgba(136, 170, 243, 0.25);\n  box-shadow: 0 0 0 1px #fdfdfd, 0 0 0 0.25rem rgba(136, 170, 243, 0.25);\n}\n\n.form-range:focus::-moz-range-thumb {\n  box-shadow: 0 0 0 1px #fdfdfd, 0 0 0 0.25rem rgba(136, 170, 243, 0.25);\n}\n\n.form-range::-moz-focus-outer {\n  border: 0;\n}\n\n.form-range::-webkit-slider-thumb {\n  width: 1rem;\n  height: 1rem;\n  margin-top: -0.25rem;\n  background-color: var(--admin-color);\n  border: 0;\n  border-radius: 1rem;\n  -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;\n  -webkit-appearance: none;\n  appearance: none;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .form-range::-webkit-slider-thumb {\n    -webkit-transition: none;\n    transition: none;\n  }\n}\n\n.form-range::-webkit-slider-thumb:active {\n  background-color: #dbe6fb;\n}\n\n.form-range::-webkit-slider-runnable-track {\n  width: 100%;\n  height: 0.5rem;\n  color: transparent;\n  cursor: pointer;\n  background-color: #dee2e6;\n  border-color: transparent;\n  border-radius: 1rem;\n}\n\n.form-range::-moz-range-thumb {\n  width: 1rem;\n  height: 1rem;\n  background-color: var(--admin-color);\n  border: 0;\n  border-radius: 1rem;\n  -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  -moz-appearance: none;\n  appearance: none;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .form-range::-moz-range-thumb {\n    -moz-transition: none;\n    transition: none;\n  }\n}\n\n.form-range::-moz-range-thumb:active {\n  background-color: #dbe6fb;\n}\n\n.form-range::-moz-range-track {\n  width: 100%;\n  height: 0.5rem;\n  color: transparent;\n  cursor: pointer;\n  background-color: #dee2e6;\n  border-color: transparent;\n  border-radius: 1rem;\n}\n\n.form-range:disabled {\n  pointer-events: none;\n}\n\n.form-range:disabled::-webkit-slider-thumb {\n  background-color: #adb5bd;\n}\n\n.form-range:disabled::-moz-range-thumb {\n  background-color: #adb5bd;\n}\n\n.form-floating {\n  position: relative;\n}\n\n.form-floating>.form-control,\n.form-floating>.form-select {\n  height: calc(3.5rem + 2px);\n  line-height: 1.25;\n}\n\n.form-floating>label {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  padding: 1rem 1rem;\n  pointer-events: none;\n  border: 1px solid transparent;\n  -webkit-transform-origin: 0 0;\n  transform-origin: 0 0;\n  -webkit-transition: opacity 0.1s ease-in-out, -webkit-transform 0.1s ease-in-out;\n  transition: opacity 0.1s ease-in-out, -webkit-transform 0.1s ease-in-out;\n  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;\n  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out, -webkit-transform 0.1s ease-in-out;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .form-floating>label {\n    -webkit-transition: none;\n    transition: none;\n  }\n}\n\n.form-floating>.form-control {\n  padding: 1rem 1rem;\n}\n\n.form-floating>.form-control::-webkit-input-placeholder {\n  color: transparent;\n}\n\n.form-floating>.form-control::-moz-placeholder {\n  color: transparent;\n}\n\n.form-floating>.form-control:-ms-input-placeholder {\n  color: transparent;\n}\n\n.form-floating>.form-control::-ms-input-placeholder {\n  color: transparent;\n}\n\n.form-floating>.form-control::placeholder {\n  color: transparent;\n}\n\n.form-floating>.form-control:not(:-moz-placeholder-shown) {\n  padding-top: 1.625rem;\n  padding-bottom: 0.625rem;\n}\n\n.form-floating>.form-control:not(:-ms-input-placeholder) {\n  padding-top: 1.625rem;\n  padding-bottom: 0.625rem;\n}\n\n.form-floating>.form-control:focus,\n.form-floating>.form-control:not(:placeholder-shown) {\n  padding-top: 1.625rem;\n  padding-bottom: 0.625rem;\n}\n\n.form-floating>.form-control:-webkit-autofill {\n  padding-top: 1.625rem;\n  padding-bottom: 0.625rem;\n}\n\n.form-floating>.form-select {\n  padding-top: 1.625rem;\n  padding-bottom: 0.625rem;\n}\n\n.form-floating>.form-control:not(:-moz-placeholder-shown)~label {\n  opacity: 0.65;\n  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);\n}\n\n.form-floating>.form-control:not(:-ms-input-placeholder)~label {\n  opacity: 0.65;\n  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);\n}\n\n.form-floating>.form-control:focus~label,\n.form-floating>.form-control:not(:placeholder-shown)~label,\n.form-floating>.form-select~label {\n  opacity: 0.65;\n  -webkit-transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);\n  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);\n}\n\n.form-floating>.form-control:-webkit-autofill~label {\n  opacity: 0.65;\n  -webkit-transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);\n  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);\n}\n\n.input-group {\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-box-align: stretch;\n  -ms-flex-align: stretch;\n  align-items: stretch;\n  width: 100%;\n}\n\n.input-group>.form-control,\n.input-group>.form-select {\n  position: relative;\n  -webkit-box-flex: 1;\n  -ms-flex: 1 1 auto;\n  flex: 1 1 auto;\n  width: 1%;\n  min-width: 0;\n}\n\n.input-group>.form-control:focus,\n.input-group>.form-select:focus {\n  z-index: 3;\n}\n\n.input-group .btn {\n  position: relative;\n  z-index: 2;\n}\n\n.input-group .btn:focus {\n  z-index: 3;\n}\n\n.input-group-text {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  padding: 0.59rem 1rem;\n  font-size: 0.875rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: var(--bs-body-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: #e9ecef;\n  border: 1px solid #ced4da;\n  border-radius: 0.25rem;\n}\n\n.input-group-lg>.form-control,\n.input-group-lg>.form-select,\n.input-group-lg>.input-group-text,\n.input-group-lg>.btn {\n  padding: 0.75rem 1rem;\n  font-size: 1.09375rem;\n  border-radius: 0.3rem;\n}\n\n.input-group-sm>.form-control,\n.input-group-sm>.form-select,\n.input-group-sm>.input-group-text,\n.input-group-sm>.btn {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.765625rem;\n  border-radius: 0.2rem;\n}\n\n.input-group-lg>.form-select,\n.input-group-sm>.form-select {\n  padding-right: 4rem;\n}\n\n.input-group:not(.has-validation)> :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu),\n.input-group:not(.has-validation)>.dropdown-toggle:nth-last-child(n+3) {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.input-group.has-validation> :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu),\n.input-group.has-validation>.dropdown-toggle:nth-last-child(n+4) {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.input-group> :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {\n  margin-left: -1px;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.valid-feedback {\n  display: none;\n  width: 100%;\n  margin-top: 0.25rem;\n  font-size: 0.875em;\n  color: #34c997;\n}\n\n.valid-tooltip {\n  position: absolute;\n  top: 100%;\n  z-index: 5;\n  display: none;\n  max-width: 100%;\n  padding: 0.25rem 0.5rem;\n  margin-top: 0.1rem;\n  font-size: 0.765625rem;\n  color: #000;\n  background-color: rgba(52, 201, 151, 0.9);\n  border-radius: 0.25rem;\n}\n\n.was-validated :valid~.valid-feedback,\n.was-validated :valid~.valid-tooltip,\n.is-valid~.valid-feedback,\n.is-valid~.valid-tooltip {\n  display: block;\n}\n\n.was-validated .form-control:valid,\n.form-control.is-valid {\n  border-color: #34c997;\n  padding-right: calc(1.5em + 1.18rem);\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%2334c997' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right calc(0.375em + 0.295rem) center;\n  background-size: calc(0.75em + 0.59rem) calc(0.75em + 0.59rem);\n}\n\n.was-validated .form-control:valid:focus,\n.form-control.is-valid:focus {\n  border-color: #34c997;\n  -webkit-box-shadow: 0 0 0 0.25rem rgba(52, 201, 151, 0.25);\n  box-shadow: 0 0 0 0.25rem rgba(52, 201, 151, 0.25);\n}\n\n.was-validated textarea.form-control:valid,\ntextarea.form-control.is-valid {\n  padding-right: calc(1.5em + 1.18rem);\n  background-position: top calc(0.375em + 0.295rem) right calc(0.375em + 0.295rem);\n}\n\n.was-validated .form-select:valid,\n.form-select.is-valid {\n  border-color: #34c997;\n}\n\n.was-validated .form-select:valid:not([multiple]):not([size]),\n.was-validated .form-select:valid:not([multiple])[size=\"1\"],\n.form-select.is-valid:not([multiple]):not([size]),\n.form-select.is-valid:not([multiple])[size=\"1\"] {\n  padding-right: 5.5rem;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e\"), url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%2334c997' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\");\n  background-position: right 1rem center, center right 3rem;\n  background-size: 16px 12px, calc(0.75em + 0.59rem) calc(0.75em + 0.59rem);\n}\n\n.was-validated .form-select:valid:focus,\n.form-select.is-valid:focus {\n  border-color: #34c997;\n  -webkit-box-shadow: 0 0 0 0.25rem rgba(52, 201, 151, 0.25);\n  box-shadow: 0 0 0 0.25rem rgba(52, 201, 151, 0.25);\n}\n\n.was-validated .form-check-input:valid,\n.form-check-input.is-valid {\n  border-color: #34c997;\n}\n\n.was-validated .form-check-input:valid:checked,\n.form-check-input.is-valid:checked {\n  background-color: #34c997;\n}\n\n.was-validated .form-check-input:valid:focus,\n.form-check-input.is-valid:focus {\n  -webkit-box-shadow: 0 0 0 0.25rem rgba(52, 201, 151, 0.25);\n  box-shadow: 0 0 0 0.25rem rgba(52, 201, 151, 0.25);\n}\n\n.was-validated .form-check-input:valid~.form-check-label,\n.form-check-input.is-valid~.form-check-label {\n  color: #34c997;\n}\n\n.form-check-inline .form-check-input~.valid-feedback {\n  margin-left: 0.5em;\n}\n\n.was-validated .input-group .form-control:valid,\n.input-group .form-control.is-valid,\n.was-validated .input-group .form-select:valid,\n.input-group .form-select.is-valid {\n  z-index: 1;\n}\n\n.was-validated .input-group .form-control:valid:focus,\n.input-group .form-control.is-valid:focus,\n.was-validated .input-group .form-select:valid:focus,\n.input-group .form-select.is-valid:focus {\n  z-index: 3;\n}\n\n.invalid-feedback {\n  display: none;\n  width: 100%;\n  margin-top: 0.25rem;\n  font-size: 0.875em;\n  color: #ec4a58;\n}\n\n.invalid-tooltip {\n  position: absolute;\n  top: 100%;\n  z-index: 5;\n  display: none;\n  max-width: 100%;\n  padding: 0.25rem 0.5rem;\n  margin-top: 0.1rem;\n  font-size: 0.765625rem;\n  color: #000;\n  background-color: rgba(236, 74, 88, 0.9);\n  border-radius: 0.25rem;\n}\n\n.was-validated :invalid~.invalid-feedback,\n.was-validated :invalid~.invalid-tooltip,\n.is-invalid~.invalid-feedback,\n.is-invalid~.invalid-tooltip {\n  display: block;\n}\n\n.was-validated .form-control:invalid,\n.form-control.is-invalid {\n  border-color: #ec4a58;\n  padding-right: calc(1.5em + 1.18rem);\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23ec4a58'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23ec4a58' stroke='none'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right calc(0.375em + 0.295rem) center;\n  background-size: calc(0.75em + 0.59rem) calc(0.75em + 0.59rem);\n}\n\n.was-validated .form-control:invalid:focus,\n.form-control.is-invalid:focus {\n  border-color: #ec4a58;\n  -webkit-box-shadow: 0 0 0 0.25rem rgba(236, 74, 88, 0.25);\n  box-shadow: 0 0 0 0.25rem rgba(236, 74, 88, 0.25);\n}\n\n.was-validated textarea.form-control:invalid,\ntextarea.form-control.is-invalid {\n  padding-right: calc(1.5em + 1.18rem);\n  background-position: top calc(0.375em + 0.295rem) right calc(0.375em + 0.295rem);\n}\n\n.was-validated .form-select:invalid,\n.form-select.is-invalid {\n  border-color: #ec4a58;\n}\n\n.was-validated .form-select:invalid:not([multiple]):not([size]),\n.was-validated .form-select:invalid:not([multiple])[size=\"1\"],\n.form-select.is-invalid:not([multiple]):not([size]),\n.form-select.is-invalid:not([multiple])[size=\"1\"] {\n  padding-right: 5.5rem;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e\"), url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23ec4a58'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23ec4a58' stroke='none'/%3e%3c/svg%3e\");\n  background-position: right 1rem center, center right 3rem;\n  background-size: 16px 12px, calc(0.75em + 0.59rem) calc(0.75em + 0.59rem);\n}\n\n.was-validated .form-select:invalid:focus,\n.form-select.is-invalid:focus {\n  border-color: #ec4a58;\n  -webkit-box-shadow: 0 0 0 0.25rem rgba(236, 74, 88, 0.25);\n  box-shadow: 0 0 0 0.25rem rgba(236, 74, 88, 0.25);\n}\n\n.was-validated .form-check-input:invalid,\n.form-check-input.is-invalid {\n  border-color: #ec4a58;\n}\n\n.was-validated .form-check-input:invalid:checked,\n.form-check-input.is-invalid:checked {\n  background-color: #ec4a58;\n}\n\n.was-validated .form-check-input:invalid:focus,\n.form-check-input.is-invalid:focus {\n  -webkit-box-shadow: 0 0 0 0.25rem rgba(236, 74, 88, 0.25);\n  box-shadow: 0 0 0 0.25rem rgba(236, 74, 88, 0.25);\n}\n\n.was-validated .form-check-input:invalid~.form-check-label,\n.form-check-input.is-invalid~.form-check-label {\n  color: #ec4a58;\n}\n\n.form-check-inline .form-check-input~.invalid-feedback {\n  margin-left: 0.5em;\n}\n\n.was-validated .input-group .form-control:invalid,\n.input-group .form-control.is-invalid,\n.was-validated .input-group .form-select:invalid,\n.input-group .form-select.is-invalid {\n  z-index: 2;\n}\n\n.was-validated .input-group .form-control:invalid:focus,\n.input-group .form-control.is-invalid:focus,\n.was-validated .input-group .form-select:invalid:focus,\n.input-group .form-select.is-invalid:focus {\n  z-index: 3;\n}\n\n.btn {\n  display: inline-block;\n  font-weight: 500;\n  line-height: 1.5;\n  color: var(--bs-body-color);\n  text-align: center;\n  text-decoration: none;\n  vertical-align: middle;\n  cursor: pointer;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  background-color: transparent;\n  border: 1px solid transparent;\n  padding: 0.59rem 1rem;\n  font-size: 0.875rem;\n  border-radius: var(--border-radius) !important;\n  -webkit-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;\n}\n\n.breadcrumb-wrapper .btn {\n  border-radius: var(--border-radius) !important;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .btn {\n    -webkit-transition: none;\n    transition: none;\n  }\n}\n\n.btn:hover {\n  color: var(--bs-body-color);\n}\n\n.btn-check:focus+.btn,\n.btn:focus {\n  outline: 0;\n  -webkit-box-shadow: 0 0 0 0.25rem rgba(136, 170, 243, 0.25);\n  box-shadow: 0 0 0 0.25rem rgba(136, 170, 243, 0.25);\n}\n\n.btn:disabled,\n.btn.disabled,\nfieldset:disabled .btn {\n  pointer-events: none;\n  opacity: 0.65;\n  cursor: not-allowed;\n}\n\n.btn-purple {\n  color: #000;\n  background-color: #8268e2;\n  border-color: #8268e2;\n}\n\n.btn-purple:hover {\n  color: #000;\n  background-color: #957fe6;\n  border-color: #8f77e5;\n}\n\n.btn-check:focus+.btn-purple,\n.btn-purple:focus {\n  color: #000;\n  background-color: #957fe6;\n  border-color: #8f77e5;\n  -webkit-box-shadow: 0 0 0 0.25rem rgba(111, 88, 192, 0.5);\n  box-shadow: 0 0 0 0.25rem rgba(111, 88, 192, 0.5);\n}\n\n.btn-check:checked+.btn-purple,\n.btn-check:active+.btn-purple,\n.btn-purple:active,\n.btn-purple.active,\n.show>.btn-purple.dropdown-toggle {\n  color: #000;\n  background-color: #9b86e8;\n  border-color: #8f77e5;\n}\n\n.btn-check:checked+.btn-purple:focus,\n.btn-check:active+.btn-purple:focus,\n.btn-purple:active:focus,\n.btn-purple.active:focus,\n.show>.btn-purple.dropdown-toggle:focus {\n  -webkit-box-shadow: 0 0 0 0.25rem rgba(111, 88, 192, 0.5);\n  box-shadow: 0 0 0 0.25rem rgba(111, 88, 192, 0.5);\n}\n\n.btn-purple:disabled,\n.btn-purple.disabled {\n  color: #000;\n  background-color: #8268e2;\n  border-color: #8268e2;\n}\n\n.btn-outline-purple {\n  color: #8268e2;\n  border-color: #8268e2;\n}\n\n.btn-outline-purple:hover {\n  color: #000;\n  background-color: #8268e2;\n  border-color: #8268e2;\n}\n\n.btn-check:focus+.btn-outline-purple,\n.btn-outline-purple:focus {\n  -webkit-box-shadow: 0 0 0 0.25rem rgba(130, 104, 226, 0.5);\n  box-shadow: 0 0 0 0.25rem rgba(130, 104, 226, 0.5);\n}\n\n.btn-check:checked+.btn-outline-purple,\n.btn-check:active+.btn-outline-purple,\n.btn-outline-purple:active,\n.btn-outline-purple.active,\n.btn-outline-purple.dropdown-toggle.show {\n  color: #000;\n  background-color: #8268e2;\n  border-color: #8268e2;\n}\n\n.btn-check:checked+.btn-outline-purple:focus,\n.btn-check:active+.btn-outline-purple:focus,\n.btn-outline-purple:active:focus,\n.btn-outline-purple.active:focus,\n.btn-outline-purple.dropdown-toggle.show:focus {\n  -webkit-box-shadow: 0 0 0 0.25rem rgba(130, 104, 226, 0.5);\n  box-shadow: 0 0 0 0.25rem rgba(130, 104, 226, 0.5);\n}\n\n.btn-outline-purple:disabled,\n.btn-outline-purple.disabled {\n  color: #8268e2;\n  background-color: transparent;\n}\n\n.btn-link {\n  font-weight: 400;\n  color: var(--admin-color);\n  text-decoration: underline;\n}\n\n.btn-link:hover {\n  color: #6d88c2;\n}\n\n.btn-link:disabled,\n.btn-link.disabled {\n  color: #6c757d;\n}\n\n.btn-lg,\n.btn-group-lg>.btn {\n  padding: 0.75rem 1rem;\n  font-size: 1.09375rem;\n  border-radius: 0.3rem;\n}\n\n.btn-sm,\n.btn-group-sm>.btn {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.765625rem;\n  border-radius: 0.2rem;\n}\n\n.fade {\n  -webkit-transition: opacity 0.15s linear;\n  transition: opacity 0.15s linear;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .fade {\n    -webkit-transition: none;\n    transition: none;\n  }\n}\n\n.fade:not(.show) {\n  opacity: 0;\n}\n\n/* .collapse:not(.show) {\n  display: none;\n} */\n\n.collapsing {\n  height: 0;\n  overflow: hidden;\n  -webkit-transition: height 0.35s ease;\n  transition: height 0.35s ease;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .collapsing {\n    -webkit-transition: none;\n    transition: none;\n  }\n}\n\n.collapsing.collapse-horizontal {\n  width: 0;\n  height: auto;\n  -webkit-transition: width 0.35s ease;\n  transition: width 0.35s ease;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .collapsing.collapse-horizontal {\n    -webkit-transition: none;\n    transition: none;\n  }\n}\n\n.dropup,\n.dropend,\n.dropdown,\n.dropstart {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n}\n\n.dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  /* content: \"\"; */\n  border-top: 0.3em solid;\n  border-right: 0.3em solid transparent;\n  border-bottom: 0;\n  border-left: 0.3em solid transparent;\n}\n\n.dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n\n.dropdown-menu {\n  position: absolute;\n  z-index: 1000;\n  display: none;\n  min-width: 10rem;\n  padding: 0.5rem 0;\n  margin: 0;\n  font-size: 0.875rem;\n  color: var(--bs-black-rgb);\n  text-align: left;\n  list-style: none;\n  background-color: #ffffff;\n  background-clip: padding-box;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.25rem;\n}\n\n.dropdown-menu[data-bs-popper] {\n  top: 100%;\n  left: 0;\n  margin-top: 0.125rem;\n}\n\n.dropdown-menu-start {\n  --bs-position: start;\n}\n\n.dropdown-menu-start[data-bs-popper] {\n  right: auto;\n  left: 0;\n}\n\n.dropdown-menu-end {\n  --bs-position: end;\n}\n\n.dropdown-menu-end[data-bs-popper] {\n  right: 0;\n  left: auto;\n}\n\n@media (min-width: 576px) {\n  .dropdown-menu-sm-start {\n    --bs-position: start;\n  }\n\n  .dropdown-menu-sm-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n\n  .dropdown-menu-sm-end {\n    --bs-position: end;\n  }\n\n  .dropdown-menu-sm-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n\n@media (min-width: 768px) {\n  .dropdown-menu-md-start {\n    --bs-position: start;\n  }\n\n  .dropdown-menu-md-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n\n  .dropdown-menu-md-end {\n    --bs-position: end;\n  }\n\n  .dropdown-menu-md-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n\n@media (min-width: 992px) {\n  .dropdown-menu-lg-start {\n    --bs-position: start;\n  }\n\n  .dropdown-menu-lg-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n\n  .dropdown-menu-lg-end {\n    --bs-position: end;\n  }\n\n  .dropdown-menu-lg-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n\n@media (min-width: 1200px) {\n  .dropdown-menu-xl-start {\n    --bs-position: start;\n  }\n\n  .dropdown-menu-xl-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n\n  .dropdown-menu-xl-end {\n    --bs-position: end;\n  }\n\n  .dropdown-menu-xl-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n\n@media (min-width: 1500px) {\n  .dropdown-menu-xxl-start {\n    --bs-position: start;\n  }\n\n  .dropdown-menu-xxl-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n\n  .dropdown-menu-xxl-end {\n    --bs-position: end;\n  }\n\n  .dropdown-menu-xxl-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n\n.dropup .dropdown-menu[data-bs-popper] {\n  top: auto;\n  bottom: 100%;\n  margin-top: 0;\n  margin-bottom: 0.125rem;\n}\n\n.dropup .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0;\n  border-right: 0.3em solid transparent;\n  border-bottom: 0.3em solid;\n  border-left: 0.3em solid transparent;\n}\n\n.dropup .dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n\n.dropend .dropdown-menu[data-bs-popper] {\n  top: 0;\n  right: auto;\n  left: 100%;\n  margin-top: 0;\n  margin-left: 0.125rem;\n}\n\n.dropend .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid transparent;\n  border-right: 0;\n  border-bottom: 0.3em solid transparent;\n  border-left: 0.3em solid;\n}\n\n.dropend .dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n\n.dropend .dropdown-toggle::after {\n  vertical-align: 0;\n}\n\n.dropstart .dropdown-menu[data-bs-popper] {\n  top: 0;\n  right: 100%;\n  left: auto;\n  margin-top: 0;\n  margin-right: 0.125rem;\n}\n\n.dropstart .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n}\n\n.dropstart .dropdown-toggle::after {\n  display: none;\n}\n\n.dropstart .dropdown-toggle::before {\n  display: inline-block;\n  margin-right: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid transparent;\n  border-right: 0.3em solid;\n  border-bottom: 0.3em solid transparent;\n}\n\n.dropstart .dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n\n.dropstart .dropdown-toggle::before {\n  vertical-align: 0;\n}\n\n.dropdown-divider {\n  height: 0;\n  margin: 0.5rem 0;\n  overflow: hidden;\n  border-top: 1px solid rgba(0, 0, 0, 0.15);\n}\n\n.dropdown-item {\n  display: block;\n  width: 100%;\n  padding: 0.25rem 1rem;\n  clear: both;\n  font-weight: 400;\n  color: #212529;\n  text-align: inherit;\n  text-decoration: none;\n  white-space: nowrap;\n  background-color: transparent;\n  border: 0;\n}\n\n.dropdown-item:hover,\n.dropdown-item:focus {\n  color: #1e2125;\n  /* background-color: #e9ecef; */\n}\n\n.dropdown-item.active,\n.dropdown-item:active {\n  color: #ffffff;\n  text-decoration: none;\n  background-color: var(--admin-color);\n}\n\n.dropdown-item.disabled,\n.dropdown-item:disabled {\n  color: #adb5bd;\n  pointer-events: none;\n  background-color: transparent;\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n.dropdown-header {\n  display: flex;\n  padding: 0.5rem 1rem;\n  margin-bottom: 0;\n  font-size: 0.765625rem;\n  color: #6c757d;\n  white-space: nowrap;\n}\n\n.dropdown-item-text {\n  display: block;\n  padding: 0.25rem 1rem;\n  color: #212529;\n}\n\n.dropdown-menu-dark {\n  color: #dee2e6;\n  background-color: #343a40;\n  border-color: rgba(0, 0, 0, 0.15);\n}\n\n.dropdown-menu-dark .dropdown-item {\n  color: #dee2e6;\n}\n\n.dropdown-menu-dark .dropdown-item:hover,\n.dropdown-menu-dark .dropdown-item:focus {\n  color: #ffffff;\n  /* background-color: rgba(255, 255, 255, 0.15); */\n}\n\n.dropdown-menu-dark .dropdown-item.active,\n.dropdown-menu-dark .dropdown-item:active {\n  color: #ffffff;\n  background-color: var(--admin-color);\n}\n\n.dropdown-menu-dark .dropdown-item.disabled,\n.dropdown-menu-dark .dropdown-item:disabled {\n  color: #adb5bd;\n}\n\n.dropdown-menu-dark .dropdown-divider {\n  border-color: rgba(0, 0, 0, 0.15);\n}\n\n.dropdown-menu-dark .dropdown-item-text {\n  color: #dee2e6;\n}\n\n.dropdown-menu-dark .dropdown-header {\n  color: #adb5bd;\n}\n\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  vertical-align: middle;\n}\n\n.btn-group>.btn,\n.btn-group-vertical>.btn {\n  position: relative;\n  -webkit-box-flex: 1;\n  -ms-flex: 1 1 auto;\n  flex: 1 1 auto;\n}\n\n.btn-group>.btn-check:checked+.btn,\n.btn-group>.btn-check:focus+.btn,\n.btn-group>.btn:hover,\n.btn-group>.btn:focus,\n.btn-group>.btn:active,\n.btn-group>.btn.active,\n.btn-group-vertical>.btn-check:checked+.btn,\n.btn-group-vertical>.btn-check:focus+.btn,\n.btn-group-vertical>.btn:hover,\n.btn-group-vertical>.btn:focus,\n.btn-group-vertical>.btn:active,\n.btn-group-vertical>.btn.active {\n  z-index: 1;\n}\n\n.btn-toolbar {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-box-pack: start;\n  -ms-flex-pack: start;\n  justify-content: flex-start;\n}\n\n.btn-toolbar .input-group {\n  width: auto;\n}\n\n.btn-group>.btn:not(:first-child),\n.btn-group>.btn-group:not(:first-child) {\n  margin-left: -1px;\n}\n\n.btn-group>.btn:not(:last-child):not(.dropdown-toggle),\n.btn-group>.btn-group:not(:last-child)>.btn {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.btn-group>.btn:nth-child(n+3),\n.btn-group> :not(.btn-check)+.btn,\n.btn-group>.btn-group:not(:first-child)>.btn {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.dropdown-toggle-split {\n  padding-right: 0.75rem;\n  padding-left: 0.75rem;\n}\n\n.dropdown-toggle-split::after,\n.dropup .dropdown-toggle-split::after,\n.dropend .dropdown-toggle-split::after {\n  margin-left: 0;\n}\n\n.dropstart .dropdown-toggle-split::before {\n  margin-right: 0;\n}\n\n.btn-sm+.dropdown-toggle-split,\n.btn-group-sm>.btn+.dropdown-toggle-split {\n  padding-right: 0.375rem;\n  padding-left: 0.375rem;\n}\n\n.btn-lg+.dropdown-toggle-split,\n.btn-group-lg>.btn+.dropdown-toggle-split {\n  padding-right: 0.75rem;\n  padding-left: 0.75rem;\n}\n\n.btn-group-vertical {\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-align: start;\n  -ms-flex-align: start;\n  align-items: flex-start;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n\n.btn-group-vertical>.btn,\n.btn-group-vertical>.btn-group {\n  width: 100%;\n}\n\n.btn-group-vertical>.btn:not(:first-child),\n.btn-group-vertical>.btn-group:not(:first-child) {\n  margin-top: -1px;\n}\n\n.btn-group-vertical>.btn:not(:last-child):not(.dropdown-toggle),\n.btn-group-vertical>.btn-group:not(:last-child)>.btn {\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.btn-group-vertical>.btn~.btn,\n.btn-group-vertical>.btn-group:not(:first-child)>.btn {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.nav {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: 0.5rem 1rem;\n  color: var(--admin-color);\n  text-decoration: none;\n  -webkit-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .nav-link {\n    -webkit-transition: none;\n    transition: none;\n  }\n}\n\n.nav-link:hover,\n.nav-link:focus {\n  color: #6d88c2;\n}\n\n.nav-link.disabled {\n  color: #6c757d;\n  pointer-events: none;\n  cursor: default;\n}\n\n.nav-tabs {\n  /* border-bottom: 1px solid #dee2e6; */\n}\n\n.nav-tabs .nav-link {\n  margin-bottom: -1px;\n  background: none;\n  border: 1px solid transparent;\n  border-top-left-radius: 0.25rem;\n  border-top-right-radius: 0.25rem;\n}\n\n.nav-tabs .nav-link:hover,\n.nav-tabs .nav-link:focus {\n  /* border-color: #e9ecef #e9ecef #dee2e6; */\n  isolation: isolate;\n}\n\n.nav-tabs .nav-link.disabled {\n  color: #6c757d;\n  background-color: transparent;\n  border-color: transparent;\n}\n\n.nav-tabs .nav-link.active,\n.nav-tabs .nav-item.show .nav-link {\n  color: #495057;\n  background-color: #fdfdfd;\n  border-color: #dee2e6 #dee2e6 #fdfdfd;\n}\n\n.nav-tabs .dropdown-menu {\n  margin-top: -1px;\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.nav-pills .nav-link {\n  background: none;\n  border: 0;\n  border-radius: 0.25rem;\n}\n\n.nav-pills .nav-link.active,\n.nav-pills .show>.nav-link {\n  color: #ffffff;\n  background-color: var(--admin-color);\n}\n\n.nav-fill>.nav-link,\n.nav-fill .nav-item {\n  -webkit-box-flex: 1;\n  -ms-flex: 1 1 auto;\n  flex: 1 1 auto;\n  text-align: center;\n}\n\n.nav-justified>.nav-link,\n.nav-justified .nav-item {\n  -ms-flex-preferred-size: 0;\n  flex-basis: 0;\n  -webkit-box-flex: 1;\n  -ms-flex-positive: 1;\n  flex-grow: 1;\n  text-align: center;\n}\n\n.nav-fill .nav-item .nav-link,\n.nav-justified .nav-item .nav-link {\n  width: 100%;\n}\n\n.tab-content>.tab-pane {\n  display: none;\n}\n\n.tab-content>.active {\n  display: block;\n}\n\n.navbar {\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  z-index: 100 !important;\n}\n\n.navbar>.container,\n.navbar>.container-fluid,\n.navbar>.container-sm,\n.navbar>.container-md,\n.navbar>.container-lg,\n.navbar>.container-xl,\n.navbar>.container-xxl {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: inherit;\n  flex-wrap: inherit;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n}\n\n.navbar-brand {\n  padding-top: 0.3359375rem;\n  padding-bottom: 0.3359375rem;\n  margin-right: 1rem;\n  font-size: 1.09375rem;\n  text-decoration: none;\n  white-space: nowrap;\n}\n\n.navbar-nav {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.navbar-nav .nav-link {\n  padding-right: 0;\n  padding-left: 0;\n}\n\n.navbar-nav .dropdown-menu {\n  position: static;\n}\n\n.navbar-text {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n}\n\n.navbar-collapse {\n  -ms-flex-preferred-size: 100%;\n  flex-basis: 100%;\n  -webkit-box-flex: 1;\n  -ms-flex-positive: 1;\n  flex-grow: 1;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.navbar-toggler {\n  padding: 0.25rem 0.75rem;\n  font-size: 1.09375rem;\n  line-height: 1;\n  background-color: transparent;\n  border: 1px solid transparent;\n  border-radius: 0.25rem;\n  -webkit-transition: -webkit-box-shadow 0.15s ease-in-out;\n  transition: -webkit-box-shadow 0.15s ease-in-out;\n  transition: box-shadow 0.15s ease-in-out;\n  transition: box-shadow 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .navbar-toggler {\n    -webkit-transition: none;\n    transition: none;\n  }\n}\n\n.navbar-toggler:hover {\n  text-decoration: none;\n}\n\n.navbar-toggler:focus {\n  text-decoration: none;\n  outline: 0;\n  -webkit-box-shadow: 0 0 0 0.25rem;\n  box-shadow: 0 0 0 0.25rem;\n}\n\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n\n.navbar-nav-scroll {\n  max-height: var(--bs-scroll-height, 75vh);\n  overflow-y: auto;\n}\n\n@media (min-width: 576px) {\n  .navbar-expand-sm {\n    -ms-flex-wrap: nowrap;\n    flex-wrap: nowrap;\n    -webkit-box-pack: start;\n    -ms-flex-pack: start;\n    justify-content: flex-start;\n  }\n\n  .navbar-expand-sm .navbar-nav {\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: row;\n    flex-direction: row;\n  }\n\n  .navbar-expand-sm .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n\n  .navbar-expand-sm .navbar-nav .nav-link {\n    padding-right: 0.5rem;\n    padding-left: 0.5rem;\n  }\n\n  .navbar-expand-sm .navbar-nav-scroll {\n    overflow: visible;\n  }\n\n  .navbar-expand-sm .navbar-collapse {\n    display: -webkit-box !important;\n    display: -ms-flexbox !important;\n    display: flex !important;\n    -ms-flex-preferred-size: auto;\n    flex-basis: auto;\n  }\n\n  .navbar-expand-sm .navbar-toggler {\n    display: none;\n  }\n\n  .navbar-expand-sm .offcanvas-header {\n    display: none;\n  }\n\n  .navbar-expand-sm .offcanvas {\n    position: inherit;\n    bottom: 0;\n    z-index: 1000;\n    -webkit-box-flex: 1;\n    -ms-flex-positive: 1;\n    flex-grow: 1;\n    visibility: visible !important;\n    background-color: transparent;\n    border-right: 0;\n    border-left: 0;\n    -webkit-transition: none;\n    transition: none;\n    -webkit-transform: none;\n    transform: none;\n  }\n\n  .navbar-expand-sm .offcanvas-top,\n  .navbar-expand-sm .offcanvas-bottom {\n    height: auto;\n    border-top: 0;\n    border-bottom: 0;\n  }\n\n  .navbar-expand-sm .offcanvas-body {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-flex: 0;\n    -ms-flex-positive: 0;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n\n@media (min-width: 768px) {\n  .navbar-expand-md {\n    -ms-flex-wrap: nowrap;\n    flex-wrap: nowrap;\n    -webkit-box-pack: start;\n    -ms-flex-pack: start;\n    justify-content: flex-start;\n  }\n\n  .navbar-expand-md .navbar-nav {\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: row;\n    flex-direction: row;\n  }\n\n  .navbar-expand-md .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n\n  .navbar-expand-md .navbar-nav .nav-link {\n    padding-right: 0.5rem;\n    padding-left: 0.5rem;\n  }\n\n  .navbar-expand-md .navbar-nav-scroll {\n    overflow: visible;\n  }\n\n  .navbar-expand-md .navbar-collapse {\n    display: -webkit-box !important;\n    display: -ms-flexbox !important;\n    display: flex !important;\n    -ms-flex-preferred-size: auto;\n    flex-basis: auto;\n  }\n\n  .navbar-expand-md .navbar-toggler {\n    display: none;\n  }\n\n  .navbar-expand-md .offcanvas-header {\n    display: none;\n  }\n\n  .navbar-expand-md .offcanvas {\n    position: inherit;\n    bottom: 0;\n    z-index: 1000;\n    -webkit-box-flex: 1;\n    -ms-flex-positive: 1;\n    flex-grow: 1;\n    visibility: visible !important;\n    background-color: transparent;\n    border-right: 0;\n    border-left: 0;\n    -webkit-transition: none;\n    transition: none;\n    -webkit-transform: none;\n    transform: none;\n  }\n\n  .navbar-expand-md .offcanvas-top,\n  .navbar-expand-md .offcanvas-bottom {\n    height: auto;\n    border-top: 0;\n    border-bottom: 0;\n  }\n\n  .navbar-expand-md .offcanvas-body {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-flex: 0;\n    -ms-flex-positive: 0;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n\n@media (min-width: 992px) {\n  .navbar-expand-lg {\n    -ms-flex-wrap: nowrap;\n    flex-wrap: nowrap;\n    -webkit-box-pack: start;\n    -ms-flex-pack: start;\n    justify-content: flex-start;\n  }\n\n  .navbar-expand-lg .navbar-nav {\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: row;\n    flex-direction: row;\n  }\n\n  .navbar-expand-lg .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n\n  .navbar-expand-lg .navbar-nav .nav-link {\n    padding-right: 0.5rem;\n    padding-left: 0.5rem;\n  }\n\n  .navbar-expand-lg .navbar-nav-scroll {\n    overflow: visible;\n  }\n\n  .navbar-expand-lg .navbar-collapse {\n    display: -webkit-box !important;\n    display: -ms-flexbox !important;\n    display: flex !important;\n    -ms-flex-preferred-size: auto;\n    flex-basis: auto;\n  }\n\n  .navbar-expand-lg .navbar-toggler {\n    display: none;\n  }\n\n  .navbar-expand-lg .offcanvas-header {\n    display: none;\n  }\n\n  .navbar-expand-lg .offcanvas {\n    position: inherit;\n    bottom: 0;\n    z-index: 1000;\n    -webkit-box-flex: 1;\n    -ms-flex-positive: 1;\n    flex-grow: 1;\n    visibility: visible !important;\n    background-color: transparent;\n    border-right: 0;\n    border-left: 0;\n    -webkit-transition: none;\n    transition: none;\n    -webkit-transform: none;\n    transform: none;\n  }\n\n  .navbar-expand-lg .offcanvas-top,\n  .navbar-expand-lg .offcanvas-bottom {\n    height: auto;\n    border-top: 0;\n    border-bottom: 0;\n  }\n\n  .navbar-expand-lg .offcanvas-body {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-flex: 0;\n    -ms-flex-positive: 0;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n\n@media (min-width: 1200px) {\n  .navbar-expand-xl {\n    -ms-flex-wrap: nowrap;\n    flex-wrap: nowrap;\n    -webkit-box-pack: start;\n    -ms-flex-pack: start;\n    justify-content: flex-start;\n  }\n\n  .navbar-expand-xl .navbar-nav {\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: row;\n    flex-direction: row;\n  }\n\n  .navbar-expand-xl .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n\n  .navbar-expand-xl .navbar-nav .nav-link {\n    padding-right: 0.5rem;\n    padding-left: 0.5rem;\n  }\n\n  .navbar-expand-xl .navbar-nav-scroll {\n    overflow: visible;\n  }\n\n  .navbar-expand-xl .navbar-collapse {\n    display: -webkit-box !important;\n    display: -ms-flexbox !important;\n    display: flex !important;\n    -ms-flex-preferred-size: auto;\n    flex-basis: auto;\n  }\n\n  .navbar-expand-xl .navbar-toggler {\n    display: none;\n  }\n\n  .navbar-expand-xl .offcanvas-header {\n    display: none;\n  }\n\n  .navbar-expand-xl .offcanvas {\n    position: inherit;\n    bottom: 0;\n    z-index: 1000;\n    -webkit-box-flex: 1;\n    -ms-flex-positive: 1;\n    flex-grow: 1;\n    visibility: visible !important;\n    background-color: transparent;\n    border-right: 0;\n    border-left: 0;\n    -webkit-transition: none;\n    transition: none;\n    -webkit-transform: none;\n    transform: none;\n  }\n\n  .navbar-expand-xl .offcanvas-top,\n  .navbar-expand-xl .offcanvas-bottom {\n    height: auto;\n    border-top: 0;\n    border-bottom: 0;\n  }\n\n  .navbar-expand-xl .offcanvas-body {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-flex: 0;\n    -ms-flex-positive: 0;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n\n@media (min-width: 1500px) {\n  .navbar-expand-xxl {\n    -ms-flex-wrap: nowrap;\n    flex-wrap: nowrap;\n    -webkit-box-pack: start;\n    -ms-flex-pack: start;\n    justify-content: flex-start;\n  }\n\n  .navbar-expand-xxl .navbar-nav {\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: row;\n    flex-direction: row;\n  }\n\n  .navbar-expand-xxl .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n\n  .navbar-expand-xxl .navbar-nav .nav-link {\n    padding-right: 0.5rem;\n    padding-left: 0.5rem;\n  }\n\n  .navbar-expand-xxl .navbar-nav-scroll {\n    overflow: visible;\n  }\n\n  .navbar-expand-xxl .navbar-collapse {\n    display: -webkit-box !important;\n    display: -ms-flexbox !important;\n    display: flex !important;\n    -ms-flex-preferred-size: auto;\n    flex-basis: auto;\n  }\n\n  .navbar-expand-xxl .navbar-toggler {\n    display: none;\n  }\n\n  .navbar-expand-xxl .offcanvas-header {\n    display: none;\n  }\n\n  .navbar-expand-xxl .offcanvas {\n    position: inherit;\n    bottom: 0;\n    z-index: 1000;\n    -webkit-box-flex: 1;\n    -ms-flex-positive: 1;\n    flex-grow: 1;\n    visibility: visible !important;\n    background-color: transparent;\n    border-right: 0;\n    border-left: 0;\n    -webkit-transition: none;\n    transition: none;\n    -webkit-transform: none;\n    transform: none;\n  }\n\n  .navbar-expand-xxl .offcanvas-top,\n  .navbar-expand-xxl .offcanvas-bottom {\n    height: auto;\n    border-top: 0;\n    border-bottom: 0;\n  }\n\n  .navbar-expand-xxl .offcanvas-body {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-flex: 0;\n    -ms-flex-positive: 0;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n\n.navbar-expand {\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  -webkit-box-pack: start;\n  -ms-flex-pack: start;\n  justify-content: flex-start;\n}\n\n.navbar-expand .navbar-nav {\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: row;\n  flex-direction: row;\n}\n\n.navbar-expand .navbar-nav .dropdown-menu {\n  position: absolute;\n}\n\n.navbar-expand .navbar-nav .nav-link {\n  padding-right: 0.5rem;\n  padding-left: 0.5rem;\n}\n\n.navbar-expand .navbar-nav-scroll {\n  overflow: visible;\n}\n\n.navbar-expand .navbar-collapse {\n  display: -webkit-box !important;\n  display: -ms-flexbox !important;\n  display: flex !important;\n  -ms-flex-preferred-size: auto;\n  flex-basis: auto;\n}\n\n.navbar-expand .navbar-toggler {\n  display: none;\n}\n\n.navbar-expand .offcanvas-header {\n  display: none;\n}\n\n.navbar-expand .offcanvas {\n  position: inherit;\n  bottom: 0;\n  z-index: 1000;\n  -webkit-box-flex: 1;\n  -ms-flex-positive: 1;\n  flex-grow: 1;\n  visibility: visible !important;\n  background-color: transparent;\n  border-right: 0;\n  border-left: 0;\n  -webkit-transition: none;\n  transition: none;\n  -webkit-transform: none;\n  transform: none;\n}\n\n.navbar-expand .offcanvas-top,\n.navbar-expand .offcanvas-bottom {\n  height: auto;\n  border-top: 0;\n  border-bottom: 0;\n}\n\n.navbar-expand .offcanvas-body {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex: 0;\n  -ms-flex-positive: 0;\n  flex-grow: 0;\n  padding: 0;\n  overflow-y: visible;\n}\n\n.navbar-light .navbar-brand {\n  color: rgba(0, 0, 0, 0.9);\n}\n\n.navbar-light .navbar-brand:hover,\n.navbar-light .navbar-brand:focus {\n  color: rgba(0, 0, 0, 0.9);\n}\n\n.navbar-light .navbar-nav .nav-link {\n  color: rgba(0, 0, 0, 0.55);\n}\n\n.navbar-light .navbar-nav .nav-link:hover,\n.navbar-light .navbar-nav .nav-link:focus {\n  color: rgba(0, 0, 0, 0.7);\n}\n\n.navbar-light .navbar-nav .nav-link.disabled {\n  color: rgba(0, 0, 0, 0.3);\n}\n\n.navbar-light .navbar-nav .show>.nav-link,\n.navbar-light .navbar-nav .nav-link.active {\n  color: rgba(0, 0, 0, 0.9);\n}\n\n.navbar-light .navbar-toggler {\n  color: rgba(0, 0, 0, 0.55);\n  border-color: rgba(0, 0, 0, 0.1);\n}\n\n.navbar-light .navbar-toggler-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%280, 0, 0, 0.55%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n}\n\n.navbar-light .navbar-text {\n  color: rgba(0, 0, 0, 0.55);\n}\n\n.navbar-light .navbar-text a,\n.navbar-light .navbar-text a:hover,\n.navbar-light .navbar-text a:focus {\n  color: rgba(0, 0, 0, 0.9);\n}\n\n.navbar-dark .navbar-brand {\n  color: #ffffff;\n}\n\n.navbar-dark .navbar-brand:hover,\n.navbar-dark .navbar-brand:focus {\n  color: #ffffff;\n}\n\n.navbar-dark .navbar-nav .nav-link {\n  color: rgba(255, 255, 255, 0.55);\n}\n\n.navbar-dark .navbar-nav .nav-link:hover,\n.navbar-dark .navbar-nav .nav-link:focus {\n  color: rgba(255, 255, 255, 0.75);\n}\n\n.navbar-dark .navbar-nav .nav-link.disabled {\n  color: rgba(255, 255, 255, 0.25);\n}\n\n.navbar-dark .navbar-nav .show>.nav-link,\n.navbar-dark .navbar-nav .nav-link.active {\n  color: #ffffff;\n}\n\n.navbar-dark .navbar-toggler {\n  color: rgba(255, 255, 255, 0.55);\n  border-color: rgba(255, 255, 255, 0.1);\n}\n\n.navbar-dark .navbar-toggler-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 0.55%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n}\n\n.navbar-dark .navbar-text {\n  color: rgba(255, 255, 255, 0.55);\n}\n\n.navbar-dark .navbar-text a,\n.navbar-dark .navbar-text a:hover,\n.navbar-dark .navbar-text a:focus {\n  color: #ffffff;\n}\n\n.card {\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  min-width: 0;\n  word-wrap: break-word;\n  background-color: #ffffff;\n  background-clip: border-box;\n  /* border: 1px solid #f3f3f3;\n  border-radius: 0.25rem; */\n}\n\n.card>hr {\n  margin-right: 0;\n  margin-left: 0;\n}\n\n.card>.list-group {\n  border-top: inherit;\n  border-bottom: inherit;\n}\n\n.card>.list-group:first-child {\n  border-top-width: 0;\n  border-top-left-radius: calc(0.25rem - 1px);\n  border-top-right-radius: calc(0.25rem - 1px);\n}\n\n.card>.list-group:last-child {\n  border-bottom-width: 0;\n  border-bottom-right-radius: calc(0.25rem - 1px);\n  border-bottom-left-radius: calc(0.25rem - 1px);\n}\n\n.card>.card-header+.list-group,\n.card>.list-group+.card-footer {\n  border-top: 0;\n}\n\n/* page loading set height start*/\n\n.pageOnloadHight {\n  height: 100vh;\n  /* display: none; */\n}\n\n/* page loading set height end */\n.card-body {\n  -webkit-box-flex: 1;\n  -ms-flex: 1 1 auto;\n  flex: 1 1 auto;\n  padding: 1rem 1rem;\n}\n\n.card-title {\n  margin-bottom: 0.5rem;\n}\n\n.card-subtitle {\n  margin-top: -0.25rem;\n  margin-bottom: 0;\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link+.card-link {\n  margin-left: 1rem;\n}\n\n.card-header {\n  padding: 0.5rem 1rem;\n  margin-bottom: 0;\n  /* background-color: rgba(0, 0, 0, 0.03); */\n  border-bottom: 1px solid var(--border-color);\n}\n\n.card-header:first-child {\n  border-radius: calc(0.25rem - 1px) calc(0.25rem - 1px) 0 0;\n}\n\n.card-footer {\n  padding: 0.5rem 1rem;\n  background-color: rgba(0, 0, 0, 0.03);\n  border-top: 1px solid var(--border-color);\n}\n\n.card-footer:last-child {\n  border-radius: 0 0 calc(0.25rem - 1px) calc(0.25rem - 1px);\n}\n\n.card-header-tabs {\n  margin-right: -0.5rem;\n  margin-bottom: -0.5rem;\n  margin-left: -0.5rem;\n  border-bottom: 0;\n}\n\n.card-header-tabs .nav-link.active {\n  background-color: #ffffff;\n  border-bottom-color: #ffffff;\n}\n\n.card-header-pills {\n  margin-right: -0.5rem;\n  margin-left: -0.5rem;\n}\n\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: 1rem;\n  border-radius: calc(0.25rem - 1px);\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  width: 100%;\n}\n\n.card-img,\n.card-img-top {\n  border-top-left-radius: calc(0.25rem - 1px);\n  border-top-right-radius: calc(0.25rem - 1px);\n}\n\n.card-img,\n.card-img-bottom {\n  border-bottom-right-radius: calc(0.25rem - 1px);\n  border-bottom-left-radius: calc(0.25rem - 1px);\n}\n\n.card-group>.card {\n  margin-bottom: 0.75rem;\n}\n\n@media (min-width: 576px) {\n  .card-group {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n    -ms-flex-flow: row wrap;\n    flex-flow: row wrap;\n  }\n\n  .card-group>.card {\n    -webkit-box-flex: 1;\n    -ms-flex: 1 0 0%;\n    flex: 1 0 0%;\n    margin-bottom: 0;\n  }\n\n  .card-group>.card+.card {\n    margin-left: 0;\n    border-left: 0;\n  }\n\n  .card-group>.card:not(:last-child) {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n\n  .card-group>.card:not(:last-child) .card-img-top,\n  .card-group>.card:not(:last-child) .card-header {\n    border-top-right-radius: 0;\n  }\n\n  .card-group>.card:not(:last-child) .card-img-bottom,\n  .card-group>.card:not(:last-child) .card-footer {\n    border-bottom-right-radius: 0;\n  }\n\n  .card-group>.card:not(:first-child) {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n\n  .card-group>.card:not(:first-child) .card-img-top,\n  .card-group>.card:not(:first-child) .card-header {\n    border-top-left-radius: 0;\n  }\n\n  .card-group>.card:not(:first-child) .card-img-bottom,\n  .card-group>.card:not(:first-child) .card-footer {\n    border-bottom-left-radius: 0;\n  }\n}\n\n.accordion-button {\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  width: 100%;\n  padding: 1rem 1.25rem;\n  font-size: 0.875rem;\n  color: var(--bs-body-color);\n  text-align: left;\n  background-color: #fdfdfd;\n  border: 0;\n  border-radius: 0;\n  overflow-anchor: none;\n  -webkit-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, border-radius 0.15s ease, -webkit-box-shadow 0.15s ease-in-out;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, border-radius 0.15s ease, -webkit-box-shadow 0.15s ease-in-out;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease, -webkit-box-shadow 0.15s ease-in-out;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .accordion-button {\n    -webkit-transition: none;\n    transition: none;\n  }\n}\n\n.accordion-button:not(.collapsed) {\n  color: #7a99db;\n  background-color: #f3f7fe;\n  -webkit-box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.125);\n  box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.125);\n}\n\n.accordion-button:not(.collapsed)::after {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%237a99db'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n  -webkit-transform: rotate(-180deg);\n  transform: rotate(-180deg);\n}\n\n.accordion-button::after {\n  -ms-flex-negative: 0;\n  flex-shrink: 0;\n  width: 1.25rem;\n  height: 1.25rem;\n  margin-left: auto;\n  content: \"\";\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%238a909d'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-size: 1.25rem;\n  -webkit-transition: -webkit-transform 0.2s ease-in-out;\n  transition: -webkit-transform 0.2s ease-in-out;\n  transition: transform 0.2s ease-in-out;\n  transition: transform 0.2s ease-in-out, -webkit-transform 0.2s ease-in-out;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .accordion-button::after {\n    -webkit-transition: none;\n    transition: none;\n  }\n}\n\n.accordion-button:hover {\n  z-index: 2;\n}\n\n.accordion-button:focus {\n  z-index: 3;\n  border-color: #c4d5f9;\n  outline: 0;\n  -webkit-box-shadow: 0 0 0 0.25rem rgba(136, 170, 243, 0.25);\n  box-shadow: 0 0 0 0.25rem rgba(136, 170, 243, 0.25);\n}\n\n.accordion-header {\n  margin-bottom: 0;\n}\n\n.accordion-item {\n  background-color: #fdfdfd;\n  border: 1px solid rgba(0, 0, 0, 0.125);\n}\n\n.accordion-item:first-of-type {\n  border-top-left-radius: 0.25rem;\n  border-top-right-radius: 0.25rem;\n}\n\n.accordion-item:first-of-type .accordion-button {\n  border-top-left-radius: calc(0.25rem - 1px);\n  border-top-right-radius: calc(0.25rem - 1px);\n}\n\n.accordion-item:not(:first-of-type) {\n  border-top: 0;\n}\n\n.accordion-item:last-of-type {\n  border-bottom-right-radius: 0.25rem;\n  border-bottom-left-radius: 0.25rem;\n}\n\n.accordion-item:last-of-type .accordion-button.collapsed {\n  border-bottom-right-radius: calc(0.25rem - 1px);\n  border-bottom-left-radius: calc(0.25rem - 1px);\n}\n\n.accordion-item:last-of-type .accordion-collapse {\n  border-bottom-right-radius: 0.25rem;\n  border-bottom-left-radius: 0.25rem;\n}\n\n.accordion-body {\n  padding: 1rem 1.25rem;\n}\n\n.accordion-flush .accordion-collapse {\n  border-width: 0;\n}\n\n.accordion-flush .accordion-item {\n  border-right: 0;\n  border-left: 0;\n  border-radius: 0;\n}\n\n.accordion-flush .accordion-item:first-child {\n  border-top: 0;\n}\n\n.accordion-flush .accordion-item:last-child {\n  border-bottom: 0;\n}\n\n.accordion-flush .accordion-item .accordion-button {\n  border-radius: 0;\n}\n\n.breadcrumb {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  padding: 1rem 1.25rem;\n  margin-bottom: 1rem;\n  list-style: none;\n  background-color: transparent;\n}\n\n.breadcrumb-item+.breadcrumb-item {\n  padding-left: 0.5rem;\n}\n\n.breadcrumb-item+.breadcrumb-item::before {\n  float: left;\n  padding-right: 0.5rem;\n  color: #6c757d;\n  content: var(--bs-breadcrumb-divider, \"/\")\n    /* rtl: var(--bs-breadcrumb-divider, \"/\") */\n  ;\n}\n\n.breadcrumb-item.active {\n  color: #6c757d;\n}\n\n.pagination {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  padding-left: 0;\n  list-style: none;\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  color: var(--admin-color);\n  text-decoration: none;\n  background-color: #ffffff;\n  border: 1px solid #dee2e6;\n  -webkit-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .page-link {\n    -webkit-transition: none;\n    transition: none;\n  }\n}\n\n.page-link:hover {\n  z-index: 2;\n  color: #6d88c2;\n  background-color: #e9ecef;\n  border-color: #dee2e6;\n}\n\n.page-link:focus {\n  z-index: 3;\n  color: #6d88c2;\n  background-color: #e9ecef;\n  outline: 0;\n  -webkit-box-shadow: 0 0 0 0.25rem rgba(136, 170, 243, 0.25);\n  box-shadow: 0 0 0 0.25rem rgba(136, 170, 243, 0.25);\n}\n\n.page-item:not(:first-child) .page-link {\n  margin-left: -1px;\n}\n\n.page-item.active .page-link {\n  z-index: 3;\n  color: #ffffff;\n  background-color: var(--admin-color);\n  border-color: var(--admin-color);\n}\n\n.page-item.disabled .page-link {\n  color: #6c757d;\n  pointer-events: none;\n  background-color: #ffffff;\n  border-color: #dee2e6;\n}\n\n.page-link {\n  padding: 1rem 1.25rem;\n}\n\n.page-item:first-child .page-link {\n  border-top-left-radius: 0.25rem;\n  border-bottom-left-radius: 0.25rem;\n}\n\n.page-item:last-child .page-link {\n  border-top-right-radius: 0.25rem;\n  border-bottom-right-radius: 0.25rem;\n}\n\n.pagination-lg .page-link {\n  padding: 0.75rem 1.5rem;\n  font-size: 1.09375rem;\n}\n\n.pagination-lg .page-item:first-child .page-link {\n  border-top-left-radius: 0.3rem;\n  border-bottom-left-radius: 0.3rem;\n}\n\n.pagination-lg .page-item:last-child .page-link {\n  border-top-right-radius: 0.3rem;\n  border-bottom-right-radius: 0.3rem;\n}\n\n.pagination-sm .page-link {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.765625rem;\n}\n\n.pagination-sm .page-item:first-child .page-link {\n  border-top-left-radius: 0.2rem;\n  border-bottom-left-radius: 0.2rem;\n}\n\n.pagination-sm .page-item:last-child .page-link {\n  border-top-right-radius: 0.2rem;\n  border-bottom-right-radius: 0.2rem;\n}\n\n.badge {\n  display: inline-block;\n  padding: 0.5em 1em;\n  font-size: 0.75em;\n  font-weight: 500;\n  line-height: 1;\n  color: #ffffff;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  border-radius: 0.125rem;\n}\n\n.badge:empty {\n  display: none;\n}\n\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n\n.alert {\n  position: relative;\n  padding: 1.25rem 1.25rem;\n  margin-bottom: 1rem;\n  border: 1px solid transparent;\n  border-radius: 0.25rem;\n}\n\n.alert-heading {\n  color: inherit;\n}\n\n.alert-link {\n  font-weight: 700;\n}\n\n.alert-dismissible {\n  padding-right: 3.75rem;\n}\n\n.alert-dismissible .btn-close {\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 2;\n  padding: 1.5625rem 1.25rem;\n}\n\n.alert-purple {\n  color: #4e3e88;\n  background-color: #e6e1f9;\n  border-color: #dad2f6;\n}\n\n.alert-purple .alert-link {\n  color: #3e326d;\n}\n\n@-webkit-keyframes progress-bar-stripes {\n  0% {\n    background-position-x: 1rem;\n  }\n}\n\n@keyframes progress-bar-stripes {\n  0% {\n    background-position-x: 1rem;\n  }\n}\n\n.progress {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  height: 1rem;\n  overflow: hidden;\n  font-size: 0.65625rem;\n  background-color: #e9ecef;\n  border-radius: 0.25rem;\n}\n\n.progress-bar {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  overflow: hidden;\n  color: #ffffff;\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--admin-color);\n  -webkit-transition: width 0.6s ease;\n  transition: width 0.6s ease;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .progress-bar {\n    -webkit-transition: none;\n    transition: none;\n  }\n}\n\n.progress-bar-striped {\n  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n  background-size: 1rem 1rem;\n}\n\n.progress-bar-animated {\n  -webkit-animation: 1s linear infinite progress-bar-stripes;\n  animation: 1s linear infinite progress-bar-stripes;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .progress-bar-animated {\n    -webkit-animation: none;\n    animation: none;\n  }\n}\n\n.list-group {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  padding-left: 0;\n  margin-bottom: 0;\n  border-radius: 0.25rem;\n}\n\n.list-group-numbered {\n  list-style-type: none;\n  counter-reset: section;\n}\n\n.list-group-numbered>li::before {\n  content: counters(section, \".\") \". \";\n  counter-increment: section;\n}\n\n.list-group-item-action {\n  width: 100%;\n  color: #495057;\n  text-align: inherit;\n}\n\n.list-group-item-action:hover,\n.list-group-item-action:focus {\n  z-index: 1;\n  color: #495057;\n  text-decoration: none;\n  background-color: #fdfdfd;\n}\n\n.list-group-item-action:active {\n  color: var(--bs-body-color);\n  background-color: #e9ecef;\n}\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: 0.5rem 1rem;\n  color: #212529;\n  text-decoration: none;\n  background-color: #ffffff;\n  border: 1px solid rgba(0, 0, 0, 0.125);\n}\n\n.list-group-item:first-child {\n  border-top-left-radius: inherit;\n  border-top-right-radius: inherit;\n}\n\n.list-group-item:last-child {\n  border-bottom-right-radius: inherit;\n  border-bottom-left-radius: inherit;\n}\n\n.list-group-item.disabled,\n.list-group-item:disabled {\n  color: #6c757d;\n  pointer-events: none;\n  background-color: #ffffff;\n}\n\n.list-group-item.active {\n  z-index: 2;\n  color: #ffffff;\n  background-color: var(--admin-color);\n  border-color: var(--admin-color);\n}\n\n.list-group-item+.list-group-item {\n  border-top-width: 0;\n}\n\n.list-group-item+.list-group-item.active {\n  margin-top: -1px;\n  border-top-width: 1px;\n}\n\n.list-group-horizontal {\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: row;\n  flex-direction: row;\n}\n\n.list-group-horizontal>.list-group-item:first-child {\n  border-bottom-left-radius: 0.25rem;\n  border-top-right-radius: 0;\n}\n\n.list-group-horizontal>.list-group-item:last-child {\n  border-top-right-radius: 0.25rem;\n  border-bottom-left-radius: 0;\n}\n\n.list-group-horizontal>.list-group-item.active {\n  margin-top: 0;\n}\n\n.list-group-horizontal>.list-group-item+.list-group-item {\n  border-top-width: 1px;\n  border-left-width: 0;\n}\n\n.list-group-horizontal>.list-group-item+.list-group-item.active {\n  margin-left: -1px;\n  border-left-width: 1px;\n}\n\n@media (min-width: 576px) {\n  .list-group-horizontal-sm {\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: row;\n    flex-direction: row;\n  }\n\n  .list-group-horizontal-sm>.list-group-item:first-child {\n    border-bottom-left-radius: 0.25rem;\n    border-top-right-radius: 0;\n  }\n\n  .list-group-horizontal-sm>.list-group-item:last-child {\n    border-top-right-radius: 0.25rem;\n    border-bottom-left-radius: 0;\n  }\n\n  .list-group-horizontal-sm>.list-group-item.active {\n    margin-top: 0;\n  }\n\n  .list-group-horizontal-sm>.list-group-item+.list-group-item {\n    border-top-width: 1px;\n    border-left-width: 0;\n  }\n\n  .list-group-horizontal-sm>.list-group-item+.list-group-item.active {\n    margin-left: -1px;\n    border-left-width: 1px;\n  }\n}\n\n@media (min-width: 768px) {\n  .list-group-horizontal-md {\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: row;\n    flex-direction: row;\n  }\n\n  .list-group-horizontal-md>.list-group-item:first-child {\n    border-bottom-left-radius: 0.25rem;\n    border-top-right-radius: 0;\n  }\n\n  .list-group-horizontal-md>.list-group-item:last-child {\n    border-top-right-radius: 0.25rem;\n    border-bottom-left-radius: 0;\n  }\n\n  .list-group-horizontal-md>.list-group-item.active {\n    margin-top: 0;\n  }\n\n  .list-group-horizontal-md>.list-group-item+.list-group-item {\n    border-top-width: 1px;\n    border-left-width: 0;\n  }\n\n  .list-group-horizontal-md>.list-group-item+.list-group-item.active {\n    margin-left: -1px;\n    border-left-width: 1px;\n  }\n}\n\n@media (min-width: 992px) {\n  .list-group-horizontal-lg {\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: row;\n    flex-direction: row;\n  }\n\n  .list-group-horizontal-lg>.list-group-item:first-child {\n    border-bottom-left-radius: 0.25rem;\n    border-top-right-radius: 0;\n  }\n\n  .list-group-horizontal-lg>.list-group-item:last-child {\n    border-top-right-radius: 0.25rem;\n    border-bottom-left-radius: 0;\n  }\n\n  .list-group-horizontal-lg>.list-group-item.active {\n    margin-top: 0;\n  }\n\n  .list-group-horizontal-lg>.list-group-item+.list-group-item {\n    border-top-width: 1px;\n    border-left-width: 0;\n  }\n\n  .list-group-horizontal-lg>.list-group-item+.list-group-item.active {\n    margin-left: -1px;\n    border-left-width: 1px;\n  }\n}\n\n@media (min-width: 1200px) {\n  .list-group-horizontal-xl {\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: row;\n    flex-direction: row;\n  }\n\n  .list-group-horizontal-xl>.list-group-item:first-child {\n    border-bottom-left-radius: 0.25rem;\n    border-top-right-radius: 0;\n  }\n\n  .list-group-horizontal-xl>.list-group-item:last-child {\n    border-top-right-radius: 0.25rem;\n    border-bottom-left-radius: 0;\n  }\n\n  .list-group-horizontal-xl>.list-group-item.active {\n    margin-top: 0;\n  }\n\n  .list-group-horizontal-xl>.list-group-item+.list-group-item {\n    border-top-width: 1px;\n    border-left-width: 0;\n  }\n\n  .list-group-horizontal-xl>.list-group-item+.list-group-item.active {\n    margin-left: -1px;\n    border-left-width: 1px;\n  }\n}\n\n@media (min-width: 1500px) {\n  .list-group-horizontal-xxl {\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: row;\n    flex-direction: row;\n  }\n\n  .list-group-horizontal-xxl>.list-group-item:first-child {\n    border-bottom-left-radius: 0.25rem;\n    border-top-right-radius: 0;\n  }\n\n  .list-group-horizontal-xxl>.list-group-item:last-child {\n    border-top-right-radius: 0.25rem;\n    border-bottom-left-radius: 0;\n  }\n\n  .list-group-horizontal-xxl>.list-group-item.active {\n    margin-top: 0;\n  }\n\n  .list-group-horizontal-xxl>.list-group-item+.list-group-item {\n    border-top-width: 1px;\n    border-left-width: 0;\n  }\n\n  .list-group-horizontal-xxl>.list-group-item+.list-group-item.active {\n    margin-left: -1px;\n    border-left-width: 1px;\n  }\n}\n\n.list-group-flush {\n  border-radius: 0;\n}\n\n.list-group-flush>.list-group-item {\n  border-width: 0 0 1px;\n}\n\n.list-group-flush>.list-group-item:last-child {\n  border-bottom-width: 0;\n}\n\n.list-group-item-purple {\n  color: #4e3e88;\n  background-color: #e6e1f9;\n}\n\n.list-group-item-purple.list-group-item-action:hover,\n.list-group-item-purple.list-group-item-action:focus {\n  color: #4e3e88;\n  background-color: #cfcbe0;\n}\n\n.list-group-item-purple.list-group-item-action.active {\n  color: #ffffff;\n  background-color: #4e3e88;\n  border-color: #4e3e88;\n}\n\n.btn-close {\n  -webkit-box-sizing: content-box;\n  box-sizing: content-box;\n  width: 1em;\n  height: 1em;\n  padding: 0.25em 0.25em;\n  color: #000;\n  background: transparent url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23000'%3e%3cpath d='M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z'/%3e%3c/svg%3e\") center/1em auto no-repeat;\n  border: 0;\n  border-radius: 0.25rem;\n  opacity: 0.5;\n}\n\n.btn-close:hover {\n  color: #000;\n  text-decoration: none;\n  opacity: 0.75;\n}\n\n.btn-close:focus {\n  outline: 0;\n  -webkit-box-shadow: 0 0 0 0.25rem rgba(136, 170, 243, 0.25);\n  box-shadow: 0 0 0 0.25rem rgba(136, 170, 243, 0.25);\n  opacity: 1;\n}\n\n.btn-close:disabled,\n.btn-close.disabled {\n  pointer-events: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  opacity: 0.25;\n}\n\n.btn-close-white {\n  -webkit-filter: invert(1) grayscale(100%) brightness(200%);\n  filter: invert(1) grayscale(100%) brightness(200%);\n}\n\n.toast {\n  width: 350px;\n  max-width: 100%;\n  font-size: 0.875rem;\n  pointer-events: auto;\n  background-color: rgba(255, 255, 255, 0.85);\n  background-clip: padding-box;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  -webkit-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);\n  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);\n  border-radius: 0.25rem;\n}\n\n.toast.showing {\n  opacity: 0;\n}\n\n.toast:not(.show) {\n  display: none;\n}\n\n.toast-container {\n  width: -webkit-max-content;\n  width: -moz-max-content;\n  width: max-content;\n  max-width: 100%;\n  pointer-events: none;\n}\n\n.toast-container> :not(:last-child) {\n  margin-bottom: 0.75rem;\n}\n\n.toast-header {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  padding: 0.5rem 0.75rem;\n  color: #6c757d;\n  background-color: rgba(255, 255, 255, 0.85);\n  background-clip: padding-box;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n  border-top-left-radius: calc(0.25rem - 1px);\n  border-top-right-radius: calc(0.25rem - 1px);\n}\n\n.toast-header .btn-close {\n  margin-right: -0.375rem;\n  margin-left: 0.75rem;\n}\n\n.toast-body {\n  padding: 0.75rem;\n  word-wrap: break-word;\n}\n\n.modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1055;\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  outline: 0;\n}\n\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: 0.5rem;\n  pointer-events: none;\n}\n\n.modal.fade .modal-dialog {\n  -webkit-transition: -webkit-transform 0.3s ease-out;\n  transition: -webkit-transform 0.3s ease-out;\n  transition: transform 0.3s ease-out;\n  transition: transform 0.3s ease-out, -webkit-transform 0.3s ease-out;\n  -webkit-transform: translate(0, -50px);\n  transform: translate(0, -50px);\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .modal.fade .modal-dialog {\n    -webkit-transition: none;\n    transition: none;\n  }\n}\n\n.modal.show .modal-dialog {\n  -webkit-transform: none;\n  transform: none;\n}\n\n.modal.modal-static .modal-dialog {\n  -webkit-transform: scale(1.02);\n  transform: scale(1.02);\n}\n\n.modal-dialog-scrollable {\n  height: calc(100% - 1rem);\n}\n\n.modal-dialog-scrollable .modal-content {\n  max-height: 100%;\n  overflow: hidden;\n}\n\n.modal-dialog-scrollable .modal-body {\n  overflow-y: auto;\n}\n\n.modal-dialog-centered {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  min-height: calc(100% - 1rem);\n}\n\n.modal-content {\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  width: 100%;\n  pointer-events: auto;\n  background-color: #ffffff;\n  background-clip: padding-box;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  border-radius: 0.3rem;\n  outline: 0;\n}\n\n.modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1050;\n  width: 100vw;\n  height: 100vh;\n  background-color: #000;\n}\n\n.modal-backdrop.fade {\n  opacity: 0;\n}\n\n.modal-backdrop.show {\n  opacity: 0.5;\n}\n\n.modal-header {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-negative: 0;\n  flex-shrink: 0;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n  padding: 1rem 1rem;\n  border-bottom: 1px solid var(--border-color);\n  border-top-left-radius: calc(0.3rem - 1px);\n  border-top-right-radius: calc(0.3rem - 1px);\n}\n\n.modal-header .btn-close {\n  padding: 0.5rem 0.5rem;\n  margin: -0.5rem -0.5rem -0.5rem auto;\n}\n\n.modal-title {\n  margin-bottom: 0;\n  line-height: 1.5;\n}\n\n.modal-body {\n  position: relative;\n  -webkit-box-flex: 1;\n  -ms-flex: 1 1 auto;\n  flex: 1 1 auto;\n  padding: 1rem;\n}\n\n.modal-footer {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -ms-flex-negative: 0;\n  flex-shrink: 0;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: end;\n  -ms-flex-pack: end;\n  justify-content: flex-end;\n  padding: 0.75rem;\n  border-top: 1px solid var(--border-color);\n  border-bottom-right-radius: calc(0.3rem - 1px);\n  border-bottom-left-radius: calc(0.3rem - 1px);\n}\n\n.modal-footer>* {\n  margin: 0.25rem;\n}\n\n@media (min-width: 576px) {\n  .modal-dialog {\n    max-width: 500px;\n    margin: 1.75rem auto;\n  }\n\n  .modal-dialog-scrollable {\n    height: calc(100% - 3.5rem);\n  }\n\n  .modal-dialog-centered {\n    min-height: calc(100% - 3.5rem);\n  }\n\n  .modal-sm {\n    max-width: 400px;\n  }\n}\n\n@media (min-width: 992px) {\n\n  .modal-lg,\n  .modal-xl {\n    max-width: 800px;\n  }\n}\n\n@media (min-width: 1200px) {\n  .modal-xl {\n    max-width: 1140px;\n  }\n}\n\n.modal-fullscreen {\n  width: 100vw;\n  max-width: none;\n  height: 100%;\n  margin: 0;\n}\n\n.modal-fullscreen .modal-content {\n  height: 100%;\n  border: 0;\n  border-radius: 0;\n}\n\n.modal-fullscreen .modal-header {\n  border-radius: 0;\n}\n\n.modal-fullscreen .modal-body {\n  overflow-y: auto;\n}\n\n.modal-fullscreen .modal-footer {\n  border-radius: 0;\n}\n\n@media (max-width: 575.98px) {\n  .modal-fullscreen-sm-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n\n  .modal-fullscreen-sm-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n\n  .modal-fullscreen-sm-down .modal-header {\n    border-radius: 0;\n  }\n\n  .modal-fullscreen-sm-down .modal-body {\n    overflow-y: auto;\n  }\n\n  .modal-fullscreen-sm-down .modal-footer {\n    border-radius: 0;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .modal-fullscreen-md-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n\n  .modal-fullscreen-md-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n\n  .modal-fullscreen-md-down .modal-header {\n    border-radius: 0;\n  }\n\n  .modal-fullscreen-md-down .modal-body {\n    overflow-y: auto;\n  }\n\n  .modal-fullscreen-md-down .modal-footer {\n    border-radius: 0;\n  }\n}\n\n@media (max-width: 991.98px) {\n  .modal-fullscreen-lg-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n\n  .modal-fullscreen-lg-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n\n  .modal-fullscreen-lg-down .modal-header {\n    border-radius: 0;\n  }\n\n  .modal-fullscreen-lg-down .modal-body {\n    overflow-y: auto;\n  }\n\n  .modal-fullscreen-lg-down .modal-footer {\n    border-radius: 0;\n  }\n}\n\n@media (max-width: 1199.98px) {\n  .modal-fullscreen-xl-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n\n  .modal-fullscreen-xl-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n\n  .modal-fullscreen-xl-down .modal-header {\n    border-radius: 0;\n  }\n\n  .modal-fullscreen-xl-down .modal-body {\n    overflow-y: auto;\n  }\n\n  .modal-fullscreen-xl-down .modal-footer {\n    border-radius: 0;\n  }\n}\n\n@media (max-width: 1499.98px) {\n  .modal-fullscreen-xxl-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n\n  .modal-fullscreen-xxl-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n\n  .modal-fullscreen-xxl-down .modal-header {\n    border-radius: 0;\n  }\n\n  .modal-fullscreen-xxl-down .modal-body {\n    overflow-y: auto;\n  }\n\n  .modal-fullscreen-xxl-down .modal-footer {\n    border-radius: 0;\n  }\n}\n\n.tooltip {\n  position: absolute;\n  z-index: 1080;\n  display: block;\n  margin: 0;\n  font-family: \"Roboto\", sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  word-spacing: normal;\n  white-space: normal;\n  line-break: auto;\n  font-size: 0.765625rem;\n  word-wrap: break-word;\n  opacity: 0;\n}\n\n.tooltip.show {\n  opacity: 0.9;\n}\n\n.tooltip .tooltip-arrow {\n  position: absolute;\n  display: block;\n  width: 0.8rem;\n  height: 0.4rem;\n}\n\n.tooltip .tooltip-arrow::before {\n  position: absolute;\n  content: \"\";\n  border-color: transparent;\n  border-style: solid;\n}\n\n.bs-tooltip-top,\n.bs-tooltip-auto[data-popper-placement^=top] {\n  padding: 0.4rem 0;\n}\n\n.bs-tooltip-top .tooltip-arrow,\n.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow {\n  bottom: 0;\n}\n\n.bs-tooltip-top .tooltip-arrow::before,\n.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {\n  top: -1px;\n  border-width: 0.4rem 0.4rem 0;\n  border-top-color: #000;\n}\n\n.bs-tooltip-end,\n.bs-tooltip-auto[data-popper-placement^=right] {\n  padding: 0 0.4rem;\n}\n\n.bs-tooltip-end .tooltip-arrow,\n.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow {\n  left: 0;\n  width: 0.4rem;\n  height: 0.8rem;\n}\n\n.bs-tooltip-end .tooltip-arrow::before,\n.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {\n  right: -1px;\n  border-width: 0.4rem 0.4rem 0.4rem 0;\n  border-right-color: #000;\n}\n\n.bs-tooltip-bottom,\n.bs-tooltip-auto[data-popper-placement^=bottom] {\n  padding: 0.4rem 0;\n}\n\n.bs-tooltip-bottom .tooltip-arrow,\n.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow {\n  top: 0;\n}\n\n.bs-tooltip-bottom .tooltip-arrow::before,\n.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {\n  bottom: -1px;\n  border-width: 0 0.4rem 0.4rem;\n  border-bottom-color: #000;\n}\n\n.bs-tooltip-start,\n.bs-tooltip-auto[data-popper-placement^=left] {\n  padding: 0 0.4rem;\n}\n\n.bs-tooltip-start .tooltip-arrow,\n.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow {\n  right: 0;\n  width: 0.4rem;\n  height: 0.8rem;\n}\n\n.bs-tooltip-start .tooltip-arrow::before,\n.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {\n  left: -1px;\n  border-width: 0.4rem 0 0.4rem 0.4rem;\n  border-left-color: #000;\n}\n\n.tooltip-inner {\n  max-width: 200px;\n  padding: 0.25rem 0.5rem;\n  color: #ffffff;\n  text-align: center;\n  background-color: #000;\n  border-radius: 0.25rem;\n}\n\n.popover {\n  position: absolute;\n  top: 0;\n  left: 0\n    /* rtl:ignore */\n  ;\n  z-index: 1070;\n  display: block;\n  max-width: 276px;\n  font-family: \"Roboto\", sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  word-spacing: normal;\n  white-space: normal;\n  line-break: auto;\n  font-size: 0.765625rem;\n  word-wrap: break-word;\n  background-color: #ffffff;\n  background-clip: padding-box;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  border-radius: 0.3rem;\n}\n\n.popover .popover-arrow {\n  position: absolute;\n  display: block;\n  width: 1rem;\n  height: 0.5rem;\n}\n\n.popover .popover-arrow::before,\n.popover .popover-arrow::after {\n  position: absolute;\n  display: block;\n  content: \"\";\n  border-color: transparent;\n  border-style: solid;\n}\n\n.bs-popover-top>.popover-arrow,\n.bs-popover-auto[data-popper-placement^=top]>.popover-arrow {\n  bottom: calc(-0.5rem - 1px);\n}\n\n.bs-popover-top>.popover-arrow::before,\n.bs-popover-auto[data-popper-placement^=top]>.popover-arrow::before {\n  bottom: 0;\n  border-width: 0.5rem 0.5rem 0;\n  border-top-color: rgba(0, 0, 0, 0.25);\n}\n\n.bs-popover-top>.popover-arrow::after,\n.bs-popover-auto[data-popper-placement^=top]>.popover-arrow::after {\n  bottom: 1px;\n  border-width: 0.5rem 0.5rem 0;\n  border-top-color: #ffffff;\n}\n\n.bs-popover-end>.popover-arrow,\n.bs-popover-auto[data-popper-placement^=right]>.popover-arrow {\n  left: calc(-0.5rem - 1px);\n  width: 0.5rem;\n  height: 1rem;\n}\n\n.bs-popover-end>.popover-arrow::before,\n.bs-popover-auto[data-popper-placement^=right]>.popover-arrow::before {\n  left: 0;\n  border-width: 0.5rem 0.5rem 0.5rem 0;\n  border-right-color: rgba(0, 0, 0, 0.25);\n}\n\n.bs-popover-end>.popover-arrow::after,\n.bs-popover-auto[data-popper-placement^=right]>.popover-arrow::after {\n  left: 1px;\n  border-width: 0.5rem 0.5rem 0.5rem 0;\n  border-right-color: #ffffff;\n}\n\n.bs-popover-bottom>.popover-arrow,\n.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow {\n  top: calc(-0.5rem - 1px);\n}\n\n.bs-popover-bottom>.popover-arrow::before,\n.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow::before {\n  top: 0;\n  border-width: 0 0.5rem 0.5rem 0.5rem;\n  border-bottom-color: rgba(0, 0, 0, 0.25);\n}\n\n.bs-popover-bottom>.popover-arrow::after,\n.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow::after {\n  top: 1px;\n  border-width: 0 0.5rem 0.5rem 0.5rem;\n  border-bottom-color: #ffffff;\n}\n\n.bs-popover-bottom .popover-header::before,\n.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {\n  position: absolute;\n  top: 0;\n  left: 50%;\n  display: block;\n  width: 1rem;\n  margin-left: -0.5rem;\n  content: \"\";\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.bs-popover-start>.popover-arrow,\n.bs-popover-auto[data-popper-placement^=left]>.popover-arrow {\n  right: calc(-0.5rem - 1px);\n  width: 0.5rem;\n  height: 1rem;\n}\n\n.bs-popover-start>.popover-arrow::before,\n.bs-popover-auto[data-popper-placement^=left]>.popover-arrow::before {\n  right: 0;\n  border-width: 0.5rem 0 0.5rem 0.5rem;\n  border-left-color: rgba(0, 0, 0, 0.25);\n}\n\n.bs-popover-start>.popover-arrow::after,\n.bs-popover-auto[data-popper-placement^=left]>.popover-arrow::after {\n  right: 1px;\n  border-width: 0.5rem 0 0.5rem 0.5rem;\n  border-left-color: #ffffff;\n}\n\n.popover-header {\n  padding: 0.5rem 1rem;\n  margin-bottom: 0;\n  font-size: 0.875rem;\n  background-color: #f0f0f0;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.2);\n  border-top-left-radius: calc(0.3rem - 1px);\n  border-top-right-radius: calc(0.3rem - 1px);\n}\n\n.popover-header:empty {\n  display: none;\n}\n\n.popover-body {\n  padding: 1rem 1rem;\n  color: var(--bs-body-color);\n}\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  -ms-touch-action: pan-y;\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n}\n\n.carousel-inner::after {\n  display: block;\n  clear: both;\n  content: \"\";\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n  -webkit-transition: -webkit-transform 0.6s ease-in-out;\n  transition: -webkit-transform 0.6s ease-in-out;\n  transition: transform 0.6s ease-in-out;\n  transition: transform 0.6s ease-in-out, -webkit-transform 0.6s ease-in-out;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .carousel-item {\n    -webkit-transition: none;\n    transition: none;\n  }\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n/* rtl:begin:ignore */\n.carousel-item-next:not(.carousel-item-start),\n.active.carousel-item-end {\n  -webkit-transform: translateX(100%);\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-end),\n.active.carousel-item-start {\n  -webkit-transform: translateX(-100%);\n  transform: translateX(-100%);\n}\n\n/* rtl:end:ignore */\n.carousel-fade .carousel-item {\n  opacity: 0;\n  -webkit-transition-property: opacity;\n  transition-property: opacity;\n  -webkit-transform: none;\n  transform: none;\n}\n\n.carousel-fade .carousel-item.active,\n.carousel-fade .carousel-item-next.carousel-item-start,\n.carousel-fade .carousel-item-prev.carousel-item-end {\n  z-index: 1;\n  opacity: 1;\n}\n\n.carousel-fade .active.carousel-item-start,\n.carousel-fade .active.carousel-item-end {\n  z-index: 0;\n  opacity: 0;\n  -webkit-transition: opacity 0s 0.6s;\n  transition: opacity 0s 0.6s;\n}\n\n@media (prefers-reduced-motion: reduce) {\n\n  .carousel-fade .active.carousel-item-start,\n  .carousel-fade .active.carousel-item-end {\n    -webkit-transition: none;\n    transition: none;\n  }\n}\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  width: 15%;\n  padding: 0;\n  color: #ffffff;\n  text-align: center;\n  background: none;\n  border: 0;\n  opacity: 0.5;\n  -webkit-transition: opacity 0.15s ease;\n  transition: opacity 0.15s ease;\n}\n\n@media (prefers-reduced-motion: reduce) {\n\n  .carousel-control-prev,\n  .carousel-control-next {\n    -webkit-transition: none;\n    transition: none;\n  }\n}\n\n.carousel-control-prev:hover,\n.carousel-control-prev:focus,\n.carousel-control-next:hover,\n.carousel-control-next:focus {\n  color: #ffffff;\n  text-decoration: none;\n  outline: 0;\n  opacity: 0.9;\n}\n\n.carousel-control-prev {\n  left: 0;\n}\n\n.carousel-control-next {\n  right: 0;\n}\n\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: 2rem;\n  height: 2rem;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-size: 100% 100%;\n}\n\n/* rtl:options: {\n  \"autoRename\": true,\n  \"stringMap\":[ {\n    \"name\"    : \"prev-next\",\n    \"search\"  : \"prev\",\n    \"replace\" : \"next\"\n  } ]\n} */\n.carousel-control-prev-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23ffffff'%3e%3cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/%3e%3c/svg%3e\");\n}\n\n.carousel-control-next-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23ffffff'%3e%3cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n}\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  padding: 0;\n  margin-right: 15%;\n  margin-bottom: 1rem;\n  margin-left: 15%;\n  list-style: none;\n}\n\n.carousel-indicators [data-bs-target] {\n  -webkit-box-sizing: content-box;\n  box-sizing: content-box;\n  -webkit-box-flex: 0;\n  -ms-flex: 0 1 auto;\n  flex: 0 1 auto;\n  width: 30px;\n  height: 3px;\n  padding: 0;\n  margin-right: 3px;\n  margin-left: 3px;\n  text-indent: -999px;\n  cursor: pointer;\n  background-color: #ffffff;\n  background-clip: padding-box;\n  border: 0;\n  border-top: 10px solid transparent;\n  border-bottom: 10px solid transparent;\n  opacity: 0.5;\n  -webkit-transition: opacity 0.6s ease;\n  transition: opacity 0.6s ease;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .carousel-indicators [data-bs-target] {\n    -webkit-transition: none;\n    transition: none;\n  }\n}\n\n.carousel-indicators .active {\n  opacity: 1;\n}\n\n.carousel-caption {\n  position: absolute;\n  right: 15%;\n  bottom: 1.25rem;\n  left: 15%;\n  padding-top: 1.25rem;\n  padding-bottom: 1.25rem;\n  color: #ffffff;\n  text-align: center;\n}\n\n.carousel-dark .carousel-control-prev-icon,\n.carousel-dark .carousel-control-next-icon {\n  -webkit-filter: invert(1) grayscale(100);\n  filter: invert(1) grayscale(100);\n}\n\n.carousel-dark .carousel-indicators [data-bs-target] {\n  background-color: #000;\n}\n\n.carousel-dark .carousel-caption {\n  color: #000;\n}\n\n@-webkit-keyframes spinner-border {\n  to {\n    -webkit-transform: rotate(360deg)\n      /* rtl:ignore */\n    ;\n    transform: rotate(360deg)\n      /* rtl:ignore */\n    ;\n  }\n}\n\n@keyframes spinner-border {\n  to {\n    -webkit-transform: rotate(360deg)\n      /* rtl:ignore */\n    ;\n    transform: rotate(360deg)\n      /* rtl:ignore */\n    ;\n  }\n}\n\n.spinner-border {\n  display: inline-block;\n  width: 2rem;\n  height: 2rem;\n  vertical-align: -0.125em;\n  border: 0.25em solid currentColor;\n  border-right-color: transparent;\n  border-radius: 50%;\n  -webkit-animation: 0.75s linear infinite spinner-border;\n  animation: 0.75s linear infinite spinner-border;\n}\n\n.spinner-border-sm {\n  width: 1rem;\n  height: 1rem;\n  border-width: 0.2em;\n}\n\n@-webkit-keyframes spinner-grow {\n  0% {\n    -webkit-transform: scale(0);\n    transform: scale(0);\n  }\n\n  50% {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n\n@keyframes spinner-grow {\n  0% {\n    -webkit-transform: scale(0);\n    transform: scale(0);\n  }\n\n  50% {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n\n.spinner-grow {\n  display: inline-block;\n  width: 2rem;\n  height: 2rem;\n  vertical-align: -0.125em;\n  background-color: currentColor;\n  border-radius: 50%;\n  opacity: 0;\n  -webkit-animation: 0.75s linear infinite spinner-grow;\n  animation: 0.75s linear infinite spinner-grow;\n}\n\n.spinner-grow-sm {\n  width: 1rem;\n  height: 1rem;\n}\n\n@media (prefers-reduced-motion: reduce) {\n\n  .spinner-border,\n  .spinner-grow {\n    -webkit-animation-duration: 1.5s;\n    animation-duration: 1.5s;\n  }\n}\n\n.offcanvas {\n  position: fixed;\n  bottom: 0;\n  z-index: 1045;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  max-width: 100%;\n  visibility: hidden;\n  background-color: #ffffff;\n  background-clip: padding-box;\n  outline: 0;\n  -webkit-transition: -webkit-transform 0.3s ease-in-out;\n  transition: -webkit-transform 0.3s ease-in-out;\n  transition: transform 0.3s ease-in-out;\n  transition: transform 0.3s ease-in-out, -webkit-transform 0.3s ease-in-out;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .offcanvas {\n    -webkit-transition: none;\n    transition: none;\n  }\n}\n\n.offcanvas-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1040;\n  width: 100vw;\n  height: 100vh;\n  background-color: #000;\n}\n\n.offcanvas-backdrop.fade {\n  opacity: 0;\n}\n\n.offcanvas-backdrop.show {\n  opacity: 0.5;\n}\n\n.offcanvas-header {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n  padding: 1rem 1rem;\n}\n\n.offcanvas-header .btn-close {\n  padding: 0.5rem 0.5rem;\n  margin-top: -0.5rem;\n  margin-right: -0.5rem;\n  margin-bottom: -0.5rem;\n}\n\n.offcanvas-title {\n  margin-bottom: 0;\n  line-height: 1.5;\n}\n\n.offcanvas-body {\n  -webkit-box-flex: 1;\n  -ms-flex-positive: 1;\n  flex-grow: 1;\n  padding: 1rem 1rem;\n  overflow-y: auto;\n}\n\n.offcanvas-start {\n  top: 0;\n  left: 0;\n  width: 400px;\n  border-right: 1px solid rgba(0, 0, 0, 0.2);\n  -webkit-transform: translateX(-100%);\n  transform: translateX(-100%);\n}\n\n.offcanvas-end {\n  top: 0;\n  right: 0;\n  width: 400px;\n  border-left: 1px solid rgba(0, 0, 0, 0.2);\n  -webkit-transform: translateX(100%);\n  transform: translateX(100%);\n}\n\n.offcanvas-top {\n  top: 0;\n  right: 0;\n  left: 0;\n  height: 30vh;\n  max-height: 100%;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.2);\n  -webkit-transform: translateY(-100%);\n  transform: translateY(-100%);\n}\n\n.offcanvas-bottom {\n  right: 0;\n  left: 0;\n  height: 30vh;\n  max-height: 100%;\n  border-top: 1px solid rgba(0, 0, 0, 0.2);\n  -webkit-transform: translateY(100%);\n  transform: translateY(100%);\n}\n\n.offcanvas.show {\n  -webkit-transform: none;\n  transform: none;\n}\n\n.placeholder {\n  display: inline-block;\n  min-height: 1em;\n  vertical-align: middle;\n  cursor: wait;\n  background-color: currentColor;\n  opacity: 0.5;\n}\n\n.placeholder.btn::before {\n  display: inline-block;\n  content: \"\";\n}\n\n.placeholder-xs {\n  min-height: 0.6em;\n}\n\n.placeholder-sm {\n  min-height: 0.8em;\n}\n\n.placeholder-lg {\n  min-height: 1.2em;\n}\n\n.placeholder-glow .placeholder {\n  -webkit-animation: placeholder-glow 2s ease-in-out infinite;\n  animation: placeholder-glow 2s ease-in-out infinite;\n}\n\n@-webkit-keyframes placeholder-glow {\n  50% {\n    opacity: 0.2;\n  }\n}\n\n@keyframes placeholder-glow {\n  50% {\n    opacity: 0.2;\n  }\n}\n\n.placeholder-wave {\n  -webkit-mask-image: linear-gradient(130deg, #000 55%, rgba(0, 0, 0, 0.8) 75%, #000 95%);\n  mask-image: linear-gradient(130deg, #000 55%, rgba(0, 0, 0, 0.8) 75%, #000 95%);\n  -webkit-mask-size: 200% 100%;\n  mask-size: 200% 100%;\n  -webkit-animation: placeholder-wave 2s linear infinite;\n  animation: placeholder-wave 2s linear infinite;\n}\n\n@-webkit-keyframes placeholder-wave {\n  100% {\n    -webkit-mask-position: -200% 0%;\n    mask-position: -200% 0%;\n  }\n}\n\n@keyframes placeholder-wave {\n  100% {\n    -webkit-mask-position: -200% 0%;\n    mask-position: -200% 0%;\n  }\n}\n\n.clearfix::after {\n  display: block;\n  clear: both;\n  content: \"\";\n}\n\n.link-purple {\n  color: #8268e2;\n}\n\n.link-purple:hover,\n.link-purple:focus {\n  color: #9b86e8;\n}\n\n.ratio {\n  position: relative;\n  width: 100%;\n}\n\n.ratio::before {\n  display: block;\n  padding-top: var(--bs-aspect-ratio);\n  content: \"\";\n}\n\n.ratio>* {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.ratio-1x1 {\n  --bs-aspect-ratio: 100%;\n}\n\n.ratio-4x3 {\n  --bs-aspect-ratio: calc(3 / 4 * 100%);\n}\n\n.ratio-16x9 {\n  --bs-aspect-ratio: calc(9 / 16 * 100%);\n}\n\n.ratio-21x9 {\n  --bs-aspect-ratio: calc(9 / 21 * 100%);\n}\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1030;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1030;\n}\n\n.sticky-top {\n  position: sticky;\n  top: 0;\n  z-index: 1020;\n}\n\n@media (min-width: 576px) {\n  .sticky-sm-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n}\n\n@media (min-width: 768px) {\n  .sticky-md-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n}\n\n@media (min-width: 992px) {\n  .sticky-lg-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n}\n\n@media (min-width: 1200px) {\n  .sticky-xl-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n}\n\n@media (min-width: 1500px) {\n  .sticky-xxl-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n}\n\n.hstack {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -ms-flex-item-align: stretch;\n  -ms-grid-row-align: stretch;\n  align-self: stretch;\n}\n\n.vstack {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex: 1;\n  -ms-flex: 1 1 auto;\n  flex: 1 1 auto;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -ms-flex-item-align: stretch;\n  -ms-grid-row-align: stretch;\n  align-self: stretch;\n}\n\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n  position: absolute !important;\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important;\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n}\n\n.stretched-link::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1;\n  content: \"\";\n}\n\n.text-truncate {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.vr {\n  display: inline-block;\n  -ms-flex-item-align: stretch;\n  -ms-grid-row-align: stretch;\n  align-self: stretch;\n  width: 1px;\n  min-height: 1em;\n  background-color: currentColor;\n  opacity: 0.25;\n}\n\n.align-baseline {\n  vertical-align: baseline !important;\n}\n\n.align-top {\n  vertical-align: top !important;\n}\n\n.align-middle {\n  vertical-align: middle !important;\n}\n\n.align-bottom {\n  vertical-align: bottom !important;\n}\n\n.align-text-bottom {\n  vertical-align: text-bottom !important;\n}\n\n.align-text-top {\n  vertical-align: text-top !important;\n}\n\n.float-start {\n  float: left !important;\n}\n\n.float-end {\n  float: right !important;\n}\n\n.float-none {\n  float: none !important;\n}\n\n.opacity-0 {\n  opacity: 0 !important;\n}\n\n.opacity-25 {\n  opacity: 0.25 !important;\n}\n\n.opacity-50 {\n  opacity: 0.5 !important;\n}\n\n.opacity-75 {\n  opacity: 0.75 !important;\n}\n\n.opacity-100 {\n  opacity: 1 !important;\n}\n\n.overflow-auto {\n  overflow: auto !important;\n}\n\n.overflow-hidden {\n  overflow: hidden !important;\n}\n\n.overflow-visible {\n  overflow: visible !important;\n}\n\n.overflow-scroll {\n  overflow: scroll !important;\n}\n\n.d-inline {\n  display: inline !important;\n}\n\n.d-inline-block {\n  display: inline-block !important;\n}\n\n.d-block {\n  display: block !important;\n}\n\n.d-grid {\n  display: -ms-grid !important;\n  display: grid !important;\n}\n\n.d-table {\n  display: table !important;\n}\n\n.d-table-row {\n  display: table-row !important;\n}\n\n.d-table-cell {\n  display: table-cell !important;\n}\n\n.d-flex {\n  display: -webkit-box !important;\n  display: -ms-flexbox !important;\n  display: flex !important;\n}\n\n.d-inline-flex {\n  display: -webkit-inline-box !important;\n  display: -ms-inline-flexbox !important;\n  display: inline-flex !important;\n}\n\n.d-none {\n  display: none !important;\n}\n\n.shadow {\n  -webkit-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;\n  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;\n}\n\n.shadow-sm {\n  -webkit-box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;\n  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;\n}\n\n.shadow-lg {\n  -webkit-box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175) !important;\n  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175) !important;\n}\n\n.shadow-none {\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n}\n\n.position-static {\n  position: static !important;\n}\n\n.position-relative {\n  position: relative !important;\n}\n\n.position-absolute {\n  position: absolute !important;\n}\n\n.position-fixed {\n  position: fixed !important;\n}\n\n.position-sticky {\n  position: sticky !important;\n}\n\n.top-0 {\n  top: 0 !important;\n}\n\n.top-50 {\n  top: 50% !important;\n}\n\n.top-100 {\n  top: 100% !important;\n}\n\n.bottom-0 {\n  bottom: 0 !important;\n}\n\n.bottom-50 {\n  bottom: 50% !important;\n}\n\n.bottom-100 {\n  bottom: 100% !important;\n}\n\n.start-0 {\n  left: 0 !important;\n}\n\n.start-50 {\n  left: 50% !important;\n}\n\n.start-100 {\n  left: 100% !important;\n}\n\n.end-0 {\n  right: 0 !important;\n}\n\n.end-50 {\n  right: 50% !important;\n}\n\n.end-100 {\n  right: 100% !important;\n}\n\n.translate-middle {\n  -webkit-transform: translate(-50%, -50%) !important;\n  transform: translate(-50%, -50%) !important;\n}\n\n.translate-middle-x {\n  -webkit-transform: translateX(-50%) !important;\n  transform: translateX(-50%) !important;\n}\n\n.translate-middle-y {\n  -webkit-transform: translateY(-50%) !important;\n  transform: translateY(-50%) !important;\n}\n\n.border {\n  border: 1px solid var(--border-color) !important;\n}\n\n.border-0 {\n  border: 0 !important;\n}\n\n.border-top {\n  border-top: 1px solid var(--border-color) !important;\n}\n\n.border-top-0 {\n  border-top: 0 !important;\n}\n\n.border-end {\n  border-right: 1px solid var(--border-color) !important;\n}\n\n.border-end-0 {\n  border-right: 0 !important;\n}\n\n.border-bottom {\n  border-bottom: 1px solid var(--border-color) !important;\n}\n\n.border-bottom-0 {\n  border-bottom: 0 !important;\n}\n\n.border-start {\n  border-left: 1px solid var(--border-color) !important;\n}\n\n.border-start-0 {\n  border-left: 0 !important;\n}\n\n.border-purple {\n  border-color: #8268e2 !important;\n}\n\n.border-white {\n  border-color: #ffffff !important;\n}\n\n.border-1 {\n  border-width: 1px !important;\n}\n\n.border-2 {\n  border-width: 2px !important;\n}\n\n.border-3 {\n  border-width: 3px !important;\n}\n\n.border-4 {\n  border-width: 4px !important;\n}\n\n.border-5 {\n  border-width: 5px !important;\n}\n\n.w-25 {\n  width: 25% !important;\n}\n\n.w-50 {\n  width: 50% !important;\n}\n\n.w-75 {\n  width: 75% !important;\n}\n\n.w-100 {\n  width: 100% !important;\n}\n\n.w-auto {\n  width: auto !important;\n}\n\n.mw-100 {\n  max-width: 100% !important;\n}\n\n.vw-100 {\n  width: 100vw !important;\n}\n\n.min-vw-100 {\n  min-width: 100vw !important;\n}\n\n.h-25 {\n  height: 25% !important;\n}\n\n.h-50 {\n  height: 50% !important;\n}\n\n.h-75 {\n  height: 75% !important;\n}\n\n.h-100 {\n  height: 100% !important;\n}\n\n.h-auto {\n  height: auto !important;\n}\n\n.mh-100 {\n  max-height: 100% !important;\n}\n\n.vh-100 {\n  height: 100vh !important;\n}\n\n.min-vh-100 {\n  min-height: 100vh !important;\n}\n\n.flex-fill {\n  -webkit-box-flex: 1 !important;\n  -ms-flex: 1 1 auto !important;\n  flex: 1 1 auto !important;\n}\n\n.flex-row {\n  -webkit-box-orient: horizontal !important;\n  -webkit-box-direction: normal !important;\n  -ms-flex-direction: row !important;\n  flex-direction: row !important;\n}\n\n.flex-column {\n  -webkit-box-orient: vertical !important;\n  -webkit-box-direction: normal !important;\n  -ms-flex-direction: column !important;\n  flex-direction: column !important;\n}\n\n.flex-row-reverse {\n  -webkit-box-orient: horizontal !important;\n  -webkit-box-direction: reverse !important;\n  -ms-flex-direction: row-reverse !important;\n  flex-direction: row-reverse !important;\n}\n\n.flex-column-reverse {\n  -webkit-box-orient: vertical !important;\n  -webkit-box-direction: reverse !important;\n  -ms-flex-direction: column-reverse !important;\n  flex-direction: column-reverse !important;\n}\n\n.flex-grow-0 {\n  -webkit-box-flex: 0 !important;\n  -ms-flex-positive: 0 !important;\n  flex-grow: 0 !important;\n}\n\n.flex-grow-1 {\n  -webkit-box-flex: 1 !important;\n  -ms-flex-positive: 1 !important;\n  flex-grow: 1 !important;\n}\n\n.flex-shrink-0 {\n  -ms-flex-negative: 0 !important;\n  flex-shrink: 0 !important;\n}\n\n.flex-shrink-1 {\n  -ms-flex-negative: 1 !important;\n  flex-shrink: 1 !important;\n}\n\n.flex-wrap {\n  -ms-flex-wrap: wrap !important;\n  flex-wrap: wrap !important;\n}\n\n.flex-nowrap {\n  -ms-flex-wrap: nowrap !important;\n  flex-wrap: nowrap !important;\n}\n\n.flex-wrap-reverse {\n  -ms-flex-wrap: wrap-reverse !important;\n  flex-wrap: wrap-reverse !important;\n}\n\n.gap-6 {\n  gap: 3.5rem !important;\n}\n\n.gap-7 {\n  gap: 4rem !important;\n}\n\n.gap-8 {\n  gap: 4.5rem !important;\n}\n\n.gap-9 {\n  gap: 5rem !important;\n}\n\n.justify-content-start {\n  -webkit-box-pack: start !important;\n  -ms-flex-pack: start !important;\n  justify-content: flex-start !important;\n}\n\n.justify-content-end {\n  -webkit-box-pack: end !important;\n  -ms-flex-pack: end !important;\n  justify-content: flex-end !important;\n}\n\n.justify-content-center {\n  -webkit-box-pack: center !important;\n  -ms-flex-pack: center !important;\n  justify-content: center !important;\n}\n\n.justify-content-between {\n  -webkit-box-pack: justify !important;\n  -ms-flex-pack: justify !important;\n  justify-content: space-between !important;\n}\n\n.justify-content-around {\n  -ms-flex-pack: distribute !important;\n  justify-content: space-around !important;\n}\n\n.justify-content-evenly {\n  -webkit-box-pack: space-evenly !important;\n  -ms-flex-pack: space-evenly !important;\n  justify-content: space-evenly !important;\n}\n\n.align-items-start {\n  -webkit-box-align: start !important;\n  -ms-flex-align: start !important;\n  align-items: flex-start !important;\n}\n\n.align-items-end {\n  -webkit-box-align: end !important;\n  -ms-flex-align: end !important;\n  align-items: flex-end !important;\n}\n\n.align-items-center {\n  -webkit-box-align: center !important;\n  -ms-flex-align: center !important;\n  align-items: center !important;\n}\n\n.align-items-baseline {\n  -webkit-box-align: baseline !important;\n  -ms-flex-align: baseline !important;\n  align-items: baseline !important;\n}\n\n.align-items-stretch {\n  -webkit-box-align: stretch !important;\n  -ms-flex-align: stretch !important;\n  align-items: stretch !important;\n}\n\n.align-content-start {\n  -ms-flex-line-pack: start !important;\n  align-content: flex-start !important;\n}\n\n.align-content-end {\n  -ms-flex-line-pack: end !important;\n  align-content: flex-end !important;\n}\n\n.align-content-center {\n  -ms-flex-line-pack: center !important;\n  align-content: center !important;\n}\n\n.align-content-between {\n  -ms-flex-line-pack: justify !important;\n  align-content: space-between !important;\n}\n\n.align-content-around {\n  -ms-flex-line-pack: distribute !important;\n  align-content: space-around !important;\n}\n\n.align-content-stretch {\n  -ms-flex-line-pack: stretch !important;\n  align-content: stretch !important;\n}\n\n.align-self-auto {\n  -ms-flex-item-align: auto !important;\n  -ms-grid-row-align: auto !important;\n  align-self: auto !important;\n}\n\n.align-self-start {\n  -ms-flex-item-align: start !important;\n  align-self: flex-start !important;\n}\n\n.align-self-end {\n  -ms-flex-item-align: end !important;\n  align-self: flex-end !important;\n}\n\n.align-self-center {\n  -ms-flex-item-align: center !important;\n  -ms-grid-row-align: center !important;\n  align-self: center !important;\n}\n\n.align-self-baseline {\n  -ms-flex-item-align: baseline !important;\n  align-self: baseline !important;\n}\n\n.align-self-stretch {\n  -ms-flex-item-align: stretch !important;\n  -ms-grid-row-align: stretch !important;\n  align-self: stretch !important;\n}\n\n.order-first {\n  -webkit-box-ordinal-group: 0 !important;\n  -ms-flex-order: -1 !important;\n  order: -1 !important;\n}\n\n.order-0 {\n  -webkit-box-ordinal-group: 1 !important;\n  -ms-flex-order: 0 !important;\n  order: 0 !important;\n}\n\n.order-1 {\n  -webkit-box-ordinal-group: 2 !important;\n  -ms-flex-order: 1 !important;\n  order: 1 !important;\n}\n\n.order-2 {\n  -webkit-box-ordinal-group: 3 !important;\n  -ms-flex-order: 2 !important;\n  order: 2 !important;\n}\n\n.order-3 {\n  -webkit-box-ordinal-group: 4 !important;\n  -ms-flex-order: 3 !important;\n  order: 3 !important;\n}\n\n.order-4 {\n  -webkit-box-ordinal-group: 5 !important;\n  -ms-flex-order: 4 !important;\n  order: 4 !important;\n}\n\n.order-5 {\n  -webkit-box-ordinal-group: 6 !important;\n  -ms-flex-order: 5 !important;\n  order: 5 !important;\n}\n\n.order-last {\n  -webkit-box-ordinal-group: 7 !important;\n  -ms-flex-order: 6 !important;\n  order: 6 !important;\n}\n\n.m-6 {\n  margin: 3.5rem !important;\n}\n\n.m-7 {\n  margin: 4rem !important;\n}\n\n.m-8 {\n  margin: 4.5rem !important;\n}\n\n.m-9 {\n  margin: 5rem !important;\n}\n\n.m-auto {\n  margin: auto !important;\n}\n\n.mx-6 {\n  margin-right: 3.5rem !important;\n  margin-left: 3.5rem !important;\n}\n\n.mx-7 {\n  margin-right: 4rem !important;\n  margin-left: 4rem !important;\n}\n\n.mx-8 {\n  margin-right: 4.5rem !important;\n  margin-left: 4.5rem !important;\n}\n\n.mx-9 {\n  margin-right: 5rem !important;\n  margin-left: 5rem !important;\n}\n\n.mx-auto {\n  margin-right: auto !important;\n  margin-left: auto !important;\n}\n\n.my-6 {\n  margin-top: 3.5rem !important;\n  margin-bottom: 3.5rem !important;\n}\n\n.my-7 {\n  margin-top: 4rem !important;\n  margin-bottom: 4rem !important;\n}\n\n.my-8 {\n  margin-top: 4.5rem !important;\n  margin-bottom: 4.5rem !important;\n}\n\n.my-9 {\n  margin-top: 5rem !important;\n  margin-bottom: 5rem !important;\n}\n\n.my-auto {\n  margin-top: auto !important;\n  margin-bottom: auto !important;\n}\n\n.mt-6 {\n  margin-top: 3.5rem !important;\n}\n\n.mt-7 {\n  margin-top: 4rem !important;\n}\n\n.mt-8 {\n  margin-top: 4.5rem !important;\n}\n\n.mt-9 {\n  margin-top: 5rem !important;\n}\n\n.mt-auto {\n  margin-top: auto !important;\n}\n\n.me-6 {\n  margin-right: 3.5rem !important;\n}\n\n.me-7 {\n  margin-right: 4rem !important;\n}\n\n.me-8 {\n  margin-right: 4.5rem !important;\n}\n\n.me-9 {\n  margin-right: 5rem !important;\n}\n\n.me-auto {\n  margin-right: auto !important;\n}\n\n.mb-6 {\n  margin-bottom: 3.5rem !important;\n}\n\n.mb-7 {\n  margin-bottom: 4rem !important;\n}\n\n.mb-8 {\n  margin-bottom: 4.5rem !important;\n}\n\n.mb-9 {\n  margin-bottom: 5rem !important;\n}\n\n.mb-auto {\n  margin-bottom: auto !important;\n}\n\n.ms-6 {\n  margin-left: 3.5rem !important;\n}\n\n.ms-7 {\n  margin-left: 4rem !important;\n}\n\n.ms-8 {\n  margin-left: 4.5rem !important;\n}\n\n.ms-9 {\n  margin-left: 5rem !important;\n}\n\n.ms-auto {\n  margin-left: auto !important;\n}\n\n.p-6 {\n  padding: 3.5rem !important;\n}\n\n.p-7 {\n  padding: 4rem !important;\n}\n\n.p-8 {\n  padding: 4.5rem !important;\n}\n\n.p-9 {\n  padding: 5rem !important;\n}\n\n.px-6 {\n  padding-right: 3.5rem !important;\n  padding-left: 3.5rem !important;\n}\n\n.px-7 {\n  padding-right: 4rem !important;\n  padding-left: 4rem !important;\n}\n\n.px-8 {\n  padding-right: 4.5rem !important;\n  padding-left: 4.5rem !important;\n}\n\n.px-9 {\n  padding-right: 5rem !important;\n  padding-left: 5rem !important;\n}\n\n.py-6 {\n  padding-top: 3.5rem !important;\n  padding-bottom: 3.5rem !important;\n}\n\n.py-7 {\n  padding-top: 4rem !important;\n  padding-bottom: 4rem !important;\n}\n\n.py-8 {\n  padding-top: 4.5rem !important;\n  padding-bottom: 4.5rem !important;\n}\n\n.py-9 {\n  padding-top: 5rem !important;\n  padding-bottom: 5rem !important;\n}\n\n.pt-6 {\n  padding-top: 3.5rem !important;\n}\n\n.pt-7 {\n  padding-top: 4rem !important;\n}\n\n.pt-8 {\n  padding-top: 4.5rem !important;\n}\n\n.pt-9 {\n  padding-top: 5rem !important;\n}\n\n.pe-6 {\n  padding-right: 3.5rem !important;\n}\n\n.pe-7 {\n  padding-right: 4rem !important;\n}\n\n.pe-8 {\n  padding-right: 4.5rem !important;\n}\n\n.pe-9 {\n  padding-right: 5rem !important;\n}\n\n.pb-6 {\n  padding-bottom: 3.5rem !important;\n}\n\n.pb-7 {\n  padding-bottom: 4rem !important;\n}\n\n.pb-8 {\n  padding-bottom: 4.5rem !important;\n}\n\n.pb-9 {\n  padding-bottom: 5rem !important;\n}\n\n.ps-6 {\n  padding-left: 3.5rem !important;\n}\n\n.ps-7 {\n  padding-left: 4rem !important;\n}\n\n.ps-8 {\n  padding-left: 4.5rem !important;\n}\n\n.ps-9 {\n  padding-left: 5rem !important;\n}\n\n.font-monospace {\n  font-family: var(--bs-font-monospace) !important;\n}\n\n.fs-1 {\n  font-size: calc(1.37525rem + 1.503vw) !important;\n}\n\n.fs-2 {\n  font-size: calc(1.3249375rem + 0.89925vw) !important;\n}\n\n.fs-3 {\n  font-size: calc(1.274625rem + 0.2955vw) !important;\n}\n\n.fs-4 {\n  font-size: calc(1.250125rem + 0.0015vw) !important;\n}\n\n.fs-5 {\n  font-size: 1.124375rem !important;\n}\n\n.fs-6 {\n  font-size: 0.93625rem !important;\n}\n\n.fst-italic {\n  font-style: italic !important;\n}\n\n.fst-normal {\n  font-style: normal !important;\n}\n\n.fw-light {\n  font-weight: 300 !important;\n}\n\n.fw-lighter {\n  font-weight: lighter !important;\n}\n\n.fw-normal {\n  font-weight: 400 !important;\n}\n\n.fw-bold {\n  font-weight: 700 !important;\n}\n\n.fw-bolder {\n  font-weight: bolder !important;\n}\n\n.lh-1 {\n  line-height: 1 !important;\n}\n\n.lh-sm {\n  line-height: 1.25 !important;\n}\n\n.lh-base {\n  line-height: 1.5 !important;\n}\n\n.lh-lg {\n  line-height: 2 !important;\n}\n\n.text-start {\n  text-align: left !important;\n}\n\n.text-end {\n  text-align: right !important;\n}\n\n.text-center {\n  text-align: center !important;\n}\n\n.text-decoration-none {\n  text-decoration: none !important;\n}\n\n.text-decoration-underline {\n  text-decoration: underline !important;\n}\n\n.text-decoration-line-through {\n  text-decoration: line-through !important;\n}\n\n.text-lowercase {\n  text-transform: lowercase !important;\n}\n\n.text-uppercase {\n  text-transform: uppercase !important;\n}\n\n.text-capitalize {\n  text-transform: capitalize !important;\n}\n\n.text-wrap {\n  white-space: normal !important;\n}\n\n.text-nowrap {\n  white-space: nowrap !important;\n}\n\n/* rtl:begin:remove */\n.text-break {\n  word-wrap: break-word !important;\n  word-break: break-word !important;\n}\n\n/* rtl:end:remove */\n.text-purple {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-purple-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-black {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-white {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-body {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-muted {\n  --bs-text-opacity: 1;\n  color: #6c757d !important;\n}\n\n.text-black-50 {\n  --bs-text-opacity: 1;\n  color: rgba(0, 0, 0, 0.5) !important;\n}\n\n.text-white-50 {\n  --bs-text-opacity: 1;\n  color: rgba(255, 255, 255, 0.5) !important;\n}\n\n.text-reset {\n  --bs-text-opacity: 1;\n  color: inherit !important;\n}\n\n.text-opacity-25 {\n  --bs-text-opacity: 0.25;\n}\n\n.text-opacity-50 {\n  --bs-text-opacity: 0.5;\n}\n\n.text-opacity-75 {\n  --bs-text-opacity: 0.75;\n}\n\n.text-opacity-100 {\n  --bs-text-opacity: 1;\n}\n\n.bg-purple {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-purple-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-black {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-white {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-body {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-transparent {\n  --bs-bg-opacity: 1;\n  background-color: transparent !important;\n}\n\n.bg-opacity-10 {\n  --bs-bg-opacity: 0.1;\n}\n\n.bg-opacity-25 {\n  --bs-bg-opacity: 0.25;\n}\n\n.bg-opacity-50 {\n  --bs-bg-opacity: 0.5;\n}\n\n.bg-opacity-75 {\n  --bs-bg-opacity: 0.75;\n}\n\n.bg-opacity-100 {\n  --bs-bg-opacity: 1;\n}\n\n.bg-gradient {\n  background-image: var(--bs-gradient) !important;\n}\n\n.user-select-all {\n  -webkit-user-select: all !important;\n  -moz-user-select: all !important;\n  user-select: all !important;\n}\n\n.user-select-auto {\n  -webkit-user-select: auto !important;\n  -moz-user-select: auto !important;\n  -ms-user-select: auto !important;\n  user-select: auto !important;\n}\n\n.user-select-none {\n  -webkit-user-select: none !important;\n  -moz-user-select: none !important;\n  -ms-user-select: none !important;\n  user-select: none !important;\n}\n\n.pe-none {\n  pointer-events: none !important;\n}\n\n.pe-auto {\n  pointer-events: auto !important;\n}\n\n.rounded {\n  border-radius: 0.25rem !important;\n}\n\n.rounded-0 {\n  border-radius: 0 !important;\n}\n\n.rounded-1 {\n  border-radius: 0.2rem !important;\n}\n\n.rounded-2 {\n  border-radius: 0.25rem !important;\n}\n\n.rounded-3 {\n  border-radius: 0.3rem !important;\n}\n\n.rounded-circle {\n  border-radius: 50% !important;\n}\n\n.rounded-pill {\n  border-radius: 50rem !important;\n}\n\n.rounded-top {\n  border-top-left-radius: 0.25rem !important;\n  border-top-right-radius: 0.25rem !important;\n}\n\n.rounded-end {\n  border-top-right-radius: 0.25rem !important;\n  border-bottom-right-radius: 0.25rem !important;\n}\n\n.rounded-bottom {\n  border-bottom-right-radius: 0.25rem !important;\n  border-bottom-left-radius: 0.25rem !important;\n}\n\n.rounded-start {\n  border-bottom-left-radius: 0.25rem !important;\n  border-top-left-radius: 0.25rem !important;\n}\n\n.visible {\n  visibility: visible !important;\n}\n\n.invisible {\n  visibility: hidden !important;\n}\n\n@media (min-width: 576px) {\n  .float-sm-start {\n    float: left !important;\n  }\n\n  .float-sm-end {\n    float: right !important;\n  }\n\n  .float-sm-none {\n    float: none !important;\n  }\n\n  .d-sm-inline {\n    display: inline !important;\n  }\n\n  .d-sm-inline-block {\n    display: inline-block !important;\n  }\n\n  .d-sm-block {\n    display: block !important;\n  }\n\n  .d-sm-grid {\n    display: -ms-grid !important;\n    display: grid !important;\n  }\n\n  .d-sm-table {\n    display: table !important;\n  }\n\n  .d-sm-table-row {\n    display: table-row !important;\n  }\n\n  .d-sm-table-cell {\n    display: table-cell !important;\n  }\n\n  .d-sm-flex {\n    display: -webkit-box !important;\n    display: -ms-flexbox !important;\n    display: flex !important;\n  }\n\n  .d-sm-inline-flex {\n    display: -webkit-inline-box !important;\n    display: -ms-inline-flexbox !important;\n    display: inline-flex !important;\n  }\n\n  .d-sm-none {\n    display: none !important;\n  }\n\n  .flex-sm-fill {\n    -webkit-box-flex: 1 !important;\n    -ms-flex: 1 1 auto !important;\n    flex: 1 1 auto !important;\n  }\n\n  .flex-sm-row {\n    -webkit-box-orient: horizontal !important;\n    -webkit-box-direction: normal !important;\n    -ms-flex-direction: row !important;\n    flex-direction: row !important;\n  }\n\n  .flex-sm-column {\n    -webkit-box-orient: vertical !important;\n    -webkit-box-direction: normal !important;\n    -ms-flex-direction: column !important;\n    flex-direction: column !important;\n  }\n\n  .flex-sm-row-reverse {\n    -webkit-box-orient: horizontal !important;\n    -webkit-box-direction: reverse !important;\n    -ms-flex-direction: row-reverse !important;\n    flex-direction: row-reverse !important;\n  }\n\n  .flex-sm-column-reverse {\n    -webkit-box-orient: vertical !important;\n    -webkit-box-direction: reverse !important;\n    -ms-flex-direction: column-reverse !important;\n    flex-direction: column-reverse !important;\n  }\n\n  .flex-sm-grow-0 {\n    -webkit-box-flex: 0 !important;\n    -ms-flex-positive: 0 !important;\n    flex-grow: 0 !important;\n  }\n\n  .flex-sm-grow-1 {\n    -webkit-box-flex: 1 !important;\n    -ms-flex-positive: 1 !important;\n    flex-grow: 1 !important;\n  }\n\n  .flex-sm-shrink-0 {\n    -ms-flex-negative: 0 !important;\n    flex-shrink: 0 !important;\n  }\n\n  .flex-sm-shrink-1 {\n    -ms-flex-negative: 1 !important;\n    flex-shrink: 1 !important;\n  }\n\n  .flex-sm-wrap {\n    -ms-flex-wrap: wrap !important;\n    flex-wrap: wrap !important;\n  }\n\n  .flex-sm-nowrap {\n    -ms-flex-wrap: nowrap !important;\n    flex-wrap: nowrap !important;\n  }\n\n  .flex-sm-wrap-reverse {\n    -ms-flex-wrap: wrap-reverse !important;\n    flex-wrap: wrap-reverse !important;\n  }\n\n  .gap-sm-6 {\n    gap: 3.5rem !important;\n  }\n\n  .gap-sm-7 {\n    gap: 4rem !important;\n  }\n\n  .gap-sm-8 {\n    gap: 4.5rem !important;\n  }\n\n  .gap-sm-9 {\n    gap: 5rem !important;\n  }\n\n  .justify-content-sm-start {\n    -webkit-box-pack: start !important;\n    -ms-flex-pack: start !important;\n    justify-content: flex-start !important;\n  }\n\n  .justify-content-sm-end {\n    -webkit-box-pack: end !important;\n    -ms-flex-pack: end !important;\n    justify-content: flex-end !important;\n  }\n\n  .justify-content-sm-center {\n    -webkit-box-pack: center !important;\n    -ms-flex-pack: center !important;\n    justify-content: center !important;\n  }\n\n  .justify-content-sm-between {\n    -webkit-box-pack: justify !important;\n    -ms-flex-pack: justify !important;\n    justify-content: space-between !important;\n  }\n\n  .justify-content-sm-around {\n    -ms-flex-pack: distribute !important;\n    justify-content: space-around !important;\n  }\n\n  .justify-content-sm-evenly {\n    -webkit-box-pack: space-evenly !important;\n    -ms-flex-pack: space-evenly !important;\n    justify-content: space-evenly !important;\n  }\n\n  .align-items-sm-start {\n    -webkit-box-align: start !important;\n    -ms-flex-align: start !important;\n    align-items: flex-start !important;\n  }\n\n  .align-items-sm-end {\n    -webkit-box-align: end !important;\n    -ms-flex-align: end !important;\n    align-items: flex-end !important;\n  }\n\n  .align-items-sm-center {\n    -webkit-box-align: center !important;\n    -ms-flex-align: center !important;\n    align-items: center !important;\n  }\n\n  .align-items-sm-baseline {\n    -webkit-box-align: baseline !important;\n    -ms-flex-align: baseline !important;\n    align-items: baseline !important;\n  }\n\n  .align-items-sm-stretch {\n    -webkit-box-align: stretch !important;\n    -ms-flex-align: stretch !important;\n    align-items: stretch !important;\n  }\n\n  .align-content-sm-start {\n    -ms-flex-line-pack: start !important;\n    align-content: flex-start !important;\n  }\n\n  .align-content-sm-end {\n    -ms-flex-line-pack: end !important;\n    align-content: flex-end !important;\n  }\n\n  .align-content-sm-center {\n    -ms-flex-line-pack: center !important;\n    align-content: center !important;\n  }\n\n  .align-content-sm-between {\n    -ms-flex-line-pack: justify !important;\n    align-content: space-between !important;\n  }\n\n  .align-content-sm-around {\n    -ms-flex-line-pack: distribute !important;\n    align-content: space-around !important;\n  }\n\n  .align-content-sm-stretch {\n    -ms-flex-line-pack: stretch !important;\n    align-content: stretch !important;\n  }\n\n  .align-self-sm-auto {\n    -ms-flex-item-align: auto !important;\n    -ms-grid-row-align: auto !important;\n    align-self: auto !important;\n  }\n\n  .align-self-sm-start {\n    -ms-flex-item-align: start !important;\n    align-self: flex-start !important;\n  }\n\n  .align-self-sm-end {\n    -ms-flex-item-align: end !important;\n    align-self: flex-end !important;\n  }\n\n  .align-self-sm-center {\n    -ms-flex-item-align: center !important;\n    -ms-grid-row-align: center !important;\n    align-self: center !important;\n  }\n\n  .align-self-sm-baseline {\n    -ms-flex-item-align: baseline !important;\n    align-self: baseline !important;\n  }\n\n  .align-self-sm-stretch {\n    -ms-flex-item-align: stretch !important;\n    -ms-grid-row-align: stretch !important;\n    align-self: stretch !important;\n  }\n\n  .order-sm-first {\n    -webkit-box-ordinal-group: 0 !important;\n    -ms-flex-order: -1 !important;\n    order: -1 !important;\n  }\n\n  .order-sm-0 {\n    -webkit-box-ordinal-group: 1 !important;\n    -ms-flex-order: 0 !important;\n    order: 0 !important;\n  }\n\n  .order-sm-1 {\n    -webkit-box-ordinal-group: 2 !important;\n    -ms-flex-order: 1 !important;\n    order: 1 !important;\n  }\n\n  .order-sm-2 {\n    -webkit-box-ordinal-group: 3 !important;\n    -ms-flex-order: 2 !important;\n    order: 2 !important;\n  }\n\n  .order-sm-3 {\n    -webkit-box-ordinal-group: 4 !important;\n    -ms-flex-order: 3 !important;\n    order: 3 !important;\n  }\n\n  .order-sm-4 {\n    -webkit-box-ordinal-group: 5 !important;\n    -ms-flex-order: 4 !important;\n    order: 4 !important;\n  }\n\n  .order-sm-5 {\n    -webkit-box-ordinal-group: 6 !important;\n    -ms-flex-order: 5 !important;\n    order: 5 !important;\n  }\n\n  .order-sm-last {\n    -webkit-box-ordinal-group: 7 !important;\n    -ms-flex-order: 6 !important;\n    order: 6 !important;\n  }\n\n  .m-sm-6 {\n    margin: 3.5rem !important;\n  }\n\n  .m-sm-7 {\n    margin: 4rem !important;\n  }\n\n  .m-sm-8 {\n    margin: 4.5rem !important;\n  }\n\n  .m-sm-9 {\n    margin: 5rem !important;\n  }\n\n  .m-sm-auto {\n    margin: auto !important;\n  }\n\n  .mx-sm-6 {\n    margin-right: 3.5rem !important;\n    margin-left: 3.5rem !important;\n  }\n\n  .mx-sm-7 {\n    margin-right: 4rem !important;\n    margin-left: 4rem !important;\n  }\n\n  .mx-sm-8 {\n    margin-right: 4.5rem !important;\n    margin-left: 4.5rem !important;\n  }\n\n  .mx-sm-9 {\n    margin-right: 5rem !important;\n    margin-left: 5rem !important;\n  }\n\n  .mx-sm-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n\n  .my-sm-6 {\n    margin-top: 3.5rem !important;\n    margin-bottom: 3.5rem !important;\n  }\n\n  .my-sm-7 {\n    margin-top: 4rem !important;\n    margin-bottom: 4rem !important;\n  }\n\n  .my-sm-8 {\n    margin-top: 4.5rem !important;\n    margin-bottom: 4.5rem !important;\n  }\n\n  .my-sm-9 {\n    margin-top: 5rem !important;\n    margin-bottom: 5rem !important;\n  }\n\n  .my-sm-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n\n  .mt-sm-6 {\n    margin-top: 3.5rem !important;\n  }\n\n  .mt-sm-7 {\n    margin-top: 4rem !important;\n  }\n\n  .mt-sm-8 {\n    margin-top: 4.5rem !important;\n  }\n\n  .mt-sm-9 {\n    margin-top: 5rem !important;\n  }\n\n  .mt-sm-auto {\n    margin-top: auto !important;\n  }\n\n  .me-sm-6 {\n    margin-right: 3.5rem !important;\n  }\n\n  .me-sm-7 {\n    margin-right: 4rem !important;\n  }\n\n  .me-sm-8 {\n    margin-right: 4.5rem !important;\n  }\n\n  .me-sm-9 {\n    margin-right: 5rem !important;\n  }\n\n  .me-sm-auto {\n    margin-right: auto !important;\n  }\n\n  .mb-sm-6 {\n    margin-bottom: 3.5rem !important;\n  }\n\n  .mb-sm-7 {\n    margin-bottom: 4rem !important;\n  }\n\n  .mb-sm-8 {\n    margin-bottom: 4.5rem !important;\n  }\n\n  .mb-sm-9 {\n    margin-bottom: 5rem !important;\n  }\n\n  .mb-sm-auto {\n    margin-bottom: auto !important;\n  }\n\n  .ms-sm-6 {\n    margin-left: 3.5rem !important;\n  }\n\n  .ms-sm-7 {\n    margin-left: 4rem !important;\n  }\n\n  .ms-sm-8 {\n    margin-left: 4.5rem !important;\n  }\n\n  .ms-sm-9 {\n    margin-left: 5rem !important;\n  }\n\n  .ms-sm-auto {\n    margin-left: auto !important;\n  }\n\n  .p-sm-6 {\n    padding: 3.5rem !important;\n  }\n\n  .p-sm-7 {\n    padding: 4rem !important;\n  }\n\n  .p-sm-8 {\n    padding: 4.5rem !important;\n  }\n\n  .p-sm-9 {\n    padding: 5rem !important;\n  }\n\n  .px-sm-6 {\n    padding-right: 3.5rem !important;\n    padding-left: 3.5rem !important;\n  }\n\n  .px-sm-7 {\n    padding-right: 4rem !important;\n    padding-left: 4rem !important;\n  }\n\n  .px-sm-8 {\n    padding-right: 4.5rem !important;\n    padding-left: 4.5rem !important;\n  }\n\n  .px-sm-9 {\n    padding-right: 5rem !important;\n    padding-left: 5rem !important;\n  }\n\n  .py-sm-6 {\n    padding-top: 3.5rem !important;\n    padding-bottom: 3.5rem !important;\n  }\n\n  .py-sm-7 {\n    padding-top: 4rem !important;\n    padding-bottom: 4rem !important;\n  }\n\n  .py-sm-8 {\n    padding-top: 4.5rem !important;\n    padding-bottom: 4.5rem !important;\n  }\n\n  .py-sm-9 {\n    padding-top: 5rem !important;\n    padding-bottom: 5rem !important;\n  }\n\n  .pt-sm-6 {\n    padding-top: 3.5rem !important;\n  }\n\n  .pt-sm-7 {\n    padding-top: 4rem !important;\n  }\n\n  .pt-sm-8 {\n    padding-top: 4.5rem !important;\n  }\n\n  .pt-sm-9 {\n    padding-top: 5rem !important;\n  }\n\n  .pe-sm-6 {\n    padding-right: 3.5rem !important;\n  }\n\n  .pe-sm-7 {\n    padding-right: 4rem !important;\n  }\n\n  .pe-sm-8 {\n    padding-right: 4.5rem !important;\n  }\n\n  .pe-sm-9 {\n    padding-right: 5rem !important;\n  }\n\n  .pb-sm-6 {\n    padding-bottom: 3.5rem !important;\n  }\n\n  .pb-sm-7 {\n    padding-bottom: 4rem !important;\n  }\n\n  .pb-sm-8 {\n    padding-bottom: 4.5rem !important;\n  }\n\n  .pb-sm-9 {\n    padding-bottom: 5rem !important;\n  }\n\n  .ps-sm-6 {\n    padding-left: 3.5rem !important;\n  }\n\n  .ps-sm-7 {\n    padding-left: 4rem !important;\n  }\n\n  .ps-sm-8 {\n    padding-left: 4.5rem !important;\n  }\n\n  .ps-sm-9 {\n    padding-left: 5rem !important;\n  }\n\n  .text-sm-start {\n    text-align: left !important;\n  }\n\n  .text-sm-end {\n    text-align: right !important;\n  }\n\n  .text-sm-center {\n    text-align: center !important;\n  }\n}\n\n@media (min-width: 768px) {\n  .float-md-start {\n    float: left !important;\n  }\n\n  .float-md-end {\n    float: right !important;\n  }\n\n  .float-md-none {\n    float: none !important;\n  }\n\n  .d-md-inline {\n    display: inline !important;\n  }\n\n  .d-md-inline-block {\n    display: inline-block !important;\n  }\n\n  .d-md-block {\n    display: block !important;\n  }\n\n  .d-md-grid {\n    display: -ms-grid !important;\n    display: grid !important;\n  }\n\n  .d-md-table {\n    display: table !important;\n  }\n\n  .d-md-table-row {\n    display: table-row !important;\n  }\n\n  .d-md-table-cell {\n    display: table-cell !important;\n  }\n\n  .d-md-flex {\n    display: -webkit-box !important;\n    display: -ms-flexbox !important;\n    display: flex !important;\n  }\n\n  .d-md-inline-flex {\n    display: -webkit-inline-box !important;\n    display: -ms-inline-flexbox !important;\n    display: inline-flex !important;\n  }\n\n  .d-md-none {\n    display: none !important;\n  }\n\n  .flex-md-fill {\n    -webkit-box-flex: 1 !important;\n    -ms-flex: 1 1 auto !important;\n    flex: 1 1 auto !important;\n  }\n\n  .flex-md-row {\n    -webkit-box-orient: horizontal !important;\n    -webkit-box-direction: normal !important;\n    -ms-flex-direction: row !important;\n    flex-direction: row !important;\n  }\n\n  .flex-md-column {\n    -webkit-box-orient: vertical !important;\n    -webkit-box-direction: normal !important;\n    -ms-flex-direction: column !important;\n    flex-direction: column !important;\n  }\n\n  .flex-md-row-reverse {\n    -webkit-box-orient: horizontal !important;\n    -webkit-box-direction: reverse !important;\n    -ms-flex-direction: row-reverse !important;\n    flex-direction: row-reverse !important;\n  }\n\n  .flex-md-column-reverse {\n    -webkit-box-orient: vertical !important;\n    -webkit-box-direction: reverse !important;\n    -ms-flex-direction: column-reverse !important;\n    flex-direction: column-reverse !important;\n  }\n\n  .flex-md-grow-0 {\n    -webkit-box-flex: 0 !important;\n    -ms-flex-positive: 0 !important;\n    flex-grow: 0 !important;\n  }\n\n  .flex-md-grow-1 {\n    -webkit-box-flex: 1 !important;\n    -ms-flex-positive: 1 !important;\n    flex-grow: 1 !important;\n  }\n\n  .flex-md-shrink-0 {\n    -ms-flex-negative: 0 !important;\n    flex-shrink: 0 !important;\n  }\n\n  .flex-md-shrink-1 {\n    -ms-flex-negative: 1 !important;\n    flex-shrink: 1 !important;\n  }\n\n  .flex-md-wrap {\n    -ms-flex-wrap: wrap !important;\n    flex-wrap: wrap !important;\n  }\n\n  .flex-md-nowrap {\n    -ms-flex-wrap: nowrap !important;\n    flex-wrap: nowrap !important;\n  }\n\n  .flex-md-wrap-reverse {\n    -ms-flex-wrap: wrap-reverse !important;\n    flex-wrap: wrap-reverse !important;\n  }\n\n  .gap-md-6 {\n    gap: 3.5rem !important;\n  }\n\n  .gap-md-7 {\n    gap: 4rem !important;\n  }\n\n  .gap-md-8 {\n    gap: 4.5rem !important;\n  }\n\n  .gap-md-9 {\n    gap: 5rem !important;\n  }\n\n  .justify-content-md-start {\n    -webkit-box-pack: start !important;\n    -ms-flex-pack: start !important;\n    justify-content: flex-start !important;\n  }\n\n  .justify-content-md-end {\n    -webkit-box-pack: end !important;\n    -ms-flex-pack: end !important;\n    justify-content: flex-end !important;\n  }\n\n  .justify-content-md-center {\n    -webkit-box-pack: center !important;\n    -ms-flex-pack: center !important;\n    justify-content: center !important;\n  }\n\n  .justify-content-md-between {\n    -webkit-box-pack: justify !important;\n    -ms-flex-pack: justify !important;\n    justify-content: space-between !important;\n  }\n\n  .justify-content-md-around {\n    -ms-flex-pack: distribute !important;\n    justify-content: space-around !important;\n  }\n\n  .justify-content-md-evenly {\n    -webkit-box-pack: space-evenly !important;\n    -ms-flex-pack: space-evenly !important;\n    justify-content: space-evenly !important;\n  }\n\n  .align-items-md-start {\n    -webkit-box-align: start !important;\n    -ms-flex-align: start !important;\n    align-items: flex-start !important;\n  }\n\n  .align-items-md-end {\n    -webkit-box-align: end !important;\n    -ms-flex-align: end !important;\n    align-items: flex-end !important;\n  }\n\n  .align-items-md-center {\n    -webkit-box-align: center !important;\n    -ms-flex-align: center !important;\n    align-items: center !important;\n  }\n\n  .align-items-md-baseline {\n    -webkit-box-align: baseline !important;\n    -ms-flex-align: baseline !important;\n    align-items: baseline !important;\n  }\n\n  .align-items-md-stretch {\n    -webkit-box-align: stretch !important;\n    -ms-flex-align: stretch !important;\n    align-items: stretch !important;\n  }\n\n  .align-content-md-start {\n    -ms-flex-line-pack: start !important;\n    align-content: flex-start !important;\n  }\n\n  .align-content-md-end {\n    -ms-flex-line-pack: end !important;\n    align-content: flex-end !important;\n  }\n\n  .align-content-md-center {\n    -ms-flex-line-pack: center !important;\n    align-content: center !important;\n  }\n\n  .align-content-md-between {\n    -ms-flex-line-pack: justify !important;\n    align-content: space-between !important;\n  }\n\n  .align-content-md-around {\n    -ms-flex-line-pack: distribute !important;\n    align-content: space-around !important;\n  }\n\n  .align-content-md-stretch {\n    -ms-flex-line-pack: stretch !important;\n    align-content: stretch !important;\n  }\n\n  .align-self-md-auto {\n    -ms-flex-item-align: auto !important;\n    -ms-grid-row-align: auto !important;\n    align-self: auto !important;\n  }\n\n  .align-self-md-start {\n    -ms-flex-item-align: start !important;\n    align-self: flex-start !important;\n  }\n\n  .align-self-md-end {\n    -ms-flex-item-align: end !important;\n    align-self: flex-end !important;\n  }\n\n  .align-self-md-center {\n    -ms-flex-item-align: center !important;\n    -ms-grid-row-align: center !important;\n    align-self: center !important;\n  }\n\n  .align-self-md-baseline {\n    -ms-flex-item-align: baseline !important;\n    align-self: baseline !important;\n  }\n\n  .align-self-md-stretch {\n    -ms-flex-item-align: stretch !important;\n    -ms-grid-row-align: stretch !important;\n    align-self: stretch !important;\n  }\n\n  .order-md-first {\n    -webkit-box-ordinal-group: 0 !important;\n    -ms-flex-order: -1 !important;\n    order: -1 !important;\n  }\n\n  .order-md-0 {\n    -webkit-box-ordinal-group: 1 !important;\n    -ms-flex-order: 0 !important;\n    order: 0 !important;\n  }\n\n  .order-md-1 {\n    -webkit-box-ordinal-group: 2 !important;\n    -ms-flex-order: 1 !important;\n    order: 1 !important;\n  }\n\n  .order-md-2 {\n    -webkit-box-ordinal-group: 3 !important;\n    -ms-flex-order: 2 !important;\n    order: 2 !important;\n  }\n\n  .order-md-3 {\n    -webkit-box-ordinal-group: 4 !important;\n    -ms-flex-order: 3 !important;\n    order: 3 !important;\n  }\n\n  .order-md-4 {\n    -webkit-box-ordinal-group: 5 !important;\n    -ms-flex-order: 4 !important;\n    order: 4 !important;\n  }\n\n  .order-md-5 {\n    -webkit-box-ordinal-group: 6 !important;\n    -ms-flex-order: 5 !important;\n    order: 5 !important;\n  }\n\n  .order-md-last {\n    -webkit-box-ordinal-group: 7 !important;\n    -ms-flex-order: 6 !important;\n    order: 6 !important;\n  }\n\n  .m-md-6 {\n    margin: 3.5rem !important;\n  }\n\n  .m-md-7 {\n    margin: 4rem !important;\n  }\n\n  .m-md-8 {\n    margin: 4.5rem !important;\n  }\n\n  .m-md-9 {\n    margin: 5rem !important;\n  }\n\n  .m-md-auto {\n    margin: auto !important;\n  }\n\n  .mx-md-6 {\n    margin-right: 3.5rem !important;\n    margin-left: 3.5rem !important;\n  }\n\n  .mx-md-7 {\n    margin-right: 4rem !important;\n    margin-left: 4rem !important;\n  }\n\n  .mx-md-8 {\n    margin-right: 4.5rem !important;\n    margin-left: 4.5rem !important;\n  }\n\n  .mx-md-9 {\n    margin-right: 5rem !important;\n    margin-left: 5rem !important;\n  }\n\n  .mx-md-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n\n  .my-md-6 {\n    margin-top: 3.5rem !important;\n    margin-bottom: 3.5rem !important;\n  }\n\n  .my-md-7 {\n    margin-top: 4rem !important;\n    margin-bottom: 4rem !important;\n  }\n\n  .my-md-8 {\n    margin-top: 4.5rem !important;\n    margin-bottom: 4.5rem !important;\n  }\n\n  .my-md-9 {\n    margin-top: 5rem !important;\n    margin-bottom: 5rem !important;\n  }\n\n  .my-md-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n\n  .mt-md-6 {\n    margin-top: 3.5rem !important;\n  }\n\n  .mt-md-7 {\n    margin-top: 4rem !important;\n  }\n\n  .mt-md-8 {\n    margin-top: 4.5rem !important;\n  }\n\n  .mt-md-9 {\n    margin-top: 5rem !important;\n  }\n\n  .mt-md-auto {\n    margin-top: auto !important;\n  }\n\n  .me-md-6 {\n    margin-right: 3.5rem !important;\n  }\n\n  .me-md-7 {\n    margin-right: 4rem !important;\n  }\n\n  .me-md-8 {\n    margin-right: 4.5rem !important;\n  }\n\n  .me-md-9 {\n    margin-right: 5rem !important;\n  }\n\n  .me-md-auto {\n    margin-right: auto !important;\n  }\n\n  .mb-md-6 {\n    margin-bottom: 3.5rem !important;\n  }\n\n  .mb-md-7 {\n    margin-bottom: 4rem !important;\n  }\n\n  .mb-md-8 {\n    margin-bottom: 4.5rem !important;\n  }\n\n  .mb-md-9 {\n    margin-bottom: 5rem !important;\n  }\n\n  .mb-md-auto {\n    margin-bottom: auto !important;\n  }\n\n  .ms-md-6 {\n    margin-left: 3.5rem !important;\n  }\n\n  .ms-md-7 {\n    margin-left: 4rem !important;\n  }\n\n  .ms-md-8 {\n    margin-left: 4.5rem !important;\n  }\n\n  .ms-md-9 {\n    margin-left: 5rem !important;\n  }\n\n  .ms-md-auto {\n    margin-left: auto !important;\n  }\n\n  .p-md-6 {\n    padding: 3.5rem !important;\n  }\n\n  .p-md-7 {\n    padding: 4rem !important;\n  }\n\n  .p-md-8 {\n    padding: 4.5rem !important;\n  }\n\n  .p-md-9 {\n    padding: 5rem !important;\n  }\n\n  .px-md-6 {\n    padding-right: 3.5rem !important;\n    padding-left: 3.5rem !important;\n  }\n\n  .px-md-7 {\n    padding-right: 4rem !important;\n    padding-left: 4rem !important;\n  }\n\n  .px-md-8 {\n    padding-right: 4.5rem !important;\n    padding-left: 4.5rem !important;\n  }\n\n  .px-md-9 {\n    padding-right: 5rem !important;\n    padding-left: 5rem !important;\n  }\n\n  .py-md-6 {\n    padding-top: 3.5rem !important;\n    padding-bottom: 3.5rem !important;\n  }\n\n  .py-md-7 {\n    padding-top: 4rem !important;\n    padding-bottom: 4rem !important;\n  }\n\n  .py-md-8 {\n    padding-top: 4.5rem !important;\n    padding-bottom: 4.5rem !important;\n  }\n\n  .py-md-9 {\n    padding-top: 5rem !important;\n    padding-bottom: 5rem !important;\n  }\n\n  .pt-md-6 {\n    padding-top: 3.5rem !important;\n  }\n\n  .pt-md-7 {\n    padding-top: 4rem !important;\n  }\n\n  .pt-md-8 {\n    padding-top: 4.5rem !important;\n  }\n\n  .pt-md-9 {\n    padding-top: 5rem !important;\n  }\n\n  .pe-md-6 {\n    padding-right: 3.5rem !important;\n  }\n\n  .pe-md-7 {\n    padding-right: 4rem !important;\n  }\n\n  .pe-md-8 {\n    padding-right: 4.5rem !important;\n  }\n\n  .pe-md-9 {\n    padding-right: 5rem !important;\n  }\n\n  .pb-md-6 {\n    padding-bottom: 3.5rem !important;\n  }\n\n  .pb-md-7 {\n    padding-bottom: 4rem !important;\n  }\n\n  .pb-md-8 {\n    padding-bottom: 4.5rem !important;\n  }\n\n  .pb-md-9 {\n    padding-bottom: 5rem !important;\n  }\n\n  .ps-md-6 {\n    padding-left: 3.5rem !important;\n  }\n\n  .ps-md-7 {\n    padding-left: 4rem !important;\n  }\n\n  .ps-md-8 {\n    padding-left: 4.5rem !important;\n  }\n\n  .ps-md-9 {\n    padding-left: 5rem !important;\n  }\n\n  .text-md-start {\n    text-align: left !important;\n  }\n\n  .text-md-end {\n    text-align: right !important;\n  }\n\n  .text-md-center {\n    text-align: center !important;\n  }\n}\n\n@media (min-width: 992px) {\n  .float-lg-start {\n    float: left !important;\n  }\n\n  .float-lg-end {\n    float: right !important;\n  }\n\n  .float-lg-none {\n    float: none !important;\n  }\n\n  .d-lg-inline {\n    display: inline !important;\n  }\n\n  .d-lg-inline-block {\n    display: inline-block !important;\n  }\n\n  .d-lg-block {\n    display: block !important;\n  }\n\n  .d-lg-grid {\n    display: -ms-grid !important;\n    display: grid !important;\n  }\n\n  .d-lg-table {\n    display: table !important;\n  }\n\n  .d-lg-table-row {\n    display: table-row !important;\n  }\n\n  .d-lg-table-cell {\n    display: table-cell !important;\n  }\n\n  .d-lg-flex {\n    display: -webkit-box !important;\n    display: -ms-flexbox !important;\n    display: flex !important;\n  }\n\n  .d-lg-inline-flex {\n    display: -webkit-inline-box !important;\n    display: -ms-inline-flexbox !important;\n    display: inline-flex !important;\n  }\n\n  .d-lg-none {\n    display: none !important;\n  }\n\n  .flex-lg-fill {\n    -webkit-box-flex: 1 !important;\n    -ms-flex: 1 1 auto !important;\n    flex: 1 1 auto !important;\n  }\n\n  .flex-lg-row {\n    -webkit-box-orient: horizontal !important;\n    -webkit-box-direction: normal !important;\n    -ms-flex-direction: row !important;\n    flex-direction: row !important;\n  }\n\n  .flex-lg-column {\n    -webkit-box-orient: vertical !important;\n    -webkit-box-direction: normal !important;\n    -ms-flex-direction: column !important;\n    flex-direction: column !important;\n  }\n\n  .flex-lg-row-reverse {\n    -webkit-box-orient: horizontal !important;\n    -webkit-box-direction: reverse !important;\n    -ms-flex-direction: row-reverse !important;\n    flex-direction: row-reverse !important;\n  }\n\n  .flex-lg-column-reverse {\n    -webkit-box-orient: vertical !important;\n    -webkit-box-direction: reverse !important;\n    -ms-flex-direction: column-reverse !important;\n    flex-direction: column-reverse !important;\n  }\n\n  .flex-lg-grow-0 {\n    -webkit-box-flex: 0 !important;\n    -ms-flex-positive: 0 !important;\n    flex-grow: 0 !important;\n  }\n\n  .flex-lg-grow-1 {\n    -webkit-box-flex: 1 !important;\n    -ms-flex-positive: 1 !important;\n    flex-grow: 1 !important;\n  }\n\n  .flex-lg-shrink-0 {\n    -ms-flex-negative: 0 !important;\n    flex-shrink: 0 !important;\n  }\n\n  .flex-lg-shrink-1 {\n    -ms-flex-negative: 1 !important;\n    flex-shrink: 1 !important;\n  }\n\n  .flex-lg-wrap {\n    -ms-flex-wrap: wrap !important;\n    flex-wrap: wrap !important;\n  }\n\n  .flex-lg-nowrap {\n    -ms-flex-wrap: nowrap !important;\n    flex-wrap: nowrap !important;\n  }\n\n  .flex-lg-wrap-reverse {\n    -ms-flex-wrap: wrap-reverse !important;\n    flex-wrap: wrap-reverse !important;\n  }\n\n  .gap-lg-6 {\n    gap: 3.5rem !important;\n  }\n\n  .gap-lg-7 {\n    gap: 4rem !important;\n  }\n\n  .gap-lg-8 {\n    gap: 4.5rem !important;\n  }\n\n  .gap-lg-9 {\n    gap: 5rem !important;\n  }\n\n  .justify-content-lg-start {\n    -webkit-box-pack: start !important;\n    -ms-flex-pack: start !important;\n    justify-content: flex-start !important;\n  }\n\n  .justify-content-lg-end {\n    -webkit-box-pack: end !important;\n    -ms-flex-pack: end !important;\n    justify-content: flex-end !important;\n  }\n\n  .justify-content-lg-center {\n    -webkit-box-pack: center !important;\n    -ms-flex-pack: center !important;\n    justify-content: center !important;\n  }\n\n  .justify-content-lg-between {\n    -webkit-box-pack: justify !important;\n    -ms-flex-pack: justify !important;\n    justify-content: space-between !important;\n  }\n\n  .justify-content-lg-around {\n    -ms-flex-pack: distribute !important;\n    justify-content: space-around !important;\n  }\n\n  .justify-content-lg-evenly {\n    -webkit-box-pack: space-evenly !important;\n    -ms-flex-pack: space-evenly !important;\n    justify-content: space-evenly !important;\n  }\n\n  .align-items-lg-start {\n    -webkit-box-align: start !important;\n    -ms-flex-align: start !important;\n    align-items: flex-start !important;\n  }\n\n  .align-items-lg-end {\n    -webkit-box-align: end !important;\n    -ms-flex-align: end !important;\n    align-items: flex-end !important;\n  }\n\n  .align-items-lg-center {\n    -webkit-box-align: center !important;\n    -ms-flex-align: center !important;\n    align-items: center !important;\n  }\n\n  .align-items-lg-baseline {\n    -webkit-box-align: baseline !important;\n    -ms-flex-align: baseline !important;\n    align-items: baseline !important;\n  }\n\n  .align-items-lg-stretch {\n    -webkit-box-align: stretch !important;\n    -ms-flex-align: stretch !important;\n    align-items: stretch !important;\n  }\n\n  .align-content-lg-start {\n    -ms-flex-line-pack: start !important;\n    align-content: flex-start !important;\n  }\n\n  .align-content-lg-end {\n    -ms-flex-line-pack: end !important;\n    align-content: flex-end !important;\n  }\n\n  .align-content-lg-center {\n    -ms-flex-line-pack: center !important;\n    align-content: center !important;\n  }\n\n  .align-content-lg-between {\n    -ms-flex-line-pack: justify !important;\n    align-content: space-between !important;\n  }\n\n  .align-content-lg-around {\n    -ms-flex-line-pack: distribute !important;\n    align-content: space-around !important;\n  }\n\n  .align-content-lg-stretch {\n    -ms-flex-line-pack: stretch !important;\n    align-content: stretch !important;\n  }\n\n  .align-self-lg-auto {\n    -ms-flex-item-align: auto !important;\n    -ms-grid-row-align: auto !important;\n    align-self: auto !important;\n  }\n\n  .align-self-lg-start {\n    -ms-flex-item-align: start !important;\n    align-self: flex-start !important;\n  }\n\n  .align-self-lg-end {\n    -ms-flex-item-align: end !important;\n    align-self: flex-end !important;\n  }\n\n  .align-self-lg-center {\n    -ms-flex-item-align: center !important;\n    -ms-grid-row-align: center !important;\n    align-self: center !important;\n  }\n\n  .align-self-lg-baseline {\n    -ms-flex-item-align: baseline !important;\n    align-self: baseline !important;\n  }\n\n  .align-self-lg-stretch {\n    -ms-flex-item-align: stretch !important;\n    -ms-grid-row-align: stretch !important;\n    align-self: stretch !important;\n  }\n\n  .order-lg-first {\n    -webkit-box-ordinal-group: 0 !important;\n    -ms-flex-order: -1 !important;\n    order: -1 !important;\n  }\n\n  .order-lg-0 {\n    -webkit-box-ordinal-group: 1 !important;\n    -ms-flex-order: 0 !important;\n    order: 0 !important;\n  }\n\n  .order-lg-1 {\n    -webkit-box-ordinal-group: 2 !important;\n    -ms-flex-order: 1 !important;\n    order: 1 !important;\n  }\n\n  .order-lg-2 {\n    -webkit-box-ordinal-group: 3 !important;\n    -ms-flex-order: 2 !important;\n    order: 2 !important;\n  }\n\n  .order-lg-3 {\n    -webkit-box-ordinal-group: 4 !important;\n    -ms-flex-order: 3 !important;\n    order: 3 !important;\n  }\n\n  .order-lg-4 {\n    -webkit-box-ordinal-group: 5 !important;\n    -ms-flex-order: 4 !important;\n    order: 4 !important;\n  }\n\n  .order-lg-5 {\n    -webkit-box-ordinal-group: 6 !important;\n    -ms-flex-order: 5 !important;\n    order: 5 !important;\n  }\n\n  .order-lg-last {\n    -webkit-box-ordinal-group: 7 !important;\n    -ms-flex-order: 6 !important;\n    order: 6 !important;\n  }\n\n  .m-lg-6 {\n    margin: 3.5rem !important;\n  }\n\n  .m-lg-7 {\n    margin: 4rem !important;\n  }\n\n  .m-lg-8 {\n    margin: 4.5rem !important;\n  }\n\n  .m-lg-9 {\n    margin: 5rem !important;\n  }\n\n  .m-lg-auto {\n    margin: auto !important;\n  }\n\n  .mx-lg-6 {\n    margin-right: 3.5rem !important;\n    margin-left: 3.5rem !important;\n  }\n\n  .mx-lg-7 {\n    margin-right: 4rem !important;\n    margin-left: 4rem !important;\n  }\n\n  .mx-lg-8 {\n    margin-right: 4.5rem !important;\n    margin-left: 4.5rem !important;\n  }\n\n  .mx-lg-9 {\n    margin-right: 5rem !important;\n    margin-left: 5rem !important;\n  }\n\n  .mx-lg-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n\n  .my-lg-6 {\n    margin-top: 3.5rem !important;\n    margin-bottom: 3.5rem !important;\n  }\n\n  .my-lg-7 {\n    margin-top: 4rem !important;\n    margin-bottom: 4rem !important;\n  }\n\n  .my-lg-8 {\n    margin-top: 4.5rem !important;\n    margin-bottom: 4.5rem !important;\n  }\n\n  .my-lg-9 {\n    margin-top: 5rem !important;\n    margin-bottom: 5rem !important;\n  }\n\n  .my-lg-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n\n  .mt-lg-6 {\n    margin-top: 3.5rem !important;\n  }\n\n  .mt-lg-7 {\n    margin-top: 4rem !important;\n  }\n\n  .mt-lg-8 {\n    margin-top: 4.5rem !important;\n  }\n\n  .mt-lg-9 {\n    margin-top: 5rem !important;\n  }\n\n  .mt-lg-auto {\n    margin-top: auto !important;\n  }\n\n  .me-lg-6 {\n    margin-right: 3.5rem !important;\n  }\n\n  .me-lg-7 {\n    margin-right: 4rem !important;\n  }\n\n  .me-lg-8 {\n    margin-right: 4.5rem !important;\n  }\n\n  .me-lg-9 {\n    margin-right: 5rem !important;\n  }\n\n  .me-lg-auto {\n    margin-right: auto !important;\n  }\n\n  .mb-lg-6 {\n    margin-bottom: 3.5rem !important;\n  }\n\n  .mb-lg-7 {\n    margin-bottom: 4rem !important;\n  }\n\n  .mb-lg-8 {\n    margin-bottom: 4.5rem !important;\n  }\n\n  .mb-lg-9 {\n    margin-bottom: 5rem !important;\n  }\n\n  .mb-lg-auto {\n    margin-bottom: auto !important;\n  }\n\n  .ms-lg-6 {\n    margin-left: 3.5rem !important;\n  }\n\n  .ms-lg-7 {\n    margin-left: 4rem !important;\n  }\n\n  .ms-lg-8 {\n    margin-left: 4.5rem !important;\n  }\n\n  .ms-lg-9 {\n    margin-left: 5rem !important;\n  }\n\n  .ms-lg-auto {\n    margin-left: auto !important;\n  }\n\n  .p-lg-6 {\n    padding: 3.5rem !important;\n  }\n\n  .p-lg-7 {\n    padding: 4rem !important;\n  }\n\n  .p-lg-8 {\n    padding: 4.5rem !important;\n  }\n\n  .p-lg-9 {\n    padding: 5rem !important;\n  }\n\n  .px-lg-6 {\n    padding-right: 3.5rem !important;\n    padding-left: 3.5rem !important;\n  }\n\n  .px-lg-7 {\n    padding-right: 4rem !important;\n    padding-left: 4rem !important;\n  }\n\n  .px-lg-8 {\n    padding-right: 4.5rem !important;\n    padding-left: 4.5rem !important;\n  }\n\n  .px-lg-9 {\n    padding-right: 5rem !important;\n    padding-left: 5rem !important;\n  }\n\n  .py-lg-6 {\n    padding-top: 3.5rem !important;\n    padding-bottom: 3.5rem !important;\n  }\n\n  .py-lg-7 {\n    padding-top: 4rem !important;\n    padding-bottom: 4rem !important;\n  }\n\n  .py-lg-8 {\n    padding-top: 4.5rem !important;\n    padding-bottom: 4.5rem !important;\n  }\n\n  .py-lg-9 {\n    padding-top: 5rem !important;\n    padding-bottom: 5rem !important;\n  }\n\n  .pt-lg-6 {\n    padding-top: 3.5rem !important;\n  }\n\n  .pt-lg-7 {\n    padding-top: 4rem !important;\n  }\n\n  .pt-lg-8 {\n    padding-top: 4.5rem !important;\n  }\n\n  .pt-lg-9 {\n    padding-top: 5rem !important;\n  }\n\n  .pe-lg-6 {\n    padding-right: 3.5rem !important;\n  }\n\n  .pe-lg-7 {\n    padding-right: 4rem !important;\n  }\n\n  .pe-lg-8 {\n    padding-right: 4.5rem !important;\n  }\n\n  .pe-lg-9 {\n    padding-right: 5rem !important;\n  }\n\n  .pb-lg-6 {\n    padding-bottom: 3.5rem !important;\n  }\n\n  .pb-lg-7 {\n    padding-bottom: 4rem !important;\n  }\n\n  .pb-lg-8 {\n    padding-bottom: 4.5rem !important;\n  }\n\n  .pb-lg-9 {\n    padding-bottom: 5rem !important;\n  }\n\n  .ps-lg-6 {\n    padding-left: 3.5rem !important;\n  }\n\n  .ps-lg-7 {\n    padding-left: 4rem !important;\n  }\n\n  .ps-lg-8 {\n    padding-left: 4.5rem !important;\n  }\n\n  .ps-lg-9 {\n    padding-left: 5rem !important;\n  }\n\n  .text-lg-start {\n    text-align: left !important;\n  }\n\n  .text-lg-end {\n    text-align: right !important;\n  }\n\n  .text-lg-center {\n    text-align: center !important;\n  }\n}\n\n@media (min-width: 1200px) {\n  .float-xl-start {\n    float: left !important;\n  }\n\n  .float-xl-end {\n    float: right !important;\n  }\n\n  .float-xl-none {\n    float: none !important;\n  }\n\n  .d-xl-inline {\n    display: inline !important;\n  }\n\n  .d-xl-inline-block {\n    display: inline-block !important;\n  }\n\n  .d-xl-block {\n    display: block !important;\n  }\n\n  .d-xl-grid {\n    display: -ms-grid !important;\n    display: grid !important;\n  }\n\n  .d-xl-table {\n    display: table !important;\n  }\n\n  .d-xl-table-row {\n    display: table-row !important;\n  }\n\n  .d-xl-table-cell {\n    display: table-cell !important;\n  }\n\n  .d-xl-flex {\n    display: -webkit-box !important;\n    display: -ms-flexbox !important;\n    display: flex !important;\n  }\n\n  .d-xl-inline-flex {\n    display: -webkit-inline-box !important;\n    display: -ms-inline-flexbox !important;\n    display: inline-flex !important;\n  }\n\n  .d-xl-none {\n    display: none !important;\n  }\n\n  .flex-xl-fill {\n    -webkit-box-flex: 1 !important;\n    -ms-flex: 1 1 auto !important;\n    flex: 1 1 auto !important;\n  }\n\n  .flex-xl-row {\n    -webkit-box-orient: horizontal !important;\n    -webkit-box-direction: normal !important;\n    -ms-flex-direction: row !important;\n    flex-direction: row !important;\n  }\n\n  .flex-xl-column {\n    -webkit-box-orient: vertical !important;\n    -webkit-box-direction: normal !important;\n    -ms-flex-direction: column !important;\n    flex-direction: column !important;\n  }\n\n  .flex-xl-row-reverse {\n    -webkit-box-orient: horizontal !important;\n    -webkit-box-direction: reverse !important;\n    -ms-flex-direction: row-reverse !important;\n    flex-direction: row-reverse !important;\n  }\n\n  .flex-xl-column-reverse {\n    -webkit-box-orient: vertical !important;\n    -webkit-box-direction: reverse !important;\n    -ms-flex-direction: column-reverse !important;\n    flex-direction: column-reverse !important;\n  }\n\n  .flex-xl-grow-0 {\n    -webkit-box-flex: 0 !important;\n    -ms-flex-positive: 0 !important;\n    flex-grow: 0 !important;\n  }\n\n  .flex-xl-grow-1 {\n    -webkit-box-flex: 1 !important;\n    -ms-flex-positive: 1 !important;\n    flex-grow: 1 !important;\n  }\n\n  .flex-xl-shrink-0 {\n    -ms-flex-negative: 0 !important;\n    flex-shrink: 0 !important;\n  }\n\n  .flex-xl-shrink-1 {\n    -ms-flex-negative: 1 !important;\n    flex-shrink: 1 !important;\n  }\n\n  .flex-xl-wrap {\n    -ms-flex-wrap: wrap !important;\n    flex-wrap: wrap !important;\n  }\n\n  .flex-xl-nowrap {\n    -ms-flex-wrap: nowrap !important;\n    flex-wrap: nowrap !important;\n  }\n\n  .flex-xl-wrap-reverse {\n    -ms-flex-wrap: wrap-reverse !important;\n    flex-wrap: wrap-reverse !important;\n  }\n\n  .gap-xl-6 {\n    gap: 3.5rem !important;\n  }\n\n  .gap-xl-7 {\n    gap: 4rem !important;\n  }\n\n  .gap-xl-8 {\n    gap: 4.5rem !important;\n  }\n\n  .gap-xl-9 {\n    gap: 5rem !important;\n  }\n\n  .justify-content-xl-start {\n    -webkit-box-pack: start !important;\n    -ms-flex-pack: start !important;\n    justify-content: flex-start !important;\n  }\n\n  .justify-content-xl-end {\n    -webkit-box-pack: end !important;\n    -ms-flex-pack: end !important;\n    justify-content: flex-end !important;\n  }\n\n  .justify-content-xl-center {\n    -webkit-box-pack: center !important;\n    -ms-flex-pack: center !important;\n    justify-content: center !important;\n  }\n\n  .justify-content-xl-between {\n    -webkit-box-pack: justify !important;\n    -ms-flex-pack: justify !important;\n    justify-content: space-between !important;\n  }\n\n  .justify-content-xl-around {\n    -ms-flex-pack: distribute !important;\n    justify-content: space-around !important;\n  }\n\n  .justify-content-xl-evenly {\n    -webkit-box-pack: space-evenly !important;\n    -ms-flex-pack: space-evenly !important;\n    justify-content: space-evenly !important;\n  }\n\n  .align-items-xl-start {\n    -webkit-box-align: start !important;\n    -ms-flex-align: start !important;\n    align-items: flex-start !important;\n  }\n\n  .align-items-xl-end {\n    -webkit-box-align: end !important;\n    -ms-flex-align: end !important;\n    align-items: flex-end !important;\n  }\n\n  .align-items-xl-center {\n    -webkit-box-align: center !important;\n    -ms-flex-align: center !important;\n    align-items: center !important;\n  }\n\n  .align-items-xl-baseline {\n    -webkit-box-align: baseline !important;\n    -ms-flex-align: baseline !important;\n    align-items: baseline !important;\n  }\n\n  .align-items-xl-stretch {\n    -webkit-box-align: stretch !important;\n    -ms-flex-align: stretch !important;\n    align-items: stretch !important;\n  }\n\n  .align-content-xl-start {\n    -ms-flex-line-pack: start !important;\n    align-content: flex-start !important;\n  }\n\n  .align-content-xl-end {\n    -ms-flex-line-pack: end !important;\n    align-content: flex-end !important;\n  }\n\n  .align-content-xl-center {\n    -ms-flex-line-pack: center !important;\n    align-content: center !important;\n  }\n\n  .align-content-xl-between {\n    -ms-flex-line-pack: justify !important;\n    align-content: space-between !important;\n  }\n\n  .align-content-xl-around {\n    -ms-flex-line-pack: distribute !important;\n    align-content: space-around !important;\n  }\n\n  .align-content-xl-stretch {\n    -ms-flex-line-pack: stretch !important;\n    align-content: stretch !important;\n  }\n\n  .align-self-xl-auto {\n    -ms-flex-item-align: auto !important;\n    -ms-grid-row-align: auto !important;\n    align-self: auto !important;\n  }\n\n  .align-self-xl-start {\n    -ms-flex-item-align: start !important;\n    align-self: flex-start !important;\n  }\n\n  .align-self-xl-end {\n    -ms-flex-item-align: end !important;\n    align-self: flex-end !important;\n  }\n\n  .align-self-xl-center {\n    -ms-flex-item-align: center !important;\n    -ms-grid-row-align: center !important;\n    align-self: center !important;\n  }\n\n  .align-self-xl-baseline {\n    -ms-flex-item-align: baseline !important;\n    align-self: baseline !important;\n  }\n\n  .align-self-xl-stretch {\n    -ms-flex-item-align: stretch !important;\n    -ms-grid-row-align: stretch !important;\n    align-self: stretch !important;\n  }\n\n  .order-xl-first {\n    -webkit-box-ordinal-group: 0 !important;\n    -ms-flex-order: -1 !important;\n    order: -1 !important;\n  }\n\n  .order-xl-0 {\n    -webkit-box-ordinal-group: 1 !important;\n    -ms-flex-order: 0 !important;\n    order: 0 !important;\n  }\n\n  .order-xl-1 {\n    -webkit-box-ordinal-group: 2 !important;\n    -ms-flex-order: 1 !important;\n    order: 1 !important;\n  }\n\n  .order-xl-2 {\n    -webkit-box-ordinal-group: 3 !important;\n    -ms-flex-order: 2 !important;\n    order: 2 !important;\n  }\n\n  .order-xl-3 {\n    -webkit-box-ordinal-group: 4 !important;\n    -ms-flex-order: 3 !important;\n    order: 3 !important;\n  }\n\n  .order-xl-4 {\n    -webkit-box-ordinal-group: 5 !important;\n    -ms-flex-order: 4 !important;\n    order: 4 !important;\n  }\n\n  .order-xl-5 {\n    -webkit-box-ordinal-group: 6 !important;\n    -ms-flex-order: 5 !important;\n    order: 5 !important;\n  }\n\n  .order-xl-last {\n    -webkit-box-ordinal-group: 7 !important;\n    -ms-flex-order: 6 !important;\n    order: 6 !important;\n  }\n\n  .m-xl-6 {\n    margin: 3.5rem !important;\n  }\n\n  .m-xl-7 {\n    margin: 4rem !important;\n  }\n\n  .m-xl-8 {\n    margin: 4.5rem !important;\n  }\n\n  .m-xl-9 {\n    margin: 5rem !important;\n  }\n\n  .m-xl-auto {\n    margin: auto !important;\n  }\n\n  .mx-xl-6 {\n    margin-right: 3.5rem !important;\n    margin-left: 3.5rem !important;\n  }\n\n  .mx-xl-7 {\n    margin-right: 4rem !important;\n    margin-left: 4rem !important;\n  }\n\n  .mx-xl-8 {\n    margin-right: 4.5rem !important;\n    margin-left: 4.5rem !important;\n  }\n\n  .mx-xl-9 {\n    margin-right: 5rem !important;\n    margin-left: 5rem !important;\n  }\n\n  .mx-xl-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n\n  .my-xl-6 {\n    margin-top: 3.5rem !important;\n    margin-bottom: 3.5rem !important;\n  }\n\n  .my-xl-7 {\n    margin-top: 4rem !important;\n    margin-bottom: 4rem !important;\n  }\n\n  .my-xl-8 {\n    margin-top: 4.5rem !important;\n    margin-bottom: 4.5rem !important;\n  }\n\n  .my-xl-9 {\n    margin-top: 5rem !important;\n    margin-bottom: 5rem !important;\n  }\n\n  .my-xl-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n\n  .mt-xl-6 {\n    margin-top: 3.5rem !important;\n  }\n\n  .mt-xl-7 {\n    margin-top: 4rem !important;\n  }\n\n  .mt-xl-8 {\n    margin-top: 4.5rem !important;\n  }\n\n  .mt-xl-9 {\n    margin-top: 5rem !important;\n  }\n\n  .mt-xl-auto {\n    margin-top: auto !important;\n  }\n\n  .me-xl-6 {\n    margin-right: 3.5rem !important;\n  }\n\n  .me-xl-7 {\n    margin-right: 4rem !important;\n  }\n\n  .me-xl-8 {\n    margin-right: 4.5rem !important;\n  }\n\n  .me-xl-9 {\n    margin-right: 5rem !important;\n  }\n\n  .me-xl-auto {\n    margin-right: auto !important;\n  }\n\n  .mb-xl-6 {\n    margin-bottom: 3.5rem !important;\n  }\n\n  .mb-xl-7 {\n    margin-bottom: 4rem !important;\n  }\n\n  .mb-xl-8 {\n    margin-bottom: 4.5rem !important;\n  }\n\n  .mb-xl-9 {\n    margin-bottom: 5rem !important;\n  }\n\n  .mb-xl-auto {\n    margin-bottom: auto !important;\n  }\n\n  .ms-xl-6 {\n    margin-left: 3.5rem !important;\n  }\n\n  .ms-xl-7 {\n    margin-left: 4rem !important;\n  }\n\n  .ms-xl-8 {\n    margin-left: 4.5rem !important;\n  }\n\n  .ms-xl-9 {\n    margin-left: 5rem !important;\n  }\n\n  .ms-xl-auto {\n    margin-left: auto !important;\n  }\n\n  .p-xl-6 {\n    padding: 3.5rem !important;\n  }\n\n  .p-xl-7 {\n    padding: 4rem !important;\n  }\n\n  .p-xl-8 {\n    padding: 4.5rem !important;\n  }\n\n  .p-xl-9 {\n    padding: 5rem !important;\n  }\n\n  .px-xl-6 {\n    padding-right: 3.5rem !important;\n    padding-left: 3.5rem !important;\n  }\n\n  .px-xl-7 {\n    padding-right: 4rem !important;\n    padding-left: 4rem !important;\n  }\n\n  .px-xl-8 {\n    padding-right: 4.5rem !important;\n    padding-left: 4.5rem !important;\n  }\n\n  .px-xl-9 {\n    padding-right: 5rem !important;\n    padding-left: 5rem !important;\n  }\n\n  .py-xl-6 {\n    padding-top: 3.5rem !important;\n    padding-bottom: 3.5rem !important;\n  }\n\n  .py-xl-7 {\n    padding-top: 4rem !important;\n    padding-bottom: 4rem !important;\n  }\n\n  .py-xl-8 {\n    padding-top: 4.5rem !important;\n    padding-bottom: 4.5rem !important;\n  }\n\n  .py-xl-9 {\n    padding-top: 5rem !important;\n    padding-bottom: 5rem !important;\n  }\n\n  .pt-xl-6 {\n    padding-top: 3.5rem !important;\n  }\n\n  .pt-xl-7 {\n    padding-top: 4rem !important;\n  }\n\n  .pt-xl-8 {\n    padding-top: 4.5rem !important;\n  }\n\n  .pt-xl-9 {\n    padding-top: 5rem !important;\n  }\n\n  .pe-xl-6 {\n    padding-right: 3.5rem !important;\n  }\n\n  .pe-xl-7 {\n    padding-right: 4rem !important;\n  }\n\n  .pe-xl-8 {\n    padding-right: 4.5rem !important;\n  }\n\n  .pe-xl-9 {\n    padding-right: 5rem !important;\n  }\n\n  .pb-xl-6 {\n    padding-bottom: 3.5rem !important;\n  }\n\n  .pb-xl-7 {\n    padding-bottom: 4rem !important;\n  }\n\n  .pb-xl-8 {\n    padding-bottom: 4.5rem !important;\n  }\n\n  .pb-xl-9 {\n    padding-bottom: 5rem !important;\n  }\n\n  .ps-xl-6 {\n    padding-left: 3.5rem !important;\n  }\n\n  .ps-xl-7 {\n    padding-left: 4rem !important;\n  }\n\n  .ps-xl-8 {\n    padding-left: 4.5rem !important;\n  }\n\n  .ps-xl-9 {\n    padding-left: 5rem !important;\n  }\n\n  .text-xl-start {\n    text-align: left !important;\n  }\n\n  .text-xl-end {\n    text-align: right !important;\n  }\n\n  .text-xl-center {\n    text-align: center !important;\n  }\n}\n\n@media (min-width: 1500px) {\n  .float-xxl-start {\n    float: left !important;\n  }\n\n  .float-xxl-end {\n    float: right !important;\n  }\n\n  .float-xxl-none {\n    float: none !important;\n  }\n\n  .d-xxl-inline {\n    display: inline !important;\n  }\n\n  .d-xxl-inline-block {\n    display: inline-block !important;\n  }\n\n  .d-xxl-block {\n    display: block !important;\n  }\n\n  .d-xxl-grid {\n    display: -ms-grid !important;\n    display: grid !important;\n  }\n\n  .d-xxl-table {\n    display: table !important;\n  }\n\n  .d-xxl-table-row {\n    display: table-row !important;\n  }\n\n  .d-xxl-table-cell {\n    display: table-cell !important;\n  }\n\n  .d-xxl-flex {\n    display: -webkit-box !important;\n    display: -ms-flexbox !important;\n    display: flex !important;\n  }\n\n  .d-xxl-inline-flex {\n    display: -webkit-inline-box !important;\n    display: -ms-inline-flexbox !important;\n    display: inline-flex !important;\n  }\n\n  .d-xxl-none {\n    display: none !important;\n  }\n\n  .flex-xxl-fill {\n    -webkit-box-flex: 1 !important;\n    -ms-flex: 1 1 auto !important;\n    flex: 1 1 auto !important;\n  }\n\n  .flex-xxl-row {\n    -webkit-box-orient: horizontal !important;\n    -webkit-box-direction: normal !important;\n    -ms-flex-direction: row !important;\n    flex-direction: row !important;\n  }\n\n  .flex-xxl-column {\n    -webkit-box-orient: vertical !important;\n    -webkit-box-direction: normal !important;\n    -ms-flex-direction: column !important;\n    flex-direction: column !important;\n  }\n\n  .flex-xxl-row-reverse {\n    -webkit-box-orient: horizontal !important;\n    -webkit-box-direction: reverse !important;\n    -ms-flex-direction: row-reverse !important;\n    flex-direction: row-reverse !important;\n  }\n\n  .flex-xxl-column-reverse {\n    -webkit-box-orient: vertical !important;\n    -webkit-box-direction: reverse !important;\n    -ms-flex-direction: column-reverse !important;\n    flex-direction: column-reverse !important;\n  }\n\n  .flex-xxl-grow-0 {\n    -webkit-box-flex: 0 !important;\n    -ms-flex-positive: 0 !important;\n    flex-grow: 0 !important;\n  }\n\n  .flex-xxl-grow-1 {\n    -webkit-box-flex: 1 !important;\n    -ms-flex-positive: 1 !important;\n    flex-grow: 1 !important;\n  }\n\n  .flex-xxl-shrink-0 {\n    -ms-flex-negative: 0 !important;\n    flex-shrink: 0 !important;\n  }\n\n  .flex-xxl-shrink-1 {\n    -ms-flex-negative: 1 !important;\n    flex-shrink: 1 !important;\n  }\n\n  .flex-xxl-wrap {\n    -ms-flex-wrap: wrap !important;\n    flex-wrap: wrap !important;\n  }\n\n  .flex-xxl-nowrap {\n    -ms-flex-wrap: nowrap !important;\n    flex-wrap: nowrap !important;\n  }\n\n  .flex-xxl-wrap-reverse {\n    -ms-flex-wrap: wrap-reverse !important;\n    flex-wrap: wrap-reverse !important;\n  }\n\n  .gap-xxl-6 {\n    gap: 3.5rem !important;\n  }\n\n  .gap-xxl-7 {\n    gap: 4rem !important;\n  }\n\n  .gap-xxl-8 {\n    gap: 4.5rem !important;\n  }\n\n  .gap-xxl-9 {\n    gap: 5rem !important;\n  }\n\n  .justify-content-xxl-start {\n    -webkit-box-pack: start !important;\n    -ms-flex-pack: start !important;\n    justify-content: flex-start !important;\n  }\n\n  .justify-content-xxl-end {\n    -webkit-box-pack: end !important;\n    -ms-flex-pack: end !important;\n    justify-content: flex-end !important;\n  }\n\n  .justify-content-xxl-center {\n    -webkit-box-pack: center !important;\n    -ms-flex-pack: center !important;\n    justify-content: center !important;\n  }\n\n  .justify-content-xxl-between {\n    -webkit-box-pack: justify !important;\n    -ms-flex-pack: justify !important;\n    justify-content: space-between !important;\n  }\n\n  .justify-content-xxl-around {\n    -ms-flex-pack: distribute !important;\n    justify-content: space-around !important;\n  }\n\n  .justify-content-xxl-evenly {\n    -webkit-box-pack: space-evenly !important;\n    -ms-flex-pack: space-evenly !important;\n    justify-content: space-evenly !important;\n  }\n\n  .align-items-xxl-start {\n    -webkit-box-align: start !important;\n    -ms-flex-align: start !important;\n    align-items: flex-start !important;\n  }\n\n  .align-items-xxl-end {\n    -webkit-box-align: end !important;\n    -ms-flex-align: end !important;\n    align-items: flex-end !important;\n  }\n\n  .align-items-xxl-center {\n    -webkit-box-align: center !important;\n    -ms-flex-align: center !important;\n    align-items: center !important;\n  }\n\n  .align-items-xxl-baseline {\n    -webkit-box-align: baseline !important;\n    -ms-flex-align: baseline !important;\n    align-items: baseline !important;\n  }\n\n  .align-items-xxl-stretch {\n    -webkit-box-align: stretch !important;\n    -ms-flex-align: stretch !important;\n    align-items: stretch !important;\n  }\n\n  .align-content-xxl-start {\n    -ms-flex-line-pack: start !important;\n    align-content: flex-start !important;\n  }\n\n  .align-content-xxl-end {\n    -ms-flex-line-pack: end !important;\n    align-content: flex-end !important;\n  }\n\n  .align-content-xxl-center {\n    -ms-flex-line-pack: center !important;\n    align-content: center !important;\n  }\n\n  .align-content-xxl-between {\n    -ms-flex-line-pack: justify !important;\n    align-content: space-between !important;\n  }\n\n  .align-content-xxl-around {\n    -ms-flex-line-pack: distribute !important;\n    align-content: space-around !important;\n  }\n\n  .align-content-xxl-stretch {\n    -ms-flex-line-pack: stretch !important;\n    align-content: stretch !important;\n  }\n\n  .align-self-xxl-auto {\n    -ms-flex-item-align: auto !important;\n    -ms-grid-row-align: auto !important;\n    align-self: auto !important;\n  }\n\n  .align-self-xxl-start {\n    -ms-flex-item-align: start !important;\n    align-self: flex-start !important;\n  }\n\n  .align-self-xxl-end {\n    -ms-flex-item-align: end !important;\n    align-self: flex-end !important;\n  }\n\n  .align-self-xxl-center {\n    -ms-flex-item-align: center !important;\n    -ms-grid-row-align: center !important;\n    align-self: center !important;\n  }\n\n  .align-self-xxl-baseline {\n    -ms-flex-item-align: baseline !important;\n    align-self: baseline !important;\n  }\n\n  .align-self-xxl-stretch {\n    -ms-flex-item-align: stretch !important;\n    -ms-grid-row-align: stretch !important;\n    align-self: stretch !important;\n  }\n\n  .order-xxl-first {\n    -webkit-box-ordinal-group: 0 !important;\n    -ms-flex-order: -1 !important;\n    order: -1 !important;\n  }\n\n  .order-xxl-0 {\n    -webkit-box-ordinal-group: 1 !important;\n    -ms-flex-order: 0 !important;\n    order: 0 !important;\n  }\n\n  .order-xxl-1 {\n    -webkit-box-ordinal-group: 2 !important;\n    -ms-flex-order: 1 !important;\n    order: 1 !important;\n  }\n\n  .order-xxl-2 {\n    -webkit-box-ordinal-group: 3 !important;\n    -ms-flex-order: 2 !important;\n    order: 2 !important;\n  }\n\n  .order-xxl-3 {\n    -webkit-box-ordinal-group: 4 !important;\n    -ms-flex-order: 3 !important;\n    order: 3 !important;\n  }\n\n  .order-xxl-4 {\n    -webkit-box-ordinal-group: 5 !important;\n    -ms-flex-order: 4 !important;\n    order: 4 !important;\n  }\n\n  .order-xxl-5 {\n    -webkit-box-ordinal-group: 6 !important;\n    -ms-flex-order: 5 !important;\n    order: 5 !important;\n  }\n\n  .order-xxl-last {\n    -webkit-box-ordinal-group: 7 !important;\n    -ms-flex-order: 6 !important;\n    order: 6 !important;\n  }\n\n  .m-xxl-6 {\n    margin: 3.5rem !important;\n  }\n\n  .m-xxl-7 {\n    margin: 4rem !important;\n  }\n\n  .m-xxl-8 {\n    margin: 4.5rem !important;\n  }\n\n  .m-xxl-9 {\n    margin: 5rem !important;\n  }\n\n  .m-xxl-auto {\n    margin: auto !important;\n  }\n\n  .mx-xxl-6 {\n    margin-right: 3.5rem !important;\n    margin-left: 3.5rem !important;\n  }\n\n  .mx-xxl-7 {\n    margin-right: 4rem !important;\n    margin-left: 4rem !important;\n  }\n\n  .mx-xxl-8 {\n    margin-right: 4.5rem !important;\n    margin-left: 4.5rem !important;\n  }\n\n  .mx-xxl-9 {\n    margin-right: 5rem !important;\n    margin-left: 5rem !important;\n  }\n\n  .mx-xxl-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n\n  .my-xxl-6 {\n    margin-top: 3.5rem !important;\n    margin-bottom: 3.5rem !important;\n  }\n\n  .my-xxl-7 {\n    margin-top: 4rem !important;\n    margin-bottom: 4rem !important;\n  }\n\n  .my-xxl-8 {\n    margin-top: 4.5rem !important;\n    margin-bottom: 4.5rem !important;\n  }\n\n  .my-xxl-9 {\n    margin-top: 5rem !important;\n    margin-bottom: 5rem !important;\n  }\n\n  .my-xxl-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n\n  .mt-xxl-6 {\n    margin-top: 3.5rem !important;\n  }\n\n  .mt-xxl-7 {\n    margin-top: 4rem !important;\n  }\n\n  .mt-xxl-8 {\n    margin-top: 4.5rem !important;\n  }\n\n  .mt-xxl-9 {\n    margin-top: 5rem !important;\n  }\n\n  .mt-xxl-auto {\n    margin-top: auto !important;\n  }\n\n  .me-xxl-6 {\n    margin-right: 3.5rem !important;\n  }\n\n  .me-xxl-7 {\n    margin-right: 4rem !important;\n  }\n\n  .me-xxl-8 {\n    margin-right: 4.5rem !important;\n  }\n\n  .me-xxl-9 {\n    margin-right: 5rem !important;\n  }\n\n  .me-xxl-auto {\n    margin-right: auto !important;\n  }\n\n  .mb-xxl-6 {\n    margin-bottom: 3.5rem !important;\n  }\n\n  .mb-xxl-7 {\n    margin-bottom: 4rem !important;\n  }\n\n  .mb-xxl-8 {\n    margin-bottom: 4.5rem !important;\n  }\n\n  .mb-xxl-9 {\n    margin-bottom: 5rem !important;\n  }\n\n  .mb-xxl-auto {\n    margin-bottom: auto !important;\n  }\n\n  .ms-xxl-6 {\n    margin-left: 3.5rem !important;\n  }\n\n  .ms-xxl-7 {\n    margin-left: 4rem !important;\n  }\n\n  .ms-xxl-8 {\n    margin-left: 4.5rem !important;\n  }\n\n  .ms-xxl-9 {\n    margin-left: 5rem !important;\n  }\n\n  .ms-xxl-auto {\n    margin-left: auto !important;\n  }\n\n  .p-xxl-6 {\n    padding: 3.5rem !important;\n  }\n\n  .p-xxl-7 {\n    padding: 4rem !important;\n  }\n\n  .p-xxl-8 {\n    padding: 4.5rem !important;\n  }\n\n  .p-xxl-9 {\n    padding: 5rem !important;\n  }\n\n  .px-xxl-6 {\n    padding-right: 3.5rem !important;\n    padding-left: 3.5rem !important;\n  }\n\n  .px-xxl-7 {\n    padding-right: 4rem !important;\n    padding-left: 4rem !important;\n  }\n\n  .px-xxl-8 {\n    padding-right: 4.5rem !important;\n    padding-left: 4.5rem !important;\n  }\n\n  .px-xxl-9 {\n    padding-right: 5rem !important;\n    padding-left: 5rem !important;\n  }\n\n  .py-xxl-6 {\n    padding-top: 3.5rem !important;\n    padding-bottom: 3.5rem !important;\n  }\n\n  .py-xxl-7 {\n    padding-top: 4rem !important;\n    padding-bottom: 4rem !important;\n  }\n\n  .py-xxl-8 {\n    padding-top: 4.5rem !important;\n    padding-bottom: 4.5rem !important;\n  }\n\n  .py-xxl-9 {\n    padding-top: 5rem !important;\n    padding-bottom: 5rem !important;\n  }\n\n  .pt-xxl-6 {\n    padding-top: 3.5rem !important;\n  }\n\n  .pt-xxl-7 {\n    padding-top: 4rem !important;\n  }\n\n  .pt-xxl-8 {\n    padding-top: 4.5rem !important;\n  }\n\n  .pt-xxl-9 {\n    padding-top: 5rem !important;\n  }\n\n  .pe-xxl-6 {\n    padding-right: 3.5rem !important;\n  }\n\n  .pe-xxl-7 {\n    padding-right: 4rem !important;\n  }\n\n  .pe-xxl-8 {\n    padding-right: 4.5rem !important;\n  }\n\n  .pe-xxl-9 {\n    padding-right: 5rem !important;\n  }\n\n  .pb-xxl-6 {\n    padding-bottom: 3.5rem !important;\n  }\n\n  .pb-xxl-7 {\n    padding-bottom: 4rem !important;\n  }\n\n  .pb-xxl-8 {\n    padding-bottom: 4.5rem !important;\n  }\n\n  .pb-xxl-9 {\n    padding-bottom: 5rem !important;\n  }\n\n  .ps-xxl-6 {\n    padding-left: 3.5rem !important;\n  }\n\n  .ps-xxl-7 {\n    padding-left: 4rem !important;\n  }\n\n  .ps-xxl-8 {\n    padding-left: 4.5rem !important;\n  }\n\n  .ps-xxl-9 {\n    padding-left: 5rem !important;\n  }\n\n  .text-xxl-start {\n    text-align: left !important;\n  }\n\n  .text-xxl-end {\n    text-align: right !important;\n  }\n\n  .text-xxl-center {\n    text-align: center !important;\n  }\n}\n\n@media (min-width: 1200px) {\n  .fs-1 {\n    font-size: 2.5025rem !important;\n  }\n\n  .fs-2 {\n    font-size: 1.999375rem !important;\n  }\n\n  .fs-3 {\n    font-size: 1.49625rem !important;\n  }\n\n  .fs-4 {\n    font-size: 1.25125rem !important;\n  }\n}\n\n@media print {\n  .d-print-inline {\n    display: inline !important;\n  }\n\n  .d-print-inline-block {\n    display: inline-block !important;\n  }\n\n  .d-print-block {\n    display: block !important;\n  }\n\n  .d-print-grid {\n    display: -ms-grid !important;\n    display: grid !important;\n  }\n\n  .d-print-table {\n    display: table !important;\n  }\n\n  .d-print-table-row {\n    display: table-row !important;\n  }\n\n  .d-print-table-cell {\n    display: table-cell !important;\n  }\n\n  .d-print-flex {\n    display: -webkit-box !important;\n    display: -ms-flexbox !important;\n    display: flex !important;\n  }\n\n  .d-print-inline-flex {\n    display: -webkit-inline-box !important;\n    display: -ms-inline-flexbox !important;\n    display: inline-flex !important;\n  }\n\n  .d-print-none {\n    display: none !important;\n  }\n}\n\n.ec-cat-form h4,\n.ec-cat-form .h4 {\n  border-bottom: 1px solid var(--border-color);\n  padding-bottom: 20px;\n  margin-bottom: 15px;\n}\n\n@media (max-width: 1199.98px) {\n\n  .ec-cat-form h4,\n  .ec-cat-form .h4 {\n    font-size: 18px;\n  }\n}\n\n.ec-cat-form form label {\n  width: 100%;\n  font-weight: 500;\n  color: var(--bs-body-color);\n}\n\n.ec-cat-form form label span {\n  font-size: 13px;\n  color: #999;\n  font-weight: 300;\n  text-transform: none;\n}\n\n.ec-cat-form form input {\n  width: 100%;\n  padding: 0 15px;\n  border-radius: 0;\n  border: 1px solid #eeeeee !important;\n  background-color: transparent;\n  color: #777;\n  line-height: 3;\n  border-radius: 15px;\n}\n\n.ec-cat-form form textarea {\n  width: 100%;\n  padding: 0 15px;\n  border-radius: 0;\n  border: 1px solid #eeeeee !important;\n  background-color: transparent;\n  color: #777;\n  padding: 15px;\n  border-radius: 15px;\n}\n\n.ec-cat-form form select {\n  width: 100%;\n  height: 45px;\n  margin: 0;\n  padding: 0 15px;\n  border-radius: 0;\n  border: 1px solid #eeeeee !important;\n  background-color: transparent;\n  color: #777;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  outline: none;\n  border-radius: 15px;\n}\n\n.ec-cat-form form input[type=text] {\n  height: 45px;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  outline: none;\n  border-radius: 15px;\n}\n\n.ec-cat-form form small,\n.ec-cat-form form .small {\n  margin-top: 10px;\n  display: block;\n}\n\n.ec-cat-form form input[type=color] {\n  width: 25px !important;\n  height: 25px !important;\n  padding: 0;\n  border-radius: 15px;\n  border-radius: 0 !important;\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  margin: 4px;\n  min-height: 25px;\n}\n\n.ec-cat-form form input[type=color] i {\n  border-radius: 0;\n}\n\n.ec-cat-form form .form-checkbox-box {\n  height: 30px;\n  margin-top: 5px;\n  display: inline-block;\n}\n\n.ec-cat-form form .form-check {\n  height: 20px;\n  margin: 0 5px 0 0;\n  padding: 0;\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.ec-cat-form form .form-check input {\n  width: 35px !important;\n  height: 100% !important;\n  margin: 0;\n}\n\n.ec-cat-form form .form-check label {\n  margin: 5px 5px 2px 7px;\n  line-height: 11px;\n  color: #999;\n}\n\n.ec-cat-form .bootstrap-tagsinput {\n  width: 100%;\n  margin-bottom: 15px;\n  background-color: transparent;\n  border: 1px solid #eeeeee;\n  display: inline-block;\n  padding: 5px 10px;\n  color: #555;\n  vertical-align: middle;\n  border-radius: 15px;\n  line-height: 22px;\n  cursor: text;\n}\n\n.ec-cat-form .bootstrap-tagsinput input {\n  height: 40px;\n  border: none !important;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  outline: none;\n  background-color: transparent;\n  padding: 0 5px;\n  margin: 0;\n  width: auto;\n  max-width: inherit;\n}\n\n.ec-cat-form .bootstrap-tagsinput input:focus {\n  border: none;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.ec-cat-form .bootstrap-tagsinput input::-webkit-input-placeholder {\n  color: #999;\n  opacity: 1;\n}\n\n.ec-cat-form .bootstrap-tagsinput input::-moz-placeholder {\n  color: #999;\n  opacity: 1;\n}\n\n.ec-cat-form .bootstrap-tagsinput input:-ms-input-placeholder {\n  color: #999;\n  opacity: 1;\n  color: #999;\n}\n\n.ec-cat-form .bootstrap-tagsinput input::-ms-input-placeholder {\n  color: #999;\n  opacity: 1;\n  color: #999;\n}\n\n.ec-cat-form .bootstrap-tagsinput input::placeholder {\n  color: #999;\n  opacity: 1;\n}\n\n.ec-cat-form .bootstrap-tagsinput .tag {\n  margin-right: 2px;\n  color: #777;\n}\n\n.ec-cat-form .bootstrap-tagsinput .tag [data-role=remove] {\n  margin-left: 8px;\n  cursor: pointer;\n  color: #f96e6e;\n}\n\n.ec-cat-form .bootstrap-tagsinput .tag [data-role=remove]:after {\n  content: \"×\";\n  padding: 0px 2px;\n}\n\n.ec-cat-form .bootstrap-tagsinput .tag [data-role=remove]:hover {\n  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.2), 0 1px 2px rgba(0, 0, 0, 0.05);\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.2), 0 1px 2px rgba(0, 0, 0, 0.05);\n}\n\n.ec-cat-form .bootstrap-tagsinput .tag [data-role=remove]:hover:active {\n  -webkit-box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n}\n\n.ec-cat-form .bootstrap-tagsinput.form-control input::-moz-placeholder {\n  color: #777;\n  opacity: 1;\n}\n\n.ec-cat-form .bootstrap-tagsinput.form-control input:-ms-input-placeholder {\n  color: #777;\n}\n\n.ec-cat-form .bootstrap-tagsinput.form-control input::-webkit-input-placeholder {\n  color: #777;\n}\n\n.ec-cat-list .cat-thumb {\n  width: 45px;\n  height: 45px;\n  border-radius: 15px;\n}\n\n.ec-cat-list table tbody tr td {\n  max-width: 300px;\n}\n\n.ec-cat-list table tbody tr td .ec-sub-cat-count {\n  margin: 2px 0 2px 5px;\n  background-color: var(--admin-color);\n  padding: 2px 7px;\n  color: #fff;\n  border-radius: 10px;\n  display: inline-block;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: row;\n  flex-direction: row;\n}\n\n.ec-cat-list table tbody tr td .ec-sub-cat-tag {\n  margin: 3px 0 3px 5px;\n  background-color: #f9f9f9;\n  padding: 2px 7px;\n  border-radius: 10px;\n  text-transform: capitalize;\n  display: inline-block;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  font-size: 12px;\n  letter-spacing: 0.02rem;\n}\n\n/*===== ERROR =====*/\n.error-wrapper {\n  padding-top: 30px;\n  padding-bottom: 30px;\n  border-radius: 15px;\n}\n\n.error-wrapper .error-title {\n  font-size: 140px;\n  line-height: 120px;\n  font-weight: 600;\n}\n\n@media (max-width: 991.98px) {\n  .error-wrapper .error-title {\n    font-size: 100px;\n    line-height: 80px;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .error-wrapper .error-title {\n    font-size: 70px;\n    line-height: 50px;\n  }\n}\n\n@media (max-width: 575.98px) {\n  .error-wrapper .error-title {\n    font-size: 50px;\n    line-height: 35px;\n  }\n}\n\n.error-wrapper .error-title .error-subtitle {\n  font-size: 15px;\n}\n\n.error-wrapper .error-title .img-responsive {\n  max-width: 100%;\n}\n\n/*===== PROFILE =====*/\n@media (min-width: 992px) {\n  .profile-content-right {\n    border-top: 0px;\n    border-left: 1px solid var(--border-color);\n  }\n}\n\n.profile-content-right .nav-style-border.nav-tabs .nav-link {\n  padding: 0 0 0.94rem;\n}\n\n.profile-timeline-media .media-body>span {\n  font-size: 0.81rem;\n}\n\n.profile-timeline-media .media-body>p {\n  line-height: 1.6;\n  padding-top: 2rem;\n}\n\n.text-dark {\n  color: var(--bs-black-rgb);\n}\n\n.text-secondary {\n  color: var(--bs-body-color) !important;\n}\n\n.ec-store-list .store-thumb {\n  width: 45px;\n  height: 45px;\n  border-radius: 15px;\n}\n\n@media (max-width: 575.98px) {\n  .ec-store-wrapper .ec-card-space {\n    padding: 15px !important;\n  }\n}\n\n.ec-store-card .card-default {\n  overflow: inherit;\n}\n\n.ec-store-card .card-default .ec-store-detail h6,\n.ec-store-card .card-default .ec-store-detail .h6 {\n  margin: 10px 0 10px 0;\n  padding: 5px 2px;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 1.2;\n  color: var(--bs-body-color);\n  text-transform: capitalize !important;\n  border-radius: 10px;\n  background: #f1f1f1;\n}\n\n.ec-store-card .card-default .ec-store-detail h5,\n.ec-store-card .card-default .ec-store-detail .h5 {\n  margin-top: 0;\n  margin-bottom: 0;\n  font-weight: 600;\n  line-height: 1.2;\n  color: var(--bs-body-color);\n  font-size: 15px;\n}\n\n.ec-store-card .card-default .view-detail {\n  position: absolute;\n  top: 6px;\n  right: 15px;\n  font-size: 20px;\n  color: #bbb;\n}\n\n.ec-store-card .card-default .view-detail:hover {\n  color: var(--admin-color);\n}\n\n.ec-store-card .card-default .store-info .img-fluid {\n  width: 150px;\n}\n\n.user-list .store-thumb {\n  width: 45px;\n  height: 45px;\n}\n\n.ec-user-card .img-fluid {\n  width: 70px;\n  border-radius: 15px;\n}\n\n.ec-user-card .media-body h5,\n.ec-user-card .media-body .h5 {\n  font-size: 16px;\n}\n\n.ec-ec-content-wrapper .view-detail {\n  position: absolute;\n  top: 6px;\n  right: 15px;\n  font-size: 20px;\n  color: #bbb;\n}\n\n.ec-ec-content-wrapper .modal-contact-detail .dropdown i {\n  margin: 0 15px;\n}\n\n/*===== ORDERS =====*/\n.ec-odr-dtl .ec-odr {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n}\n\n.ec-odr-dtl h2,\n.ec-odr-dtl .h2 {\n  margin-top: 0px;\n  line-height: 0.8em;\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  width: 100%;\n}\n\n.ec-odr-dtl .small {\n  font-weight: 300;\n  text-align: right;\n}\n\n.ec-odr-dtl hr {\n  /* margin-top: 10px; */\n  border-color: #ddd;\n}\n\n.ec-odr-dtl .table tr.line {\n  border-bottom: 1px solid #ccc;\n}\n\n.ec-odr-dtl .table td {\n  border: none;\n}\n\n.ec-odr-dtl .identity {\n  margin-top: 10px;\n  font-size: 1.1em;\n  font-weight: 300;\n}\n\n.ec-odr-dtl .identity strong {\n  font-weight: 600;\n}\n\n.ec-odr-dtl .info-grid {\n  font-style: normal;\n  line-height: inherit;\n  border: 1px solid #e1e2e6;\n  height: 100%;\n  border-radius: 15px;\n  overflow: hidden;\n}\n\n@media (max-width: 1199.98px) {\n  .ec-odr-dtl .info-grid {\n    height: auto;\n    margin-bottom: 24px;\n  }\n}\n\n.ec-odr-dtl .info-title {\n  width: 100%;\n  text-align: center;\n  display: inline-block;\n  background: #f7f7f7;\n  padding: 10px;\n  color: var(--text-color);\n}\n\n.ec-odr-dtl .info-title strong {\n  font-weight: 500;\n}\n\n.ec-odr-dtl .info-content {\n  padding: 20px;\n}\n\n.ec-odr-dtl .tbl-title {\n  margin-top: 30px;\n  border: 1px solid #f7f7f7;\n  text-align: center;\n  padding: 10px;\n  margin-bottom: 20px;\n  background: #f7f7f7;\n  color: #2b2b2b;\n  font-size: 15px;\n}\n\n@media (max-width: 1199.98px) {\n  .ec-odr-dtl .tbl-title {\n    margin-top: 0;\n  }\n}\n\n.ec-odr-dtl .product-img {\n  width: 50px;\n  border-radius: 15px;\n}\n\n.product-img.tbl-img {\n  width: 50px;\n  border-radius: 15px;\n}\n\n.o-tbl thead tr td strong {\n  font-weight: 500;\n  color: var(--text-color);\n}\n\n.o-tbl tbody tr:nth-of-type(odd)>* {\n  background-color: #f9f9f9;\n  --bs-table-accent-bg: #f9f9f9;\n}\n\n.o-tbl tbody tr td strong {\n  font-weight: 500;\n  color: var(--text-color);\n}\n\n/*===== TRACK ORDERS =====*/\n.steps .step {\n  display: block;\n  width: 100%;\n  text-align: center;\n}\n\n@media (max-width: 575.98px) {\n  .steps .step {\n    margin-bottom: 24px;\n  }\n}\n\n.steps .step .step-icon-wrap {\n  display: block;\n  position: relative;\n  width: 100%;\n  height: 80px;\n  text-align: center;\n}\n\n.steps .step .step-icon-wrap::before {\n  display: block;\n  position: absolute;\n  top: 50%;\n  width: 50%;\n  height: 3px;\n  margin-top: -1px;\n  background-color: #e1e7ec;\n  content: \"\";\n  z-index: 1;\n  left: 0;\n}\n\n.steps .step .step-icon-wrap::after {\n  display: block;\n  position: absolute;\n  top: 50%;\n  width: 50%;\n  height: 3px;\n  margin-top: -1px;\n  background-color: #e1e7ec;\n  content: \"\";\n  z-index: 1;\n  right: 0;\n}\n\n@media (max-width: 991.98px) {\n  .steps .step .step-icon-wrap {\n    height: 50px;\n  }\n}\n\n.steps .step .step-icon {\n  display: inline-block;\n  position: relative;\n  width: 80px;\n  height: 80px;\n  border: 1px solid #e1e7ec;\n  border-radius: 30px;\n  background-color: #f5f5f5;\n  color: #374250;\n  font-size: 38px;\n  line-height: 81px;\n  z-index: 5;\n}\n\n@media (max-width: 991.98px) {\n  .steps .step .step-icon {\n    width: 50px;\n    height: 50px;\n    font-size: 26px;\n    line-height: 50px;\n    border-radius: 18px;\n  }\n}\n\n.steps .step .step-title {\n  margin-top: 16px;\n  margin-bottom: 0;\n  color: #606975;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.steps .step:first-child .step-icon-wrap::before {\n  display: none;\n}\n\n.steps .step:last-child .step-icon-wrap::after {\n  display: none;\n}\n\n.steps .step.completed .step-icon-wrap::before {\n  background-color: var(--admin-color);\n}\n\n.steps .step.completed .step-icon-wrap::after {\n  background-color: var(--admin-color);\n}\n\n.steps .step.completed .step-icon {\n  border-color: var(--admin-color);\n  background-color: var(--admin-color);\n  color: #fff;\n}\n\n.trk-order span {\n  color: #777777;\n}\n\n.bg-faded,\n.bg-secondary {\n  background-color: #f5f5f5 !important;\n}\n\n@media (max-width: 576px) {\n  .flex-sm-nowrap .step .step-icon-wrap::before {\n    display: none;\n  }\n\n  .flex-sm-nowrap .step .step-icon-wrap::after {\n    display: none;\n  }\n}\n\n@media (max-width: 768px) {\n  .flex-md-nowrap .step .step-icon-wrap::before {\n    display: none;\n  }\n\n  .flex-md-nowrap .step .step-icon-wrap::after {\n    display: none;\n  }\n}\n\n@media (max-width: 991px) {\n  .flex-lg-nowrap .step .step-icon-wrap::before {\n    display: none;\n  }\n\n  .flex-lg-nowrap .step .step-icon-wrap::after {\n    display: none;\n  }\n}\n\n@media (max-width: 1200px) {\n  .flex-xl-nowrap .step .step-icon-wrap::before {\n    display: none;\n  }\n\n  .flex-xl-nowrap .step .step-icon-wrap::after {\n    display: none;\n  }\n}\n\n/*===== ADD PRODUCTS =====*/\n.ec-store-uploads .ec-store-img-upload {\n  margin-bottom: -10px;\n  position: sticky;\n  top: 30px;\n}\n\n.ec-store-uploads .ec-store-img-upload .ec-store-main-img .avatar-upload {\n  margin-bottom: 10px;\n  position: relative;\n}\n\n@media (max-width: 991.98px) {\n  .ec-store-uploads .ec-store-img-upload .ec-store-main-img .avatar-upload {\n    max-width: 400px;\n    margin: 0 auto 15px auto;\n  }\n}\n\n.ec-store-uploads .ec-store-img-upload .ec-store-main-img .avatar-upload .avatar-edit {\n  position: absolute;\n  right: 25px;\n  z-index: 1;\n  top: 25px;\n}\n\n.ec-store-uploads .ec-store-img-upload .ec-store-main-img .avatar-upload .avatar-edit input {\n  opacity: 0;\n  width: 40px;\n  height: 40px;\n  padding: 0;\n  border-radius: 50%;\n  position: absolute;\n  z-index: 1;\n}\n\n.ec-store-uploads .ec-store-img-upload .ec-store-main-img .avatar-upload .avatar-edit input+label {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  padding: 10px;\n  margin-bottom: 0;\n  border-radius: 10px;\n  background: #ffffff;\n  border: 1px solid transparent;\n  -webkit-box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.15);\n  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.15);\n  border: 1px solid #eeeeee;\n  cursor: pointer;\n  font-weight: normal;\n  -webkit-transition: all 0.2s ease-in-out;\n  transition: all 0.2s ease-in-out;\n}\n\n.ec-store-uploads .ec-store-img-upload .ec-store-main-img .avatar-upload .avatar-edit input+label .svg_img {\n  width: 25px;\n  opacity: 0.6;\n}\n\n.ec-store-uploads .ec-store-img-upload .ec-store-main-img .avatar-upload .avatar-edit input+label:hover {\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.ec-store-uploads .ec-store-img-upload .ec-store-main-img .avatar-upload .avatar-preview {\n  width: 100%;\n  height: 100%;\n  padding: 15px;\n  position: relative;\n  border: 1px solid #eeeeee;\n  border-radius: 15px;\n}\n\n.ec-store-uploads .ec-store-img-upload .ec-store-main-img .avatar-upload .avatar-preview>div {\n  width: 100%;\n  height: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n}\n\n.ec-store-uploads .ec-store-img-upload .ec-store-main-img .avatar-upload .avatar-preview .imagePreview img {\n  margin: auto;\n  vertical-align: middle;\n  max-width: 100%;\n  border-radius: 10px;\n}\n\n.ec-store-uploads .ec-store-img-upload .ec-store-main-img .thumb-upload-set {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  width: 100%;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n\n@media (max-width: 991.98px) {\n  .ec-store-uploads .ec-store-img-upload .ec-store-main-img .thumb-upload-set {\n    padding-bottom: 24px;\n  }\n}\n\n.ec-store-uploads .ec-store-img-upload .ec-store-main-img .thumb-upload-set .thumb-upload {\n  margin: 2px 7px 10px 7px;\n  position: relative;\n  z-index: 1;\n  overflow: hidden;\n  display: inline-block;\n}\n\n.ec-store-uploads .ec-store-img-upload .ec-store-main-img .thumb-upload-set .thumb-upload .thumb-edit {\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  z-index: 1;\n  cursor: pointer;\n}\n\n.ec-store-uploads .ec-store-img-upload .ec-store-main-img .thumb-upload-set .thumb-upload input {\n  opacity: 0;\n  width: 30px;\n  height: 30px;\n  padding: 0;\n  border-radius: 50%;\n  position: absolute;\n  z-index: 1;\n  cursor: pointer;\n}\n\n.ec-store-uploads .ec-store-img-upload .ec-store-main-img .thumb-upload-set .thumb-upload input+label {\n  width: 30px;\n  height: 30px;\n  padding: 4px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  margin-bottom: 0;\n  border-radius: 10px;\n  background: #ffffff;\n  border: 1px solid transparent;\n  -webkit-box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.15);\n  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.15);\n  border: 1px solid #eeeeee;\n  cursor: pointer;\n  font-weight: normal;\n  -webkit-transition: all 0.2s ease-in-out;\n  transition: all 0.2s ease-in-out;\n  cursor: pointer;\n}\n\n.ec-store-uploads .ec-store-img-upload .ec-store-main-img .thumb-upload-set .thumb-upload input+label .svg_img {\n  width: 18px;\n  opacity: 0.6;\n  cursor: pointer;\n}\n\n.ec-store-uploads .ec-store-img-upload .ec-store-main-img .thumb-upload-set .thumb-upload input+label:hover {\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.ec-store-uploads .ec-store-img-upload .ec-store-main-img .thumb-upload-set .thumb-upload .thumb-preview {\n  padding: 2px;\n  position: relative;\n  border: 1px solid #eeeeee;\n  border-radius: 10px;\n}\n\n.ec-store-uploads .ec-store-img-upload .ec-store-main-img .thumb-upload-set .thumb-upload .thumb-preview>div {\n  width: 80px;\n  height: 80px;\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n}\n\n@media (max-width: 1199.98px) {\n  .ec-store-uploads .ec-store-img-upload .ec-store-main-img .thumb-upload-set .thumb-upload .thumb-preview>div {\n    width: 70px;\n    height: 70px;\n  }\n}\n\n.ec-store-uploads .ec-store-img-upload .ec-store-main-img .thumb-upload-set .thumb-upload .thumb-preview img {\n  width: 100%;\n  height: 100%;\n  vertical-align: middle;\n  max-width: 100%;\n  border-radius: 7px;\n}\n\n.ec-store-uploads .ec-store-upload-detail .mb-25 {\n  margin-bottom: 25px;\n}\n\n.ec-store-uploads .ec-store-upload-detail form label {\n  width: 100%;\n  text-transform: uppercase;\n  font-weight: 500;\n}\n\n.ec-store-uploads .ec-store-upload-detail form label span {\n  font-size: 13px;\n  color: #999;\n  font-weight: 300;\n  text-transform: none;\n}\n\n.ec-store-uploads .ec-store-upload-detail form input {\n  width: 100%;\n  margin-bottom: 30px;\n  padding: 0 15px;\n  border-radius: 0;\n  border: 1px solid #eeeeee !important;\n  background-color: transparent;\n  color: #777;\n  line-height: 3;\n  border-radius: 15px;\n}\n\n.ec-store-uploads .ec-store-upload-detail form textarea {\n  width: 100%;\n  margin-bottom: 30px;\n  padding: 0 15px;\n  border-radius: 0;\n  border: 1px solid #eeeeee !important;\n  background-color: transparent;\n  color: #777;\n  padding: 15px;\n  border-radius: 15px;\n}\n\n.ec-store-uploads .ec-store-upload-detail form select {\n  width: 100%;\n  height: 45px;\n  margin-bottom: 30px;\n  padding: 0 15px;\n  border-radius: 0;\n  border: 1px solid #eeeeee !important;\n  background-color: transparent;\n  color: #777;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  outline: none;\n  border-radius: 15px;\n}\n\n.ec-store-uploads .ec-store-upload-detail form input[type=text] {\n  height: 45px;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  outline: none;\n  border-radius: 15px;\n}\n\n.ec-store-uploads .ec-store-upload-detail form input[type=color] {\n  width: 25px !important;\n  height: 25px !important;\n  padding: 0;\n  border-radius: 15px;\n  border-radius: 0 !important;\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  margin: 4px;\n  min-height: 25px;\n}\n\n.ec-store-uploads .ec-store-upload-detail form input[type=color] i {\n  border-radius: 0;\n}\n\n.ec-store-uploads .ec-store-upload-detail form .form-checkbox-box {\n  height: 30px;\n  margin-top: 5px;\n  display: inline-block;\n}\n\n.ec-store-uploads .ec-store-upload-detail form .form-check {\n  height: 20px;\n  margin: 0 5px 0 0;\n  padding: 0;\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.ec-store-uploads .ec-store-upload-detail form .form-check input {\n  width: 35px !important;\n  height: 100% !important;\n  margin: 0;\n}\n\n.ec-store-uploads .ec-store-upload-detail form .form-check label {\n  margin: 5px 5px 2px 7px;\n  line-height: 11px;\n  color: #999;\n}\n\n.ec-store-uploads .ec-store-upload-detail .bootstrap-tagsinput {\n  width: 100%;\n  margin-bottom: 30px;\n  background-color: transparent;\n  border: 1px solid #eeeeee;\n  display: inline-block;\n  padding: 5px 10px;\n  color: #555;\n  vertical-align: middle;\n  border-radius: 15px;\n  line-height: 22px;\n  cursor: text;\n}\n\n.ec-store-uploads .ec-store-upload-detail .bootstrap-tagsinput input {\n  height: 40px;\n  border: none !important;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  outline: none;\n  background-color: transparent;\n  padding: 0 5px;\n  margin: 0;\n  width: auto;\n  max-width: inherit;\n}\n\n.ec-store-uploads .ec-store-upload-detail .bootstrap-tagsinput input:focus {\n  border: none;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.ec-store-uploads .ec-store-upload-detail .bootstrap-tagsinput input::-webkit-input-placeholder {\n  color: #999;\n  opacity: 1;\n}\n\n.ec-store-uploads .ec-store-upload-detail .bootstrap-tagsinput input::-moz-placeholder {\n  color: #999;\n  opacity: 1;\n}\n\n.ec-store-uploads .ec-store-upload-detail .bootstrap-tagsinput input:-ms-input-placeholder {\n  color: #999;\n  opacity: 1;\n  color: #999;\n}\n\n.ec-store-uploads .ec-store-upload-detail .bootstrap-tagsinput input::-ms-input-placeholder {\n  color: #999;\n  opacity: 1;\n  color: #999;\n}\n\n.ec-store-uploads .ec-store-upload-detail .bootstrap-tagsinput input::placeholder {\n  color: #999;\n  opacity: 1;\n}\n\n.ec-store-uploads .ec-store-upload-detail .bootstrap-tagsinput .tag {\n  margin-right: 2px;\n  color: #777;\n}\n\n.ec-store-uploads .ec-store-upload-detail .bootstrap-tagsinput .tag [data-role=remove] {\n  margin-left: 8px;\n  cursor: pointer;\n  color: #f96e6e;\n}\n\n.ec-store-uploads .ec-store-upload-detail .bootstrap-tagsinput .tag [data-role=remove]:after {\n  content: \"×\";\n  padding: 0px 2px;\n}\n\n.ec-store-uploads .ec-store-upload-detail .bootstrap-tagsinput .tag [data-role=remove]:hover {\n  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.2), 0 1px 2px rgba(0, 0, 0, 0.05);\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.2), 0 1px 2px rgba(0, 0, 0, 0.05);\n}\n\n.ec-store-uploads .ec-store-upload-detail .bootstrap-tagsinput .tag [data-role=remove]:hover:active {\n  -webkit-box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n}\n\n.ec-store-uploads .ec-store-upload-detail .bootstrap-tagsinput.form-control input::-moz-placeholder {\n  color: #777;\n  opacity: 1;\n}\n\n.ec-store-uploads .ec-store-upload-detail .bootstrap-tagsinput.form-control input:-ms-input-placeholder {\n  color: #777;\n}\n\n.ec-store-uploads .ec-store-upload-detail .bootstrap-tagsinput.form-control input::-webkit-input-placeholder {\n  color: #777;\n}\n\n/*===== LIST PRODUCTS =====*/\n.card-default .card-header .card-bar {\n  width: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.card-default .card-header .card-bar .p-space {\n  padding: 0 6px;\n}\n\n@media (max-width: 991.98px) {\n  .card-default .card-header .card-bar .p-space {\n    width: 50%;\n  }\n}\n\n.card-default .card-header .card-bar .sort {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n  -ms-flex-pack: end;\n  justify-content: flex-end;\n}\n\n@media (max-width: 991.98px) {\n  .card-default .card-header .card-bar .sort {\n    padding-top: 12px;\n  }\n}\n\n@media (max-width: 991.98px) {\n  .card-default .card-header .card-bar {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n  }\n}\n\n.card-wrapper {\n  -webkit-transition: all 0.3s ease-in-out;\n  transition: all 0.3s ease-in-out;\n  background: white;\n  margin-bottom: 24px;\n  position: relative;\n  overflow: hidden;\n  border: 1px solid #f0f0f0;\n  border-radius: 15px;\n  -webkit-box-shadow: 0;\n  box-shadow: 0;\n}\n\n.card-wrapper:hover {\n  -webkit-box-shadow: 0px 0 20px -1px rgba(0, 0, 0, 0.1);\n  box-shadow: 0px 0 20px -1px rgba(0, 0, 0, 0.1);\n}\n\n.card-wrapper:hover .card-top .card-image {\n  border-radius: 10px;\n  -webkit-transform: scale(1.03);\n  transform: scale(1.03);\n}\n\n.card-wrapper .card-container {\n  padding: 12px;\n}\n\n.card-wrapper .card-container .card-top {\n  overflow: hidden;\n  border-radius: 10px;\n}\n\n.card-wrapper .card-container .card-top .card-image {\n  -webkit-transition: all 0.3s ease-in-out;\n  transition: all 0.3s ease-in-out;\n  width: 100%;\n  border-radius: 10px;\n}\n\n.card-wrapper .card-container .card-bottom {\n  padding: 12px 0 0 0;\n  width: 100%;\n  background: #ffffff;\n}\n\n.card-wrapper .card-container .card-bottom h3,\n.card-wrapper .card-container .card-bottom .h3 {\n  margin: 0 0 5px 0;\n  padding: 0;\n  font-size: 14px;\n  font-weight: 400;\n}\n\n.card-wrapper .card-container .card-bottom h3:hover,\n.card-wrapper .card-container .card-bottom .h3:hover {\n  cursor: pointer;\n}\n\n.card-wrapper .card-container .card-bottom p {\n  margin: 0;\n  padding: 0;\n  font-weight: 600;\n}\n\n.card-wrapper .card-container .card-action {\n  -webkit-transition: all 0.3s ease-in-out;\n  transition: all 0.3s ease-in-out;\n  position: absolute;\n  list-style: none;\n  line-height: 2em;\n  overflow: hidden;\n  top: 22px;\n  right: -50px;\n  background: #fff;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  right: 22px;\n  opacity: 0;\n  border-radius: 10px;\n  border: 1px solid var(--border-color);\n}\n\n.card-wrapper .card-container .card-action .card-edit {\n  -ms-flex-line-pack: center;\n  align-content: center;\n  width: 35px;\n  height: 35px;\n  display: -ms-grid;\n  display: grid;\n  text-align: center;\n}\n\n.card-wrapper .card-container .card-action .card-edit i {\n  font-size: 20px;\n  padding: 0;\n  color: #bbb;\n  padding: 15px ​10p;\n}\n\n.card-wrapper .card-container .card-action .card-edit:hover {\n  cursor: pointer;\n}\n\n.card-wrapper .card-container .card-action .card-edit:hover i {\n  color: var(--admin-color);\n  -webkit-transition: all 0.7s ease-in-out;\n  transition: all 0.7s ease-in-out;\n}\n\n.card-wrapper .card-container .card-action .card-preview {\n  -ms-flex-line-pack: center;\n  align-content: center;\n  display: -ms-grid;\n  display: grid;\n  width: 35px;\n  height: 35px;\n  text-align: center;\n  border-top: 1px solid var(--border-color);\n  border-bottom: 1px solid var(--border-color);\n}\n\n.card-wrapper .card-container .card-action .card-preview i {\n  font-size: 20px;\n  padding: 0;\n  color: #bbb;\n}\n\n.card-wrapper .card-container .card-action .card-preview:hover {\n  cursor: pointer;\n}\n\n.card-wrapper .card-container .card-action .card-preview:hover i {\n  color: var(--admin-color);\n  -webkit-transition: all 0.7s ease-in-out;\n  transition: all 0.7s ease-in-out;\n}\n\n.card-wrapper .card-container .card-action .card-remove {\n  -ms-flex-line-pack: center;\n  align-content: center;\n  display: -ms-grid;\n  display: grid;\n  width: 35px;\n  height: 35px;\n  text-align: center;\n}\n\n.card-wrapper .card-container .card-action .card-remove i {\n  font-size: 20px;\n  padding: 0;\n  color: #bbb;\n}\n\n.card-wrapper .card-container .card-action .card-remove:hover {\n  cursor: pointer;\n}\n\n.card-wrapper .card-container .card-action .card-remove:hover i {\n  color: var(--admin-color);\n  -webkit-transition: all 0.7s ease-in-out;\n  transition: all 0.7s ease-in-out;\n}\n\n.card-wrapper:hover .card-action {\n  -webkit-transition: all 0.3s ease-in-out;\n  transition: all 0.3s ease-in-out;\n  right: 22px;\n  opacity: 1;\n}\n\n/*===== PRODUCT DETAILS =====*/\n/*-----  Single Product  -----*/\n.single-pro-img {\n  position: relative;\n  width: 100%;\n}\n\n@media (max-width: 991.98px) {\n  .single-pro-img {\n    max-width: 500px;\n    margin: auto;\n  }\n}\n\n.single-pro-img .single-product-scroll {\n  position: sticky;\n  top: 30px;\n}\n\n.single-pro-img .ec-360-lbl {\n  position: absolute;\n  top: 15px;\n  right: 15px;\n  z-index: 1;\n  border-radius: 50%;\n  cursor: pointer;\n  height: 40px;\n  width: 40px;\n  text-align: center;\n  -ms-flex-line-pack: center;\n  align-content: center;\n  display: -ms-grid;\n  display: grid;\n  opacity: 0.7;\n}\n\n.single-pro-img .ec-360-lbl:hover {\n  opacity: 1;\n}\n\n.single-pro-img .ec-video-icon {\n  position: absolute;\n  display: -ms-grid;\n  display: grid;\n  top: 15px;\n  right: 15px;\n  height: 40px;\n  width: 40px;\n  text-align: center;\n  -ms-flex-line-pack: center;\n  align-content: center;\n  cursor: pointer;\n  z-index: 1;\n  opacity: 0.7;\n}\n\n.single-pro-img .ec-video-icon:hover {\n  opacity: 1;\n}\n\n.single-product-cover {\n  overflow: hidden;\n  cursor: -webkit-zoom-in;\n  cursor: zoom-in;\n  border-radius: 15px;\n}\n\n.single-product-cover .slick-slide img {\n  width: 100%;\n  border-radius: 15px;\n}\n\n.single-nav-thumb {\n  width: 100%;\n}\n\n.single-nav-thumb .slick-arrow {\n  position: absolute;\n  top: 37%;\n  left: auto;\n  right: auto;\n  margin: 0 auto;\n  font-size: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  width: 30px;\n  height: 30px;\n  padding: 0;\n  z-index: 1;\n}\n\n.single-nav-thumb .slick-arrow.slick-prev {\n  right: auto;\n  left: -11px;\n}\n\n.single-nav-thumb .slick-arrow.slick-prev:before {\n  content: \"\";\n  font-family: \"Material Design Icons\";\n  color: #777;\n}\n\n.single-nav-thumb .slick-arrow.slick-next {\n  right: -14px;\n  left: auto;\n}\n\n.single-nav-thumb .slick-arrow.slick-next:before {\n  content: \"\";\n  font-family: \"Material Design Icons\";\n  color: #777;\n}\n\n.single-nav-thumb .slick-arrow {\n  opacity: 0.5;\n}\n\n.single-nav-thumb .slick-arrow:hover {\n  opacity: 1;\n}\n\n.single-nav-thumb .slick-arrow:before {\n  content: \"\";\n  color: #777777;\n  position: relative;\n  font-size: 30px;\n  font-family: \"EcIcons\";\n  width: 100%;\n  line-height: 30px;\n  height: 30px;\n}\n\n.single-nav-thumb .slick-list {\n  margin: 0 -8px;\n}\n\n.single-nav-thumb .single-slide {\n  padding: 11px 11px 0 11px;\n  display: block !important;\n}\n\n.single-nav-thumb .slick-slide img {\n  width: 100%;\n  border: 1px solid transparent;\n  -webkit-transition: all 0.3s ease 0s;\n  transition: all 0.3s ease 0s;\n  cursor: pointer;\n  border-radius: 10px;\n  border-color: var(--border-color);\n}\n\n.single-nav-thumb .slick-slide:hover img {\n  border-color: var(--admin-color);\n}\n\n.single-nav-thumb .slick-slide.slick-current.slick-active img {\n  border-color: #ddd;\n}\n\n.single-nav-thumb .slick-arrow {\n  top: 40%;\n}\n\n.product-detail .product-desc {\n  padding-bottom: 15px;\n}\n\n.product-detail .product-rate {\n  padding: 5px 0;\n}\n\n.product-detail .product-rate i {\n  font-size: 22px;\n  padding: 0 2px 0 0;\n}\n\n.product-detail .product-rate .is-rated {\n  color: #ffd481;\n}\n\n.product-detail h5,\n.product-detail .h5 {\n  color: var(--text-color);\n}\n\n.product-detail .product-price {\n  padding-bottom: 15px;\n  font-weight: 700;\n  font-size: 16px;\n}\n\n.product-detail .product-sku {\n  padding-bottom: 15px;\n}\n\n.product-detail .ec-ofr {\n  margin: 10px 0 20px 0;\n}\n\n.product-detail .ec-ofr ul li {\n  margin: 10px 0;\n}\n\n.product-detail .ec-ofr ul li b {\n  font-weight: 500;\n}\n\n.product-detail .product-size,\n.product-detail .product-color {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  padding-bottom: 15px;\n}\n\n.product-detail .product-size li,\n.product-detail .product-color li {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  padding: 2px;\n  border-radius: 30px;\n  opacity: 0.7;\n  background-color: transparent;\n  -webkit-transition: all 0.3s ease-in-out;\n  transition: all 0.3s ease-in-out;\n  width: 25px;\n  height: 25px;\n  cursor: pointer;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  font-size: 12px;\n  line-height: 22px;\n  padding: 0;\n  border: 1px solid #eeeeee;\n  float: left;\n  margin-right: 10px;\n  border-radius: 0;\n}\n\n.product-detail .product-size li {\n  width: auto;\n  height: auto;\n  line-height: 18px;\n  padding: 0px 7px;\n  border-radius: 10px;\n}\n\n.product-detail .product-color .color {\n  border-radius: 30px;\n}\n\n.product-detail .product-color .color span {\n  width: 100%;\n  height: 100%;\n  display: block;\n  border-radius: 30px;\n}\n\n.product-detail .product-stock {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n}\n\n.product-detail .product-stock .stock {\n  border: 1px solid var(--border-color);\n  margin: 0 20px 5px 0;\n  padding: 10px;\n  text-align: center;\n  border-radius: 15px;\n}\n\n.product-detail .product-stock .stock .title {\n  font-weight: 500;\n  font-size: 14px;\n}\n\n.product-detail .seller-card {\n  overflow: inherit;\n}\n\n@media (max-width: 991.98px) {\n  .product-detail .product-overview {\n    padding-top: 24px;\n  }\n}\n\n.product-detail .product-overview .list-unstyled li {\n  display: block !important;\n  text-align: center;\n}\n\n.product-detail .nav-tabs {\n  border: none;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n\n.product-detail .nav-tabs .nav-link {\n  border-top-left-radius: 10px;\n  border-top-right-radius: 10px;\n}\n\n.product-detail .nav-tabs .nav-link i {\n  font-size: 16px;\n}\n\n.product-detail .tab-content {\n  overflow: hidden;\n  background-color: #fff;\n  text-align: left;\n  padding: 35px 30px 21px 30px;\n  border: 1px solid #eeeeee;\n  border-radius: 0;\n  color: #202020;\n  font-size: 18px;\n  letter-spacing: 0;\n  line-height: 1.6;\n  border-radius: 15px;\n}\n\n.product-detail .tab-content p {\n  color: #777777;\n}\n\n.product-detail .tab-content .tab-pane {\n  padding: 0 !important;\n}\n\n.product-detail .tab-content .tab-pane .features {\n  padding-top: 10px;\n}\n\n.product-detail .tab-content .tab-pane ul {\n  padding-left: 16px;\n  font-size: 15px;\n}\n\n.product-detail .tab-content .tab-pane ul li {\n  list-style-type: disclosure-closed;\n  color: #777777;\n}\n\n.product-detail .tab-content .tab-pane .ec-t-review-item {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin: 0 0 25px;\n  padding-bottom: 25px;\n  border-bottom: 1px solid #eeeeee;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.product-detail .tab-content .tab-pane .ec-t-review-item .ec-t-review-top {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  margin: 0;\n}\n\n.product-detail .tab-content .tab-pane .ec-t-review-item .ec-t-review-top .ec-t-review-name {\n  font-weight: 500;\n}\n\n.product-detail .tab-content .tab-pane .ec-t-review-item .ec-t-review-avtar {\n  width: 100px;\n  margin: 0 15px 0 0;\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 90px;\n  flex: 0 0 90px;\n}\n\n.product-detail .tab-content .tab-pane .ec-t-review-item .ec-t-review-avtar img {\n  width: 100%;\n  border-radius: 15px;\n}\n\n@media (max-width: 1199.98px) {\n  .product-detail .u-card {\n    margin-top: 24px;\n  }\n\n  .product-detail .u-card img {\n    width: 100px;\n  }\n}\n\n.ec-t-rate {\n  padding: 0;\n  line-height: 25px;\n}\n\n.ec-t-rate i {\n  font-size: 18px;\n  padding: 0;\n}\n\n.ec-t-rate .is-rated {\n  color: #ffd481;\n}\n\n.product-brand .card-default {\n  margin-bottom: 24px;\n  overflow: inherit;\n}\n\n@media (max-width: 767.98px) {\n  .product-brand .card-default {\n    max-width: 300px;\n    margin: 0 auto 24px auto;\n  }\n}\n\n.product-brand .rounded-circle {\n  border-radius: 15px !important;\n  -webkit-box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.05);\n  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.05);\n  width: 100px;\n  border: 1px solid var(--border-color);\n}\n\n.product-brand .brand-delete {\n  -webkit-transition: all 0.3s ease-in-out;\n  transition: all 0.3s ease-in-out;\n  position: absolute;\n  right: 10px;\n  top: 5px;\n  font-size: 17px;\n  cursor: pointer;\n  color: #bbb;\n}\n\n.product-brand .brand-delete:hover {\n  color: #f7b7b7;\n}\n\n/** Invoice CSS **/\n.invoice-wrapper .text-dark {\n  font-weight: 500;\n}\n\n.invoice-wrapper address span {\n  font-weight: 500;\n}\n\n.invoice-wrapper .inv-tbl tbody tr:nth-of-type(odd)>* {\n  background-color: #f9f9f9;\n  --bs-table-accent-bg: #f9f9f9;\n}\n\n.invoice-wrapper .inv-tbl tbody tr td {\n  vertical-align: middle;\n}\n\n.invoice-wrapper .inv-tbl tbody tr td img {\n  width: 40px;\n  border-radius: 15px;\n}\n\n.invoice-wrapper .inc-total ul li span {\n  float: right;\n}\n\n.invoice-wrapper .inc-total .btn {\n  max-width: 180px;\n  margin-left: auto;\n}\n\n@media (max-width: 1199.98px) {\n  .invoice-wrapper .disp-none {\n    display: none;\n  }\n}\n\n.m-0 {\n  margin: 0 !important;\n}\n\n.mt-0,\n.my-0 {\n  margin-top: 0 !important;\n}\n\n.mr-0,\n.mx-0 {\n  margin-right: 0 !important;\n}\n\n.mb-0,\n.my-0 {\n  margin-bottom: 0 !important;\n}\n\n.ml-0,\n.mx-0 {\n  margin-left: 0 !important;\n}\n\n.m-1 {\n  margin: 5px !important;\n}\n\n.mt-1,\n.my-1 {\n  margin-top: 5px !important;\n}\n\n.mr-1,\n.mx-1 {\n  margin-right: 5px !important;\n}\n\n.mb-1,\n.my-1 {\n  margin-bottom: 5px !important;\n}\n\n.ml-1,\n.mx-1 {\n  margin-left: 5px !important;\n}\n\n.m-2 {\n  margin: 5px !important;\n}\n\n.mt-2,\n.my-2 {\n  margin-top: 5px !important;\n}\n\n.mr-2,\n.mx-2 {\n  margin-right: 5px !important;\n}\n\n.mb-2,\n.my-2 {\n  margin-bottom: 5px !important;\n}\n\n.ml-2,\n.mx-2 {\n  margin-left: 5px !important;\n}\n\n.m-3 {\n  margin: 15px !important;\n}\n\n.mt-3,\n.my-3 {\n  margin-top: 15px !important;\n}\n\n.mr-3,\n.mx-3 {\n  margin-right: 15px !important;\n}\n\n.mb-3,\n.my-3 {\n  margin-bottom: 15px !important;\n}\n\n.ml-3,\n.mx-3 {\n  margin-left: 15px !important;\n}\n\n.m-4 {\n  margin: 30px !important;\n}\n\n.mt-4,\n.my-4 {\n  margin-top: 30px !important;\n}\n\n.mt-24px {\n  margin-top: 24px;\n}\n\n.mb-24px {\n  margin-bottom: 24px;\n}\n\n.mt-m-24px {\n  margin-top: -24px;\n}\n\n.mb-m-24px {\n  margin-bottom: -24px;\n}\n\n.mr-4,\n.mx-4 {\n  margin-right: 30px !important;\n}\n\n.mb-4,\n.my-4 {\n  margin-bottom: 30px !important;\n}\n\n.ml-4,\n.mx-4 {\n  margin-left: 30px !important;\n}\n\n.m-5 {\n  margin: 30px !important;\n}\n\n.mt-5,\n.my-5 {\n  margin-top: 30px !important;\n}\n\n.mr-5,\n.mx-5 {\n  margin-right: 30px !important;\n}\n\n.mb-5,\n.my-5 {\n  margin-bottom: 30px !important;\n}\n\n.ml-5,\n.mx-5 {\n  margin-left: 30px !important;\n}\n\n.m-6 {\n  margin: 50px !important;\n}\n\n.mt-6,\n.my-6 {\n  margin-top: 50px !important;\n}\n\n.mr-6,\n.mx-6 {\n  margin-right: 50px !important;\n}\n\n.mb-6,\n.my-6 {\n  margin-bottom: 50px !important;\n}\n\n.ml-6,\n.mx-6 {\n  margin-left: 50px !important;\n}\n\n.m-7 {\n  margin: 60px !important;\n}\n\n.mt-7,\n.my-7 {\n  margin-top: 60px !important;\n}\n\n.mr-7,\n.mx-7 {\n  margin-right: 60px !important;\n}\n\n.mb-7,\n.my-7 {\n  margin-bottom: 60px !important;\n}\n\n.ml-7,\n.mx-7 {\n  margin-left: 60px !important;\n}\n\n.m-8 {\n  margin: 70px !important;\n}\n\n.mt-8,\n.my-8 {\n  margin-top: 70px !important;\n}\n\n.mr-8,\n.mx-8 {\n  margin-right: 70px !important;\n}\n\n.mb-8,\n.my-8 {\n  margin-bottom: 70px !important;\n}\n\n.ml-8,\n.mx-8 {\n  margin-left: 70px !important;\n}\n\n.m-9 {\n  margin: 80px !important;\n}\n\n.mt-9,\n.my-9 {\n  margin-top: 80px !important;\n}\n\n.mr-9,\n.mx-9 {\n  margin-right: 80px !important;\n}\n\n.mb-9,\n.my-9 {\n  margin-bottom: 80px !important;\n}\n\n.ml-9,\n.mx-9 {\n  margin-left: 80px !important;\n}\n\n.p-0 {\n  padding: 0 !important;\n}\n\n.pt-0,\n.py-0 {\n  padding-top: 0 !important;\n}\n\n.pr-0,\n.px-0 {\n  padding-right: 0 !important;\n}\n\n.pb-0,\n.py-0 {\n  padding-bottom: 0 !important;\n}\n\n.pl-0,\n.px-0 {\n  padding-left: 0 !important;\n}\n\n.p-1 {\n  padding: 5px !important;\n}\n\n.pt-1,\n.py-1 {\n  padding-top: 5px !important;\n}\n\n.pr-1,\n.px-1 {\n  padding-right: 5px !important;\n}\n\n.pb-1,\n.py-1 {\n  padding-bottom: 5px !important;\n}\n\n.pl-1,\n.px-1 {\n  padding-left: 5px !important;\n}\n\n.p-2 {\n  padding: 5px !important;\n}\n\n.pt-2,\n.py-2 {\n  padding-top: 5px !important;\n}\n\n.pr-2,\n.px-2 {\n  padding-right: 5px !important;\n}\n\n.pb-2,\n.py-2 {\n  padding-bottom: 5px !important;\n}\n\n.pl-2,\n.px-2 {\n  padding-left: 5px !important;\n}\n\n.p-3 {\n  padding: 15px !important;\n}\n\n.pt-15px {\n  padding-top: 15px !important;\n}\n\n.pb-15px {\n  padding-bottom: 15px !important;\n}\n\n.pt-3,\n.py-3 {\n  padding-top: 15px !important;\n}\n\n.pr-3,\n.px-3 {\n  padding-right: 15px !important;\n}\n\n.pb-3,\n.py-3 {\n  padding-bottom: 15px !important;\n}\n\n.pl-3,\n.px-3 {\n  padding-left: 15px !important;\n}\n\n.p-4 {\n  padding: 30px !important;\n}\n\n.p-24px {\n  padding: 24px !important;\n}\n\n.pt-24px {\n  padding-top: 24px !important;\n}\n\n.pb-24px {\n  padding-bottom: 24px !important;\n}\n\n.pt-4,\n.py-4 {\n  padding-top: 30px !important;\n}\n\n.pr-4,\n.px-4 {\n  padding-right: 30px !important;\n}\n\n.pb-4,\n.py-4 {\n  padding-bottom: 30px !important;\n}\n\n.pl-4,\n.px-4 {\n  padding-left: 30px !important;\n}\n\n.p-5 {\n  padding: 30px !important;\n}\n\n.pt-5,\n.py-5 {\n  padding-top: 30px !important;\n}\n\n.pr-5,\n.px-5 {\n  padding-right: 30px !important;\n}\n\n.pb-5,\n.py-5 {\n  padding-bottom: 30px !important;\n}\n\n.pl-5,\n.px-5 {\n  padding-left: 30px !important;\n}\n\n.p-6 {\n  padding: 50px !important;\n}\n\n.pt-6,\n.py-6 {\n  padding-top: 50px !important;\n}\n\n.pr-6,\n.px-6 {\n  padding-right: 50px !important;\n}\n\n.pb-6,\n.py-6 {\n  padding-bottom: 50px !important;\n}\n\n.pl-6,\n.px-6 {\n  padding-left: 50px !important;\n}\n\n.p-7 {\n  padding: 60px !important;\n}\n\n.pt-7,\n.py-7 {\n  padding-top: 60px !important;\n}\n\n.pr-7,\n.px-7 {\n  padding-right: 60px !important;\n}\n\n.pb-7,\n.py-7 {\n  padding-bottom: 60px !important;\n}\n\n.pl-7,\n.px-7 {\n  padding-left: 60px !important;\n}\n\n.p-8 {\n  padding: 70px !important;\n}\n\n.pt-8,\n.py-8 {\n  padding-top: 70px !important;\n}\n\n.pr-8,\n.px-8 {\n  padding-right: 70px !important;\n}\n\n.pb-8,\n.py-8 {\n  padding-bottom: 70px !important;\n}\n\n.pl-8,\n.px-8 {\n  padding-left: 70px !important;\n}\n\n.p-9 {\n  padding: 80px !important;\n}\n\n.pt-9,\n.py-9 {\n  padding-top: 80px !important;\n}\n\n.pr-9,\n.px-9 {\n  padding-right: 80px !important;\n}\n\n.pb-9,\n.py-9 {\n  padding-bottom: 80px !important;\n}\n\n.pl-9,\n.px-9 {\n  padding-left: 80px !important;\n}\n\n.m-n1 {\n  margin: -5px !important;\n}\n\n.mt-n1,\n.my-n1 {\n  margin-top: -5px !important;\n}\n\n.mr-n1,\n.mx-n1 {\n  margin-right: -5px !important;\n}\n\n.mb-n1,\n.my-n1 {\n  margin-bottom: -5px !important;\n}\n\n.ml-n1,\n.mx-n1 {\n  margin-left: -5px !important;\n}\n\n.m-n2 {\n  margin: -5px !important;\n}\n\n.mt-n2,\n.my-n2 {\n  margin-top: -5px !important;\n}\n\n.mr-n2,\n.mx-n2 {\n  margin-right: -5px !important;\n}\n\n.mb-n2,\n.my-n2 {\n  margin-bottom: -5px !important;\n}\n\n.ml-n2,\n.mx-n2 {\n  margin-left: -5px !important;\n}\n\n.m-n3 {\n  margin: -15px !important;\n}\n\n.mt-n3,\n.my-n3 {\n  margin-top: -15px !important;\n}\n\n.mr-n3,\n.mx-n3 {\n  margin-right: -15px !important;\n}\n\n.mb-n3,\n.my-n3 {\n  margin-bottom: -15px !important;\n}\n\n.ml-n3,\n.mx-n3 {\n  margin-left: -15px !important;\n}\n\n.m-n4 {\n  margin: -30px !important;\n}\n\n.mt-n4,\n.my-n4 {\n  margin-top: -30px !important;\n}\n\n.mr-n4,\n.mx-n4 {\n  margin-right: -30px !important;\n}\n\n.mb-n4,\n.my-n4 {\n  margin-bottom: -30px !important;\n}\n\n.ml-n4,\n.mx-n4 {\n  margin-left: -30px !important;\n}\n\n.m-n5 {\n  margin: -50px !important;\n}\n\n.mt-n5,\n.my-n5 {\n  margin-top: -50px !important;\n}\n\n.mr-n5,\n.mx-n5 {\n  margin-right: -50px !important;\n}\n\n.mb-n5,\n.my-n5 {\n  margin-bottom: -50px !important;\n}\n\n.ml-n5,\n.mx-n5 {\n  margin-left: -50px !important;\n}\n\n.m-n6 {\n  margin: -50px !important;\n}\n\n.mt-n6,\n.my-n6 {\n  margin-top: -50px !important;\n}\n\n.mr-n6,\n.mx-n6 {\n  margin-right: -50px !important;\n}\n\n.mb-n6,\n.my-n6 {\n  margin-bottom: -50px !important;\n}\n\n.ml-n6,\n.mx-n6 {\n  margin-left: -50px !important;\n}\n\n.m-n7 {\n  margin: -60px !important;\n}\n\n.mt-n7,\n.my-n7 {\n  margin-top: -60px !important;\n}\n\n.mr-n7,\n.mx-n7 {\n  margin-right: -60px !important;\n}\n\n.mb-n7,\n.my-n7 {\n  margin-bottom: -60px !important;\n}\n\n.ml-n7,\n.mx-n7 {\n  margin-left: -60px !important;\n}\n\n.m-n8 {\n  margin: -70px !important;\n}\n\n.mt-n8,\n.my-n8 {\n  margin-top: -70px !important;\n}\n\n.mr-n8,\n.mx-n8 {\n  margin-right: -70px !important;\n}\n\n.mb-n8,\n.my-n8 {\n  margin-bottom: -70px !important;\n}\n\n.ml-n8,\n.mx-n8 {\n  margin-left: -70px !important;\n}\n\n.m-n9 {\n  margin: -80px !important;\n}\n\n.mt-n9,\n.my-n9 {\n  margin-top: -80px !important;\n}\n\n.mr-n9,\n.mx-n9 {\n  margin-right: -80px !important;\n}\n\n.mb-n9,\n.my-n9 {\n  margin-bottom: -80px !important;\n}\n\n.ml-n9,\n.mx-n9 {\n  margin-left: -80px !important;\n}\n\n.m-auto {\n  margin: auto !important;\n}\n\n.mt-auto,\n.my-auto {\n  margin-top: auto !important;\n}\n\n.mr-auto,\n.mx-auto {\n  margin-right: auto !important;\n}\n\n.mb-auto,\n.my-auto {\n  margin-bottom: auto !important;\n}\n\n.ml-auto,\n.mx-auto {\n  margin-left: auto !important;\n}\n\n@media (min-width: 576px) {\n  .m-sm-0 {\n    margin: 0 !important;\n  }\n\n  .mt-sm-0,\n  .my-sm-0 {\n    margin-top: 0 !important;\n  }\n\n  .mr-sm-0,\n  .mx-sm-0 {\n    margin-right: 0 !important;\n  }\n\n  .mb-sm-0,\n  .my-sm-0 {\n    margin-bottom: 0 !important;\n  }\n\n  .ml-sm-0,\n  .mx-sm-0 {\n    margin-left: 0 !important;\n  }\n\n  .m-sm-1 {\n    margin: 5px !important;\n  }\n\n  .mt-sm-1,\n  .my-sm-1 {\n    margin-top: 5px !important;\n  }\n\n  .mr-sm-1,\n  .mx-sm-1 {\n    margin-right: 5px !important;\n  }\n\n  .mb-sm-1,\n  .my-sm-1 {\n    margin-bottom: 5px !important;\n  }\n\n  .ml-sm-1,\n  .mx-sm-1 {\n    margin-left: 5px !important;\n  }\n\n  .m-sm-2 {\n    margin: 5px !important;\n  }\n\n  .mt-sm-2,\n  .my-sm-2 {\n    margin-top: 5px !important;\n  }\n\n  .mr-sm-2,\n  .mx-sm-2 {\n    margin-right: 5px !important;\n  }\n\n  .mb-sm-2,\n  .my-sm-2 {\n    margin-bottom: 5px !important;\n  }\n\n  .ml-sm-2,\n  .mx-sm-2 {\n    margin-left: 5px !important;\n  }\n\n  .m-sm-3 {\n    margin: 15px !important;\n  }\n\n  .mt-sm-3,\n  .my-sm-3 {\n    margin-top: 15px !important;\n  }\n\n  .mr-sm-3,\n  .mx-sm-3 {\n    margin-right: 15px !important;\n  }\n\n  .mb-sm-3,\n  .my-sm-3 {\n    margin-bottom: 15px !important;\n  }\n\n  .ml-sm-3,\n  .mx-sm-3 {\n    margin-left: 15px !important;\n  }\n\n  .m-sm-4 {\n    margin: 30px !important;\n  }\n\n  .mt-sm-4,\n  .my-sm-4 {\n    margin-top: 30px !important;\n  }\n\n  .mr-sm-4,\n  .mx-sm-4 {\n    margin-right: 30px !important;\n  }\n\n  .mb-sm-4,\n  .my-sm-4 {\n    margin-bottom: 30px !important;\n  }\n\n  .ml-sm-4,\n  .mx-sm-4 {\n    margin-left: 30px !important;\n  }\n\n  .m-sm-5 {\n    margin: 30px !important;\n  }\n\n  .mt-sm-5,\n  .my-sm-5 {\n    margin-top: 30px !important;\n  }\n\n  .mr-sm-5,\n  .mx-sm-5 {\n    margin-right: 30px !important;\n  }\n\n  .mb-sm-5,\n  .my-sm-5 {\n    margin-bottom: 30px !important;\n  }\n\n  .ml-sm-5,\n  .mx-sm-5 {\n    margin-left: 30px !important;\n  }\n\n  .m-sm-6 {\n    margin: 50px !important;\n  }\n\n  .mt-sm-6,\n  .my-sm-6 {\n    margin-top: 50px !important;\n  }\n\n  .mr-sm-6,\n  .mx-sm-6 {\n    margin-right: 50px !important;\n  }\n\n  .mb-sm-6,\n  .my-sm-6 {\n    margin-bottom: 50px !important;\n  }\n\n  .ml-sm-6,\n  .mx-sm-6 {\n    margin-left: 50px !important;\n  }\n\n  .m-sm-7 {\n    margin: 60px !important;\n  }\n\n  .mt-sm-7,\n  .my-sm-7 {\n    margin-top: 60px !important;\n  }\n\n  .mr-sm-7,\n  .mx-sm-7 {\n    margin-right: 60px !important;\n  }\n\n  .mb-sm-7,\n  .my-sm-7 {\n    margin-bottom: 60px !important;\n  }\n\n  .ml-sm-7,\n  .mx-sm-7 {\n    margin-left: 60px !important;\n  }\n\n  .m-sm-8 {\n    margin: 70px !important;\n  }\n\n  .mt-sm-8,\n  .my-sm-8 {\n    margin-top: 70px !important;\n  }\n\n  .mr-sm-8,\n  .mx-sm-8 {\n    margin-right: 70px !important;\n  }\n\n  .mb-sm-8,\n  .my-sm-8 {\n    margin-bottom: 70px !important;\n  }\n\n  .ml-sm-8,\n  .mx-sm-8 {\n    margin-left: 70px !important;\n  }\n\n  .m-sm-9 {\n    margin: 80px !important;\n  }\n\n  .mt-sm-9,\n  .my-sm-9 {\n    margin-top: 80px !important;\n  }\n\n  .mr-sm-9,\n  .mx-sm-9 {\n    margin-right: 80px !important;\n  }\n\n  .mb-sm-9,\n  .my-sm-9 {\n    margin-bottom: 80px !important;\n  }\n\n  .ml-sm-9,\n  .mx-sm-9 {\n    margin-left: 80px !important;\n  }\n\n  .p-sm-0 {\n    padding: 0 !important;\n  }\n\n  .pt-sm-0,\n  .py-sm-0 {\n    padding-top: 0 !important;\n  }\n\n  .pr-sm-0,\n  .px-sm-0 {\n    padding-right: 0 !important;\n  }\n\n  .pb-sm-0,\n  .py-sm-0 {\n    padding-bottom: 0 !important;\n  }\n\n  .pl-sm-0,\n  .px-sm-0 {\n    padding-left: 0 !important;\n  }\n\n  .p-sm-1 {\n    padding: 5px !important;\n  }\n\n  .pt-sm-1,\n  .py-sm-1 {\n    padding-top: 5px !important;\n  }\n\n  .pr-sm-1,\n  .px-sm-1 {\n    padding-right: 5px !important;\n  }\n\n  .pb-sm-1,\n  .py-sm-1 {\n    padding-bottom: 5px !important;\n  }\n\n  .pl-sm-1,\n  .px-sm-1 {\n    padding-left: 5px !important;\n  }\n\n  .p-sm-2 {\n    padding: 5px !important;\n  }\n\n  .pt-sm-2,\n  .py-sm-2 {\n    padding-top: 5px !important;\n  }\n\n  .pr-sm-2,\n  .px-sm-2 {\n    padding-right: 5px !important;\n  }\n\n  .pb-sm-2,\n  .py-sm-2 {\n    padding-bottom: 5px !important;\n  }\n\n  .pl-sm-2,\n  .px-sm-2 {\n    padding-left: 5px !important;\n  }\n\n  .p-sm-3 {\n    padding: 15px !important;\n  }\n\n  .pt-sm-3,\n  .py-sm-3 {\n    padding-top: 15px !important;\n  }\n\n  .pr-sm-3,\n  .px-sm-3 {\n    padding-right: 15px !important;\n  }\n\n  .pb-sm-3,\n  .py-sm-3 {\n    padding-bottom: 15px !important;\n  }\n\n  .pl-sm-3,\n  .px-sm-3 {\n    padding-left: 15px !important;\n  }\n\n  .p-sm-4 {\n    padding: 30px !important;\n  }\n\n  .pt-sm-4,\n  .py-sm-4 {\n    padding-top: 30px !important;\n  }\n\n  .pr-sm-4,\n  .px-sm-4 {\n    padding-right: 30px !important;\n  }\n\n  .pb-sm-4,\n  .py-sm-4 {\n    padding-bottom: 30px !important;\n  }\n\n  .pl-sm-4,\n  .px-sm-4 {\n    padding-left: 30px !important;\n  }\n\n  .p-sm-5 {\n    padding: 30px !important;\n  }\n\n  .pt-sm-5,\n  .py-sm-5 {\n    padding-top: 30px !important;\n  }\n\n  .pr-sm-5,\n  .px-sm-5 {\n    padding-right: 30px !important;\n  }\n\n  .pb-sm-5,\n  .py-sm-5 {\n    padding-bottom: 30px !important;\n  }\n\n  .pl-sm-5,\n  .px-sm-5 {\n    padding-left: 30px !important;\n  }\n\n  .p-sm-6 {\n    padding: 50px !important;\n  }\n\n  .pt-sm-6,\n  .py-sm-6 {\n    padding-top: 50px !important;\n  }\n\n  .pr-sm-6,\n  .px-sm-6 {\n    padding-right: 50px !important;\n  }\n\n  .pb-sm-6,\n  .py-sm-6 {\n    padding-bottom: 50px !important;\n  }\n\n  .pl-sm-6,\n  .px-sm-6 {\n    padding-left: 50px !important;\n  }\n\n  .p-sm-7 {\n    padding: 60px !important;\n  }\n\n  .pt-sm-7,\n  .py-sm-7 {\n    padding-top: 60px !important;\n  }\n\n  .pr-sm-7,\n  .px-sm-7 {\n    padding-right: 60px !important;\n  }\n\n  .pb-sm-7,\n  .py-sm-7 {\n    padding-bottom: 60px !important;\n  }\n\n  .pl-sm-7,\n  .px-sm-7 {\n    padding-left: 60px !important;\n  }\n\n  .p-sm-8 {\n    padding: 70px !important;\n  }\n\n  .pt-sm-8,\n  .py-sm-8 {\n    padding-top: 70px !important;\n  }\n\n  .pr-sm-8,\n  .px-sm-8 {\n    padding-right: 70px !important;\n  }\n\n  .pb-sm-8,\n  .py-sm-8 {\n    padding-bottom: 70px !important;\n  }\n\n  .pl-sm-8,\n  .px-sm-8 {\n    padding-left: 70px !important;\n  }\n\n  .p-sm-9 {\n    padding: 80px !important;\n  }\n\n  .pt-sm-9,\n  .py-sm-9 {\n    padding-top: 80px !important;\n  }\n\n  .pr-sm-9,\n  .px-sm-9 {\n    padding-right: 80px !important;\n  }\n\n  .pb-sm-9,\n  .py-sm-9 {\n    padding-bottom: 80px !important;\n  }\n\n  .pl-sm-9,\n  .px-sm-9 {\n    padding-left: 80px !important;\n  }\n\n  .m-sm-n1 {\n    margin: -5px !important;\n  }\n\n  .mt-sm-n1,\n  .my-sm-n1 {\n    margin-top: -5px !important;\n  }\n\n  .mr-sm-n1,\n  .mx-sm-n1 {\n    margin-right: -5px !important;\n  }\n\n  .mb-sm-n1,\n  .my-sm-n1 {\n    margin-bottom: -5px !important;\n  }\n\n  .ml-sm-n1,\n  .mx-sm-n1 {\n    margin-left: -5px !important;\n  }\n\n  .m-sm-n2 {\n    margin: -5px !important;\n  }\n\n  .mt-sm-n2,\n  .my-sm-n2 {\n    margin-top: -5px !important;\n  }\n\n  .mr-sm-n2,\n  .mx-sm-n2 {\n    margin-right: -5px !important;\n  }\n\n  .mb-sm-n2,\n  .my-sm-n2 {\n    margin-bottom: -5px !important;\n  }\n\n  .ml-sm-n2,\n  .mx-sm-n2 {\n    margin-left: -5px !important;\n  }\n\n  .m-sm-n3 {\n    margin: -15px !important;\n  }\n\n  .mt-sm-n3,\n  .my-sm-n3 {\n    margin-top: -15px !important;\n  }\n\n  .mr-sm-n3,\n  .mx-sm-n3 {\n    margin-right: -15px !important;\n  }\n\n  .mb-sm-n3,\n  .my-sm-n3 {\n    margin-bottom: -15px !important;\n  }\n\n  .ml-sm-n3,\n  .mx-sm-n3 {\n    margin-left: -15px !important;\n  }\n\n  .m-sm-n4 {\n    margin: -30px !important;\n  }\n\n  .mt-sm-n4,\n  .my-sm-n4 {\n    margin-top: -30px !important;\n  }\n\n  .mr-sm-n4,\n  .mx-sm-n4 {\n    margin-right: -30px !important;\n  }\n\n  .mb-sm-n4,\n  .my-sm-n4 {\n    margin-bottom: -30px !important;\n  }\n\n  .ml-sm-n4,\n  .mx-sm-n4 {\n    margin-left: -30px !important;\n  }\n\n  .m-sm-n5 {\n    margin: -50px !important;\n  }\n\n  .mt-sm-n5,\n  .my-sm-n5 {\n    margin-top: -50px !important;\n  }\n\n  .mr-sm-n5,\n  .mx-sm-n5 {\n    margin-right: -50px !important;\n  }\n\n  .mb-sm-n5,\n  .my-sm-n5 {\n    margin-bottom: -50px !important;\n  }\n\n  .ml-sm-n5,\n  .mx-sm-n5 {\n    margin-left: -50px !important;\n  }\n\n  .m-sm-n6 {\n    margin: -50px !important;\n  }\n\n  .mt-sm-n6,\n  .my-sm-n6 {\n    margin-top: -50px !important;\n  }\n\n  .mr-sm-n6,\n  .mx-sm-n6 {\n    margin-right: -50px !important;\n  }\n\n  .mb-sm-n6,\n  .my-sm-n6 {\n    margin-bottom: -50px !important;\n  }\n\n  .ml-sm-n6,\n  .mx-sm-n6 {\n    margin-left: -50px !important;\n  }\n\n  .m-sm-n7 {\n    margin: -60px !important;\n  }\n\n  .mt-sm-n7,\n  .my-sm-n7 {\n    margin-top: -60px !important;\n  }\n\n  .mr-sm-n7,\n  .mx-sm-n7 {\n    margin-right: -60px !important;\n  }\n\n  .mb-sm-n7,\n  .my-sm-n7 {\n    margin-bottom: -60px !important;\n  }\n\n  .ml-sm-n7,\n  .mx-sm-n7 {\n    margin-left: -60px !important;\n  }\n\n  .m-sm-n8 {\n    margin: -70px !important;\n  }\n\n  .mt-sm-n8,\n  .my-sm-n8 {\n    margin-top: -70px !important;\n  }\n\n  .mr-sm-n8,\n  .mx-sm-n8 {\n    margin-right: -70px !important;\n  }\n\n  .mb-sm-n8,\n  .my-sm-n8 {\n    margin-bottom: -70px !important;\n  }\n\n  .ml-sm-n8,\n  .mx-sm-n8 {\n    margin-left: -70px !important;\n  }\n\n  .m-sm-n9 {\n    margin: -80px !important;\n  }\n\n  .mt-sm-n9,\n  .my-sm-n9 {\n    margin-top: -80px !important;\n  }\n\n  .mr-sm-n9,\n  .mx-sm-n9 {\n    margin-right: -80px !important;\n  }\n\n  .mb-sm-n9,\n  .my-sm-n9 {\n    margin-bottom: -80px !important;\n  }\n\n  .ml-sm-n9,\n  .mx-sm-n9 {\n    margin-left: -80px !important;\n  }\n\n  .m-sm-auto {\n    margin: auto !important;\n  }\n\n  .mt-sm-auto,\n  .my-sm-auto {\n    margin-top: auto !important;\n  }\n\n  .mr-sm-auto,\n  .mx-sm-auto {\n    margin-right: auto !important;\n  }\n\n  .mb-sm-auto,\n  .my-sm-auto {\n    margin-bottom: auto !important;\n  }\n\n  .ml-sm-auto,\n  .mx-sm-auto {\n    margin-left: auto !important;\n  }\n}\n\n@media (min-width: 768px) {\n  .m-md-0 {\n    margin: 0 !important;\n  }\n\n  .mt-md-0,\n  .my-md-0 {\n    margin-top: 0 !important;\n  }\n\n  .mr-md-0,\n  .mx-md-0 {\n    margin-right: 0 !important;\n  }\n\n  .mb-md-0,\n  .my-md-0 {\n    margin-bottom: 0 !important;\n  }\n\n  .ml-md-0,\n  .mx-md-0 {\n    margin-left: 0 !important;\n  }\n\n  .m-md-1 {\n    margin: 5px !important;\n  }\n\n  .mt-md-1,\n  .my-md-1 {\n    margin-top: 5px !important;\n  }\n\n  .mr-md-1,\n  .mx-md-1 {\n    margin-right: 5px !important;\n  }\n\n  .mb-md-1,\n  .my-md-1 {\n    margin-bottom: 5px !important;\n  }\n\n  .ml-md-1,\n  .mx-md-1 {\n    margin-left: 5px !important;\n  }\n\n  .m-md-2 {\n    margin: 5px !important;\n  }\n\n  .mt-md-2,\n  .my-md-2 {\n    margin-top: 5px !important;\n  }\n\n  .mr-md-2,\n  .mx-md-2 {\n    margin-right: 5px !important;\n  }\n\n  .mb-md-2,\n  .my-md-2 {\n    margin-bottom: 5px !important;\n  }\n\n  .ml-md-2,\n  .mx-md-2 {\n    margin-left: 5px !important;\n  }\n\n  .m-md-3 {\n    margin: 15px !important;\n  }\n\n  .mt-md-3,\n  .my-md-3 {\n    margin-top: 15px !important;\n  }\n\n  .mr-md-3,\n  .mx-md-3 {\n    margin-right: 15px !important;\n  }\n\n  .mb-md-3,\n  .my-md-3 {\n    margin-bottom: 15px !important;\n  }\n\n  .ml-md-3,\n  .mx-md-3 {\n    margin-left: 15px !important;\n  }\n\n  .m-md-4 {\n    margin: 30px !important;\n  }\n\n  .mt-md-4,\n  .my-md-4 {\n    margin-top: 30px !important;\n  }\n\n  .mr-md-4,\n  .mx-md-4 {\n    margin-right: 30px !important;\n  }\n\n  .mb-md-4,\n  .my-md-4 {\n    margin-bottom: 30px !important;\n  }\n\n  .ml-md-4,\n  .mx-md-4 {\n    margin-left: 30px !important;\n  }\n\n  .m-md-5 {\n    margin: 30px !important;\n  }\n\n  .mt-md-5,\n  .my-md-5 {\n    margin-top: 30px !important;\n  }\n\n  .mr-md-5,\n  .mx-md-5 {\n    margin-right: 30px !important;\n  }\n\n  .mb-md-5,\n  .my-md-5 {\n    margin-bottom: 30px !important;\n  }\n\n  .ml-md-5,\n  .mx-md-5 {\n    margin-left: 30px !important;\n  }\n\n  .m-md-6 {\n    margin: 50px !important;\n  }\n\n  .mt-md-6,\n  .my-md-6 {\n    margin-top: 50px !important;\n  }\n\n  .mr-md-6,\n  .mx-md-6 {\n    margin-right: 50px !important;\n  }\n\n  .mb-md-6,\n  .my-md-6 {\n    margin-bottom: 50px !important;\n  }\n\n  .ml-md-6,\n  .mx-md-6 {\n    margin-left: 50px !important;\n  }\n\n  .m-md-7 {\n    margin: 60px !important;\n  }\n\n  .mt-md-7,\n  .my-md-7 {\n    margin-top: 60px !important;\n  }\n\n  .mr-md-7,\n  .mx-md-7 {\n    margin-right: 60px !important;\n  }\n\n  .mb-md-7,\n  .my-md-7 {\n    margin-bottom: 60px !important;\n  }\n\n  .ml-md-7,\n  .mx-md-7 {\n    margin-left: 60px !important;\n  }\n\n  .m-md-8 {\n    margin: 70px !important;\n  }\n\n  .mt-md-8,\n  .my-md-8 {\n    margin-top: 70px !important;\n  }\n\n  .mr-md-8,\n  .mx-md-8 {\n    margin-right: 70px !important;\n  }\n\n  .mb-md-8,\n  .my-md-8 {\n    margin-bottom: 70px !important;\n  }\n\n  .ml-md-8,\n  .mx-md-8 {\n    margin-left: 70px !important;\n  }\n\n  .m-md-9 {\n    margin: 80px !important;\n  }\n\n  .mt-md-9,\n  .my-md-9 {\n    margin-top: 80px !important;\n  }\n\n  .mr-md-9,\n  .mx-md-9 {\n    margin-right: 80px !important;\n  }\n\n  .mb-md-9,\n  .my-md-9 {\n    margin-bottom: 80px !important;\n  }\n\n  .ml-md-9,\n  .mx-md-9 {\n    margin-left: 80px !important;\n  }\n\n  .p-md-0 {\n    padding: 0 !important;\n  }\n\n  .pt-md-0,\n  .py-md-0 {\n    padding-top: 0 !important;\n  }\n\n  .pr-md-0,\n  .px-md-0 {\n    padding-right: 0 !important;\n  }\n\n  .pb-md-0,\n  .py-md-0 {\n    padding-bottom: 0 !important;\n  }\n\n  .pl-md-0,\n  .px-md-0 {\n    padding-left: 0 !important;\n  }\n\n  .p-md-1 {\n    padding: 5px !important;\n  }\n\n  .pt-md-1,\n  .py-md-1 {\n    padding-top: 5px !important;\n  }\n\n  .pr-md-1,\n  .px-md-1 {\n    padding-right: 5px !important;\n  }\n\n  .pb-md-1,\n  .py-md-1 {\n    padding-bottom: 5px !important;\n  }\n\n  .pl-md-1,\n  .px-md-1 {\n    padding-left: 5px !important;\n  }\n\n  .p-md-2 {\n    padding: 5px !important;\n  }\n\n  .pt-md-2,\n  .py-md-2 {\n    padding-top: 5px !important;\n  }\n\n  .pr-md-2,\n  .px-md-2 {\n    padding-right: 5px !important;\n  }\n\n  .pb-md-2,\n  .py-md-2 {\n    padding-bottom: 5px !important;\n  }\n\n  .pl-md-2,\n  .px-md-2 {\n    padding-left: 5px !important;\n  }\n\n  .p-md-3 {\n    padding: 15px !important;\n  }\n\n  .pt-md-3,\n  .py-md-3 {\n    padding-top: 15px !important;\n  }\n\n  .pr-md-3,\n  .px-md-3 {\n    padding-right: 15px !important;\n  }\n\n  .pb-md-3,\n  .py-md-3 {\n    padding-bottom: 15px !important;\n  }\n\n  .pl-md-3,\n  .px-md-3 {\n    padding-left: 15px !important;\n  }\n\n  .p-md-4 {\n    padding: 30px !important;\n  }\n\n  .pt-md-4,\n  .py-md-4 {\n    padding-top: 30px !important;\n  }\n\n  .pr-md-4,\n  .px-md-4 {\n    padding-right: 30px !important;\n  }\n\n  .pb-md-4,\n  .py-md-4 {\n    padding-bottom: 30px !important;\n  }\n\n  .pl-md-4,\n  .px-md-4 {\n    padding-left: 30px !important;\n  }\n\n  .p-md-5 {\n    padding: 30px !important;\n  }\n\n  .pt-md-5,\n  .py-md-5 {\n    padding-top: 30px !important;\n  }\n\n  .pr-md-5,\n  .px-md-5 {\n    padding-right: 30px !important;\n  }\n\n  .pb-md-5,\n  .py-md-5 {\n    padding-bottom: 30px !important;\n  }\n\n  .pl-md-5,\n  .px-md-5 {\n    padding-left: 30px !important;\n  }\n\n  .p-md-6 {\n    padding: 50px !important;\n  }\n\n  .pt-md-6,\n  .py-md-6 {\n    padding-top: 50px !important;\n  }\n\n  .pr-md-6,\n  .px-md-6 {\n    padding-right: 50px !important;\n  }\n\n  .pb-md-6,\n  .py-md-6 {\n    padding-bottom: 50px !important;\n  }\n\n  .pl-md-6,\n  .px-md-6 {\n    padding-left: 50px !important;\n  }\n\n  .p-md-7 {\n    padding: 60px !important;\n  }\n\n  .pt-md-7,\n  .py-md-7 {\n    padding-top: 60px !important;\n  }\n\n  .pr-md-7,\n  .px-md-7 {\n    padding-right: 60px !important;\n  }\n\n  .pb-md-7,\n  .py-md-7 {\n    padding-bottom: 60px !important;\n  }\n\n  .pl-md-7,\n  .px-md-7 {\n    padding-left: 60px !important;\n  }\n\n  .p-md-8 {\n    padding: 70px !important;\n  }\n\n  .pt-md-8,\n  .py-md-8 {\n    padding-top: 70px !important;\n  }\n\n  .pr-md-8,\n  .px-md-8 {\n    padding-right: 70px !important;\n  }\n\n  .pb-md-8,\n  .py-md-8 {\n    padding-bottom: 70px !important;\n  }\n\n  .pl-md-8,\n  .px-md-8 {\n    padding-left: 70px !important;\n  }\n\n  .p-md-9 {\n    padding: 80px !important;\n  }\n\n  .pt-md-9,\n  .py-md-9 {\n    padding-top: 80px !important;\n  }\n\n  .pr-md-9,\n  .px-md-9 {\n    padding-right: 80px !important;\n  }\n\n  .pb-md-9,\n  .py-md-9 {\n    padding-bottom: 80px !important;\n  }\n\n  .pl-md-9,\n  .px-md-9 {\n    padding-left: 80px !important;\n  }\n\n  .m-md-n1 {\n    margin: -5px !important;\n  }\n\n  .mt-md-n1,\n  .my-md-n1 {\n    margin-top: -5px !important;\n  }\n\n  .mr-md-n1,\n  .mx-md-n1 {\n    margin-right: -5px !important;\n  }\n\n  .mb-md-n1,\n  .my-md-n1 {\n    margin-bottom: -5px !important;\n  }\n\n  .ml-md-n1,\n  .mx-md-n1 {\n    margin-left: -5px !important;\n  }\n\n  .m-md-n2 {\n    margin: -5px !important;\n  }\n\n  .mt-md-n2,\n  .my-md-n2 {\n    margin-top: -5px !important;\n  }\n\n  .mr-md-n2,\n  .mx-md-n2 {\n    margin-right: -5px !important;\n  }\n\n  .mb-md-n2,\n  .my-md-n2 {\n    margin-bottom: -5px !important;\n  }\n\n  .ml-md-n2,\n  .mx-md-n2 {\n    margin-left: -5px !important;\n  }\n\n  .m-md-n3 {\n    margin: -15px !important;\n  }\n\n  .mt-md-n3,\n  .my-md-n3 {\n    margin-top: -15px !important;\n  }\n\n  .mr-md-n3,\n  .mx-md-n3 {\n    margin-right: -15px !important;\n  }\n\n  .mb-md-n3,\n  .my-md-n3 {\n    margin-bottom: -15px !important;\n  }\n\n  .ml-md-n3,\n  .mx-md-n3 {\n    margin-left: -15px !important;\n  }\n\n  .m-md-n4 {\n    margin: -30px !important;\n  }\n\n  .mt-md-n4,\n  .my-md-n4 {\n    margin-top: -30px !important;\n  }\n\n  .mr-md-n4,\n  .mx-md-n4 {\n    margin-right: -30px !important;\n  }\n\n  .mb-md-n4,\n  .my-md-n4 {\n    margin-bottom: -30px !important;\n  }\n\n  .ml-md-n4,\n  .mx-md-n4 {\n    margin-left: -30px !important;\n  }\n\n  .m-md-n5 {\n    margin: -50px !important;\n  }\n\n  .mt-md-n5,\n  .my-md-n5 {\n    margin-top: -50px !important;\n  }\n\n  .mr-md-n5,\n  .mx-md-n5 {\n    margin-right: -50px !important;\n  }\n\n  .mb-md-n5,\n  .my-md-n5 {\n    margin-bottom: -50px !important;\n  }\n\n  .ml-md-n5,\n  .mx-md-n5 {\n    margin-left: -50px !important;\n  }\n\n  .m-md-n6 {\n    margin: -50px !important;\n  }\n\n  .mt-md-n6,\n  .my-md-n6 {\n    margin-top: -50px !important;\n  }\n\n  .mr-md-n6,\n  .mx-md-n6 {\n    margin-right: -50px !important;\n  }\n\n  .mb-md-n6,\n  .my-md-n6 {\n    margin-bottom: -50px !important;\n  }\n\n  .ml-md-n6,\n  .mx-md-n6 {\n    margin-left: -50px !important;\n  }\n\n  .m-md-n7 {\n    margin: -60px !important;\n  }\n\n  .mt-md-n7,\n  .my-md-n7 {\n    margin-top: -60px !important;\n  }\n\n  .mr-md-n7,\n  .mx-md-n7 {\n    margin-right: -60px !important;\n  }\n\n  .mb-md-n7,\n  .my-md-n7 {\n    margin-bottom: -60px !important;\n  }\n\n  .ml-md-n7,\n  .mx-md-n7 {\n    margin-left: -60px !important;\n  }\n\n  .m-md-n8 {\n    margin: -70px !important;\n  }\n\n  .mt-md-n8,\n  .my-md-n8 {\n    margin-top: -70px !important;\n  }\n\n  .mr-md-n8,\n  .mx-md-n8 {\n    margin-right: -70px !important;\n  }\n\n  .mb-md-n8,\n  .my-md-n8 {\n    margin-bottom: -70px !important;\n  }\n\n  .ml-md-n8,\n  .mx-md-n8 {\n    margin-left: -70px !important;\n  }\n\n  .m-md-n9 {\n    margin: -80px !important;\n  }\n\n  .mt-md-n9,\n  .my-md-n9 {\n    margin-top: -80px !important;\n  }\n\n  .mr-md-n9,\n  .mx-md-n9 {\n    margin-right: -80px !important;\n  }\n\n  .mb-md-n9,\n  .my-md-n9 {\n    margin-bottom: -80px !important;\n  }\n\n  .ml-md-n9,\n  .mx-md-n9 {\n    margin-left: -80px !important;\n  }\n\n  .m-md-auto {\n    margin: auto !important;\n  }\n\n  .mt-md-auto,\n  .my-md-auto {\n    margin-top: auto !important;\n  }\n\n  .mr-md-auto,\n  .mx-md-auto {\n    margin-right: auto !important;\n  }\n\n  .mb-md-auto,\n  .my-md-auto {\n    margin-bottom: auto !important;\n  }\n\n  .ml-md-auto,\n  .mx-md-auto {\n    margin-left: auto !important;\n  }\n}\n\n@media (min-width: 992px) {\n  .m-lg-0 {\n    margin: 0 !important;\n  }\n\n  .mt-lg-0,\n  .my-lg-0 {\n    margin-top: 0 !important;\n  }\n\n  .mr-lg-0,\n  .mx-lg-0 {\n    margin-right: 0 !important;\n  }\n\n  .mb-lg-0,\n  .my-lg-0 {\n    margin-bottom: 0 !important;\n  }\n\n  .ml-lg-0,\n  .mx-lg-0 {\n    margin-left: 0 !important;\n  }\n\n  .m-lg-1 {\n    margin: 5px !important;\n  }\n\n  .mt-lg-1,\n  .my-lg-1 {\n    margin-top: 5px !important;\n  }\n\n  .mr-lg-1,\n  .mx-lg-1 {\n    margin-right: 5px !important;\n  }\n\n  .mb-lg-1,\n  .my-lg-1 {\n    margin-bottom: 5px !important;\n  }\n\n  .ml-lg-1,\n  .mx-lg-1 {\n    margin-left: 5px !important;\n  }\n\n  .m-lg-2 {\n    margin: 5px !important;\n  }\n\n  .mt-lg-2,\n  .my-lg-2 {\n    margin-top: 5px !important;\n  }\n\n  .mr-lg-2,\n  .mx-lg-2 {\n    margin-right: 5px !important;\n  }\n\n  .mb-lg-2,\n  .my-lg-2 {\n    margin-bottom: 5px !important;\n  }\n\n  .ml-lg-2,\n  .mx-lg-2 {\n    margin-left: 5px !important;\n  }\n\n  .m-lg-3 {\n    margin: 15px !important;\n  }\n\n  .mt-lg-3,\n  .my-lg-3 {\n    margin-top: 15px !important;\n  }\n\n  .mr-lg-3,\n  .mx-lg-3 {\n    margin-right: 15px !important;\n  }\n\n  .mb-lg-3,\n  .my-lg-3 {\n    margin-bottom: 15px !important;\n  }\n\n  .ml-lg-3,\n  .mx-lg-3 {\n    margin-left: 15px !important;\n  }\n\n  .m-lg-4 {\n    margin: 30px !important;\n  }\n\n  .mt-lg-4,\n  .my-lg-4 {\n    margin-top: 30px !important;\n  }\n\n  .mr-lg-4,\n  .mx-lg-4 {\n    margin-right: 30px !important;\n  }\n\n  .mb-lg-4,\n  .my-lg-4 {\n    margin-bottom: 30px !important;\n  }\n\n  .ml-lg-4,\n  .mx-lg-4 {\n    margin-left: 30px !important;\n  }\n\n  .m-lg-5 {\n    margin: 30px !important;\n  }\n\n  .mt-lg-5,\n  .my-lg-5 {\n    margin-top: 30px !important;\n  }\n\n  .mr-lg-5,\n  .mx-lg-5 {\n    margin-right: 30px !important;\n  }\n\n  .mb-lg-5,\n  .my-lg-5 {\n    margin-bottom: 30px !important;\n  }\n\n  .ml-lg-5,\n  .mx-lg-5 {\n    margin-left: 30px !important;\n  }\n\n  .m-lg-6 {\n    margin: 50px !important;\n  }\n\n  .mt-lg-6,\n  .my-lg-6 {\n    margin-top: 50px !important;\n  }\n\n  .mr-lg-6,\n  .mx-lg-6 {\n    margin-right: 50px !important;\n  }\n\n  .mb-lg-6,\n  .my-lg-6 {\n    margin-bottom: 50px !important;\n  }\n\n  .ml-lg-6,\n  .mx-lg-6 {\n    margin-left: 50px !important;\n  }\n\n  .m-lg-7 {\n    margin: 60px !important;\n  }\n\n  .mt-lg-7,\n  .my-lg-7 {\n    margin-top: 60px !important;\n  }\n\n  .mr-lg-7,\n  .mx-lg-7 {\n    margin-right: 60px !important;\n  }\n\n  .mb-lg-7,\n  .my-lg-7 {\n    margin-bottom: 60px !important;\n  }\n\n  .ml-lg-7,\n  .mx-lg-7 {\n    margin-left: 60px !important;\n  }\n\n  .m-lg-8 {\n    margin: 70px !important;\n  }\n\n  .mt-lg-8,\n  .my-lg-8 {\n    margin-top: 70px !important;\n  }\n\n  .mr-lg-8,\n  .mx-lg-8 {\n    margin-right: 70px !important;\n  }\n\n  .mb-lg-8,\n  .my-lg-8 {\n    margin-bottom: 70px !important;\n  }\n\n  .ml-lg-8,\n  .mx-lg-8 {\n    margin-left: 70px !important;\n  }\n\n  .m-lg-9 {\n    margin: 80px !important;\n  }\n\n  .mt-lg-9,\n  .my-lg-9 {\n    margin-top: 80px !important;\n  }\n\n  .mr-lg-9,\n  .mx-lg-9 {\n    margin-right: 80px !important;\n  }\n\n  .mb-lg-9,\n  .my-lg-9 {\n    margin-bottom: 80px !important;\n  }\n\n  .ml-lg-9,\n  .mx-lg-9 {\n    margin-left: 80px !important;\n  }\n\n  .p-lg-0 {\n    padding: 0 !important;\n  }\n\n  .pt-lg-0,\n  .py-lg-0 {\n    padding-top: 0 !important;\n  }\n\n  .pr-lg-0,\n  .px-lg-0 {\n    padding-right: 0 !important;\n  }\n\n  .pb-lg-0,\n  .py-lg-0 {\n    padding-bottom: 0 !important;\n  }\n\n  .pl-lg-0,\n  .px-lg-0 {\n    padding-left: 0 !important;\n  }\n\n  .p-lg-1 {\n    padding: 5px !important;\n  }\n\n  .pt-lg-1,\n  .py-lg-1 {\n    padding-top: 5px !important;\n  }\n\n  .pr-lg-1,\n  .px-lg-1 {\n    padding-right: 5px !important;\n  }\n\n  .pb-lg-1,\n  .py-lg-1 {\n    padding-bottom: 5px !important;\n  }\n\n  .pl-lg-1,\n  .px-lg-1 {\n    padding-left: 5px !important;\n  }\n\n  .p-lg-2 {\n    padding: 5px !important;\n  }\n\n  .pt-lg-2,\n  .py-lg-2 {\n    padding-top: 5px !important;\n  }\n\n  .pr-lg-2,\n  .px-lg-2 {\n    padding-right: 5px !important;\n  }\n\n  .pb-lg-2,\n  .py-lg-2 {\n    padding-bottom: 5px !important;\n  }\n\n  .pl-lg-2,\n  .px-lg-2 {\n    padding-left: 5px !important;\n  }\n\n  .p-lg-3 {\n    padding: 15px !important;\n  }\n\n  .pt-lg-3,\n  .py-lg-3 {\n    padding-top: 15px !important;\n  }\n\n  .pr-lg-3,\n  .px-lg-3 {\n    padding-right: 15px !important;\n  }\n\n  .pb-lg-3,\n  .py-lg-3 {\n    padding-bottom: 15px !important;\n  }\n\n  .pl-lg-3,\n  .px-lg-3 {\n    padding-left: 15px !important;\n  }\n\n  .p-lg-4 {\n    padding: 30px !important;\n  }\n\n  .pt-lg-4,\n  .py-lg-4 {\n    padding-top: 30px !important;\n  }\n\n  .pr-lg-4,\n  .px-lg-4 {\n    padding-right: 30px !important;\n  }\n\n  .pb-lg-4,\n  .py-lg-4 {\n    padding-bottom: 30px !important;\n  }\n\n  .pl-lg-4,\n  .px-lg-4 {\n    padding-left: 30px !important;\n  }\n\n  .p-lg-5 {\n    padding: 30px !important;\n  }\n\n  .pt-lg-5,\n  .py-lg-5 {\n    padding-top: 30px !important;\n  }\n\n  .pr-lg-5,\n  .px-lg-5 {\n    padding-right: 30px !important;\n  }\n\n  .pb-lg-5,\n  .py-lg-5 {\n    padding-bottom: 30px !important;\n  }\n\n  .pl-lg-5,\n  .px-lg-5 {\n    padding-left: 30px !important;\n  }\n\n  .p-lg-6 {\n    padding: 50px !important;\n  }\n\n  .pt-lg-6,\n  .py-lg-6 {\n    padding-top: 50px !important;\n  }\n\n  .pr-lg-6,\n  .px-lg-6 {\n    padding-right: 50px !important;\n  }\n\n  .pb-lg-6,\n  .py-lg-6 {\n    padding-bottom: 50px !important;\n  }\n\n  .pl-lg-6,\n  .px-lg-6 {\n    padding-left: 50px !important;\n  }\n\n  .p-lg-7 {\n    padding: 60px !important;\n  }\n\n  .pt-lg-7,\n  .py-lg-7 {\n    padding-top: 60px !important;\n  }\n\n  .pr-lg-7,\n  .px-lg-7 {\n    padding-right: 60px !important;\n  }\n\n  .pb-lg-7,\n  .py-lg-7 {\n    padding-bottom: 60px !important;\n  }\n\n  .pl-lg-7,\n  .px-lg-7 {\n    padding-left: 60px !important;\n  }\n\n  .p-lg-8 {\n    padding: 70px !important;\n  }\n\n  .pt-lg-8,\n  .py-lg-8 {\n    padding-top: 70px !important;\n  }\n\n  .pr-lg-8,\n  .px-lg-8 {\n    padding-right: 70px !important;\n  }\n\n  .pb-lg-8,\n  .py-lg-8 {\n    padding-bottom: 70px !important;\n  }\n\n  .pl-lg-8,\n  .px-lg-8 {\n    padding-left: 70px !important;\n  }\n\n  .p-lg-9 {\n    padding: 80px !important;\n  }\n\n  .pt-lg-9,\n  .py-lg-9 {\n    padding-top: 80px !important;\n  }\n\n  .pr-lg-9,\n  .px-lg-9 {\n    padding-right: 80px !important;\n  }\n\n  .pb-lg-9,\n  .py-lg-9 {\n    padding-bottom: 80px !important;\n  }\n\n  .pl-lg-9,\n  .px-lg-9 {\n    padding-left: 80px !important;\n  }\n\n  .m-lg-n1 {\n    margin: -5px !important;\n  }\n\n  .mt-lg-n1,\n  .my-lg-n1 {\n    margin-top: -5px !important;\n  }\n\n  .mr-lg-n1,\n  .mx-lg-n1 {\n    margin-right: -5px !important;\n  }\n\n  .mb-lg-n1,\n  .my-lg-n1 {\n    margin-bottom: -5px !important;\n  }\n\n  .ml-lg-n1,\n  .mx-lg-n1 {\n    margin-left: -5px !important;\n  }\n\n  .m-lg-n2 {\n    margin: -5px !important;\n  }\n\n  .mt-lg-n2,\n  .my-lg-n2 {\n    margin-top: -5px !important;\n  }\n\n  .mr-lg-n2,\n  .mx-lg-n2 {\n    margin-right: -5px !important;\n  }\n\n  .mb-lg-n2,\n  .my-lg-n2 {\n    margin-bottom: -5px !important;\n  }\n\n  .ml-lg-n2,\n  .mx-lg-n2 {\n    margin-left: -5px !important;\n  }\n\n  .m-lg-n3 {\n    margin: -15px !important;\n  }\n\n  .mt-lg-n3,\n  .my-lg-n3 {\n    margin-top: -15px !important;\n  }\n\n  .mr-lg-n3,\n  .mx-lg-n3 {\n    margin-right: -15px !important;\n  }\n\n  .mb-lg-n3,\n  .my-lg-n3 {\n    margin-bottom: -15px !important;\n  }\n\n  .ml-lg-n3,\n  .mx-lg-n3 {\n    margin-left: -15px !important;\n  }\n\n  .m-lg-n4 {\n    margin: -30px !important;\n  }\n\n  .mt-lg-n4,\n  .my-lg-n4 {\n    margin-top: -30px !important;\n  }\n\n  .mr-lg-n4,\n  .mx-lg-n4 {\n    margin-right: -30px !important;\n  }\n\n  .mb-lg-n4,\n  .my-lg-n4 {\n    margin-bottom: -30px !important;\n  }\n\n  .ml-lg-n4,\n  .mx-lg-n4 {\n    margin-left: -30px !important;\n  }\n\n  .m-lg-n5 {\n    margin: -50px !important;\n  }\n\n  .mt-lg-n5,\n  .my-lg-n5 {\n    margin-top: -50px !important;\n  }\n\n  .mr-lg-n5,\n  .mx-lg-n5 {\n    margin-right: -50px !important;\n  }\n\n  .mb-lg-n5,\n  .my-lg-n5 {\n    margin-bottom: -50px !important;\n  }\n\n  .ml-lg-n5,\n  .mx-lg-n5 {\n    margin-left: -50px !important;\n  }\n\n  .m-lg-n6 {\n    margin: -50px !important;\n  }\n\n  .mt-lg-n6,\n  .my-lg-n6 {\n    margin-top: -50px !important;\n  }\n\n  .mr-lg-n6,\n  .mx-lg-n6 {\n    margin-right: -50px !important;\n  }\n\n  .mb-lg-n6,\n  .my-lg-n6 {\n    margin-bottom: -50px !important;\n  }\n\n  .ml-lg-n6,\n  .mx-lg-n6 {\n    margin-left: -50px !important;\n  }\n\n  .m-lg-n7 {\n    margin: -60px !important;\n  }\n\n  .mt-lg-n7,\n  .my-lg-n7 {\n    margin-top: -60px !important;\n  }\n\n  .mr-lg-n7,\n  .mx-lg-n7 {\n    margin-right: -60px !important;\n  }\n\n  .mb-lg-n7,\n  .my-lg-n7 {\n    margin-bottom: -60px !important;\n  }\n\n  .ml-lg-n7,\n  .mx-lg-n7 {\n    margin-left: -60px !important;\n  }\n\n  .m-lg-n8 {\n    margin: -70px !important;\n  }\n\n  .mt-lg-n8,\n  .my-lg-n8 {\n    margin-top: -70px !important;\n  }\n\n  .mr-lg-n8,\n  .mx-lg-n8 {\n    margin-right: -70px !important;\n  }\n\n  .mb-lg-n8,\n  .my-lg-n8 {\n    margin-bottom: -70px !important;\n  }\n\n  .ml-lg-n8,\n  .mx-lg-n8 {\n    margin-left: -70px !important;\n  }\n\n  .m-lg-n9 {\n    margin: -80px !important;\n  }\n\n  .mt-lg-n9,\n  .my-lg-n9 {\n    margin-top: -80px !important;\n  }\n\n  .mr-lg-n9,\n  .mx-lg-n9 {\n    margin-right: -80px !important;\n  }\n\n  .mb-lg-n9,\n  .my-lg-n9 {\n    margin-bottom: -80px !important;\n  }\n\n  .ml-lg-n9,\n  .mx-lg-n9 {\n    margin-left: -80px !important;\n  }\n\n  .m-lg-auto {\n    margin: auto !important;\n  }\n\n  .mt-lg-auto,\n  .my-lg-auto {\n    margin-top: auto !important;\n  }\n\n  .mr-lg-auto,\n  .mx-lg-auto {\n    margin-right: auto !important;\n  }\n\n  .mb-lg-auto,\n  .my-lg-auto {\n    margin-bottom: auto !important;\n  }\n\n  .ml-lg-auto,\n  .mx-lg-auto {\n    margin-left: auto !important;\n  }\n}\n\n@media (min-width: 1200px) {\n  .m-xl-0 {\n    margin: 0 !important;\n  }\n\n  .mt-xl-0,\n  .my-xl-0 {\n    margin-top: 0 !important;\n  }\n\n  .mr-xl-0,\n  .mx-xl-0 {\n    margin-right: 0 !important;\n  }\n\n  .mb-xl-0,\n  .my-xl-0 {\n    margin-bottom: 0 !important;\n  }\n\n  .ml-xl-0,\n  .mx-xl-0 {\n    margin-left: 0 !important;\n  }\n\n  .m-xl-1 {\n    margin: 5px !important;\n  }\n\n  .mt-xl-1,\n  .my-xl-1 {\n    margin-top: 5px !important;\n  }\n\n  .mr-xl-1,\n  .mx-xl-1 {\n    margin-right: 5px !important;\n  }\n\n  .mb-xl-1,\n  .my-xl-1 {\n    margin-bottom: 5px !important;\n  }\n\n  .ml-xl-1,\n  .mx-xl-1 {\n    margin-left: 5px !important;\n  }\n\n  .m-xl-2 {\n    margin: 5px !important;\n  }\n\n  .mt-xl-2,\n  .my-xl-2 {\n    margin-top: 5px !important;\n  }\n\n  .mr-xl-2,\n  .mx-xl-2 {\n    margin-right: 5px !important;\n  }\n\n  .mb-xl-2,\n  .my-xl-2 {\n    margin-bottom: 5px !important;\n  }\n\n  .ml-xl-2,\n  .mx-xl-2 {\n    margin-left: 5px !important;\n  }\n\n  .m-xl-3 {\n    margin: 15px !important;\n  }\n\n  .mt-xl-3,\n  .my-xl-3 {\n    margin-top: 15px !important;\n  }\n\n  .mr-xl-3,\n  .mx-xl-3 {\n    margin-right: 15px !important;\n  }\n\n  .mb-xl-3,\n  .my-xl-3 {\n    margin-bottom: 15px !important;\n  }\n\n  .ml-xl-3,\n  .mx-xl-3 {\n    margin-left: 15px !important;\n  }\n\n  .m-xl-4 {\n    margin: 30px !important;\n  }\n\n  .mt-xl-4,\n  .my-xl-4 {\n    margin-top: 30px !important;\n  }\n\n  .mr-xl-4,\n  .mx-xl-4 {\n    margin-right: 30px !important;\n  }\n\n  .mb-xl-4,\n  .my-xl-4 {\n    margin-bottom: 30px !important;\n  }\n\n  .ml-xl-4,\n  .mx-xl-4 {\n    margin-left: 30px !important;\n  }\n\n  .m-xl-5 {\n    margin: 30px !important;\n  }\n\n  .mt-xl-5,\n  .my-xl-5 {\n    margin-top: 30px !important;\n  }\n\n  .mr-xl-5,\n  .mx-xl-5 {\n    margin-right: 30px !important;\n  }\n\n  .mb-xl-5,\n  .my-xl-5 {\n    margin-bottom: 30px !important;\n  }\n\n  .ml-xl-5,\n  .mx-xl-5 {\n    margin-left: 30px !important;\n  }\n\n  .m-xl-6 {\n    margin: 50px !important;\n  }\n\n  .mt-xl-6,\n  .my-xl-6 {\n    margin-top: 50px !important;\n  }\n\n  .mr-xl-6,\n  .mx-xl-6 {\n    margin-right: 50px !important;\n  }\n\n  .mb-xl-6,\n  .my-xl-6 {\n    margin-bottom: 50px !important;\n  }\n\n  .ml-xl-6,\n  .mx-xl-6 {\n    margin-left: 50px !important;\n  }\n\n  .m-xl-7 {\n    margin: 60px !important;\n  }\n\n  .mt-xl-7,\n  .my-xl-7 {\n    margin-top: 60px !important;\n  }\n\n  .mr-xl-7,\n  .mx-xl-7 {\n    margin-right: 60px !important;\n  }\n\n  .mb-xl-7,\n  .my-xl-7 {\n    margin-bottom: 60px !important;\n  }\n\n  .ml-xl-7,\n  .mx-xl-7 {\n    margin-left: 60px !important;\n  }\n\n  .m-xl-8 {\n    margin: 70px !important;\n  }\n\n  .mt-xl-8,\n  .my-xl-8 {\n    margin-top: 70px !important;\n  }\n\n  .mr-xl-8,\n  .mx-xl-8 {\n    margin-right: 70px !important;\n  }\n\n  .mb-xl-8,\n  .my-xl-8 {\n    margin-bottom: 70px !important;\n  }\n\n  .ml-xl-8,\n  .mx-xl-8 {\n    margin-left: 70px !important;\n  }\n\n  .m-xl-9 {\n    margin: 80px !important;\n  }\n\n  .mt-xl-9,\n  .my-xl-9 {\n    margin-top: 80px !important;\n  }\n\n  .mr-xl-9,\n  .mx-xl-9 {\n    margin-right: 80px !important;\n  }\n\n  .mb-xl-9,\n  .my-xl-9 {\n    margin-bottom: 80px !important;\n  }\n\n  .ml-xl-9,\n  .mx-xl-9 {\n    margin-left: 80px !important;\n  }\n\n  .p-xl-0 {\n    padding: 0 !important;\n  }\n\n  .pt-xl-0,\n  .py-xl-0 {\n    padding-top: 0 !important;\n  }\n\n  .pr-xl-0,\n  .px-xl-0 {\n    padding-right: 0 !important;\n  }\n\n  .pb-xl-0,\n  .py-xl-0 {\n    padding-bottom: 0 !important;\n  }\n\n  .pl-xl-0,\n  .px-xl-0 {\n    padding-left: 0 !important;\n  }\n\n  .p-xl-1 {\n    padding: 5px !important;\n  }\n\n  .pt-xl-1,\n  .py-xl-1 {\n    padding-top: 5px !important;\n  }\n\n  .pr-xl-1,\n  .px-xl-1 {\n    padding-right: 5px !important;\n  }\n\n  .pb-xl-1,\n  .py-xl-1 {\n    padding-bottom: 5px !important;\n  }\n\n  .pl-xl-1,\n  .px-xl-1 {\n    padding-left: 5px !important;\n  }\n\n  .p-xl-2 {\n    padding: 5px !important;\n  }\n\n  .pt-xl-2,\n  .py-xl-2 {\n    padding-top: 5px !important;\n  }\n\n  .pr-xl-2,\n  .px-xl-2 {\n    padding-right: 5px !important;\n  }\n\n  .pb-xl-2,\n  .py-xl-2 {\n    padding-bottom: 5px !important;\n  }\n\n  .pl-xl-2,\n  .px-xl-2 {\n    padding-left: 5px !important;\n  }\n\n  .p-xl-3 {\n    padding: 15px !important;\n  }\n\n  .pt-xl-3,\n  .py-xl-3 {\n    padding-top: 15px !important;\n  }\n\n  .pr-xl-3,\n  .px-xl-3 {\n    padding-right: 15px !important;\n  }\n\n  .pb-xl-3,\n  .py-xl-3 {\n    padding-bottom: 15px !important;\n  }\n\n  .pl-xl-3,\n  .px-xl-3 {\n    padding-left: 15px !important;\n  }\n\n  .p-xl-4 {\n    padding: 30px !important;\n  }\n\n  .pt-xl-4,\n  .py-xl-4 {\n    padding-top: 30px !important;\n  }\n\n  .pr-xl-4,\n  .px-xl-4 {\n    padding-right: 30px !important;\n  }\n\n  .pb-xl-4,\n  .py-xl-4 {\n    padding-bottom: 30px !important;\n  }\n\n  .pl-xl-4,\n  .px-xl-4 {\n    padding-left: 30px !important;\n  }\n\n  .p-xl-5 {\n    padding: 30px !important;\n  }\n\n  .pt-xl-5,\n  .py-xl-5 {\n    padding-top: 30px !important;\n  }\n\n  .pr-xl-5,\n  .px-xl-5 {\n    padding-right: 30px !important;\n  }\n\n  .pb-xl-5,\n  .py-xl-5 {\n    padding-bottom: 30px !important;\n  }\n\n  .pl-xl-5,\n  .px-xl-5 {\n    padding-left: 30px !important;\n  }\n\n  .p-xl-6 {\n    padding: 50px !important;\n  }\n\n  .pt-xl-6,\n  .py-xl-6 {\n    padding-top: 50px !important;\n  }\n\n  .pr-xl-6,\n  .px-xl-6 {\n    padding-right: 50px !important;\n  }\n\n  .pb-xl-6,\n  .py-xl-6 {\n    padding-bottom: 50px !important;\n  }\n\n  .pl-xl-6,\n  .px-xl-6 {\n    padding-left: 50px !important;\n  }\n\n  .p-xl-7 {\n    padding: 60px !important;\n  }\n\n  .pt-xl-7,\n  .py-xl-7 {\n    padding-top: 60px !important;\n  }\n\n  .pr-xl-7,\n  .px-xl-7 {\n    padding-right: 60px !important;\n  }\n\n  .pb-xl-7,\n  .py-xl-7 {\n    padding-bottom: 60px !important;\n  }\n\n  .pl-xl-7,\n  .px-xl-7 {\n    padding-left: 60px !important;\n  }\n\n  .p-xl-8 {\n    padding: 70px !important;\n  }\n\n  .pt-xl-8,\n  .py-xl-8 {\n    padding-top: 70px !important;\n  }\n\n  .pr-xl-8,\n  .px-xl-8 {\n    padding-right: 70px !important;\n  }\n\n  .pb-xl-8,\n  .py-xl-8 {\n    padding-bottom: 70px !important;\n  }\n\n  .pl-xl-8,\n  .px-xl-8 {\n    padding-left: 70px !important;\n  }\n\n  .p-xl-9 {\n    padding: 80px !important;\n  }\n\n  .pt-xl-9,\n  .py-xl-9 {\n    padding-top: 80px !important;\n  }\n\n  .pr-xl-9,\n  .px-xl-9 {\n    padding-right: 80px !important;\n  }\n\n  .pb-xl-9,\n  .py-xl-9 {\n    padding-bottom: 80px !important;\n  }\n\n  .pl-xl-9,\n  .px-xl-9 {\n    padding-left: 80px !important;\n  }\n\n  .m-xl-n1 {\n    margin: -5px !important;\n  }\n\n  .mt-xl-n1,\n  .my-xl-n1 {\n    margin-top: -5px !important;\n  }\n\n  .mr-xl-n1,\n  .mx-xl-n1 {\n    margin-right: -5px !important;\n  }\n\n  .mb-xl-n1,\n  .my-xl-n1 {\n    margin-bottom: -5px !important;\n  }\n\n  .ml-xl-n1,\n  .mx-xl-n1 {\n    margin-left: -5px !important;\n  }\n\n  .m-xl-n2 {\n    margin: -5px !important;\n  }\n\n  .mt-xl-n2,\n  .my-xl-n2 {\n    margin-top: -5px !important;\n  }\n\n  .mr-xl-n2,\n  .mx-xl-n2 {\n    margin-right: -5px !important;\n  }\n\n  .mb-xl-n2,\n  .my-xl-n2 {\n    margin-bottom: -5px !important;\n  }\n\n  .ml-xl-n2,\n  .mx-xl-n2 {\n    margin-left: -5px !important;\n  }\n\n  .m-xl-n3 {\n    margin: -15px !important;\n  }\n\n  .mt-xl-n3,\n  .my-xl-n3 {\n    margin-top: -15px !important;\n  }\n\n  .mr-xl-n3,\n  .mx-xl-n3 {\n    margin-right: -15px !important;\n  }\n\n  .mb-xl-n3,\n  .my-xl-n3 {\n    margin-bottom: -15px !important;\n  }\n\n  .ml-xl-n3,\n  .mx-xl-n3 {\n    margin-left: -15px !important;\n  }\n\n  .m-xl-n4 {\n    margin: -30px !important;\n  }\n\n  .mt-xl-n4,\n  .my-xl-n4 {\n    margin-top: -30px !important;\n  }\n\n  .mr-xl-n4,\n  .mx-xl-n4 {\n    margin-right: -30px !important;\n  }\n\n  .mb-xl-n4,\n  .my-xl-n4 {\n    margin-bottom: -30px !important;\n  }\n\n  .ml-xl-n4,\n  .mx-xl-n4 {\n    margin-left: -30px !important;\n  }\n\n  .m-xl-n5 {\n    margin: -50px !important;\n  }\n\n  .mt-xl-n5,\n  .my-xl-n5 {\n    margin-top: -50px !important;\n  }\n\n  .mr-xl-n5,\n  .mx-xl-n5 {\n    margin-right: -50px !important;\n  }\n\n  .mb-xl-n5,\n  .my-xl-n5 {\n    margin-bottom: -50px !important;\n  }\n\n  .ml-xl-n5,\n  .mx-xl-n5 {\n    margin-left: -50px !important;\n  }\n\n  .m-xl-n6 {\n    margin: -50px !important;\n  }\n\n  .mt-xl-n6,\n  .my-xl-n6 {\n    margin-top: -50px !important;\n  }\n\n  .mr-xl-n6,\n  .mx-xl-n6 {\n    margin-right: -50px !important;\n  }\n\n  .mb-xl-n6,\n  .my-xl-n6 {\n    margin-bottom: -50px !important;\n  }\n\n  .ml-xl-n6,\n  .mx-xl-n6 {\n    margin-left: -50px !important;\n  }\n\n  .m-xl-n7 {\n    margin: -60px !important;\n  }\n\n  .mt-xl-n7,\n  .my-xl-n7 {\n    margin-top: -60px !important;\n  }\n\n  .mr-xl-n7,\n  .mx-xl-n7 {\n    margin-right: -60px !important;\n  }\n\n  .mb-xl-n7,\n  .my-xl-n7 {\n    margin-bottom: -60px !important;\n  }\n\n  .ml-xl-n7,\n  .mx-xl-n7 {\n    margin-left: -60px !important;\n  }\n\n  .m-xl-n8 {\n    margin: -70px !important;\n  }\n\n  .mt-xl-n8,\n  .my-xl-n8 {\n    margin-top: -70px !important;\n  }\n\n  .mr-xl-n8,\n  .mx-xl-n8 {\n    margin-right: -70px !important;\n  }\n\n  .mb-xl-n8,\n  .my-xl-n8 {\n    margin-bottom: -70px !important;\n  }\n\n  .ml-xl-n8,\n  .mx-xl-n8 {\n    margin-left: -70px !important;\n  }\n\n  .m-xl-n9 {\n    margin: -80px !important;\n  }\n\n  .mt-xl-n9,\n  .my-xl-n9 {\n    margin-top: -80px !important;\n  }\n\n  .mr-xl-n9,\n  .mx-xl-n9 {\n    margin-right: -80px !important;\n  }\n\n  .mb-xl-n9,\n  .my-xl-n9 {\n    margin-bottom: -80px !important;\n  }\n\n  .ml-xl-n9,\n  .mx-xl-n9 {\n    margin-left: -80px !important;\n  }\n\n  .m-xl-auto {\n    margin: auto !important;\n  }\n\n  .mt-xl-auto,\n  .my-xl-auto {\n    margin-top: auto !important;\n  }\n\n  .mr-xl-auto,\n  .mx-xl-auto {\n    margin-right: auto !important;\n  }\n\n  .mb-xl-auto,\n  .my-xl-auto {\n    margin-bottom: auto !important;\n  }\n\n  .ml-xl-auto,\n  .mx-xl-auto {\n    margin-left: auto !important;\n  }\n}\n\n@media (min-width: 1500px) {\n  .m-xxl-0 {\n    margin: 0 !important;\n  }\n\n  .mt-xxl-0,\n  .my-xxl-0 {\n    margin-top: 0 !important;\n  }\n\n  .mr-xxl-0,\n  .mx-xxl-0 {\n    margin-right: 0 !important;\n  }\n\n  .mb-xxl-0,\n  .my-xxl-0 {\n    margin-bottom: 0 !important;\n  }\n\n  .ml-xxl-0,\n  .mx-xxl-0 {\n    margin-left: 0 !important;\n  }\n\n  .m-xxl-1 {\n    margin: 5px !important;\n  }\n\n  .mt-xxl-1,\n  .my-xxl-1 {\n    margin-top: 5px !important;\n  }\n\n  .mr-xxl-1,\n  .mx-xxl-1 {\n    margin-right: 5px !important;\n  }\n\n  .mb-xxl-1,\n  .my-xxl-1 {\n    margin-bottom: 5px !important;\n  }\n\n  .ml-xxl-1,\n  .mx-xxl-1 {\n    margin-left: 5px !important;\n  }\n\n  .m-xxl-2 {\n    margin: 5px !important;\n  }\n\n  .mt-xxl-2,\n  .my-xxl-2 {\n    margin-top: 5px !important;\n  }\n\n  .mr-xxl-2,\n  .mx-xxl-2 {\n    margin-right: 5px !important;\n  }\n\n  .mb-xxl-2,\n  .my-xxl-2 {\n    margin-bottom: 5px !important;\n  }\n\n  .ml-xxl-2,\n  .mx-xxl-2 {\n    margin-left: 5px !important;\n  }\n\n  .m-xxl-3 {\n    margin: 15px !important;\n  }\n\n  .mt-xxl-3,\n  .my-xxl-3 {\n    margin-top: 15px !important;\n  }\n\n  .mr-xxl-3,\n  .mx-xxl-3 {\n    margin-right: 15px !important;\n  }\n\n  .mb-xxl-3,\n  .my-xxl-3 {\n    margin-bottom: 15px !important;\n  }\n\n  .ml-xxl-3,\n  .mx-xxl-3 {\n    margin-left: 15px !important;\n  }\n\n  .m-xxl-4 {\n    margin: 30px !important;\n  }\n\n  .mt-xxl-4,\n  .my-xxl-4 {\n    margin-top: 30px !important;\n  }\n\n  .mr-xxl-4,\n  .mx-xxl-4 {\n    margin-right: 30px !important;\n  }\n\n  .mb-xxl-4,\n  .my-xxl-4 {\n    margin-bottom: 30px !important;\n  }\n\n  .ml-xxl-4,\n  .mx-xxl-4 {\n    margin-left: 30px !important;\n  }\n\n  .m-xxl-5 {\n    margin: 30px !important;\n  }\n\n  .mt-xxl-5,\n  .my-xxl-5 {\n    margin-top: 30px !important;\n  }\n\n  .mr-xxl-5,\n  .mx-xxl-5 {\n    margin-right: 30px !important;\n  }\n\n  .mb-xxl-5,\n  .my-xxl-5 {\n    margin-bottom: 30px !important;\n  }\n\n  .ml-xxl-5,\n  .mx-xxl-5 {\n    margin-left: 30px !important;\n  }\n\n  .m-xxl-6 {\n    margin: 50px !important;\n  }\n\n  .mt-xxl-6,\n  .my-xxl-6 {\n    margin-top: 50px !important;\n  }\n\n  .mr-xxl-6,\n  .mx-xxl-6 {\n    margin-right: 50px !important;\n  }\n\n  .mb-xxl-6,\n  .my-xxl-6 {\n    margin-bottom: 50px !important;\n  }\n\n  .ml-xxl-6,\n  .mx-xxl-6 {\n    margin-left: 50px !important;\n  }\n\n  .m-xxl-7 {\n    margin: 60px !important;\n  }\n\n  .mt-xxl-7,\n  .my-xxl-7 {\n    margin-top: 60px !important;\n  }\n\n  .mr-xxl-7,\n  .mx-xxl-7 {\n    margin-right: 60px !important;\n  }\n\n  .mb-xxl-7,\n  .my-xxl-7 {\n    margin-bottom: 60px !important;\n  }\n\n  .ml-xxl-7,\n  .mx-xxl-7 {\n    margin-left: 60px !important;\n  }\n\n  .m-xxl-8 {\n    margin: 70px !important;\n  }\n\n  .mt-xxl-8,\n  .my-xxl-8 {\n    margin-top: 70px !important;\n  }\n\n  .mr-xxl-8,\n  .mx-xxl-8 {\n    margin-right: 70px !important;\n  }\n\n  .mb-xxl-8,\n  .my-xxl-8 {\n    margin-bottom: 70px !important;\n  }\n\n  .ml-xxl-8,\n  .mx-xxl-8 {\n    margin-left: 70px !important;\n  }\n\n  .m-xxl-9 {\n    margin: 80px !important;\n  }\n\n  .mt-xxl-9,\n  .my-xxl-9 {\n    margin-top: 80px !important;\n  }\n\n  .mr-xxl-9,\n  .mx-xxl-9 {\n    margin-right: 80px !important;\n  }\n\n  .mb-xxl-9,\n  .my-xxl-9 {\n    margin-bottom: 80px !important;\n  }\n\n  .ml-xxl-9,\n  .mx-xxl-9 {\n    margin-left: 80px !important;\n  }\n\n  .p-xxl-0 {\n    padding: 0 !important;\n  }\n\n  .pt-xxl-0,\n  .py-xxl-0 {\n    padding-top: 0 !important;\n  }\n\n  .pr-xxl-0,\n  .px-xxl-0 {\n    padding-right: 0 !important;\n  }\n\n  .pb-xxl-0,\n  .py-xxl-0 {\n    padding-bottom: 0 !important;\n  }\n\n  .pl-xxl-0,\n  .px-xxl-0 {\n    padding-left: 0 !important;\n  }\n\n  .p-xxl-1 {\n    padding: 5px !important;\n  }\n\n  .pt-xxl-1,\n  .py-xxl-1 {\n    padding-top: 5px !important;\n  }\n\n  .pr-xxl-1,\n  .px-xxl-1 {\n    padding-right: 5px !important;\n  }\n\n  .pb-xxl-1,\n  .py-xxl-1 {\n    padding-bottom: 5px !important;\n  }\n\n  .pl-xxl-1,\n  .px-xxl-1 {\n    padding-left: 5px !important;\n  }\n\n  .p-xxl-2 {\n    padding: 5px !important;\n  }\n\n  .pt-xxl-2,\n  .py-xxl-2 {\n    padding-top: 5px !important;\n  }\n\n  .pr-xxl-2,\n  .px-xxl-2 {\n    padding-right: 5px !important;\n  }\n\n  .pb-xxl-2,\n  .py-xxl-2 {\n    padding-bottom: 5px !important;\n  }\n\n  .pl-xxl-2,\n  .px-xxl-2 {\n    padding-left: 5px !important;\n  }\n\n  .p-xxl-3 {\n    padding: 15px !important;\n  }\n\n  .pt-xxl-3,\n  .py-xxl-3 {\n    padding-top: 15px !important;\n  }\n\n  .pr-xxl-3,\n  .px-xxl-3 {\n    padding-right: 15px !important;\n  }\n\n  .pb-xxl-3,\n  .py-xxl-3 {\n    padding-bottom: 15px !important;\n  }\n\n  .pl-xxl-3,\n  .px-xxl-3 {\n    padding-left: 15px !important;\n  }\n\n  .p-xxl-4 {\n    padding: 30px !important;\n  }\n\n  .pt-xxl-4,\n  .py-xxl-4 {\n    padding-top: 30px !important;\n  }\n\n  .pr-xxl-4,\n  .px-xxl-4 {\n    padding-right: 30px !important;\n  }\n\n  .pb-xxl-4,\n  .py-xxl-4 {\n    padding-bottom: 30px !important;\n  }\n\n  .pl-xxl-4,\n  .px-xxl-4 {\n    padding-left: 30px !important;\n  }\n\n  .p-xxl-5 {\n    padding: 30px !important;\n  }\n\n  .pt-xxl-5,\n  .py-xxl-5 {\n    padding-top: 30px !important;\n  }\n\n  .pr-xxl-5,\n  .px-xxl-5 {\n    padding-right: 30px !important;\n  }\n\n  .pb-xxl-5,\n  .py-xxl-5 {\n    padding-bottom: 30px !important;\n  }\n\n  .pl-xxl-5,\n  .px-xxl-5 {\n    padding-left: 30px !important;\n  }\n\n  .p-xxl-6 {\n    padding: 50px !important;\n  }\n\n  .pt-xxl-6,\n  .py-xxl-6 {\n    padding-top: 50px !important;\n  }\n\n  .pr-xxl-6,\n  .px-xxl-6 {\n    padding-right: 50px !important;\n  }\n\n  .pb-xxl-6,\n  .py-xxl-6 {\n    padding-bottom: 50px !important;\n  }\n\n  .pl-xxl-6,\n  .px-xxl-6 {\n    padding-left: 50px !important;\n  }\n\n  .p-xxl-7 {\n    padding: 60px !important;\n  }\n\n  .pt-xxl-7,\n  .py-xxl-7 {\n    padding-top: 60px !important;\n  }\n\n  .pr-xxl-7,\n  .px-xxl-7 {\n    padding-right: 60px !important;\n  }\n\n  .pb-xxl-7,\n  .py-xxl-7 {\n    padding-bottom: 60px !important;\n  }\n\n  .pl-xxl-7,\n  .px-xxl-7 {\n    padding-left: 60px !important;\n  }\n\n  .p-xxl-8 {\n    padding: 70px !important;\n  }\n\n  .pt-xxl-8,\n  .py-xxl-8 {\n    padding-top: 70px !important;\n  }\n\n  .pr-xxl-8,\n  .px-xxl-8 {\n    padding-right: 70px !important;\n  }\n\n  .pb-xxl-8,\n  .py-xxl-8 {\n    padding-bottom: 70px !important;\n  }\n\n  .pl-xxl-8,\n  .px-xxl-8 {\n    padding-left: 70px !important;\n  }\n\n  .p-xxl-9 {\n    padding: 80px !important;\n  }\n\n  .pt-xxl-9,\n  .py-xxl-9 {\n    padding-top: 80px !important;\n  }\n\n  .pr-xxl-9,\n  .px-xxl-9 {\n    padding-right: 80px !important;\n  }\n\n  .pb-xxl-9,\n  .py-xxl-9 {\n    padding-bottom: 80px !important;\n  }\n\n  .pl-xxl-9,\n  .px-xxl-9 {\n    padding-left: 80px !important;\n  }\n\n  .m-xxl-n1 {\n    margin: -5px !important;\n  }\n\n  .mt-xxl-n1,\n  .my-xxl-n1 {\n    margin-top: -5px !important;\n  }\n\n  .mr-xxl-n1,\n  .mx-xxl-n1 {\n    margin-right: -5px !important;\n  }\n\n  .mb-xxl-n1,\n  .my-xxl-n1 {\n    margin-bottom: -5px !important;\n  }\n\n  .ml-xxl-n1,\n  .mx-xxl-n1 {\n    margin-left: -5px !important;\n  }\n\n  .m-xxl-n2 {\n    margin: -5px !important;\n  }\n\n  .mt-xxl-n2,\n  .my-xxl-n2 {\n    margin-top: -5px !important;\n  }\n\n  .mr-xxl-n2,\n  .mx-xxl-n2 {\n    margin-right: -5px !important;\n  }\n\n  .mb-xxl-n2,\n  .my-xxl-n2 {\n    margin-bottom: -5px !important;\n  }\n\n  .ml-xxl-n2,\n  .mx-xxl-n2 {\n    margin-left: -5px !important;\n  }\n\n  .m-xxl-n3 {\n    margin: -15px !important;\n  }\n\n  .mt-xxl-n3,\n  .my-xxl-n3 {\n    margin-top: -15px !important;\n  }\n\n  .mr-xxl-n3,\n  .mx-xxl-n3 {\n    margin-right: -15px !important;\n  }\n\n  .mb-xxl-n3,\n  .my-xxl-n3 {\n    margin-bottom: -15px !important;\n  }\n\n  .ml-xxl-n3,\n  .mx-xxl-n3 {\n    margin-left: -15px !important;\n  }\n\n  .m-xxl-n4 {\n    margin: -30px !important;\n  }\n\n  .mt-xxl-n4,\n  .my-xxl-n4 {\n    margin-top: -30px !important;\n  }\n\n  .mr-xxl-n4,\n  .mx-xxl-n4 {\n    margin-right: -30px !important;\n  }\n\n  .mb-xxl-n4,\n  .my-xxl-n4 {\n    margin-bottom: -30px !important;\n  }\n\n  .ml-xxl-n4,\n  .mx-xxl-n4 {\n    margin-left: -30px !important;\n  }\n\n  .m-xxl-n5 {\n    margin: -50px !important;\n  }\n\n  .mt-xxl-n5,\n  .my-xxl-n5 {\n    margin-top: -50px !important;\n  }\n\n  .mr-xxl-n5,\n  .mx-xxl-n5 {\n    margin-right: -50px !important;\n  }\n\n  .mb-xxl-n5,\n  .my-xxl-n5 {\n    margin-bottom: -50px !important;\n  }\n\n  .ml-xxl-n5,\n  .mx-xxl-n5 {\n    margin-left: -50px !important;\n  }\n\n  .m-xxl-n6 {\n    margin: -50px !important;\n  }\n\n  .mt-xxl-n6,\n  .my-xxl-n6 {\n    margin-top: -50px !important;\n  }\n\n  .mr-xxl-n6,\n  .mx-xxl-n6 {\n    margin-right: -50px !important;\n  }\n\n  .mb-xxl-n6,\n  .my-xxl-n6 {\n    margin-bottom: -50px !important;\n  }\n\n  .ml-xxl-n6,\n  .mx-xxl-n6 {\n    margin-left: -50px !important;\n  }\n\n  .m-xxl-n7 {\n    margin: -60px !important;\n  }\n\n  .mt-xxl-n7,\n  .my-xxl-n7 {\n    margin-top: -60px !important;\n  }\n\n  .mr-xxl-n7,\n  .mx-xxl-n7 {\n    margin-right: -60px !important;\n  }\n\n  .mb-xxl-n7,\n  .my-xxl-n7 {\n    margin-bottom: -60px !important;\n  }\n\n  .ml-xxl-n7,\n  .mx-xxl-n7 {\n    margin-left: -60px !important;\n  }\n\n  .m-xxl-n8 {\n    margin: -70px !important;\n  }\n\n  .mt-xxl-n8,\n  .my-xxl-n8 {\n    margin-top: -70px !important;\n  }\n\n  .mr-xxl-n8,\n  .mx-xxl-n8 {\n    margin-right: -70px !important;\n  }\n\n  .mb-xxl-n8,\n  .my-xxl-n8 {\n    margin-bottom: -70px !important;\n  }\n\n  .ml-xxl-n8,\n  .mx-xxl-n8 {\n    margin-left: -70px !important;\n  }\n\n  .m-xxl-n9 {\n    margin: -80px !important;\n  }\n\n  .mt-xxl-n9,\n  .my-xxl-n9 {\n    margin-top: -80px !important;\n  }\n\n  .mr-xxl-n9,\n  .mx-xxl-n9 {\n    margin-right: -80px !important;\n  }\n\n  .mb-xxl-n9,\n  .my-xxl-n9 {\n    margin-bottom: -80px !important;\n  }\n\n  .ml-xxl-n9,\n  .mx-xxl-n9 {\n    margin-left: -80px !important;\n  }\n\n  .m-xxl-auto {\n    margin: auto !important;\n  }\n\n  .mt-xxl-auto,\n  .my-xxl-auto {\n    margin-top: auto !important;\n  }\n\n  .mr-xxl-auto,\n  .mx-xxl-auto {\n    margin-right: auto !important;\n  }\n\n  .mb-xxl-auto,\n  .my-xxl-auto {\n    margin-bottom: auto !important;\n  }\n\n  .ml-xxl-auto,\n  .mx-xxl-auto {\n    margin-left: auto !important;\n  }\n}\n\n/* Padding Top */\n.pt-25 {\n  padding-top: 25px;\n}\n\n.pt-30 {\n  padding-top: 30px;\n}\n\n.pt-35 {\n  padding-top: 35px;\n}\n\n.pt-40 {\n  padding-top: 40px;\n}\n\n.pt-45 {\n  padding-top: 48px;\n}\n\n.pt-55 {\n  padding-top: 55px;\n}\n\n.pt-50 {\n  padding-top: 50px;\n}\n\n.pt-60 {\n  padding-top: 60px;\n}\n\n.pt-65 {\n  padding-top: 65px;\n}\n\n.pt-70 {\n  padding-top: 70px;\n}\n\n.pt-75 {\n  padding-top: 75px;\n}\n\n.pt-80 {\n  padding-top: 80px;\n}\n\n.pt-90 {\n  padding-top: 90px;\n}\n\n.pt-100 {\n  padding-top: 100px;\n}\n\n@media (min-width: 992px) {\n  .pt-100 {\n    padding-top: 100px;\n  }\n}\n\n/* Padding Bottom */\n.pb-25 {\n  padding-bottom: 25px;\n}\n\n.pb-30 {\n  padding-bottom: 30px;\n}\n\n.pb-35 {\n  padding-bottom: 35px;\n}\n\n.pb-40 {\n  padding-bottom: 40px;\n}\n\n.pb-45 {\n  padding-bottom: 45px;\n}\n\n.pb-50 {\n  padding-bottom: 50px;\n}\n\n.pb-55 {\n  padding-bottom: 55px;\n}\n\n.pb-60 {\n  padding-bottom: 60px;\n}\n\n.pb-65 {\n  padding-bottom: 65px;\n}\n\n.pb-70 {\n  padding-bottom: 70px;\n}\n\n.pb-75 {\n  padding-bottom: 75px;\n}\n\n.pb-80 {\n  padding-bottom: 80px;\n}\n\n.pb-90 {\n  padding-bottom: 90px;\n}\n\n.pb-100 {\n  padding-bottom: 100px;\n}\n\n.pv-35 {\n  padding-top: 35px;\n  padding-bottom: 35px;\n}\n\n.pv-40 {\n  padding-top: 40px;\n  padding-bottom: 40px;\n}\n\n.pv-45 {\n  padding-top: 45px;\n  padding-bottom: 40px;\n}\n\n.pv-50 {\n  padding-top: 50px;\n  padding-bottom: 50px;\n}\n\n.pv-55 {\n  padding-top: 55px;\n  padding-bottom: 55px;\n}\n\n.pv-60 {\n  padding-top: 60px;\n  padding-bottom: 60px;\n}\n\n.pv-65 {\n  padding-top: 65px;\n  padding-bottom: 65px;\n}\n\n.pv-70 {\n  padding-top: 70px;\n  padding-bottom: 70px;\n}\n\n.pv-75 {\n  padding-top: 75px;\n  padding-bottom: 75px;\n}\n\n.pv-80 {\n  padding-top: 80px;\n  padding-bottom: 80px;\n}\n\n.pv-90 {\n  padding-top: 90px;\n  padding-bottom: 90px;\n}\n\n.pv-100 {\n  padding-top: 100px;\n  padding-bottom: 100px;\n}\n\n/*  margin top */\n.mt-5px {\n  margin-top: 5px;\n}\n\n.mt-10px {\n  margin-top: 10px;\n}\n\n.mt-30 {\n  margin-top: 30px;\n}\n\n.mt-35 {\n  margin-top: 35px;\n}\n\n.mt-40 {\n  margin-top: 40px;\n}\n\n.mt-50 {\n  margin-top: 50px;\n}\n\n.mt-60 {\n  margin-top: 60px;\n}\n\n.mt-70 {\n  margin-top: 70px;\n}\n\n.mt-75 {\n  margin-top: 75px;\n}\n\n.mt-80 {\n  margin-top: 80px;\n}\n\n.mt-85 {\n  margin-top: 85px;\n}\n\n.mt-90 {\n  margin-top: 90px;\n}\n\n.mt-95 {\n  margin-top: 95px;\n}\n\n.mt-100 {\n  margin-top: 100px;\n}\n\n/* Margin Bottom */\n.mb-5px {\n  margin-bottom: 5px;\n}\n\n.mb-10px {\n  margin-bottom: 10px;\n}\n\n.mb-30 {\n  margin-bottom: 30px;\n}\n\n.mb-35 {\n  margin-bottom: 35px;\n}\n\n.mb-40 {\n  margin-bottom: 40px;\n}\n\n.mb-50 {\n  margin-bottom: 50px;\n}\n\n.mb-60 {\n  margin-bottom: 60px;\n}\n\n.mb-70 {\n  margin-bottom: 70px;\n}\n\n.mb-75 {\n  margin-bottom: 75px;\n}\n\n.mb-80 {\n  margin-bottom: 80px;\n}\n\n.mb-85 {\n  margin-bottom: 85px;\n}\n\n.mb-90 {\n  margin-bottom: 90px;\n}\n\n.mb-95 {\n  margin-bottom: 95px;\n}\n\n.mb-100 {\n  margin-bottom: 100px;\n}\n\n/* Width */\n.w-45 {\n  width: 45px;\n  height: auto;\n}\n\n/* Icon box width */\n.iconbox-18 {\n  width: 18px;\n  height: 18px;\n}\n\n.iconbox-45 {\n  width: 45px;\n  height: 45px;\n}\n\n/* Weight */\n.font-weight-medium {\n  font-weight: 500;\n}\n\n.font-size-20 {\n  font-size: 20px;\n}\n\n/* Vertical Position */\n.absolute-middle {\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n  transform: translateY(-50%);\n}\n\n.absolute-bottom {\n  top: auto;\n  bottom: 0;\n}\n\n/* Over Flow Hidden */\n.overflow-hidden {\n  overflow: hidden;\n}\n\n/*===== REBOOT =====*/\n* {\n  outline: 0;\n  margin: 0;\n  padding: 0;\n}\n\nhtml,\n* {\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\nul {\n  margin: 0;\n  padding: 0;\n}\n\nul li {\n  list-style-type: none;\n}\n\nhr {\n  /* margin: 10px 0; */\n  background: var(--border-color);\n  opacity: 1;\n}\n\np {\n  font-weight: 400;\n  margin-bottom: 0;\n  font-size: 14px;\n  /* line-height: 1.2; */\n}\n\n::-moz-selection {\n  background-color: var(--admin-color);\n  color: #ffffff;\n}\n\n::selection {\n  background-color: var(--admin-color);\n  color: #ffffff;\n}\n\nbutton,\na {\n  text-decoration: none;\n  -webkit-transition: all 0.3s ease-in-out;\n  transition: all 0.3s ease-in-out;\n}\n\n@media (prefers-reduced-motion: reduce) {\n\n  button,\n  a {\n    -webkit-transition: none;\n    transition: none;\n  }\n}\n\nbutton:hover,\nbutton:focus,\nbutton:active,\na:hover,\na:focus,\na:active {\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  outline: none;\n  text-decoration: none;\n}\n\nbutton {\n  background: transparent;\n  border: none;\n  cursor: pointer;\n}\n\n/*===== BADGE =====*/\n.badge {\n  text-transform: uppercase;\n  color: #ffffff;\n  padding-top: 0.75em;\n}\n\n.badge-sm {\n  padding-top: 0.5em;\n  padding-left: 0.6em;\n  padding-right: 0.6em;\n  font-size: 65%;\n}\n\n.badge {\n  display: inline-block;\n  padding: 0.5em 1em;\n  font-size: 75%;\n  font-weight: 500;\n  line-height: 9px;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  border-radius: 10px;\n  -webkit-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .badge {\n    -webkit-transition: none;\n    transition: none;\n  }\n}\n\na.badge:hover,\na.badge:focus {\n  text-decoration: none;\n}\n\n.badge:empty {\n  display: none;\n}\n\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n\n.badge-pill {\n  padding-right: 0.6em;\n  padding-left: 0.6em;\n  border-radius: 10rem;\n}\n\n.badge-primary {\n  color: #ffffff;\n  background-color: #4c84ff;\n}\n\na.badge-primary:hover,\na.badge-primary:focus {\n  color: #ffffff;\n  background-color: #1961ff;\n}\n\na.badge-primary:focus,\na.badge-primary.focus {\n  outline: 0;\n  -webkit-box-shadow: 0 0 0 0.2rem rgba(76, 132, 255, 0.5);\n  box-shadow: 0 0 0 0.2rem rgba(76, 132, 255, 0.5);\n}\n\n.badge-secondary {\n  color: #ffffff;\n  background-color: var(--bs-body-color);\n}\n\na.badge-secondary:hover,\na.badge-secondary:focus {\n  color: #ffffff;\n  background-color: #6f7685;\n}\n\na.badge-secondary:focus,\na.badge-secondary.focus {\n  outline: 0;\n  -webkit-box-shadow: 0 0 0 0.2rem rgba(138, 144, 157, 0.5);\n  box-shadow: 0 0 0 0.2rem rgba(138, 144, 157, 0.5);\n}\n\n.badge-success {\n  color: #ffffff;\n  background-color: #29cc97;\n}\n\na.badge-success:hover,\na.badge-success:focus {\n  color: #ffffff;\n  background-color: #20a278;\n}\n\na.badge-success:focus,\na.badge-success.focus {\n  outline: 0;\n  -webkit-box-shadow: 0 0 0 0.2rem rgba(41, 204, 151, 0.5);\n  box-shadow: 0 0 0 0.2rem rgba(41, 204, 151, 0.5);\n}\n\n.badge-info {\n  color: #ffffff;\n  background-color: #13cae1;\n}\n\na.badge-info:hover,\na.badge-info:focus {\n  color: #ffffff;\n  background-color: #0fa0b2;\n}\n\na.badge-info:focus,\na.badge-info.focus {\n  outline: 0;\n  -webkit-box-shadow: 0 0 0 0.2rem rgba(19, 202, 225, 0.5);\n  box-shadow: 0 0 0 0.2rem rgba(19, 202, 225, 0.5);\n}\n\n.badge-warning {\n  color: #212529;\n  background-color: #fec400;\n}\n\na.badge-warning:hover,\na.badge-warning:focus {\n  color: #212529;\n  background-color: #cb9d00;\n}\n\na.badge-warning:focus,\na.badge-warning.focus {\n  outline: 0;\n  -webkit-box-shadow: 0 0 0 0.2rem rgba(254, 196, 0, 0.5);\n  box-shadow: 0 0 0 0.2rem rgba(254, 196, 0, 0.5);\n}\n\n.badge-danger {\n  color: #ffffff;\n  background-color: #fe5461;\n}\n\na.badge-danger:hover,\na.badge-danger:focus {\n  color: #ffffff;\n  background-color: #fe2132;\n}\n\na.badge-danger:focus,\na.badge-danger.focus {\n  outline: 0;\n  -webkit-box-shadow: 0 0 0 0.2rem rgba(254, 84, 97, 0.5);\n  box-shadow: 0 0 0 0.2rem rgba(254, 84, 97, 0.5);\n}\n\n.badge-light {\n  color: #212529;\n  background-color: #f5f6fa;\n}\n\na.badge-light:hover,\na.badge-light:focus {\n  color: #212529;\n  background-color: #d3d7e9;\n}\n\na.badge-light:focus,\na.badge-light.focus {\n  outline: 0;\n  -webkit-box-shadow: 0 0 0 0.2rem rgba(245, 246, 250, 0.5);\n  box-shadow: 0 0 0 0.2rem rgba(245, 246, 250, 0.5);\n}\n\n.badge-dark {\n  color: #ffffff;\n  background-color: #1b223c;\n}\n\na.badge-dark:hover,\na.badge-dark:focus {\n  color: #ffffff;\n  background-color: #0b0e19;\n}\n\na.badge-dark:focus,\na.badge-dark.focus {\n  outline: 0;\n  -webkit-box-shadow: 0 0 0 0.2rem rgba(27, 34, 60, 0.5);\n  box-shadow: 0 0 0 0.2rem rgba(27, 34, 60, 0.5);\n}\n\n.badge-purple {\n  color: #ffffff;\n  background-color: #896def;\n}\n\na.badge-purple:hover,\na.badge-purple:focus {\n  color: #ffffff;\n  background-color: #643fea;\n}\n\na.badge-purple:focus,\na.badge-purple.focus {\n  outline: 0;\n  -webkit-box-shadow: 0 0 0 0.2rem rgba(137, 109, 239, 0.5);\n  box-shadow: 0 0 0 0.2rem rgba(137, 109, 239, 0.5);\n}\n\n/*===== BREDCRUMB =====*/\n.breadcrumb-wrapper-2 {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n}\n\n.breadcrumb-wrapper-2 .breadcrumbs {\n  margin-top: 0 !important;\n}\n\n.breadcrumb-wrapper {\n  margin-bottom: 20px;\n  margin-top: 20px;\n}\n\n.breadcrumb-wrapper h1,\n.breadcrumb-wrapper .h1 {\n  color: var(--text-color);\n  font-size: 25px;\n  font-weight: 500;\n}\n\n@media (max-width: 1499.98px) {\n\n  .breadcrumb-wrapper h1,\n  .breadcrumb-wrapper .h1 {\n    font-size: 23px;\n  }\n}\n\n@media (max-width: 1199.98px) {\n\n  .breadcrumb-wrapper h1,\n  .breadcrumb-wrapper .h1 {\n    font-size: 20px;\n  }\n}\n\n.breadcrumb-wrapper .btn {\n  border-radius: 15px;\n}\n\n.breadcrumb-wrapper .btn:hover {\n  /* background-color: #6d88c2; */\n}\n\n.breadcrumb-wrapper .breadcrumbs {\n  margin-top: 5px;\n}\n\n.breadcrumb-wrapper .breadcrumbs span i {\n  margin: 0 5px;\n  font-size: 18px;\n}\n\n.breadcrumb-wrapper.breadcrumb-contacts {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n}\n\n.breadcrumb-wrapper.breadcrumb-contacts .btn {\n  /* margin: 10px 0; */\n}\n\n.breadcrumb .breadcrumb-item {\n  font-size: 15px;\n  text-transform: capitalize;\n}\n\n.breadcrumb .breadcrumb-item a {\n  color: var(--bs-body-color);\n  text-transform: capitalize;\n}\n\n.breadcrumb.breadcrumb-inverse {\n  border-color: #4c84ff;\n  background-color: rgba(228, 237, 255, 0.6);\n}\n\n.breadcrumb.breadcrumb-inverse .breadcrumb-item {\n  color: var(--admin-color);\n}\n\n.breadcrumb.breadcrumb-inverse .breadcrumb-item:before {\n  color: inherit;\n}\n\n.breadcrumb.breadcrumb-primary {\n  border-color: var(--admin-color);\n  background-color: var(--admin-color);\n}\n\n.breadcrumb.breadcrumb-primary .breadcrumb-item,\n.breadcrumb.breadcrumb-primary .breadcrumb-item a {\n  color: #ffffff;\n}\n\n.breadcrumb.breadcrumb-primary .breadcrumb-item:before {\n  color: #ffffff;\n}\n\n.breadcrumb.breadcrumb-pink {\n  border-color: #ee5588;\n  background-color: #ee5588;\n}\n\n.breadcrumb.breadcrumb-pink .breadcrumb-item,\n.breadcrumb.breadcrumb-pink .breadcrumb-item a {\n  color: #ffffff;\n}\n\n.breadcrumb.breadcrumb-pink .breadcrumb-item:before {\n  color: #ffffff;\n}\n\n.breadcrumb.breadcrumb-success {\n  border-color: #34c997;\n  background-color: #34c997;\n}\n\n.breadcrumb.breadcrumb-success .breadcrumb-item,\n.breadcrumb.breadcrumb-success .breadcrumb-item a {\n  color: #ffffff;\n}\n\n.breadcrumb.breadcrumb-success .breadcrumb-item:before {\n  color: #ffffff;\n}\n\n.breadcrumb.breadcrumb-danger {\n  border-color: #ec4a58;\n  background-color: #ec4a58;\n}\n\n.breadcrumb.breadcrumb-danger .breadcrumb-item,\n.breadcrumb.breadcrumb-danger .breadcrumb-item a {\n  color: #ffffff;\n}\n\n.breadcrumb.breadcrumb-danger .breadcrumb-item:before {\n  color: #ffffff;\n}\n\n.breadcrumb.breadcrumb-warning {\n  border-color: #ddaa04;\n  background-color: #ddaa04;\n}\n\n.breadcrumb.breadcrumb-warning .breadcrumb-item,\n.breadcrumb.breadcrumb-warning .breadcrumb-item a {\n  color: #ffffff;\n}\n\n.breadcrumb.breadcrumb-warning .breadcrumb-item:before {\n  color: #ffffff;\n}\n\n.breadcrumb.breadcrumb-info {\n  border-color: #24c4da;\n  background-color: #24c4da;\n}\n\n.breadcrumb.breadcrumb-info .breadcrumb-item,\n.breadcrumb.breadcrumb-info .breadcrumb-item a {\n  color: #ffffff;\n}\n\n.breadcrumb.breadcrumb-info .breadcrumb-item:before {\n  color: #ffffff;\n}\n\n.breadcrumb-item+.breadcrumb-item::before {\n  content: \"\";\n  top: 10px;\n  font-size: 7px;\n  color: var(--bs-body-color);\n  position: relative;\n  -webkit-transform: rotate(45deg);\n  transform: rotate(45deg);\n  font-family: \"Material Design Icons\";\n}\n\n/*===== BUTTONS =====*/\n.btn {\n  border-radius: 15px;\n}\n\n.btn.btn-square {\n  border-radius: 0px;\n}\n\n.btn.btn-pill {\n  border-radius: 100px;\n}\n\n.btn.btn-outline-primary {\n  color: var(--admin-color);\n  border-color: var(--admin-color);\n}\n\n.btn.btn-outline-secondary {\n  color: var(--bs-body-color);\n  border-color: var(--bs-body-color);\n}\n\n.btn.btn-outline-success {\n  color: #34c997;\n  border-color: #34c997;\n}\n\n.btn.btn-outline-info {\n  color: #24c4da;\n  border-color: #24c4da;\n}\n\n.btn.btn-outline-warning {\n  color: #ddaa04;\n  border-color: #ddaa04;\n}\n\n.btn.btn-outline-danger {\n  color: #ec4a58;\n  border-color: #ec4a58;\n}\n\n.btn.btn-primary {\n  color: #ffffff;\n  background-color: var(--admin-color);\n  border-color: var(--admin-color);\n}\n\n.btn.btn-primary:hover,\n.btn.btn-outline-primary:hover {\n  color: #ffffff;\n  background-color: var(--button-hover-color);\n  border-color: var(--button-hover-color);\n}\n\n.btn.btn-secondary {\n  color: #ffffff;\n  background-color: var(--bs-body-color);\n  border-color: var(--bs-body-color);\n}\n\n.btn.btn-secondary:hover,\n.btn.btn-outline-secondary:hover {\n  color: #ffffff;\n  background-color: var(--bs-body-color);\n  border-color: var(--bs-body-color);\n}\n\n.btn.btn-success {\n  color: #ffffff;\n  background-color: #34c997;\n  border-color: #34c997;\n}\n\n.btn.btn-success:hover,\n.btn.btn-outline-success:hover {\n  color: #ffffff;\n  background-color: #34c997;\n  border-color: #34c997;\n}\n\n.btn.btn-info {\n  color: #ffffff;\n  background-color: #24c4da;\n  border-color: #24c4da;\n}\n\n.btn.btn-info:hover,\n.btn.btn-outline-info:hover {\n  color: #ffffff;\n  background-color: #24c4da;\n  border-color: #24c4da;\n}\n\n.btn.btn-warning {\n  color: #ffffff;\n  background-color: #ddaa04;\n  border-color: #ddaa04;\n}\n\n.btn.btn-warning:hover,\n.btn.btn-outline-warning:hover {\n  color: #ffffff;\n  background-color: #ddaa04;\n  border-color: #ddaa04;\n}\n\n.btn.btn-danger {\n  color: #ffffff;\n  background-color: #ec4a58;\n  border-color: #ec4a58;\n}\n\n.btn.btn-danger:hover,\n.btn.btn-outline-danger:hover {\n  color: #ffffff;\n  background-color: #ec4a58;\n  border-color: #ec4a58;\n}\n\n.btn-block {\n  display: block;\n  width: 100%;\n}\n\n/* Button Social */\n.btn-facebook,\n.btn-twitter,\n.btn-google-plus,\n.btn-linkedin,\n.btn-pinterest,\n.btn-tumblr,\n.btn-vimeo,\n.btn-skype,\n.btn-dropbox {\n  position: relative;\n  overflow: hidden;\n  color: #ffffff;\n  text-align: center;\n  padding: 0.312rem 0.625rem;\n  font-size: 15px;\n  border: 1px solid transparent;\n  line-height: 1.5;\n  width: 40px;\n  height: 40px;\n}\n\n.btn-facebook.text,\n.btn-twitter.text,\n.btn-google-plus.text,\n.btn-linkedin.text,\n.btn-pinterest.text,\n.btn-tumblr.text,\n.btn-vimeo.text,\n.btn-skype.text,\n.btn-dropbox.text {\n  width: auto;\n  padding-left: 1.25rem;\n  padding-right: 1.25rem;\n}\n\n.btn-facebook.text i,\n.btn-twitter.text i,\n.btn-google-plus.text i,\n.btn-linkedin.text i,\n.btn-pinterest.text i,\n.btn-tumblr.text i,\n.btn-vimeo.text i,\n.btn-skype.text i,\n.btn-dropbox.text i {\n  margin-right: 0.5rem;\n}\n\n.btn-facebook.btn-lg,\n.btn-group-lg>.btn-facebook.btn,\n.btn-twitter.btn-lg,\n.btn-group-lg>.btn-twitter.btn,\n.btn-google-plus.btn-lg,\n.btn-group-lg>.btn-google-plus.btn,\n.btn-linkedin.btn-lg,\n.btn-group-lg>.btn-linkedin.btn,\n.btn-pinterest.btn-lg,\n.btn-group-lg>.btn-pinterest.btn,\n.btn-tumblr.btn-lg,\n.btn-group-lg>.btn-tumblr.btn,\n.btn-vimeo.btn-lg,\n.btn-group-lg>.btn-vimeo.btn,\n.btn-skype.btn-lg,\n.btn-group-lg>.btn-skype.btn,\n.btn-dropbox.btn-lg,\n.btn-group-lg>.btn-dropbox.btn {\n  height: 50px;\n  padding-left: 1.88rem;\n  padding-right: 1.88rem;\n}\n\n.btn-facebook {\n  background: #3b5998;\n}\n\n.btn-facebook.btn-outline {\n  color: #3b5998;\n  border-color: rgba(59, 89, 152, 0.6);\n  background: transparent;\n}\n\n.btn-facebook:hover {\n  color: #ffffff;\n  background: #344e86;\n}\n\n.btn-facebook:hover.btn-outline {\n  color: #ffffff;\n  border-color: #3b5998;\n}\n\n.btn-facebook:hover::before {\n  background: #2d4373;\n}\n\n.btn-twitter {\n  background: #00aced;\n}\n\n.btn-twitter.btn-outline {\n  color: #00aced;\n  border-color: rgba(0, 172, 237, 0.6);\n  background: transparent;\n}\n\n.btn-twitter:hover {\n  color: #ffffff;\n  background: #0099d4;\n}\n\n.btn-twitter:hover.btn-outline {\n  color: #ffffff;\n  border-color: #00aced;\n}\n\n.btn-skype {\n  background: #00aff0;\n}\n\n.btn-skype.btn-outline {\n  color: #00aff0;\n  border-color: rgba(0, 175, 240, 0.6);\n  background: transparent;\n}\n\n.btn-skype:hover {\n  color: #ffffff;\n  background: #00aff0;\n}\n\n.btn-skype:hover.btn-outline {\n  color: #ffffff;\n  border-color: #00aff0;\n}\n\n.btn-skype:hover::before {\n  background: #0087ba;\n}\n\n.btn-linkedin {\n  background: #4875b4;\n}\n\n.btn-linkedin.btn-outline {\n  color: #4875b4;\n  border-color: rgba(72, 117, 180, 0.6);\n  background: transparent;\n}\n\n.btn-linkedin:hover {\n  color: #ffffff;\n  background: #4169a2;\n}\n\n.btn-linkedin:hover.btn-outline {\n  color: #ffffff;\n  border-color: #4875b4;\n}\n\n.btn-linkedin:hover::before {\n  background: #395d90;\n}\n\n.btn-pinterest {\n  background: #cb2027;\n}\n\n.btn-pinterest.btn-outline {\n  color: #cb2027;\n  border-color: rgba(203, 32, 39, 0.6);\n  background: transparent;\n}\n\n.btn-pinterest:hover {\n  color: #ffffff;\n  background: #b51d23;\n}\n\n.btn-pinterest:hover.btn-outline {\n  color: #ffffff;\n  border-color: #cb2027;\n}\n\n.btn-pinterest:hover::before {\n  background: #9f191f;\n}\n\n.btn-tumblr {\n  background: #32506d;\n}\n\n.btn-tumblr.btn-outline {\n  color: #32506d;\n  border-color: rgba(50, 80, 109, 0.6);\n  background: transparent;\n}\n\n.btn-tumblr:hover {\n  color: #ffffff;\n  background: #2a435c;\n}\n\n.btn-tumblr:hover.btn-outline {\n  color: #ffffff;\n  border-color: #32506d;\n}\n\n.btn-tumblr:hover::before {\n  background: #22364a;\n}\n\n.btn-google-plus {\n  background: #d34836;\n}\n\n.btn-google-plus.btn-outline {\n  color: #d34836;\n  border-color: rgba(211, 72, 54, 0.6);\n  background: transparent;\n}\n\n.btn-google-plus:hover {\n  color: #ffffff;\n  background: #c43d2b;\n}\n\n.btn-google-plus:hover.btn-outline {\n  color: #ffffff;\n  border-color: #d34836;\n}\n\n.btn-google-plus:hover::before {\n  background: #b03626;\n}\n\n.btn-dropbox {\n  background: #007ee5;\n}\n\n.btn-dropbox.btn-outline {\n  color: #007ee5;\n  border-color: rgba(0, 126, 229, 0.6);\n  background: transparent;\n}\n\n.btn-dropbox:hover {\n  color: #ffffff;\n  background: #0070cc;\n}\n\n.btn-dropbox:hover.btn-outline {\n  color: #ffffff;\n  border-color: #007ee5;\n}\n\n.btn-dropbox:hover::before {\n  background: #0062b2;\n}\n\n.btn-vimeo {\n  background: #aad450;\n}\n\n.btn-vimeo.btn-outline {\n  color: #aad450;\n  border-color: rgba(170, 212, 80, 0.6);\n  background: transparent;\n}\n\n.btn-vimeo:hover {\n  color: #ffffff;\n  background: #a0cf3c;\n}\n\n.btn-vimeo:hover.btn-outline {\n  color: #ffffff;\n  border-color: #aad450;\n}\n\n.btn-vimeo:hover::before {\n  background: #93c130;\n}\n\n.social-button .btn {\n  margin: 2px;\n  border-color: var(--border-color);\n  line-height: 28px;\n  color: var(--bs-body-color);\n}\n\n.social-button .btn:hover {\n  border-color: var(--admin-color);\n  color: #ffffff;\n  background: var(--admin-color);\n}\n\n/*===== 4.12 DROPDOWN =====*/\n.btn:focus,\n.btn:active,\n.btn.active,\n.dropdown-toggle:focus,\n.dropdown-toggle:active,\n.dropdown-toggle.active {\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n}\n\n.dropdown-toggle::after {\n  border-right: 5px solid transparent;\n  border-bottom: 0px;\n  border-top: 6px solid;\n  border-left: 5px solid transparent;\n  vertical-align: middle;\n}\n\n/* Button Split */\n.dropdown-toggle-split {\n  padding: 0 0.75rem;\n}\n\n/*===== BUTTON LOADING =====*/\n.btn.btn-ladda {\n  display: inline-block;\n  margin-bottom: 0;\n  font-weight: 500;\n  text-align: center;\n  vertical-align: middle;\n  -ms-touch-action: manipulation;\n  touch-action: manipulation;\n  cursor: pointer;\n  white-space: nowrap;\n  padding: auto 20px;\n  font-size: auto;\n  border-radius: 0px;\n}\n\n/*===== CARD =====*/\n.card {\n  /* width: 48%; */\n  border-radius: var(--border-radius);\n  /* -webkit-box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.03);\n  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.03); */\n  border: 1px solid var(--border-color);\n}\n\n.cardWrapper.card-default .card-body {\n  padding: 0;\n}\n\n.showLogin .card {\n  border-radius: 0;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.card .card-header h2,\n.card .card-header .h2 {\n  color: var(--text-color);\n  margin-bottom: 0.312rem;\n  font-size: 20px;\n  line-height: 1;\n}\n\n.card .card-img-overlay {\n  z-index: 1;\n}\n\n.card-default .card-header {\n  padding: 20px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  background-color: #ffffff;\n  border-radius: 15px 15px 0 0;\n}\n\n@media (min-width: 1500px) {\n  .card-default .card-header {\n    /* padding-left: 30px; */\n    /* padding-right: 30px; */\n  }\n}\n\n.card-default .card-header .dropdown-menu {\n  right: 0 !important;\n  left: auto !important;\n}\n\n.card-default .card-header h2,\n.card-default .card-header .h2 {\n  color: var(--card-title-color);\n  margin-bottom: 0;\n  font-size: 18px;\n  line-height: 1;\n  font-weight: 500;\n}\n\n.card-default .card-header .tools {\n  line-height: 15px;\n}\n\n.card-default .card-header .date-range-report {\n  line-height: 17px;\n}\n\n@media (max-width: 575.98px) {\n  .card-default .card-header .date-range-report {\n    width: 100%;\n    margin-top: 5px;\n  }\n}\n\n/* .card-default .card-header-border-bottom {\n  border-bottom: 1px solid var(--border-color);\n} */\n\n.card-default .card-header-border-bottom h2,\n.card-default .card-header-border-bottom .h2 {\n  margin-bottom: 0;\n}\n\n.card-default .card-body {\n  padding: 15px 20px;\n  overflow: auto;\n}\n\n.card-default .card-body p {\n  line-height: 1.5;\n  color: var(--bs-black-rgb);\n}\n\n.card-default .card-body .billingAddressWrapper p.mandatory_field {\n  color: var(--card-title-color);\n  font-weight: 500;\n  font-size: 15px;\n}\n\n.card-default .card-footer {\n  border-top: 1px solid var(--border-color);\n  padding-left: 20px;\n  padding-right: 20px;\n  border-radius: 0 0 15px 15px;\n}\n\n.card-default .card-footer a {\n  text-decoration: none;\n}\n\n.card-default .card-footer ul li {\n  font-size: 13px;\n}\n\n.card-default.contact a {\n  color: var(--bs-body-color);\n}\n\n.card-default.contact .contact-details .small {\n  font-size: 0.875rem;\n}\n\n/*Card mini*/\n.card-mini {\n  border: 1px solid var(--border-color);\n  border-radius: 15px;\n  -webkit-box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.03);\n  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.03);\n}\n\n.card-mini .card-body {\n  padding: 1.63rem;\n}\n\n.card-mini .card-body h2,\n.card-mini .card-body .h2 {\n  color: var(--text-color);\n  font-size: 23px;\n}\n\n.card-mini .chartjs-wrapper {\n  height: 100px;\n}\n\n.card-mini .card-footer {\n  border-top: 1px solid var(--border-color);\n}\n\n/* Card Icon Info*/\n.card-icon-info>i {\n  color: var(--admin-color);\n  font-size: 1.56rem;\n  display: inline-block;\n}\n\n.card-icon-info>span {\n  font-size: 0.88rem;\n  display: inline-block;\n}\n\n/* Card table border none */\n.card-table-border-none .card-header {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  background-color: #ffffff;\n}\n\n.card-table-border-none .card-header h2,\n.card-table-border-none .card-header .h2 {\n  color: var(--text-color);\n  margin-bottom: 0;\n  font-size: 20px;\n  line-height: 1;\n}\n\n.card-table-border-none .card-header-border-bottom {\n  background-color: #ffffff;\n  padding-top: 28px;\n  padding-bottom: 20px;\n  border-bottom: 1px solid var(--border-color);\n}\n\n.card-table-border-none .card-header-border-bottom h2,\n.card-table-border-none .card-header-border-bottom .h2 {\n  margin-bottom: 0;\n}\n\n.card-table-border-none .card-body {\n  padding: 20px;\n}\n\n@media (min-width: 1500px) {\n  .card-table-border-none .card-body {\n    padding: 3.125rem 3.125rem;\n  }\n}\n\n.card-table-border-none .card-footer {\n  border-top: 1px solid var(--border-color);\n  padding-left: 20px;\n  padding-right: 20px;\n}\n\n@media (min-width: 1500px) {\n  .card-table-border-none .card-footer {\n    padding-left: 3.125rem;\n    padding-right: 3.125rem;\n  }\n}\n\n.card-table-border-none tbody td,\n.card-table-border-none thead th {\n  border: none;\n}\n\n.card-table-border-none tbody td {\n  font-size: 14px;\n  padding-top: 30px;\n}\n\n.Sold-card-table tbody td,\n.Sold-card-table thead th {\n  border-bottom: 1px solid var(--border-color);\n}\n\n.Sold-card-table tbody td {\n  padding: 15px 0;\n  font-size: 15px;\n}\n\n.card-deck {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -ms-flex-flow: row wrap;\n  flex-flow: row wrap;\n  margin-right: -15px;\n  margin-left: -15px;\n}\n\n.card-deck .card {\n  -webkit-box-flex: 1;\n  -ms-flex: 1 0 0%;\n  flex: 1 0 0%;\n  margin-right: 15px;\n  margin-bottom: 0;\n  margin-left: 15px;\n}\n\n/*===== ACCORDION CARD =====*/\n.accordion .card {\n  border: 0px;\n  margin-bottom: 0.94rem;\n}\n\n.accordion .card-header {\n  padding: 0;\n  background-color: transparent;\n  border: none;\n}\n\n.accordion .card-header .btn,\n.accordion .card-header a {\n  display: block;\n  height: auto;\n  position: relative;\n  line-height: 1.5;\n  padding: 1.56rem;\n  width: 100%;\n  text-align: left;\n  text-decoration: none !important;\n  color: var(--text-color);\n  border-radius: calc(.25rem - 1px) calc(.25rem - 1px) 0 0;\n  white-space: unset;\n  -webkit-transition: all 0.3s 0.2s ease-in;\n  transition: all 0.3s 0.2s ease-in;\n}\n\n.noteContent{\n  font-size: 10px;\n  font-weight: 300;\n}\n\n@media (prefers-reduced-motion: reduce) {\n\n  .accordion .card-header .btn,\n  .accordion .card-header a {\n    -webkit-transition: none;\n    transition: none;\n  }\n}\n\n.accordion .card-header .btn:after,\n.accordion .card-header a:after {\n  position: absolute;\n  color: var(--bs-body-color);\n  font-size: 15px;\n  right: 25px;\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n  transform: translateY(-50%);\n}\n\n.accordion .card-header .btn:hover,\n.accordion .card-header .btn:focus,\n.accordion .card-header a:hover,\n.accordion .card-header a:focus {\n  text-decoration: none !important;\n}\n\n.accordion .card-header .btn[aria-expanded=false]:after,\n.accordion .card-header a[aria-expanded=false]:after {\n  content: \"\";\n  font-family: \"Material Design Icons\";\n}\n\n.accordion .card-header .btn[aria-expanded=true],\n.accordion .card-header a[aria-expanded=true] {\n  -webkit-box-shadow: 0px 0px 19px rgba(229, 230, 235, 0.6) !important;\n  box-shadow: 0px 0px 19px rgba(229, 230, 235, 0.6) !important;\n  color: var(--admin-color);\n  border-bottom: 1px solid var(--border-color);\n}\n\n.accordion .card-header .btn[aria-expanded=true]:after,\n.accordion .card-header a[aria-expanded=true]:after {\n  content: \"\";\n  font-family: \"Material Design Icons\";\n  color: var(--admin-color);\n}\n\n.accordion .card-body {\n  -webkit-box-shadow: 0px 7px 19px rgba(229, 230, 235, 0.6);\n  box-shadow: 0px 7px 19px rgba(229, 230, 235, 0.6);\n}\n\n.accordion-shadow .card {\n  -webkit-box-shadow: 0px 7px 19px rgba(229, 230, 235, 0.6);\n  box-shadow: 0px 7px 19px rgba(229, 230, 235, 0.6);\n}\n\n.accordion-shadow .card-header .btn[aria-expanded=false]:after,\n.accordion-shadow .card-header a[aria-expanded=false]:after {\n  opacity: 1;\n}\n\n.accordion-shadow .card-header .btn[aria-expanded=true],\n.accordion-shadow .card-header a[aria-expanded=true] {\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n}\n\n.accordion-shadow .card-header .btn[aria-expanded=true]:after,\n.accordion-shadow .card-header a[aria-expanded=true]:after {\n  content: \"\";\n  font-family: \"Material Design Icons\";\n  color: var(--admin-color);\n}\n\n.accordion-shadow .card-body {\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n}\n\n.accordion-bordered .card {\n  border: 1px solid var(--border-color) !important;\n  border-radius: 0;\n}\n\n.accordion-bordered .card-header .btn[aria-expanded=false]:after,\n.accordion-bordered .card-header a[aria-expanded=false]:after {\n  opacity: 1;\n}\n\n.accordion-bordered .card-header .btn[aria-expanded=true],\n.accordion-bordered .card-header a[aria-expanded=true] {\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n}\n\n.accordion-bordered .card-body {\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n}\n\n.accordion-header-border-bottom .card-header {\n  border-bottom: 1px solid var(--border-color);\n}\n\n.accordion-header-border-bottom .card-header .btn,\n.accordion-header-border-bottom .card-header a {\n  padding: 1.56rem 0;\n  border-bottom: none;\n}\n\n.accordion-header-border-bottom .card-header .btn:after,\n.accordion-header-border-bottom .card-header a:after {\n  right: 0;\n}\n\n.accordion-header-border-bottom .card-header .btn[aria-expanded=false]:after,\n.accordion-header-border-bottom .card-header a[aria-expanded=false]:after {\n  opacity: 1;\n}\n\n.accordion-header-border-bottom .card-header .btn[aria-expanded=true],\n.accordion-header-border-bottom .card-header a[aria-expanded=true] {\n  border-bottom: none;\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n}\n\n.accordion-header-border-bottom .card-header .btn[aria-expanded=true]:after,\n.accordion-header-border-bottom .card-header a[aria-expanded=true]:after {\n  content: \"\";\n  font-family: \"Material Design Icons\";\n  color: var(--admin-color);\n}\n\n.accordion-header-border-bottom .card-body {\n  padding-left: 0;\n  padding-right: 0;\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n}\n\n.accordion .card-header {\n  padding: 0 !important;\n  background-color: transparent;\n  border: none;\n}\n\n.full-calendar {\n  position: relative;\n}\n\n.full-calendar .fc-header-toolbar {\n  margin: 30px;\n  line-height: 0;\n}\n\n@media (min-width: 1500px) {\n  .full-calendar .fc-header-toolbar {\n    margin: 30px 50px;\n  }\n}\n\n.full-calendar .fc-toolbar {\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-align: start;\n  -ms-flex-align: start;\n  align-items: flex-start;\n}\n\n@media (min-width: 768px) {\n  .full-calendar .fc-toolbar {\n    -ms-flex-flow: wrap;\n    flex-flow: wrap;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n  }\n}\n\n.full-calendar .fc-left {\n  margin-bottom: 25px;\n}\n\n@media (min-width: 768px) {\n  .full-calendar .fc-left {\n    margin-bottom: 0;\n  }\n}\n\n.full-calendar .fc-left h2,\n.full-calendar .fc-left .h2 {\n  color: var(--text-color);\n  font-size: 1.25125rem;\n  text-transform: capitalize;\n  margin-left: 0;\n}\n\n.full-calendar .fc-view-container {\n  background-color: #ffffff;\n  border-radius: 0.25rem;\n  border: 1px solid #ddd;\n  margin: 30px;\n}\n\n@media (min-width: 1500px) {\n  .full-calendar .fc-view-container {\n    margin: 30px 50px 50px;\n  }\n}\n\n.full-calendar thead tr {\n  background-color: transparent;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.full-calendar .fc-day-header {\n  padding: 10px 0;\n}\n\n.full-calendar .fc-day-header span {\n  color: #000;\n  font-size: 1rem;\n}\n\n.full-calendar .fc-time,\n.full-calendar .fc-title {\n  color: #ffffff;\n}\n\n.full-calendar .fc-day-number {\n  color: #000;\n}\n\n.full-calendar .fc-time {\n  font-weight: normal;\n}\n\n.full-calendar thead tr th:first-child {\n  border-top-left-radius: 10px;\n}\n\n.full-calendar .fc-event {\n  border: 1px solid transparent;\n}\n\n.full-calendar .fc-event,\n.full-calendar .fc-event-dot {\n  background-color: var(--admin-color);\n  cursor: pointer;\n}\n\n.full-calendar .fc-button-primary {\n  background-color: #ffffff;\n  border-color: #ddd;\n}\n\n.full-calendar .fc-button-primary:focus {\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n}\n\n.full-calendar .fc-button-primary:hover {\n  background-color: transparent;\n  border-color: #ddd;\n}\n\n.error-message{\n  text-align: center;\n  color: var(--bs-red);\n}\n\n.full-calendar .fc-icon {\n  margin-top: -3px;\n}\n\n.full-calendar .fc-icon-chevron-left,\n.full-calendar .fc-icon-chevron-right {\n  color: var(--bs-body-color);\n}\n\n.full-calendar .fc-today-button {\n  color: #ffffff;\n  background-color: var(--admin-color);\n  border-color: var(--admin-color);\n  text-transform: uppercase;\n}\n\n.full-calendar .fc-today-button:focus {\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n}\n\n.full-calendar .fc-today-button:hover {\n  color: var(--admin-color);\n  background-color: #ffffff;\n  border-color: var(--admin-color);\n}\n\n.full-calendar .fc-button:disabled {\n  opacity: 1;\n}\n\n.full-calendar .fc-button-primary:not(:disabled).fc-button-active,\n.full-calendar .fc-button-primary:not(:disabled):active {\n  background-color: transparent;\n  border-color: #ddd;\n}\n\n.full-calendar .fc td,\n.full-calendar .fc th {\n  border: 1px solid transparent;\n}\n\n.full-calendar .fc td {\n  border-right: 1px solid #ddd;\n}\n\n.full-calendar .fc td:last-child {\n  border-right-color: transparent;\n}\n\n.full-calendar .fc-row .fc-bg {\n  border-top: 1px solid #ddd !important;\n}\n\n.full-calendar tbody tr {\n  border-bottom: 1px solid #ddd !important;\n}\n\n.full-calendar .fc th {\n  border: 1px solid #ddd;\n}\n\n.full-calendar .fc-past-event {\n  background-color: #bfbfc3;\n}\n\n.full-calendar .fc-current-event .fc-time,\n.full-calendar .fc-current-event .fc-title {\n  font-size: 13px;\n}\n\n.full-calendar .fc-today .fc-day-number {\n  background-color: var(--admin-color);\n  color: #ffffff;\n  border-radius: 50%;\n  width: 20px;\n  height: 20px;\n  line-height: 20px;\n  text-align: center;\n}\n\n.fc-datepicker-header {\n  cursor: pointer;\n}\n\n.fc-unthemed td.fc-today {\n  background-color: rgba(136, 170, 243, 0.3);\n}\n\n.ui-icon {\n  top: -4px;\n  left: -7px;\n}\n\n/*===== ALERT =====*/\nlabel {\n  /* text-transform: capitalize; */\n}\n\np,\nli,\nspan {\n  letter-spacing: 0.02rem;\n}\n\n.alert {\n  font-size: 15px;\n  font-weight: 500;\n  color: var(--text-color);\n}\n\n.alert.alert-highlighted {\n  color: #ffffff;\n}\n\n.alert.alert-primary {\n  background-color: #ffdada;\n  border-color: #c5d6fc;\n}\n\n.alert.alert-secondary {\n  background-color: #cacaca;\n  border-color: #cacaca;\n}\n\n.alert.alert-success {\n  background-color: #bffde9;\n  border-color: #bffde9;\n}\n\n.alert.alert-danger {\n  background-color: #ffc3c8;\n  border-color: #ffc3c8;\n}\n\n.alert.alert-warning {\n  background-color: #faeec6;\n  border-color: #faeec6;\n}\n\n.alert.alert-info {\n  background-color: #b8f5fc;\n  border-color: #b8f5fc;\n}\n\n.alert.alert-light {\n  background-color: #f5f6fa;\n  border-color: #f5f6fa;\n  color: var(--text-color);\n}\n\n.alert.alert-dark {\n  background-color: #3d3d3d;\n  border-color: #3d3d3d;\n}\n\n.alert.alert-outlined {\n  background-color: transparent;\n  color: #3d3d3d;\n}\n\n/* Notification List */\n.notifications-list li a {\n  display: block;\n  color: var(--bs-body-color);\n  font-size: 0.88rem;\n  padding: 0.625rem 1.25rem;\n}\n\n.notifications-list li:hover {\n  /* background-color: #fdfdfd; */\n}\n\n/*===== ALERT =====*/\n.bg-primary {\n  background-color: var(--admin-color) !important;\n}\n\n.bg-success {\n  background-color: #34c997 !important;\n}\n\n.bg-warning {\n  background-color: #ddaa04 !important;\n}\n\n.bg-info {\n  background-color: #24c4da !important;\n}\n\n.bg-danger {\n  background-color: #ec4a58 !important;\n}\n\nlabel {\n  /* text-transform: capitalize; */\n  display: inline-block;\n  margin-bottom: 0.5rem;\n}\n\n.text-right {\n  text-align: right !important;\n}\n\n@media (max-width: 1199.98px) {\n  .ec-cust-card {\n    margin-bottom: 24px;\n  }\n}\n\n.ec-cust-card tbody td {\n  padding-top: 22px;\n}\n\n.ec-cust-card tbody td small,\n.ec-cust-card tbody td .small {\n  color: #999;\n}\n\n.ec-card-top-prod .ec-pos {\n  position: relative;\n}\n\n.ec-card-top-prod .ec-price {\n  margin-top: 10px;\n}\n\n.ec-card-top-prod .ec-price span {\n  margin-right: 10px;\n  font-weight: 500;\n}\n\n.ec-card-top-prod .ec-price del {\n  color: #999;\n  font-size: 13px;\n}\n\n.ec-card-top-prod .sale {\n  position: absolute;\n  top: 0;\n  right: 15px;\n  color: #999 !important;\n  font-size: 13px;\n}\n\n.media-image img {\n  width: 100%;\n  border-radius: 15px;\n}\n\n.table .tbl-thumb {\n  width: 50px;\n  border-radius: 15px;\n}\n\n.rounded-circle {\n  border-radius: 15px !important;\n}\n\n.border-right {\n  border-right: 1px solid #e5e9f2;\n}\n\n.p-b-15 {\n  padding-bottom: 24px;\n}\n\n.p-20 {\n  padding: 20px;\n}\n\n.dash-card .card-body span {\n  position: absolute;\n  right: 20px;\n  bottom: 25px;\n  font-size: 30px;\n  border-radius: 15px;\n  width: 50px;\n  height: 50px;\n  text-align: center;\n  background: var(--admin-color);\n  color: #ffffff;\n}\n\n.profile-img {\n  width: 50px !important;\n}\n\n/* ===== CARET =====*/\n.caret {\n  display: inline-block;\n  width: 0;\n  height: 0;\n  margin-left: 0.125rem;\n  vertical-align: middle;\n  border-top: 4px dashed;\n  border-top: 4px solid;\n  border-right: 4px solid transparent;\n  border-left: 4px solid transparent;\n\n}\n\n/* ===== Form Control =====*/\n.form-control {\n  border-radius: 5px;\n}\n\n/*===== CAROUSEL =====*/\n.carousel-indicators {\n  bottom: 0;\n}\n\n@media (min-width: 768px) {\n  .carousel-indicators {\n    bottom: -5px;\n  }\n}\n\n.carousel-indicators.indicator-success li {\n  background-color: rgba(52, 201, 151, 0.2);\n}\n\n.carousel-indicators.indicator-success li.active {\n  background-color: #34c997;\n}\n\n.carousel-indicators li {\n  -webkit-box-sizing: content-box;\n  box-sizing: content-box;\n  -webkit-box-flex: 0;\n  -ms-flex: 0 1 auto;\n  flex: 0 1 auto;\n  width: 30px;\n  height: 3px;\n  margin-right: 3px;\n  margin-left: 3px;\n  text-indent: -999px;\n  cursor: pointer;\n  background-color: #ffffff;\n  background-clip: padding-box;\n  border-top: 10px solid transparent;\n  border-bottom: 10px solid transparent;\n  opacity: 0.5;\n  -webkit-transition: opacity 0.6s ease;\n  transition: opacity 0.6s ease;\n}\n\n.carousel-caption {\n  bottom: 40px;\n}\n\n/* Carousel Testimonial */\n.carousel-testimonial .carousel-control-next,\n.carousel-testimonial .carousel-control-prev {\n  color: red;\n}\n\n.carousel-testimonial .carousel-control-prev,\n.carousel-testimonial .carousel-control-next {\n  width: auto;\n  z-index: 55;\n  color: var(--bs-body-color);\n}\n\n.carousel-testimonial .carousel-control-prev .carousel-control-prev-icon {\n  color: var(--bs-body-color);\n}\n\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n/*===== CHART =====*/\n@media (max-width: 575.98px) {\n  #user-acquisition .mb-6 {\n    margin-bottom: 80px !important;\n  }\n}\n\n.world-data-chart {\n  padding-left: 20px;\n  padding-right: 20px;\n}\n\n@media (min-width: 1200px) {\n  .world-data-chart.border-bottom {\n    border-bottom: 0 !important;\n    border-right: 1px solid var(--border-color);\n  }\n}\n\n#regions_purchase>div>div {\n  margin: 0 auto 30px auto;\n}\n\n@media (min-width: 1200px) {\n  #linechart {\n    min-height: 280px;\n  }\n}\n\n@media (min-width: 1200px) {\n  #doChart {\n    min-height: 210px;\n  }\n}\n\n#polar,\n#radar {\n  min-height: 200px;\n}\n\n@media (min-width: 768px) {\n\n  #polar,\n  #radar {\n    min-height: 230px;\n  }\n}\n\n@media (min-width: 1200px) {\n\n  #polar,\n  #radar {\n    min-height: 270px;\n    min-width: 100%;\n  }\n}\n\n[polar-data-height] {\n  height: 455px;\n}\n\n[radar-data-height] {\n  height: 408px;\n}\n\n@media (min-width: 1200px) {\n  #currentUser {\n    min-height: 283px;\n    height: 283px !important;\n  }\n}\n\n@media (min-width: 1200px) {\n  #activity {\n    min-height: 280px;\n  }\n}\n\n#deviceChart {\n  min-height: 200px;\n}\n\n@media (min-width: 768px) {\n  #deviceChart {\n    min-height: 230px;\n  }\n}\n\n/* Coutom Lenged*/\n.customLegend li {\n  display: inline-block;\n  margin-right: 20px;\n  margin-top: 20px;\n}\n\n.customLegend li span {\n  display: inline-block;\n  width: 12px;\n  height: 12px;\n  margin-right: 0.312rem;\n  border-radius: 1.56rem;\n}\n\n.chat {\n  border-radius: 0.25rem;\n}\n\n.chat .chat-left-side .chat-search {\n  padding-left: 1rem;\n  padding-right: 1rem;\n  padding-top: 1.5rem;\n  padding-bottom: 1.5rem;\n}\n\n.chat .chat-left-side #chat-left-content {\n  height: 373px !important;\n}\n\n@media (min-width: 992px) {\n  .chat .chat-left-side #chat-left-content {\n    height: calc(100vh - 320px) !important;\n  }\n}\n\n@media (min-width: 1200px) {\n  .chat .chat-left-side #chat-left-content {\n    height: calc(100vh - 350px) !important;\n  }\n}\n\n@media (min-width: 768px) {\n  .chat .chat-left-side .last-msg {\n    width: 300px;\n  }\n}\n\n@media (min-width: 992px) {\n  .chat .chat-left-side .last-msg {\n    width: 125px;\n  }\n}\n\n@media (min-width: 1500px) {\n  .chat .chat-left-side .last-msg {\n    width: 220px;\n  }\n}\n\n.chat .chat-right-side {\n  border-left: 1px solid var(--border-color);\n}\n\n.chat .chat-right-side .chat-right-content {\n  padding: 1.5rem;\n}\n\n.chat .chat-right-side #chat-right-content {\n  height: 373px !important;\n}\n\n@media (min-width: 992px) {\n  .chat .chat-right-side #chat-right-content {\n    height: calc(100vh - 395px) !important;\n  }\n}\n\n@media (min-width: 1200px) {\n  .chat .chat-right-side #chat-right-content {\n    height: calc(100vh - 405px) !important;\n  }\n}\n\npre {\n  border-left: 4px solid var(--admin-color);\n  padding: 1.25rem 0.94rem;\n  background: rgba(0, 0, 0, 0.05);\n  border-radius: 0.19rem;\n}\n\npre code {\n  background: transparent;\n  font-size: 1rem;\n  color: var(--text-color);\n}\n\n.pre-code,\ncode {\n  font-family: Menlo, Monaco, \"Courier New\", Courier, monospace;\n  font-size: 1rem;\n  background: rgba(0, 0, 0, 0.05);\n  padding: 0.19rem 0.625rem;\n  margin: 0 0.125rem;\n  color: var(--text-color);\n}\n\n.pre-code {\n  padding: 1.25rem 0.94rem !important;\n}\n\n/* Dropdown Menu */\n.dropdown-menu {\n  border: 1px solid var(--border-color);\n  right: 0;\n}\n\n.sign-inup .container {\n  position: relative;\n  z-index: 2;\n}\n\n.sign-inup .form-height {\n  height: 100vh;\n}\n\n@media (max-width: 575.98px) {\n  .sign-inup .form-height {\n    height: 100%;\n  }\n}\n\n@media (max-height: 600px) {\n  .sign-inup .form-height {\n    height: 100%;\n  }\n}\n\n.sign-inup .form-height-login {\n  height: 100vh;\n}\n\n@media (max-width: 575.98px) {\n  .sign-inup .form-height-login {\n    height: 100%;\n  }\n}\n\n@media (max-height: 480px) {\n  .sign-inup .form-height-login {\n    height: 100%;\n  }\n}\n\n/*===== REGISTRATION =====*/\n.sign-inup .card {\n  overflow: hidden;\n}\n\n@media (max-width: 991.98px) {\n  .sign-inup .card {\n    max-width: 430px;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .sign-inup .card .p-5 {\n    padding: 20px 15px 15px 15px !important;\n  }\n}\n\n.sign-inup .card .ec-brand {\n  border: none;\n}\n\n.sign-inup .card form .control {\n  color: #777777;\n}\n\n.sign-inup .card form button {\n  width: 130px;\n  margin: auto;\n}\n\n.sign-inup .text-dark {\n  text-align: center;\n  margin-bottom: 25px !important;\n}\n\n.sign-inup .ec-brand span {\n  width: 100%;\n  padding: 0;\n  display: block;\n  text-align: center;\n  border: none;\n}\n\n.sign-inup .ec-brand span img {\n  margin-bottom: 0;\n}\n\n.sign-inup .sign-upp {\n  text-align: center;\n}\n\n.sign-inup .ec-brand span img {\n  width: 100px;\n  max-width: 100px;\n}\n\n.sign-upp {\n  text-align: center;\n}\n\n/* Separator */\n.separator {\n  border-top: 1px solid var(--border-color);\n}\n\n/*===== DATERANGEPICKER =====*/\n.daterangepicker {\n  -webkit-box-shadow: 0px 5px 18px 0px rgba(229, 233, 242, 0.5);\n  box-shadow: 0px 5px 18px 0px rgba(229, 233, 242, 0.5);\n}\n\n.daterangepicker .ranges ul {\n  padding-top: 0.625rem;\n  padding-bottom: 0.625rem;\n  width: auto;\n}\n\n.daterangepicker .ranges li {\n  padding: 0.5rem 1.25rem;\n  font-size: 0.875rem;\n}\n\n.daterangepicker .ranges li.active {\n  background-color: transparent;\n  color: var(--admin-color);\n}\n\n.daterangepicker:before,\n.daterangepicker:after {\n  display: none;\n}\n\n.daterangepicker .drp-buttons .btn {\n  padding: 0 1.25rem;\n}\n\n.daterangepicker td.in-range {\n  background-color: rgba(136, 170, 243, 0.1);\n}\n\n.daterangepicker td.available:hover {\n  background-color: var(--admin-color);\n  color: #ffffff;\n}\n\n.daterangepicker .ranges li:hover {\n  background-color: transparent;\n  color: var(--admin-color);\n}\n\n/* Ragnge Date Picker */\n.date-range-report span {\n  cursor: pointer;\n}\n\n.date-range-report span:after {\n  display: inline-block;\n  width: 0;\n  height: 0;\n  margin-left: 1em;\n  content: \"\";\n  border-right: 5px solid transparent;\n  border-bottom: 0px;\n  border-top: 6px solid;\n  border-left: 5px solid transparent;\n  vertical-align: middle;\n}\n\n.date-range::-webkit-input-placeholder {\n  color: #495057;\n}\n\n.date-range::-moz-placeholder {\n  color: #495057;\n}\n\n.date-range:-ms-input-placeholder {\n  color: #495057;\n}\n\n.date-range::-ms-input-placeholder {\n  color: #495057;\n}\n\n.date-range::placeholder {\n  color: #495057;\n}\n\n/*===== FORMS =====*/\n.form-control:focus {\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.form-group,\n.input-group {\n  /* padding: 0px; */\n  /* margin-bottom: 1.25rem; */\n}\n\n.form-group label,\n.input-group label {\n  /* color: #56606e; */\n  font-size: 14px;\n  margin-bottom: 12px;\n  font-weight: 500;\n}\n\n.form-group label {\n  color: var(--gray-text-color);\n}\n\n.form-group .form-control,\n.input-group .form-control {\n  font-size: 14px;\n  /* height: 35px; */\n  padding: 0.5rem 0.5rem;\n  border-color: var(--border-color);\n  margin-bottom: 18px;\n}\n\n.form-group .form-control.input-lg,\n.input-group .form-control.input-lg {\n  font-size: 1.06rem;\n  padding: 0.9375rem 1.06rem;\n}\n\n.form-group .form-control.input-sm,\n.input-group .form-control.input-sm {\n  font-size: 0.8125rem;\n  padding: 0.38rem 1.06rem;\n}\n\n.form-group .input-group-prepend,\n.input-group .input-group-prepend {\n  margin-right: -1px;\n}\n\n.form-group .input-group-prepend,\n.form-group .input-group-append,\n.input-group .input-group-prepend,\n.input-group .input-group-append {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.form-pill .form-group .form-control {\n  border-radius: 100px;\n}\n\n.horizontal-form .form-check {\n  padding-left: 0;\n}\n\n.horizontal-form .form-check label {\n  font-weight: 400;\n  font-size: 0.875rem;\n}\n\n.form-row {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  margin-right: -5px;\n  margin-left: -5px;\n}\n\n.form-row>[className*=col-] {\n  padding-right: 5px;\n  padding-left: 5px;\n}\n\n/* Form components - checkbox and radios */\n.control {\n  display: block;\n  position: relative;\n  padding-left: 1.56rem;\n  color: var(--text-color);\n  margin-bottom: 0.9375rem;\n  cursor: pointer;\n  font-size: 0.875rem;\n  font-weight: 500;\n}\n\n.control input {\n  position: absolute;\n  z-index: -1;\n  opacity: 0;\n}\n\n.control-indicator {\n  position: absolute;\n  top: 2px;\n  left: 0;\n  height: 15px;\n  width: 15px;\n  background: #e1e2e5;\n  border: 1px solid #ccc;\n  border-radius: 0.125rem;\n}\n\n.control-radio .control-indicator {\n  border-radius: 50%;\n}\n\n.control input:disabled~.control-indicator {\n  background: #e1e2e5;\n  opacity: 0.6;\n  pointer-events: none;\n  border: 1px solid #ccc;\n}\n\n.control-indicator:after {\n  content: \"\";\n  position: absolute;\n  display: none;\n}\n\n.control input:checked~.control-indicator:after {\n  display: block;\n}\n\n.control-checkbox .control-indicator:after {\n  left: 4px;\n  top: 1px;\n  width: 5px;\n  height: 8px;\n  background: transparent !important;\n  border: solid var(--text-color);\n  border-width: 0 2px 2px 0;\n  -webkit-transform: rotate(45deg);\n  transform: rotate(45deg);\n}\n\n.control-checkbox input:disabled~.control-indicator:after {\n  border-color: #7b7b7b;\n}\n\n.control-radio .control-indicator:after {\n  left: 4px;\n  top: 4px;\n  height: 5px;\n  width: 5px;\n  border-radius: 50%;\n  background: var(--text-color);\n}\n\n.control-radio input:disabled~.control-indicator:after {\n  background: #7b7b7b;\n}\n\n/* Contextual Style */\n.checkbox-primary .control-indicator,\n.radio-primary .control-indicator {\n  background: var(--admin-color);\n  border-color: var(--admin-color);\n}\n\n.checkbox-primary .control-indicator::after,\n.radio-primary .control-indicator::after {\n  color: #ffffff;\n  border-color: #ffffff;\n  background: #ffffff;\n}\n\n.checkbox-warning .control-indicator,\n.radio-warning .control-indicator {\n  background: #ddaa04;\n  border-color: #ddaa04;\n}\n\n.checkbox-warning .control-indicator::after,\n.radio-warning .control-indicator::after {\n  color: #ffffff;\n  border-color: #ffffff;\n  background: #ffffff;\n}\n\n.checkbox-danger .control-indicator,\n.radio-danger .control-indicator {\n  background: #ec4a58;\n  border-color: #ec4a58;\n}\n\n.checkbox-danger .control-indicator::after,\n.radio-danger .control-indicator::after {\n  color: #ffffff;\n  border-color: #ffffff;\n  background: #ffffff;\n}\n\n.checkbox-success .control-indicator,\n.radio-success .control-indicator {\n  background: #34c997;\n  border-color: #34c997;\n}\n\n.checkbox-success .control-indicator::after,\n.radio-success .control-indicator::after {\n  color: #ffffff;\n  border-color: #ffffff;\n  background: #ffffff;\n}\n\n.checkbox-info .control-indicator,\n.radio-info .control-indicator {\n  background: #24c4da;\n  border-color: #24c4da;\n}\n\n.checkbox-info .control-indicator::after,\n.radio-info .control-indicator::after {\n  color: #ffffff;\n  border-color: #ffffff;\n  background: #ffffff;\n}\n\n/* All Outline Contextual Style */\n.control.outlined .control-indicator {\n  background: transparent !important;\n}\n\n.control.outlined input:disabled~.control-indicator {\n  background: transparent !important;\n}\n\n.control.outlined.checkbox-primary .control-indicator,\n.control.outlined.radio-primary .control-indicator {\n  background: transparent;\n  border-color: var(--admin-color);\n}\n\n.control.outlined.checkbox-primary .control-indicator::after,\n.control.outlined.radio-primary .control-indicator::after {\n  background: var(--admin-color);\n  border-color: var(--admin-color);\n  color: #ffffff;\n}\n\n.control.outlined.checkbox-warning .control-indicator,\n.control.outlined.radio-warning .control-indicator {\n  background: transparent;\n  border-color: #ddaa04;\n}\n\n.control.outlined.checkbox-warning .control-indicator::after,\n.control.outlined.radio-warning .control-indicator::after {\n  background: #ddaa04;\n  border-color: #ddaa04;\n  color: #ffffff;\n}\n\n.control.outlined.checkbox-danger .control-indicator,\n.control.outlined.radio-danger .control-indicator {\n  background: transparent;\n  border-color: #ec4a58;\n}\n\n.control.outlined.checkbox-danger .control-indicator::after,\n.control.outlined.radio-danger .control-indicator::after {\n  background: #ec4a58;\n  border-color: #ec4a58;\n  color: #ffffff;\n}\n\n.control.outlined.checkbox-success .control-indicator,\n.control.outlined.radio-success .control-indicator {\n  background: transparent;\n  border-color: #34c997;\n}\n\n.control.outlined.checkbox-success .control-indicator::after,\n.control.outlined.radio-success .control-indicator::after {\n  background: #34c997;\n  border-color: #34c997;\n  color: #ffffff;\n}\n\n.control.outlined.checkbox-info .control-indicator,\n.control.outlined.radio-info .control-indicator {\n  background: transparent;\n  border-color: #24c4da;\n}\n\n.control.outlined.checkbox-info .control-indicator::after,\n.control.outlined.radio-info .control-indicator::after {\n  background: #24c4da;\n  border-color: #24c4da;\n  color: #ffffff;\n}\n\n.custom-select {\n  width: auto;\n  margin-left: 0.625rem;\n}\n\n/* Form components- input groups */\n.input-group>.input-group-prepend>.input-group-text,\n.input-group>.input-group-append>.input-group-text {\n  background-color: #fdfdfd;\n  border-color: var(--border-color);\n}\n\n.input-group>.input-group-prepend>.input-group-text.bg-primary,\n.input-group>.input-group-append>.input-group-text.bg-primary {\n  border-color: var(--admin-color);\n  color: #ffffff;\n}\n\n.input-group>.input-group-prepend>.input-group-text.bg-warning,\n.input-group>.input-group-append>.input-group-text.bg-warning {\n  border-color: #ddaa04;\n  color: #ffffff;\n}\n\n.input-group>.input-group-prepend>.input-group-text.bg-danger,\n.input-group>.input-group-append>.input-group-text.bg-danger {\n  border-color: #ec4a58;\n  color: #ffffff;\n}\n\n.input-group>.input-group-prepend>.input-group-text.bg-success,\n.input-group>.input-group-append>.input-group-text.bg-success {\n  border-color: #34c997;\n  color: #ffffff;\n}\n\n.input-group>.input-group-prepend>.input-group-text .control,\n.input-group>.input-group-append>.input-group-text .control {\n  margin-bottom: 1.25rem;\n}\n\n.input-group>.input-group-prepend .form-check,\n.input-group>.input-group-append .form-check {\n  padding-left: 0;\n}\n\n.input-group>.input-group-prepend .form-check .form-check-label,\n.input-group>.input-group-append .form-check .form-check-label {\n  margin-bottom: 0;\n}\n\n.input-group>.input-group-prepend .form-check .radio-custom-label:before,\n.input-group>.input-group-prepend .form-check .checkbox-custom-label:before,\n.input-group>.input-group-append .form-check .radio-custom-label:before,\n.input-group>.input-group-append .form-check .checkbox-custom-label:before {\n  margin-right: 0;\n  background: #ffffff;\n}\n\n.input-group>.input-group-prepend .form-check .radio-custom:checked+.radio-custom-label:before,\n.input-group>.input-group-prepend .form-check .checkbox-custom:checked+.checkbox-custom-label:before,\n.input-group>.input-group-append .form-check .radio-custom:checked+.radio-custom-label:before,\n.input-group>.input-group-append .form-check .checkbox-custom:checked+.checkbox-custom-label:before {\n  border: 1px solid #d4d5db;\n  line-height: 1rem;\n}\n\n.input-group>.input-group-prepend .form-check .radio-custom:checked+.radio-custom-label:before,\n.input-group>.input-group-append .form-check .radio-custom:checked+.radio-custom-label:before {\n  font-size: 0.5rem;\n}\n\n/* Form components- Validation */\n.invalid-feedback,\n.valid-feedback {\n  font-size: 90%;\n}\n\n/* Form components- Advanced */\n.select2-container--default .select2-selection--multiple {\n  border-color: var(--border-color);\n}\n\n.select2-container--default.select2-container--focus .select2-selection--multiple {\n  border-color: rgba(136, 170, 243, 0.5);\n}\n\n.select2-container--default .select2-selection--multiple .select2-selection__choice {\n  border-color: #4c84ff;\n  background-color: rgba(76, 132, 255, 0.051);\n  color: #4c84ff;\n}\n\n.select2-container--default .select2-selection--multiple .select2-selection__choice__remove {\n  color: #4c84ff;\n  padding-right: 0.31rem;\n  margin-right: 0.31rem;\n  border-right: 1px solid #4c84ff;\n}\n\n.form-group .custom-file {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  height: calc(1.5em + 1.18rem + 2px);\n  margin-bottom: 0;\n}\n\n.form-group .custom-file .custom-file-input {\n  position: relative;\n  z-index: 2;\n  width: 100%;\n  height: calc(1.5em + 1.18rem + 2px);\n  margin: 0;\n  overflow: hidden;\n  opacity: 0;\n}\n\n.form-group .custom-file .form-group label,\n.form-group .custom-file .input-group label {\n  color: #1b223c;\n  font-size: 15px;\n}\n\n.form-group .custom-file .custom-file-label {\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1;\n  height: calc(1.5em + 1.18rem + 2px);\n  width: 80px;\n  padding: 0.59rem 1rem;\n  overflow: hidden;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #495057;\n  background-color: #ffffff;\n  border: 1px solid #ced4da;\n  border-radius: 0.25rem;\n}\n\n.form-group .custom-file .custom-file-label::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 3;\n  display: block;\n  height: calc(1.5em + 1.18rem);\n  padding: 0.59rem 1rem;\n  line-height: 1.5;\n  color: #495057;\n  content: \"Browse\";\n  background-color: #e9ecef;\n  border-left: inherit;\n  border-radius: 0 0.25rem 0.25rem 0;\n}\n\n/* Media Small */\n.media {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: start;\n  -ms-flex-align: start;\n  align-items: flex-start;\n}\n\n.media-message {\n  padding-left: 1rem;\n  padding-right: 1rem;\n  padding-top: 0.75rem;\n  padding-bottom: 0.75rem;\n}\n\n.media-message img {\n  width: 40px;\n}\n\n.media-message .status {\n  position: absolute;\n  bottom: 0;\n  right: 0px;\n  width: 12px;\n  height: 12px;\n  border: 2px solid transparent;\n  border-radius: 50%;\n}\n\n.media-message .status.active,\n.media-message .status.away {\n  border-color: #ffffff;\n}\n\n.media-message .status.active {\n  background-color: #34c997;\n}\n\n.media-message .status.away {\n  background-color: #ddaa04;\n}\n\n.media-message .title {\n  color: var(--text-color);\n  font-size: 0.9375rem;\n  margin-bottom: 0;\n}\n\n.media-message .last-msg {\n  width: 180px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  margin-bottom: 0;\n  color: var(--bs-body-color);\n}\n\n@media (min-width: 768px) {\n  .media-message .last-msg {\n    width: 550px;\n  }\n}\n\n@media (min-width: 992px) {\n  .media-message .last-msg {\n    width: 125px;\n  }\n}\n\n@media (min-width: 1200px) {\n  .media-message .last-msg {\n    width: 220px;\n  }\n}\n\n.media-message .date {\n  text-align: right;\n  font-size: 12px;\n  color: var(--bs-body-color);\n}\n\n.media-message:hover {\n  background-color: rgba(233, 236, 239, 0.5);\n  text-decoration: none;\n}\n\n.media-message.media-active {\n  background-color: var(--admin-color);\n}\n\n.media-message.media-active .title,\n.media-message.media-active .last-msg,\n.media-message.media-active .date {\n  color: #ffffff;\n}\n\n.media-message.event-active {\n  background-color: rgba(233, 236, 239, 0.5);\n}\n\n.media-notification .last-msg {\n  width: 200px;\n}\n\n.media-chat {\n  margin-bottom: 1.5rem;\n}\n\n.media-chat .content {\n  background-color: rgba(233, 236, 239, 0.5);\n  padding: 0.5rem 1.25rem;\n  border-radius: 0.25rem;\n  margin-bottom: 1.25rem;\n}\n\n.media-chat .heading-title a {\n  color: var(--text-color);\n}\n\n.media-chat .heading-title a:hover {\n  color: var(--admin-color);\n  text-decoration: none;\n}\n\n.media-chat .title {\n  color: var(--admin-color);\n  font-size: 1rem;\n}\n\n.media-chat .message {\n  background-color: rgba(233, 236, 239, 0.5);\n  padding: 0.5rem 1.25rem;\n  border-radius: 0.25rem;\n  margin-bottom: 0.25rem;\n  color: var(--text-color);\n}\n\n.media-chat .date-time {\n  font-size: 10px;\n  padding-left: 1.25rem;\n}\n\n.media-chat.media-left img {\n  width: 50px;\n}\n\n.media-chat.media-right {\n  text-align: right;\n  -webkit-box-pack: end;\n  -ms-flex-pack: end;\n  justify-content: flex-end;\n}\n\n.media-chat.media-right img {\n  width: 40px;\n}\n\n.media-chat:hover {\n  text-decoration: none;\n}\n\n.media-chat.media-chat-header {\n  border-bottom: 1px solid var(--border-color);\n  border-top: 1px solid var(--border-color);\n  padding: 1.125rem 1.5rem;\n}\n\n@media (min-width: 992px) {\n  .media-chat.media-chat-header {\n    border-top: 0;\n  }\n}\n\n.media-chat.media-chat-header img {\n  width: 60px;\n}\n\n.media-chat.media-chat-header .dropdown-toggle {\n  color: var(--bs-body-color);\n  text-transform: uppercase;\n}\n\n.media-chat.media-chat-header .dropdown-toggle.icon-burger-mini {\n  font-size: 1.5rem;\n  position: relative;\n}\n\n.media-chat.media-chat-header .dropdown-toggle.icon-burger-mini:after {\n  display: none;\n}\n\n.media-chat.media-chat-header .dropdown-toggle.icon-burger-mini:before {\n  font-family: \"Material Design Icons\";\n  content: \"\";\n}\n\n.media-chat.media-chat-header .dropdown-menu {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  -webkit-box-shadow: 0px 5px 18px 0px rgba(229, 233, 242, 0.5);\n  box-shadow: 0px 5px 18px 0px rgba(229, 233, 242, 0.5);\n  min-width: auto;\n}\n\n.media-chat.media-chat-header .dropdown-menu .dropdown-item {\n  padding: 0.3125rem 1.25rem;\n}\n\n.media-chat.media-chat-header .dropdown-menu .dropdown-item a {\n  font-size: 0.875rem;\n  color: var(--bs-body-color);\n  text-transform: capitalize;\n}\n\n.media-chat.media-chat-header .dropdown-menu .dropdown-item:hover {\n  background-color: transparent;\n}\n\n.media-chat.media-chat-header .dropdown-menu .dropdown-item:hover a {\n  color: var(--admin-color);\n}\n\n.media-body {\n  -webkit-box-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n}\n\n/*===== FOOTER =====*/\n.main-footer {\n  background: #ffffff;\n  padding: 15px;\n  color: #444444;\n  border-top: 1px solid var(--border-color);\n}\n\n.copyright {\n  padding: 15px;\n  border-top: 1px solid var(--border-color);\n}\n\n.copyright p {\n  font-weight: 300;\n  text-align: center;\n  font-size: 14px;\n}\n\n/* Body */\n#body {\n  position: relative;\n  height: 100%;\n  overflow-x: hidden;\n}\n\n/* Wrapper */\n.wrapper {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: stretch;\n  -ms-flex-align: stretch;\n  align-items: stretch;\n  -webkit-box-flex: 1;\n  -ms-flex: 1 1 auto;\n  flex: 1 1 auto;\n  width: 100%;\n  min-height: 100vh;\n}\n\n/* Page Wrapper */\n.ec-page-wrapper {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  width: 100%;\n}\n\n.ec-content-wrapper {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex: 1;\n  -ms-flex: 1 1 auto;\n  flex: 1 1 auto;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n}\n\n/* Content */\n.content {\n  margin-right: auto;\n  margin-left: auto;\n  padding: 30px;\n  padding-top: 0px;\n  width: 100%;\n  position: relative;\n}\n\n@media (max-width: 767.98px) {\n  .content {\n    padding: 30px 15px;\n  }\n}\n\n.no-gutters>[className*=col-] {\n  padding-right: 0;\n  padding-left: 0;\n}\n\n/* Meterial Desing Codes */\n.mdi-show-code code {\n  display: inline-block;\n  vertical-align: middle;\n  background: rgba(138, 144, 157, 0.1);\n  padding: 3px 5px;\n  border-radius: 3px;\n  border: 1px solid var(--border-color);\n}\n\n.mdi-show-code i.mdi {\n  vertical-align: middle;\n  border-radius: 4px;\n  display: inline-block;\n}\n\n.mdi-show-code i.mdi.dark-demo {\n  background: #333;\n}\n\n.mdi-show-code .note {\n  color: #999;\n  font-size: 14px;\n  padding: 0 20px 5px 20px;\n}\n\n.icons {\n  -webkit-column-count: 1;\n  -moz-column-count: 1;\n  column-count: 1;\n  -webkit-column-gap: 20px;\n  -moz-column-gap: 20px;\n  column-gap: 20px;\n}\n\n@media (min-width: 992px) {\n  .icons {\n    -webkit-column-count: 2;\n    -moz-column-count: 2;\n    column-count: 2;\n  }\n}\n\n@media (min-width: 1200px) {\n  .icons {\n    -webkit-column-count: 3;\n    -moz-column-count: 3;\n    column-count: 3;\n  }\n}\n\n.icons div {\n  line-height: 3em;\n}\n\n.icons div span {\n  cursor: pointer;\n  font-size: 14px;\n  text-overflow: ellipsis;\n  display: inline-block;\n  max-width: calc(100% - 90px);\n  overflow: hidden;\n  vertical-align: middle;\n  white-space: nowrap;\n}\n\n.icons div code:hover,\n.icons div span:hover,\n.icons div i:hover {\n  color: var(--admin-color);\n}\n\n.icons div code:hover {\n  border-color: var(--admin-color);\n}\n\n.icons div code {\n  border: 1px solid var(--border-color);\n  width: 65px;\n  margin-left: 2px;\n  margin-right: 4px;\n  border-radius: 4px;\n  display: inline-block;\n  vertical-align: middle;\n  text-align: center;\n  line-height: 24px;\n  cursor: pointer;\n}\n\n.icons div i {\n  display: inline-block;\n  width: 32px;\n  height: 24px;\n  text-align: center;\n  vertical-align: middle;\n  cursor: pointer;\n  line-height: 24px;\n}\n\n.icons .mdi:before {\n  font-size: 24px;\n}\n\ndiv.copied {\n  position: fixed;\n  top: 100px;\n  left: 50%;\n  width: 200px;\n  text-align: center;\n  color: #ffffff;\n  background-color: #34c997;\n  padding: 10px 15px;\n  border-radius: 4px;\n  margin-left: -100px;\n}\n\n.icons-list .fa-icon {\n  font-weight: 900;\n  font-size: 20px;\n  margin: 5px 10px;\n  line-height: 21px;\n  padding: 10px 0;\n  width: 30px;\n  text-align: center;\n}\n\n.icons-list .fa-span {\n  background: #f1f1f1;\n  padding: 5px 10px;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n/*===== LIST GROUP =====*/\n.list-group .list-group-item {\n  padding: 1.38rem;\n}\n\n.list-styled>li {\n  list-style-type: disc;\n  margin-left: 0.94rem;\n  margin-right: 0.94rem;\n}\n\n.list-group-item-secondary {\n  color: var(--bs-body-color);\n  background-color: #cacaca;\n}\n\n.list-group-item-success {\n  color: #34c997;\n  background-color: #bffde9;\n}\n\n.list-group-item-danger {\n  color: #ec4a58;\n  background-color: #ffc3c8;\n}\n\n.list-group-item-warning {\n  color: #ddaa04;\n  background-color: #faeec6;\n}\n\n.list-group-item-info {\n  color: #24c4da;\n  background-color: #b8f5fc;\n}\n\n/* ======== MAP ======== */\n.map-container {\n  height: 400px;\n  width: 100%;\n  margin: 0;\n  padding: 0;\n}\n\n.info-title {\n  color: var(--text-color);\n  padding: 0.31rem;\n}\n\n/* ===== Vector Map Zoom In And Zoom Out Button ===== */\n.jvectormap-zoomin,\n.jvectormap-zoomout {\n  background-color: var(--admin-color);\n}\n\n/* ======== VECTOR MAP ======== */\n/* Vector Map World 2 */\n.vector-map-world-2 {\n  padding-bottom: 0 !important;\n  height: 350px;\n}\n\n@media (min-width: 992px) {\n\n  #modal-add-contact .modal-lg,\n  #modal-contact .modal-lg {\n    max-width: 755px;\n  }\n}\n\n@media (min-width: 1200px) {\n\n  #modal-add-contact .modal-lg,\n  #modal-contact .modal-lg {\n    margin-left: auto;\n    margin-right: auto;\n  }\n}\n\n#modal-add-contact .modal-header .btn-close-icon,\n#modal-add-contact .modal-header .btn-edit-icon,\n#modal-add-contact .modal-header .btn-dots-icon,\n#modal-contact .modal-header .btn-close-icon,\n#modal-contact .modal-header .btn-edit-icon,\n#modal-contact .modal-header .btn-dots-icon {\n  font-size: 1.125rem;\n  padding: 0 5px;\n  color: var(--bs-body-color);\n}\n\n.modal .modal-content {\n  border-radius: 30px;\n}\n\n#modal-add-member .modal-header .btn-close-icon,\n#modal-add-member .modal-header .btn-edit-icon,\n#modal-add-member .modal-header .btn-dots-icon {\n  font-size: 1.125rem;\n  padding: 0 5px;\n  color: var(--bs-body-color);\n}\n\n@media (min-width: 768px) {\n  #modal-add-member .last-msg {\n    width: 200px;\n  }\n}\n\n@media (min-width: 992px) {\n  #modal-add-member .last-msg {\n    width: 125px;\n  }\n}\n\n@media (min-width: 1200px) {\n  #modal-add-member .last-msg {\n    width: 220px;\n  }\n}\n\n/* ======================================\n  --> 2. NAVBAR\n========================================= */\n.ec-main-header {\n  position: fixed;\n  top: 0;\n  left: 0%;\n  right: 0;\n  z-index: 15;\n  margin-bottom: 0;\n  padding: 0;\n  -webkit-transition: -webkit-box-shadow 0.2s linear;\n  transition: -webkit-box-shadow 0.2s linear;\n  transition: box-shadow 0.2s linear;\n  transition: box-shadow 0.2s linear, -webkit-box-shadow 0.2s linear;\n}\n\n/* Navbar */\n.navbar {\n  margin-bottom: 0;\n  border: none;\n  min-height: 70px;\n  border-radius: 0;\n  padding: 0;\n  border-bottom: 1px solid var(--border-color);\n  -webkit-transition: margin-left 0.3s ease-in-out;\n  transition: margin-left 0.3s ease-in-out;\n  background-color: #ffffff;\n  /* Search Form */\n  /* Navbar Nav */\n  /* Navbar Collapse */\n  /* Navbar Right */\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .navbar {\n    -webkit-transition: none;\n    transition: none;\n  }\n}\n\n.navbar .sidebar-offcanvas-toggle,\n.navbar .sidebar-toggle {\n  background-color: transparent;\n  background-image: none;\n  color: #bbb;\n  font-size: 30px;\n  padding: 0 24px;\n  border: 0px;\n  cursor: pointer;\n}\n\n.navbar .sidebar-offcanvas-toggle:before,\n.navbar .sidebar-toggle:before {\n  content: \"神\";\n  font-family: \"Material Design Icons\";\n}\n\n.navbar .navbar-toggler i {\n  color: var(--bs-body-color);\n}\n\n.navbar .search-form {\n  width: 400px;\n  position: relative;\n  margin-right: auto;\n  padding-left: 0;\n  background-color: #f7f7f7;\n  border-radius: 15px;\n}\n\n@media (min-width: 1500px) {\n  .navbar .search-form {\n    width: auto;\n  }\n}\n\n@media (max-width: 1199.98px) {\n  .navbar .search-form {\n    width: 300px;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .navbar .search-form {\n    width: 70%;\n    margin: 0 auto 15px auto;\n    -webkit-box-ordinal-group: 3;\n    -ms-flex-order: 2;\n    order: 2;\n  }\n}\n\n@media (max-width: 575.98px) {\n  .navbar .search-form {\n    width: 100%;\n    margin: 0 24px 15px 24px;\n    -webkit-box-ordinal-group: 3;\n    -ms-flex-order: 2;\n    order: 2;\n  }\n}\n\n.navbar .search-form .input-group {\n  margin-bottom: 0;\n}\n\n.navbar .search-form .btn {\n  background: transparent;\n  border: none;\n  color: var(--bs-body-color);\n  font-size: 20px;\n  padding: 0px 10px;\n}\n\n.navbar .search-form .btn:active,\n.navbar .search-form .btn:focus {\n  outline: none;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.navbar .search-form input.form-control {\n  border: none;\n  background: transparent;\n  padding: 0.5rem 15px;\n}\n\n/* @media (min-width: 1500px) {\n  .navbar .search-form input.form-control {\n    min-width: 500px;\n  }\n} */\n.navbar .search-form #search-results-container {\n  width: 100%;\n  background: #fff;\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  -webkit-box-shadow: 1px 2px 5px #e5e9f2;\n  box-shadow: 1px 2px 5px #e5e9f2;\n}\n\n.navbar .search-form #search-results-container li {\n  padding: 20px 30px;\n}\n\n.navbar .search-form #search-results-container li .link {\n  font-size: 15px;\n}\n\n.navbar .navbar-nav {\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  padding-left: 1rem;\n  padding-right: 1rem;\n}\n\n@media (min-width: 768px) {\n  .navbar .navbar-nav {\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    padding-left: 0;\n    padding-right: 0;\n  }\n}\n\n@media (min-width: 1200px) {\n  .navbar .navbar-nav {\n    padding-left: 20px;\n    padding-right: 20px;\n  }\n}\n\n.navbar .navbar-nav .nav-item {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n}\n\n@media (min-width: 992px) {\n  .navbar .navbar-nav .nav-item {\n    padding-top: 1.28px;\n    padding-bottom: 1.28px;\n  }\n}\n\n.navbar .navbar-nav .nav-item .nav-link {\n  color: var(--bs-body-color);\n}\n\n.navbar .navbar-collapse {\n  -webkit-box-ordinal-group: 2;\n  -ms-flex-order: 1;\n  order: 1;\n  border-top: 1px solid var((--border-color));\n}\n\n@media (min-width: 992px) {\n  .navbar .navbar-collapse {\n    -webkit-box-ordinal-group: 1;\n    -ms-flex-order: 0;\n    order: 0;\n    border-top: none;\n  }\n}\n\n.navbar .navbar-right .navbar-nav {\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n@media (min-width: 992px) {\n  .navbar .navbar-right .navbar-nav {\n    padding-left: 0;\n    padding-right: 0;\n  }\n}\n\n@media (min-width: 1200px) {\n  .navbar .navbar-right .navbar-nav {\n    padding-left: 0;\n    padding-right: 0;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .navbar .navbar-right .navbar-nav {\n    margin: 15px 0;\n  }\n}\n\n.navbar .navbar-right .navbar-nav li>.dropdown-menu {\n  -webkit-transition: all 0.3s ease-in-out;\n  transition: all 0.3s ease-in-out;\n  position: absolute;\n  top: 60px;\n  left: auto;\n  right: 0;\n  border-color: var(--border-color);\n  border-radius: 15px;\n  overflow: hidden;\n  -webkit-box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.1);\n  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.1);\n}\n\n@media (max-width: 575.98px) {\n  .navbar .navbar-right .navbar-nav li>.dropdown-menu {\n    right: -130px;\n  }\n}\n\n@media (min-width: 992px) {\n  .navbar .navbar-right .navbar-nav .user-menu {\n    text-align: right;\n  }\n}\n\n.navbar .navbar-right .navbar-nav .user-menu .user-image {\n  width: 40px;\n  border-radius: 15px;\n}\n\n.navbar .navbar-right .navbar-nav .user-menu .dropdown-toggle {\n  font-size: 15px;\n  padding: 0 15px;\n  -webkit-transition: all 0.3s ease-in-out;\n  transition: all 0.3s ease-in-out;\n}\n\n.navbar .navbar-right .navbar-nav .user-menu .dropdown-toggle:after {\n  border-top: 6px solid;\n  border-left-width: 6px;\n  border-right-width: 6px;\n  vertical-align: middle;\n  color: #bbb;\n}\n\n\n.navbar .navbar-right .navbar-nav .notifications-menu>.dropdown-menu {\n  width: 275px;\n  right: -75px;\n}\n\n\n.navbar .navbar-right .navbar-nav .right-sidebar-2-menu i {\n  font-size: 24px;\n  color: #bbb;\n  line-height: 30px;\n}\n\n.navbar .dropdown-menu {\n  width: 255px;\n  padding: 0 0 0 0;\n  margin: 0;\n  top: 100%;\n  border-color: transparent;\n}\n\n.navbar .dropdown-menu li.dropdown-header img {\n  width: 50px;\n  vertical-align: top;\n  border-radius: 15px;\n  margin-right: 0.63rem;\n}\n\n.navbar .dropdown-menu li.dropdown-header small,\n.navbar .dropdown-menu li.dropdown-header .small {\n  font-size: 13px;\n  display: block;\n  color: var(--bs-black-rgb);\n}\n\n.navbar .dropdown-menu>li .link {\n  display: block;\n  color: var(--bs-black-rgb);\n  font-size: 14px;\n  padding: 10px 15px;\n  cursor: pointer;\n}\n\n.navbar .dropdown-menu>li .link:hover {\n  background-color: #f0f0f0;\n}\n\n.navbar .dropdown-menu>li .link>i {\n  width: 18px;\n  margin-right: 10px;\n  display: inline-block;\n  text-align: center;\n  font-size: 17px;\n  line-height: 15px;\n}\n\n.navbar .dropdown-menu li.dropdown-footer {\n  border-bottom-left-radius: 5px;\n  border-bottom-right-radius: 5px;\n  border-top-right-radius: 0;\n  border-top-left-radius: 0;\n  background-color: #ffffff;\n  border-top: 1px solid var(--border-color);\n  margin-top: 10px;\n}\n\n.navbar .dropdown-menu li.dropdown-footer>a {\n  padding: 15px 20px;\n}\n\n.navbar .dropdown-item.active,\n.navbar .dropdown-item:active {\n  color: var(--bs-body-color);\n  background-color: transparent;\n}\n\n@media (max-width: 767px) {\n\n  .ec-main-header .logo,\n  .ec-main-header .navbar {\n    width: 100%;\n  }\n\n  .ec-main-header .navbar {\n    margin: 0;\n  }\n}\n\n/* Header Fix and Header Static For Mobile */\n.ec-header-fixed .ec-page-wrapper {\n  padding-top: 4.4rem;\n}\n\n@media (max-width: 767.98px) {\n  .ec-header-fixed .ec-page-wrapper {\n    padding-top: 7.4rem;\n  }\n}\n\n.ec-header-fixed.ec-header-static-mobile .ec-main-header {\n  position: relative;\n}\n\n@media (min-width: 768px) {\n  .ec-header-fixed.ec-header-static-mobile .ec-main-header {\n    position: fixed;\n  }\n}\n\n.ec-header-fixed.ec-header-static-mobile .ec-page-wrapper {\n  padding-top: 0;\n}\n\n@media (min-width: 768px) {\n  .ec-header-fixed.ec-header-static-mobile .ec-page-wrapper {\n    padding-top: 4.875rem;\n  }\n}\n\n/* Header Static and Header Fixed for Mobile */\n.ec-header-static.ec-header-fixed-mobile .ec-main-header {\n  position: fixed !important;\n}\n\n@media (min-width: 768px) {\n  .ec-header-static.ec-header-fixed-mobile .ec-main-header {\n    position: relative !important;\n  }\n}\n\n.ec-header-static.ec-header-fixed-mobile .ec-page-wrapper {\n  padding-top: 4.875rem;\n}\n\n@media (min-width: 992px) {\n  .navbar .dropdown-menu {\n    border-color: var(--border-color);\n  }\n}\n\n.navbar .dropdown-menu li.dropdown-header {\n  border-top-left-radius: 5px;\n  border-top-right-radius: 5px;\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n  background-color: #ffffff;\n  border-bottom: 1px solid var(--border-color);\n  padding-bottom: 15px;\n  padding: 15px;\n  color: var(--text-color);\n  font-size: 15px;\n  margin-bottom: 0.63rem;\n}\n\n\n@media (min-width: 768px) {\n  .ec-header-static.ec-header-fixed-mobile .ec-page-wrapper {\n    padding-top: 0;\n  }\n}\n\n/*  Header Dark Version */\n.ec-header-dark .navbar {\n  background: #1a283e;\n}\n\n.ec-header-dark .navbar .search-form .input-group input,\n.ec-header-dark .navbar .search-form .input-group .btn {\n  background-color: var(--text-color);\n  color: #fff !important;\n}\n\n.ec-header-dark .navbar .search-form .input-group input::-webkit-input-placeholder,\n.ec-header-dark .navbar .search-form .input-group .btn::-webkit-input-placeholder {\n  color: #eee;\n}\n\n.ec-header-dark .navbar .search-form .input-group input::-moz-placeholder,\n.ec-header-dark .navbar .search-form .input-group .btn::-moz-placeholder {\n  color: #eee;\n}\n\n.ec-header-dark .navbar .search-form .input-group input:-ms-input-placeholder,\n.ec-header-dark .navbar .search-form .input-group .btn:-ms-input-placeholder {\n  color: #eee;\n}\n\n.ec-header-dark .navbar .search-form .input-group input::-ms-input-placeholder,\n.ec-header-dark .navbar .search-form .input-group .btn::-ms-input-placeholder {\n  color: #eee;\n}\n\n.ec-header-dark .navbar .search-form .input-group input::placeholder,\n.ec-header-dark .navbar .search-form .input-group .btn::placeholder {\n  color: #eee;\n}\n\n.ec-header-dark .navbar .sidebar-toggle {\n  border-color: rgba(255, 255, 255, 0.2);\n  color: #fff;\n}\n\n.ec-header-dark .navbar .navbar-right .navbar-nav .user-menu .dropdown-toggle:after {\n  color: #fff;\n}\n\n.ec-header-dark .navbar .navbar-right .navbar-nav .notifications-menu .dropdown-toggle {\n  color: #fff;\n}\n\n.ec-header-dark .navbar .navbar-right .navbar-nav .right-sidebar-2-menu i {\n  color: #fff;\n}\n\n.ec-header-dark .navbar .sidebar-offcanvas-toggle {\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n.ec-header-dark .navbar .search-form .btn,\n.ec-header-dark .navbar .search-form .input-group input.form-control {\n  color: #b7c0cd;\n}\n\n.ec-header-dark .navbar .navbar-right .navbar-nav .notifications-menu .dropdown-toggle {\n  border-left: 1px solid var(--text-color) !important;\n  border-right: 1px solid var(--text-color) !important;\n}\n\n.ec-header-dark .navbar .navbar-right .navbar-nav .user-menu .dropdown-toggle>span {\n  color: var(--bs-body-color);\n}\n\n.ec-header-dark .navbar .navbar-right .navbar-nav .right-sidebar-2-menu {\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n/* light Header */\n.ec-header-light .navbar {\n  background-color: #ffffff;\n}\n\n.ec-header-light .navbar .sidebar-toggle {\n  border-color: var(--border-color);\n}\n\n.ec-header-light .navbar .sidebar-offcanvas-toggle {\n  border-color: var(--border-color);\n}\n\n.ec-header-light .navbar .search-form .btn,\n.ec-header-light .navbar .search-form .input-group input.form-control {\n  color: var(--bs-body-color);\n}\n\n.ec-header-light .navbar .navbar-right .navbar-nav .notifications-menu .dropdown-toggle {\n  border-left: 1px solid var(--border-color) !important;\n  border-right: 1px solid var(--border-color) !important;\n}\n\n.ec-header-light .navbar .navbar-right .navbar-nav .user-menu .dropdown-toggle>span {\n  color: var(--text-color);\n}\n\n/* Cusmtom Dropdown */\n.custom-dropdown .custom-dropdown-toggler .icon {\n  font-size: 28px;\n  color: #212529;\n}\n\n.custom-dropdown .custom-dropdown-toggler .badge-xs {\n  position: absolute;\n  top: 4px;\n  right: 8px;\n  background-color: var(--bs-body-color);\n  min-width: 18px;\n  min-height: 18px;\n  color: #ffffff;\n  font-size: 12px;\n  font-weight: 700;\n  padding: 3px 5px;\n}\n\n/* Notification */\n.dropdown-notify {\n  -webkit-transition: all 0.3s ease-in-out;\n  transition: all 0.3s ease-in-out;\n  display: none;\n  width: 320px;\n  position: absolute;\n  top: 50px;\n  border-radius: 5px;\n  background-color: #ffffff;\n  -webkit-transform: translateX(-50%);\n  transform: translateX(-50%);\n  right: 0;\n  left: auto;\n  border-radius: 15px;\n  overflow: hidden;\n  -webkit-box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.1);\n  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.1);\n  -webkit-transform: translateX(0);\n  transform: translateX(0);\n  z-index: 15;\n}\n\n@media (max-width: 575.98px) {\n  .dropdown-notify {\n    width: 300px;\n    right: -67px;\n    left: auto;\n  }\n}\n\n/*===== PAGINATION =====*/\n.pagination {\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n\n.pagination .page-item.active .page-link {\n  z-index: 3;\n  color: #fff;\n}\n\n.pagination .page-item:first-child .page-link {\n  border-top-left-radius: 10px;\n  border-bottom-left-radius: 10px;\n}\n\n.pagination .page-item:last-child .page-link {\n  border-top-right-radius: 10px;\n  border-bottom-right-radius: 10px;\n}\n\n.pagination .page-link {\n  padding: 5px 10px;\n  line-height: 17px;\n  color: var(--bs-body-color);\n}\n\n.pagination .page-link:focus {\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.pagination-flat .page-item .page-link {\n  border: 0px;\n}\n\n.pagination-flat-rounded .page-item .page-link {\n  border-radius: 100%;\n}\n\n.pagination-seperated .page-item .page-link {\n  padding: 5px 10px;\n  margin: 0 3px;\n  border-radius: 0;\n}\n\n@media (max-width: 575.98px) {\n  .pagination-seperated .page-item .page-link {\n    padding: 5px 7px;\n  }\n}\n\n.pagination-seperated .page-item:last-child .page-link {\n  margin-right: 0;\n}\n\n.pagination-seperated .page-item:first-child .page-link {\n  margin-left: 0;\n}\n\n.pagination-seperated-rounded .page-item .page-link {\n  border-radius: 10px;\n}\n\n.border-rounded .page-item:last-child .page-link {\n  border-top-right-radius: 10px;\n  border-bottom-right-radius: 10px;\n}\n\n.border-rounded .page-item:first-child .page-link {\n  margin-left: 0;\n  border-top-left-radius: 10px;\n  border-bottom-left-radius: 10px;\n}\n\n/*===== CIRCLE PROGRESS =====*/\n.circle {\n  position: relative;\n  text-align: center;\n}\n\n.circle .circle-content {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 100%;\n  -webkit-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n}\n\n.circle .circle-content h6,\n.circle .circle-content .h6,\n.circle .circle-content strong {\n  font-size: 12px;\n}\n\n.circle.circle-lg h6,\n.circle.circle-lg .h6 {\n  font-size: 45px;\n}\n\n.circle.circle-lg h6 span,\n.circle.circle-lg .h6 span {\n  font-size: 35px;\n}\n\n/*===== TOOLTIP =====*/\n/*Popver Tooltip*/\n.popover {\n  background-color: #ffffff;\n}\n\n.popover .arrow {\n  position: absolute;\n  display: block;\n  width: 1rem;\n  height: 0.5rem;\n  margin: 0 0.3rem;\n}\n\n.popover .arrow::before,\n.popover .arrow::after {\n  position: absolute;\n  display: block;\n  /* content: \"\"; */\n  border-color: transparent;\n  border-right-color: transparent;\n  border-style: solid;\n}\n\n.popover-header {\n  background-color: transparent;\n  border-bottom: 0px;\n  padding-bottom: 0px;\n  color: var(--text-color);\n  font-size: 1.125rem;\n}\n\n.popover-body {\n  color: var(--bs-body-color);\n}\n\n.bs-popover-right>.arrow,\n.bs-popover-auto[x-placement^=right]>.arrow {\n  left: calc(-0.5rem - 1px);\n  width: 0.5rem;\n  height: 1rem;\n  margin: 0.3rem 0;\n}\n\n.bs-popover-right>.arrow::before,\n.bs-popover-auto[x-placement^=right]>.arrow::before {\n  left: 0;\n  border-width: 0.5rem 0.5rem 0.5rem 0;\n  border-right-color: rgba(0, 0, 0, 0.25);\n}\n\n.bs-popover-right>.arrow::after,\n.bs-popover-auto[x-placement^=right]>.arrow::after {\n  left: 1px;\n  border-width: 0.5rem 0.5rem 0.5rem 0;\n  border-right-color: #ffffff;\n}\n\n.bs-popover-top>.arrow,\n.bs-popover-auto[data-popper-placement^=top]>.arrow,\n.bs-popover-auto[x-placement^=top]>.arrow {\n  bottom: calc(-0.5rem - 1px);\n}\n\n.bs-popover-top>.arrow::before,\n.bs-popover-auto[data-popper-placement^=top]>.arrow::before,\n.bs-popover-auto[x-placement^=top]>.arrow::before {\n  bottom: 0;\n  border-width: 0.5rem 0.5rem 0;\n  border-top-color: rgba(0, 0, 0, 0.25);\n}\n\n.bs-popover-top>.arrow::after,\n.bs-popover-auto[data-popper-placement^=top]>.arrow::after,\n.bs-popover-auto[x-placement^=top]>.arrow::after {\n  bottom: 1px;\n  border-width: 0.5rem 0.5rem 0;\n  border-top-color: #ffffff;\n}\n\n.bs-popover-left>.arrow,\n.bs-popover-auto[x-placement^=left]>.arrow {\n  right: calc(-0.5rem - 1px);\n  width: 0.5rem;\n  height: 1rem;\n  margin: 0.3rem 0;\n}\n\n.bs-popover-left>.arrow::before,\n.bs-popover-auto[x-placement^=left]>.arrow::before {\n  right: 0;\n  border-width: 0.5rem 0 0.5rem 0.5rem;\n  border-left-color: rgba(0, 0, 0, 0.25);\n}\n\n.bs-popover-left>.arrow::after,\n.bs-popover-auto[x-placement^=left]>.arrow::after {\n  right: 1px;\n  border-width: 0.5rem 0 0.5rem 0.5rem;\n  border-left-color: #ffffff;\n}\n\n.bs-popover-bottom>.arrow,\n.bs-popover-auto[data-popper-placement^=bottom]>.arrow,\n.bs-popover-auto[x-placement^=bottom]>.arrow {\n  top: calc(-0.5rem - 1px);\n}\n\n.bs-popover-bottom>.arrow::before,\n.bs-popover-auto[data-popper-placement^=bottom]>.arrow::before,\n.bs-popover-auto[x-placement^=bottom]>.arrow::before {\n  top: 0;\n  border-width: 0 0.5rem 0.5rem 0.5rem;\n  border-bottom-color: rgba(0, 0, 0, 0.25);\n}\n\n.bs-popover-bottom>.arrow::after,\n.bs-popover-auto[data-popper-placement^=bottom]>.arrow::after,\n.bs-popover-auto[x-placement^=bottom]>.arrow::after {\n  top: 1px;\n  border-width: 0 0.5rem 0.5rem 0.5rem;\n  border-bottom-color: #ffffff;\n}\n\n/* Tooltip Inner */\n.tooltip-inner {\n  background-color: #ffffff;\n  border: 1px solid #ebebeb;\n  padding: 0.56rem 1.125rem;\n  color: var(--text-color);\n  color: var(--text-color);\n  font-size: 15px;\n  font-weight: 500;\n}\n\n.bs-tooltip-auto[x-placement^=top] .arrow::before,\n.bs-tooltip-top .arrow::before,\n.bs-tooltip-auto[data-popper-placement^=top] .arrow::before {\n  top: 0px;\n  border-top-color: var(--border-color);\n}\n\n.bs-tooltip-auto[x-placement^=right] .arrow::before,\n.bs-tooltip-right .arrow::before {\n  right: 0px;\n  border-right-color: var(--border-color);\n}\n\n.bs-tooltip-auto[x-placement^=bottom] .arrow::before,\n.bs-tooltip-bottom .arrow::before,\n.bs-tooltip-auto[data-popper-placement^=bottom] .arrow::before {\n  bottom: 0px;\n  border-bottom-color: var(--border-color);\n}\n\n.bs-tooltip-auto[x-placement^=left] .arrow::before,\n.bs-tooltip-left .arrow::before {\n  left: 0px;\n  border-left-color: var(--border-color);\n}\n\n.tooltip .arrow::after {\n  position: absolute;\n  content: \"\";\n  border-color: transparent;\n  border-style: solid;\n}\n\n.bs-tooltip-auto[x-placement^=top] .arrow::after,\n.bs-tooltip-top .arrow::after,\n.bs-tooltip-auto[data-popper-placement^=top] .arrow::after {\n  z-index: 0;\n  top: -1px;\n  border-width: 0.4rem 0.4rem 0;\n  border-top-color: #fff;\n}\n\n.bs-tooltip-auto[x-placement^=right] .arrow::after,\n.bs-tooltip-right .arrow::after {\n  z-index: 0;\n  right: -1px;\n  border-width: 0.4rem 0.4rem 0.4rem 0;\n  border-right-color: #fff;\n}\n\n.bs-tooltip-auto[x-placement^=bottom] .arrow::after,\n.bs-tooltip-bottom .arrow::after,\n.bs-tooltip-auto[data-popper-placement^=bottom] .arrow::after {\n  border-width: 0 0.4rem 0.4rem;\n  z-index: 0;\n  bottom: -1px;\n  border-bottom-color: #fff;\n}\n\n.bs-tooltip-auto[x-placement^=left] .arrow::after,\n.bs-tooltip-left .arrow::after {\n  border-width: 0.4rem 0.4rem;\n  z-index: 0;\n  left: -1px;\n  border-left-color: #fff;\n}\n\n/* Vector Map Tooltip */\n.jvectormap-tip {\n  background-color: #ffffff;\n  color: var(--bs-body-color);\n  padding-left: 0.625rem;\n  padding-right: 0.625rem;\n  border-radius: 0.31rem;\n}\n\n/* ======================================\n--> 3. SIDEBAR NAVIGATION\n========================================= */\n\n/* width */\n::-webkit-scrollbar {\n\n  width: 5px;\n  height: 100%;\n}\n\n/* Track */\n::-webkit-scrollbar-track {\n  box-shadow: inset 0 0 5px white;\n  border-radius: 10px;\n}\n\n/* Handle */\n::-webkit-scrollbar-thumb {\n  background: #ced4da;\n  border-radius: 10px;\n}\n\n/* Handle on hover\n::-webkit-scrollbar-thumb:hover {\n  background: #b30000; \n} */\n\n.ec-navigation {\n  height: calc(100% - 45px);\n  overflow-y: auto;\n}\n\n.ec-left-sidebar {\n  position: fixed;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-transform: translateX(-251px);\n  transform: translateX(-251px);\n  top: 0%;\n  bottom: 0;\n}\n\n@media (min-width: 768px) {\n  .ec-left-sidebar {\n    -webkit-transform: translateX(0);\n    transform: translateX(0);\n    width: 250px;\n    position: relative;\n    z-index: 1;\n  }\n}\n\n.sidebar {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  overflow: hidden;\n  height: 100%;\n  z-index: 1050;\n  min-height: 100vh;\n  position: relative;\n}\n\n.sidebar .sidebar-inner {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-flex: 1;\n  -ms-flex: 1 1 auto;\n  flex: 1 1 auto;\n  margin-top: 10px;\n}\n\n@media (min-width: 768px) {\n  .sidebar .sidebar-inner {\n    margin-top: 20px;\n  }\n}\n\n@media (min-width: 1200px) {\n  .sidebar .sidebar-inner {\n    margin-top: 10px;\n  }\n}\n\n.sidebar .sidebar-inner>li {\n  position: relative;\n}\n\n.sidebar .sidebar-inner>li>span {\n  padding: 15px 25px;\n  line-height: 20px;\n  color: var(--secondary-color);\n  display: block;\n  text-decoration: none;\n  font-weight: 400;\n  white-space: nowrap;\n}\n\n.sidebar .sidebar-inner .collapse.show {\n  width: 100%;\n  /* display: block; */\n}\n\n.sidebar .sidebar-inner>li.active>span {\n  position: relative;\n  z-index: 10;\n  color: #ffffff;\n}\n\n.sidebar .sidebar-inner>li.active>a:before {\n  opacity: 1;\n}\n\n.sidebar .sidebar-inner>li>span:before {\n  position: absolute;\n  content: \"\";\n  left: 5px;\n  top: 0;\n  width: 5px;\n  height: 100%;\n  /* border-radius: 5px; */\n  background: var(--admin-color);\n  opacity: 0;\n}\n\n.sidebar .sidebar-inner .section-title {\n  padding: 1.25rem 1.56rem 0;\n  font-weight: 700;\n  text-transform: uppercase;\n  font-size: 0.75rem;\n  color: var(--text-color);\n  letter-spacing: 1.2px;\n}\n\n.sidebar .sidebar-inner .sub-menu .section-title {\n  padding: 1.25rem 0.94rem 0.625rem;\n}\n\n/* App brand */\n.ec-brand {\n  position: relative;\n  display: block;\n  background-color: transparent;\n}\n\n.ec-brand span {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  height: 70px;\n  line-height: 75px;\n  width: 250px;\n  border-right: 1px solid var(--border-color);\n  -webkit-transition: width 0.3s ease-in-out;\n  transition: width 0.3s ease-in-out;\n  padding-left: 1.56rem;\n\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .ec-brand span {\n    -webkit-transition: none;\n    transition: none;\n  }\n}\n\n@media (min-width: 768px) {\n  .ec-brand span {\n    overflow: hidden;\n  }\n}\n\n.ec-brand span img {\n  max-width: 30px;\n  vertical-align: middle;\n}\n\n.ec-brand .ec-brand-name {\n  color: var(--text-color);\n  font-size: 30px;\n  margin-left: 5px;\n  max-width: 170px;\n  font-size: 30px;\n  font-weight: 700;\n}\n\n/*  Nav menus Icon Styles */\n.sidebar .nav>li>span i {\n  float: left;\n  margin-right: 0.94rem;\n  width: 20px;\n  text-align: center;\n  line-height: 20px;\n  font-size: 1.5rem;\n}\n\n/* .sidebar .nav > li.active > a i {\n  color: var(--admin-color);\n} */\n\np {\n  letter-spacing: 0.02rem;\n}\n\nspan {\n  letter-spacing: 0.02rem;\n}\n\n/* Caret styles */\n.sidebar li>span .caret {\n  width: 20px;\n  height: 20px;\n  line-height: 20px;\n  text-align: center;\n  font-size: 1.25rem;\n  border: none;\n}\n\n.sidebar li>span .caret:before {\n  content: \"\\e5e1\";\n  display: block;\n  text-align: center;\n  -webkit-transition: all 0.2s linear;\n  transition: all 0.2s linear;\n  opacity: 0.5;\n  font-size: 13px;\n}\n\n.sidebar li>span .caret:before {\n  font-family: \"Material Symbols Outlined\" !important;\n  font-weight: 400;\n  font-style: normal;\n  font-variant: normal;\n  text-rendering: auto;\n}\n\n.sidebar li.active>span .caret:before,\n.sidebar li.expand>span .caret:before,\n.sidebar li.expanding>span .caret:before {\n  -webkit-transform: rotate(0);\n  transform: rotate(0);\n}\n\n.sidebar li.active.expand>span .caret:before,\n.sidebar li.expand>span .caret:before,\n.sidebar li.expanding>span .caret:before {\n  -webkit-transform: rotate(90deg);\n  transform: rotate(90deg);\n}\n\n.sidebar li.active>span .caret:before {\n  opacity: 1;\n}\n\n.sidebar li.closed>span .caret:before,\n.sidebar li.closing>span .caret:before {\n  -webkit-transform: rotate(0);\n  transform: rotate(0);\n}\n\n/*  sub-menu dropdowns */\n.sidebar .sub-menu {\n  list-style-type: none;\n  padding: 0.625rem 0 0.625rem 2.81rem;\n  margin: 0;\n  position: relative;\n}\n\n.sidebar .sub-menu>li>span {\n  padding: 0.625rem 1.25rem 0.625rem 0.94rem;\n  display: block;\n  text-decoration: none;\n  position: relative;\n  font-size: 0.88rem;\n}\n\n.sidebar .sub-menu>li .sub-menu {\n  padding-left: 2.18rem;\n}\n\n.sidebar .sub-menu>li .sub-menu>li>span {\n  position: relative;\n  font-size: 0.81rem;\n  padding-left: 0;\n  text-overflow: ellipsis;\n}\n\n.sidebar .sub-menu>li .sub-menu>li>span:after {\n  position: absolute;\n  content: \"\";\n  top: 20px;\n  left: -20px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  width: 10px;\n}\n\n.sidebar .has-sub.active.expand>.sub-menu {\n  display: none;\n}\n\n.sidebar .has-sub .has-sub .caret {\n  top: 12px;\n}\n\n.sidebar .sidenav-item-link {\n  display: -webkit-box !important;\n  display: -ms-flexbox !important;\n  display: flex !important;\n  -webkit-box-flex: 1;\n  -ms-flex-positive: 1;\n  flex-grow: 1;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.sidebar .sidenav-item-link .nav-text {\n  margin-right: auto;\n  overflow: hidden;\n  max-width: 130px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.sidebar .sidenav-item-link .badge {\n  padding: 0.4em 0.6em;\n}\n\n.sidebar .sub-menu>li>span .nav-text {\n  white-space: pre-line;\n}\n\n.sidebar .sub-menu .has-sub .nav-text {\n  white-space: nowrap;\n}\n\n.collapse:hover {\n  display: block;\n}\n\n/* Sidebar for Mobile */\n.sidebar-mobile-in .ec-left-sidebar {\n  -webkit-transform: translateX(0px) !important;\n  transform: translateX(0px) !important;\n  z-index: 1050;\n  -webkit-transition: -webkit-transform 0.3s ease-in-out;\n  transition: -webkit-transform 0.3s ease-in-out;\n  transition: transform 0.3s ease-in-out;\n  transition: transform 0.3s ease-in-out, -webkit-transform 0.3s ease-in-out;\n}\n\n@media (min-width: 768px) {\n  .sidebar-mobile-in .ec-left-sidebar {\n    -webkit-transform: translateX(-251px) !important;\n    transform: translateX(-251px) !important;\n  }\n}\n\n.sidebar-mobile-out .ec-left-sidebar {\n  -webkit-transform: translateX(-251px) !important;\n  transform: translateX(-251px) !important;\n  z-index: 1050;\n  -webkit-transition: -webkit-transform 0.3s ease-in-out;\n  transition: -webkit-transform 0.3s ease-in-out;\n  transition: transform 0.3s ease-in-out;\n  transition: transform 0.3s ease-in-out, -webkit-transform 0.3s ease-in-out;\n}\n\n@media (min-width: 768px) {\n  .sidebar-mobile-out .ec-left-sidebar {\n    -webkit-transform: translateX(0px) !important;\n    transform: translateX(0px) !important;\n  }\n}\n\n/* Sidebar Minified */\n.sidebar-minified .ec-left-sidebar {\n  width: 250px;\n  z-index: 15;\n  -webkit-transform: translateX(0);\n  transform: translateX(0);\n  -webkit-transition: -webkit-transform 0.3s ease-in-out;\n  transition: -webkit-transform 0.3s ease-in-out;\n  transition: transform 0.3s ease-in-out;\n  transition: transform 0.3s ease-in-out, -webkit-transform 0.3s ease-in-out;\n}\n\n@media (min-width: 768px) {\n  .sidebar-minified .ec-left-sidebar {\n    width: 75px;\n    -webkit-transition: width 0.3s ease-in;\n    transition: width 0.3s ease-in;\n  }\n}\n\n@media (min-width: 768px) {\n  .sidebar-minified .ec-left-sidebar .ec-brand .ec-brand-name {\n    visibility: hidden;\n    opacity: 0;\n    -webkit-transition: opacity 0.3s ease-in-out;\n    transition: opacity 0.3s ease-in-out;\n  }\n}\n\n@media (min-width: 768px) and (prefers-reduced-motion: reduce) {\n  .sidebar-minified .ec-left-sidebar .ec-brand .ec-brand-name {\n    -webkit-transition: none;\n    transition: none;\n  }\n}\n\n.sidebar-minified .ec-left-sidebar .sidebar .sub-menu {\n  padding-top: 0;\n  padding-bottom: 0;\n}\n\n.sidebar-minified .ec-left-sidebar .nav>li>span>.caret,\n.sidebar-minified .ec-left-sidebar .nav>li>span {\n  opacity: 1;\n}\n\n@media (min-width: 768px) {\n\n  .sidebar-minified .ec-left-sidebar .nav>li>span>.caret,\n  .sidebar-minified .ec-left-sidebar .nav>li>span>p {\n    opacity: 0;\n  }\n}\n\n.sidebar-minified .ec-left-sidebar .nav>li>a>.caret {\n  right: 15px;\n}\n\n.sidebar-minified .ec-left-sidebar .nav li.has-sub .collapse>.sub-menu {\n  left: 0;\n  top: 0;\n  width: 100%;\n  margin: 0;\n}\n\n.sidebar-minified .ec-left-sidebar .nav li.has-sub.expand .collapse>.sub-menu {\n  height: 0;\n}\n\n.sidebar-minified .ec-left-sidebar .nav li.has-sub.expand .collapse>.sub-menu li {\n  visibility: hidden;\n  opacity: 0;\n}\n\n@media (max-width: 575.98px) {\n  .sidebar-minified .ec-left-sidebar .nav li.has-sub.expand .collapse>.sub-menu {\n    -webkit-transition: opacity 0.3s ease-in-out;\n    transition: opacity 0.3s ease-in-out;\n    display: block !important;\n    opacity: 1;\n    visibility: visible;\n  }\n}\n\n@media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {\n  .sidebar-minified .ec-left-sidebar .nav li.has-sub.expand .collapse>.sub-menu {\n    -webkit-transition: none;\n    transition: none;\n  }\n}\n\n.sidebar-minified .ec-left-sidebar .separator {\n  border-top-width: 0;\n}\n\n@media (min-width: 768px) {\n  .sidebar-minified .ec-left-sidebar .sidebar-footer {\n    height: 0;\n  }\n}\n\n@media (min-width: 768px) {\n  .sidebar-minified .ec-left-sidebar .sidebar-footer-content {\n    visibility: hidden;\n    opacity: 0;\n  }\n}\n\n.sidebar-minified .ec-left-sidebar .sidebar-scrollbar {\n  overflow: unset !important;\n}\n\n/* Sidebar Minified Hover */\n@media (min-width: 768px) {\n  .sidebar-minified .ec-left-sidebar:hover {\n    width: 250px;\n    margin-right: -10.94rem;\n  }\n}\n\n.sidebar-minified .ec-left-sidebar:hover .nav li.has-sub.expand .collapse>.sub-menu {\n  -webkit-transition: opacity 0.3s ease-in-out;\n  transition: opacity 0.3s ease-in-out;\n  height: auto;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .sidebar-minified .ec-left-sidebar:hover .nav li.has-sub.expand .collapse>.sub-menu {\n    -webkit-transition: none;\n    transition: none;\n  }\n}\n\n.sidebar-minified .ec-left-sidebar:hover .nav li.has-sub.expand .collapse>.sub-menu li {\n  opacity: 1;\n  visibility: visible;\n  -webkit-transition: opacity 0.3s ease-out 0.25s;\n  transition: opacity 0.3s ease-out 0.25s;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .sidebar-minified .ec-left-sidebar:hover .nav li.has-sub.expand .collapse>.sub-menu li {\n    -webkit-transition: none;\n    transition: none;\n  }\n}\n\n.sidebar-minified .ec-left-sidebar:hover .nav>li>span>.caret,\n.sidebar-minified .ec-left-sidebar:hover .nav>li>span>p {\n  opacity: 1;\n  -webkit-transition: opacity 0.3s ease-in;\n  transition: opacity 0.3s ease-in;\n  -webkit-transition-delay: 0.15s;\n  transition-delay: 0.15s;\n}\n\n@media (prefers-reduced-motion: reduce) {\n\n  .sidebar-minified .ec-left-sidebar:hover .nav>li>span>.caret,\n  .sidebar-minified .ec-left-sidebar:hover .nav>li>span>p {\n    -webkit-transition: none;\n    transition: none;\n  }\n}\n\n.sidebar-minified .ec-left-sidebar:hover .ec-brand-name {\n  opacity: 1;\n  visibility: visible;\n  -webkit-transition: opacity 0.3s ease;\n  transition: opacity 0.3s ease;\n  -webkit-transition-delay: 0.3s;\n  transition-delay: 0.3s;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .sidebar-minified .ec-left-sidebar:hover .ec-brand-name {\n    -webkit-transition: none;\n    transition: none;\n  }\n}\n\n@media (min-width: 768px) {\n  .sidebar-minified .ec-left-sidebar:hover .ec-brand .ec-brand-name {\n    opacity: 1;\n    visibility: visible;\n    -webkit-transition-delay: 0.3s;\n    transition-delay: 0.3s;\n  }\n}\n\n.sidebar-minified .ec-left-sidebar:hover .sidebar .sub-menu {\n  padding-top: 0.625rem;\n  padding-bottom: 0.625rem;\n}\n\n.sidebar-minified .ec-left-sidebar:hover .separator {\n  border-top-width: 1px;\n}\n\n@media (min-width: 768px) {\n  .sidebar-minified .ec-left-sidebar:hover .sidebar-footer {\n    height: auto;\n  }\n}\n\n.sidebar-minified .ec-left-sidebar:hover .sidebar-footer-content {\n  visibility: visible;\n  opacity: 1;\n  -webkit-transition: opacity 0.3s ease-in-out 0.15s;\n  transition: opacity 0.3s ease-in-out 0.15s;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .sidebar-minified .ec-left-sidebar:hover .sidebar-footer-content {\n    -webkit-transition: none;\n    transition: none;\n  }\n}\n\n.sidebar-minified .ec-left-sidebar:hover .sidebar-scrollbar {\n  overflow: hidden !important;\n}\n\n/* Sidebar Minified Not transition */\n@media (min-width: 768px) {\n  .sidebar-minified:not(.ec-left-sidebar) .ec-left-sidebar {\n    -webkit-transition-duration: 0.3s;\n    transition-duration: 0.3s;\n    -webkit-transition-timing-function: ease-in-out;\n    transition-timing-function: ease-in-out;\n    -webkit-transition-property: margin-left, margin-right, width;\n    transition-property: margin-left, margin-right, width;\n  }\n}\n\n/* Sidebar Static With Minified */\n.ec-sidebar-static.sidebar-minified .ec-page-wrapper .ec-main-header {\n  -webkit-transition: padding-left 0.3s ease-in-out;\n  transition: padding-left 0.3s ease-in-out;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .ec-sidebar-static.sidebar-minified .ec-page-wrapper .ec-main-header {\n    -webkit-transition: none;\n    transition: none;\n  }\n}\n\n@media (min-width: 768px) {\n  .ec-sidebar-static.sidebar-minified.ec-header-fixed .ec-page-wrapper .ec-main-header {\n    padding-left: 4.69rem;\n  }\n}\n\n.ec-sidebar-static.sidebar-minified-out .ec-left-sidebar {\n  -webkit-transition: width 0.3s ease-in-out;\n  transition: width 0.3s ease-in-out;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .ec-sidebar-static.sidebar-minified-out .ec-left-sidebar {\n    -webkit-transition: none;\n    transition: none;\n  }\n}\n\n.ec-sidebar-static.sidebar-minified-out .ec-page-wrapper .ec-main-header {\n  -webkit-transition: padding-left 0.3s ease-in-out;\n  transition: padding-left 0.3s ease-in-out;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .ec-sidebar-static.sidebar-minified-out .ec-page-wrapper .ec-main-header {\n    -webkit-transition: none;\n    transition: none;\n  }\n}\n\n/* Sidebar Fixed With Minified Layout Container */\n@media (min-width: 768px) {\n  .ec-sidebar-fixed.sidebar-minified .ec-page-wrapper {\n    padding-left: 4.69rem;\n    -webkit-transition: padding-left 0.3s ease-in-out;\n    transition: padding-left 0.3s ease-in-out;\n  }\n}\n\n@media (min-width: 768px) and (prefers-reduced-motion: reduce) {\n  .ec-sidebar-fixed.sidebar-minified .ec-page-wrapper {\n    -webkit-transition: none;\n    transition: none;\n  }\n}\n\n@media (min-width: 768px) {\n  .ec-sidebar-fixed.sidebar-minified.ec-header-fixed .ec-page-wrapper .ec-main-header {\n    padding-left: 4.69rem;\n    -webkit-transition: padding-left 0.3s ease-in-out;\n    transition: padding-left 0.3s ease-in-out;\n  }\n}\n\n@media (min-width: 768px) and (prefers-reduced-motion: reduce) {\n  .ec-sidebar-fixed.sidebar-minified.ec-header-fixed .ec-page-wrapper .ec-main-header {\n    -webkit-transition: none;\n    transition: none;\n  }\n}\n\n/* Sidebar Minified Out */\n/* .sidebar-minified-out {\n  Sidebar Fixed With Sidebar Minified Out\n} */\n\n.sidebar-minified-out .ec-left-sidebar {\n  z-index: 10000;\n  -webkit-transform: translateX(-251px);\n  transform: translateX(-251px);\n  -webkit-transition: -webkit-transform 0.3s ease-in-out !important;\n  transition: -webkit-transform 0.3s ease-in-out !important;\n  transition: transform 0.3s ease-in-out !important;\n  transition: transform 0.3s ease-in-out, -webkit-transform 0.3s ease-in-out !important;\n}\n\n@media (min-width: 768px) {\n  .sidebar-minified-out .ec-left-sidebar {\n    -webkit-transform: translateX(0px);\n    transform: translateX(0px);\n    -webkit-transition: width 0.3s ease-in-out !important;\n    transition: width 0.3s ease-in-out !important;\n  }\n}\n\n.sidebar-minified-out .sidebar .sub-menu {\n  padding-bottom: 0.625rem;\n  padding-top: 0.625rem;\n}\n\n.sidebar-minified-out .sidebar .nav>li>span {\n  -webkit-transition: opacity 0.3s ease-in-out 0.3s;\n  transition: opacity 0.3s ease-in-out 0.3s;\n  visibility: visible;\n  opacity: 1;\n}\n\n.sidebar-minified-out .sidebar li>span .caret {\n  -webkit-transition: opacity 0.3s ease-in-out 0.3s;\n  transition: opacity 0.3s ease-in-out 0.3s;\n  visibility: visible;\n  opacity: 1;\n}\n\n.sidebar-minified-out .nav li.has-sub.expand .collapse>.sub-menu {\n  height: auto;\n}\n\n.sidebar-minified-out .nav li.has-sub.expand .collapse>.sub-menu li {\n  opacity: 1;\n  visibility: visible;\n  -webkit-transition: opacity 0.3s ease-out 0.25s;\n  transition: opacity 0.3s ease-out 0.25s;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .sidebar-minified-out .nav li.has-sub.expand .collapse>.sub-menu li {\n    -webkit-transition: none;\n    transition: none;\n  }\n}\n\n.sidebar-minified-out .sidebar-footer-content {\n  visibility: visible;\n  opacity: 1;\n  -webkit-transition: opacity 0.3s ease-in-out 0.15s;\n  transition: opacity 0.3s ease-in-out 0.15s;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .sidebar-minified-out .sidebar-footer-content {\n    -webkit-transition: none;\n    transition: none;\n  }\n}\n\n.sidebar-minified-out .ec-left-sidebar {\n  -webkit-transition: width 0.3s ease-in-out;\n  transition: width 0.3s ease-in-out;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .sidebar-minified-out .ec-left-sidebar {\n    -webkit-transition: none;\n    transition: none;\n  }\n}\n\n.sidebar-minified-out .ec-page-wrapper {\n  -webkit-transition: padding-left 0.3s ease-in-out;\n  transition: padding-left 0.3s ease-in-out;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .sidebar-minified-out .ec-page-wrapper {\n    -webkit-transition: none;\n    transition: none;\n  }\n}\n\n.sidebar-minified-out .ec-page-wrapper .ec-main-header {\n  -webkit-transition: padding-left 0.3s ease-in-out;\n  transition: padding-left 0.3s ease-in-out;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .sidebar-minified-out .ec-page-wrapper .ec-main-header {\n    -webkit-transition: none;\n    transition: none;\n  }\n}\n\n/* Sidebar Fixed And Offcanvas */\n@media (min-width: 768px) {\n\n  .ec-sidebar-fixed-offcanvas .ec-left-sidebar,\n  .ec-sidebar-fixed .ec-left-sidebar {\n    position: fixed;\n    top: 70px;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    z-index: 16;\n  }\n}\n\n@media (min-width: 768px) {\n\n  .ec-sidebar-fixed-offcanvas .ec-page-wrapper,\n  .ec-sidebar-fixed .ec-page-wrapper {\n    padding-left: 15.6rem;\n  }\n}\n\n@media (min-width: 768px) {\n\n  .ec-sidebar-fixed-offcanvas .ec-main-header,\n  .ec-sidebar-fixed .ec-main-header {\n    /* padding-left: 15.6rem; */\n  }\n}\n\n.ec-sidebar-fixed-offcanvas.ec-header-static .ec-main-header,\n.ec-sidebar-fixed.ec-header-static .ec-main-header {\n  position: relative;\n}\n\n@media (min-width: 768px) {\n\n  .ec-sidebar-fixed-offcanvas.ec-header-static .ec-main-header,\n  .ec-sidebar-fixed.ec-header-static .ec-main-header {\n    padding-left: 0;\n  }\n}\n\n.ec-sidebar-fixed-offcanvas .ec-sidebar-footer,\n.ec-sidebar-fixed .ec-sidebar-footer {\n  padding-bottom: 30px;\n}\n\n@media (min-width: 768px) {\n\n  .ec-sidebar-fixed-offcanvas .ec-sidebar-footer,\n  .ec-sidebar-fixed .ec-sidebar-footer {\n    padding-bottom: 30px;\n  }\n}\n\n.ec-sidebar-fixed-offcanvas .ec-sidebar-footer .sidebar-footer,\n.ec-sidebar-fixed .ec-sidebar-footer .sidebar-footer {\n  position: absolute;\n  bottom: 0;\n}\n\n.ec-sidebar-fixed-offcanvas.sidebar-collapse .ec-page-wrapper {\n  padding-left: 0;\n}\n\n@media (min-width: 768px) {\n  .ec-sidebar-fixed-offcanvas.sidebar-collapse .sidebar-footer {\n    left: -251px;\n  }\n}\n\n@media (min-width: 768px) {\n  .ec-sidebar-fixed-offcanvas.sidebar-collapse-out .sidebar-footer {\n    left: 0px;\n    -webkit-transition: left 0.3s ease-in-out;\n    transition: left 0.3s ease-in-out;\n  }\n}\n\n@media (min-width: 768px) and (prefers-reduced-motion: reduce) {\n  .ec-sidebar-fixed-offcanvas.sidebar-collapse-out .sidebar-footer {\n    -webkit-transition: none;\n    transition: none;\n  }\n}\n\n/* Sidebar Collapse */\n@media (min-width: 768px) {\n  .sidebar-collapse .ec-left-sidebar {\n    margin-left: -15.6rem;\n    -webkit-transition: margin-left 0.3s ease-in-out;\n    transition: margin-left 0.3s ease-in-out;\n  }\n}\n\n@media (min-width: 768px) and (prefers-reduced-motion: reduce) {\n  .sidebar-collapse .ec-left-sidebar {\n    -webkit-transition: none;\n    transition: none;\n  }\n}\n\n@media (min-width: 768px) {\n  .sidebar-collapse .ec-page-wrapper {\n    -webkit-transition: padding-left 0.3s ease-in-out;\n    transition: padding-left 0.3s ease-in-out;\n  }\n}\n\n@media (min-width: 768px) and (prefers-reduced-motion: reduce) {\n  .sidebar-collapse .ec-page-wrapper {\n    -webkit-transition: none;\n    transition: none;\n  }\n}\n\n/* Sidebar Out Collapse */\n@media (min-width: 768px) {\n  .sidebar-collapse-out .ec-left-sidebar {\n    margin-left: 0px;\n    -webkit-transition: margin-left 0.3s ease-in-out;\n    transition: margin-left 0.3s ease-in-out;\n  }\n}\n\n@media (min-width: 768px) and (prefers-reduced-motion: reduce) {\n  .sidebar-collapse-out .ec-left-sidebar {\n    -webkit-transition: none;\n    transition: none;\n  }\n}\n\n@media (min-width: 768px) {\n  .sidebar-collapse-out .ec-page-wrapper {\n    -webkit-transition: padding-left 0.3s ease-in-out;\n    transition: padding-left 0.3s ease-in-out;\n  }\n}\n\n@media (min-width: 768px) and (prefers-reduced-motion: reduce) {\n  .sidebar-collapse-out .ec-page-wrapper {\n    -webkit-transition: none;\n    transition: none;\n  }\n}\n\n.sidebar-collapse.ec-header-fixed .ec-page-wrapper .ec-main-header {\n  padding-left: 0;\n  -webkit-transition: padding-left 0.3s ease-in-out;\n  transition: padding-left 0.3s ease-in-out;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .sidebar-collapse.ec-header-fixed .ec-page-wrapper .ec-main-header {\n    -webkit-transition: none;\n    transition: none;\n  }\n}\n\n.sidebar-collapse-out .ec-page-wrapper .ec-main-header {\n  -webkit-transition: padding-left 0.3s ease-in-out;\n  transition: padding-left 0.3s ease-in-out;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .sidebar-collapse-out .ec-page-wrapper .ec-main-header {\n    -webkit-transition: none;\n    transition: none;\n  }\n}\n\n/* Sidebar Static With Footer */\n.ec-sidebar-static .sidebar.ec-sidebar-footer .slimScrollDiv,\n.ec-sidebar-static-offcanvas .sidebar.ec-sidebar-footer .slimScrollDiv {\n  height: 100%;\n}\n\n@media (min-width: 768px) {\n\n  .ec-sidebar-static .sidebar.ec-sidebar-footer .slimScrollDiv,\n  .ec-sidebar-static-offcanvas .sidebar.ec-sidebar-footer .slimScrollDiv {\n    height: auto !important;\n  }\n}\n\n@media (min-width: 768px) {\n\n  .ec-sidebar-static.ec-header-fixed .ec-main-header,\n  .ec-sidebar-static-offcanvas.ec-header-fixed .ec-main-header {\n    padding-left: 15.6rem;\n  }\n}\n\n.sidebar-ec-content-wrapper {\n  height: calc(100% - 45px) !important;\n}\n\n/* Sidebar Bg Dark */\n.ec-sidebar-dark .ec-brand {\n  border-color: #37455a;\n  border-right: 1px solid #37455a;\n}\n\n.ec-sidebar-dark .ec-brand span {\n  border-color: #37455a;\n}\n\n.ec-sidebar-dark hr {\n  background: #37455a;\n}\n\n.ec-sidebar-dark .ec-left-sidebar {\n  background-color: #1a283e;\n}\n\n.ec-sidebar-dark .sidebar .sub-menu {\n  background: #293546;\n}\n\n.ec-sidebar-dark .sidebar .sub-menu>li>span {\n  color: #b7c0cd;\n}\n\n.ec-sidebar-dark .sidebar .sub-menu>li>span.active {\n  color: #ffffff;\n}\n\n.ec-sidebar-dark .sidebar .sub-menu>li>a .nav-text {\n  white-space: pre-line;\n}\n\n.ec-sidebar-dark .sidebar .sub-menu .has-sub .nav-text {\n  white-space: nowrap;\n}\n\n.ec-sidebar-dark .sidebar .sub-menu>li.active>span,\n.ec-sidebar-dark .sidebar .sub-menu>li.active>span:focus,\n.ec-sidebar-dark .sidebar .sub-menu>li.active>span:hover,\n.ec-sidebar-dark .sidebar .sub-menu>li>span:focus,\n.ec-sidebar-dark .sidebar .sub-menu>li>span:hover {\n  color: #ffffff;\n}\n\n.ec-sidebar-dark .sidebar .nav>li.active>span {\n  color: #ffffff;\n}\n\n.ec-sidebar-dark .separator {\n  border-color: rgba(243, 243, 243, 0.2);\n}\n\n.ec-sidebar-dark .sidebar-footer {\n  background-color: #212a39;\n}\n\n/* Sidebar Light */\n.ec-sidebar-light .ec-left-sidebar {\n  background-color: #ffffff;\n}\n\n.ec-sidebar-light .sidebar {\n  border-right: 1px solid var(--border-color);\n}\n\n.ec-sidebar-light .sidebar .sub-menu {\n  background-color: var(--gray-bg-color);\n}\n\n.ec-sidebar-light .sidebar .sub-menu>li>a {\n  color: var(--bs-body-color);\n}\n\n.ec-sidebar-light .sidebar .sub-menu>li>span.active {\n  color: #4c515b;\n}\n\n.ec-sidebar-light .sidebar .sub-menu>li.active>span,\n.ec-sidebar-light .sidebar .sub-menu>li.active>span:focus,\n.ec-sidebar-light .sidebar .sub-menu>li.active>span:hover,\n.ec-sidebar-light .sidebar .sub-menu>li>span:focus,\n.ec-sidebar-light .sidebar .sub-menu>li>span:hover {\n  color: #4c515b;\n}\n\n.ec-sidebar-light .sidebar .nav>li.active>span {\n  color: #4c515b;\n}\n\n.ec-sidebar-light .sidebar .separator {\n  border-color: var(--border-color);\n}\n\n.ec-sidebar-light .sidebar-footer {\n  background-color: #ffffff;\n}\n\n.ec-sidebar-light .sidebar .sub-menu>li .sub-menu>li>span:after {\n  border: 1px solid var(--bs-body-color);\n}\n\n/* Sidebar Footer Content*/\n.sidebar-footer-content {\n  padding: 0 1.9rem;\n  padding-top: 1.56rem;\n  padding-bottom: 0.75rem;\n  width: 250px;\n}\n\n@media (min-width: 1200px) {\n  .sidebar-footer-content {\n    padding-top: 2.81rem;\n    padding-bottom: 2rem;\n  }\n}\n\n.sidebar-footer-content>h6,\n.sidebar-footer-content>.h6 {\n  color: #b7c0cd;\n  font-size: 0.81rem;\n  margin-top: 0.69rem;\n  margin-bottom: 0.69rem;\n  white-space: nowrap;\n}\n\n.sidebar-footer-content .progress {\n  height: 15px;\n  margin-bottom: 1.88rem;\n  overflow: hidden;\n  background-color: #e4eaec;\n  border-radius: 0.215rem;\n}\n\n.sidebar-footer-content .progress-xs {\n  height: 4px;\n  border-radius: 0.06rem;\n}\n\n.sidebar-footer-content .progress-xs .progress-bar {\n  line-height: 4px;\n}\n\n.sidebar-footer-content .progress-xs .progress-bar.progress-bar-warning {\n  background: #ddaa04;\n}\n\n/* App Logo Fill Color */\n.logo-fill-blue {\n  fill: #84befc;\n}\n\n.logo-fill-white {\n  fill: #ffffff;\n}\n\n/* Right Sidebar Toogler Add */\n.right-sidebar-toggoler-in .right-sidebar {\n  right: 0;\n  -webkit-transition: right 0.3s ease-in-out;\n  transition: right 0.3s ease-in-out;\n}\n\n.right-sidebar-toggoler-in .right-sidebar .btn-right-sidebar-toggler {\n  right: 60px;\n  -webkit-transition: right 0.3s ease-in-out;\n  transition: right 0.3s ease-in-out;\n}\n\n.right-sidebar-toggoler-in .right-sidebar .btn-right-sidebar-toggler i {\n  -webkit-transform: rotate(180deg);\n  transform: rotate(180deg);\n  -webkit-transition: -webkit-transform 0.3s ease-in-out;\n  transition: -webkit-transform 0.3s ease-in-out;\n  transition: transform 0.3s ease-in-out;\n  transition: transform 0.3s ease-in-out, -webkit-transform 0.3s ease-in-out;\n}\n\n.right-sidebar-toggoler-out .right-sidebar {\n  -webkit-transition: right 0.3s ease-in-out;\n  transition: right 0.3s ease-in-out;\n}\n\n.right-sidebar-toggoler-out .right-sidebar .btn-right-sidebar-toggler {\n  -webkit-transition: right 0.3s ease-in-out;\n  transition: right 0.3s ease-in-out;\n}\n\n.right-sidebar-toggoler-out .right-sidebar i {\n  -webkit-transform: rotate(0deg);\n  transform: rotate(0deg);\n  -webkit-transition: -webkit-transform 0.3s ease-in-out;\n  transition: -webkit-transform 0.3s ease-in-out;\n  transition: transform 0.3s ease-in-out;\n  transition: transform 0.3s ease-in-out, -webkit-transform 0.3s ease-in-out;\n}\n\n/* Right Sidebar */\n.right-sidebar {\n  width: 60px;\n  min-height: 100vh;\n  position: fixed;\n  right: -60px;\n  top: 0;\n  z-index: 1;\n  -webkit-transition: right 0.3s ease-in-out;\n  transition: right 0.3s ease-in-out;\n  /* From Group Label */\n}\n\n@media (min-width: 1200px) {\n  .right-sidebar {\n    right: 0;\n    -webkit-transition: right 0.3s ease-in-out;\n    transition: right 0.3s ease-in-out;\n  }\n}\n\n.right-sidebar .btn-right-sidebar-toggler {\n  position: fixed;\n  top: 135px;\n  right: 0;\n  background-color: #ffffff;\n  border-top-left-radius: 1rem;\n  border-bottom-left-radius: 1rem;\n  width: 35px;\n  height: 30px;\n  border: 1px solid var(--border-color);\n}\n\n.right-sidebar .btn-right-sidebar-toggler i {\n  line-height: 28px;\n  margin-left: 5px;\n  font-size: 1.25rem;\n  display: inline-block;\n}\n\n@media (min-width: 1200px) {\n  .right-sidebar .btn-right-sidebar-toggler {\n    display: none;\n  }\n}\n\n.right-sidebar .form-group label {\n  line-height: 1.3;\n}\n\n/* Nav Right Sidebar */\n.nav-right-sidebar {\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  position: relative;\n}\n\n.nav-right-sidebar .nav-item {\n  margin: auto;\n  margin-bottom: 0.75rem;\n}\n\n.nav-right-sidebar .nav-link {\n  font-size: 1.5rem;\n}\n\n.nav-right-sidebar .nav-link:focus {\n  background-color: rgba(138, 144, 157, 0.1);\n}\n\n/* Nav Container */\n.right-nav-container {\n  position: relative;\n  z-index: 100;\n  background-color: #ffffff;\n  min-height: 100vh;\n  border-left: 1px solid var(--border-color);\n}\n\n.right-nav-container .nav-right-sidebar {\n  padding-top: 120px;\n}\n\n/* Right Sidebar Tab Content */\n.right-sidebar-tab {\n  position: fixed;\n  top: 76px;\n  right: -375px;\n  width: 315px;\n  min-height: 100%;\n  background-color: #ffffff;\n  border-left: 1px solid var(--border-color);\n}\n\n.right-sidebar-tab .tab-content {\n  position: relative;\n  z-index: 10;\n}\n\n/* Right Sidebar Content Out */\n@media (min-width: 1200px) {\n  .right-sidebar-out .ec-content-wrapper {\n    margin-right: 60px;\n    -webkit-transition: margin-right 0.3s ease-in-out;\n    transition: margin-right 0.3s ease-in-out;\n  }\n}\n\n.right-sidebar-out .right-sidebar-tab {\n  right: -315px;\n  -webkit-transition: right 0.3s ease-in-out;\n  transition: right 0.3s ease-in-out;\n}\n\n/* Right Sidebar Content IN */\n@media (min-width: 1200px) {\n  .right-sidebar-in .ec-content-wrapper {\n    margin-right: 375px;\n    -webkit-transition: margin-right 0.3s ease-in-out;\n    transition: margin-right 0.3s ease-in-out;\n  }\n}\n\n.right-sidebar-in .right-sidebar-tab {\n  right: 60px;\n  -webkit-transition: right 0.3s ease-in-out;\n  transition: right 0.3s ease-in-out;\n}\n\n/* Nav Icon Small */\n.icon-sm {\n  width: 45px;\n  height: 45px;\n  line-height: 45px;\n  border-radius: 50%;\n  padding: 0;\n  text-align: center;\n}\n\n/* Card Right Sidebar */\n.card-right-sidebar {\n  border: none;\n}\n\n.card-right-sidebar .card-header {\n  background-color: transparent;\n  padding: 1rem;\n  padding-top: 1.5rem;\n  padding-right: 1rem;\n  padding-bottom: 1rem;\n  padding-right: 1rem;\n  color: var(--text-color);\n}\n\n.card-right-sidebar .card-header .close {\n  width: 30px;\n  height: 30px;\n  line-height: 1;\n  border-radius: 50%;\n  margin-top: -5px;\n}\n\n.card-right-sidebar .card-header .close:hover {\n  background-color: rgba(138, 144, 157, 0.1);\n}\n\n.card-right-sidebar .card-header .card-title {\n  margin-bottom: 0;\n  font-size: 0.94rem;\n}\n\n/* Dark Version  */\n.right-ec-sidebar-dark .right-nav-container {\n  background-color: #1a283e;\n  border-left: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n/* Right Sidebar 2 */\n.right-sidebar-container-2 {\n  right: 0;\n  top: 0;\n  width: 315px !important;\n  display: block;\n  z-index: 555555;\n  position: fixed;\n  background: #fff;\n  border-radius: 0;\n  height: 100%;\n  -webkit-transform: translateX(100%);\n  transform: translateX(100%);\n  border-left: 1px solid var(--border-color);\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n  /* Theme Button */\n  /* Reset Button */\n  /* Theme Button Active */\n  /* Slelect box */\n  /* Theme Subtitle */\n}\n\n.right-sidebar-container-2 .btn-close-right-sidebar-2 {\n  top: 50%;\n  right: 0;\n  -webkit-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n  position: absolute;\n  border-bottom-left-radius: 6px;\n  border-top-left-radius: 6px;\n  margin-left: -40px;\n  min-width: 40px;\n  height: 35px;\n  line-height: 35px;\n  text-align: center;\n  cursor: pointer;\n  font-size: 1.25rem;\n  color: var(--text-color);\n}\n\n.right-sidebar-container-2 h2,\n.right-sidebar-container-2 .h2 {\n  font-size: 1.25rem;\n  font-weight: 200;\n  color: #ffffff;\n}\n\n.right-sidebar-container-2 .right-sidebar-2-header {\n  padding: 17px 30px;\n  border-radius: 0 0 !important;\n  display: block;\n  color: var(--text-color);\n  position: relative;\n  background-color: #fff;\n  border-bottom: 1px solid var(--border-color);\n}\n\n.right-sidebar-container-2 .right-sidebar-2-header p {\n  font-size: 13px;\n  color: var(--text-color);\n  display: none;\n}\n\n.right-sidebar-container-2 .right-sidebar-2-header h2,\n.right-sidebar-container-2 .right-sidebar-2-header .h2 {\n  color: var(--text-color);\n}\n\n.right-sidebar-container-2 .btn-right-sidebar-2 {\n  color: var(--bs-body-color);\n  font-size: 13px;\n  text-transform: uppercase;\n  font-weight: 200;\n  padding: 4px 10px;\n  width: 48%;\n  text-align: center;\n  margin-right: 10px;\n  text-decoration: none;\n  line-height: 21px;\n}\n\n.right-sidebar-container-2 .btn-right-sidebar-2:last-child {\n  margin-right: 0;\n}\n\n.right-sidebar-container-2 .btn-reset {\n  background-color: var(--admin-color);\n  border: 0;\n  color: #ffffff;\n  width: auto;\n  cursor: pointer;\n  line-height: 2;\n  border-radius: 15px !important;\n}\n\n.right-sidebar-container-2 .btn-right-sidebar-2.btn-right-sidebar-2-active {\n  background-color: var(--bs-body-color);\n  color: #ffffff;\n  text-decoration: none;\n}\n\n.right-sidebar-container-2 .right-sidebar-2-select {\n  width: 100%;\n  height: 31px;\n  border-radius: 4px;\n  padding-left: 10px;\n  padding-right: 10px;\n}\n\n.right-sidebar-container-2 .right-sidebar-2-subtitle {\n  color: #a6aab4;\n  font-size: 16px;\n  display: block;\n  margin-bottom: 10px;\n  margin-top: 10px;\n}\n\n/* Theme Option Visibile */\n.right-sidebar-2-visible {\n  -webkit-transform: translateX(0);\n  transform: translateX(0);\n}\n\n/* Style Swticher Body */\n.right-sidebar-2-body {\n  padding: 15px 30px;\n  border-bottom-left-radius: 4px;\n  border-bottom-right-radius: 4px;\n  height: calc(100vh - 60px);\n}\n\n.right-sidebar-2-body .no-col-space {\n  margin-bottom: 30px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.right-sidebar-2-body hr {\n  /* margin: 11px 0; */\n  border-color: #454545;\n}\n\n/* Simplebar */\n.simplebar-scrollbar::before {\n  background-color: rgba(153, 153, 153, 0.8);\n  width: 5px;\n  left: 6px;\n  right: 6px;\n}\n\n/*===== SPINNERS =====*/\n/* Rotating Plane */\n.sk-rotating-plane {\n  width: 40px;\n  height: 40px;\n  background-color: #333;\n  -webkit-animation: sk-rotateplane 1.2s infinite ease-in-out;\n  animation: sk-rotateplane 1.2s infinite ease-in-out;\n}\n\n@-webkit-keyframes sk-rotateplane {\n  0% {\n    -webkit-transform: perspective(120px);\n  }\n\n  50% {\n    -webkit-transform: perspective(120px) rotateY(180deg);\n  }\n\n  100% {\n    -webkit-transform: perspective(120px) rotateY(180deg) rotateX(180deg);\n  }\n}\n\n@keyframes sk-rotateplane {\n  0% {\n    transform: perspective(120px) rotateX(0deg) rotateY(0deg);\n    -webkit-transform: perspective(120px) rotateX(0deg) rotateY(0deg);\n  }\n\n  50% {\n    transform: perspective(120px) rotateX(-180.1deg) rotateY(0deg);\n    -webkit-transform: perspective(120px) rotateX(-180.1deg) rotateY(0deg);\n  }\n\n  100% {\n    transform: perspective(120px) rotateX(-180deg) rotateY(-179.9deg);\n    -webkit-transform: perspective(120px) rotateX(-180deg) rotateY(-179.9deg);\n  }\n}\n\n/* double-bounce */\n.sk-double-bounce {\n  width: 40px;\n  height: 40px;\n  position: relative;\n}\n\n.double-bounce1,\n.double-bounce2 {\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  background-color: #333;\n  opacity: 0.6;\n  position: absolute;\n  top: 0;\n  left: 0;\n  -webkit-animation: sk-bounce 2s infinite ease-in-out;\n  animation: sk-bounce 2s infinite ease-in-out;\n}\n\n.double-bounce2 {\n  -webkit-animation-delay: -1s;\n  animation-delay: -1s;\n}\n\n@-webkit-keyframes sk-bounce {\n\n  0%,\n  100% {\n    -webkit-transform: scale(0);\n  }\n\n  50% {\n    -webkit-transform: scale(1);\n  }\n}\n\n@keyframes sk-bounce {\n\n  0%,\n  100% {\n    transform: scale(0);\n    -webkit-transform: scale(0);\n  }\n\n  50% {\n    transform: scale(1);\n    -webkit-transform: scale(1);\n  }\n}\n\n/* Wave */\n.sk-wave {\n  width: 50px;\n  height: 40px;\n  text-align: center;\n  font-size: 0.625rem;\n}\n\n.sk-wave>div {\n  background-color: #333;\n  height: 100%;\n  width: 6px;\n  display: inline-block;\n  -webkit-animation: sk-stretchdelay 1.2s infinite ease-in-out;\n  animation: sk-stretchdelay 1.2s infinite ease-in-out;\n}\n\n.sk-wave .rect2 {\n  -webkit-animation-delay: -1.1s;\n  animation-delay: -1.1s;\n}\n\n.sk-wave .rect3 {\n  -webkit-animation-delay: -1s;\n  animation-delay: -1s;\n}\n\n.sk-wave .rect4 {\n  -webkit-animation-delay: -0.9s;\n  animation-delay: -0.9s;\n}\n\n.sk-wave .rect5 {\n  -webkit-animation-delay: -0.8s;\n  animation-delay: -0.8s;\n}\n\n@-webkit-keyframes sk-stretchdelay {\n\n  0%,\n  40%,\n  100% {\n    -webkit-transform: scaleY(0.4);\n  }\n\n  20% {\n    -webkit-transform: scaleY(1);\n  }\n}\n\n@keyframes sk-stretchdelay {\n\n  0%,\n  40%,\n  100% {\n    transform: scaleY(0.4);\n    -webkit-transform: scaleY(0.4);\n  }\n\n  20% {\n    transform: scaleY(1);\n    -webkit-transform: scaleY(1);\n  }\n}\n\n/* Wonderting Cube */\n.sk-wonder-cube {\n  width: 40px;\n  height: 40px;\n  position: relative;\n}\n\n.cube1,\n.cube2 {\n  background-color: #333;\n  width: 15px;\n  height: 15px;\n  position: absolute;\n  top: 0;\n  left: 0;\n  -webkit-animation: sk-cubemove 1.8s infinite ease-in-out;\n  animation: sk-cubemove 1.8s infinite ease-in-out;\n}\n\n.cube2 {\n  -webkit-animation-delay: -0.9s;\n  animation-delay: -0.9s;\n}\n\n@-webkit-keyframes sk-cubemove {\n  25% {\n    -webkit-transform: translateX(42px) rotate(-90deg) scale(0.5);\n  }\n\n  50% {\n    -webkit-transform: translateX(42px) translateY(42px) rotate(-180deg);\n  }\n\n  75% {\n    -webkit-transform: translateX(0px) translateY(42px) rotate(-270deg) scale(0.5);\n  }\n\n  100% {\n    -webkit-transform: rotate(-360deg);\n  }\n}\n\n@keyframes sk-cubemove {\n  25% {\n    transform: translateX(42px) rotate(-90deg) scale(0.5);\n    -webkit-transform: translateX(42px) rotate(-90deg) scale(0.5);\n  }\n\n  50% {\n    transform: translateX(42px) translateY(42px) rotate(-179deg);\n    -webkit-transform: translateX(42px) translateY(42px) rotate(-179deg);\n  }\n\n  50.1% {\n    transform: translateX(42px) translateY(42px) rotate(-180deg);\n    -webkit-transform: translateX(42px) translateY(42px) rotate(-180deg);\n  }\n\n  75% {\n    transform: translateX(0px) translateY(42px) rotate(-270deg) scale(0.5);\n    -webkit-transform: translateX(0px) translateY(42px) rotate(-270deg) scale(0.5);\n  }\n\n  100% {\n    transform: rotate(-360deg);\n    -webkit-transform: rotate(-360deg);\n  }\n}\n\n/* Pulse */\n.sk-pulse {\n  width: 60px;\n  height: 60px;\n  background-color: #333;\n  border-radius: 100%;\n  -webkit-animation: sk-scaleout 1s infinite ease-in-out;\n  animation: sk-scaleout 1s infinite ease-in-out;\n}\n\n@-webkit-keyframes sk-scaleout {\n  0% {\n    -webkit-transform: scale(0);\n  }\n\n  100% {\n    -webkit-transform: scale(1);\n    opacity: 0;\n  }\n}\n\n@keyframes sk-scaleout {\n  0% {\n    -webkit-transform: scale(0);\n    transform: scale(0);\n  }\n\n  100% {\n    -webkit-transform: scale(1);\n    transform: scale(1);\n    opacity: 0;\n  }\n}\n\n/* Chasing dots */\n.sk-chasing-dots {\n  width: 40px;\n  height: 40px;\n  position: relative;\n  text-align: center;\n  -webkit-animation: sk-rotate 2s infinite linear;\n  animation: sk-rotate 2s infinite linear;\n}\n\n.dot1,\n.dot2 {\n  width: 60%;\n  height: 60%;\n  display: inline-block;\n  position: absolute;\n  top: 0;\n  background-color: #333;\n  border-radius: 100%;\n  -webkit-animation: sk-bounce 2s infinite ease-in-out;\n  animation: sk-bounce 2s infinite ease-in-out;\n}\n\n.dot2 {\n  top: auto;\n  bottom: 0;\n  -webkit-animation-delay: -1s;\n  animation-delay: -1s;\n}\n\n@-webkit-keyframes sk-rotate {\n  100% {\n    -webkit-transform: rotate(360deg);\n  }\n}\n\n@keyframes sk-rotate {\n  100% {\n    transform: rotate(360deg);\n    -webkit-transform: rotate(360deg);\n  }\n}\n\n@-webkit-keyframes sk-bounce {\n\n  0%,\n  100% {\n    -webkit-transform: scale(0);\n  }\n\n  50% {\n    -webkit-transform: scale(1);\n  }\n}\n\n@keyframes sk-bounce {\n\n  0%,\n  100% {\n    transform: scale(0);\n    -webkit-transform: scale(0);\n  }\n\n  50% {\n    transform: scale(1);\n    -webkit-transform: scale(1);\n  }\n}\n\n/* Three bounce */\n.sk-three-bounce {\n  width: 70px;\n  height: 40px;\n  text-align: center;\n}\n\n.sk-three-bounce>div {\n  width: 18px;\n  height: 18px;\n  background-color: #333;\n  border-radius: 100%;\n  display: inline-block;\n  -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;\n  animation: sk-bouncedelay 1.4s infinite ease-in-out both;\n}\n\n.sk-three-bounce .bounce1 {\n  -webkit-animation-delay: -0.32s;\n  animation-delay: -0.32s;\n}\n\n.sk-three-bounce .bounce2 {\n  -webkit-animation-delay: -0.16s;\n  animation-delay: -0.16s;\n}\n\n@-webkit-keyframes sk-bouncedelay {\n\n  0%,\n  80%,\n  100% {\n    -webkit-transform: scale(0);\n  }\n\n  40% {\n    -webkit-transform: scale(1);\n  }\n}\n\n@keyframes sk-bouncedelay {\n\n  0%,\n  80%,\n  100% {\n    -webkit-transform: scale(0);\n    transform: scale(0);\n  }\n\n  40% {\n    -webkit-transform: scale(1);\n    transform: scale(1);\n  }\n}\n\n/* Circle */\n.sk-circle {\n  width: 40px;\n  height: 40px;\n  position: relative;\n}\n\n.sk-circle .sk-child {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  left: 0;\n  top: 0;\n}\n\n.sk-circle .sk-child:before {\n  content: \"\";\n  display: block;\n  margin: 0 auto;\n  width: 15%;\n  height: 15%;\n  background-color: #333;\n  border-radius: 100%;\n  -webkit-animation: sk-circleBounceDelay 1.2s infinite ease-in-out both;\n  animation: sk-circleBounceDelay 1.2s infinite ease-in-out both;\n}\n\n.sk-circle .sk-circle2 {\n  -webkit-transform: rotate(30deg);\n  transform: rotate(30deg);\n}\n\n.sk-circle .sk-circle3 {\n  -webkit-transform: rotate(60deg);\n  transform: rotate(60deg);\n}\n\n.sk-circle .sk-circle4 {\n  -webkit-transform: rotate(90deg);\n  transform: rotate(90deg);\n}\n\n.sk-circle .sk-circle5 {\n  -webkit-transform: rotate(120deg);\n  transform: rotate(120deg);\n}\n\n.sk-circle .sk-circle6 {\n  -webkit-transform: rotate(150deg);\n  transform: rotate(150deg);\n}\n\n.sk-circle .sk-circle7 {\n  -webkit-transform: rotate(180deg);\n  transform: rotate(180deg);\n}\n\n.sk-circle .sk-circle8 {\n  -webkit-transform: rotate(210deg);\n  transform: rotate(210deg);\n}\n\n.sk-circle .sk-circle9 {\n  -webkit-transform: rotate(240deg);\n  transform: rotate(240deg);\n}\n\n.sk-circle .sk-circle10 {\n  -webkit-transform: rotate(270deg);\n  transform: rotate(270deg);\n}\n\n.sk-circle .sk-circle11 {\n  -webkit-transform: rotate(300deg);\n  transform: rotate(300deg);\n}\n\n.sk-circle .sk-circle12 {\n  -webkit-transform: rotate(330deg);\n  transform: rotate(330deg);\n}\n\n.sk-circle .sk-circle2:before {\n  -webkit-animation-delay: -1.1s;\n  animation-delay: -1.1s;\n}\n\n.sk-circle .sk-circle3:before {\n  -webkit-animation-delay: -1s;\n  animation-delay: -1s;\n}\n\n.sk-circle .sk-circle4:before {\n  -webkit-animation-delay: -0.9s;\n  animation-delay: -0.9s;\n}\n\n.sk-circle .sk-circle5:before {\n  -webkit-animation-delay: -0.8s;\n  animation-delay: -0.8s;\n}\n\n.sk-circle .sk-circle6:before {\n  -webkit-animation-delay: -0.7s;\n  animation-delay: -0.7s;\n}\n\n.sk-circle .sk-circle7:before {\n  -webkit-animation-delay: -0.6s;\n  animation-delay: -0.6s;\n}\n\n.sk-circle .sk-circle8:before {\n  -webkit-animation-delay: -0.5s;\n  animation-delay: -0.5s;\n}\n\n.sk-circle .sk-circle9:before {\n  -webkit-animation-delay: -0.4s;\n  animation-delay: -0.4s;\n}\n\n.sk-circle .sk-circle10:before {\n  -webkit-animation-delay: -0.3s;\n  animation-delay: -0.3s;\n}\n\n.sk-circle .sk-circle11:before {\n  -webkit-animation-delay: -0.2s;\n  animation-delay: -0.2s;\n}\n\n.sk-circle .sk-circle12:before {\n  -webkit-animation-delay: -0.1s;\n  animation-delay: -0.1s;\n}\n\n@-webkit-keyframes sk-circleBounceDelay {\n\n  0%,\n  80%,\n  100% {\n    -webkit-transform: scale(0);\n    transform: scale(0);\n  }\n\n  40% {\n    -webkit-transform: scale(1);\n    transform: scale(1);\n  }\n}\n\n@keyframes sk-circleBounceDelay {\n\n  0%,\n  80%,\n  100% {\n    -webkit-transform: scale(0);\n    transform: scale(0);\n  }\n\n  40% {\n    -webkit-transform: scale(1);\n    transform: scale(1);\n  }\n}\n\n/* Cube Grid */\n.sk-cube-grid {\n  width: 40px;\n  height: 40px;\n}\n\n.sk-cube-grid .sk-cube {\n  width: 33%;\n  height: 33%;\n  background-color: #333;\n  float: left;\n  -webkit-animation: sk-cubeGridScaleDelay 1.3s infinite ease-in-out;\n  animation: sk-cubeGridScaleDelay 1.3s infinite ease-in-out;\n}\n\n.sk-cube-grid .sk-cube1 {\n  -webkit-animation-delay: 0.2s;\n  animation-delay: 0.2s;\n}\n\n.sk-cube-grid .sk-cube2 {\n  -webkit-animation-delay: 0.3s;\n  animation-delay: 0.3s;\n}\n\n.sk-cube-grid .sk-cube3 {\n  -webkit-animation-delay: 0.4s;\n  animation-delay: 0.4s;\n}\n\n.sk-cube-grid .sk-cube4 {\n  -webkit-animation-delay: 0.1s;\n  animation-delay: 0.1s;\n}\n\n.sk-cube-grid .sk-cube5 {\n  -webkit-animation-delay: 0.2s;\n  animation-delay: 0.2s;\n}\n\n.sk-cube-grid .sk-cube6 {\n  -webkit-animation-delay: 0.3s;\n  animation-delay: 0.3s;\n}\n\n.sk-cube-grid .sk-cube7 {\n  -webkit-animation-delay: 0s;\n  animation-delay: 0s;\n}\n\n.sk-cube-grid .sk-cube8 {\n  -webkit-animation-delay: 0.1s;\n  animation-delay: 0.1s;\n}\n\n.sk-cube-grid .sk-cube9 {\n  -webkit-animation-delay: 0.2s;\n  animation-delay: 0.2s;\n}\n\n@-webkit-keyframes sk-cubeGridScaleDelay {\n\n  0%,\n  70%,\n  100% {\n    -webkit-transform: scale3D(1, 1, 1);\n    transform: scale3D(1, 1, 1);\n  }\n\n  35% {\n    -webkit-transform: scale3D(0, 0, 1);\n    transform: scale3D(0, 0, 1);\n  }\n}\n\n@keyframes sk-cubeGridScaleDelay {\n\n  0%,\n  70%,\n  100% {\n    -webkit-transform: scale3D(1, 1, 1);\n    transform: scale3D(1, 1, 1);\n  }\n\n  35% {\n    -webkit-transform: scale3D(0, 0, 1);\n    transform: scale3D(0, 0, 1);\n  }\n}\n\n/* Fading Circle */\n.sk-fading-circle {\n  width: 40px;\n  height: 40px;\n  position: relative;\n}\n\n.sk-fading-circle .sk-circle {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  left: 0;\n  top: 0;\n}\n\n.sk-fading-circle .sk-circle:before {\n  content: \"\";\n  display: block;\n  margin: 0 auto;\n  width: 15%;\n  height: 15%;\n  background-color: #333;\n  border-radius: 100%;\n  -webkit-animation: sk-circleFadeDelay 1.2s infinite ease-in-out both;\n  animation: sk-circleFadeDelay 1.2s infinite ease-in-out both;\n}\n\n.sk-fading-circle .sk-circle2 {\n  -webkit-transform: rotate(30deg);\n  transform: rotate(30deg);\n}\n\n.sk-fading-circle .sk-circle3 {\n  -webkit-transform: rotate(60deg);\n  transform: rotate(60deg);\n}\n\n.sk-fading-circle .sk-circle4 {\n  -webkit-transform: rotate(90deg);\n  transform: rotate(90deg);\n}\n\n.sk-fading-circle .sk-circle5 {\n  -webkit-transform: rotate(120deg);\n  transform: rotate(120deg);\n}\n\n.sk-fading-circle .sk-circle6 {\n  -webkit-transform: rotate(150deg);\n  transform: rotate(150deg);\n}\n\n.sk-fading-circle .sk-circle7 {\n  -webkit-transform: rotate(180deg);\n  transform: rotate(180deg);\n}\n\n.sk-fading-circle .sk-circle8 {\n  -webkit-transform: rotate(210deg);\n  transform: rotate(210deg);\n}\n\n.sk-fading-circle .sk-circle9 {\n  -webkit-transform: rotate(240deg);\n  transform: rotate(240deg);\n}\n\n.sk-fading-circle .sk-circle10 {\n  -webkit-transform: rotate(270deg);\n  transform: rotate(270deg);\n}\n\n.sk-fading-circle .sk-circle11 {\n  -webkit-transform: rotate(300deg);\n  transform: rotate(300deg);\n}\n\n.sk-fading-circle .sk-circle12 {\n  -webkit-transform: rotate(330deg);\n  transform: rotate(330deg);\n}\n\n.sk-fading-circle .sk-circle2:before {\n  -webkit-animation-delay: -1.1s;\n  animation-delay: -1.1s;\n}\n\n.sk-fading-circle .sk-circle3:before {\n  -webkit-animation-delay: -1s;\n  animation-delay: -1s;\n}\n\n.sk-fading-circle .sk-circle4:before {\n  -webkit-animation-delay: -0.9s;\n  animation-delay: -0.9s;\n}\n\n.sk-fading-circle .sk-circle5:before {\n  -webkit-animation-delay: -0.8s;\n  animation-delay: -0.8s;\n}\n\n.sk-fading-circle .sk-circle6:before {\n  -webkit-animation-delay: -0.7s;\n  animation-delay: -0.7s;\n}\n\n.sk-fading-circle .sk-circle7:before {\n  -webkit-animation-delay: -0.6s;\n  animation-delay: -0.6s;\n}\n\n.sk-fading-circle .sk-circle8:before {\n  -webkit-animation-delay: -0.5s;\n  animation-delay: -0.5s;\n}\n\n.sk-fading-circle .sk-circle9:before {\n  -webkit-animation-delay: -0.4s;\n  animation-delay: -0.4s;\n}\n\n.sk-fading-circle .sk-circle10:before {\n  -webkit-animation-delay: -0.3s;\n  animation-delay: -0.3s;\n}\n\n.sk-fading-circle .sk-circle11:before {\n  -webkit-animation-delay: -0.2s;\n  animation-delay: -0.2s;\n}\n\n.sk-fading-circle .sk-circle12:before {\n  -webkit-animation-delay: -0.1s;\n  animation-delay: -0.1s;\n}\n\n@-webkit-keyframes sk-circleFadeDelay {\n\n  0%,\n  39%,\n  100% {\n    opacity: 0;\n  }\n\n  40% {\n    opacity: 1;\n  }\n}\n\n@keyframes sk-circleFadeDelay {\n\n  0%,\n  39%,\n  100% {\n    opacity: 0;\n  }\n\n  40% {\n    opacity: 1;\n  }\n}\n\n/* Folding Cube */\n.sk-folding-cube {\n  width: 40px;\n  height: 40px;\n  position: relative;\n  -webkit-transform: rotateZ(45deg);\n  transform: rotateZ(45deg);\n}\n\n.sk-folding-cube .sk-cube {\n  float: left;\n  width: 50%;\n  height: 50%;\n  position: relative;\n  -webkit-transform: scale(1.1);\n  transform: scale(1.1);\n}\n\n.sk-folding-cube .sk-cube:before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: #333;\n  -webkit-animation: sk-foldCubeAngle 2.4s infinite linear both;\n  animation: sk-foldCubeAngle 2.4s infinite linear both;\n  -webkit-transform-origin: 100% 100%;\n  transform-origin: 100% 100%;\n}\n\n.sk-folding-cube .sk-cube2 {\n  -webkit-transform: scale(1.1) rotateZ(90deg);\n  transform: scale(1.1) rotateZ(90deg);\n}\n\n.sk-folding-cube .sk-cube3 {\n  -webkit-transform: scale(1.1) rotateZ(180deg);\n  transform: scale(1.1) rotateZ(180deg);\n}\n\n.sk-folding-cube .sk-cube4 {\n  -webkit-transform: scale(1.1) rotateZ(270deg);\n  transform: scale(1.1) rotateZ(270deg);\n}\n\n.sk-folding-cube .sk-cube2:before {\n  -webkit-animation-delay: 0.3s;\n  animation-delay: 0.3s;\n}\n\n.sk-folding-cube .sk-cube3:before {\n  -webkit-animation-delay: 0.6s;\n  animation-delay: 0.6s;\n}\n\n.sk-folding-cube .sk-cube4:before {\n  -webkit-animation-delay: 0.9s;\n  animation-delay: 0.9s;\n}\n\n@-webkit-keyframes sk-foldCubeAngle {\n\n  0%,\n  10% {\n    -webkit-transform: perspective(140px) rotateX(-180deg);\n    transform: perspective(140px) rotateX(-180deg);\n    opacity: 0;\n  }\n\n  25%,\n  75% {\n    -webkit-transform: perspective(140px) rotateX(0deg);\n    transform: perspective(140px) rotateX(0deg);\n    opacity: 1;\n  }\n\n  90%,\n  100% {\n    -webkit-transform: perspective(140px) rotateY(180deg);\n    transform: perspective(140px) rotateY(180deg);\n    opacity: 0;\n  }\n}\n\n@keyframes sk-foldCubeAngle {\n\n  0%,\n  10% {\n    -webkit-transform: perspective(140px) rotateX(-180deg);\n    transform: perspective(140px) rotateX(-180deg);\n    opacity: 0;\n  }\n\n  25%,\n  75% {\n    -webkit-transform: perspective(140px) rotateX(0deg);\n    transform: perspective(140px) rotateX(0deg);\n    opacity: 1;\n  }\n\n  90%,\n  100% {\n    -webkit-transform: perspective(140px) rotateY(180deg);\n    transform: perspective(140px) rotateY(180deg);\n    opacity: 0;\n  }\n}\n\n/* Chase */\n.sk-chase {\n  width: 60px;\n  height: 60px;\n  position: relative;\n  -webkit-animation: sk-chase 2.5s infinite linear both;\n  animation: sk-chase 2.5s infinite linear both;\n}\n\n.sk-chase-dot {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  left: 0;\n  top: 0;\n  -webkit-animation: sk-chase-dot 2s infinite ease-in-out both;\n  animation: sk-chase-dot 2s infinite ease-in-out both;\n}\n\n.sk-chase-dot:before {\n  content: \"\";\n  display: block;\n  width: 25%;\n  height: 25%;\n  background-color: #333;\n  border-radius: 100%;\n  -webkit-animation: sk-chase-dot-before 2s infinite ease-in-out both;\n  animation: sk-chase-dot-before 2s infinite ease-in-out both;\n}\n\n.sk-chase-dot:nth-child(1) {\n  -webkit-animation-delay: -1.1s;\n  animation-delay: -1.1s;\n}\n\n.sk-chase-dot:nth-child(2) {\n  -webkit-animation-delay: -1s;\n  animation-delay: -1s;\n}\n\n.sk-chase-dot:nth-child(3) {\n  -webkit-animation-delay: -0.9s;\n  animation-delay: -0.9s;\n}\n\n.sk-chase-dot:nth-child(4) {\n  -webkit-animation-delay: -0.8s;\n  animation-delay: -0.8s;\n}\n\n.sk-chase-dot:nth-child(5) {\n  -webkit-animation-delay: -0.7s;\n  animation-delay: -0.7s;\n}\n\n.sk-chase-dot:nth-child(6) {\n  -webkit-animation-delay: -0.6s;\n  animation-delay: -0.6s;\n}\n\n.sk-chase-dot:nth-child(1):before {\n  -webkit-animation-delay: -1.1s;\n  animation-delay: -1.1s;\n}\n\n.sk-chase-dot:nth-child(2):before {\n  -webkit-animation-delay: -1s;\n  animation-delay: -1s;\n}\n\n.sk-chase-dot:nth-child(3):before {\n  -webkit-animation-delay: -0.9s;\n  animation-delay: -0.9s;\n}\n\n.sk-chase-dot:nth-child(4):before {\n  -webkit-animation-delay: -0.8s;\n  animation-delay: -0.8s;\n}\n\n.sk-chase-dot:nth-child(5):before {\n  -webkit-animation-delay: -0.7s;\n  animation-delay: -0.7s;\n}\n\n@-webkit-keyframes sk-chase {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes sk-chase {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n@-webkit-keyframes sk-chase-dot {\n\n  80%,\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes sk-chase-dot {\n\n  80%,\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n@-webkit-keyframes sk-chase-dot-before {\n  50% {\n    -webkit-transform: scale(0.4);\n    transform: scale(0.4);\n  }\n\n  100%,\n  0% {\n    -webkit-transform: scale(1);\n    transform: scale(1);\n  }\n}\n\n@keyframes sk-chase-dot-before {\n  50% {\n    -webkit-transform: scale(0.4);\n    transform: scale(0.4);\n  }\n\n  100%,\n  0% {\n    -webkit-transform: scale(1);\n    transform: scale(1);\n  }\n}\n\n/*===== SWITCHERS =====*/\ninput[type=checkbox],\ninput[type=radio] {\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  padding: 0;\n}\n\n.switch {\n  position: relative;\n  display: inline-block;\n  vertical-align: top;\n  width: 64px;\n  height: 30px;\n  background-color: transparent;\n  cursor: pointer;\n}\n\n.switch .switch-input {\n  position: absolute;\n  top: 0;\n  left: 0;\n  opacity: 0;\n  display: none;\n  visibility: hidden;\n}\n\n.switch .switch-label {\n  position: relative;\n  display: block;\n  height: inherit;\n  font-size: 0.625rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  background-color: #fff;\n  border: 1px solid #c2cfd6;\n  border-radius: 4px;\n  -webkit-transition: opacity background-color 0.3s 0.3s ease-out;\n  transition: opacity background-color 0.3s 0.3s ease-out;\n}\n\n.switch .switch-handle {\n  position: absolute;\n  top: 3px;\n  left: 3px;\n  width: 24px;\n  height: 24px;\n  background: #fff;\n  border: 1px solid #c2cfd6;\n  border-radius: 1px;\n  -webkit-transition: left 0.3s ease-out;\n  transition: left 0.3s ease-out;\n}\n\n.switch .switch-input:checked~.switch-handle {\n  left: 37px;\n}\n\n/* Switch context properties */\n.switch-primary>.switch-input:checked~.switch-label {\n  background-color: var(--admin-color) !important;\n  border-color: var(--admin-color);\n}\n\n.switch-primary>.switch-input:checked~.switch-handle {\n  border-color: transparent;\n}\n\n.switch-secondary>.switch-input:checked~.switch-label {\n  background-color: var(--bs-body-color) !important;\n  border-color: var(--bs-body-color);\n}\n\n.switch-secondary>.switch-input:checked~.switch-handle {\n  border-color: transparent;\n}\n\n.switch-success>.switch-input:checked~.switch-label {\n  background-color: #34c997 !important;\n  border-color: #34c997;\n}\n\n.switch-success>.switch-input:checked~.switch-handle {\n  border-color: transparent;\n}\n\n.switch-info>.switch-input:checked~.switch-label {\n  background-color: #24c4da !important;\n  border-color: #24c4da;\n}\n\n.switch-info>.switch-input:checked~.switch-handle {\n  border-color: transparent;\n}\n\n.switch-warning>.switch-input:checked~.switch-label {\n  background-color: #ddaa04 !important;\n  border-color: #ddaa04;\n}\n\n.switch-warning>.switch-input:checked~.switch-handle {\n  border-color: transparent;\n}\n\n.switch-danger>.switch-input:checked~.switch-label {\n  background-color: #ec4a58 !important;\n  border-color: #ec4a58;\n}\n\n.switch-danger>.switch-input:checked~.switch-handle {\n  border-color: transparent;\n}\n\n/* Switch Pill */\n.switch-pill .switch-handle,\n.switch-pill .switch-label {\n  border-radius: 50px !important;\n}\n\n/* Switch Outline */\n.switch-outline-primary>.switch-input:checked~.switch-label {\n  background-color: #ffffff !important;\n  border-color: var(--admin-color);\n}\n\n.switch-outline-primary .switch-input:checked~.switch-label:after {\n  color: var(--admin-color);\n}\n\n.switch-outline-primary>.switch-input:checked~.switch-handle {\n  border-color: var(--admin-color);\n}\n\n.switch-outline-secondary>.switch-input:checked~.switch-label {\n  background-color: #ffffff !important;\n  border-color: var(--bs-body-color);\n}\n\n.switch-outline-secondary .switch-input:checked~.switch-label:after {\n  color: var(--bs-body-color);\n}\n\n.switch-outline-secondary>.switch-input:checked~.switch-handle {\n  border-color: var(--bs-body-color);\n}\n\n.switch-outline-success>.switch-input:checked~.switch-label {\n  background-color: #ffffff !important;\n  border-color: #34c997;\n}\n\n.switch-outline-success .switch-input:checked~.switch-label:after {\n  color: #34c997;\n}\n\n.switch-outline-success>.switch-input:checked~.switch-handle {\n  border-color: #34c997;\n}\n\n.switch-outline-info>.switch-input:checked~.switch-label {\n  background-color: #ffffff !important;\n  border-color: #24c4da;\n}\n\n.switch-outline-info .switch-input:checked~.switch-label:after {\n  color: #24c4da;\n}\n\n.switch-outline-info>.switch-input:checked~.switch-handle {\n  border-color: #24c4da;\n}\n\n.switch-outline-warning>.switch-input:checked~.switch-label {\n  background-color: #ffffff !important;\n  border-color: #ddaa04;\n}\n\n.switch-outline-warning>.switch-input:checked~.switch-label:after {\n  color: #ddaa04;\n}\n\n.switch-outline-warning>.switch-input:checked~.switch-handle {\n  border-color: #ddaa04;\n}\n\n.switch-outline-danger>.switch-input:checked~.switch-label {\n  background-color: #ffffff !important;\n  border-color: #ec4a58;\n}\n\n.switch-outline-danger>.switch-input:checked~.switch-label:after {\n  color: #ec4a58;\n}\n\n.switch-outline-danger>.switch-input:checked~.switch-handle {\n  border-color: #ec4a58;\n}\n\n/* Switch Outline Alternative */\n.switch-outline-alt-primary>.switch-input:checked~.switch-label {\n  background-color: #ffffff !important;\n  border-color: var(--admin-color);\n}\n\n.switch-outline-alt-primary .switch-input:checked~.switch-label:after {\n  color: var(--admin-color);\n}\n\n.switch-outline-alt-primary>.switch-input:checked~.switch-handle {\n  background-color: var(--admin-color);\n  border-color: var(--admin-color);\n}\n\n.switch-outline-alt-secondary>.switch-input:checked~.switch-label {\n  background-color: #ffffff !important;\n  border-color: var(--bs-body-color);\n}\n\n.switch-outline-alt-secondary>.switch-input:checked~.switch-label:after {\n  color: var(--bs-body-color);\n}\n\n.switch-outline-alt-secondary>.switch-input:checked~.switch-handle {\n  background-color: var(--bs-body-color);\n  border-color: var(--bs-body-color);\n}\n\n.switch-outline-alt-success>.switch-input:checked~.switch-label {\n  background-color: #ffffff !important;\n  border-color: #34c997;\n}\n\n.switch-outline-alt-success>.switch-input:checked~.switch-label:after {\n  color: #34c997;\n}\n\n.switch-outline-alt-success>.switch-input:checked~.switch-handle {\n  background-color: #34c997;\n  border-color: #34c997;\n}\n\n.switch-outline-alt-info>.switch-input:checked~.switch-label {\n  background-color: #ffffff !important;\n  border-color: #24c4da;\n}\n\n.switch-outline-alt-info>.switch-input:checked~.switch-label:after {\n  color: #24c4da;\n}\n\n.switch-outline-alt-info>.switch-input:checked~.switch-handle {\n  background-color: #24c4da;\n  border-color: #24c4da;\n}\n\n.switch-outline-alt-warning>.switch-input:checked~.switch-label {\n  background-color: #ffffff !important;\n  border-color: #ddaa04;\n}\n\n.switch-outline-alt-warning>.switch-input:checked~.switch-label:after {\n  color: #ddaa04;\n}\n\n.switch-outline-alt-warning>.switch-input:checked~.switch-handle {\n  background-color: #ddaa04;\n  border-color: #ddaa04;\n}\n\n.switch-outline-alt-danger>.switch-input:checked~.switch-label {\n  background-color: #ffffff !important;\n  border-color: #ec4a58;\n}\n\n.switch-outline-alt-danger>.switch-input:checked~.switch-label:after {\n  color: #ec4a58;\n}\n\n.switch-outline-alt-danger>.switch-input:checked~.switch-handle {\n  background-color: #ec4a58;\n  border-color: #ec4a58;\n}\n\n/* Switch With Text */\n.switch.switch-text,\n.switch.switch-icon {\n  position: relative;\n  display: inline-block;\n  vertical-align: top;\n  width: 64px;\n  height: 30px;\n  background-color: transparent;\n  cursor: pointer;\n}\n\n.switch.switch-text .switch-input,\n.switch.switch-icon .switch-input {\n  position: absolute;\n  top: 0;\n  left: 0;\n  opacity: 0;\n}\n\n.switch.switch-text .switch-label,\n.switch.switch-icon .switch-label {\n  position: relative;\n  display: block;\n  height: inherit;\n  font-size: 0.625rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  background-color: #ffffff;\n  border: 1px solid #c2cfd6;\n  border-radius: 2px;\n  -webkit-transition: opacity background 0.3s ease-out;\n  transition: opacity background 0.3s ease-out;\n}\n\n.switch.switch-text .switch-handle,\n.switch.switch-icon .switch-handle {\n  position: absolute;\n  top: 3px;\n  left: 3px;\n  width: 24px;\n  height: 24px;\n  background: #fff;\n  border: 1px solid #c2cfd6;\n  border-radius: 0.06rem;\n  -webkit-transition: left 0.3s ease-out;\n  transition: left 0.3s ease-out;\n}\n\n.switch.switch-text .switch-label:after,\n.switch.switch-text .switch-label:before {\n  position: absolute;\n  top: 50%;\n  width: 50%;\n  margin-top: -0.31rem;\n  line-height: 1;\n  font-size: 12px;\n  font-weight: 400;\n  font-family: \"Roboto\", sans-serif;\n  text-align: center;\n  -webkit-transition: inherit;\n  transition: inherit;\n}\n\n.switch.switch-text .switch-label:before {\n  right: 1px;\n  color: #c2cfd6;\n  content: attr(data-off);\n}\n\n.switch.switch-text .switch-label:after {\n  left: 1px;\n  color: #fff;\n  content: attr(data-on);\n  opacity: 0;\n}\n\n.switch.switch-text .switch-input:checked~.switch-label:before {\n  opacity: 0;\n}\n\n.switch.switch-text .switch-input:checked~.switch-label:after {\n  opacity: 1;\n}\n\n.switch.switch-text .switch-input:checked~.switch-handle {\n  left: 37px;\n}\n\n/* Switch With Icon */\n.switch.switch-icon .switch-label:after,\n.switch.switch-icon .switch-label:before {\n  position: absolute;\n  top: 50%;\n  width: 50%;\n  margin-top: -8px;\n  line-height: 1;\n  font-size: 1rem;\n  font-weight: 400;\n  font-family: \"Material Design Icons\";\n  text-align: center;\n  -webkit-transition: inherit;\n  transition: inherit;\n}\n\n.switch.switch-icon .switch-label:before {\n  right: 1px;\n  color: #c2cfd6;\n  content: \"\";\n}\n\n.switch.switch-icon .switch-label:after {\n  left: 1px;\n  color: #fff;\n  content: \"\";\n  opacity: 0;\n}\n\n.switch.switch-icon .switch-input:checked~.switch-label:before {\n  opacity: 0;\n}\n\n.switch.switch-icon .switch-input:checked~.switch-label:after {\n  opacity: 1;\n}\n\n.switch.switch-icon .switch-input:checked~.switch-handle {\n  left: 37px;\n}\n\n/*===== TABS =====*/\n.notifications-menu .card-default .card-header-border-bottom {\n  margin-bottom: 12px !important;\n}\n\n.nav-tabs .nav-item .nav-link {\n  color: var(--text-color);\n  font-size: 16px;\n  font-weight: 500;\n  padding: 8px 20px;\n}\n\n.nav-tabs .nav-item .nav-link.active {\n  color: var(--admin-color);\n}\n\n.nav-tabs .nav-item .nav-link.disabled {\n  color: var(--bs-body-color);\n}\n\n.nav-tabs .nav-item .nav-link.disabled:hover {\n  cursor: not-allowed;\n}\n\n.nav-pills .nav-item .nav-link {\n  color: var(--text-color);\n  font-weight: 500;\n  padding: 12px 20px;\n}\n\n.nav-pills .nav-item .nav-link.active {\n  color: #ffffff;\n  background: var(--admin-color);\n}\n\n.nav-pills .nav-item .nav-link.disabled {\n  color: var(--bs-body-color);\n}\n\n.nav-pills .nav-item .nav-link.disabled:hover {\n  cursor: not-allowed;\n}\n\n.tab-pane {\n  line-height: 1.8;\n}\n\n/* Custom Tab Style - Fill */\n.nav-style-fill.nav-pills {\n  border: 2px solid var(--border-color);\n  border-radius: 0.38rem;\n  overflow: hidden;\n}\n\n.nav-style-fill.nav-pills .nav-link {\n  border-radius: 0;\n  padding-top: 0.94rem;\n  padding-bottom: 0.94rem;\n}\n\n.nav-style-fill.nav-pills .nav-link.active,\n.nav-style-fill.nav-pills .show>.nav-link {\n  color: var(--admin-color);\n  background-color: #f5f6fa;\n}\n\n.nav-tabs.nav-style-border {\n  padding-left: 1.9rem;\n  padding-right: 1.9rem;\n  padding-bottom: 0.625rem;\n}\n\n@media (min-width: 768px) {\n  .nav-tabs.nav-style-border {\n    padding-bottom: 0;\n  }\n}\n\n@media (min-width: 1500px) {\n  .nav-tabs.nav-style-border {\n    padding-left: 3.12rem;\n    padding-right: 3.12rem;\n  }\n}\n\n.nav-tabs.nav-style-border .nav-item {\n  margin-right: 0.94rem;\n}\n\n@media (min-width: 768px) {\n  .nav-tabs.nav-style-border .nav-item {\n    margin-right: 2.19rem;\n  }\n}\n\n@media (min-width: 1200px) {\n  .nav-tabs.nav-style-border .nav-item {\n    /* margin-right: 3.12rem; */\n    margin-bottom: 0;\n  }\n}\n\n@media (min-width: 1500px) {\n  .nav-tabs.nav-style-border .nav-item {\n    margin-right: 5rem;\n  }\n}\n\n.nav-tabs.nav-style-border .nav-item .nav-link {\n  padding: 20px 0 20px 0;\n  color: var(--bs-gray-dark);\n  position: relative;\n  cursor: pointer;\n}\n\n.nav-tabs.nav-style-border .nav-item .nav-link .type-name {\n  display: block;\n}\n\n.nav-tabs.nav-style-border .nav-item .nav-link:after {\n  content: \"\";\n  position: absolute;\n  bottom: 14px;\n  left: 0;\n  height: 2px;\n  background: var(--bs-gray-dark);\n  width: 100%;\n  opacity: 0;\n  visibility: hidden;\n  -webkit-transition: all 0.3s ease-in;\n  transition: all 0.3s ease-in;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .nav-tabs.nav-style-border .nav-item .nav-link:after {\n    -webkit-transition: none;\n    transition: none;\n  }\n}\n\n@media (min-width: 576px) {\n  .nav-tabs.nav-style-border .nav-item .nav-link:after {\n    bottom: -1px;\n  }\n}\n\n.nav-tabs.nav-style-border .nav-item .nav-link.active:after {\n  opacity: 1;\n  visibility: visible;\n}\n\n.nav-tabs.nav-style-border .nav-item .nav-link:hover,\n.nav-tabs.nav-style-border .nav-item .nav-link.active {\n  border-color: transparent;\n  background-color: transparent;\n}\n\n@media (min-width: 768px) {\n  .nav-tabs.nav-style-border .nav-item:first-child {\n    margin-bottom: 0.94rem;\n  }\n}\n\n@media (min-width: 992px) {\n  .nav-tabs.nav-style-border .nav-item:first-child {\n    margin-bottom: 0;\n  }\n}\n\n.nav-tabs.nav-style-border .nav-item:last-child {\n  margin-bottom: 0;\n}\n\n/* Vertical Tabs */\n.nav-tabs.nav-stacked {\n  margin-right: 0;\n  border-bottom: 0;\n  border-right: none;\n}\n\n@media (min-width: 768px) {\n  .nav-tabs.nav-stacked {\n    border-right: 1px solid var(--border-color);\n    padding-right: 0;\n  }\n}\n\n.nav-tabs.nav-stacked .nav-item {\n  margin: 0 !important;\n  float: none !important;\n  display: block !important;\n}\n\n.nav-tabs.nav-stacked .nav-item .nav-link {\n  padding: 12px 0.94rem;\n  margin-right: 0px;\n  border-right: 0px;\n  margin-right: -1px;\n  border-color: transparent;\n}\n\n.nav-tabs.nav-stacked .nav-item .nav-link i {\n  padding-right: 0.625rem;\n}\n\n.nav-tabs.nav-stacked .nav-item .nav-link.active {\n  border: 1px solid var(--border-color);\n}\n\n@media (min-width: 768px) {\n  .nav-tabs.nav-stacked .nav-item .nav-link.active {\n    border-right: 0px;\n    border-radius: 0;\n    border-top-left-radius: 0.38rem;\n    border-bottom-left-radius: 0.38rem;\n  }\n\n  .nav-tabs.nav-stacked .nav-item .nav-link.active:before {\n    top: 0;\n    width: 2px;\n    height: 100%;\n    bottom: 0px;\n  }\n}\n\n/*===== TODO LIST ======*/\n.todo-single-item {\n  margin-bottom: 2.19em;\n  position: relative;\n}\n\n.todo-single-item .task-content {\n  white-space: nowrap;\n  line-height: normal;\n}\n\n.todo-single-item .task-content span {\n  margin-left: 1rem;\n}\n\n.todo-single-item>span {\n  margin-left: 2rem;\n  position: relative;\n  display: inline-block;\n  color: #000;\n}\n\n.todo-single-item>span.badge {\n  color: #ffffff;\n  -webkit-transition: all 0.3s ease-in;\n  transition: all 0.3s ease-in;\n  display: inline-table;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .todo-single-item>span.badge {\n    -webkit-transition: none;\n    transition: none;\n  }\n}\n\n.todo-single-item.alert {\n  padding: 0;\n  font-weight: inherit;\n  font-size: inherit;\n}\n\n.todo-single-item i.mdi {\n  width: 20px;\n  height: 20px;\n  border: 1px solid #d4d5db;\n  border-radius: 50%;\n  margin-right: 0.38rem;\n  position: relative;\n  overflow: hidden;\n  text-align: center;\n  line-height: 1.3rem;\n  position: absolute;\n  left: 0;\n  -webkit-transition: all 0.3s ease-in;\n  transition: all 0.3s ease-in;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .todo-single-item i.mdi {\n    -webkit-transition: none;\n    transition: none;\n  }\n}\n\n.todo-single-item i.mdi:hover {\n  border-color: rgba(52, 201, 151, 0.5);\n  background-color: rgba(52, 201, 151, 0.2);\n  cursor: pointer;\n}\n\n.todo-input {\n  display: none;\n}\n\n.todo-input input {\n  margin-top: -0.31rem;\n  border: none;\n  font-size: 15px;\n  padding: 0.312rem 0.625rem;\n}\n\n.todo-input input:active,\n.todo-input input:focus {\n  -webkit-box-shadow: 0px 2px 8px rgba(86, 96, 110, 0.2);\n  box-shadow: 0px 2px 8px rgba(86, 96, 110, 0.2);\n}\n\n.todo-single-item.finished>span {\n  color: var(--bs-body-color);\n  text-decoration: line-through;\n}\n\n.todo-single-item.finished>span.badge {\n  text-decoration: none;\n  background-color: #cfd0d8;\n  color: var(--bs-body-color);\n}\n\n.todo-single-item.finished i.mdi {\n  background-color: transparent;\n  border-color: #d4d5db;\n}\n\n.todo-single-item.finished i.mdi:after {\n  content: \"\";\n  font-size: 0.75rem;\n  color: #34c997;\n  font-family: \"Material Design Icons\";\n  font-weight: bold;\n}\n\n.todo-single-item.finished .task-content span.badge {\n  text-decoration: none;\n  background-color: #cfd0d8;\n  color: var(--bs-body-color);\n}\n\n.remove-task {\n  -webkit-transition: all 0.3s;\n  transition: all 0.3s;\n  fill: #cfd0d8;\n  cursor: pointer;\n}\n\n.remove-task:hover {\n  fill: rgba(236, 74, 88, 0.7);\n}\n\n.todo-form i.mdi {\n  border-color: transparent;\n  font-size: 20px;\n  width: auto;\n  height: auto;\n  margin-right: 0;\n  position: absolute;\n  right: 0;\n}\n\n@media (min-width: 992px) {\n  .todo-form i.mdi {\n    font-size: 25px;\n  }\n}\n\n.todo-form i.mdi:hover {\n  border-color: transparent;\n  background-color: transparent;\n}\n\n/*===== FONTS SIZE =====*/\n.font-size-10 {\n  font-size: 10px;\n}\n\n.font-size-11 {\n  font-size: 11px;\n}\n\n.font-size-12 {\n  font-size: 12px;\n}\n\n.font-size-13 {\n  font-size: 13px;\n}\n\n.font-size-14 {\n  font-size: 14px;\n}\n\n.font-size-15 {\n  font-size: 15px;\n}\n\n.font-size-16 {\n  font-size: 16px;\n}\n\n.font-size-17 {\n  font-size: 17px;\n}\n\n.font-size-18 {\n  font-size: 18px;\n}\n\n.font-size-19 {\n  font-size: 19px;\n}\n\n.font-size-20 {\n  font-size: 20px;\n}\n\n.salesOverviewCard .card {\n  margin: 0 10px;\n}\n\n.salesOverviewCard .card:first-child {\n  margin-left: 0;\n}\n\n/*===== TABLES =====*/\n@media (max-width: 767.98px) {\n  div.dataTables_wrapper div.dataTables_paginate ul.pagination {\n    -webkit-box-pack: start;\n    -ms-flex-pack: start;\n    justify-content: flex-start;\n  }\n}\n\ndiv.dataTables_wrapper div.dataTables_length select {\n  margin: 0 5px;\n  border-color: var(--border-color);\n  border-radius: 10px;\n}\n\ndiv.dataTables_wrapper div.dataTables_filter input {\n  border-color: var(--border-color);\n  border-radius: 10px;\n}\n\n.bottom-information {\n  /* margin-top: 15px !important; */\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n@media (max-width: 575.98px) {\n  .dataTables_length {\n    width: 100% !important;\n    margin-bottom: 15px;\n  }\n}\n\n@media (max-width: 575.98px) {\n  #responsive-data-table_filter {\n    width: 100% !important;\n  }\n}\n\n@media (max-width: 575.98px) {\n  .dataTables_info {\n    display: none;\n  }\n}\n\n.table> :not(:first-child) {\n  border-top: 1px solid var(--border-color);\n}\n\ntable.dataTable td {\n  vertical-align: middle;\n}\n\ntable.dataTable td .dropdown-menu {\n  top: 30px;\n  -webkit-box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);\n  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);\n}\n\ntable.dataTable td .btn-group button {\n  padding: 3px 10px;\n}\n\ntable.dataTable td .btn-group button:first-child {\n  border-radius: 15px 0 0 15px !important;\n}\n\ntable.dataTable td .btn-group button:nth-last-child(-n+2) {\n  border-radius: 0 15px 15px 0 !important;\n}\n\n.ec-tbl .ec-tbl-content {\n  overflow-y: auto;\n}\n\n.ec-tbl .ec-tbl-content table {\n  min-width: 800px;\n}\n\ndiv.dataTables_wrapper div.dataTables_info,\ndiv.dataTables_wrapper div.dataTables_paginate {\n  width: auto !important;\n  padding: 0 !important;\n}\n\nth {\n  font-weight: 500;\n  font-size: 15px;\n}\n\nthead th,\ntbody tr td:first-child {\n  color: var(--bs-black-rgb);\n\n}\n\n.table-secondary td {\n  background-color: #ffffff;\n  color: var(--bs-black-rgb);\n}\n\n.table-primary {\n  background-color: rgba(136, 170, 243, 0.6);\n  color: var(--text-color);\n}\n\n.table-info {\n  background-color: rgba(36, 196, 218, 0.6);\n  color: var(--text-color);\n}\n\n.table-success {\n  background-color: rgba(52, 201, 151, 0.6);\n  color: var(--text-color);\n}\n\n.table-danger {\n  background-color: rgba(236, 74, 88, 0.6);\n  color: var(--text-color);\n}\n\n.table-warning {\n  background-color: rgba(221, 170, 4, 0.6);\n  color: var(--text-color);\n}\n\n.table-dark thead th,\n.table-dark tbody tr td:first-child {\n  color: #ffffff;\n}\n\n/* Table borderless */\n.table-borderless th,\n.table-borderless td {\n  border: 1px solid transparent;\n}\n\n.table-borderless thead th {\n  border-bottom: 1px solid transparent;\n  font-size: 0.81rem;\n  color: var(--bs-body-color);\n  font-weight: 400;\n}\n\n.table-borderless tbody tr a.link {\n  color: var(--text-color);\n}\n\n.table-borderless tbody tr a.link:hover {\n  color: var(--admin-color);\n}\n\n/* Card Table */\n.card-table {\n  margin-top: 20px;\n  margin-bottom: 0;\n}\n\n.card-table thead th {\n  font-size: 14px;\n  font-weight: 500;\n  padding: 0 1.9rem 1.25rem 0;\n  color: var(--bs-body-color);\n}\n\n@media (min-width: 768px) {\n  .card-table thead th {\n    font-size: 14px;\n  }\n}\n\n.card-table tbody td {\n  padding: 15px 15px 15px 0;\n  vertical-align: middle;\n  margin: 0.625rem 0 0.625rem;\n  font-size: 0.81rem;\n}\n\n@media (min-width: 768px) {\n  .card-table tbody td {\n    font-size: 15px;\n  }\n}\n\n.card-table tbody td a:hover {\n  color: var(--admin-color) !important;\n}\n\n.card-table tbody tr {\n  position: relative;\n  -webkit-transition: -webkit-box-shadow 0.3s ease-in-out;\n  transition: -webkit-box-shadow 0.3s ease-in-out;\n  transition: box-shadow 0.3s ease-in-out;\n  transition: box-shadow 0.3s ease-in-out, -webkit-box-shadow 0.3s ease-in-out;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .card-table tbody tr {\n    -webkit-transition: none;\n    transition: none;\n  }\n}\n\n.card-table tbody tr td:first-child {\n  color: var(--bs-body-color);\n}\n\n.card-table .avater {\n  width: 45px;\n  height: 45px;\n  overflow: hidden;\n}\n\n@media (min-width: 1200px) {\n  .table-responsive-large {\n    display: inline-table;\n  }\n}\n\n/* Customer Table */\n.customer-table .media-image {\n  width: 45px;\n  height: 45px;\n  overflow: hidden;\n}\n\n.customer-table .media-image img {\n  max-width: 100%;\n}\n\n.customer-table .media-body h6,\n.customer-table .media-body .h6 {\n  font-size: 15px;\n  font-weight: 500;\n}\n\n/* Notification Block */\n.notification-table .table-header {\n  margin-bottom: 1.9rem;\n}\n\n.notification-table .media {\n  max-width: 70%;\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n}\n\n.notification-table .media-icon {\n  color: #ffffff;\n  font-size: 1rem;\n}\n\n.notification-table .media-icon.cat-1 {\n  background-color: var(--admin-color);\n}\n\n.notification-table .media-icon.cat-2 {\n  background-color: #34c997;\n}\n\n.notification-table .media-icon.cat-3 {\n  background-color: #ddaa04;\n}\n\n.notification-table .media-icon.cat-4 {\n  background-color: #24c4da;\n}\n\n.notification-table .media-body a {\n  font-size: 15px;\n  color: var(--text-color);\n  display: inline-block;\n}\n\n.notification-table .media-body a:hover {\n  color: var(--admin-color);\n}\n\n.notification-table .media-body p {\n  font-size: 0.81rem;\n}\n\n/* Products Table */\n.products-table .table-header {\n  padding-bottom: 0.94rem;\n}\n\n.products-table table tr td {\n  vertical-align: middle;\n  padding-top: 1.9rem;\n}\n\n.products-table a.dropdown-toggle:after {\n  display: none;\n}\n\n.products-table .media {\n  margin-top: 2.19rem;\n}\n\n@media (min-width: 1200px) {\n  .products-table .media {\n    margin-top: 2.81rem;\n  }\n}\n\n@media (min-width: 1500px) {\n  .products-table .media {\n    margin-top: 2.19rem;\n  }\n}\n\n.products-table .media .media-body {\n  padding-right: 1.25rem;\n}\n\n.products-table .media .media-body a {\n  color: var(--text-color);\n}\n\n.products-table .media .media-body a h6,\n.products-table .media .media-body a .h6 {\n  font-size: 15px;\n  margin-bottom: 0.625rem;\n  font-weight: 500;\n  color: inherit;\n}\n\n.products-table .media .media-body a:hover {\n  color: var(--admin-color);\n}\n\n.products-table .media .media-body>p {\n  margin-bottom: 0.31rem;\n  line-height: 1.5;\n}\n\n/* Data Tables */\n.expendable-data-table,\n.basic-data-table {\n  overflow-x: scroll;\n}\n\n@media (min-width: 1500px) {\n\n  .expendable-data-table,\n  .basic-data-table {\n    overflow-x: hidden;\n  }\n}\n\n.expendable-data-table .table,\n.basic-data-table .table,\n.responsive-data-table .table {\n  border-top: 0;\n  margin: 25px 0 !important;\n}\n\n.expendable-data-table .table.table-borderless thead th,\n.basic-data-table .table.table-borderless thead th,\n.responsive-data-table .table.table-borderless thead th {\n  border-bottom: 1px solid transparent;\n}\n\n.expendable-data-table .table-bordered thead th,\n.expendable-data-table .table-bordered thead td,\n.basic-data-table .table-bordered thead th,\n.basic-data-table .table-bordered thead td,\n.responsive-data-table .table-bordered thead th,\n.responsive-data-table .table-bordered thead td {\n  border-bottom-width: 1px;\n}\n\n.expendable-data-table .table thead th,\n.basic-data-table .table thead th,\n.responsive-data-table .table thead th {\n  border-bottom: 1px solid var(--border-color);\n}\n\n.expendable-data-table thead th,\n.expendable-data-table tbody tr td:first-child,\n.basic-data-table thead th,\n.basic-data-table tbody tr td:first-child,\n.responsive-data-table thead th,\n.responsive-data-table tbody tr td:first-child {\n  color: #1b223c;\n  font-weight: 500;\n  font-size: 14px;\n}\n\n.expendable-data-table table.dataTable>tbody>tr.child span.dtr-title,\n.basic-data-table table.dataTable>tbody>tr.child span.dtr-title,\n.responsive-data-table table.dataTable>tbody>tr.child span.dtr-title {\n  font-weight: 500;\n}\n\n.expendable-data-table .top-information,\n.expendable-data-table .bottom-information,\n.basic-data-table .top-information,\n.basic-data-table .bottom-information,\n.responsive-data-table .top-information,\n.responsive-data-table .bottom-information {\n  padding: 0 15px;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.expendable-data-table .dataTables_filter,\n.basic-data-table .dataTables_filter,\n.responsive-data-table .dataTables_filter {\n  display: inline-block !important;\n}\n\n.expendable-data-table .dataTables_filter label,\n.basic-data-table .dataTables_filter label,\n.responsive-data-table .dataTables_filter label {\n  margin-bottom: 0;\n}\n\n.expendable-data-table .dataTables_filter label .form-control-sm,\n.basic-data-table .dataTables_filter label .form-control-sm,\n.responsive-data-table .dataTables_filter label .form-control-sm {\n  height: 30px;\n  border-radius: 10px;\n}\n\n.expendable-data-table .dataTables_length,\n.basic-data-table .dataTables_length,\n.responsive-data-table .dataTables_length {\n  display: inline-block !important;\n}\n\n.expendable-data-table .dataTables_length label,\n.basic-data-table .dataTables_length label,\n.responsive-data-table .dataTables_length label {\n  margin-bottom: 0;\n}\n\n.expendable-data-table .dataTables_length label .custom-select-sm,\n.basic-data-table .dataTables_length label .custom-select-sm,\n.responsive-data-table .dataTables_length label .custom-select-sm {\n  height: 30px;\n  margin: 0 10px;\n  cursor: pointer;\n  border-radius: 10px;\n}\n\n.expendable-data-table .dataTables_length .custom-select,\n.basic-data-table .dataTables_length .custom-select,\n.responsive-data-table .dataTables_length .custom-select {\n  background: transparent;\n}\n\n.expendable-data-table .dataTables_info,\n.basic-data-table .dataTables_info,\n.responsive-data-table .dataTables_info {\n  padding-top: 7px !important;\n}\n\n@media (min-width: 768px) {\n\n  .expendable-data-table .dataTables_info,\n  .basic-data-table .dataTables_info,\n  .responsive-data-table .dataTables_info {\n    margin-bottom: 0;\n    opacity: 0;\n  }\n}\n\n@media (min-width: 992px) {\n\n  .expendable-data-table .dataTables_info,\n  .basic-data-table .dataTables_info,\n  .responsive-data-table .dataTables_info {\n    padding-top: 1.2em !important;\n    opacity: 1;\n  }\n}\n\n@media (min-width: 1200px) {\n\n  .expendable-data-table .dataTables_info,\n  .basic-data-table .dataTables_info,\n  .responsive-data-table .dataTables_info {\n    padding-top: 1em !important;\n  }\n}\n\n.expendable-data-table .pagination .disabled .page-link,\n.basic-data-table .pagination .disabled .page-link,\n.responsive-data-table .pagination .disabled .page-link {\n  background-color: transparent !important;\n}\n\n.expendable-data-table table.dataTable.dtr-inline.collapsed>tbody>tr[role=row]>td:first-child:before,\n.expendable-data-table table.dataTable.dtr-inline.collapsed>tbody>tr[role=row]>th:first-child:before,\n.basic-data-table table.dataTable.dtr-inline.collapsed>tbody>tr[role=row]>td:first-child:before,\n.basic-data-table table.dataTable.dtr-inline.collapsed>tbody>tr[role=row]>th:first-child:before,\n.responsive-data-table table.dataTable.dtr-inline.collapsed>tbody>tr[role=row]>td:first-child:before,\n.responsive-data-table table.dataTable.dtr-inline.collapsed>tbody>tr[role=row]>th:first-child:before {\n  background-color: #34c997;\n  top: 14px;\n  width: 16px;\n  height: 16px;\n  line-height: 16px;\n  border: 0;\n  font-weight: bold;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.expendable-data-table table.dataTable.dtr-inline.collapsed>tbody>tr.parent>td:first-child:before,\n.expendable-data-table table.dataTable.dtr-inline.collapsed>tbody>tr.parent>th:first-child:before,\n.basic-data-table table.dataTable.dtr-inline.collapsed>tbody>tr.parent>td:first-child:before,\n.basic-data-table table.dataTable.dtr-inline.collapsed>tbody>tr.parent>th:first-child:before,\n.responsive-data-table table.dataTable.dtr-inline.collapsed>tbody>tr.parent>td:first-child:before,\n.responsive-data-table table.dataTable.dtr-inline.collapsed>tbody>tr.parent>th:first-child:before {\n  background-color: #ddaa04;\n}\n\n.expendable-data-table table.dataTable.hover tbody tr:hover,\n.expendable-data-table table.dataTable.display tbody tr:hover,\n.basic-data-table table.dataTable.hover tbody tr:hover,\n.basic-data-table table.dataTable.display tbody tr:hover,\n.responsive-data-table table.dataTable.hover tbody tr:hover,\n.responsive-data-table table.dataTable.display tbody tr:hover {\n  background-color: rgba(0, 0, 0, 0.05);\n}\n\n#basic-data-table_next .page-link,\n#basic-data-table_previous .page-link,\n#responsive-data-table_previous .page-link,\n#responsive-data-table_next .page-link,\n#expendable-data-table_previous .page-link,\n#expendable-data-table_next .page-link {\n  background-color: #e9ecef;\n}\n\n/* Responsive Data Tables */\n.responsive-data-table table.dataTable.dtr-inline.collapsed>tbody>tr[role=row]>td:first-child,\n.responsive-data-table table.dataTable.dtr-inline.collapsed>tbody>tr[role=row]>th:first-child {\n  padding-left: 40px;\n}\n\n.responsive-data-table table.dataTable.dtr-inline.collapsed>tbody>tr[role=row]>td:first-child:before,\n.responsive-data-table table.dataTable.dtr-inline.collapsed>tbody>tr[role=row]>th:first-child:before {\n  left: 10px;\n}\n\n/* Expendable Data Tables */\n.expendable-data-table .dataTable {\n  margin: 25px 0 !important;\n}\n\n.expendable-data-table table.dataTable.display tbody tr.odd>.sorting_1,\n.expendable-data-table table.dataTable.display tbody tr.even>.sorting_1,\n.expendable-data-table table.dataTable.order-column.stripe tbody tr.odd>.sorting_1,\n.expendable-data-table table.dataTable.order-column.stripe tbody tr.even>.sorting_1,\n.expendable-data-table table.dataTable thead .sorting_asc,\n.expendable-data-table table.dataTable thead .sorting {\n  background-color: transparent;\n  font-weight: 500;\n  color: var(--text-color);\n}\n\n.expendable-data-table table.dataTable.display tbody tr.odd,\n.expendable-data-table table.dataTable.display tbody tr:hover {\n  background-color: transparent;\n}\n\n.expendable-data-table table.dataTable.display tbody td {\n  border-top: 1px solid var(--border-color);\n}\n\n.expendable-data-table .table-bordered.table.dataTable.display tbody tr[role] td {\n  padding: 12px 12px;\n}\n\n.expendable-data-table table.dataTable.display tbody tr[role] td {\n  border-top: 1px solid var(--border-color);\n  padding: 12px 0px;\n}\n\n.expendable-data-table .table-borderless.table.dataTable thead th,\n.expendable-data-table .table-borderless.table.dataTable tbody td,\n.expendable-data-table .table-borderless.table.dataTable.display tbody tr[role] td {\n  border-top: 1px solid transparent;\n}\n\n.expendable-data-table .table-striped tbody tr[role]:nth-of-type(odd) {\n  background-color: rgba(0, 0, 0, 0.05) !important;\n}\n\n.expendable-data-table .table-striped tbody tr:nth-of-type(odd) {\n  background-color: transparent;\n}\n\n.expendable-data-table table.dataTable tbody td {\n  border-top: 1px solid var(--border-color);\n}\n\n.expendable-data-table table.dataTable thead th {\n  border-top: 1px solid var(--border-color);\n  border-bottom: 1px solid var(--border-color);\n  padding: 12px 18px;\n}\n\n.expendable-data-table table.dataTable.no-footer {\n  border-bottom: 1px solid transparent;\n}\n\n.expendable-data-table .dataTables_wrapper .dataTables_paginate .paginate_button {\n  padding: 0;\n  margin-left: -2px;\n  background: -webkit-gradient(linear, left top, left bottom, from(transparent), to(transparent));\n  background: linear-gradient(to bottom, transparent 0%, transparent 100%);\n}\n\n.expendable-data-table .dataTables_wrapper .dataTables_paginate .paginate_button:hover {\n  border: 1px solid #ffffff;\n}\n\n.expendable-data-table .dataTables_wrapper .dataTables_paginate .paginate_button:active {\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.expendable-data-table .dataTables_wrapper .dataTables_paginate {\n  padding-top: 0;\n}\n\n.expendable-data-table .table-bordered.table.dataTable thead .sorting_asc,\n.expendable-data-table .table-bordered.table.dataTable thead .sorting {\n  padding-left: 12px;\n}\n\n.expendable-data-table .table-bordered.table.dataTable.no-footer {\n  border-bottom: 1px solid var(--border-color);\n}\n\n.expendable-data-table table.dataTable thead .sorting_asc,\n.expendable-data-table table.dataTable thead .sorting {\n  background: transparent;\n  padding-left: 0px;\n}\n\n.expendable-data-table table.dataTable thead th:first-child:before,\n.expendable-data-table table.dataTable thead th:first-child:after {\n  display: none;\n}\n\n.expendable-data-table table.dataTable thead .sorting:before,\n.expendable-data-table table.dataTable thead .sorting_desc:before,\n.expendable-data-table table.dataTable thead .sorting_asc:before {\n  right: 2em;\n}\n\n.expendable-data-table table.dataTable thead .sorting:after,\n.expendable-data-table table.dataTable thead .sorting_desc:after,\n.expendable-data-table table.dataTable thead .sorting_asc:after {\n  right: 1.5em;\n}\n\n.expendable-data-table .dataTables_filter,\n.expendable-data-table .dataTables_length,\n.expendable-data-table .dataTables_wrapper .dataTables_info {\n  color: var(--bs-body-color);\n}\n\n.expendable-data-table .dataTables_filter,\n.expendable-data-table .dataTables_info,\n.expendable-data-table .dataTables_length {\n  margin-top: 0;\n  padding-top: 0 !important;\n}\n\n.expendable-data-table .top-information,\n.expendable-data-table .bottom-information {\n  padding: 0 16px;\n}\n\n.expendable-data-table th.details-control.sorting_disabled {\n  width: 1px !important;\n}\n\n.expendable-data-table table.dataTable thead>tr>th.sorting_desc {\n  padding-left: 0;\n  font-weight: 500;\n}\n\n.expendable-data-table tr.shown td.details-control,\n.expendable-data-table td.details-control {\n  position: relative;\n  background: transparent;\n  cursor: pointer;\n}\n\n.expendable-data-table tr.shown td.details-control::before,\n.expendable-data-table td.details-control::before {\n  position: absolute;\n  content: \"+\";\n  font-family: \"Courier New\", Courier, monospace;\n  top: 14px;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n  transform: translateX(-50%);\n  width: 16px;\n  height: 16px;\n  line-height: 16px;\n  color: #ffffff;\n  border-radius: 16px;\n  text-align: center;\n  font-weight: bold;\n  background-color: #34c997;\n}\n\n.expendable-data-table tr.shown td.details-control::before {\n  content: \"-\";\n  background-color: #ddaa04;\n}\n\n.expendable-data-table .table-hover tbody tr:hover {\n  color: var(--text-color);\n}\n\n.expendable-data-table .table-hover.table.dataTable.hover tbody tr[role]:hover,\n.expendable-data-table .table-hover.table.dataTable.display tbody tr[role]:hover {\n  background-color: rgba(0, 0, 0, 0.05);\n}\n\ndiv.dataTables_wrapper div.dataTables_length,\ndiv.dataTables_wrapper div.dataTables_filter {\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n  width: 50%;\n}\n\n/*===== WIDGETS =====*/\n.profile-content .profile-left-spacing {\n  padding: 24px 0 24px 24px;\n}\n\n@media (max-width: 991.98px) {\n  .profile-content .profile-left-spacing {\n    padding: 24px 24px 0 24px;\n  }\n}\n\n.profile-content .profile-left-spacing .btn {\n  border-radius: 15px;\n}\n\n.profile-content .nav-tabs.nav-style-border {\n  padding-bottom: 0;\n}\n\n.profile-content .nav-tabs.nav-style-border .nav-item:first-child {\n  margin-bottom: 0;\n}\n\n.widget-block {\n  position: relative;\n  padding: 1.9rem;\n  margin-bottom: 1.9rem;\n}\n\n.widget-block.bg-primary {\n  border-color: var(--admin-color);\n}\n\n.widget-block.bg-primary p {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n.widget-block.bg-primary .progress {\n  background: rgba(255, 255, 255, 0.5);\n}\n\n.widget-block.bg-warning {\n  border-color: #ddaa04;\n}\n\n.widget-block.bg-warning p {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n.widget-block.bg-warning .progress {\n  background: rgba(255, 255, 255, 0.5);\n}\n\n.widget-block.bg-danger {\n  border-color: #ec4a58;\n}\n\n.widget-block.bg-danger p {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n.widget-block.bg-danger .progress {\n  background: rgba(255, 255, 255, 0.5);\n}\n\n.widget-block.bg-success {\n  border-color: #34c997;\n}\n\n.widget-block.bg-success p {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n.widget-block.bg-success .progress {\n  background: rgba(255, 255, 255, 0.5);\n}\n\n.widget-block i {\n  font-size: 1.38rem;\n}\n\n.widget-chart {\n  height: 70px;\n}\n\n.widget-chart #barChart {\n  width: 100%;\n  height: 100%;\n}\n\n.widget-media {\n  position: relative;\n  padding: 24px;\n  margin-bottom: 24px;\n  border-radius: 15px;\n  -webkit-box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.03);\n  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.03);\n}\n\n.widget-media .icon {\n  width: 60px;\n  height: 60px;\n  text-align: center;\n  line-height: 60px;\n}\n\n.widget-media i {\n  font-size: 26px;\n}\n\n.widget-profile .card-img {\n  width: 100px;\n  height: 100px;\n  overflow: hidden;\n}\n\n.widget-profile .card-img img {\n  width: 100%;\n}\n\n/* Widgets Dropdown */\n.widget-dropdown .dropdown-toggle {\n  color: var(--bs-body-color);\n  text-transform: uppercase;\n}\n\n.widget-dropdown .dropdown-toggle.icon-burger-mini {\n  font-size: 1.5rem;\n  position: relative;\n}\n\n.widget-dropdown .dropdown-toggle.icon-burger-mini:after {\n  display: none;\n}\n\n.widget-dropdown .dropdown-toggle.icon-burger-mini:before {\n  font-family: \"Material Design Icons\";\n  content: \"\";\n}\n\n.widget-dropdown .dropdown-menu {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  -webkit-box-shadow: 0px 5px 18px 0px rgba(229, 233, 242, 0.5);\n  box-shadow: 0px 5px 18px 0px rgba(229, 233, 242, 0.5);\n  min-width: auto;\n  right: 0 !important;\n  left: auto !important;\n}\n\n.widget-dropdown .dropdown-menu .dropdown-item {\n  padding: 0.3125rem 1.25rem;\n}\n\n.widget-dropdown .dropdown-menu .dropdown-item a {\n  font-size: 0.875rem;\n  color: var(--bs-body-color);\n  text-transform: capitalize;\n}\n\n.widget-dropdown .dropdown-menu .dropdown-item:hover {\n  background-color: transparent;\n}\n\n.widget-dropdown .dropdown-menu .dropdown-item:hover a {\n  color: var(--admin-color);\n}\n\n/*===== COMPACT SPACING =====*/\n.compact-spacing {\n  /* Navbar */\n  /* Github Icon */\n  /* App Brand */\n  /* App Brand */\n  /* Right Sidebar 2 */\n  /* Header Fix */\n  /* Content */\n  /* Sidebar */\n  /* Compact Units */\n  /* Compact Notifications */\n  /* Media */\n  /* Card */\n  /* Analytics Data Height */\n  /* Polar Data Content */\n  /* Profile Data Height */\n  /* Activity Data Spacing */\n  /* User Profile */\n  /* Invoice Wrapper */\n  /* Table */\n  /* Copyright */\n}\n\n.compact-spacing .navbar {\n  min-height: 60px;\n  -webkit-transition: all 0.3s;\n  transition: all 0.3s;\n  /* Navbar Right */\n}\n\n.compact-spacing .navbar .sidebar-offcanvas-toggle,\n.compact-spacing .navbar .sidebar-toggle {\n  height: 60px;\n}\n\n.compact-spacing .navbar .navbar-right .navbar-nav .user-menu .dropdown-toggle {\n  line-height: 60px;\n}\n\n.compact-spacing .navbar .navbar-right .navbar-nav .notifications-menu .dropdown-toggle {\n  line-height: 60px;\n}\n\n.compact-spacing .navbar .navbar-right .navbar-nav .right-sidebar-2-menu i {\n  line-height: 60px;\n}\n\n.compact-spacing .github-link {\n  top: -8px;\n}\n\n.compact-spacing .github-link i {\n  top: 0px;\n  right: 5px;\n}\n\n.compact-spacing .github-link svg {\n  width: 69px;\n  height: 69px;\n}\n\n.compact-spacing .ec-brand span {\n  height: 62px;\n  line-height: 62px;\n  -webkit-transition: all 0.3s;\n  transition: all 0.3s;\n}\n\n.compact-spacing #toast-container {\n  margin-top: 50px;\n}\n\n.compact-spacing .right-sidebar-container-2 .right-sidebar-2-header {\n  padding: 11.5px 30px;\n  -webkit-transition: all 0.3s;\n  transition: all 0.3s;\n}\n\n.compact-spacing.ec-header-fixed .ec-page-wrapper {\n  padding-top: 3.875rem;\n}\n\n@media (min-width: 1200px) {\n  .compact-spacing .content {\n    padding: 24px;\n    -webkit-transition: all 0.3s;\n    transition: all 0.3s;\n  }\n}\n\n.compact-spacing .sidebar .sidebar-inner>li>span {\n  padding: 12px 25px;\n}\n\n.compact-spacing .compact-units {\n  height: 365px !important;\n}\n\n.compact-spacing .compact-notifications {\n  height: 415px !important;\n}\n\n.compact-spacing .media-border-bottom {\n  padding-left: 2rem !important;\n  padding-right: 2rem !important;\n}\n\n.compact-spacing .card-table-border-none .card-header,\n.compact-spacing .card-default .card-header {\n  padding: 15px;\n}\n\n.compact-spacing .card-table-border-none .card-body,\n.compact-spacing .card-default .card-body {\n  padding: 15px;\n}\n\n.compact-spacing .card-table-border-none .card-footer,\n.compact-spacing .card-default .card-footer {\n  padding-left: 15px;\n  padding-right: 15px;\n}\n\n.compact-spacing .card-table-border-none .card-footer a,\n.compact-spacing .card-default .card-footer a {\n  padding: 7px 0 !important;\n}\n\n.compact-spacing [analytics-data-height] {\n  height: 573px;\n}\n\n.compact-spacing [polar-data-content] {\n  margin-bottom: 20px;\n}\n\n.compact-spacing [Profile-data-height] {\n  min-height: 520px;\n}\n\n.compact-spacing [activity-data-spacing] {\n  margin-bottom: 39px;\n}\n\n.compact-spacing .profile-right-spacing {\n  padding: 1.88rem 0 !important;\n}\n\n.compact-spacing .profile-right-spacing .nav-style-border {\n  padding-left: 1.88rem !important;\n  padding-right: 1.88rem !important;\n}\n\n.compact-spacing .profile-right-spacing .tab-content {\n  padding-left: 1.88rem !important;\n  padding-right: 1.88rem !important;\n}\n\n.compact-spacing .profile-right-spacing .tab-content .tab-pane-content {\n  margin-top: 1.88rem !important;\n}\n\n.compact-spacing .profile-right-spacing .tab-content .tab-pane-content .form-group {\n  margin-bottom: 1.5rem !important;\n}\n\n.compact-spacing .tab-widget,\n.compact-spacing .timeline-media-spacing {\n  margin-top: 15px !important;\n}\n\n.compact-spacing .invoice-wrapper {\n  padding: 15px !important;\n}\n\n.compact-spacing .recent-orders .card-body {\n  padding-bottom: 0 !important;\n}\n\n.compact-spacing .card-table {\n  margin-top: 1rem;\n}\n\n.compact-spacing .copyright {\n  padding-top: 1.35rem;\n  padding-bottom: 1.35rem;\n}\n\n.compact-spacing .right-sidebar-2-body {\n  padding: 0 15px;\n}\n\n.compact-spacing .right-sidebar-2-body .no-col-space {\n  margin-bottom: 20px;\n}\n\n/** Options sidebar css **/\n.ec-tools-sidebar-overlay {\n  display: none;\n  width: 100%;\n  height: 100vh;\n  position: fixed;\n  top: 0;\n  left: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 17;\n}\n\n.right-sidebar-2-body .no-col-space {\n  border: solid 1px #eee !important;\n  border-radius: 15px;\n}\n\n.right-sidebar-container-2 .btn-right-sidebar-2 {\n  width: 50% !important;\n  margin-right: 0 !important;\n  border: 0;\n  border-radius: 15px;\n}\n\n.right-sidebar-container-2 .btn-right-sidebar-2.btn-right-sidebar-2-active {\n  background-color: #eee !important;\n  color: #777777 !important;\n  text-decoration: none !important;\n  margin-right: 0 !important;\n  border-radius: 15px !important;\n}\n\n.right-sidebar-container-2 .right-sidebar-2-select {\n  background: #eee;\n  color: #777777;\n  border: none;\n  border-radius: 15px;\n}\n\n\n\n.card-body.defaultText {\n  min-height: 330px;\n  display: flex;\n  justify-content: space-around;\n  flex-direction: column;\n}\n\n.filterTab .nav-style-border {\n  margin: 0 0 0 0;\n  padding: 0;\n  /* border-bottom: 1px solid rgb(222, 226, 230); */\n}\n\n.filterTab .search-form {\n  width: 350px;\n  position: relative;\n  margin-right: auto;\n  padding-left: 0;\n  background-color: var(--gray-bg-color);\n  border-radius: var(--border-radius);\n  height: 35px;\n}\n\n.filterTab .col-lg-7 {\n  padding-right: 0;\n}\n\n.filterTab .col-lg-5 {\n  /* border-bottom: 1px solid rgb(222, 226, 230); */\n  /* padding-left: 0; */\n}\n\n.filterTab .nav-tabs .nav-link {\n  margin-bottom: 0px;\n}\n\n.filterTab .nav-tabs.nav-style-border .nav-item .nav-link {\n  padding: 10px 0 10px 0;\n}\n\n#productTypeFilter,\n#productTypeFilter:focus,\n#productTypeFilter:active,\n#storeFilter,\n#storeFilter:focus,\n#storeFilter:active {\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n  outline: none;\n}\n\n\n.card-default .card-body p.addressChangeBtn {\n  color: var(--admin-color);\n  cursor: pointer;\n  text-decoration: underline;\n}\n\n.createOrderPage .form-group label,\n.createOrderPage .input-group label {\n  /* color: rgb(138, 144, 157) */\n}\n\n.editOrderPage .form-group label,\n.editOrderPage .input-group label {\n  /* color: rgb(138, 144, 157) */\n}\n\n.card.ordersCard {\n  box-shadow: none;\n  border: none;\n  width: 800px;\n  height: 550px;\n  border: 1px solid #ced4da;\n}\n\n.card.ordersCard tbody tr {\n  cursor: pointer;\n}\n\n.addaddress.small .form-group,\n.editAddress.small .form-group {\n  margin-bottom: 10px !important;\n}\n\n.addaddress.small .saveBtn,\n.editAddress.small .saveBtn {\n  text-align: right;\n  padding: 0 30px 24px 0;\n}\n\n.editAddress .hideStatus {\n  display: none;\n}\n\n.addaddress.small .mdi-arrow-left,\n.editAddress.small .mdi-arrow-left {\n  font-size: 22px;\n  cursor: pointer;\n}\n\n.navAndSearchWrapper {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border: 1px solid var(--border-color);\n  width: 100%;\n  border-radius: 10px;\n  padding: 10px 10px;\n}\n\n\n/* custome css */\n\n/* MyProfile css start */\n\n.rest_email_message .resetLink {\n  color: var(--admin-color);\n  cursor: pointer;\n  border-bottom: 1px solid;\n}\n\n/* MyProfile css end */\n\ninput {\n  font-size: 14px;\n  height: 35px;\n  padding: 0.5rem 1.06rem;\n  border-color: var(--border-color);\n  margin-bottom: 18px;\n}\n\ntextarea {\n  font-size: 14px;\n  padding: 0.5rem 1.06rem;\n  border-color: var(--border-color);\n  margin-bottom: 18px;\n}\n\n.search-form .input-group input {\n  font-size: 14px;\n  /* height: 48px !important; */\n  padding: 0.5rem 1.06rem;\n  border-color: var(--border-color);\n  margin-bottom: 0px !important;\n}\n\n#search-results input {\n  height: 100%;\n  margin: 0;\n}\n\n.SearchGroup input {\n  /* height: 47px; */\n  margin: 0;\n}\n\n.search_icon {\n  padding: 7px 14px;\n}\n\n.search-form .input-group span {\n  margin: auto;\n}\n\n#search-results span {\n  /* margin: auto; */\n}\n\n/* Change the background color of the saved input fields */\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus,\ntextarea:-webkit-autofill,\ntextarea:-webkit-autofill:hover,\ntextarea:-webkit-autofill:focus,\nselect:-webkit-autofill,\nselect:-webkit-autofill:hover,\nselect:-webkit-autofill:focus {\n  color: var(--bs-black-rgb) !important;\n  background-color: #fdfdfd !important;\n  transition: background-color 5000s ease-in-out 0s;\n}\n\n/* Change the text color of the saved input fields */\ninput:-webkit-autofill::first-line {\n  color: var(--bs-black-rgb) !important;\n}\n\n.form-control input {\n  border-color: var(--border-color)\n}\n\n.form-control select {\n  border-color: var(--border-color)\n}\n\n.SearchGroup {\n  height: 35px;\n}\n\n.SearchGroup span {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 12px;\n}\n\n.select_store p {\n  height: 50vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.mandatory_field::after {\n  content: \"*\";\n  color: red;\n  padding-left: 5px;\n  font-size: 14px;\n}\n\n.optional {\n  color: #ff8c8c;\n}\n\n.table_loader {\n  z-index: 5;\n  background-color: white !important;\n  width: 95%;\n  height: 50vh;\n  border-radius: 10px;\n  background: no-repeat;\n}\n\n.edit_page_loader {\n  position: absolute;\n  z-index: 5;\n  background-color: white !important;\n  width: 100%;\n  height: 75vh;\n  top: 5%;\n  border-radius: 10px;\n  background: no-repeat;\n  margin-right: 30px;\n}\n\n.full_page_loader {\n  position: absolute;\n  z-index: 5;\n  background-color: white !important;\n  width: 100%;\n  height: 100vh;\n  top: 0;\n  border-radius: 10px;\n  background: no-repeat;\n}\n\n.page_loader {\n\n  position: absolute;\n  z-index: 5;\n  background-color: white !important;\n  width: 95%;\n  height: 71vh;\n  top: 30px;\n  border-radius: 10px;\n  background: no-repeat;\n  margin-right: 30px;\n\n}\n\n.dashboard_page_loader {\n\n  position: absolute;\n  z-index: 5;\n  background-color: white !important;\n  width: 95%;\n  height: 71vh;\n  top: 75px;\n  border-radius: 10px;\n  background: no-repeat;\n  margin-right: 30px;\n\n}\n\n.sales_and_fee_filterTab {\n  /* display: flex; */\n  /* justify-content: flex-end; */\n  margin-bottom: 10px;\n}\n\n.sales_and_fee_filterTab .sales_and_fee_search_form {\n  /* width: 350px; */\n  position: relative;\n  padding-left: 0;\n  background-color: #f7f7f7;\n  border-radius: var(--border-radius);\n  height: 35px;\n}\n\n\nselect {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  margin: 0;\n  padding: 0;\n  font-size: 100%;\n  font-family: inherit;\n  border: none;\n  background: none;\n}\n\n/* Custom styles for the dropdown */\nselect {\n  width: 200px;\n  padding: 8px;\n  /* border: 1px solid #ccc; */\n  border-radius: 4px;\n  background-color: #f7f7f7;\n  color: var(--bs-black-rgb);\n  font-size: 14px;\n}\n\n/* Style dropdown options */\nselect option {\n  background-color: #f7f7f7;\n  color: var(--bs-black-rgb);\n  font-size: 14px;\n  padding: 4px;\n}\n\n/* Hover effect on options */\nselect option:hover {\n  background-color: #e3e3e3;\n}\n\n/* Focus effect on the dropdown */\nselect:focus {\n  outline: none;\n  border-color: #6c9ce8;\n  box-shadow: 0 0 5px rgba(108, 156, 232, 0.5);\n}\n\n/* orders_list_page */\n\n.orders_button_wrapper {\n  margin-left: 50%;\n}\n\n\n.filter_dropDown_wrapper {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n\n.fulfillment_wrapper {\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n\n.filter_operation_mode {\n  width: 20%;\n}\n\n.filter_popup {\n  position: fixed !important;\n  top: 50% !important;\n  left: 59%;\n  transform: translate(-50%, -50%) !important;\n  z-index: 9999 !important;\n  background-color: #fff !important;\n  padding: 20px !important;\n  box-shadow: 0 0 20px rgba(0, 0, 0, 0.3) !important;\n  width: 75%;\n}\n\n.filter_popup_height {\n  /* height: 200px; */\n}\n\n\n.filter_operation_mode .from_and_to_date {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 300px;\n}\n\n.filter_operation_mode .from_and_to_date input {\n  height: 41px;\n  margin-bottom: 0;\n\n}\n\n.from_and_to_date .fillter_to_date {\n  margin-left: 10px;\n}\n\n.close_fillter {\n  position: absolute;\n  right: 25px;\n  cursor: pointer;\n}\n\n.close_fillter:hover {\n  color: red;\n}\n\n.close_fillter_file_upload {\n  position: absolute;\n  right: 18px;\n  top:15px;\n  font-size: 18px;\n  cursor: pointer;\n}\n\n.close_fillter_file_upload:hover {\n  color: red;\n}\n\n.filter_by_order_id input {\n  margin: 0;\n  height: 41px;\n}\n\n.applied_filter_remove {\n  position: absolute;\n  right: 15px;\n  top: 10px;\n  font-size: 10px;\n  cursor: pointer;\n}\n\n.applied_filter_remove:hover {\n  color: red;\n}\n\n.add_fillter_btn {\n  margin-left: 175px;\n}\n\n.fillter_message_Wrapper {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.filterMessage {\n  /* width: 25%; */\n  margin: 20px 20px 20px 0px;\n}\n\n.fliter_operation_mode_btn {\n  width: 20%;\n  display: flex;\n  justify-content: space-evenly;\n  margin-top: 34px;\n}\n\n.filter_btn_with_date {\n  margin-left: 130px;\n}\n\n.filter_dateWrapper {\n  display: flex;\n  flex-direction: column;\n  width: 50%;\n}\n\n.filter_body {\n  padding: 25px;\n}\n\ninput[type=\"password\"] {\n  -webkit-text-security: disc;\n  text-security: disc;\n}\n\n.abbr.no-style {\n  text-decoration: none;\n  border-bottom: none;\n  cursor: default;\n}\n\n\n.no-scroll {\n  overflow: hidden;\n}\n\n.no_recipient {\n  height: 300px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.images_preview_block_wrapper {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-items: center;\n}\n\n.images_preview_block_wrapper .images_preview_block {\n\n  width: 43%;\n}\n\n.message_center {\n  display: flex;\n  justify-content: center;\n  align-items: center\n}\n\n.recipient_header_wrapper {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.otp-input{\n  width: 44px;\n  margin-right: 10px;\n  margin-top: 10px;\n}\n\n.input-password{\n  position: relative;\n  width: 320px !important;\n  margin-top: 10px;\n}\n\n.otp-buttons{\n  width: 320px;\n  display: flex;\n  justify-content:space-between;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
